import React, { useCallback, useEffect, useRef, useState } from "react";
import {Container, Modal, Row, Col, Button, Form, Tooltip, Spinner} from "react-bootstrap";
import { useSelector } from "react-redux";
import APICom from "../utils/helpers/APICom.js";
import {Icon} from '@iconify/react';
import * as XLSX from 'xlsx';
import GridControl from "../components/Controls/gridControl.js";
import CCProfile from "../components/Controls/CCProfile.js";
import ClientProfile from "../components/Controls/ClientProfile.js";
import PhoneInput from "react-phone-number-input/input";
import MapControlSkeleton from "../components/Controls/mapControlSkeleton.js";
import PersistStorage from "../utils/helpers/PersistStorage.js";
import ARBResponseListener from "../components/Controls/ARBResponseListener.js";
import ExportIcon from "../assets/Images/CommonImages/save.png";
import ClearFilterIcon from "../assets/Images/CommonImages/clearFilter.png";
import ITCLogo from '../assets/Images/CommonImages/ITClogo.png';
import MultiSelectDropdown from '../components/Controls/multiselectdropdown.js';
import MultiSchedule from "../components/Dispatch/MultiSchedule.js";
import CallerIDNotifierListener from "../components/Controls/CallerIDNotifier";
import DateTimeUtils from "../utils/DateTimeUtility.js";
import 'react-phone-number-input/style.css';
import AttributeSelectors from "../components/AttributeSelectors.js";
import AttributeSelectorNew from "../components/AttributeSelectorsNew.js";
import mobilityAdditions from '@iconify-icons/mdi/account-multiple-add';
import moment from "moment";
import { toast } from 'react-toastify';
import '../../src/assets/Styles/CallTakerCSS/CallTaker.css';
import CommonFunctions from "../utils/helpers/CommonFunctions.js";
import { generateRows, updateIndexes } from "../components/AttributeSelectorManager.js";
import PredictiveNegotiationStatusCard from "../components/PredictiveNegotiationStatusCard.js";
import ContextTransferPanel from "../components/Controls/ContextPanel.js";
import CancelTrip from "../components/Dispatch/CancelTrip.js";

const CallTaker = (props) => {

  const WARNING_PCA_NOT_ALLOWED = "Warning: PCA Not Allowed";
  const KNOWN_KEYS = ["Primary","PCA","Guests","Children"];
  const [isUserAllowedOutOfServiceArea, setIsUserAllowedOutOfServiceArea] = useState(false);
  const [defaultZoneLatLngsFromASCS, setDefaultZoneLatLngsFromASCS] = useState({Latitude: 0, Longitude: 0});
  const [maxAgentPromptMilesASCS, setMaxAgentPromptMilesASCS] = useState(0);
  const [attributeValidationMsg, setAttributeValidationMsg] = useState("");
  const [isAffiliateHasMobilityAttributes, setIsAffiliateHasMobilityAttributes] = useState(false);
  const [showMobilityAttributes, setShowMobilityAttributes] = useState(false);
  const [isPCAApprovedFromEaas, setIsPCAApprovedFromEaas] = useState(false);
  const [isPCAApprovalCaputured, setIsPCAApprovalCaputured] = useState(false);


  const [gridMainType, setGridMainType] = useState('Dispatch');
  const [showCancel, setShowCancel] = useState(false);
  const [selectRowData, setSelectedRowData] = useState([]);
  const [showCloseButton, setShowCloseButton] = useState(true);
  const [showColumnChooser, setShowColumnChooser] = useState(false);

  const [showPredictiveNegotiationStatusCard, setShowPredictiveNegotiationStatusCard] = useState(false);
  const [predictiveNegotiationList, setPredictiveNegotiationList] = useState([{confirmationNumber: "", pickDate: "", title: "", status: "", OfferedTime: "", showLoader: true, counter: 0}]);
  const [predictiveHeaderTitle,setPredictiveHeaderTitle] = useState("");
  const [predictiveHeaderMsg,setPredictiveHeaderMsg] = useState("");
  const onPredictiveNegotiationStatusCardClick = () => {
    try {
      setShowPredictiveNegotiationStatusCard(false)
    } catch (error) {
      
    }
  }

  const [predictiveNegoTitle, setPredictiveNegoTitle] = useState("Please wait while the system is checking the service availability.");
  const [currentBookedTripConfirmationNumber, setCurrentBookedTripConfirmationNumber] = useState("");
  const [predictiveNegoDate, setPredictiveNegoDate] = useState("");
  const [currentBookedTripNegotiationStatus, setCurrentBookedTripNegotiationStatus] = useState("");
  const [showPredictiveNegoLoader, setShowPredictiveNegoLoader] = useState(false);
  const [enableFutureDateValidation, setEnableFutureDateValidation] = useState(true);


  const onAttributeValidation = () => {
    try {
      setShowMobilityAttributes(false);
      setAttributeValidationMsg("");
      const countOfUnSelectedAtrbs = unSelectedMobilityAttributes();
      if(countOfUnSelectedAtrbs > 0){
        setAttributeValidationMsg("Attribute(s) selection required.");
      }
      else{
        setShowMobilityAttributes(false);
      }
    } catch (error) {
      
    }
  }

  const onAttributeValidation_New = () => {
    try {
      
      setShowMobilityAttributes(false);
      setAttributeValidationMsg("");
      const countOfUnSelectedAtrbs = unSelectedMobilityAttributes_New();
      if(countOfUnSelectedAtrbs > 0){
        setAttributeValidationMsg("Attribute(s) selection required.");
      }
      else{
        setShowMobilityAttributes(false);
      }
    } catch (error) {
      
    }
  }

  const unSelectedMobilityAttributes_New = () => {
    try {
      const unselected = [];

      if(mobilityPassengers.passenger >= 1)
      {
        const primaryRow = Object.values(mobilitySavedData).find(item => item.type === 'primary');
        if (primaryRow) {
          if (!primaryRow.selectedLabel || !primaryRow.selectedAttribute) {
            unselected.push(primaryRow);
          }
        }
      }
      
      if(mobilityPassengers.passenger > 1){
        const adultRows = Object.values(mobilitySavedData).find(item => item.type === 'adult');
        if (adultRows) {
          if (!adultRows.selectedLabel || !adultRows.selectedAttribute) {
            unselected.push(adultRows);
          }
        }
      }
  
      if(mobilityPassengers.children >= 1){
        const childrenRows = Object.values(mobilitySavedData).find(item => item.type === 'children');
        if (childrenRows) {
          if (!childrenRows.selectedLabel || !childrenRows.selectedAttribute) {
            unselected.push(childrenRows);
          }
        }
      }

     return unselected.length;
    } catch (error) {
      return 0;
    }
  }

  const GetMobilityPrimaryData = () => {
    try {
      const primaryRow = Object.values(mobilitySavedData).find(item => item.type === 'primary');
      return primaryRow;
    } catch (error) {
      
    }
  }

  const [showAlert, setAlert] = useState(false);
  const [showSideBar, setShowSideBar] = useState(false);
  const [showChatBot, setShowChatBot] = useState(false);
  const [specificLinkRequirement, setSpecificLinkRequirement] = useState([]);
  const [iAppID, setiAppID] = useState(26);
  const [isSchTimeFieldDisabled, setIsSchTimeFieldDisabled] = useState(true);
  const [isVSSelectionDisabled, setIsVSSelectionDisabled] = useState(false);
  const [isTimeValidated, setIsTimeValidated] = useState(true);
  const [isFirefox, setIsFirefox] = useState((typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1));
  const { loginData }  = useSelector((store) => store.login);
  const { GlobalASCSData, ASCSSettingData, DispatchVehicleData, AffiliateData, FundingSourceData, ZoneVerticesData, 
    VirtualStopsData, RCZZoneVerticesData, PaymentTypesData, ClassOfServiceData, AttributeData, DispatchDriverData,
    MvRouteSettingData, ZoneSpeedMultiplier, isLoading, BrokerServingAffiliatesData
  } = useSelector((store) => store.combinedata);
  const [showDynamicModal, setShowDynamicModal] = useState(false);
  const [modalClass, setModalClass] = useState("");
  const [modalBodyHTML, setModalBodyHTML] = useState(null);
  const [handlePageProgressBar, sethandlePageProgressBar] = useState(null); 
  const [modalFooterHTML, setModalFooterHTML] = useState(
    <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
      OK
    </Button>
  );

  const [showARBNotifications, setShowARBNotifications] = useState(false); 
  const [modalHeaderText, setModalHeaderText] = useState("");
  const [clientInfoDisplay, setClientInfoDisplay] = useState(true);
  const [driverVehInfoDisplay, setDriverVehInfoDisplay] = useState(false);
  const [additionalDetailsDisplay, setAdditionalDetailsDisplay] = useState(false);
  const [paymentDetailsDisplay, setPaymentDetailsDisplay] = useState(false);
  const [insuranceInfoDisplay, setInsuranceInfoDisplay] = useState(false);
  const [stopOrderDisplay, setStopOrderDisplay] = useState(true);
  const [agentTripsDisplay, setAgentTripsDisplay] = useState(false);
  const [manifestDetailsDisplay, setManifestDetailsDisplay] = useState(false);
  const [manualDataOverwrite, setManualDataOverwrite] = useState({fare:0, price: 0, miles: 0});
  const [selectedSummaryHeader, setSelectedSummaryHeader] = useState("stopOrder");
  const [affiliateDropDownHTML, setAffiliateDropDownHTML] = useState(null);
  const [virtualStopDropDownHTML, setVirtualStopDropDownHTML] = useState(null);
  const [submitBtnTitle, setSubmitBtnTitle] = useState("Book");
  const [submitParatransitBtnTitle, setSubmitParatransitBtnTitle] = useState("Book");
  const [inputSuggestionListClientName, setInputSuggestionListClientName] = useState("");
  const [inputSuggestionListClientPhone, setInputSuggestionListClientPhone] = useState("");
  const [inputSuggestionListClientMedID, setInputSuggestionListClientMedID] = useState("");
  const [inputSuggestionListPU, setInputSuggestionListPU] = useState(null);
  const [inputSuggestionListDO, setInputSuggestionListDO] = useState(null);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const [highlightedIndexDO, setHightlightedIndexDO] = useState(-1);
  const [showStopBlock, setShowStopBlock] = useState(false);
  const [stopTripCheckBox, setStopTripCheckBox] = useState(false);
  const [stopSaveBtnTitle, setStopSaveBtnTitle] = useState("Save");
  const [stopEditInfo, setStopEditInfo] = useState({data:{}, index:0});
  const [showStopsInput, setShowStopsInput] = useState(true);
  const [affiliateAbbr, setAffiliateAbbr] = useState("");
  
  const [riderNameCheck, setRiderNameCheck] = useState("");
  const [medicalIDCheck, setMedicalIDCheck] = useState("");
  const [microtransit, setMicrotransit] = useState(true);
  const [ShowAPILoader, setShowAPILoader] = useState(false);
  const [MTSMTableHTML, setMTSMTableHTML] = useState(null);
  const [PredictiveTableHTML, setPredictiveTableHTML] = useState(null);
  const [mapVsSelected, setMapVSSelected] = useState([]);
  const [mapPointSelection, setMapPointSelection] = useState([]);

  const [rczVerifData, setRczVerifData] = useState([]);
  const [showClientActiveTripsModal, setShowClientActiveTripsModal] = useState(false);
  const [showClienteDuplicateTripsModal, setShowClienteDuplicateTripsModal] = useState(false);
  const [searchButtonValidation, setSearchButtonValidation] = useState("");
  const [activeTripConfirmation, setActiveTripConfirmation] = useState("");
  const [activeTripSelected, setActiveTripSelected] = useState(false);
  const [dynamicModeStyle, setDynamicModeStyle] = useState({});
  const [dynamicModeRowStyle, setDynamicModeRowStyle] = useState({});
  const [screenWidthSize, setScreenWidthSize] = useState(window.innerWidth);
  const [mapScreenHeightSize, setMapScreenHeightSize] = useState((window.innerHeight - 530 < 200 ? 200 : window.innerHeight - 530));
  const [summaryViewScreenHeightSize, setSummaryViewScreenHeightSize] = useState((window.innerHeight - (275 + mapScreenHeightSize)));
  const [TotalMTSMRecords, setTotalMTSMRecords] = useState(0);
  const [TotalPredictiveRecords, setTotalPredictiveRecords] = useState(0);
  const [manualFareChecks, setManualFareChecks] = useState({fareEstimateCheck: false, fareEstimateDisabled: false, mileEstimateCheck: false, mileEstimateDisabled: false, priceCheck: false, priceCheckDisabled: false});
  const [manualDistanceEditMode, setManualDistanceEditMode] = useState(false);
  const [IsAffMicroFlag, setIsAffMicroFlag] = useState(false);

  const searchButtonValidationRef = useRef('');
  const manualFareChecksRef = useRef({priceCheck:false, fareCheck:false, milesCheck:false});
  const puVSCallValidation = useRef(false);
  const doVSCallValidation = useRef(false);
  const puVSValueChanged = useRef("");
  const doVSValueChanged = useRef("");
  const isValidateRCZCalledFromReset = useRef(false);
  const addStopErrorFlag = useRef(false);
  const iframeRef = useRef(null);
  const showChatBotRef = useRef(false);
  const liRefRecentDropoffAddressComponent = useRef([]); // Array to hold refs for each <li> DO
  const liRefRecentPickupAddressComponent = useRef([]); // Array to hold refs for each <li> PU
  const liRefPickupAddressComponent = useRef([]); // Array to hold refs for each <li> PU
  const liRefDropoffAddressComponent = useRef([]); // Array to hold refs for each <li> DO
  const liRefStopAddressComponent = useRef([]); // Array to hold refs for each <li> Stop
  const liRefs = useRef([]); // Array to hold refs for each <li> PU
  const liRefsDO = useRef([]); // Array to hold refs for each <li> DO
  const xCancelSourceForGrid = useRef(null);
  const bookBtnRef = useRef(null);
  const paratransitBookBtnRef = useRef(null);
  const resetBtnRef = useRef(null);
  const agentNotesBtnRef = useRef(null);
  const phoneRef = useRef(null);
  const clientNameCheckRef = useRef(null);
  const clientMedIDCheckRef = useRef(null);
  const riderNameRef = useRef(null);
  const focusedSuggestionCheckPU = useRef(false);
  const focusedSuggestionCheckDO = useRef(false);
  const timeValidateCheck = useRef(false);
  const vsChangeRef = useRef({type:""});
  const affiliateSelRef = useRef(null);
  const searchClientBtnRef = useRef(null);
  const vsSelectedRef = useRef([]);
  const clientIndexRef = useRef({index:0, data:{}});
  const transitTypeRef = useRef([]);
  const addressSwitchBtnRef = useRef(null);
  const calculatedTimeCheck = useRef(0);
  const addressInfoDetails = useRef({pick: {state:"", city: "", zip: ""}, drop: {state:"", city:"", zip:""}});
  const mapPointPickupSelection = useRef([]);
  const mapPointDropoffSelection = useRef([]);
  const mapPointStopSelection = useRef([]);
  const apptTimeCheckValsRef = useRef({ServiceTime:0, ApptWindow:0, TimeWindow: 0});
  const DOVSDropdownRef = useRef(null);
  const PUVSDropdownRef = useRef(null);
  const validateZeroFare = useRef({FareAlertMessage: ""});
  //-------------------------------------------------------------Client Info Active Trips Modal
  const [showLoader, setShowLoader] = useState(false);
  const [showAddLegLoader, setShowAddLegLoader] = useState(false);
  const [showSearchLoader, setShowSearchLoader] = useState(false);
  const [AgentTripRecordsTableHTML, setAgentTripRecordsTableHTML] = useState(null);
  
  const [ActiveTripsTableData, setActiveTripsTableData] = useState([]);
  const [clientActiveTripsColData, setClientActiveTripsColData] = useState([]);

  const [duplicateTripsTableData, setDuplicateTripsTableData] = useState([]);
  const [stopLoadRiderName, setStopLoadRiderName] = useState("");
  const [stopUnloadRiderName, setStopUnloadRiderName] = useState("RN");
  const [modalResolveAllowDuplicate, setModalResolveAllowDuplicate] = useState(false);
  const [ctpanel, setCTPanel] = useState({ShowcontextPanel:false, ContextPanelData: "", ContextDateTime:"", ContextPhoneNo:""})


    const [mobilityFields, setMobilityFields] = useState(['Primary', 'Guest', 'PCA', 'Child']);
  //const [mobilityAttributeOptions, setMobilityAttributeOptions] = useState(['AMB', 'W.C.', 'Eectric W.C.', 'XL W.C.', 'Scooter', 'E.Scooter', 'CarSeat']);// Later provided from the Combined data API (Combined data API) 

  const [mobilityAttributeOptions, setMobilityAttributeOptions] = useState([]);
  const [mobilityPassengers, setMobilityPassengers] = useState({
    passenger: 1,
    children: 0,
  })

  const refMobilityAttributeOptions = useRef(mobilityAttributeOptions);

  const [mobilityDbData, setMobilityDbData] = useState({
      Primary: {},
      PCA: [],
      Guests: [],
      Children: [],
      IsMobility: false
  });


  const [mobilitySavedData, setMobilitySavedData] = useState({
    Primary: {},
    PCA: [],
    Guests: [],
    Children: [],
    IsMobility: false
});
  
const PredictiveRef = useRef({ ByPassPredictiveCheck: false, PredictiveData: null });


  
  useEffect(() => {
    handleSelectionsChange();
  }, [mobilitySavedData])


  var wcValues = ['W.C.', 'Eectric W.C.', 'XL W.C.', 'wheel chair', 'wheelchair', 'Electric Wheelchair', 'XL wheelchair'];
  wcValues = ['amb', "Ambulatory"];
  wcValues = wcValues.map(v => v.toLowerCase());

  function IsMobilityStructredData(_mobilitySavedData) {
    try {
      if (typeof _mobilitySavedData === "object" && _mobilitySavedData !== null) {
        return KNOWN_KEYS.some(key => key in _mobilitySavedData);
      }
      return false;
    } catch (error) {
      return false;
    }
  }
  
  const handleSelectionsChange = () => {
    let listOfSelectedAttributes = [];
    try {
      if (mobilityPassengers?.passenger >= 1) {
        if(IsMobilityStructredData(mobilitySavedData) === true){
          if(mobilitySavedData?.Primary != undefined){
            listOfSelectedAttributes.push(mobilitySavedData.Primary.selectedAttribute);
          }
        }
        else{
            const primaryRow = Object.values(mobilitySavedData).find(item => item.type === 'primary');
            if(primaryRow){
              listOfSelectedAttributes.push(primaryRow.selectedAttribute);
            }
          }
      }
    
  
    if (mobilityPassengers?.passenger >= 1) {
        if(IsMobilityStructredData(mobilitySavedData) === true){
          if(mobilitySavedData?.Guests != undefined){
            mobilitySavedData?.Guests.forEach(p => {
              if (p.selectedAttribute) {
                listOfSelectedAttributes.push(p.selectedAttribute);
              }
            });
          }
          if(mobilitySavedData?.PCA != undefined){
            mobilitySavedData?.PCA.forEach(p => {
              if (p.selectedAttribute) {
                listOfSelectedAttributes.push(p.selectedAttribute);
              }
            });
          }
        }
        else{
          const adultRows = Object.values(mobilitySavedData).filter(item => item.type === 'adult');
          adultRows.forEach(row => {
            if (row.selectedAttribute) {
              listOfSelectedAttributes.push(row.selectedAttribute);
            }
          });
        }
      }
  
      if (mobilityPassengers?.children >= 1) {
        if(IsMobilityStructredData(mobilitySavedData) === true){
          if(mobilitySavedData?.Children != undefined){
            mobilitySavedData?.Children.forEach(p => {
              if (p.selectedAttribute) {
                listOfSelectedAttributes.push(p.selectedAttribute);
              }
            });
          }
        }
        else{
          const adultRows = Object.values(mobilitySavedData).filter(item => item.type === 'children');
          adultRows.forEach(row => {
            if (row.selectedAttribute) {
              listOfSelectedAttributes.push(row.selectedAttribute);
            }
          });
        }
        
      }
      countTotalWCCount(listOfSelectedAttributes);
    } catch (error) {
      
    }
  };

  const validateMobilityCapacities = async (tripsDetailsObj) => {
    if(tripsDetailsObj == undefined){
      return;
    }
    try {
      let validationMsgsLst = [];
      let doesTripHasMultiLeg = tripsDetailsObj?.addressInfo?.Trips?.length > 1 ? true : false;
      if(doesTripHasMultiLeg){
        for (let index = 0; index < tripsDetailsObj?.addressInfo?.Trips?.length; index++) {
          let i = index + 1;
          let passengerInfoObj = tripsDetailsObj.addressInfo.Trips[index].Details[0].passengerInfo;
          if (passengerInfoObj) {
            const payload = {
              iAffiliateID: parseInt(selectedAff),
              Primary: passengerInfoObj.Primary,
              PCA: passengerInfoObj.PCA,
              Guests: passengerInfoObj.Guests,
              Children: passengerInfoObj.Children,
              IsCapacityValid: false
            };
            let response = await CallToValidateMobilityCapacities(payload, xCancelSourceForGrid, i);
            if (response?.length > 0) {
              validationMsgsLst.push(...response);
            }
          }
        }
      }
      else{
        const passengerInfoObj = tripsDetailsObj?.addressInfo?.Trips[0]?.Details[0]?.passengerInfo;
        if(passengerInfoObj){
          const _Primary = passengerInfoObj.Primary;
          const _PCA = passengerInfoObj.PCA;
          const _Guests = passengerInfoObj.Guests;
          const _Children = passengerInfoObj.Children;
          const payload = {
            iAffiliateID: parseInt(selectedAff),
            Primary: _Primary,
            PCA: _PCA,
            Guests: _Guests,
            Children: _Children,
            IsCapacityValid: false
          };
          let response = await CallToValidateMobilityCapacities(payload, xCancelSourceForGrid, 1, false);
          if(response?.length > 0){
            validationMsgsLst.push(...response);
          }
        }
      }
  
      let _validationMsg = "";
      if(validationMsgsLst?.length > 0){
        _validationMsg = (
          <div>
            {validationMsgsLst.map(item => (
              <div key={item.tripIndex} style={{ marginBottom: "0px" }}>
                {item.Msg}
              </div>
            ))}
          </div>
        );
        return { isCapacityValid: false, validationMsg: _validationMsg };
      }
      else{
        return { isCapacityValid: true, validationMsg: "" };
      }
    } catch (error) {
      return { isCapacityValid: true, validationMsg: "" };
    }
  };

  const unSelectedMobilityAttributes = () => {
    try {

      const unselected = [];

      if(mobilityPassengers.passenger >= 1)
      {
        if (!mobilityDbData.Primary?.Attributes || mobilityDbData.Primary.Attributes.trim() === '') {
          unselected.push('Primary');
        }
      }
      
  
      if(mobilityPassengers.passenger > 1){
        if (!mobilityDbData.PCA?.Attributes || mobilityDbData.PCA.Attributes.trim() === '') {
          unselected.push('PCA');
        }
      }
      
  
      if(mobilityPassengers.passenger >= 3){
        (mobilityDbData.Guests || []).forEach((guest, index) => {
          if (!guest?.Attributes || guest.Attributes.trim() === '') {
            unselected.push(`Guest ${index + 1}`);
          }
        });
      }
      
  
      if(mobilityPassengers.children >= 1){
        (mobilityDbData.Children || []).forEach((child, index) => {
          if (!child?.Attributes || child.Attributes.trim() === '') {
            unselected.push(`Child ${index + 1}`);
          }
        });
      }
      
  
     return unselected.length;
    } catch (error) {
      return 0;
    }
  }

  const [duplicateTripsGridOptions, setDuplicateTripsGridOptions] = useState({
    height: 300,
    heightoffset: 600,
    calculateHeight: false,
    pagination: true,
    sortCondition: true,
    paginationMode: "local",
    paginationSize: 500,
    paginationSizeSelector: [500, 1000, 1500, 2000, 2500],
    selectable: 1,
    reactiveData:false, //enable data reactivity
    layout: "fitDataStretch",
    placeholder:"No Data Available",
    clipboard: false,
    selectableRangeMode: "click",
    GridName:"clientInfoDuplicateTripsTable",
    paginationCounter:"rows",
    intervalTimer: GlobalASCSData.find(dict => dict.SubTitle === "Tb01") === undefined? 60000:GlobalASCSData.find(dict => dict.SubTitle === "Tb01").value*2000,
    movableColumns:true,
    vDefaultGridName: "SelectedGridRouteSRQARQPRQ_New",
    index: "iRefId",
    autoColumns: true,
    bSysUser: 1,
    intervalEnable: false,
    persistence: false,
    bWebApplySettingToAll: true,
    GridReturnOnlyIDColumnInRowData: false,
    containerClass: "col position-relative",
    Containerstyle: {},
    footerElement: '<button class="tabulator_btns" title="Export Excel" id="'
    +"clientInfoDuplicateTripsTable"+'_Export"></button><button class="tabulator_btns lastTabulator-btn" '
    +' title="Clear Filters" id="'+"clientInfoDuplicateTripsTable"+'_ClearFilters"></button>',
    tableDoubleClickFunc: function(table, row) {
      try{
        
      }
      catch(err){console.log(err);}
    },
    footerElementHandles: function (table) {
        activeTripsTableObjRef.current = table;
        // activeTripsTableObjRef.current.selectRow( activeTripsTableObjRef.current.getData()[0].iManifestNumber);
        let img = document.createElement("img");
          img.style.cssText = "width:16px; height:16px"; 
          img.src = ExportIcon;
          document.getElementById("clientInfoDuplicateTripsTable_Export").appendChild(img);

        img = document.createElement("img");
          img.style.cssText = "width:16px; height:16px"; 
          img.src = ClearFilterIcon;
          document.getElementById("clientInfoDuplicateTripsTable_ClearFilters").appendChild(img);

        document.getElementById("clientInfoDuplicateTripsTable_Export").addEventListener("click", function() {
          try{
            const data = table.getData('active');
            const columnsToIgnore = ['id'];
            let filteredData = data.map(row =>{
              const filteredRow = {...row};
              columnsToIgnore.forEach(column => delete filteredRow[column]);
              return filteredRow;
            });
            
            const sheet = XLSX.utils.json_to_sheet(filteredData);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, sheet, "MRMS Data");
            XLSX.writeFile(wb, "DuplicateTrips_data.xlsx");
          }
          catch(err){console.log(err);}
        });
        document.getElementById('clientInfoDuplicateTripsTable_ClearFilters').addEventListener("click", function(){
            table.clearHeaderFilter();
        });
    },
    rowSelectionChangeHandle: function(data){
      try{

      }
      catch(err){console.log(err);}
    },
    ActionList: true,
    listofCheckBoxCols : [],
    AlwaysHiddenColumns: []
  });

  

  const [activeTripsGridOptions, setActiveTripsGridOptions] = useState({
    height: 300,
    heightoffset: 600,
    calculateHeight: false,
    pagination: true,
    sortCondition: true,
    paginationMode: "local",
    paginationSize: 500,
    paginationSizeSelector: [500, 1000, 1500, 2000, 2500],
    selectable: 1,
    reactiveData:false, //enable data reactivity
    layout: "fitDataStretch",
    placeholder:"No Data Available",
    clipboard: false,
    selectableRangeMode: "click",
    GridName:"ClientActiveTripsGrid",
    paginationCounter:"rows",
    intervalTimer: GlobalASCSData.find(dict => dict.SubTitle === "Tb01") === undefined? 60000:GlobalASCSData.find(dict => dict.SubTitle === "Tb01").value*2000,
    movableColumns:true,
    vDefaultGridName: "ClientActiveTripsGrid",
    index: "iRefId",
    autoColumns: true,
    bSysUser: 1,
    saveCCSettingsOption: true,
    intervalEnable: false,
    persistence: true,
    bWebApplySettingToAll: true,
    GridReturnOnlyIDColumnInRowData: false,
    containerClass: "col position-relative",
    Containerstyle: {},
    footerElement: '<button class="tabulator_btns" title="Export Excel" id="'
    +"ClientActiveTripsGrid"+'_Export"></button><button class="tabulator_btns lastTabulator-btn" '
    +' title="Clear Filters" id="'+"ClientActiveTripsGrid"+'_ClearFilters"></button>',
    tableDoubleClickFunc: function(table, row) {
      try{
        
      }
      catch(err){console.log(err);}
    },
    footerElementHandles: function (table) {
        activeTripsTableObjRef.current = table;
        // activeTripsTableObjRef.current.selectRow( activeTripsTableObjRef.current.getData()[0].iManifestNumber);
        let img = document.createElement("img");
          img.style.cssText = "width:16px; height:16px"; 
          img.src = ExportIcon;
          document.getElementById("ClientActiveTripsGrid_Export").appendChild(img);

        img = document.createElement("img");
          img.style.cssText = "width:16px; height:16px"; 
          img.src = ClearFilterIcon;
          document.getElementById("ClientActiveTripsGrid_ClearFilters").appendChild(img);

        document.getElementById("ClientActiveTripsGrid_Export").addEventListener("click", function() {
          try{
            const data = table.getData('active');
            const columnsToIgnore = ['id'];
            let filteredData = data.map(row =>{
              const filteredRow = {...row};
              columnsToIgnore.forEach(column => delete filteredRow[column]);
              return filteredRow;
            });
            
            const sheet = XLSX.utils.json_to_sheet(filteredData);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, sheet, "MRMS Data");
            XLSX.writeFile(wb, "ActiveTrips_data.xlsx");
          }
          catch(err){console.log(err);}
        });
        document.getElementById('ClientActiveTripsGrid_ClearFilters').addEventListener("click", function(){
            table.clearHeaderFilter();
        });
    },
    rowSelectionChangeHandle: function(data){
      try{

      }
      catch(err){console.log(err);}
    },
    ActionList: true,
    listofCheckBoxCols : [],
    AlwaysHiddenColumns: []
  });
  const [showAddrPhone, setShowAddrPhone] = useState({pick: false, drop: false});
  const [addrPhoneInfo, setAddrPhoneInfo] = useState({pick: null, drop: null});

  const [showAddrApartment, setShowAddrApartment] = useState({pick: false, drop: false});
  const [addrApartmentInfo, setAddrApartmentInfo] = useState({pick: null, drop: null});

  const activeTripsTableObjRef = useRef(null);
  //-------------------------------------------------------------
  //-------------------------------------------------------------Client Info
  const [addLegBtnTitle, setAddLegBtnTitle] = useState("Add Leg");
  const [verifiedInfoUpdateIndex, setVerifiedInfoUpdateIndex] = useState(0);
  const [stopLoadType, setStopLoadType] = useState({none:true, load:false, unload:false});
  const [passengerTypeCountStop, setPassengerTypeCountStop] = useState({ambPass:1,totalWC:0,totalSA:0, total:1});
  const [clientStops, setClientStops] = useState([]);
  const [FSDropdown, setFSDropdown] = useState([]);
  const [COSDropdown, setCOSDropdown] = useState([]);
  const [PayDropdown, setPayDropdown] = useState([]);
  const [CopayFSDropdown, setCopayFSDropdown] = useState([]);
  const [COSSelected, setCOSSelected] = useState(1);
  const [PaySelected, setPaySelected] = useState(1);
  const [FSSelected, setFSSelected] = useState("");
  const [COSTargetID, setCOSTargetID] = useState(0);
  const [FSTargetID, setFSTargetID] = useState("");
  const [PayTargetID, setPayTargetID] = useState("");
  const [clientInfo, setClientInfo] = useState([]);
  const [clientIDInfo, setClientIDInfo] = useState([]);
  const [forcePassServiceHoursCheck, setForcePassServiceHoursCheck] = useState(false);
  const [riderVerification, setRiderVerification] = useState("");
  const [brokerModes, setBrokerModes] = useState({brokerMode:0, globalBrokerMode:0});
  const [schTime, setSchTime] = useState("");
  const [recentAddresses, setRecentAddresses] = useState([]);
  const [phone, setPhone] = useState(null);
  const [srcUrl, setSrcUrl] = useState('');
  const [chatBotPhone, setChatBotPhone] = useState('');
  const [callBackPhone, setCallBackPhone] = useState(null);
  const [callBackActual, setCallBackActual] = useState("");
  const [riderName, setRiderName] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [isPhoneUpdateFromFunction, setIsPhoneUpdateFromFunction] = useState(false);
  const [historyTrips, setHistoryTrips] = useState(()=>{
    const savedTrips = PersistStorage.retrieve("agentTrips", true);
    if(savedTrips === null)  // Check if "agentTrips" key exists in localStorage
    {
      PersistStorage.save("agentTrips", [], true);
      return []; // Return an empty array as initial state
    }
    return savedTrips;
  });
  const [selectedAff, setSelectedAff] = useState(()=>{
    let storedSelection = PersistStorage.retrieve("affSelectedCallAgent", true);
    if(storedSelection) {
      if(storedSelection.includes(","))
      {
        return (AffiliateData.find(item => parseInt(item.iTransType) === 2))?.AffiliateID || 125;
      }
      else
      {
        return storedSelection;
      }
    }
    else {
      return (AffiliateData.find(item => parseInt(item.iTransType) === 2))?.AffiliateID || 125;
    }
  });
  const [confirmationNo, setConfirmationNo] = useState("");
  const [schPUTime, setSchPUTime] = useState("");
  const [tripStatus, setTripStatus] = useState("");
  const [clientStatus, setClientStatus] = useState("");
  const [passengerTypeCount, setPassengerTypeCount] = useState({ambPass:1,totalWC:0,totalSA:0, total:1, totalChildren: 0});
  const [clientSummary, setClientSummary] = useState({totalCalls:0, totalNS:0, totalCancels:0, 
    lastCall:"", tripDistance:0.0, TripDuration:0.0, TripFare:0.0, TripCopay:0.0}
  );


  const [zones, setZones] = useState("");
  const [fareZones, setFareZones] = useState({pick:"", drop:""});
  const [dispatchZones, setDispatchZones] = useState({pickZone:"", dropZone:""});
  const [agentNotes, setAgentNotes] = useState("");
  const [pickupAddr, setPickupAddr] = useState("");
  const [dropAddr, setDropAddr] = useState("");
  const [pickupVirtualStop, setPickupVirtualStop] = useState({name:"", value:"PU VS"});
  const [dropAddrVirtualStop, setDropAddrVirtualStop] = useState({name:"", value:"DO VS"});
  const [walkDistance, setWalkDistance] = useState({PUWalk:0, DOWalk:0, PUDuration:0, DODuration:0});
  const [pickExtraInfo, setPickExtraInfo] = useState("");
  const [dropExtraInfo, setDropExtraInfo] = useState("");
  const [clientNameList, setClientNameList] = useState([]);
  const [pickPOI, setPickPOI] = useState("");
  const [dropPOI, setDropPOI] = useState("");
  const [stopPOI, setStopPOI] = useState("");
  const [showCCInfoDialog, setShowCCInfoDialog] = useState(false);
  const [showClientInfoCreationDialog, setShowClientInfoCreationDialog] = useState(false);
  const [mainInfoNewClient, setMainInfoNewClient] = useState({type:'', value: ''});
  const [newClientInfoExtraInfo, setNewClientInfoExtraInfo] = useState({language: 0, passType: '', agentNotes: '', ID: '',
    remarks: '', email: '', rollcall: {phone: false, sms: false, email: false}, priority: '', name: '', affDetails: {affID: 0, FSID: 0}, phone: ''
  });

  const stopPassengerLoadTrackerRef = useRef(0);
  const pickExtraInfoRef = useRef(null);
  const dropLatLng = useRef("");
  const pickLatLng = useRef("");
  const fareZonesRef = useRef({pickFareZone:"", dropFareZone:""});
  const searchedClientID = useRef(-1);
  const liClientNameRefs = useRef([]); // Array to hold refs for each <li> Client Names
  const liClientPhoneRefs = useRef([]); // Array to hold refs for each <li> Client Numbers
  const liClientMedicalIDRefs = useRef([]); // Array to hold refs for each <li> Client MED ID
  const focusedSuggestionCheckClientName = useRef(false);
  const focusedSuggestionCheckMedicalID = useRef(false);
  const focusedSuggestionCheckClientPhone = useRef(false);
  const StopNameSelectionRef = useRef(null);
  const rowData = useRef([]);
  const clientInfoDisplayRef = useRef(null);
  const passengerCountPassengerRef = useRef(null);
  const addLegBtnRef = useRef(null);
  const apptTimeRef = useRef(null);
  const debounceTimeout = useRef(null); // Holds the timeout for debouncing
  const puTimerIntervalRef = useRef(null); //Timer for user entry on PU address
  const puPOITimerIntervalRef = useRef(null); //Timer for user entry on PU address
  const doTimerIntervalRef = useRef(null); //Timer for user entry on DO address
  const doPOITimerIntervalRef = useRef(null); //Timer for user entry on PU address
  const searchClientFlagRef = useRef(false);
  const ITCMapURL = useRef((selectedAff && ASCSSettingData[selectedAff] ? (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "ITCMapServiceURL")).value+"autocomplete?address=": "https://itcmap.itcurves.us/api/Map/autocomplete?address="));
  const ITCMapDirections = useRef((selectedAff && ASCSSettingData[selectedAff] ? (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "ITCMapServiceURL")).value+"directions": "https://itcmap.itcurves.us/api/Map/directions"));
  const ITCMapRawURL = useRef((selectedAff && ASCSSettingData[selectedAff] ? (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "ITCMapServiceURL")).value : "https://itcmap.itcurves.us/api/map/"));
  const OSRM_Username = useRef((selectedAff && ASCSSettingData[selectedAff] ? (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "ITCMapServiceUserName")).value : "REGENCY"));
  const OSRM_Password = useRef((selectedAff && ASCSSettingData[selectedAff] ? (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "ITCMapServicePassword")).value : "barwoodpass"));
  const EnablePredictiveNegotiation = parseInt(useRef((selectedAff && ASCSSettingData[selectedAff] ? (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "EnablePredictiveNegotiation")).value : "barwoodpass")).current);
  const MaxPassengerCount_ASCS = useRef((selectedAff && ASCSSettingData[selectedAff] ? (JSON.parse(ASCSSettingData[selectedAff]).find((item) => item.SubTitle === "MaxPassengerCount"))?.value : 0) ?? 0 );
  //-------------------------------------------------------------
  //-------------------------------------------------------------Schedule PU Info
  const [requiredClass, setRequiredClass] = useState("");
  const validateUserEnteredSchedulePickuptime = useRef(false);
  const isPreviousLegSchTimeValidated = useRef(false);
  const [selectedDateSchTime, setSelectedDateSchTime] = useState("");
  useEffect(() => {
    
    const validateFutureDate = async () => {
      //await FutureDateValidation();
    }
    validateFutureDate();
    
  }, [selectedDateSchTime])
  const [systemDateTime, setSystemDateTime] = useState({time:"", date:""});
  const [appointmentTime, setAppointmentTime] = useState("");
  const [willCall, setWillCall] = useState(false);
  useEffect(() => {

    if(willCall){
      setRequiredClass("");
    }

  }, [willCall])
  const [multischModalShow, setMultischModalShow] = useState(false);
  const [scheduleJSON, setScheduleJSON] = useState({mainData: "", multiSchData:"", range:"", neverExpire:false});
  const systemDateTimeRef = useRef({time:"", date:"", givenDate:"", givenTime:"", timeWithSettingAdded:0});
  const timeZoneDiff = useRef(0);
  const addedMinutesSystemSetting = useRef((selectedAff && ASCSSettingData[selectedAff] ? 
    parseInt((JSON.parse(ASCSSettingData[selectedAff]).find((item) => item.SubTitle === "Ta01")).value) / 60 : 0)
  );
  //-------------------------------------------------------------
  //-------------------------------------------------------------Stop Addr Info
  const [stopAddr, setStopAddr] = useState("");
  const [stopAddrZone, setStopAddrZone] = useState("");
  const [stopAddrExtra, setStopAddrExtra] = useState("");
  const [stopWillCall, setStopWillCall] = useState(false);
  const [stopWaitTimeInput, setStopWaitTimeInput] = useState(0);
  const [stopPhone, setStopPhone] = useState(null);
  const [highlightedIndexStop, setHightlightedIndexStop] = useState(-1);
  const [inputSuggestionListStop, setInputSuggestionListStop] = useState(null);
  const stopLatLng = useRef("");
  const liRefsStop = useRef([]); // Array to hold refs for each <li> Stop
  const focusedSuggestionCheckStop = useRef(false);
  //-------------------------------------------------------------
  //-------------------------------------------------------------Mobility Info
  const [mobilityDetails, setMobilityDetails] = useState({totalVeh:1, vehTypeMin:0, vehNumMin:0, driverNumMin:0, genderMin:0, languageMin:0});
  const [mobilityChecks, setMobilityChecks] = useState({vehTypeCheck:false, vehNumCheck:false, driverNumCheck:false, genderCheck:false, languageCheck:false});
  const [selectedTripAttr, setSelectedTripAttr] = useState([]);
  const [vehNumberOptionsHTML, setVehNumberOptionsHTML] = useState([]);
  const [vehTypeOptionsHTML, setVehTypeOptionsManageHTML] = useState([]);
  const [driverNumberOptionsHTML, setDriverNumberOptionsHTML] = useState([]);
  const [languageOptionsHTML, setLanguageOptionsHTML] = useState([]);
  const [selectedVehNum, setSelectedVehNum] = useState("VN");
  const [selectedVehType, setSelectedVehType] = useState("VT");
  const [selectedDriverNum, setSelectedDriverNum] = useState("DN");
  const [selectedGender, setSelectedGender] = useState("Gender");
  const [selectedLanguage, setSelectedLanguage] = useState("Language");
  const [AttributesFilterMultiSelect, SetAttributesFilterMultiSelect] = useState({options: [], selectedValues:selectedTripAttr, placeholder:"Trip Attributes",
    displayValue:"name", emptyRecordMsg:"N/A", id:"DispatchGridAttributesSelect", className:"callAgentInputStyle border-0 text-nowrap toolbarCallAgent", 
    AllItemsSelectedPlaceHolder:"All Attributes", SelectAllPlaceHolder:"",
    styles:{ width:"100%", maxHeight:"30px", display:"block", minWidth:"120px", marginLeft:"0.5rem", height:"30px", backgroundColor:"#e6eef1", border:0, borderRadius:"5px"}});
  const mobilityInfoDisplayRef = useRef(null);
  const languageOptionsSelRef = useRef(null);
  //-------------------------------------------------------------
  //-------------------------------------------------------------Insurance Info
  const [medID, setMedID] = useState("");
  const [insuranceName, setInsuranceName] = useState("");
  const [insuranceDOB, setInsuranceDOB] = useState("");
  const [insuranceSSN, setInsuranceSSN] = useState("");
  const [SSNDisplayValue, setSSNDisplayValue] = useState("");
  const [insuranceAuthCode, setInsuranceAuthCode] = useState("");
  const [insuranceType, setInsuranceType] = useState("");
  const [insuranceAgency, setInsuranceAgency] = useState("");
  const [insuranceServiceCode, setInsuranceServiceCode] = useState("");
  const [insuranceCaseWorker, setInsuranceCaseWorker] = useState("");
  const [insuranceRide, setInsuranceRide] = useState("");
  const insuranceRideSelRef = useRef(null);
  const insuranceInfoDisplayRef = useRef(null);
  //-------------------------------------------------------------
  //-------------------------------------------------------------Payment Info
  const [copayAmount, setCopayAmount] = useState(0);
  const [fareEstimateAPISummary, setFareEstimateAPISummary] = useState({copay: 0, walletID: 0, promo: "", eaasJSON: "", displayMessage: "", verifyStatus: ""});
  const [minMonth, setMinMonth] = useState('');
  const [maxMonth, setMaxMonth] = useState('');
  const [cardNumber, setCardNumber] = useState("");
  const [cardType, setCardType] = useState("");
  const [cardInfo, setCardInfo] = useState({cardNumber:"", expiry: "", selectedCard: "", selectedExpiry: "", selectedCardType: "", uniqueID: 0, gateID: "", response: ""});
  const [showCCBtn, setShowCCBtn] = useState(false);
  const [cardExpiration, setCardExpiration] = useState("");
  const [clientEmail, setClientEmail] = useState("");
  const [copayFSSelected, setCopayFSSelected] = useState("");
  const [copayPayTypeSelected, setCopayPayTypeSelected] = useState("CPT");
  const [RCType, setRCType] = useState({phoneType:false, emailType:false, SMSType:false});
  const [clientJob, setClientJob] = useState("");
  const [paymentAdditionalInfo, setPaymentAdditionalInfo] = useState("");
  const [selectedTripType, setSelectedTripType] = useState(3);
  const [selectedTripPriority, setSelectedTripPriority] = useState(5);
  const [tripTypeOptionsHTML, setTripTypeOptionsHTML] = useState([]);
  const [fareMethod, setFareMethod] = useState(0);
  const [fareDataArr, setFareDataArr] = useState([]);
  const [CheckCCParams, setCheckCCParams] = useState("");
  const fareMethodRef = useRef(0);
  const paymentCardIDInfoRef = useRef({uniqueID: -1, oldUniqueID: -1, payStatusID: -1, invalidForSave: 0, retCCUniqueID: -1, CCPaidAmount: 0, CCRetPaidAmount: 0});
  const manualCheckRef = useRef({AgentPriceAdjustmentFSIDs: "", SDEnableNegotiatedFare: -1, AgentPriceAdjustmentFareFSIDs: ""});

  //-------------------------------------------------------------
  //-------------------------------------------------------------Stop Order
  const [verifiedAddr, setVerifiedAddr] = useState([]);
  const [tripDetails, setTripDetails] = useState({pickAddr: "", dropAddr: "", date: "", 
    time: "", distance: 0, duration: 0, fare: 0, copay: 0, willCall: false, apptTime: "", notes:"", phone:"",
    puNotes:"", doNotes:"", riderName:"", passCount: 0, waitTime: "", clientCity: "", clientState: "",
    id: 0, clientMedID: 0, clientAddr: "", FundingSource: 0, PaymentSelected: 0, AffiliateSelected: 0, COS: 0, copay:0.0, 
    cardNum: "", cardExp: "", RC: RCType, driverNum: "", driverNumCheck: false,
    driverMins: 0, gender: "", genderMins: 0, vehNum: "", vehType:"", vehTypeCheck: false, vehTypeMins: 0,
    vehNumCheck: false, vehMins: 0, language: "", languageMins: 0,
    tripAttribute: "", insurance: {Agency: 0, Type: 0, CaseWorker: 0, AuthCode: 0, ServiceCode: 0}
  });
  //-------------------------------------------------------------
  //------------------------------------------------------------- Map
  const [mapData, setMapData] = useState([]);
  const [mapOptionsCallAgent, setMapOptionsCallAgent] = useState({
    mapPolylines:{single:true,multiple:false},
    mapZoomOpts: {zoomControl: false, draggable: true, scrollWheel: true, disableDoubleClickZoom: false},
    mapDefaultBtns: false,
    mapOptions: {tilt: 47.5, zoom: 12, zone:true, aff: selectedAff},
    GridName:"callAgent",
  });
  const [MicrotransitMapWalkPolyline, SetMicrotransitMapWalkPolyline] = useState({pick: 0 , drop: 0});
  const microPolylineDict = useRef({pick:0, drop:0});
  const [showForceReqTimeModal, setShowForceReqTimeModal] =  useState({show: false, title: 'Edit Request Time', forceReqDate: '', forceReqTime: '',  ForceReqTripID: "-1" });
  //-------------------------------------------------------------
  //#region UseEffects



/**
 * This function will validate if the Schedule time is provided or not when 
 * the Booking Date is in future
 */
  const FutureDateValidation = async () => {
    if(enableFutureDateValidation == false || willCall || riderName === ""){
      setRequiredClass("");
      return;
    }
    let continueBooking = true;
    try {
      let serverDateTime = await DateTimeUtils.getCurrentSystemDateTime();

      if(selectedDateSchTime != undefined && selectedDateSchTime != ""){

        let server_Month = serverDateTime.split("/")[0];
        let server_Day = serverDateTime.split("/")[1];
        let server_Year = serverDateTime.split("/")[2].split(" ")[0];
        serverDateTime = server_Year + "-" + server_Month + "-" + server_Day; 
        const userDate = moment(selectedDateSchTime, "YYYY-MM-DD");
        const _serverDate = moment(serverDateTime, "YYYY-MM-DD");

        // Check if time1 is greater than time2
        if (userDate.isAfter(_serverDate, 'day')) {
          if(schTime == undefined || schTime == ""){
              validateUserEnteredSchedulePickuptime.current = true;
              setRequiredClass("input-warning");
              toast.error("Required: Please enter the pickup requested time in the highlighted field.", {
                autoClose: 6000,
                hideProgressBar: true,
                position: "top-center",
                closeOnClick: true,
                pauseOnHover: true
              });
              continueBooking = false;
              return continueBooking;
          }
          else{
            setRequiredClass("");
            validateUserEnteredSchedulePickuptime.current = false;
          }
        } else {
          setRequiredClass("");
          validateUserEnteredSchedulePickuptime.current = false;
        }
      }
      return continueBooking;
   } catch (error) {
      console.error("An Error occured while validating the user entered date");
      setRequiredClass("");
      validateUserEnteredSchedulePickuptime.current = false;
      return continueBooking;
   }
  }

  const handleMobilityAttributesBtn = (e) => {
    try {

      // Update passenger attribute details from here
      const newPassengerCount = parseInt(passengerTypeCount.total);
      const oldPassengerCount = mobilityPassengers.passenger || 0;
      if (newPassengerCount < oldPassengerCount) {
      
        const updatedData = { ...mobilityDbData };
    
        // Primary always exists if passenger count >= 1
        if (newPassengerCount === 0) {
          updatedData.Primary = {Name: "Primary", Attributes: ""};
          updatedData.PCA = [];//{Name: "PCA", Attributes: ""};
          updatedData.Guests = [];
        }
    
        // If only 1 passenger, no PCA or guests
        if (newPassengerCount === 1) {
          updatedData.PCA = [];//{Name: "PCA", Attributes: ""};;
          updatedData.Guests = [];
        }
    
        // If 2 passengers, include PCA but no guests
        // if (newPassengerCount === 2) {
        //   updatedData.Guests = [];
        // }
    
        // If > 2, keep only needed guests
        if (newPassengerCount > 2 && Array.isArray(mobilityDbData.Guests)) {
          //const maxGuests = newPassengerCount - 2;
          //updatedData.Guests = mobilityDbData.Guests.slice(0, maxGuests);
        }
    
        // Call setData or dispatch updated data
        setMobilityDbData(updatedData);
      }

       setShowMobilityAttributes(true);
    } catch (error) {
      
    }
  }

  // const countTotalWCCount = (updatedSelections) => {
  //   try {
  //     const selectedKeys = Object.values(updatedSelections)
  //     .map(k => parseInt(k))
  //     .filter(k => !isNaN(k));
    
  //     const wcCount = selectedKeys.filter(key =>
  //       !wcValues.includes(
  //         mobilityAttributeOptions.find(opt => opt.key === key)?.value?.toLowerCase()
  //       )
  //     ).length;

  //     if(wcCount >= 0 && passengerTypeCount?.totalWC != undefined){
  //       passengerTypeCount.totalWC = wcCount;
  //     }
  //   } catch (error) {
      
  //   }
  // }

  const countTotalWCCount = (updatedSelections) => {
    try {
      const selectedKeys = Object.values(updatedSelections)
      .map(k => parseInt(k))
      .filter(k => !isNaN(k));
    
      const wcCount = selectedKeys.filter(key =>
        !wcValues.includes(
          mobilityAttributeOptions.find(opt => opt.key === key)?.value?.toLowerCase()
        )
      ).length;

      if(wcCount >= 0 && passengerTypeCount?.totalWC != undefined){
        passengerTypeCount.totalWC = wcCount;
        setPassengerTypeCount({...passengerTypeCount, totalWC:parseInt(wcCount)});
      }
    } catch (error) {
      
    }
  }

  const countTotalWCCountFromObject = (updatedSelections) => {
    try {
      const selectedKeys = [];
  
      // Handle Primary and PCA
      if (updatedSelections.primary?.Attributes) {
        selectedKeys.push(parseInt(updatedSelections.primary.Attributes));
      }

      if (Array.isArray(updatedSelections.pca)) {
        updatedSelections.pca.forEach(item => {
          if (item.Attributes) {
            selectedKeys.push(parseInt(item.Attributes));
          }
        });
      }

      // Handle Guests
      if (Array.isArray(updatedSelections.guests)) {
        updatedSelections.guests.forEach(guest => {
          if (guest.Attributes) {
            selectedKeys.push(parseInt(guest.Attributes));
          }
        });
      }
  
      // Handle Children
      if (Array.isArray(updatedSelections.children)) {
        updatedSelections.children.forEach(child => {
          if (child.Attributes) {
            selectedKeys.push(parseInt(child.Attributes));
          }
        });
      }
  
      // Filter out NaN
      const validKeys = selectedKeys.filter(k => !isNaN(k));
  
      // Count how many of these keys match wheelchair-related values
      let attributes = refMobilityAttributeOptions.current;
      const wcCount = validKeys.filter(key =>
        !wcValues.includes(
          attributes.find(opt => opt.key === key)?.value?.toLowerCase()
        )
      ).length;
  
   
      if (wcCount >= 0 && passengerTypeCount?.totalWC !== undefined) {
        return wcCount;
        //setPassengerTypeCount({...passengerTypeCount, totalWC:parseInt(wcCount)});
      }
      return 0;
    } catch (error) {
      console.error("Error counting total wheelchair count:", error);
      return 0;
    }
  };

  


  useEffect(() => {
    try{
      document.title = "Call Agent 2.0";
      timeZoneDiff.current = loginData.TimeZoneDifference;
      const URL = GlobalASCSData.find(dict => dict.SubTitle.toLowerCase() === "chatboturl") ? GlobalASCSData.find(dict => dict.SubTitle.toLowerCase() === "chatboturl").value : "";
      setSpecificLinkRequirement(URL); //If chatbot URL exists in setting, it is set here for use in iframe of chatbot
        
      const queryParams = new URLSearchParams(window.location.search);
      const tripSelected = queryParams.get('TripSelected')? true:false;
      if(bookBtnRef.current) //If microtransit, disable booking until addresses are populated
      {
        bookBtnRef.current.disabled = true;
      }
      rowData.current = (PersistStorage.retrieve("rowDataCallAgent", true)  && tripSelected? PersistStorage.retrieve("rowDataCallAgent", true):[]); //Get rowData from selected row on D2.0
      let editRowData = (PersistStorage.retrieve("rowDataEditTrip", true)  && tripSelected? PersistStorage.retrieve("rowDataEditTrip", true):""); //Get edit data from API called on D2.0
      let affCheck = PersistStorage.retrieve("affSelectedCallAgent", true); //Get selected aff if any
      let editRowDataFlag = (editRowData && editRowData !== "" && editRowData !== "No data found" && typeof editRowData === 'object'); //Making a flag for edit data if available
      let selectedAffVS = [];
      let tripData = null;
      let affiliateID = (affCheck && !affCheck.includes(",") && affCheck != null ? affCheck : ((AffiliateData.find(item => parseInt(item.iTransType) === 2))?.AffiliateID || AffiliateData[0].AffiliateID)); //Finding the correct affiliate ID selection
      let tripTypeArr = [{name:"Corporate", val:1}, {name:"Airport", val:2}, {name:"Normal", val:3} , 
        {name:"Corporate/Airport", val:5} , {name:"WheelChair", val:8}, {name:"Break Trip", val:9}, {name:"Depot Trip", val:10}
      ];
      let SettingData = (affiliateID && ASCSSettingData[affiliateID] ? JSON.parse(ASCSSettingData[affiliateID]) : "");
      let AgentPriceAdjustmentFSIDs = (SettingData !== "" ? (SettingData.find((item) => item.SubTitle === "FS_IDs_AgentPriceAdjustment")).value : "");
      let SDEnableNegotiatedFare = (SettingData !== "" ? SettingData.find((item) => item.SubTitle === "SDEnableNegotiatedFare").value : 0);
      let AgentPriceAdjustmentFareFSIDsSetting = (SettingData !== "" ? (SettingData.find((item) => item.SubTitle === "FS_IDs_AgentFareAdjustment")).value : "");
      manualCheckRef.current = {AgentPriceAdjustmentFSIDs: AgentPriceAdjustmentFSIDs, SDEnableNegotiatedFare: SDEnableNegotiatedFare, AgentPriceAdjustmentFareFSIDs: AgentPriceAdjustmentFareFSIDsSetting};

   
      let mobilityAttributesLst = AttributeData ? AttributeData.filter((item,index)=> {return parseInt(item.iAttrATSPID) === parseInt(affiliateID) && parseInt(item.iAttrType) === 10}) : [];
      let mobilityAttrOptions = mobilityAttributesLst && mobilityAttributesLst.length > 0 ? mobilityAttributesLst.map((item)=>{
        let dict = {};
        dict.key = item.ID;
        dict.value = item.Title;
        dict.iAttrType = item.iAttrType;
        return dict;
      }).sort((a, b) => a.value.localeCompare(b.value)) : [];
      setMobilityAttributeOptions(mobilityAttrOptions);
      refMobilityAttributeOptions.current = mobilityAttrOptions;


      //Finding transit type info to use for distinguishing between micro vs para
      transitTypeRef.current = AffiliateData.filter((item,index) => {
        try{
          return parseInt(item.AffiliateID) === parseInt(affiliateID);
        }
        catch(err){console.log(err);}
      });

      if(editRowData && editRowData !== "" && typeof editRowData === 'object') //Check if edit data from selected trip exists
      {
        if(editRowData === "No data found") //If API returns nothing, inform user in a modal that edit is not possible
        {
          getCurrentSystemDateTime("date", true); //Get server date & time
          setSubmitBtnTitle("Book");
          setModalHeaderText("No Data Found");
          setModalBodyHTML("There is no record in system for the selected trip, please select another or contact the administrator.");
          setModalFooterHTML(
            <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
              OK
            </Button>
          );
          setShowDynamicModal(true);
          
        }
        else //Data exists for edit
        {
          getCurrentSystemDateTime("date", false); //Get server date & time
          handleEditTrip(editRowData, ""); //Call main function for handling population of existing trip data on call taker
          
          if(bookBtnRef.current) //Change book btn titles according to type of affiliate (micro vs para)
          {
            setSubmitBtnTitle("Update");
          }
          else
          {
            setSubmitParatransitBtnTitle("Update");
          }
        }
        
      }
      else //New reservation is being made
      {
        getCurrentSystemDateTime("date", true); //Get server date & time
        if(bookBtnRef.current) //Change book btn titles according to type of affiliate (micro vs para)
        {
          setSubmitBtnTitle("Book");
        }
        else
        {
          setSubmitParatransitBtnTitle("Book");
        }
      }

      let tripTypeHTML = tripTypeArr.map(function(item, index){
        return(
          <option key={index} value={item.val}>{item.name}</option>
        );
      });
      let attrSelection = AttributeData ? AttributeData.filter((item,index)=> {return parseInt(item.iAttrATSPID) === parseInt(affiliateID) && parseInt(item.iAttrType) !== 10 }) : [];
      let attrOptionsMultiSel = attrSelection && attrSelection.length > 0 ? attrSelection.map((item)=>{
        let dict = {};
        dict.id = item.ID;
        dict.name = item.Title;
        return dict;
      }).sort((a, b) => a.name.localeCompare(b.name)) : [];

      setTripTypeOptionsHTML(tripTypeHTML); //Set trip type dropdown options
      
      if(editRowDataFlag) //Condition block to find correct trip to show for edit
      {
        for(let k = 0; k < editRowData.addressInfo.trips.length; k++)
        {
          if(parseInt(rowData.current[0].iRefID) === parseInt(editRowData.addressInfo.trips[k].details[0].tripInfo.refID))
          {
            tripData = editRowData.addressInfo.trips[k];
          }
        }

        tripData = tripData || editRowData.addressInfo.trips[0];
        
        if(tripData.details[0].tripInfo.entityAttributes !== "") //Setting up the attribute dropdown with appropriate options and selected options (if any)
        {
          let providedAttrArr = [];
          let groupSelected = [];
          if(tripData.details[0].tripInfo.entityAttributes.includes(","))
          {
            providedAttrArr = tripData.details[0].tripInfo.entityAttributes.split(",");
            setSelectedTripAttr(providedAttrArr);
          }
          else
          {
            providedAttrArr.push(tripData.details[0].tripInfo.entityAttributes);        
            setSelectedTripAttr(providedAttrArr);    
          }
          
          for(let k = 0; k < attrOptionsMultiSel.length; k++)
          {
            if(providedAttrArr.includes(String(attrOptionsMultiSel[k].id)))
            {
              groupSelected.push({id:attrOptionsMultiSel[k].id, name:attrOptionsMultiSel[k].name});
            }
          }
  
          SetAttributesFilterMultiSelect({ ...AttributesFilterMultiSelect, ...{options: attrOptionsMultiSel,
            selectedValues:(editRowData && tripData.details[0].tripInfo.entityAttributes !== "" ? groupSelected : [])}}
          );
        }
      }
      else
      {
        SetAttributesFilterMultiSelect({ ...AttributesFilterMultiSelect, ...{options: attrOptionsMultiSel,
          selectedValues:[]}}
        );
      }
      
      // //Finding transit type info to use for distinguishing between micro vs para
      // transitTypeRef.current = AffiliateData.filter((item,index) => {
      //   try{
      //     return parseInt(item.AffiliateID) === parseInt(affiliateID);
      //   }
      //   catch(err){console.log(err);}
      // });
      const familyAffiliates = (transitTypeRef.current.length > 0 ? AffiliateData.filter((item) => {
        return parseInt(item.DTSPID) === parseInt(transitTypeRef.current[0].DTSPID) && parseInt(item.iTransType) === 2;
      }) : []);
      const isMicroIncluded = (familyAffiliates.length > 0);
    
      //Creating dynamic style for main two columns/rows on call taker to avoid repetition
      const dynamicCallAgentHeight = (transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2)
      ? { height: "396px", maxHeight: "396px" }
      : { height: `calc(100vh - 125px)` };
      const rowContainerDynamicHeight = (transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2)
      ? { marginLeft: "10%", marginRight:"10%", boxShadow:"-2px 0px 3px #999, 2px 0px 3px #999" }
      : { height: `calc(100vh - 125px)`, marginLeft: "10%", marginRight:"10%", boxShadow:"-2px 0px 3px #999, 2px 0px 3px #999" };
      setDynamicModeStyle(dynamicCallAgentHeight); 
      setDynamicModeRowStyle(rowContainerDynamicHeight);
      setIsAffMicroFlag(isMicroIncluded);

      //vehicle number, vehicle type, driver number, funding source, class of service, attribute data, and broker mode found from settings in combinedDataAPI
      let vehData = (DispatchVehicleData[parseInt(affiliateID)] && DispatchVehicleData[parseInt(affiliateID)] !== "" ? DispatchVehicleData[parseInt(affiliateID)] : []);
      let vehNum = (vehData.length !== 0 ? handleDuplicates(JSON.parse(vehData), "VehicleNumber") : []);
      let vehType = (vehData.length !== 0 ? handleDuplicates(JSON.parse(vehData), "VehicleType") : []);
      let driverNum = DispatchDriverData[parseInt(affiliateID)] ? JSON.parse(DispatchDriverData[parseInt(affiliateID)]) : [];
      const sortedVehNum = vehNum.sort((a, b) => a.VehicleNumber - b.VehicleNumber);
      const sortedDriverNum = driverNum.sort((a, b) => a.DriverNumber - b.DriverNumber);
      let languageTypes = ["English", "Spanish", "Chinese", "Tagalog", "Vietnamese", "Arabic", "French", "Korean", "Russian", "Haitian Creole",
        "Hindi", "Portuguese", "Italian", "Polish", "Urdu", "Japanese", "Persian", "Gujarati", "Telugu", "Bengali", "Greek", "Punjabi", "Tamil", 
        "Armenian", "Serbo-Croatian", "Hebrew"];
      let fsSelection = FundingSourceData[parseInt(affiliateID)] && FundingSourceData[parseInt(affiliateID)] !== undefined ? JSON.parse(FundingSourceData[parseInt(affiliateID)]) : [];
      let cosSelection = ClassOfServiceData[parseInt(affiliateID)] && ClassOfServiceData[parseInt(affiliateID)] !== undefined ? JSON.parse(ClassOfServiceData[parseInt(affiliateID)]) : [];
      let paySelection = PaymentTypesData[parseInt(affiliateID)] && PaymentTypesData[parseInt(affiliateID)] !== undefined ? JSON.parse(PaymentTypesData[parseInt(affiliateID)]) : [];
      let copayFSSetting = (ASCSSettingData[parseInt(affiliateID)] ? (JSON.parse(ASCSSettingData[parseInt(affiliateID)]).find((item) => item.SubTitle === "CopayFSID_List")).value : "");
      let fundingSourceSelected = "";
      let selectedFSIndex = -1;
      let copayFSSelectedTemp = "";
      let ASCSGlobalBrokerMode = (ASCSSettingData[parseInt(affiliateID)] ? (JSON.parse(ASCSSettingData[parseInt(affiliateID)]).find((item) => item.SubTitle === "BrokerMode")).value : 0);
      let languageOptions = languageTypes.map(function(item, index){
        return(
          <option key={index} value={(index+1)}>{item}</option>
        );
      });
      let vehicleNumOptionsHTML = sortedVehNum.map(function(item, index){
        return(
            <option key={index} value={item.VehicleID+"_"+item.VehicleNumber}>{item.VehicleNumber}</option>
        );
      });
      let driverNumberOptionsHTML = sortedDriverNum.map(function(item, index){
        return(
          <option key={index} value={item.DriverID+"_"+item.DriverNumber}>{item.DriverNumber}</option>
        );
      });
      let cosOptionsHTML = cosSelection.map((item, index)=>{
        return(
          <option key={index} value={item.iClassOfServiceID}>
            {item.vClassName}
          </option>
        );
      });
      if(cosSelection[0]){
        setCOSTargetID(cosSelection[0].iClassOfServiceID);
        setCOSSelected(cosSelection[0].iClassOfServiceID);
      }
      let vehicleTypeOptionsHTML = vehType.map(function(item, index){
        if(item.VehicleType && item.VehicleType.toUpperCase() !== "TESTTYPE")
        {
          return(
            <option key={index} value={item.iVTypeID} data-virtual={item.MaxWheelChairs}>{item.VehicleType}</option>
          );
        }
      });
      
      let fsOptionsHTML = fsSelection.map((item, index)=>{
        if((item.AccountID.toLowerCase().includes("self") || item.AccountID.toLowerCase().includes("cash")) || parseInt(item.FID) === 1) //Set target FS ID and broker mode for first time to self/cash default
        {
          setBrokerModes({globalBrokerMode: ASCSGlobalBrokerMode, brokerMode: item.BrokerMode});
          handleManualAmountOnFSChange(item, parseInt(item.FID));
          setFSSelected(item.FID);
          setAffiliateAbbr(item.AffiliateAbbrevation);
          setFSTargetID(item.FID); 
          fundingSourceSelected = item.FID;
          selectedFSIndex = index;
        }
        return(
          <option key={index} value={item.FID} data-virtual={item.FPayTypeID} label={item.AccountID}>
            {item.AccountID}
          </option>
        );
      });
      if(selectedFSIndex === -1){
        selectedFSIndex = 0;
        handleManualAmountOnFSChange(fsSelection[selectedFSIndex], parseInt(fsSelection[selectedFSIndex].FID));
        setFSSelected(fsSelection[selectedFSIndex].FID);
        setAffiliateAbbr(fsSelection[selectedFSIndex].AffiliateAbbrevation);
        setFSTargetID(fsSelection[selectedFSIndex].FID);
      }
      let payOptionsHTML = paySelection.map((item, index)=>{
        if(selectedFSIndex > -1 && parseInt(fsSelection[selectedFSIndex].PaymentTypeID) === parseInt(item.iID)) //Auto select the initial index for payment type of pay and copay
        {
          setPayTargetID(item.iID);
          setCopayPayTypeSelected(item.iID);
          setPaySelected(item.iID);
        }

        if(item.vName !== "" && item.vName !== "-" && !item.vName.toLowerCase().includes("unused") && !item.vName.toLowerCase().includes("wallet") && item.bActive) //Ignore payment types with no names, '-', or unused included
        {
          return(
            <option key={index} value={item.iID}>
              {item.vName}
            </option>
          );
        }
      });
      let copayFSOptionsHTML = fsSelection.map((item, index)=>{
        if(copayFSSetting === "") //In case there is no FS setting for copay in ASCS
        {
          if((item.AccountID.toLowerCase().includes("self") || item.AccountID.toLowerCase().includes("cash")) || parseInt(item.FID) === 1) //Set target FS ID and broker mode for first time to self/cash default
          {
            setCopayFSSelected(item.FID);
            copayFSSelectedTemp = item.FID;
          }
          
          return(
            <option key={index} value={item.FID} data-virtual={item.FPayTypeID} label={item.AccountID}>
              {item.AccountID}
            </option>
          );
        }
        else //If there is a setting in ASCS for copay
        {
          setCopayFSSelected(1);
          copayFSSelectedTemp = 1;
          let tempSettingIDs = copayFSSetting.includes(",")? copayFSSetting.split(",") : copayFSSetting;
          if(Array.isArray(tempSettingIDs))  //If setting is an array
          {
            if(tempSettingIDs.includes(String(item.FID))) //Find and save only the FID which is included in settings list
            {
              return(
                <option key={index} value={item.FID} data-virtual={item.FPayTypeID} label={item.AccountID}>
                  {item.AccountID}
                </option>
              );
            }
          }
          else //Setting is a single value
          {
            if(parseInt(tempSettingIDs) === parseInt(item.FID)) //Find and save only the FID which is included in settings list
            {
              return(
                <option key={index} value={item.FID} data-virtual={item.FPayTypeID} label={item.AccountID}>
                  {item.AccountID}
                </option>
              );
            }
          }
        }
      });

        for(let k = 0; k < VirtualStopsData.length; k++)
        {
          if(parseInt(affiliateID) === parseInt(VirtualStopsData[k].iSATSPID) && VirtualStopsData[k].ZoneID && parseInt(VirtualStopsData[k].ZoneID) > 0)
          {
            selectedAffVS.push(VirtualStopsData[k]);
          }
        }

    
      if(fundingSourceSelected === "" && fsSelection.length > 0) //In case the self/cash FS ID does not exist set to initial element's value
      {
        setBrokerModes({globalBrokerMode: ASCSGlobalBrokerMode, brokerMode: fsSelection[0].BrokerMode});
        handleManualAmountOnFSChange(fsSelection[0], parseInt(fsSelection[0].FID));
        setFSSelected(fsSelection[0].FID);
        setAffiliateAbbr(fsSelection[0].AffiliateAbbrevation);
        setFSTargetID(fsSelection[0].FID); 
        fundingSourceSelected = fsSelection[0].FID;
      }
      if(copayFSSelectedTemp === "") //In case no copay funding source was selected, set it again
      {
        setCopayFSSelected(fundingSourceSelected);
      }

      if(editRowDataFlag)
      {
        const matchingTripTypeOption = tripTypeHTML.find(option=>{
          if(tripData.details[0].tripInfo.callType !== -1)
            return option.props.value === tripData.details[0].tripInfo.callType;
        });
        setSelectedTripType((matchingTripTypeOption !== undefined ? matchingTripTypeOption.props.value : 3)); //Finding the correct option of trip type from dropdown
        
        const matchingDriverOption = driverNumberOptionsHTML.find(option=>{
          const [driverID, driverNum] = option.props.value.split("_");
          if(tripData.details[0].driverInfo.specialDriverId !== -1)
            return parseInt(driverID) === parseInt(tripData.details[0].driverInfo.specialDriverId); 
        });
        try{
          setSelectedDriverNum((matchingDriverOption !== undefined ? matchingDriverOption.props.value : "DN")); //Finding the correct option of driver number from dropdown
        }catch(err){console.log(err);}

        const matchingVehOption = vehicleNumOptionsHTML.find(option=>{
          const [vehID, vehNum] = option.props.value.split("_");
          if(!tripData.details[0].vehicleInfo.specialVehicleId !== -1)
            return parseInt(vehID) === parseInt(tripData.details[0].vehicleInfo.specialVehicleId);
        });
        setSelectedVehNum((matchingVehOption !== undefined ? matchingVehOption.props.value : "VN")); //Finding the correct option of vehicle number from dropdown
      }

      vehicleTypeOptionsHTML.unshift(<option key={333} value={"VT"}>{"None"}</option>); //Adding option to mobility info to unselect values if user wants to reset
      vehicleNumOptionsHTML.unshift(<option key={444} value={"VN"}>{"None"}</option>);
      driverNumberOptionsHTML.unshift(<option key={555} value={"DN"}>{"None"}</option>);
      languageOptions.unshift(<option key={666} value={"Language"}>{"None"}</option>);
      setLanguageOptionsHTML(languageOptions);
      setVehNumberOptionsHTML(vehicleNumOptionsHTML);
      setVehTypeOptionsManageHTML(vehicleTypeOptionsHTML);
      setDriverNumberOptionsHTML(driverNumberOptionsHTML);

      setPayDropdown(payOptionsHTML); //Appending the FS and copay options HTML
      setCOSDropdown(cosOptionsHTML); 
      setFSDropdown(fsOptionsHTML);
      setCopayFSDropdown(copayFSOptionsHTML);

      let cosID = (cosSelection[0] ? cosSelection[0].iClassOfServiceID : 1);
      
      handleInitialFareAPIs(fundingSourceSelected, affiliateID, cosID); //Handling all fare APIs for initial load of the page

      startAffSelectionDropDown(selectedAffVS, (editRowDataFlag? parseInt(editRowData.generalInfo.requestAffiliateID): 0)); //Get affiliate dropdown function
      
      let interval = "";
      let resizeTimeout = 0;
      const handleResize = () =>{
        try{
          clearTimeout(resizeTimeout); //clear if resizing continues
          resizeTimeout = setTimeout(() => {
            
            let mapHeight = 0;
            let summaryWindowHeight = 0;
            
            if(EnablePredictiveNegotiation.current === 0) 
            { 
              mapHeight = ((window.innerHeight - 530) < 200 ? 200 : (window.innerHeight - 530));
              summaryWindowHeight = (window.innerHeight - (mapHeight + 275));
            }
            else if(EnablePredictiveNegotiation !== 0)
            {
              mapHeight = ((window.innerHeight - 630) < 200 ? 200 : (window.innerHeight - 630));
              summaryWindowHeight = (window.innerHeight - (mapHeight + 425));
            }
            setShowSideBar(false);
            setScreenWidthSize(window.innerWidth);
            setMapScreenHeightSize(mapHeight);
            setSummaryViewScreenHeightSize(summaryWindowHeight);
          }, 100);
        }
        catch(err){console.log(err);}
      };
      
      window.addEventListener('resize', handleResize); //For dynamic width adjustment of the call taker
      window.addEventListener('keydown', handleKeyPress); //keypress event for chatbot dialog close and other functions if needed
        
      if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2)) //If affiliate is microtransit...
      {
        //Set timer to check for ARBListener event if response is returned for booked trips status, delete old bookings if row # is higher than 4
        interval = setInterval(() => {
          try{
            let mtsmConfirmationNumList = PersistStorage.retrieve("confirmationsData", false);
            if(mtsmConfirmationNumList && mtsmConfirmationNumList.length > 0)
            {
              setTotalMTSMRecords(mtsmConfirmationNumList.length);
              if(mtsmConfirmationNumList.length > 4)
              {
                const currDate = new Date();
                const timeDiff = Math.abs(currDate - new Date(mtsmConfirmationNumList[0].creationTime));
                if(timeDiff >= 900000) //If time is 15 min since creation for 5th and below trip, remove them from table
                {
                  mtsmConfirmationNumList.shift();
                }
              }
              PersistStorage.save('confirmationsData', mtsmConfirmationNumList, 999, false);
              //Get trips table in order (newest-oldest)
              let MTMSNegotiationHTML = mtsmConfirmationNumList.reverse().map(function(item, index){
                const currDate = new Date();
                const timeDiff = Math.abs(currDate - new Date(item.creationTime));
                if(timeDiff >= 90000 && (item.msg === "" || item.msg.toLowerCase().includes("failed")))
                {
                  return(
                    <tr key={index} className="text-center border-bottom border-dark">
                      <td className="border border-dark user-select-none small">{item.Confirmation}</td>
                      <td className="border border-dark user-select-none small overflow-hidden text-nowrap" title={"N/A"} style={{textOverflow:"ellipsis"}}>
                        {"N/A"}
                      </td>
                      <td className="border border-dark user-select-none small overflow-hidden text-nowrap" title={"N/A"} style={{textOverflow:"ellipsis"}}>
                        {"N/A"}
                      </td>
                      <td className="border border-dark user-select-none text-nowrap small overflow-hidden" 
                        style={{textOverflow:"ellipsis"}} title={item.name} 
                      >{item.name}</td>
                      <td className="border border-dark user-select-none text-nowrap small overflow-hidden" title={"Routing system timed out"} 
                        style={{textOverflow:"ellipsis"}}
                      >{"Routing system timed out"}</td>
                      <td className="border-dark border-bottom user-select-none text-center justify-content-center">
                        <div className="d-flex justify-content-center">
                          <Button variant="secondary" tabIndex={-1} className="d-inline-block p-1 py-0" title={"Remove trip from view"} 
                            onClick={handleRemoveRecord} name={item.Confirmation}>
                            X
                          </Button>
                          <Button variant="danger" tabIndex={-1} className="mx-1 d-inline-block p-1 py-0"
                            name={item.Confirmation} onClick={handleRejectConfirmation} data-name={"cancel"}
                          > 
                            Cancel
                          </Button>
                        </div>
                      </td>
                    </tr>
                  );
                  
                }
                else if(item.msg === "" || item.msg.toLowerCase().includes("failed"))
                {
                  return(
                    <tr key={index} className="text-center border-bottom border-dark">
                      <td className="border border-dark user-select-none small">{item.Confirmation}</td>
                      <td className="border border-dark user-select-none small overflow-hidden text-nowrap" title={"N/A"} style={{textOverflow:"ellipsis"}}>
                        {"N/A"}
                      </td>
                      <td className="border border-dark user-select-none small overflow-hidden text-nowrap" title={"N/A"} style={{textOverflow:"ellipsis"}}>
                        {"N/A"}
                      </td>
                      <td className="border border-dark user-select-none text-nowrap small overflow-hidden" 
                        style={{textOverflow:"ellipsis"}} title={item.name} 
                      >{item.name}</td>
                      <td className="border border-dark user-select-none text-nowrap small overflow-hidden" title={"Processing request..."} 
                        style={{textOverflow:"ellipsis"}}
                      >{"Processing request..."}</td>
                      <td className="border-dark border-bottom user-select-none text-center justify-content-center">
                        <div className="d-flex justify-content-center">
                          <Button variant="secondary" className="d-inline-block p-1 py-0" title={"Remove trip from view"} 
                            onClick={handleRemoveRecord} tabIndex={-1} name={item.Confirmation}>
                            X
                          </Button>
                          <Button variant="danger" className="mx-1 d-inline-block p-1 py-0"
                            name={item.Confirmation} tabIndex={-1} onClick={handleRejectConfirmation} data-name={"cancel"}
                          > 
                            Cancel
                          </Button>
                        </div>
                      </td>
                    </tr>
                  );
                }
                else
                {
                  return(
                    <tr key={index} className="text-center border-bottom border-dark">
                      <td className="border border-dark user-select-none small">{item.Confirmation}</td>
                      <td className="border border-dark user-select-none small overflow-hidden text-nowrap" title={item.time} style={{textOverflow:"ellipsis"}}>
                        {item.time}
                      </td>
                      <td className="border border-dark user-select-none small overflow-hidden text-nowrap" title={item.dropTime} style={{textOverflow:"ellipsis"}}>
                        {item.dropTime}
                      </td>
                      <td className="border border-dark user-select-none text-nowrap small overflow-hidden" 
                        style={{textOverflow:"ellipsis"}} title={item.name} 
                      >{item.name}</td>
                      <td className="border border-dark user-select-none text-nowrap small overflow-hidden" title={item.msg} 
                        style={{textOverflow:"ellipsis"}}
                      >{item.msg}</td>
                      <td className="border-dark border-bottom user-select-none text-center justify-content-center">
                        <div className="d-flex justify-content-center">
                          <Button variant="secondary" className="d-inline-block p-1 py-0" disabled={item.msg === ""} title={"Remove trip from view"} 
                            onClick={handleRemoveRecord} tabIndex={-1} name={item.Confirmation}>
                            X
                          </Button>
                          {(item.time !== "N/A" || item.msg.toLowerCase().includes("failed")) && timeDiff < 240000?
                          <Button variant="danger" className="mx-1 d-inline-block p-1 py-0" disabled={item.msg === ""} title={"Reject scheduled trip"} 
                            onClick={handleRejectConfirmation} tabIndex={-1} name={item.Confirmation} data-name={"reject"}>
                            Reject
                          </Button>:
                          <Button variant="danger" className="mx-1 d-inline-block p-1 py-0 opacity-0" disabled={item.time === "N/A"} 
                            name={item.Confirmation} tabIndex={-1}>
                            Reject
                          </Button>}
                        </div>
                      </td>
                    </tr>
                  )
                }
                
              });
              setMTSMTableHTML(
                <>
                  {MTMSNegotiationHTML}
                </>
              );
              // console.log(mtsmConfirmationNumList);
              if(mtsmConfirmationNumList && mtsmConfirmationNumList.length > 0)
              {
                setConfirmationNo(mtsmConfirmationNumList[0].Confirmation);
              }
            }
            else
            {
              setTotalMTSMRecords(0); //Default case where no trips are booked
              
              setMTSMTableHTML(
                <>
                  <tr className="text-center">
                    <td className="border border-dark user-select-none">{""}</td>
                    <td className="border border-dark user-select-none">{""}</td>
                    <td className="border border-dark user-select-none">{""}</td>
                    <td className="border border-dark user-select-none text-nowrap small overflow-hidden" 
                      style={{textOverflow:"ellipsis", maxWidth:"65px", minWidth:"50px"}} title={""} 
                    >{""}</td>
                    <td className="border border-dark user-select-none text-nowrap small overflow-hidden" title={""} 
                      style={{textOverflow:"ellipsis", maxWidth:"80px", minWidth:"60px"}}
                    >
                      {""}
                    </td>
                    <td className="user-select-none text-center justify-content-center">
                      {""}
                    </td>
                  </tr>
                </>
              );
              if(!editRowDataFlag) 
              {
                setConfirmationNo("");
              }
            }
          }
          catch(err){console.log(err);}
          
        }, 1000);
        
      }
      else if(transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2)
      {
          let ExsistingPredictiveData = PersistStorage.retrieve("PredictiveData", false);
          if(ExsistingPredictiveData !== null)
          {
              let PreditiveTripData = JSON.parse('[' + ExsistingPredictiveData + ']');
              let PredictiveHTML = "";
              const now = moment();
              if(PreditiveTripData !== null && PreditiveTripData.length > 0)
              {
                    PreditiveTripData = PreditiveTripData.sort((a, b) => {
                      let dateA = new Date(a.InsertTime);
                      let dateB = new Date(b.InsertTime);
                      return dateB - dateA ; // Ascending order (earliest first)
                    });

                    PreditiveTripData = PreditiveTripData.filter(item => {
                      const insertTime = moment(item.InsertTime, "M/D/YYYY h:mm:ss A");
                      let systemcalcTime = now.clone().add(timeZoneDiff.current, 'milliseconds')
                      const diffInMinutes = Math.abs(insertTime.diff(systemcalcTime, 'minutes'));
                      return diffInMinutes <= 30; // Only include items within 30 minutes
                    });

                    
                    if(PreditiveTripData.length)
                    {
                      setTotalPredictiveRecords(PreditiveTripData.length);
                      PredictiveHTML =  
                      [...PreditiveTripData].sort((a, b) => {
                        const dateA = a.PickDate ? new Date(a.PickDate) : new Date(0);
                        const dateB = b.PickDate ? new Date(b.PickDate) : new Date(0);
                        return dateA - dateB; // Descending order (latest first)
                      })
                      //PreditiveTripData.map((item, index) => (
                        .map((item, index) => (
                        <tr key={item.Confirmation} className="text-center">
                          <td className="border border-dark user-select-none" style={{fontSize:"smaller"}} >{item.Confirmation}</td>
                          <td className="border border-dark user-select-none" style={{fontSize:"smaller"}}>{item.Status}</td>
                          <td className="border border-dark user-select-none text-nowrap small overflow-hidden" style={{fontSize:"smaller"}}>
                          {moment(item.PickDate, "M/D/YYYY h:mm A").format("M/D/YYYY h:mm A")}</td>
                          <td className="border border-dark user-select-none text-nowrap small overflow-hidden">{item.OfferedTime}</td>
                          {item.Status === 'Routed (Out of Window)' && (
                            <td className="border border-dark user-select-none text-center justify-content-center">
                              <span title={"Force Request Time"}><Icon icon="entypo:back-in-time" className="me-3 text-white my-auto text-secondary" style={{width:"22px", height:"22px", color:"white", cursor:"pointer"}}
                              onClick={(e) => {handlePredictiveForceReq(item.Confirmation)}} /></span>
                              {"                                                                                       "}
                              <span title={"Cancel Trip"}><Icon icon="game-icons:cancel" className=" text-white my-auto text-secondary" style={{width:"22px", height:"22px", color:"white", cursor:"pointer"}}
                              onClick={(e) => {handlePredictiveCancel(item.Confirmation)}} /></span>
                            </td>
                          )}
                          {item.Status === 'Routed' && (
                            <td className="border border-dark user-select-none text-center justify-content-center">
                              <span style={{ visibility: "hidden" }}>
                                <Icon icon="entypo:back-in-time" className="me-3" style={{width:"22px", height:"22px"}} />
                              </span> 
                              {"                                                                                       "}
                              <span title={"Cancel Trip"}><Icon icon="game-icons:cancel" className=" text-white my-auto text-secondary" style={{width:"22px", height:"22px", color:"white", cursor:"pointer"}}
                              onClick={(e) => {handlePredictiveCancel(item.Confirmation)}} /></span>
                            </td>
                          )}
                          {(item.Status === 'UnRouted' || item.Status === 'UnRouted (Forced)') && (
                            <td className="border border-dark user-select-none text-center justify-content-center">
                              <span title={"Edit Request Time"}><Icon icon="cuida:edit-outline" className="me-3 text-white my-auto text-secondary" style={{width:"22px", height:"22px", color:"white", cursor:"pointer"}}
                              onClick={(e) => {handlePredictiveEdit(item.Confirmation, item.PickDate)}} /></span>
                              {"                                                                                       "}
                              <span title={"Cancel Trip"}><Icon icon="game-icons:cancel" className=" text-white my-auto text-secondary" style={{width:"22px", height:"22px", color:"white", cursor:"pointer"}}
                              onClick={(e) => {handlePredictiveCancel(item.Confirmation)}} /></span>
                            </td>
                          )}
                          {item.Status === 'Cancelled' && (
                            <td className="border border-dark user-select-none text-center justify-content-center">{""}</td>
                          )}
                        </tr>
                      ))
                    }
              }
              
              setPredictiveTableHTML(PredictiveHTML === "" ? null : PredictiveHTML);
          }
        }


      //@@@@@@@@@@@@ Mobility Attributes Enalbing Criteria @@@@@@@@@@@//
      // We can check from combined data API call. If we have mobility attributes then we can put it
      if(refMobilityAttributeOptions.current != undefined && refMobilityAttributeOptions.current != [] && refMobilityAttributeOptions.current != null && refMobilityAttributeOptions.current?.length > 0){
        setIsAffiliateHasMobilityAttributes(true);
      }
      //@@@@@@@@@@@@ Mobility Attributes Enabling Criteria @@@@@@@@@@//
      
      let screenMapHeight = 0;
      let summaryScreenWindowHeight = 0;
      if(EnablePredictiveNegotiation === 0)
      {
        screenMapHeight = ((window.innerHeight - 530) < 200 ? 200 : (window.innerHeight - 530));
        summaryScreenWindowHeight = (window.innerHeight - (screenMapHeight + 275));
      }
      else if(EnablePredictiveNegotiation !== 0)
      {
        screenMapHeight = ((window.innerHeight - 630) < 200 ? 200 : (window.innerHeight - 630));
        summaryScreenWindowHeight = (window.innerHeight - (screenMapHeight + 425));
      }
      setMapScreenHeightSize(screenMapHeight);
      setSummaryViewScreenHeightSize(summaryScreenWindowHeight);

      //@@@@@@@@@@@@@ Get Default Lat/Lngs for the zone @@@@@@@@@@@@@@@//
      
      if(ASCSSettingData && selectedAff){
       try {
         let DefaultZoneLatitude = parseFloat((JSON.parse(ASCSSettingData[selectedAff]).find((item) => item.SubTitle === "Default-Latitude-To-Focus-On-Zone-Management").value));
         let DefaultZoneLongitude = parseFloat((JSON.parse(ASCSSettingData[selectedAff]).find((item) => item.SubTitle === "Default-Longitude-To-Focus-On-Zone-Management").value));
         setDefaultZoneLatLngsFromASCS({Latitude: DefaultZoneLatitude, Longitude: DefaultZoneLongitude});
       } catch (error) {}
      }
      //@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@//

      //@@@@@@@@@@@@ Get MaxAgentPromptMilesRadius @@@@@@@@@@@@@@@@@@@@/
      if(GlobalASCSData && selectedAff){
        try {
          let MaxAgentPromptMilesRadius = parseInt((JSON.parse(ASCSSettingData[selectedAff]).find((item) => item.SubTitle === "MaxAgentPromptMilesRadius").value));
          setMaxAgentPromptMilesASCS(MaxAgentPromptMilesRadius);
        } catch (error) {}
      }
      //@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@//

      return()=>{
        if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2))
        {
          clearInterval(interval);
        }
        clearTimeout(resizeTimeout); //clearing screen resize timer
        // Clean up the event listener on component unmount
        window.removeEventListener('keydown', handleKeyPress);
        window.removeEventListener('resize', handleResize);
      };
    }
    catch(err){console.log(err);}

  }, []);

  useEffect(() => {
    try{

      if(activeTripConfirmation !== "") //If user selects an action on active trips of client...
      {
        if(activeTripConfirmation.includes("_copy")) //Copy action; copying data onto call taker for booking 
        {
          let tripInfo = ActiveTripsTableData.filter((item)=>{
            try{
              if(String(item.iRefId) === String(activeTripConfirmation.replace("_copy","")))
              {
                return true;
              }
            }
            catch(err){console.log(err);}
          });

          handleEditTrip(tripInfo, "API", true);
          setActiveTripConfirmation("");
          setShowClientActiveTripsModal(false);
        }
        else if(activeTripConfirmation.includes("_edit")) //Edit action; editing data for updating active trip
        {
          let tripInfo = ActiveTripsTableData.filter((item)=>{
            try{
              if(String(item.iRefId) === String(activeTripConfirmation.replace("_edit","")))
              {
                return true;
              }
            }
            catch(err){console.log(err);}
          });
          handleEditTrip(tripInfo, "API");
          setActiveTripConfirmation("");
          setShowClientActiveTripsModal(false);
        }
        else if(activeTripConfirmation.includes("_remove")) //Remove action; not available for active trips
        {
          setActiveTripConfirmation("");
        }
        else //Cancel action; canceling active trips from the dialog
        {
          cancelActiveTripFromDialog(activeTripConfirmation);
          // handleCancelTrip(activeTripConfirmation, "active");
          // setActiveTripConfirmation("");
        }
      }
    }
    catch(err){console.log(err);}

  }, [activeTripConfirmation]);

  const cancelActiveTripFromDialog = async (activeTripConfirmation) => {
    try {
      setShowCloseButton(false);
      let CancelTripConfirm = await showConfirmationModal("Are you sure to cancel this trip with conf# " + activeTripConfirmation + " ?", "Warning", false);
      if(CancelTripConfirm === false){
        setActiveTripConfirmation("");
        setShowCancel(false);
        return;
      }
      let tripInfo = ActiveTripsTableData?.filter((item)=>{
        try{
          if(String(item.iRefId) === String(activeTripConfirmation))
          {
            return true;
          }
        }
        catch(err){console.log(err);}
      });

      setActiveTripConfirmation("");
      tripInfo = DataMappingForCancelTrip(tripInfo);
      setSelectedRowData(tripInfo);
      setShowCancel(true);
    } catch (error) {
      setActiveTripConfirmation("");
      setShowCancel(false);
    }
  }

  const DataMappingForCancelTrip = (tripInfo) => {
    try {
        if(tripInfo){
          tripInfo[0].ConfirmationNo = tripInfo[0].iRefId;
          tripInfo[0].iAssignedVehicleId = tripInfo[0].AssignedVehicleId;
          tripInfo[0].iScheduleID = tripInfo[0].ScheduleID;
          tripInfo[0].ServiceID = tripInfo[0].iServiceID;
          tripInfo[0].PZONE = tripInfo[0].PickZoneName;
          tripInfo[0].ServiceStatus = tripInfo[0].ServiceStatusID;
          tripInfo[0].iSchDetailID = "-1";//tripInfo[0].ScheduleID;
          tripInfo[0].IsReturnTrip = tripInfo[0].ReturnTrip;
      }
      return tripInfo;
    } catch (error) {
      return tripInfo;
    }
  }

  const handleCancelAction = (confirmationNumber) => {
    try {
      let filteredData = ActiveTripsTableData.filter((item)=>{
        return String(item.iRefId) !== String(confirmationNumber);
      }); 
      setActiveTripsTableData(filteredData);  
    } catch (error) {
      
    }
  };

  useEffect(() => {
    try{
      let UserID = parseInt(loginData.iUserIDActual); //Getting the accurate source URL for chatbot iframe
      let FamilyID = (AffiliateData.find((item) => {if(parseInt(item.AffiliateID) === parseInt(selectedAff)){return item}}))?.iPartnerAffiliateID || 0;
      let AffiliateID = parseInt(selectedAff);
      let clientID = typeof clientInfo === 'object' && clientInfo.Id && String(clientInfo.Id) !== "-1"? clientInfo.Id : "-1";
      let formattedPhone = "";
      if (!showChatBotRef.current && phone && phone.length >= 12) {
        formattedPhone = formatPhone(phone);
      }
      else if (showChatBotRef.current && chatBotPhone && chatBotPhone.length >= 12){
        formattedPhone = formatPhone(chatBotPhone);
      }
  
      const PhoneNo = typeof clientInfo === 'object' && clientInfo.HomePhone ? clientInfo.HomePhone : (formattedPhone !== "" ? formattedPhone : "");
      // let sourceUrl = `${specificLinkRequirement}?PhoneNo=${PhoneNo}&iAffiliateID=${AffiliateID}&iFamilyID=${FamilyID}&iUserID=${UserID}&clientID=${clientID}`
      let sourceUrl = `${specificLinkRequirement}?phoneNo=${PhoneNo}&affiliateId=${AffiliateID}&familyId=${FamilyID}&userID=${UserID}&clientID=${clientID}&affiliateType=&affiliateName=&accentColor=green`
      setSrcUrl(sourceUrl);
    }
    catch(err){console.log(err);}
  }, [specificLinkRequirement, phone, chatBotPhone]);

  useEffect(() => {
    try{
      if(mapVsSelected && mapVsSelected.length > 0) //function for virtual stop selection on map (microtransit)
      {
        let correctDate = formatDate(selectedDateSchTime + " 00:00:00"); //Get selected date with correct format
        const fetchVSFareZone = async () => {
          let genericInfo = mapVsSelected[0].data.vLatitude+","+mapVsSelected[0].data.vLongitude;
          if(mapVsSelected[0].type === "PU" && fareMethodRef.current === 1){
            await getFareZone(FSSelected, selectedAff, COSSelected, genericInfo, "pick");
          }
          else if(mapVsSelected[0].type !== "PU" && fareMethodRef.current === 1){
            await getFareZone(FSSelected, selectedAff, COSSelected, genericInfo, "drop");
          }
        };
        fetchVSFareZone();
        if(mapVsSelected[0].type === "PU")
        {
          DOVSDropdownRef.current.disabled = false;
          PUVSDropdownRef.current.disabled = false;
          setPickupAddr(mapVsSelected[0].data.Street); //Setting pickup address of virtual stop, and pins on the map for the location PU
          pickLatLng.current = mapVsSelected[0].data.vLatitude+","+mapVsSelected[0].data.vLongitude;
          setPickupVirtualStop({...pickupVirtualStop, value:mapVsSelected[0].data.ID, name:mapVsSelected[0].data.Location});
          let stopMarkersArr = [{lat:parseFloat(pickLatLng.current.split(",")[0]),
            lng: parseFloat(pickLatLng.current.split(",")[1]), Type:"PU", 
            name:(riderName === "" ? "N/A" : riderName.trim()), address: mapVsSelected[0].data.Street
          }];
          let filteredMapMarkers = mapData.filter((item)=>{
            if(item.Type === "Stop")
            {
              stopMarkersArr.push(item);
            }
            return item.Type === "DO";
          });
          filteredMapMarkers.unshift(...stopMarkersArr);
          setMapData(filteredMapMarkers);

          if(dropLatLng.current !== "")
          {
            setIsSchTimeFieldDisabled(false);
            setIsVSSelectionDisabled(true);
            if(pickupVirtualStop?.name !== undefined && pickupVirtualStop?.name !== null){
              pickupVirtualStop.name = mapVsSelected[0].data.Location;
            }
            puVSValueChanged.current = mapVsSelected[0].data.Location;
            mapPointPickupSelection.current = mapVsSelected[0].data;
            
            if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2))
            {
              wrapperHandleRCZVerification("PU", mapVsSelected[0].data.Street); //Validate and find walking distance from selected locations to closest VS
            }
            else
            {
              wrapperHandleAddressDetails("PU", mapVsSelected[0].data.Street, mapVsSelected[0].data.Street, dropAddr, correctDate, schTime); //Get distance between markers
            }
            setTimeout(() => {
              setIsVSSelectionDisabled(false);
            }, 1000);
          }
        }
        else
        {
          DOVSDropdownRef.current.disabled = false;
          PUVSDropdownRef.current.disabled = false;
          setDropAddr(mapVsSelected[0].data.Street); //Setting drop address of virtual stop, and pins on the map for the location DO
          dropLatLng.current = mapVsSelected[0].data.vLatitude+","+mapVsSelected[0].data.vLongitude;
          setDropAddrVirtualStop({...dropAddrVirtualStop, value:mapVsSelected[0].data.ID, name:mapVsSelected[0].data.Location});
          let stopMarkersArr = [];
          let filteredMapMarkers = mapData.filter((item)=>{
            if(item.Type === "Stop")
            {
              stopMarkersArr.push(item);
            }
            return item.Type === "PU";
          });
          stopMarkersArr.push({lat:parseFloat(dropLatLng.current.split(",")[0]),
            lng: parseFloat(dropLatLng.current.split(",")[1]), Type:"DO", 
            name:(riderName === "" ? "N/A" : riderName.trim()), address: mapVsSelected[0].data.Street
          });
          filteredMapMarkers.push(...stopMarkersArr);
          setMapData(filteredMapMarkers);

          if(pickLatLng.current !== "")
          {
            setIsSchTimeFieldDisabled(false);
            setIsVSSelectionDisabled(true);
            if(dropAddrVirtualStop?.name !== undefined && dropAddrVirtualStop?.name){
              dropAddrVirtualStop.name = mapVsSelected[0].data.Location;
            }
            doVSValueChanged.current = mapVsSelected[0].data.Location;
            mapPointDropoffSelection.current = mapVsSelected[0].data;

            
            if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2))
            {
              wrapperHandleRCZVerification("DO", mapVsSelected[0].data.Street); //Validate and find walking distance from selected locations to closest VS
            }
            else
            {
              wrapperHandleAddressDetails("DO", mapVsSelected[0].data.Street, pickupAddr, mapVsSelected[0].data.Street, correctDate, schTime); //Get distance between markers
            }
            setTimeout(() => {
              setIsVSSelectionDisabled(false);
            }, 1000);
          }
          
        }
      }
    }
    catch(err){console.log(err); setIsVSSelectionDisabled(false);}

  }, [mapVsSelected]);

  useEffect(() => {
    try{
      if(mapPointSelection && mapPointSelection.length > 0) //Map point selection for non-VS locations (micro & para)
      {
        const FetchData = async () => {
          if (mapPointSelection[0].type === "PU") {
            pickLatLng.current = mapPointSelection[0].latlng;
            if (fareMethodRef.current === 1) {
              await getFareZone(FSSelected, selectedAff, COSSelected, pickLatLng.current, "pick");
            }
            if ((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2)) {
              await getDispatchZone(selectedAff, pickLatLng.current, "pick");
            }
            if(addLegBtnRef.current)
              addLegBtnRef.current.disabled = false;
          } else if (mapPointSelection[0].type === "DO") {
            dropLatLng.current = mapPointSelection[0].latlng;
            if (fareMethodRef.current === 1) {
              await getFareZone(FSSelected, selectedAff, COSSelected, dropLatLng.current, "drop");
            }
            if ((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2)) {
              
              await getDispatchZone(selectedAff, dropLatLng.current, "drop");
            }
            if(addLegBtnRef.current)
              addLegBtnRef.current.disabled = false;
          }
        }
        FetchData();
        let correctDate = formatDate(selectedDateSchTime); //Get date for functions as needed
        if(mapPointSelection[0].type === "PU")
        {
          setInputSuggestionListPU("");
          setPickupAddr(mapPointSelection[0].address);
          addressInfoDetails.current.pick = {
            city: mapPointSelection[0].addressParsedObject.City, 
            state: mapPointSelection[0].addressParsedObject.State, 
            zip: mapPointSelection[0].addressParsedObject.Zip
          };

          let stopMarkersArr = [{lat:parseFloat(pickLatLng.current.split(",")[0]),
            lng: parseFloat(pickLatLng.current.split(",")[1]), Type:"PU", 
            name:(riderName === "" ? "N/A" : riderName.trim()), address: mapPointSelection[0].address}
          ];
          let filteredMapMarkers = mapData.filter((item)=>{
            if(item.Type === "Stop")
            {
              stopMarkersArr.push(item);
            }
            return item.Type === "DO";
          });
          filteredMapMarkers.unshift(...stopMarkersArr);
          
          if((transitTypeRef.current.length > 0 && (parseInt(transitTypeRef.current[0].iTransType) !== 2 || (parseInt(transitTypeRef.current[0].iTransType) === 2 && mapData.length === 0)))){
            setMapData(filteredMapMarkers);
          }

          if(dropLatLng.current !== "")
          {
            setIsVSSelectionDisabled(true);
            setIsSchTimeFieldDisabled(false);
            
            if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2))
            {
              //Adding markers to map in order
              if(mapData.length === 0){ setMapData(filteredMapMarkers); }
              wrapperHandleRCZVerification("PU", mapPointSelection[0].address);
            }
            else
            {
              wrapperHandleAddressDetails("PU", mapPointSelection[0].address, mapPointSelection[0].address, dropAddr, correctDate, schTime);
            }
            setIsVSSelectionDisabled(false);
          }
        }
        else if(mapPointSelection[0].type === "DO")
        {
          setInputSuggestionListDO("");
          setDropAddr(mapPointSelection[0].address);
          addressInfoDetails.current.drop = {
            city: mapPointSelection[0].addressParsedObject.City, 
            state: mapPointSelection[0].addressParsedObject.State, 
            zip: mapPointSelection[0].addressParsedObject.Zip
          };

          let stopMarkersArr = [];
          let filteredMapMarkers = mapData.filter((item)=>{
            if(item.Type === "Stop")
            {
              stopMarkersArr.push(item);
            }
            return item.Type === "PU";
          });
          stopMarkersArr.push({lat:parseFloat(dropLatLng.current.split(",")[0]),
            lng: parseFloat(dropLatLng.current.split(",")[1]), Type:"DO", 
            name:(riderName === "" ? "N/A" : riderName.trim()), address: mapPointSelection[0].address
          }); 
          filteredMapMarkers.push(...stopMarkersArr);
          if((transitTypeRef.current.length > 0 && (parseInt(transitTypeRef.current[0].iTransType) !== 2 || (parseInt(transitTypeRef.current[0].iTransType) === 2 && mapData.length === 0)))){
            setMapData(filteredMapMarkers);
          }

          if(pickLatLng.current !== "")
          {
            setIsVSSelectionDisabled(true);
            setIsSchTimeFieldDisabled(false);
            
            if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2))
            {
              //Adding markers to map in order
              if(mapData.length === 0){ setMapData(filteredMapMarkers); }
              wrapperHandleRCZVerification("DO", mapPointSelection[0].address);
            }
            else
            {
              wrapperHandleAddressDetails("DO", mapPointSelection[0].address, pickupAddr, mapPointSelection[0].address, correctDate, schTime);
            }
            setIsVSSelectionDisabled(false);
          }
        }
        else if(mapPointSelection[0].type === "Stop")
        {
          setInputSuggestionListStop(""); //initializing/adding stop to the list of stops lists for the addresses
          setShowStopBlock(true);
          setShowStopsInput(true);
          setStopAddr(mapPointSelection[0].address);
          stopLatLng.current = mapPointSelection[0].latlng;
        }
        setIsVSSelectionDisabled(false);
      }
    }
    catch(err){console.log(err); setIsVSSelectionDisabled(false);}

  }, [mapPointSelection]);

  useEffect(() => {
    try{
      if(bookBtnRef.current) //If microtransit...
      {
        if(schTime === "" && bookBtnRef.current.disabled && pickLatLng.current !== "" && dropLatLng.current !== "") //If time is empty and addresses are populated, enable booking
        {
          bookBtnRef.current.disabled = false;
        }
        if (schTime === "") {
          if (isValidateRCZCalledFromReset.current === false && pickLatLng.current !== "" && dropLatLng.current !== "") {
            handleValidationMsg(); //Validate RCZ
          }
        }
      }
      else if(paratransitBookBtnRef.current) //If paratransit...
      {
        if(schTime === "" && paratransitBookBtnRef.current.disabled && pickLatLng.current !== "" && dropLatLng.current !== "")
        {
          paratransitBookBtnRef.current.disabled = false; //If time is empty and addresses are populated, enable add leg/booking
          addLegBtnRef.current.disabled = false;
        }

        const validateFutureDate = async () => {
          if(isPreviousLegSchTimeValidated.current == false){
            await FutureDateValidation();
          }
        }
        validateFutureDate();
      }
    }
    catch(err){console.log(err);}
    
  }, [schTime]);

  useEffect(() =>{
    try{
      let correctDate = formatDate(selectedDateSchTime); //If value of Virtual Stop DO changed, update the reference for stop name
      if(doVSValueChanged.current !== dropAddrVirtualStop.name){
        doVSValueChanged.current = dropAddrVirtualStop.name;
      }
      if(pickLatLng.current !== "" && doVSCallValidation.current === true)
      {
        async function CallFunctionsForDOValidations() {
          setIsVSSelectionDisabled(true);
          // await handleAddressDetails("DO", dropAddrVirtualStop.name, pickupAddr, dropAddrVirtualStop.name, correctDate, schTime);
          await handleRCZVerification("DO", dropAddrVirtualStop.name, " ");
          // doVSCallValidation.current = false;
          setIsVSSelectionDisabled(false);
        };
        CallFunctionsForDOValidations(); //Get verified status of RCZ for DO address change
      }
    }
    catch(err){console.log(err);}

  }, [dropAddrVirtualStop]);

  useEffect(() =>{
    try{
      let correctDate = formatDate(selectedDateSchTime); //If value of Virtual Stop PU changed, update the reference for stop name
      if(puVSValueChanged.current !== pickupVirtualStop.name){
        puVSValueChanged.current = pickupVirtualStop.name
      }
      if(dropLatLng.current !== "" && puVSCallValidation.current === true)
      {
        async function CallFunctionsForValidation() {
          setIsVSSelectionDisabled(true);
          // await handleAddressDetails("PU", pickupVirtualStop.name, pickupVirtualStop.name, dropAddr, correctDate, schTime);
          await handleRCZVerification("PU", pickupVirtualStop.name, " ");
          
          setIsVSSelectionDisabled(false);
        };
        CallFunctionsForValidation(); //Get verified status of RCZ for PU address change
      }
    }
    catch(err){console.log(err);}

  }, [pickupVirtualStop]);

  useEffect(() => {
    try{
      if(historyTrips && historyTrips.length > 0) //Setting history table rows for recently booked paratransit trips (latest-earliest)
      {
        let historyTripsHTML = historyTrips.reverse().map(function(item, index){
          return(
            <tr key={index} className="text-center">
              <td className="text-nowrap small overflow-hidden bg-light p-1" style={{borderRight:"1px solid #ccc", borderBottomLeftRadius:"5px"}}>
                {item.confirmation}
              </td>
              <td className="text-nowrap small overflow-hidden bg-light px-1" style={{borderRight:"1px solid #ccc"}}>
                {item.type}
              </td>
              <td className="text-nowrap small overflow-hidden bg-light px-1" style={{borderRight:"1px solid #ccc"}}>
                {item.tripData.addressInfo.Trips[0].Details[0].estimatedInfo.EstimatedCost}
              </td>
              <td className="text-nowrap small overflow-hidden bg-light px-1" style={{borderRight:"1px solid #ccc"}}>
                {item.tripData.addressInfo.Trips[0].Details[0].estimatedInfo.EstimatedDistance}
              </td>
              <td className="text-nowrap small overflow-hidden bg-light p-1" style={{ borderBottomRightRadius:"5px"}}>
                {item.tripData.addressInfo.Trips[0].Details[0].estimatedInfo.EstimatedTime}
              </td>
            </tr>
          );
        });
        setAgentTripRecordsTableHTML(
          <>
            {historyTripsHTML}
          </>
        );
        if(confirmationNo === "")
        {
          setConfirmationNo(historyTrips[0].confirmation); //Set confirmation number to latest trip confirmation if none exist
        }
      } 
    }
    catch(err){console.log(err);}
    
  }, [historyTrips]);

  useEffect(()=> {
    try{
      if(clientInfo && typeof clientInfo === 'object' && !Array.isArray(clientInfo))
      {
        setTimeout(() => {
          setInputSuggestionListClientName("");
          setInputSuggestionListClientPhone("");
          setInputSuggestionListClientMedID("");
        }, 1000);
      }
    }
    catch(err){console.log(err);}
  }, [clientInfo]);

  useEffect(()=>{
    try{

      if(scheduleJSON.mainData !== "") //If multischedule data is not empty, disable add leg btn
      {
        addLegBtnRef.current.disabled = true;
      }
      else //Otherwise, check and enable it if disabled
      {
        if(addLegBtnRef.current)
          addLegBtnRef.current.disabled = false;
      }
      try {
        if(scheduleJSON.mainData.Schedule.ScheduleItem.length > 0){
          //setSelectedDateSchTime("");
          getCurrentSystemDateTime("date", true);
        }
      } catch (error) {
        
      }
    }
    catch(err){console.log(err);}
  }, [scheduleJSON]);

  useEffect(() => {
    try{
      //Function to catch and remove selected card chosen by user
      const handleAsyncCheckCC = async () => {
        try{
          let parsedResponse = JSON.parse(cardInfo.response);
          await CheckCCAmountResponseHandler(parsedResponse);
          setShowCCInfoDialog(false);
          setCheckCCParams("");
        }
        catch(err){
          console.log(err);
          setShowCCInfoDialog(false);
          setCheckCCParams("");
        }
      };
      if(cardInfo.selectedCard !== "")
      {
        setCardNumber(cardInfo.selectedCard);
        setCardExpiration(cardInfo.selectedExpiry);
        setCardType(cardInfo.selectedCardType);
        if(parseInt(paymentCardIDInfoRef.current.uniqueID) !== parseInt(cardInfo.uniqueID))
          paymentCardIDInfoRef.current.invalidForSave = 0;
        paymentCardIDInfoRef.current.uniqueID = cardInfo.uniqueID;
        if(cardInfo.response !== "")
        {
          handleAsyncCheckCC();
        }
      }
    }
    catch(err){console.log(err);}
  }, [cardInfo]);

  useEffect(() => {
    try{
      if (isPhoneUpdateFromFunction && phone !== "") {
        const event = new KeyboardEvent("keydown", {
          key: "Enter",
          code: "Enter",
          keyCode: 13,
          bubbles: true,
          cancelable: true,
        });
        phoneRef.current.dispatchEvent(event);
  
        // Reset the flag to prevent unintended triggering
        setIsPhoneUpdateFromFunction(false);
      }
    }
    catch(err){console.log(err); setIsPhoneUpdateFromFunction(false);}
    // only to be called after signal r response caller ID population
  }, [phone, isPhoneUpdateFromFunction]);

  useEffect(() => {
    try{
      if(newClientInfoExtraInfo.ID !== ''){ //New Client Creation Success

        let passCount = {amb: (newClientInfoExtraInfo.passType === 'amb' ? 1:0) , wc: (newClientInfoExtraInfo.passType !== 'amb' ? 1:0), total: 1};
        let AffID = parseInt(newClientInfoExtraInfo.affDetails.affID);
        let FSID = parseInt(newClientInfoExtraInfo.affDetails.FSID);
        let loginUserAffiliateList = (loginData.UserAffiliateList.includes(",")? loginData.UserAffiliateList.split(",") : [loginData.UserAffiliateList]);
        let checkingDataCompany = AffiliateData.find(item=>item.AffiliateID === AffID);
        let affiliateOptionsHTML = AffiliateData.map(function(item, index){
          if(loginUserAffiliateList.includes(String(item.AffiliateID)) && item.vATSPGroupName === checkingDataCompany.vATSPGroupName)
          {
            return (
              <option key={index} value={item.AffiliateID}>{item.AffiliateCompany}</option>
            );
          }
        });

        handleAffChange(AffID);

        setTimeout(() => {
          setAccountNumber(newClientInfoExtraInfo.ID);
          setPassengerTypeCount({ambPass:passCount.amb,totalWC:passCount.wc,totalSA:0, total:passCount.total});
          setMobilityPassengers({...mobilityPassengers,  passenger: passCount.amb});
          setSelectedLanguage(newClientInfoExtraInfo.language);
          setAgentNotes(newClientInfoExtraInfo.agentNotes);
          setPaymentAdditionalInfo(newClientInfoExtraInfo.remarks);
          setClientEmail(newClientInfoExtraInfo.email);
          setSelectedTripPriority(newClientInfoExtraInfo.priority);
          setRCType({phoneType:(newClientInfoExtraInfo.rollcall.phone), emailType:(newClientInfoExtraInfo.rollcall.email), SMSType:(newClientInfoExtraInfo.rollcall.sms)});
          setRiderName(newClientInfoExtraInfo.name);
          setPhone(newClientInfoExtraInfo.phone);
          setAffiliateDropDownHTML(affiliateOptionsHTML);
          
          setFSSelected(FSID); 

          phoneRef.current.disabled = true;
          clientNameCheckRef.current.disabled = true;
          clientMedIDCheckRef.current.disabled = true; //Disable Client Search
        }, 500);
        

        

        //Reset data
        setNewClientInfoExtraInfo({language: 0, passType: '', agentNotes: '', ID: '',
          remarks: '', email: '', rollcall: {phone: false, sms: false, email: false}, priority: '', name: '', affDetails: {affID: 0, FSID: 0}, phone: ''
        });
      }

    }
    catch(err){console.log(err);}
  }, [newClientInfoExtraInfo]);

  //#endregion

  //#region Render Component Functions
  const renderMultiScheduleComponent = () => { //Multischedule render function for JSX to avoid repeatition
    return(
      <span className="d-flex mx-1 justify-content-start">
        <Button title={"Multischedule"} variant="dark" className="my-auto d-flex p-0 border-1 border-secondary" 
          onKeyDown={(e)=>{if(e.key === "Enter" && (verifiedAddr.length < 1 || 
            (verifiedAddr.length === 1 && pickLatLng.current === "" && dropLatLng.current === "")))
            {handleMultischeduleOpen(e);}
          }} 
          onClick={(e)=>{
            if(verifiedAddr.length < 1 || 
              (verifiedAddr.length === 1 && pickLatLng.current === "" && dropLatLng.current === ""))
            {handleMultischeduleOpen(e);}
          }}
        >
          <Icon icon="mingcute:calendar-add-line" className="my-auto border-0 text-white" style={{cursor:(verifiedAddr.length < 1 
              || (verifiedAddr.length === 1 && pickLatLng.current === "" && dropLatLng.current === "")? "pointer":"not-allowed"), 
              width:"25px", height:"25px"
            }} tabIndex={-1}
          />
        </Button>
        <label className="small m-0 p-0 my-auto text-nowrap user-select-none ms-3" title={"Will Call?"}>{(screenWidthSize < 880 ? "WC" : "Will Call")}</label>
        <input type="checkbox" style={{cursor:"pointer"}} className="m-1" checked={willCall} 
          disabled={(scheduleJSON.mainData !== "" && scheduleJSON.mainData.Schedule.ScheduleItem.length > 0)}
          onChange={(e)=>{setWillCall(e.target.checked);}} onKeyDown={(e)=>{if(e.key === "Enter"){setWillCall(!(e.target.checked));}}}
        />
        {scheduleJSON.mainData !== "" && scheduleJSON.mainData.Schedule.ScheduleItem.length > 0 ? 
          <p className='m-0 mx-1 d-inline-block text-nowrap overflow-hidden user-select-none my-auto small text-start' style={{minWidth:"40px", textOverflow:"ellipsis"}} 
            title={((scheduleJSON.mainData.Schedule.ScheduleItem.length) +" Day(s) Scheduled on Multischedule")}
          >
            {((scheduleJSON.mainData.Schedule.ScheduleItem.length > 0 ? scheduleJSON.mainData.Schedule.ScheduleItem.length - scheduleJSON.mainData.Exclusions.length : 0)) + " day(s)"}
          </p>
        : ""}
      </span>
    );
  };

  const renderSchTimeComponent = () => {
    return(
      <span className={`justify-content-start d-flex ${screenWidthSize < 880 ? "mt-1" : "mt-2"}`}>
        {screenWidthSize < 880 ? "" : <p className='m-0 mx-1 d-inline-flex user-select-none my-auto small text-start' style={{minWidth:"40px"}} title={"Reservation Time"}>{"Time"}</p>}
        <input type="time" value={schTime} disabled={(willCall? true : isSchTimeFieldDisabled)} 
        onChange={(e)=>{setSchTime(e.target.value); setIsTimeValidated(false);}}
        onBlur={(e)=>{validateScheduleTimeField(e)}}
        className={`m-0 px-1 w-100 text-center callAgentInputStyle ${requiredClass}`} style={{minWidth:"90px", maxHeight:"28px", height:"28px"}} 
        />
        <span title={"Clear Time"} onClick={(e)=>{if(!willCall && !isSchTimeFieldDisabled){clearSchTime(e);}}}>
          <Icon icon="bx:reset" className="m-0" style={{width:"20px", height:"20px", cursor:"pointer", color:"black"}}/>
        </span>
      </span>
    );
  };

  const renderCallbackPhone = () => {
    let dynamicStyle = (screenWidthSize >= 820 ? {maxHeight:"30px", height:"30px"} : {minWidth:"120px", width:"120px", maxHeight:"30px", height:"30px"});
    return(
      <>
        {(transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2) ?
          <span className={`${screenWidthSize >= 820? "w-100" : ""} d-flex my-auto small text-nowrap`} title={"Callback phone number"}>
            <Icon icon="bx:phone" className="my-auto mx-1" style={{minWidth:"15px", minHeight:"15px", width:"15px", height:"15px"}}/>
            <label className='m-0 my-auto user-select-none callAgentLabelsResponsive'>Callback</label>
            <Form className="d-flex w-100 ms-2">
              <PhoneInput className='text-nowrap text-center m-0 w-100 callAgentInputStyle' 
                style={dynamicStyle}
                defaultCountry="US" value={callBackPhone} onChange={setCallBackPhone} 
                placeholder="(XXX) XXX-XXXX" autoComplete="new_pass"
                onKeyDown={(e)=>{
                  let input = e.target.value;
                  if((e.key === '1' || e.key === '0') && (input.length === 0 || (input.length > 0 && (input.charAt(0) === "1" || input.charAt(0) === "0"))))
                  {
                    e.preventDefault();
                  } 
                  if(e.target.value.length >= 14 && e.key !== 'Backspace' && e.key !== "Delete" && e.key !== "Tab")
                  {e.preventDefault();}
                
                }}
              /> 
            </Form>
          </span>
        : 
          <Row className="m-0">
            <Col className={`p-0 px-1 my-auto`} {...(screenWidthSize < 723 ? { xs: 6 } : {})}>
              <Form>
                <PhoneInput className='text-nowrap text-center w-100 callAgentInputStyle p-1' style={{minWidth:"120px", maxHeight:"30px", height:"30px"}}
                  defaultCountry="US" value={callBackPhone} onChange={setCallBackPhone} placeholder="(XXX) XXX-XXXX" autoComplete="new_pass"
                  onKeyDown={(e)=>{
                    let input = e.target.value;
                    if((e.key === '1' || e.key === '0') && (input.length === 0 || (input.length > 0 && (input.charAt(0) === "1" || input.charAt(0) === "0"))))
                    {
                      e.preventDefault();
                    } 
                    if(e.target.value.length >= 14 && e.key !== 'Backspace' && e.key !== "Delete" && e.key !== "Tab")
                    {e.preventDefault();}
                  }}
                /> 
              </Form>
            </Col>
            <Col className={`d-inline-flex justify-content-start p-0 ${screenWidthSize > 1215 ? 'ms-4' : (screenWidthSize < 1215 && screenWidthSize > 800 ? 'ms-2' : (screenWidthSize > 723 ? 'ms-2' : '')) }`} {...(screenWidthSize < 1215 ? { xs: 6 } : {})}>
              <p className={`m-0 mx-1 user-select-none my-auto small text-start ${screenWidthSize <= 820 ? 'd-none': ''}`} style={{minWidth:"40px"}} title={"Reservation Time"}>
                {"Time"}
              </p>
              <input type="time" value={schTime} onChange={(e) => {setSchTime(e.target.value);}} onBlur={handleSchTimeBlur} onClick={schTimeOnClick}
                onFocus={schTimeOnFocus} disabled={isSchTimeFieldDisabled}
                className="m-0 px-1 float-end w-100 text-center callAgentInputStyle" style={{minWidth:"110px", maxHeight:"30px", height:"30px"}}
              />
              <span title={"Clear Time"} onClick={clearSchTime}><Icon icon="bx:reset" className="m-0" style={{width:"20px", height:"20px", cursor:"pointer", color:"black"}}/></span>
            </Col>
          </Row>
        }
      </>
      
    );
  };

  const renderPhone = (showSuggestion = false) => {
    return(
      <>
        <PhoneInput className={`${showSideBar ? "my-2":""} text-nowrap text-center callAgentInputStyle callAgentClientPhoneResponsive`} 
          style={{maxHeight:"30px", height:"30px"}} ref={phoneRef}
          defaultCountry="US" autoComplete="new_pass" value={phone} 
          onClick={(e) => { if (isFirefox) { phoneRef.current.blur(); phoneRef.current.focus(); } }}
          onKeyUp={handlePhoneCheck} onChange={(e)=>{if(e){handlePhoneNumberChange(e);}}} placeholder="(XXX) XXX-XXXX"
          onBlur={()=>{setTimeout(() => {
            if(!focusedSuggestionCheckClientPhone.current)
            {
              setInputSuggestionListClientPhone("");
            }
          }, 300);}} onFocus={(e)=>{if(e){handlePhoneNumberChange(e);}}}
          onKeyDown={(e)=>
          {
            if((e.key === '1' || e.key === '0') && e.target.value.length === 0)
            {
              e.preventDefault();
            } 
            if(e.target.value.length >= 14 && e.key !== 'Backspace' && e.key !== "Delete" && e.key !== "Tab")
            {
              e.preventDefault();
            }
            if(e.key === "Enter" || e.key === "Tab")
            {
              if(!showSearchLoader)
              {
                setInputSuggestionListClientPhone("");
                setInputSuggestionListClientName("");
                setInputSuggestionListClientMedID("");
                if(Array.isArray(clientIDInfo) && clientIDInfo.length > 0)
                {
                  let type = clientIDInfo[0].homePhone && clientIDInfo[0].homePhone !== "" ? "CustomerPhone" : "CustomerName";
                  let searchText = type === "CustomerPhone" ? clientIDInfo[0].homePhone : (clientIDInfo[0].lastName + ", "+ clientIDInfo[0].firstName);
                  if(type === "CustomerPhone"){handleSearchCustomerPhone(searchText, false, (clientIDInfo[0].id ? clientIDInfo[0].id : 0));}
                  else{handleSearchCustomerName(searchText, false, (clientIDInfo[0].id ? clientIDInfo[0].id : 0));}
                }
                else
                {
                  if((!phone || phone.length < 12) && riderNameCheck.length > 0)
                  {
                    handleSearchCustomerName();
                  }
                  else
                  {
                    handleSearchCustomerPhone();
                  }
                }
              }
            }
            else if(e.key === 'ArrowDown')
            {
              e.preventDefault();
              setHighlightedIndex(-1);
              if(liClientPhoneRefs.current.length > 0)
              {
                if(liClientPhoneRefs.current[0]?.current) //check for empty references
                {
                  setHighlightedIndex((prevIndex) => {
                    const newIndex = (prevIndex + 1) % liClientPhoneRefs.current.length;
                    liClientPhoneRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                    return newIndex;
                  });
                }
              }
            }
            else if (e.key === 'ArrowUp') {
              e.preventDefault();
              setHighlightedIndex(-1);
              if(liClientPhoneRefs.current.length > 0)
              {
                if(liClientPhoneRefs.current[0]?.current)
                {
                  setHighlightedIndex((prevIndex) => {
                    const newIndex = (prevIndex - 1 + liClientPhoneRefs.current.length) % liClientPhoneRefs.current.length;
                    liClientPhoneRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                    return newIndex;
                  });
                }
              }
            }
          }}
          
        />
        {inputSuggestionListClientPhone && inputSuggestionListClientPhone !== "" && showSuggestion ?
          <ul tabIndex={0} className="callAgent-Suggestion-list px-1">{inputSuggestionListClientPhone}</ul>
        :""}
      </>
    );
  };

  const renderClientName = (showSuggestion = false) => {
    return(
      <>
        <input type={"text"} value={riderNameCheck} onChange={handleClientNameChange} ref={clientNameCheckRef} 
          className={"callAgentInputStyle callAgentClientNameResponsive"} title={"Client Name"}
          onClick={(e) => { if (isFirefox) { clientNameCheckRef?.current.blur(); clientNameCheckRef?.current.focus(); } }}
          placeholder={"Client Name"} onKeyUp={handleClientNameCheck} onFocus={handleClientNameChange} 
          onBlur={()=>{setTimeout(() => {
            if(!focusedSuggestionCheckClientName.current)
            {
              setInputSuggestionListClientName("");
            }
          }, 300);}}
          onKeyDown={(e)=>
          {
            if(e.key === "Enter" || (e.key === "Tab" && !e.shiftKey))
            {
              if(!showSearchLoader)
              {
                setInputSuggestionListClientPhone("");
                setInputSuggestionListClientName("");
                setInputSuggestionListClientMedID("");
                if(Array.isArray(clientIDInfo) && clientIDInfo.length > 0)
                {
                  let type = clientIDInfo[0].homePhone && clientIDInfo[0].homePhone !== "" ? "CustomerPhone" : "CustomerName";
                  let searchText = type === "CustomerPhone" ? clientIDInfo[0].homePhone : (clientIDInfo[0].lastName + ", "+ clientIDInfo[0].firstName);
                  if(type === "CustomerPhone"){handleSearchCustomerPhone(searchText, false, (clientIDInfo[0].id ? clientIDInfo[0].id : 0));}
                  else{handleSearchCustomerName(searchText, false, (clientIDInfo[0].id ? clientIDInfo[0].id : 0));}
                }
                else
                {
                  if(riderNameCheck.length === 0 && phone && phone.length >= 12)
                  {
                    handleSearchCustomerPhone();
                  }
                  else
                  {
                    handleSearchCustomerName();
                  }
                }
              }
            }
            else if(e.key === 'ArrowDown')
            {
              e.preventDefault();
              setHighlightedIndex(-1);
              if(liClientNameRefs.current.length > 0)
              {
                if(liClientNameRefs.current[0]?.current) //check for empty references
                {
                  setHighlightedIndex((prevIndex) => {
                    const newIndex = (prevIndex + 1) % liClientNameRefs.current.length;
                    liClientNameRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                    return newIndex;
                  });
                }
              }
            }
            else if (e.key === 'ArrowUp') {
              e.preventDefault();
              setHighlightedIndex(-1);
              if(liClientNameRefs.current.length > 0)
              {
                if(liClientNameRefs.current[0]?.current)
                {
                  setHighlightedIndex((prevIndex) => {
                    const newIndex = (prevIndex - 1 + liClientNameRefs.current.length) % liClientNameRefs.current.length;
                    liClientNameRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                    return newIndex;
                  });
                }
              }
            }
          }}
        />
        {inputSuggestionListClientName && inputSuggestionListClientName !== "" && showSuggestion?
          <ul tabIndex={0} className="callAgent-Suggestion-list px-1" onMouseDown={(e) => e.preventDefault()} >{inputSuggestionListClientName}</ul>
        :""}
      </>
    );
  };

  const enterPressed_CustomerSearchRef = useRef(false);

  const renderMedicalID = (showSuggestion = false) => {
    return(
      <>
        <input type={"text"} value={medicalIDCheck} onChange={handleClientMedicalIDCheckChange} ref={clientMedIDCheckRef} 
          className={`${showSuggestion ? '' : 'mt-2'} callAgentInputStyle callAgentClientMedIDCheckResponsive`} title={"Client Medical ID"}
          onClick={(e) => { if (isFirefox) { clientMedIDCheckRef?.current.blur(); clientMedIDCheckRef?.current.focus(); } }}
          placeholder={"Med ID"} onKeyUp={handleClientMedicalIDCheck}
          onBlur={(e)=>{

            if (enterPressed_CustomerSearchRef.current) {
              enterPressed_CustomerSearchRef.current = false;
              return;
            }

            let input = e.target.value;
            if(input.trim().length > 0)
            {
              setInputSuggestionListClientPhone("");
              setInputSuggestionListClientName("");
              //setTimeout(() => {
                if(!searchClientBtnRef.current.disabled && (inputSuggestionListClientMedID !== "" || !showDynamicModal))
                  handleSearchCustomerMedicalID();
              //}, 1000)
            }
            else
            {
              setTimeout(() => {
                if(!focusedSuggestionCheckMedicalID.current)
                {
                  setInputSuggestionListClientMedID("");
                }
              }, 400);
            }
          }}
          onKeyDown={(e)=>
          {
            if(e.key === "Enter" || (e.key === "Tab" && !e.shiftKey))
            {
              enterPressed_CustomerSearchRef.current = true;
              setInputSuggestionListClientPhone("");
              setInputSuggestionListClientName("");
              setInputSuggestionListClientMedID("");
              if(!searchClientBtnRef.current.disabled)
                handleSearchCustomerMedicalID();
            }
            else if(e.key === 'ArrowDown')
            {
              e.preventDefault();
              setHighlightedIndex(-1);
              if(liClientMedicalIDRefs.current.length > 0)
              {
                if(liClientMedicalIDRefs.current[0]?.current) //check for empty references
                {
                  setHighlightedIndex((prevIndex) => {
                    const newIndex = (prevIndex + 1) % liClientMedicalIDRefs.current.length;
                    liClientMedicalIDRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                    return newIndex;
                  });
                }
              }
            }
            else if (e.key === 'ArrowUp') {
              e.preventDefault();
              setHighlightedIndex(-1);
              if(liClientMedicalIDRefs.current.length > 0)
              {
                if(liClientMedicalIDRefs.current[0]?.current)
                {
                  setHighlightedIndex((prevIndex) => {
                    const newIndex = (prevIndex - 1 + liClientMedicalIDRefs.current.length) % liClientMedicalIDRefs.current.length;
                    liClientMedicalIDRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                    return newIndex;
                  });
                }
              }
            }
          }}
        />
        {inputSuggestionListClientMedID && inputSuggestionListClientMedID !== "" && showSuggestion ?
          <ul tabIndex={0} className="callAgent-Suggestion-list px-1">{inputSuggestionListClientMedID}</ul>
        :""}
      </>
    );
  };

  const renderSearchBtn = (sidebarClass = "") => {
    return(
      <>
        <Button type="button" variant="success" onClick={(e)=>{
          if(medicalIDCheck.trim() !== "" && medicalIDCheck.trim() !== "0")
          {
            handleSearchCustomerMedicalID();
          }
          else if(Array.isArray(clientIDInfo) && clientIDInfo.length > 0)
          {
            let type = clientIDInfo[0].homePhone && clientIDInfo[0].homePhone !== "" ? "CustomerPhone" : "CustomerName";
            let searchText = type === "CustomerPhone" ? clientIDInfo[0].homePhone : (clientIDInfo[0].lastName + ", "+ clientIDInfo[0].firstName);
            if(type === "CustomerPhone"){handleSearchCustomerPhone(searchText, false, (clientIDInfo[0].id ? clientIDInfo[0].id : 0));}
            else{handleSearchCustomerName(searchText, false, (clientIDInfo[0].id ? clientIDInfo[0].id : 0));}
          }
          else
            {
              if(phone && phone.length >= 12)
              {
                handleSearchCustomerPhone();
              }
              else if(riderNameCheck.length > 0)
              {
                handleSearchCustomerName();
              }
            }
          }
        } 
          title={"Client Search"} style={{borderRadius: "0px", maxHeight:"30px", height:"30px"}}
          className={`${sidebarClass !== "" ? sidebarClass : ""} rounded border-0 p-0 px-1`} ref={searchClientBtnRef}
        > 
          {showSearchLoader ? <span role='status' aria-hidden='true' className='spinner-border spinner-border-sm'></span> : "Search"}
        </Button>
      </>
    );
  };

  const renderCOSJSXDropdown = (showDetails = false) => {
    let dynamicStyle = (showDetails ? {minWidth:"110px", maxHeight:"30px", height:"30px"} : {maxWidth:"120px", width:"120px", maxHeight:"30px", height:"30px"});
    return(
      <>
        {showDetails ? 
        <>
          <Icon icon="bx:bus" className="m-1" style={{width:"20px", height:"20px"}}/>
          <label className='m-0 my-1 user-select-none fw-bold callAgentLabelsResponsive'>COS</label>
        </>: ""}
        <select style={dynamicStyle} tabIndex={-1} value={COSSelected} onChange={handleClassOfServiceChange} 
          className={`${showDetails ? "mx-1": "my-2"} text-center callAgentInputStyle`} 
        >
          {COSDropdown && COSDropdown.length > 0 ? COSDropdown:""}
        </select>
      </>
    );
  };

  const renderPayDropdown = (transitType = 'para') => {
    return(
      <>
        <select className={`d-block ${transitType === 'para' ? 'mt-1' : ''} text-center p-1 w-100 callAgentInputStyle`} style={{minWidth:"120px", maxHeight:"30px", height:"30px"}}
          value={PaySelected} 
          onChange={(e)=>{setPaySelected(e.target.value); 
            const selectedIndex = e.target.selectedIndex;
            const selectedOption = e.target.options[selectedIndex];
            setCardNumber("");
            setCardType("");
            setCheckCCParams("");
            paymentCardIDInfoRef.current = {uniqueID: -1, oldUniqueID: -1, payStatusID: -1, invalidForSave: 0, retCCUniqueID: -1, CCPaidAmount: 0, CCRetPaidAmount: 0};
            setCardInfo({cardNumber:"", expiry: "", selectedCard: "", selectedExpiry: "", selectedCardType: "", uniqueID: 0, gateID: "", response: ""});
            setCardExpiration("");
            if(selectedOption.textContent.toLowerCase().includes("card") && parseInt(e.target.value) === 2){setShowCCBtn(true);}else{if(parseInt(copayPayTypeSelected) !== 2){setShowCCBtn(false);}}
          }}
        >
          {PayDropdown && PayDropdown.length > 0 ? PayDropdown:""}
        </select>
      </>
    );
  };

  const renderAddressPhoneInfoPopup = (phoneType = '') => {
    const accurateBtnTitle = (addrPhoneInfo[phoneType] && addrPhoneInfo[phoneType].length >= 12 ?
      formatPhone(addrPhoneInfo[phoneType]) 
      : 
      ((phoneType === 'pick' ? "Pickup" : "Dropoff") + " Phone Number")
    );
    return(
      <>
        <Button variant='transparent' className="border-0 position-absolute rounded p-0 d-flex" style={{right:'0.15rem', top:'50%', transform:'translateY(-50%)'}} 
          onClick={()=>{setShowAddrPhone(prevS=>({...prevS, [phoneType]: !prevS[phoneType]}));}} title={accurateBtnTitle}
        >
          <Icon icon={'icon-park-outline:phone-call'} 
            className={`my-auto ${(addrPhoneInfo[phoneType] && addrPhoneInfo[phoneType].length >= 12) ? 'text-success' : 'text-secondary'}`}
            style={{width:"15px", height:"15px"}}
          />
        </Button>
        {showAddrPhone[phoneType] ? 
          <span className="position-absolute rounded bg-white border border-secondary my-auto"
            style={{width:'160px', maxWidth:'160px', height:'50px', maxHeight:'50px', right:'0.3rem', top:'30%'}}
          >
            <span className="border-0 rounded d-flex float-end mx-0"  style={{cursor:'pointer'}} title={'Close '+(phoneType === 'pick' ? "pickup" : "dropoff")+' phone dialogue'}
              onClick={()=>{setShowAddrPhone(prevS=>({...prevS, [phoneType]: false}));}}
            >
              <Icon icon={'heroicons:x-mark-16-solid'} className="my-auto text-secondary" style={{width:"15px", height:"15px"}}/>
            </span>
            <Form className="d-flex m-auto" style={{width:'150px', maxWidth:'150px'}}>
              
              <PhoneInput className='text-nowrap text-center my-auto w-100 callAgentInputStyle' onBlur={(e)=>{
                  setShowAddrPhone(prevS=>({...prevS, [phoneType]: false}));
                  if(e.target.value.length < 14){
                    setAddrPhoneInfo(prevS=>({...prevS, [phoneType]: null}));
                  }
                }}
                style={(screenWidthSize >= 820 ? {maxHeight:"30px", height:"30px"} : {maxWidth:"120px", width:"120px", maxHeight:"30px", height:"30px"})}
                defaultCountry="US" value={addrPhoneInfo[phoneType]} onChange={(e)=>{setAddrPhoneInfo(prevS=>({...prevS, [phoneType]: e}));}} 
                placeholder="(XXX) XXX-XXXX" autoComplete="new_pass"
                onKeyDown={(e)=>{
                  let input = e.target.value;
                  if((e.key === '1' || e.key === '0') && (input.length === 0 || (input.length > 0 && (input.charAt(0) === "1" || input.charAt(0) === "0"))))
                  {
                    e.preventDefault();
                  } 
                  if(e.target.value.length >= 14 && e.key !== 'Backspace' && e.key !== "Delete" && e.key !== "Tab"){e.preventDefault();}
                  if(e.target.value.length >= 14 && (e.key === 'Enter' || e.key === 'Tab')){
                    setShowAddrPhone(prevS=>({...prevS, [phoneType]: false}));
                  }
                  else if(e.target.value.length < 14 && (e.key === 'Enter' || e.key === 'Tab')){
                    setShowAddrPhone(prevS=>({...prevS, [phoneType]: false}));
                    setAddrPhoneInfo(prevS=>({...prevS, [phoneType]: null}));
                  }
                
                }}
              /> 
            </Form>
          </span>
        : ""}
      </>
    );
  };

const renderAddressApartmentInfoPopup = (ApartmentType) => {
  if (ApartmentType !== 'pick' && ApartmentType !== 'drop') return null;

  const val = addrApartmentInfo?.[ApartmentType] ?? '';
  const label = ApartmentType === 'pick' ? 'Pickup' : 'Dropoff';
  const accurateBtnTitle = val || `${label} Apartment`;

  return (
    <>
      <Button
        variant="transparent"
        className="border-0 position-absolute rounded p-0 d-flex"
        style={{ right: '1.85rem', top: '50%', transform: 'translateY(-50%)' }}
        onClick={() => {
          setShowAddrApartment(prevS => ({
            ...prevS,
            [ApartmentType]: !prevS[ApartmentType],
          }));
        }}
        title={accurateBtnTitle}
      >
        <Icon
          icon={'clarity:building-solid'}
          className={`my-auto ${val.length >= 1 ? 'text-success' : 'text-secondary'}`}
          style={{ width: '15px', height: '15px' }}
        />
      </Button>

      {showAddrApartment?.[ApartmentType] ? (
        <span
          className="position-absolute rounded bg-white border border-secondary my-auto"
          style={{ width: '160px', maxWidth: '160px', height: '50px', maxHeight: '50px', right: '0.3rem', top: '30%', zIndex: '10' }}
        >
          <span
            className="border-0 rounded d-flex float-end mx-0 "
            style={{ cursor: 'pointer' }}
            title={`Close ${label.toLowerCase()} apartment dialogue`}
            onMouseDown={(e) => e.preventDefault()} // prevent input blur before we close
            onClick={() => {
              setShowAddrApartment(prevS => ({ ...prevS, [ApartmentType]: false }));
            }}
          >
            <Icon icon={'heroicons:x-mark-16-solid'} className="my-auto text-secondary" style={{ width: '15px', height: '15px' }} />
          </span>

          <Form
            className="d-flex m-auto"
            style={{ width: '150px', maxWidth: '150px' }}
            onSubmit={(e) => e.preventDefault()}
          >
            <input
              type="text"
              className="text-nowrap text-center my-auto w-100 callAgentInputStyle"
              value={val}
              onChange={(e) => {
                const next = e.target.value;
                setAddrApartmentInfo(prevS => ({ ...prevS, [ApartmentType]: next }));
              }}
              onBlur={() => {
                // Only close the popup; don't clear the value
                setShowAddrApartment(prevS => ({ ...prevS, [ApartmentType]: false }));
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === 'Tab') {
                  e.preventDefault(); // keep the value; just close
                  setShowAddrApartment(prevS => ({ ...prevS, [ApartmentType]: false }));
                }
              }}
              style={
                screenWidthSize >= 820
                  ? { maxHeight: '30px', height: '30px' }
                  : { maxWidth: '120px', width: '120px', maxHeight: '30px', height: '30px' }
              }
            />
          </Form>
        </span>
      ) : null}
    </>
  );
};



  //#endregion

  //#region Page load functions
  const handleKeyPress = useCallback((event) =>{ //keyPress callback handler for varied uses
    try{
      if(event.key === "Escape" && showChatBotRef.current) //If chatbot is shown and esc key is pressed, close chatbot iframe
      {
        setShowChatBot(false);
        showChatBotRef.current = false;
      }
    }
    catch(err){console.log(err);}
  }, []);

  const handleInitialFareAPIs = async (FSID, AffID, COSID, additionalData = [], tripDataInfo = null) => {
    try{
      // if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2)) //Making sure aff is paratransit...
      // {
        await handleGetFareCalcMethod((FSID === "" ? "0":FSID), AffID, COSID); //Get fare calculation method at beginning of page load
        const queryParams = new URLSearchParams(window.location.search);
        const tripSelected = queryParams.get('TripSelected') || activeTripSelected? true:false; //Checking for query on URL of call taker webpage
        let editRowData = (additionalData.length > 0 ? additionalData[0] : (PersistStorage.retrieve("rowDataEditTrip", true) && 
          tripSelected? PersistStorage.retrieve("rowDataEditTrip", true):"")
        );
        if(editRowData && editRowData !== "" && editRowData !== "No data found" && typeof editRowData === 'object') //Making sure edit trip data is not invalid
        {
          if(pickLatLng.current !== "" && dropLatLng.current !== "")
          {
            let tripData = null;
            if(tripDataInfo) //If trip edit addressInfo data already given, use that
            {
              tripData = tripDataInfo;
            }
            else //Otherwise look for correct addressInfo based on D2.0 iRefID selected
            {
              for(let k = 0; k < editRowData.addressInfo.trips.length; k++)
              {
                if(parseInt(rowData.current[0].iRefID) === parseInt(editRowData.addressInfo.trips[k].details[0].tripInfo.refID))
                {
                  tripData = editRowData.addressInfo.trips[k];
                }
              }
              if(!tripData)
              {
                tripData = editRowData.addressInfo.trips[0];
              }
            }
            
            setShowAPILoader(true);
            resetBtnRef.current.disabled = true;
            paratransitBookBtnRef.current.disabled = true;
            let tripTypes = [{type:"pick", mapInfo:pickLatLng.current}, {type:"drop", mapInfo:dropLatLng.current}];
            for(let k = 0; k < tripTypes.length; k ++) //Check for fare zone if fare method is 1, get dispatch zone of PU & DO
            {
              if(fareMethodRef.current === 1)
              {
                await getFareZone(tripData.details[0].paymentInfo.fundingSourceID, editRowData.generalInfo.requestAffiliateID, tripData.details[0].tripInfo.classOfServiceID, tripTypes[k].mapInfo, tripTypes[k].type);
              }
              await getDispatchZone(editRowData.generalInfo.requestAffiliateID, tripTypes[k].mapInfo, tripTypes[k].type);
            }
            await wrapperHandleFareCalc(tripData.details[0].estimatedInfo.estimatedDistance, tripData.details[0].estimatedInfo.estimatedTime, 
              tripData.details[0].paymentInfo.fundingSourceID, tripData.details[0].paymentInfo.iCopayFundingSourceID, tripData.details[0].passengerInfo.totalWheelChairs, 
              tripData.details[0].passengerInfo.totalPassengers, tripData.details[0].tripInfo.classOfServiceID, editRowData.generalInfo.requestAffiliateID, 
              pickLatLng.current, tripData.details[0].estimatedInfo.coPay, "initial", editRowData.riderInfo.riderID); //Get fare estimate for eligibility & distance fare
            setShowAPILoader(false);
            resetBtnRef.current.disabled = false; //Enable add leg, reset, and book after all APIs are finished
            paratransitBookBtnRef.current.disabled = false;
            addLegBtnRef.current.disabled = false;
          }
          else //All errors following invalid addresses
          {
            if(pickLatLng.current === "" && dropLatLng.current === "")
            {
              setModalHeaderText("Invalid Address Info");
              setModalBodyHTML("Trip addresses are invalid, please enter new addresses.");
              setModalFooterHTML(
                <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                  OK
                </Button>
              );
              setShowDynamicModal(true);
            }
            else if(pickLatLng.current === "")
            {
              setModalHeaderText("Invalid Address Info");
              setModalBodyHTML("Trip's pickup address is invalid, please enter a new address.");
              setModalFooterHTML(
                <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                  OK
                </Button>
              );
              setShowDynamicModal(true);
            }
            else if(dropLatLng.current === "")
            {
              setModalHeaderText("Invalid Address Info");
              setModalBodyHTML("Trip's dropoff address is invalid, please enter a new address.");
              setModalFooterHTML(
                <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                  OK
                </Button>
              );
              setShowDynamicModal(true);
            }
          }
        }
      // }
    }
    catch(err){console.log(err);}
  };

  const handleEditTrip = async(rowDataEdit, type = "", copy = false) => {
    try{
      
      let tempData = [];
      if(type === "API")
      { //If taken from active trips instead of D2.0 edit trip API, request for edit needs to run again
        let data = {
          "refID": (parseInt(rowDataEdit[0].iRefId)),
          "serviceID": (parseInt(rowDataEdit[0].iServiceID) ?  parseInt(rowDataEdit[0].iServiceID) : 0),
          "scheduleID": (parseInt(rowDataEdit[0].ScheduleID) ?  parseInt(rowDataEdit[0].ScheduleID) : 0),
          "isSchedule": (rowDataEdit[0].TableSource.toLowerCase().includes("ondemand") ? false:true),
          "requestType": (rowDataEdit[0].TableSource.toLowerCase().includes("ondemand") ? "On Demand":"Time Call")
        };
        let response = await APICom.fetchData("ReservationCoreURL","api/ParatransitCT/GetRequestForEdit", "post", { "Content-Type": "application/json" }, data, null);

        if(response && response.error === "")
        {
          if(response.data && response.data !== "No data found")
          {
            tempData = response.data;
            setActiveTripSelected(true);
          }
          else
          {
            setModalHeaderText("Edit Info Error");
            setModalBodyHTML("No data was found for the selected trip. Please contact the administrator for additional details.");
            setModalFooterHTML(
              <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}> 
                OK
              </Button>
            );
            setShowDynamicModal(true);
            PersistStorage.save("rowDataEditTrip", "", 999, true);
            tempData = "";
            return 0;
          }
        }
        else
        {
          setModalHeaderText("Edit Info Error");
          setModalBodyHTML(<b>{response.error}</b>);
          setModalFooterHTML(
            <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
              OK
            </Button>
          );
          setShowDynamicModal(true);
          PersistStorage.save("rowDataEditTrip", "", 999, true);
          return 0;
        }
      }
      let editRowData = (type === "API" ? tempData : rowDataEdit); //Set accurate data to be used for populated fields on call taker 2.0
      if(editRowData && editRowData !== "" && typeof editRowData === 'object') //Proceed only when data is not invalid
      {
        PersistStorage.save("rowDataEditTrip", editRowData, 999, true);
        if(bookBtnRef.current)
        {
          if(copy)
            setSubmitBtnTitle("Book"); //If an active trip is being copied, dont make it update
          else
            setSubmitBtnTitle("Update");
        }
        else
        {
          if(copy){
            setSubmitParatransitBtnTitle("Book");
            mapPointPickupSelection.current = {data: {address: editRowData.addressInfo.trips[0].details[0].addressDetails.address, POI: ""}};
            mapPointPickupSelection.current["Type"] = "poi";
            mapPointDropoffSelection.current = {data: {address: editRowData.addressInfo.trips[0].details[1].addressDetails.address, POI: ""}};
            mapPointDropoffSelection.current["Type"] = "poi";
          }
          else
            setSubmitParatransitBtnTitle("Update");
        }
        PersistStorage.save("clientInfo", editRowData, 99, true);
        let tripData = null;
        let selectedConfirmationNo = ""
        if(Array.isArray(rowDataEdit)) //if from active trips
        {
          selectedConfirmationNo = parseInt(rowDataEdit[0].iRefId);
          for(let k = 0; k < editRowData.addressInfo.trips.length; k++)
          {
            if(parseInt(rowDataEdit[0].iRefId) === parseInt(editRowData.addressInfo.trips[k].details[0].tripInfo.refID))
            {
              tripData = editRowData.addressInfo.trips[k];
            }
          }
        }
        else //from main grid trips d 2.0
        {
          if(typeof(rowData.current[0]) !== 'undefined')
          {
            selectedConfirmationNo = parseInt(rowData.current[0].iRefID);
          }
          else{
            selectedConfirmationNo = "";
          }
          for(let k = 0; k < editRowData.addressInfo.trips.length; k++)
          {
            if(typeof(rowData.current[0]) !== 'undefined' && parseInt(rowData.current[0].iRefID) === parseInt(editRowData.addressInfo.trips[k].details[0].tripInfo.refID))
            {
              tripData = editRowData.addressInfo.trips[k];
            }
          }
        }

        tripData = (tripData ? tripData : editRowData.addressInfo.trips[0]); //Getting accurate addressInfo details for populating data

        try {
          if(tripData.details[0].dateInfo.isWillCall == true){
            ResetEnableFutureDateValiation();
          }
          else{
            setEnableFutureDateValidation(true);
          }
        } catch (error) {
          
        }
        setAddrApartmentInfo(prev => ({
                ...prev,
                ['pick']: tripData.details[0].addressDetails.apartmentNo ?? ''
            }));
        setAddrApartmentInfo(prev => ({
                ...prev,
                ['drop']: tripData.details[1].addressDetails.apartmentNo ?? ''
            }));

        if(tripData.details[0].tripInfo.refID > 0)
          setConfirmationNo(tripData.details[0].tripInfo.refID);
        if(editRowData.scheduleInfo && editRowData.scheduleInfo.scheduleItem && editRowData.scheduleInfo.scheduleItem.length > 0) //In case of multischedule trips...
        { //Building main data dict of multischedule along with displayed data dict
          let mainDataDict = { 
            MultiScheduleIdentifier: null, 
            vPreSch: (tripData.details[0].tripInfo.preSchedule ? tripData.details[0].tripInfo.preSchedule : ""),
            Exclusions: (editRowData.exclusions ? editRowData.exclusions : [])
          };
          let scheduleItemsArr = [];
          let daysArr = ["N/A", "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
          let displayedDataArr = [];
          // Use a Set to track added dates
          const uniqueDates = new Set();
          for(let j = 0; j < editRowData.scheduleInfo.scheduleItem.length; j++)
          {
            let scheduleInfo = editRowData.scheduleInfo.scheduleItem[j];
            scheduleItemsArr.push({
              dayName: (scheduleInfo.dayName !== ""? scheduleInfo.dayName : daysArr[(scheduleInfo.dayNumber)]),
              dayNumber: scheduleInfo.dayNumber,
              startTime: scheduleInfo.startTime,
              apptTime: scheduleInfo.apptTime,
              endTime: scheduleInfo.endTime,
              bApptTime: scheduleInfo.bApptTime,
              willcall: scheduleInfo.willcall,
              breturnleg: scheduleInfo.breturnleg,
              _returnmultischedule: {
                dayName: scheduleInfo["_returnmultischedule"].dayName,
                dayNumber: scheduleInfo["_returnmultischedule"].dayNumber,
                startTime: scheduleInfo["_returnmultischedule"].startTime,
                endTime: scheduleInfo["_returnmultischedule"].endTime,
                apptTime: scheduleInfo["_returnmultischedule"].apptTime,
                bApptTime: scheduleInfo["_returnmultischedule"].bApptTime,
                willcall: scheduleInfo["_returnmultischedule"].willcall,
                _returnmultischedule: scheduleInfo["_returnmultischedule"]._returnmultischedule,
                breturnleg: scheduleInfo.breturnleg,
              }
            });
            let dateVal = (scheduleInfo.breturnleg ? 
              (scheduleInfo["_returnmultischedule"].startTime.includes("1900") ? scheduleInfo.startTime.split("T")[0] : 
              scheduleInfo["_returnmultischedule"].startTime.split("T")[0]) : scheduleInfo.startTime.split("T")[0]
            );
            let newDateVal = dateVal.split("-")[1]+"/"+dateVal.split("-")[2]+"/"+dateVal.split("-")[0];
            let PUtimeVal = (scheduleInfo.startTime && scheduleInfo.startTime.split("T")[1] !== "00:00:00"? scheduleInfo.startTime.split("T")[1].slice(0, 5):"09:00");
            let apptTime = (scheduleInfo.apptTime && scheduleInfo.apptTime.split("T")[1] !== "00:00:00"? scheduleInfo.apptTime.split("T")[1].slice(0, 5):"");
            let returnApptTime = (scheduleInfo._returnmultischedule.apptTime && scheduleInfo._returnmultischedule.apptTime.split("T")[1] !== "00:00:00"? 
              scheduleInfo._returnmultischedule.apptTime.split("T")[1].slice(0, 5) : "");
            let returnTime = (scheduleInfo._returnmultischedule.startTime && scheduleInfo._returnmultischedule.startTime.split("T")[1] !== "00:00:00"? 
            scheduleInfo._returnmultischedule.startTime.split("T")[1].slice(0, 5) : "09:00");
            let isDateExcluded = (editRowData.exclusions && editRowData.exclusions.length > 0 ? 
              editRowData.exclusions.some(item=>{return item.exclusionDate.includes(dateVal);}) : false);

            let dayIndex = 0;
            if(daysArr[scheduleInfo.dayNumber] === "Sunday")
            {
              dayIndex = 0;
            }
            else if(daysArr[scheduleInfo.dayNumber] === "Monday")
            {
              dayIndex = 1;
            }
            else if(daysArr[scheduleInfo.dayNumber] === "Tuesday")
            {
              dayIndex = 2;
            }
            else if(daysArr[scheduleInfo.dayNumber] === "Wednesday")
            {
              dayIndex = 3;
            }
            else if(daysArr[scheduleInfo.dayNumber] === "Thursday")
            {
              dayIndex = 4;
            }
            else if(daysArr[scheduleInfo.dayNumber] === "Friday")
            {
              dayIndex = 5;
            }
            else if(daysArr[scheduleInfo.dayNumber] === "Saturday")
            {
              dayIndex = 6;
            }
            let days = (editRowData.scheduleInfo.to && editRowData.scheduleInfo.to.includes("1900") ? 
              findDaysInRange(editRowData.scheduleInfo.from.split("T")[0], editRowData.scheduleInfo.infinitetodate.split("T")[0], dayIndex) : 
              findDaysInRange(editRowData.scheduleInfo.from.split("T")[0], editRowData.scheduleInfo.to.split("T")[0], dayIndex)
            );

            if(days.length > 0)
            {
             
              days.forEach(day => {
                let tempDate = day.split("/")[2]+"-"+day.split("/")[0]+"-"+day.split("/")[1];
                if(!uniqueDates.has(day))
                {
                  uniqueDates.add(day);
                  isDateExcluded = (editRowData.exclusions && editRowData.exclusions.length > 0 ? 
                    editRowData.exclusions.some(item=>{return item.exclusionDate.includes(tempDate);}) 
                    : false
                  );
                  displayedDataArr.push({
                    Day: daysArr[scheduleInfo.dayNumber], // Assuming `day` is the index of the day in `daysArr`
                    Date: day, // Use appropriate date format for each `day` from `days` array
                    Checked: true,
                    WillCall: scheduleInfo.willcall,
                    Appt: apptTime,
                    PUTime: PUtimeVal,
                    isReturnTrip: scheduleInfo.breturnleg ? scheduleInfo.breturnleg : false,
                    ReturnWillCall: scheduleInfo._returnmultischedule.willcall ? scheduleInfo._returnmultischedule.willcall : false,
                    ReturnAppt: returnApptTime,
                    ReturnTime: returnTime,
                    schType: isDateExcluded ? "exc" : "sch",
                    isHoliday: false
                  });
                }
              });
              
            }
            else
            {
              displayedDataArr.push({
                Day:daysArr[scheduleInfo.dayNumber], Date:newDateVal, Checked:true, WillCall:scheduleInfo.willcall, Appt:apptTime, PUTime:PUtimeVal, 
                isReturnTrip:(scheduleInfo.breturnleg? scheduleInfo.breturnleg: false), 
                ReturnWillCall:(scheduleInfo._returnmultischedule.willcall? scheduleInfo._returnmultischedule.willcall: false), 
                ReturnAppt:returnApptTime, ReturnTime:returnTime, schType:(isDateExcluded ? "exc":"sch"), 
                isHoliday:false
              });
            }
            
          }
          displayedDataArr.sort((a, b) => {
            let correctDateA = (a.Date.split('/')[2] +"-"+ a.Date.split('/')[0] +"-"+ a.Date.split('/')[1]);
            let correctDateB = (b.Date.split('/')[2] +"-"+ b.Date.split('/')[0] +"-"+ b.Date.split('/')[1]);
            const dateA = new Date(correctDateA+" 00:00:00"); 
            const dateB = new Date(correctDateB+" 00:00:00");
            return dateB - dateA; // Sort latest to earliest
          });
          mainDataDict = {...mainDataDict, Schedule:{
            from: editRowData.scheduleInfo.from, 
            to: editRowData.scheduleInfo.to, 
            infinitetodate: editRowData.scheduleInfo.infinitetodate,
            ScheduleItem: scheduleItemsArr}
          };
          
          let managedData = [
            {Day:"Sunday", Date:"", Checked:false, WillCall:false, Appt:"", PUTime:"09:00", isReturnTrip:false, ReturnWillCall:false, ReturnAppt:"", ReturnTime:"09:00", schType:"sch", isHoliday:false},
            {Day:"Monday", Date:"", Checked:false, WillCall:false, Appt:"", PUTime:"09:00", isReturnTrip:false, ReturnWillCall:false, ReturnAppt:"", ReturnTime:"09:00", schType:"sch", isHoliday:false},
            {Day:"Tuesday", Date:"", Checked:false, WillCall:false, Appt:"", PUTime:"09:00", isReturnTrip:false, ReturnWillCall:false, ReturnAppt:"", ReturnTime:"09:00", schType:"sch", isHoliday:false},
            {Day:"Wednesday", Date:"", Checked:false, WillCall:false, Appt:"", PUTime:"09:00", isReturnTrip:false, ReturnWillCall:false, ReturnAppt:"", ReturnTime:"09:00", schType:"sch", isHoliday:false},
            {Day:"Thursday", Date:"", Checked:false, WillCall:false, Appt:"", PUTime:"09:00", isReturnTrip:false, ReturnWillCall:false, ReturnAppt:"", ReturnTime:"09:00", schType:"sch", isHoliday:false},
            {Day:"Friday", Date:"", Checked:false, WillCall:false, Appt:"", PUTime:"09:00", isReturnTrip:false, ReturnWillCall:false, ReturnAppt:"", ReturnTime:"09:00", schType:"sch", isHoliday:false},
            {Day:"Saturday", Date:"", Checked:false, WillCall:false, Appt:"", PUTime:"09:00", isReturnTrip:false, ReturnWillCall:false, ReturnAppt:"", ReturnTime:"09:00", schType:"sch", isHoliday:false}
          ];
          
          let updatedManagedData = managedData.map(item => {
            const matchedDay = displayedDataArr.find(displayedDay => displayedDay.Day === item.Day);
            return (matchedDay ? matchedDay : item)
          });
          
          if(editRowData.scheduleInfo.to && editRowData.scheduleInfo.to.includes("1900")) //never expire = true
          {
            setScheduleJSON(
              { 
                mainData: mainDataDict, 
                multiSchData:{managed:updatedManagedData, displayed:displayedDataArr}, 
                range: {
                  from: editRowData.scheduleInfo.from.split("T")[0], 
                  to: editRowData.scheduleInfo.infinitetodate.split("T")[0]
                }, 
                neverExpire:true
              }
            );
          }
          else //never expire = false
          {
            setScheduleJSON(
              {
                mainData: mainDataDict, 
                multiSchData: {managed:updatedManagedData, displayed:displayedDataArr}, 
                range: {
                  from: editRowData.scheduleInfo.from.split("T")[0], 
                  to: editRowData.scheduleInfo.to.split("T")[0]
                }, 
                neverExpire:false
              }
            );
          }
          
        }

        let attrSelection = AttributeData ? AttributeData.filter((item,index)=> {return parseInt(item.iAttrATSPID) === parseInt(editRowData.generalInfo.requestAffiliateID) && parseInt(item.iAttrType) !== 10}) : [];
        let attrOptionsMultiSel = attrSelection && attrSelection.length > 0 ? attrSelection.map((item)=>{
          let dict = {};
          dict.id = item.ID;
          dict.name = item.Title;
          return dict;
        }).sort((a, b) => a.name.localeCompare(b.name)) : [];
        let providedAttrArray = tripData.details[0].tripInfo.entityAttributes;
        let groupSelected = [];
        for(let k = 0; k < attrOptionsMultiSel.length; k++)
        {
          if(providedAttrArray.includes(String(attrOptionsMultiSel[k].id)))
          {
            groupSelected.push({id:attrOptionsMultiSel[k].id, name:attrOptionsMultiSel[k].name});
          }
        }
        SetAttributesFilterMultiSelect({ ...AttributesFilterMultiSelect, ...{options: attrOptionsMultiSel,
          selectedValues:(tripData.details[0].tripInfo.entityAttributes.length !== 0 ? groupSelected : [])}}
        ); //Getting the correct attributes auto-selected (if any) 
        let attributesDesc = (tripData.details[0].tripInfo.entityAttributes ? (tripData.details[0].tripInfo.entityAttributes.split(",").map((num) => parseInt(num.trim(), 10)).filter((num) => !isNaN(num)) ) : []);
        setSelectedTripAttr(attributesDesc);
        setSelectedTripType(tripData.details[0].tripInfo.callType);
        addressInfoDetails.current.pick = {city: tripData.details[0].addressDetails.city, state: tripData.details[0].addressDetails.state, zip: tripData.details[0].addressDetails.zip};
        if(tripData.details.length === 2)
        {
          addressInfoDetails.current.drop = {city: tripData.details[1].addressDetails.city, state: tripData.details[1].addressDetails.state, zip: tripData.details[1].addressDetails.zip};
        }
        else
        {
          let dataLength = tripData.details.length;
          let dropData = tripData.details[(dataLength - 1)];
          addressInfoDetails.current.drop = {city: dropData.addressDetails.city, state: dropData.addressDetails.state, zip: dropData.addressDetails.zip};
        }
        if(tripData.details[0].dateInfo.pickupDate.toLowerCase() !== "will call")
        {
          let timeTemp = ((typeof tripData.details[0].dateInfo.pickupDate === 'string' && 
            tripData.details[0].dateInfo.pickupDate.includes("T") && 
            tripData.details[0].dateInfo.pickupDate.split("T")[1] !== "00:00:00") ?
            tripData.details[0].dateInfo.pickupDate.split("T")[1] : ""
          );
          let timeParts = (timeTemp !== "" ? timeTemp.split(":") : "");

          setSchTime((timeParts !== ""? `${timeParts[0]}:${timeParts[1]}`:""));
        }
        //Method to identify if the trip is will call from given data:
        const date1 = (tripData.details[0].dateInfo.isWillCall && 
          tripData.details[0].dateInfo.willCallDay !== ""? 
          new Date(tripData.details[0].dateInfo.willCallDay) : new Date("1900-01-01T00:00:00"));
        const date2 = new Date("2000-01-01T00:00:00"); 
        if(date1 > date2 && (tripData.details[0].dateInfo.pickupDate && tripData.details[0].dateInfo.pickupDate === "1900-01-01T00:00:00"))
        {
          setWillCall(true);
        }
        else
        {
          setWillCall(false);
        }
        let date = (tripData.details[0].dateInfo.isWillCall ? (tripData.details[0].dateInfo.willCallDay.includes("T") 
        ? tripData.details[0].dateInfo.willCallDay.split("T")[0] : tripData.details[0].dateInfo.willCallDay.split(" ")[0])
        :(tripData.details[0].dateInfo.pickupDate.includes("1900") ? editRowData.scheduleInfo.from.split("T")[0]:(tripData.details[0].dateInfo.pickupDate.includes("T") ? 
        tripData.details[0].dateInfo.pickupDate.split("T")[0] : tripData.details[0].dateInfo.pickupDate.split(" ")[0])));
        setSelectedDateSchTime(date);
        setAppointmentTime((typeof tripData.details[0].dateInfo.apptTime === 'string' 
          && tripData.details[0].dateInfo.apptTime.includes("T") && 
          tripData.details[0].dateInfo.apptTime.split("T")[1] !== "00:00:00" ? 
          tripData.details[0].dateInfo.apptTime.split("T")[1]:""));
        setTripStatus((tripData.details[0].tripInfo.virtualRoute === ""?"Un-Routed":"Routed"));
        setSelectedVehType((tripData.details[0].vehicleInfo.vehicleTypeId === -1 || 
          tripData.details[0].vehicleInfo.vehicleTypeId === 0 ? "VT" : 
          parseInt(tripData.details[0].vehicleInfo.vehicleTypeId))
        );
        //Setting the insurance and additional details and communication methods
        setClientSummary(prevState=>({...prevState, totalCalls:0, totalNS:0, 
          totalCancels:0, lastCall:"",
          tripDistance:tripData.details[0].estimatedInfo.estimatedDistance, TripDuration:tripData.details[0].estimatedInfo.estimatedTime, TripFare:tripData.details[0].estimatedInfo.estimatedCost, 
          TripCopay:tripData.details[0].estimatedInfo.coPay
        }));
        setMedID((editRowData.riderInfo.riderID ? editRowData.riderInfo.riderID : "")); //Rider ID/Medical ID
        setInsuranceName(editRowData.riderInfo.pickupPerson.trim()); 
        setInsuranceSSN(0); 
        setAccountNumber(editRowData.riderInfo.id);
        setInsuranceAuthCode(0); 
        setCopayAmount(tripData.details[0].estimatedInfo.coPay);
        setClientJob((tripData.details[0].tripInfo.ext2 && tripData.details[0].tripInfo.ext2 !== "" ? tripData.details[0].tripInfo.ext2 : ""));
        setClientEmail(tripData.details[0].tripInfo.customerEmail);
        setRCType({phoneType:tripData.details[0].tripInfo.isRollingCallTypePhone, emailType:tripData.details[0].tripInfo.isRollingCallTypeEmail, SMSType:tripData.details[0].tripInfo.isRollingCallTypeSMS});
        setRiderName(editRowData.riderInfo.pickupPerson);
        setPaymentAdditionalInfo(tripData.details[0].tripInfo.extraInfo);
        setPhone(("+1"+editRowData.riderInfo.phoneNo.replaceAll("-","")));
        phoneRef.current.disabled = true;
        clientNameCheckRef.current.disabled = true;
        clientMedIDCheckRef.current.disabled = true;
        if(tripData.details[0].tripInfo.callBackInfo !== "")
        {
          setCallBackPhone(("+1"+tripData.details[0].tripInfo.callBackInfo.replaceAll("-","")));
        }
        let _totalChildren = 0;
        if(tripData.details[0].passengerInfo.children != undefined && tripData.details[0].passengerInfo.children?.length > 0){
          _totalChildren = tripData.details[0].passengerInfo.children.length;
        }


        let ambPassengerCount = tripData.details[0].passengerInfo.totalPassengers;
        let _totalWCCount = tripData.details[0].passengerInfo.totalWheelChairs;
        // if(transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2){
        //   //ambPassengerCount = 0;
        
        //   if(tripData.details[0].passengerInfo.guests.length >= 1){
        //   }
        //   else{
        //     if((tripData.details[0].passengerInfo.pca.Attributes != "" && tripData.details[0].passengerInfo.pca.Attributes != null && tripData.details[0].passengerInfo.pca.Attributes != undefined)){
             
        //     }
        //     if(tripData.details[0].passengerInfo.primary.Attributes != "" && 
        //     tripData.details[0].passengerInfo.primary.Attributes != null && tripData.details[0].passengerInfo.primary.Attributes != undefined){
            
        //     }
        //   }
        // }

        let data = {Primary:tripData.details[0].passengerInfo.primary, 
          PCA: tripData.details[0].passengerInfo.pca, Guests:tripData.details[0].passengerInfo.guests, 
          Children: tripData.details[0].passengerInfo.children};


        ////@@@@@@@@@@@ Section to Read counts When Mobility Attributes@@@@@@@@@@@//

        if(refMobilityAttributeOptions.current != undefined && refMobilityAttributeOptions.current != [] 
          && refMobilityAttributeOptions.current != null && refMobilityAttributeOptions.current?.length > 0 && 
          (transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2)){

          let Mobility_TotalAdultsCount = 0;
          let Mobility_TotalChildrenCount = 0;

          let PCACount = 0;
          let GuestsCount = 0;
          let ChildrenCount = 0;

          if(tripData.details[0].passengerInfo.primary != undefined && tripData.details[0].passengerInfo.primary?.selectedAttribute) {
            Mobility_TotalAdultsCount += 1;
          }
          if(tripData.details[0].passengerInfo.pca?.length >= 0){
            PCACount = tripData.details[0].passengerInfo.pca?.length;
            Mobility_TotalAdultsCount += PCACount;
          }
          if(tripData.details[0].passengerInfo.guests?.length >= 0){
            GuestsCount = tripData.details[0].passengerInfo.guests?.length;
            Mobility_TotalAdultsCount += GuestsCount;
          }
          if(tripData.details[0].passengerInfo.children?.length >= 0){
            Mobility_TotalChildrenCount = tripData.details[0].passengerInfo.children?.length;
          }

          ////@@@@@@@@@@@ Section to Read counts When Mobility Attributes@@@@@@@@@@@//
          let wcCount = getMobilityAttributes(tripData.details[0]);
          setPassengerTypeCount(
            {
              ambPass: Mobility_TotalAdultsCount,
              totalWC: parseInt(wcCount), 
              totalSA: parseInt(tripData.details[0].passengerInfo.serviceAnimalCount),
              total: parseInt(Mobility_TotalAdultsCount) + Mobility_TotalChildrenCount, 
              totalChildren: parseInt(Mobility_TotalChildrenCount)
          });
          
          
          setMobilityPassengers({...mobilityPassengers,  passenger:parseInt(Mobility_TotalAdultsCount) , children: _totalChildren});
          setMobilityDbData(data);
          setMobilitySavedData(structuredClone(data));
        }
        else{
          setPassengerTypeCount(
            {
              ambPass: ambPassengerCount,
              totalWC: parseInt(_totalWCCount), 
              totalSA: parseInt(tripData.details[0].passengerInfo.serviceAnimalCount),
              total:parseInt(ambPassengerCount) + parseInt(_totalWCCount), 
              totalChildren: 0
          });
        }


        //Setting address data accordingly
        setPickupAddr(tripData.details[0].addressDetails.address + ", " + tripData.details[0].addressDetails.city + ", " + tripData.details[0].addressDetails.state + " " + tripData.details[0].addressDetails.zip);
        let editAddressData = tripData.details;
        let lastTripData = (tripData.details[1].stopType === "dropoff" ? tripData.details[1] : tripData.details[(editAddressData.length - 1)]);
        let genderInitialChecks = (tripData.details[0].driverInfo.preferedDriverGender && tripData.details[0].driverInfo.preferedDriverGender !== "" 
          && tripData.details[0].driverInfo.preferedDriverGender !== -1
        );
        let languageInitialChecks = (tripData.details[0].driverInfo.preferedLanguage && tripData.details[0].driverInfo.preferedLanguage !== "" 
          && tripData.details[0].preferedLanguage !== -1
        );
        const areAddressPhonesGiven = {pick: (tripData.details[0].addressDetails.phone && tripData.details[0].addressDetails.phone !== '') , drop: (lastTripData.addressDetails.phone && lastTripData.addressDetails.phone !== '')};
        
        setDropAddr(lastTripData.addressDetails.address + ", " + lastTripData.addressDetails.city + ", " + lastTripData.addressDetails.state + " " + lastTripData.addressDetails.zip);
        dropLatLng.current = lastTripData.addressDetails.latitude && parseFloat(lastTripData.addressDetails.latitude) !== 0? lastTripData.addressDetails.latitude+","+lastTripData.addressDetails.longitude:"";
        pickLatLng.current = tripData.details[0].addressDetails.latitude && parseFloat(tripData.details[0].addressDetails.longitude) !== 0? tripData.details[0].addressDetails.latitude+","+tripData.details[0].addressDetails.longitude:"";
        
        setPickExtraInfo(tripData.details[0].addressDetails.remarks);
        setDropExtraInfo(lastTripData.addressDetails.remarks);
        setPickPOI(tripData.details[0].addressDetails.poiName); //POI set if any
        setDropPOI(lastTripData.addressDetails.poiName);
        setAddrPhoneInfo({pick: (areAddressPhonesGiven.pick ? ("+1"+tripData.details[0].addressDetails.phone.replaceAll("-","")) : null), 
          drop: (areAddressPhonesGiven.drop ? ("+1"+lastTripData.addressDetails.phone.replaceAll("-","")) : null)
        });

        setMobilityChecks({vehTypeCheck:tripData.details[0].vehicleInfo.onlyPreferedVType, vehNumCheck:tripData.details[0].vehicleInfo.onlyPreferedVehicle, 
          driverNumCheck:tripData.details[0].driverInfo.onlyPreferedDriver, genderCheck:tripData.details[0].driverInfo.onlyPreferedDriverGender,
          languageCheck:tripData.details[0].driverInfo.onlyPreferedDriverLanguage
        });
        setMobilityDetails({totalVeh:1, vehTypeMin:0, vehNumMin:tripData.details[0].vehicleInfo.vehicleNoTimeDiff, 
          driverNumMin:tripData.details[0].driverInfo.driverNoTimeDiff, genderMin:tripData.details[0].driverInfo.genderTimeDiff, 
          languageMin:tripData.details[0].driverInfo.langTimeDiff
        });
        setSelectedGender((genderInitialChecks ? tripData.details[0].driverInfo.preferedDriverGender : "Gender"));
        setSelectedLanguage((languageInitialChecks ? tripData.details[0].driverInfo.preferedLanguage : "Language"));
        let tripLatLng = []; 
        if(pickLatLng.current !== "" && dropLatLng.current !== "")
        {
          tripLatLng.push(
            {lat:parseFloat(pickLatLng.current.split(",")[0]),
              lng: parseFloat(pickLatLng.current.split(",")[1]), Type:"PU", 
              name:(editRowData.riderInfo.pickupPerson), address: (tripData.details[0].addressDetails.address + ", " + tripData.details[0].addressDetails.city + ", " + tripData.details[0].addressDetails.state + " " + tripData.details[0].addressDetails.zip)
            },
            {lat:parseFloat(dropLatLng.current.split(",")[0]),
              lng: parseFloat(dropLatLng.current.split(",")[1]), Type:"DO", 
              name:(editRowData.riderInfo.pickupPerson), address: (lastTripData.addressDetails.address + ", " + lastTripData.addressDetails.city + ", " + lastTripData.addressDetails.state + " " + lastTripData.addressDetails.zip)
            },
          ); //Setting details for map markers
        }
        let discoveredID = 0;
        let trimmedName = editRowData.riderInfo.pickupPerson.trim();
        let nameFormatForSearch = (trimmedName.includes(" ") ? (trimmedName.split(" ")[1] + ", " + trimmedName.split(" ")[0]) : trimmedName);
        if(parseInt(tripData.details[0].paymentInfo.paymentTypeID) === 2 || parseInt(tripData.details[0].paymentInfo.iActualPaymentTypeID) === 2)
        {
          await handleSearchCustomerName(nameFormatForSearch, false, (editRowData.riderInfo.id ? editRowData.riderInfo.id : 0), false);
        }
        
        if(editRowData.addressInfo.trips.length > 1) //In case of multi-trip, save and show correctly selected trip to user on stop order
        {
          let tripDetail = editRowData.addressInfo.trips;
          let stopOrderArr = [];
          let stopDetailsTrackerArr = [];
          for(let k = 0; k < tripDetail.length; k++)
          {
            stopDetailsTrackerArr.push(
              {
                stopNo:(k+1), 
                distance: tripDetail[k].details[0].estimatedInfo.estimatedDistance,
                duration: tripDetail[k].details[1].estimatedInfo.estimatedDistance
              }
            );
          }
          for(let i = 0; i < tripDetail.length; i++)
          {
            let pickData = tripDetail[i].details[0];
            let dropData = (tripDetail[i].details.length === 2 ? tripDetail[i].details[1] : tripDetail[i].details[(tripDetail[i].details.length - 1)]);
            let pickAddress = pickData.addressDetails.address + ", "+ pickData.addressDetails.city + ", " + pickData.addressDetails.state + " " + pickData.addressDetails.zip;
            let dropAddress = dropData.addressDetails.address + ", "+ dropData.addressDetails.city + ", " + dropData.addressDetails.state + " " + dropData.addressDetails.zip;
            let dateGiven = (pickData.dateInfo.isWillCall ? pickData.dateInfo.willCallDay.split("T")[0] : formatDate(pickData.dateInfo.pickupDate.split("T")[0]));
            let timeGiven = (pickData.dateInfo.isWillCall ? "Will Call" : pickData.dateInfo.pickupDate.split("T")[1]);
            let correctDate = (dateGiven.includes("-") ? formatDate(dateGiven) : dateGiven);
            let ambulatoryPassCount = parseInt(pickData.passengerInfo.totalPassengers) - parseInt(pickData.passengerInfo.totalWheelChairs);
            let fareEstimateDataDict = {copay: (pickData.paymentInfo.CopayPrice && pickData.paymentInfo.CopayPrice !== ""? parseInt(pickData.paymentInfo.CopayPrice) : 0), 
              walletID: (pickData.tripInfo.selfWalletID && pickData.tripInfo.selfWalletID !== ""? parseInt(pickData.tripInfo.selfWalletID) : 0), 
              promo: (pickData.tripInfo.Promocode || ""), eaasJSON: (pickData.tripInfo.EaasJSONResp || ""), displayMessage: "", verifyStatus: ""
            };
            let attributesDesc = (pickData.tripInfo.entityAttributes ? (pickData.tripInfo.entityAttributes.split(",").map((num) => parseInt(num.trim(), 10)).filter((num) => !isNaN(num)) ) : []);
            
            
            //let brokerDict = {brokerMode: (pickData.tripInfo.FSBrokerMode || 0) , globalBrokerMode: (pickData.tripInfo.BrokerMode || 0)};
            let BrokerMode = GetBrokerModeByAffiliateID();
            if(pickData.tripInfo.FSBrokerMode != undefined && pickData.tripInfo.FSBrokerMode != ""){
              BrokerMode = pickData.tripInfo.FSBrokerMode;
            }

            let brokerDict = {brokerMode: (BrokerMode || 0) , globalBrokerMode: (BrokerMode || 0)};

            let addressExtraDetailsVal = {pick: {state:pickData.addressDetails.state, city: pickData.addressDetails.city, zip: pickData.addressDetails.zip}, 
              drop: {state:dropData.addressDetails.state, city:dropData.addressDetails.city, zip:dropData.addressDetails.zip}};
            stopOrderArr.push({pickAddr: pickAddress, dropAddr: dropAddress, pickPOI: pickData.addressDetails.poiName, dropPOI: dropData.addressDetails.poiName,
                date: correctDate, email: pickData.tripInfo.customerEmail,
                time: timeGiven, distance: pickData.estimatedInfo.estimatedDistance, duration: pickData.estimatedInfo.estimatedTime, fare: pickData.estimatedInfo.estimatedCost, 
                copay: pickData.estimatedInfo.coPay, willCall: pickData.dateInfo.isWillCall, 
                apptTime: (pickData.dateInfo.isWillCall? "Will Call":(!pickData.dateInfo.apptTime.includes("1900")? pickData.dateInfo.apptTime.split("T")[1] : "")), 
                notes: pickData.tripInfo.agentInstructions, phone: editRowData.riderInfo.phoneNo, 
                puNotes: pickData.addressDetails.remarks, doNotes: dropData.addressDetails.remarks, riderName: editRowData.riderInfo.pickupPerson, 
                passCount: {ambPass:ambulatoryPassCount,totalWC:pickData.passengerInfo.totalWheelChairs,
                  totalSA:pickData.passengerInfo.serviceAnimalCount, total:pickData.passengerInfo.totalPassengers}, callBackPhone: (pickData.tripInfo.callBackInfo.includes("-")? ("+1"+pickData.tripInfo.callBackInfo.replaceAll("-","")) : pickData.tripInfo.callBackInfo),
                waitTime: "", stops:[], isReturn: pickData.tripInfo.returnTrip, pickLatLng: (pickData.addressDetails.latitude+","+pickData.addressDetails.longitude), 
                dropLatLng: (dropData.addressDetails.latitude+","+dropData.addressDetails.longitude),
                stopsDetails: stopDetailsTrackerArr, addressExtraDetails: addressExtraDetailsVal, id: editRowData.riderInfo.id, 
                //clientMedID: editRowData.riderInfo.medicalID, 
                clientMedID: editRowData?.riderInfo?.medicalID?.trim() || editRowData?.riderInfo?.riderID?.trim() || "0",
                paymentExtraInfo: pickData.tripInfo.extraInfo, clientJob: pickData.tripInfo.ext2,
                clientAddr: editRowData.riderInfo.clientAddress, clientCity: editRowData.riderInfo.clientCity, clientState: editRowData.riderInfo.clientState, 
                clientZip: editRowData.riderInfo.clientZip, fareZones: {pickFareZone:pickData.addressDetails.fareZone, dropFareZone:dropData.addressDetails.fareZone}, 
                dispatchZones: {pickZone: pickData.addressDetails.zone, dropZone: dropData.addressDetails.zone},
                FundingSource: pickData.paymentInfo.fundingSourceID, PaymentSelected: pickData.paymentInfo.paymentTypeID, 
                AffiliateSelected: editRowData.generalInfo.requestAffiliateID, COS: pickData.tripInfo.classOfServiceID, 
                vehType: (pickData.vehicleInfo.vehicleTypeId && pickData.vehicleInfo.vehicleTypeId !== -1 ? pickData.vehicleInfo.vehicleTypeId : "VT"), 
                vehTypeCheck: pickData.vehicleInfo.onlyPreferedVType, vehTypeMins: 0,
                cardNum: (pickData.paymentInfo.ccInfo.includes(",")? pickData.paymentInfo.ccInfo.split(",")[0] : ""), 
                cardExp: (pickData.paymentInfo.ccInfo.includes(",")? pickData.paymentInfo.ccInfo.split(",")[1] : ""), 
                RC: {phoneType:pickData.tripInfo.isRollingCallTypePhone, emailType:pickData.tripInfo.isRollingCallTypeEmail, SMSType:pickData.tripInfo.isRollingCallTypeSMS}, 
                driverNum: (pickData.driverInfo.assignedDriverNo !== "" ? pickData.driverInfo.assignedDriverNo : "DN"), driverNumCheck: pickData.driverInfo.onlyPreferedDriver,
                driverMins: pickData.driverInfo.driverNoTimeDiff, gender: (pickData.driverInfo.preferedDriverGender !== "" ? pickData.driverInfo.preferedDriverGender : "Gender"), 
                genderMins: pickData.driverInfo.genderTimeDiff, vehNum: (pickData.vehicleInfo.assignedVehNo !== "" ? pickData.vehicleInfo.assignedVehNo : "VN"), 
                genderCheck: pickData.driverInfo.onlyPreferedDriverGender,
                vehNumCheck: pickData.vehicleInfo.onlyPreferedVehicle, vehMins: pickData.vehicleInfo.vehicleNoTimeDiff, 
                language: (pickData.driverInfo.preferedLanguage !== "" && pickData.driverInfo.preferedLanguage !== 0 ? pickData.driverInfo.preferedLanguage : "Language"), 
                languageMins: pickData.driverInfo.langTimeDiff, languageCheck: pickData.driverInfo.onlyPreferedDriverLanguage,
                tripAttribute: attributesDesc, insurance: {Agency: editRowData.insuranceInfo.agencyID, Type: editRowData.insuranceInfo.insuranceID, 
                CaseWorker: editRowData.insuranceInfo.caseWorkerID, AuthCode: editRowData.insuranceInfo.authID,
                ServiceCode: editRowData.insuranceInfo.serviceCodeID}, copayPayType: pickData.paymentInfo.iActualPaymentTypeID, 
                copayFS: pickData.paymentInfo.iCopayFundingSourceID, tripType: pickData.tripInfo.callType, manualAmount: {estimatedFare: 0, estimatedDistance:0, price:0},
                tripPriority: pickData.tripInfo.slaClassID, fareMethod: pickData.tripInfo.fareMethod, billableAmount: pickData.estimatedInfo.billableAmount, 
                additionalPassengerCost: pickData.estimatedInfo.additionalPassCost, confirmationNo: ((copy)? "-1": pickData.tripInfo.refID),
                fareEstimateAPIData : fareEstimateDataDict, broker: brokerDict, CCInfo: cardInfo, ForcePassServiceHours: pickData.tripInfo.ForcePassServiceHoursCheck,
                paymentLogicInfo: {uniqueID: -1, oldUniqueID: -1, payStatusID: -1, invalidForSave: 0, retCCUniqueID: -1, CCPaidAmount: 0, CCRetPaidAmount: 0},
                addressPhoneInfo: {pick: pickData.addressDetails.phone, drop: dropData.addressDetails.phone},
                passengerMobilityInfo : {Primary: pickData.passengerInfo.primary, 
                  PCA: pickData.passengerInfo.pca, Guests: pickData.passengerInfo.guests, 
                  Children: pickData.passengerInfo.children, IsMobility: pickData.passengerInfo.isMobility},
                PUApartment: pickData.addressDetails.apartmentNo,
                  DOApartment: dropData.addressDetails.apartmentNo
              }
            );
            if(parseInt(pickData.tripInfo.refID) === parseInt(selectedConfirmationNo))
            {
              discoveredID = i;
              setVerifiedInfoUpdateIndex(i);
            }
          }
          setVerifiedAddr(stopOrderArr);
          setAddLegBtnTitle("Update");
          
        }
        setTimeout( async () => {
          
          if(editRowData.addressInfo.trips.length > 1) //Set new broker mode depending on multi/single trip
          {
            let BrokerMode = GetBrokerModeByAffiliateID();
            if(editRowData.addressInfo.trips[discoveredID].details[0].tripInfo.FSBrokerMode != undefined || editRowData.addressInfo.trips[discoveredID].details[0].tripInfo.FSBrokerMode != null){
              BrokerMode = editRowData.addressInfo.trips[discoveredID].details[0].tripInfo.FSBrokerMode;
            }

            setBrokerModes(prevState=>({...prevState, brokerMode: (BrokerMode || 0)}));
            let pickData = editRowData.addressInfo.trips[discoveredID].details[0];
            let fsData = (FundingSourceData[parseInt(editRowData.generalInfo.requestAffiliateID)] && 
              FundingSourceData[parseInt(editRowData.generalInfo.requestAffiliateID)] !== undefined ? 
              JSON.parse(FundingSourceData[parseInt(editRowData.generalInfo.requestAffiliateID)]) : []
            );
            let fsSelected = (fsData.length > 0 ? fsData.find(item => parseInt(item.FID) === parseInt(pickData.paymentInfo.fundingSourceID)) : 0);
            handleManualAmountOnFSChange(fsSelected, parseInt(pickData.paymentInfo.fundingSourceID));
            setAffiliateAbbr(fsSelected.AffiliateAbbrevation);
            if(parseInt(pickData.paymentInfo.paymentTypeID) === 2 || parseInt(pickData.paymentInfo.iActualPaymentTypeID) === 2)
            {
              setShowCCBtn(true);
            }
          }
          else
          {
            let pickData = editRowData.addressInfo.trips[0].details[0];
            if(parseInt(pickData.paymentInfo.paymentTypeID) === 2 || parseInt(pickData.paymentInfo.iActualPaymentTypeID) === 2)
            {
              setShowCCBtn(true);
            }
            let fsData = (FundingSourceData[parseInt(selectedAff)] && 
              FundingSourceData[parseInt(selectedAff)] !== undefined ? 
              JSON.parse(FundingSourceData[parseInt(selectedAff)]) : []
            );
            //let fsSelected = (fsData.length > 0 ? fsData.find(item => parseInt(item.FID) === parseInt(tripData.details[0].paymentInfo.fundingSourceID)) : 0);

            let fsSelected = fsData.length > 0 ? fsData.find(item =>parseInt(item.FID) === parseInt(tripData.details[0].paymentInfo.fundingSourceID) ) || fsData[0]: 0;
            setBrokerModes(prevState=>({...prevState, brokerMode: (fsSelected === 0 ? 0 : fsSelected.BrokerMode)}));
            handleManualAmountOnFSChange(fsSelected, parseInt(tripData.details[0].paymentInfo.fundingSourceID));
            setAffiliateAbbr(fsSelected.AffiliateAbbrevation);
          }
          setIsSchTimeFieldDisabled(false);

          //Test section
          let fsData = (FundingSourceData[parseInt(selectedAff)] && 
            FundingSourceData[parseInt(selectedAff)] !== undefined ? 
            JSON.parse(FundingSourceData[parseInt(selectedAff)]) : []
          );

          //Test added
          let fsSelected = fsData.length > 0 ? fsData.find(item =>parseInt(item.FID) === parseInt(tripData.details[0].paymentInfo.fundingSourceID) ) || fsData[0]: 0;
            //Test added
            //Test section
          //setFSSelected(parseInt(tripData.details[0].paymentInfo.fundingSourceID));
          setFSSelected(parseInt(tripData.details[0].paymentInfo.fundingSourceID));

          setCopayFSSelected(parseInt(tripData.details[0].paymentInfo.iCopayFundingSourceID));
          setCopayPayTypeSelected(tripData.details[0].paymentInfo.iActualPaymentTypeID);
          setPaySelected(tripData.details[0].paymentInfo.paymentTypeID);
          setMapData(tripLatLng);
          let tempArrLoop = (editRowData.addressInfo.trips.length > 1 ? editRowData.addressInfo.trips : [0])
          for(let j = 0; j < tempArrLoop.length; j++)
          {
            if(tempArrLoop.length === 1)
            {
              if(parseInt(tripData.details[0].paymentInfo.paymentTypeID) === 2 || parseInt(tripData.details[0].paymentInfo.iActualPaymentTypeID) === 2) { 
                setCardInfo(prevState=>({...prevState, gateID: tripData.details[0].tripInfo.gateID})); 
                
                await GetiCCInfo(parseInt(editRowData.riderInfo.id), tripData.details[0].tripInfo.gateID, parseInt(tripData.details[0].tripInfo.receivingAffiliateID));
                await GetCCTransInfo(parseInt(tripData.details[0].tripInfo.refID), 0);
              }
            }
            else
            {
              let pickData = tempArrLoop[j].details[0];
              if(parseInt(pickData.paymentInfo.paymentTypeID) === 2 || parseInt(pickData.paymentInfo.iActualPaymentTypeID) === 2) { 
                await GetiCCInfo(parseInt(editRowData.riderInfo.id), pickData.tripInfo.gateID, parseInt(pickData.tripInfo.receivingAffiliateID), j, discoveredID);
                await GetCCTransInfo(parseInt(pickData.tripInfo.refID), 0, j);
              }
            }
            
          }
          setManualDataOverwrite(prevState=>({...prevState, price:tripData.details[0].estimatedInfo.billableAmount, fare:tripData.details[0].estimatedInfo.estimatedCost}));

        }, 500); //settimeout is required to make sure changes are correctly populated on map, rider ID, pay, and FS
        if(pickLatLng.current !== "" && dropLatLng.current !== "")
        { //Handle fare or rcz verification depending on micro / para
          if(type === "API") { handleInitialFareAPIs(tripData.details[0].paymentInfo.fundingSourceID, editRowData.generalInfo.requestAffiliateID, tripData.details[0].tripInfo.classOfServiceID, [editRowData], tripData);}
          
          if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2))
          {
            wrapperHandleRCZVerification("PU", 
              (tripData.details[0].addressDetails.address + ", " + tripData.details[0].addressDetails.city + ", " + tripData.details[0].addressDetails.state + " " + tripData.details[0].addressDetails.zip),
              (lastTripData.addressDetails.address + ", " + lastTripData.addressDetails.city + ", " + lastTripData.addressDetails.state + " " + lastTripData.addressDetails.zip));
          }
        }
      }
      else
      {
        setModalHeaderText("Edit Info Error");
        setModalBodyHTML("There is an error while editing the trip, please try again or contact administrator.");
        setModalFooterHTML(
          <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
            OK
          </Button>
        );
        setShowDynamicModal(true);
      }
    }
    catch(err){console.log(err);}
  };

  const handleContextTripLoad = async(rowDataEdit, type = "", copy = false) => {
    try{
      
      let tempData = [];
      let editRowData = (type === "API" ? tempData : rowDataEdit); //Set accurate data to be used for populated fields on call taker 2.0
      if(editRowData && editRowData !== "" && typeof editRowData === 'object') //Proceed only when data is not invalid
      {
        PersistStorage.save("rowDataEditTrip", editRowData, 999, true);
        if(bookBtnRef.current)
        {
          if(copy)
            setSubmitBtnTitle("Book"); //If an active trip is being copied, dont make it update
          else
            setSubmitBtnTitle("Update");
        }
        else
        {
          if(copy){
            setSubmitParatransitBtnTitle("Book");
            mapPointPickupSelection.current = {data: {address: editRowData.addressInfo.trips[0].details[0].addressDetails.address, POI: ""}};
            mapPointPickupSelection.current["Type"] = "poi";
            mapPointDropoffSelection.current = {data: {address: editRowData.addressInfo.trips[0].details[1].addressDetails.address, POI: ""}};
            mapPointDropoffSelection.current["Type"] = "poi";
          }
          else
            setSubmitParatransitBtnTitle("Update");
        }
        PersistStorage.save("clientInfo", editRowData, 99, true);
        let tripData = null;
        let selectedConfirmationNo = ""
        if(Array.isArray(rowDataEdit)) //if from active trips
        {
          selectedConfirmationNo = parseInt(rowDataEdit[0].iRefId);
          for(let k = 0; k < editRowData.addressInfo.trips.length; k++)
          {
            if(parseInt(rowDataEdit[0].iRefId) === parseInt(editRowData.addressInfo.trips[k].details[0].tripInfo.refID))
            {
              tripData = editRowData.addressInfo.trips[k];
            }
          }
        }
        else //from main grid trips d 2.0
        {
          if(typeof(rowData.current[0]) !== 'undefined')
          {
            selectedConfirmationNo = parseInt(rowData.current[0].iRefID);
          }
          else{
            selectedConfirmationNo = "";
          }
          for(let k = 0; k < editRowData.addressInfo.trips.length; k++)
          {
            if(typeof(rowData.current[0]) !== 'undefined' && parseInt(rowData.current[0].iRefID) === parseInt(editRowData.addressInfo.trips[k].details[0].tripInfo.refID))
            {
              tripData = editRowData.addressInfo.trips[k];
            }
          }
        }

        tripData = (tripData ? tripData : editRowData.addressInfo.trips[0]); //Getting accurate addressInfo details for populating data

        try {
          if(tripData.details[0].dateInfo.isWillCall == true){
            ResetEnableFutureDateValiation();
          }
          else{
            setEnableFutureDateValidation(true);
          }
        } catch (error) {
          
        }
        setAddrApartmentInfo(prev => ({
                ...prev,
                ['pick']: tripData.details[0].addressDetails.apartmentNo ?? ''
            }));
        setAddrApartmentInfo(prev => ({
                ...prev,
                ['drop']: tripData.details[1].addressDetails.apartmentNo ?? ''
            }));

        if(tripData.details[0].tripInfo.refID > 0)
          setConfirmationNo(tripData.details[0].tripInfo.refID);
        if(editRowData.scheduleInfo && editRowData.scheduleInfo.scheduleItem && editRowData.scheduleInfo.scheduleItem.length > 0) //In case of multischedule trips...
        { //Building main data dict of multischedule along with displayed data dict
          let mainDataDict = { 
            MultiScheduleIdentifier: null, 
            vPreSch: (tripData.details[0].tripInfo.preSchedule ? tripData.details[0].tripInfo.preSchedule : ""),
            Exclusions: (editRowData.exclusions ? editRowData.exclusions : [])
          };
          let scheduleItemsArr = [];
          let daysArr = ["N/A", "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
          let displayedDataArr = [];
          // Use a Set to track added dates
          const uniqueDates = new Set();
          for(let j = 0; j < editRowData.scheduleInfo.scheduleItem.length; j++)
          {
            let scheduleInfo = editRowData.scheduleInfo.scheduleItem[j];
            scheduleItemsArr.push({
              dayName: (scheduleInfo.dayName !== ""? scheduleInfo.dayName : daysArr[(scheduleInfo.dayNumber)]),
              dayNumber: scheduleInfo.dayNumber,
              startTime: scheduleInfo.startTime,
              apptTime: scheduleInfo.apptTime,
              endTime: scheduleInfo.endTime,
              bApptTime: scheduleInfo.bApptTime,
              willcall: scheduleInfo.willcall,
              breturnleg: scheduleInfo.breturnleg,
              _returnmultischedule: {
                dayName: scheduleInfo["_returnmultischedule"].dayName,
                dayNumber: scheduleInfo["_returnmultischedule"].dayNumber,
                startTime: scheduleInfo["_returnmultischedule"].startTime,
                endTime: scheduleInfo["_returnmultischedule"].endTime,
                apptTime: scheduleInfo["_returnmultischedule"].apptTime,
                bApptTime: scheduleInfo["_returnmultischedule"].bApptTime,
                willcall: scheduleInfo["_returnmultischedule"].willcall,
                _returnmultischedule: scheduleInfo["_returnmultischedule"]._returnmultischedule,
                breturnleg: scheduleInfo.breturnleg,
              }
            });
            let dateVal = (scheduleInfo.breturnleg ? 
              (scheduleInfo["_returnmultischedule"].startTime.includes("1900") ? scheduleInfo.startTime.split("T")[0] : 
              scheduleInfo["_returnmultischedule"].startTime.split("T")[0]) : scheduleInfo.startTime.split("T")[0]
            );
            let newDateVal = dateVal.split("-")[1]+"/"+dateVal.split("-")[2]+"/"+dateVal.split("-")[0];
            let PUtimeVal = (scheduleInfo.startTime && scheduleInfo.startTime.split("T")[1] !== "00:00:00"? scheduleInfo.startTime.split("T")[1].slice(0, 5):"09:00");
            let apptTime = (scheduleInfo.apptTime && scheduleInfo.apptTime.split("T")[1] !== "00:00:00"? scheduleInfo.apptTime.split("T")[1].slice(0, 5):"");
            let returnApptTime = (scheduleInfo._returnmultischedule.apptTime && scheduleInfo._returnmultischedule.apptTime.split("T")[1] !== "00:00:00"? 
              scheduleInfo._returnmultischedule.apptTime.split("T")[1].slice(0, 5) : "");
            let returnTime = (scheduleInfo._returnmultischedule.startTime && scheduleInfo._returnmultischedule.startTime.split("T")[1] !== "00:00:00"? 
            scheduleInfo._returnmultischedule.startTime.split("T")[1].slice(0, 5) : "09:00");
            let isDateExcluded = (editRowData.exclusions && editRowData.exclusions.length > 0 ? 
              editRowData.exclusions.some(item=>{return item.exclusionDate.includes(dateVal);}) : false);

            let dayIndex = 0;
            if(daysArr[scheduleInfo.dayNumber] === "Sunday")
            {
              dayIndex = 0;
            }
            else if(daysArr[scheduleInfo.dayNumber] === "Monday")
            {
              dayIndex = 1;
            }
            else if(daysArr[scheduleInfo.dayNumber] === "Tuesday")
            {
              dayIndex = 2;
            }
            else if(daysArr[scheduleInfo.dayNumber] === "Wednesday")
            {
              dayIndex = 3;
            }
            else if(daysArr[scheduleInfo.dayNumber] === "Thursday")
            {
              dayIndex = 4;
            }
            else if(daysArr[scheduleInfo.dayNumber] === "Friday")
            {
              dayIndex = 5;
            }
            else if(daysArr[scheduleInfo.dayNumber] === "Saturday")
            {
              dayIndex = 6;
            }
            let days = (editRowData.scheduleInfo.to && editRowData.scheduleInfo.to.includes("1900") ? 
              findDaysInRange(editRowData.scheduleInfo.from.split("T")[0], editRowData.scheduleInfo.infinitetodate.split("T")[0], dayIndex) : 
              findDaysInRange(editRowData.scheduleInfo.from.split("T")[0], editRowData.scheduleInfo.to.split("T")[0], dayIndex)
            );

            if(days.length > 0)
            {
             
              days.forEach(day => {
                let tempDate = day.split("/")[2]+"-"+day.split("/")[0]+"-"+day.split("/")[1];
                if(!uniqueDates.has(day))
                {
                  uniqueDates.add(day);
                  isDateExcluded = (editRowData.exclusions && editRowData.exclusions.length > 0 ? 
                    editRowData.exclusions.some(item=>{return item.exclusionDate.includes(tempDate);}) 
                    : false
                  );
                  displayedDataArr.push({
                    Day: daysArr[scheduleInfo.dayNumber], // Assuming `day` is the index of the day in `daysArr`
                    Date: day, // Use appropriate date format for each `day` from `days` array
                    Checked: true,
                    WillCall: scheduleInfo.willcall,
                    Appt: apptTime,
                    PUTime: PUtimeVal,
                    isReturnTrip: scheduleInfo.breturnleg ? scheduleInfo.breturnleg : false,
                    ReturnWillCall: scheduleInfo._returnmultischedule.willcall ? scheduleInfo._returnmultischedule.willcall : false,
                    ReturnAppt: returnApptTime,
                    ReturnTime: returnTime,
                    schType: isDateExcluded ? "exc" : "sch",
                    isHoliday: false
                  });
                }
              });
              
            }
            else
            {
              displayedDataArr.push({
                Day:daysArr[scheduleInfo.dayNumber], Date:newDateVal, Checked:true, WillCall:scheduleInfo.willcall, Appt:apptTime, PUTime:PUtimeVal, 
                isReturnTrip:(scheduleInfo.breturnleg? scheduleInfo.breturnleg: false), 
                ReturnWillCall:(scheduleInfo._returnmultischedule.willcall? scheduleInfo._returnmultischedule.willcall: false), 
                ReturnAppt:returnApptTime, ReturnTime:returnTime, schType:(isDateExcluded ? "exc":"sch"), 
                isHoliday:false
              });
            }
            
          }
          displayedDataArr.sort((a, b) => {
            let correctDateA = (a.Date.split('/')[2] +"-"+ a.Date.split('/')[0] +"-"+ a.Date.split('/')[1]);
            let correctDateB = (b.Date.split('/')[2] +"-"+ b.Date.split('/')[0] +"-"+ b.Date.split('/')[1]);
            const dateA = new Date(correctDateA+" 00:00:00"); 
            const dateB = new Date(correctDateB+" 00:00:00");
            return dateB - dateA; // Sort latest to earliest
          });
          mainDataDict = {...mainDataDict, Schedule:{
            from: editRowData.scheduleInfo.from, 
            to: editRowData.scheduleInfo.to, 
            infinitetodate: editRowData.scheduleInfo.infinitetodate,
            ScheduleItem: scheduleItemsArr}
          };
          
          let managedData = [
            {Day:"Sunday", Date:"", Checked:false, WillCall:false, Appt:"", PUTime:"09:00", isReturnTrip:false, ReturnWillCall:false, ReturnAppt:"", ReturnTime:"09:00", schType:"sch", isHoliday:false},
            {Day:"Monday", Date:"", Checked:false, WillCall:false, Appt:"", PUTime:"09:00", isReturnTrip:false, ReturnWillCall:false, ReturnAppt:"", ReturnTime:"09:00", schType:"sch", isHoliday:false},
            {Day:"Tuesday", Date:"", Checked:false, WillCall:false, Appt:"", PUTime:"09:00", isReturnTrip:false, ReturnWillCall:false, ReturnAppt:"", ReturnTime:"09:00", schType:"sch", isHoliday:false},
            {Day:"Wednesday", Date:"", Checked:false, WillCall:false, Appt:"", PUTime:"09:00", isReturnTrip:false, ReturnWillCall:false, ReturnAppt:"", ReturnTime:"09:00", schType:"sch", isHoliday:false},
            {Day:"Thursday", Date:"", Checked:false, WillCall:false, Appt:"", PUTime:"09:00", isReturnTrip:false, ReturnWillCall:false, ReturnAppt:"", ReturnTime:"09:00", schType:"sch", isHoliday:false},
            {Day:"Friday", Date:"", Checked:false, WillCall:false, Appt:"", PUTime:"09:00", isReturnTrip:false, ReturnWillCall:false, ReturnAppt:"", ReturnTime:"09:00", schType:"sch", isHoliday:false},
            {Day:"Saturday", Date:"", Checked:false, WillCall:false, Appt:"", PUTime:"09:00", isReturnTrip:false, ReturnWillCall:false, ReturnAppt:"", ReturnTime:"09:00", schType:"sch", isHoliday:false}
          ];
          
          let updatedManagedData = managedData.map(item => {
            const matchedDay = displayedDataArr.find(displayedDay => displayedDay.Day === item.Day);
            return (matchedDay ? matchedDay : item)
          });
          
          if(editRowData.scheduleInfo.to && editRowData.scheduleInfo.to.includes("1900")) //never expire = true
          {
            setScheduleJSON(
              { 
                mainData: mainDataDict, 
                multiSchData:{managed:updatedManagedData, displayed:displayedDataArr}, 
                range: {
                  from: editRowData.scheduleInfo.from.split("T")[0], 
                  to: editRowData.scheduleInfo.infinitetodate.split("T")[0]
                }, 
                neverExpire:true
              }
            );
          }
          else //never expire = false
          {
            setScheduleJSON(
              {
                mainData: mainDataDict, 
                multiSchData: {managed:updatedManagedData, displayed:displayedDataArr}, 
                range: {
                  from: editRowData.scheduleInfo.from.split("T")[0], 
                  to: editRowData.scheduleInfo.to.split("T")[0]
                }, 
                neverExpire:false
              }
            );
          }
          
        }

        let attrSelection = AttributeData ? AttributeData.filter((item,index)=> {return parseInt(item.iAttrATSPID) === parseInt(editRowData.generalInfo.requestAffiliateID) && parseInt(item.iAttrType) !== 10}) : [];
        let attrOptionsMultiSel = attrSelection && attrSelection.length > 0 ? attrSelection.map((item)=>{
          let dict = {};
          dict.id = item.ID;
          dict.name = item.Title;
          return dict;
        }).sort((a, b) => a.name.localeCompare(b.name)) : [];
        let providedAttrArray = tripData.details[0].tripInfo.entityAttributes;
        let groupSelected = [];
        for(let k = 0; k < attrOptionsMultiSel.length; k++)
        {
          if(providedAttrArray.includes(String(attrOptionsMultiSel[k].id)))
          {
            groupSelected.push({id:attrOptionsMultiSel[k].id, name:attrOptionsMultiSel[k].name});
          }
        }
        SetAttributesFilterMultiSelect({ ...AttributesFilterMultiSelect, ...{options: attrOptionsMultiSel,
          selectedValues:(tripData.details[0].tripInfo.entityAttributes.length !== 0 ? groupSelected : [])}}
        ); //Getting the correct attributes auto-selected (if any) 
        let attributesDesc = (tripData.details[0].tripInfo.entityAttributes ? (tripData.details[0].tripInfo.entityAttributes.split(",").map((num) => parseInt(num.trim(), 10)).filter((num) => !isNaN(num)) ) : []);
        setSelectedTripAttr(attributesDesc);
        setSelectedTripType(tripData.details[0].tripInfo.callType);
        addressInfoDetails.current.pick = {city: tripData.details[0].addressDetails.city, state: tripData.details[0].addressDetails.state, zip: tripData.details[0].addressDetails.zip};
        if(tripData.details.length === 2)
        {
          addressInfoDetails.current.drop = {city: tripData.details[1].addressDetails.city, state: tripData.details[1].addressDetails.state, zip: tripData.details[1].addressDetails.zip};
        }
        else
        {
          let dataLength = tripData.details.length;
          let dropData = tripData.details[(dataLength - 1)];
          addressInfoDetails.current.drop = {city: dropData.addressDetails.city, state: dropData.addressDetails.state, zip: dropData.addressDetails.zip};
        }
        const pickupDate = tripData?.details?.[0]?.dateInfo?.pickupDate;
        if (pickupDate && typeof pickupDate === 'string' && pickupDate.toLowerCase() !== "will call") {
          let timeTemp = (
            pickupDate.includes("T") && pickupDate.split("T")[1] !== "00:00:00"
              ? pickupDate.split("T")[1]
              : ""
          );

          let timeParts = timeTemp !== "" ? timeTemp.split(":") : "";
          setSchTime(timeParts !== "" ? `${timeParts[0]}:${timeParts[1]}` : "");
        } else {
          // handle missing or invalid pickupDate if needed
          setSchTime("");
        }
        //Method to identify if the trip is will call from given data:
        const date1 = (tripData.details[0].dateInfo.isWillCall && 
          tripData.details[0].dateInfo.willCallDay !== ""? 
          new Date(tripData.details[0].dateInfo.willCallDay) : new Date("1900-01-01T00:00:00"));
        const date2 = new Date("2000-01-01T00:00:00"); 
        if(date1 > date2 && (tripData.details[0].dateInfo.pickupDate && tripData.details[0].dateInfo.pickupDate === "1900-01-01T00:00:00"))
        {
          setWillCall(true);
        }
        else
        {
          setWillCall(false);
        }
        let date = (tripData.details[0].dateInfo.isWillCall ? (tripData.details[0].dateInfo.willCallDay.includes("T") 
        ? tripData.details[0].dateInfo.willCallDay.split("T")[0] : tripData.details[0].dateInfo.willCallDay.split(" ")[0])
        :(tripData.details[0].dateInfo.pickupDate.includes("1900") ? editRowData.scheduleInfo.from.split("T")[0]:(tripData.details[0].dateInfo.pickupDate.includes("T") ? 
        tripData.details[0].dateInfo.pickupDate.split("T")[0] : tripData.details[0].dateInfo.pickupDate.split(" ")[0])));
        setSelectedDateSchTime(date);
        setAppointmentTime((typeof tripData.details[0].dateInfo.apptTime === 'string' 
          && tripData.details[0].dateInfo.apptTime.includes("T") && 
          tripData.details[0].dateInfo.apptTime.split("T")[1] !== "00:00:00" ? 
          tripData.details[0].dateInfo.apptTime.split("T")[1]:""));
        setTripStatus((tripData.details[0].tripInfo.virtualRoute === ""?"Un-Routed":"Routed"));
        setSelectedVehType((tripData.details[0].vehicleInfo.vehicleTypeId === -1 || 
          tripData.details[0].vehicleInfo.vehicleTypeId === 0 ? "VT" : 
          parseInt(tripData.details[0].vehicleInfo.vehicleTypeId))
        );
        //Setting the insurance and additional details and communication methods
        setClientSummary(prevState=>({...prevState, totalCalls:0, totalNS:0, 
          totalCancels:0, lastCall:"",
          tripDistance:tripData.details[0].estimatedInfo.estimatedDistance, TripDuration:tripData.details[0].estimatedInfo.estimatedTime, TripFare:tripData.details[0].estimatedInfo.estimatedCost, 
          TripCopay:tripData.details[0].estimatedInfo.coPay
        }));
        setMedID((editRowData.riderInfo.riderID ? editRowData.riderInfo.riderID : "")); //Rider ID/Medical ID
        setInsuranceName(editRowData.riderInfo.pickupPerson.trim()); 
        setInsuranceSSN(0); 
        setAccountNumber(editRowData.riderInfo.id);
        setInsuranceAuthCode(0); 
        setCopayAmount(tripData.details[0].estimatedInfo.coPay);
        setClientJob((tripData.details[0].tripInfo.ext2 && tripData.details[0].tripInfo.ext2 !== "" ? tripData.details[0].tripInfo.ext2 : ""));
        setClientEmail(tripData.details[0].tripInfo.customerEmail);
        setRCType({phoneType:tripData.details[0].tripInfo.isRollingCallTypePhone, emailType:tripData.details[0].tripInfo.isRollingCallTypeEmail, SMSType:tripData.details[0].tripInfo.isRollingCallTypeSMS});
        setRiderName(editRowData.riderInfo.pickupPerson);
        setPaymentAdditionalInfo(tripData.details[0].tripInfo.extraInfo);
        setPhone(("+1"+editRowData.riderInfo.phoneNo.replaceAll("-","")));
        phoneRef.current.disabled = true;
        clientNameCheckRef.current.disabled = true;
        clientMedIDCheckRef.current.disabled = true;
        if(tripData.details[0].tripInfo.callBackInfo !== "")
        {
          setCallBackPhone(("+1"+tripData.details[0].tripInfo.callBackInfo.replaceAll("-","")));
        }
        let _totalChildren = 0;
        if(tripData.details[0].passengerInfo.children != undefined && tripData.details[0].passengerInfo.children?.length > 0){
          _totalChildren = tripData.details[0].passengerInfo.children.length;
        }


        let ambPassengerCount = tripData.details[0].passengerInfo.totalPassengers;
        let _totalWCCount = tripData.details[0].passengerInfo.totalWheelChairs;

        let data = {Primary:tripData.details[0].passengerInfo.primary, 
          PCA: tripData.details[0].passengerInfo.pca, Guests:tripData.details[0].passengerInfo.guests, 
          Children: tripData.details[0].passengerInfo.children};

        //@@@@@@@@@@@ Section to Read counts When Mobility Attributes@@@@@@@@@@@//

        if(refMobilityAttributeOptions.current != undefined && refMobilityAttributeOptions.current != [] 
          && refMobilityAttributeOptions.current != null && refMobilityAttributeOptions.current?.length > 0 && 
          (transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2)){

          let Mobility_TotalAdultsCount = 0;
          let Mobility_TotalChildrenCount = 0;

          let PCACount = 0;
          let GuestsCount = 0;
          let ChildrenCount = 0;

          if(tripData.details[0].passengerInfo.primary != undefined && tripData.details[0].passengerInfo.primary?.selectedAttribute) {
            Mobility_TotalAdultsCount += 1;
          }
          if(tripData.details[0].passengerInfo.pca?.length >= 0){
            PCACount = tripData.details[0].passengerInfo.pca?.length;
            Mobility_TotalAdultsCount += PCACount;
          }
          if(tripData.details[0].passengerInfo.guests?.length >= 0){
            GuestsCount = tripData.details[0].passengerInfo.guests?.length;
            Mobility_TotalAdultsCount += GuestsCount;
          }
          if(tripData.details[0].passengerInfo.children?.length >= 0){
            Mobility_TotalChildrenCount = tripData.details[0].passengerInfo.children?.length;
          }

          ////@@@@@@@@@@@ Section to Read counts When Mobility Attributes@@@@@@@@@@@//
          let wcCount = getMobilityAttributes(tripData.details[0]);
          setPassengerTypeCount(
            {
              ambPass: Mobility_TotalAdultsCount,
              totalWC: parseInt(wcCount), 
              totalSA: parseInt(tripData.details[0].passengerInfo.serviceAnimalCount),
              total: parseInt(Mobility_TotalAdultsCount) + Mobility_TotalChildrenCount, 
              totalChildren: parseInt(Mobility_TotalChildrenCount)
          });
          
          
          setMobilityPassengers({...mobilityPassengers,  passenger:parseInt(Mobility_TotalAdultsCount) , children: _totalChildren});
          setMobilityDbData(data);
          setMobilitySavedData(structuredClone(data));
        }
        else{
          setPassengerTypeCount(
            {
              ambPass: ambPassengerCount,
              totalWC: parseInt(_totalWCCount), 
              totalSA: parseInt(tripData.details[0].passengerInfo.serviceAnimalCount),
              total:parseInt(ambPassengerCount) + parseInt(_totalWCCount), 
              totalChildren: 0
          });
        }


        //Setting address data accordingly
        setPickupAddr(tripData.details[0].addressDetails.address + ", " + tripData.details[0].addressDetails.city + ", " + tripData.details[0].addressDetails.state + " " + tripData.details[0].addressDetails.zip);
        let editAddressData = tripData.details;
        let lastTripData = (tripData.details[1].stopType === "dropoff" ? tripData.details[1] : tripData.details[(editAddressData.length - 1)]);
        let genderInitialChecks = (tripData.details[0].driverInfo.preferedDriverGender && tripData.details[0].driverInfo.preferedDriverGender !== "" 
          && tripData.details[0].driverInfo.preferedDriverGender !== -1
        );
        let languageInitialChecks = (tripData.details[0].driverInfo.preferedLanguage && tripData.details[0].driverInfo.preferedLanguage !== "" 
          && tripData.details[0].preferedLanguage !== -1
        );
        const areAddressPhonesGiven = {pick: (tripData.details[0].addressDetails.phone && tripData.details[0].addressDetails.phone !== '') , drop: (lastTripData.addressDetails.phone && lastTripData.addressDetails.phone !== '')};
        
        setDropAddr(lastTripData.addressDetails.address + ", " + lastTripData.addressDetails.city + ", " + lastTripData.addressDetails.state + " " + lastTripData.addressDetails.zip);
        dropLatLng.current = lastTripData.addressDetails.latitude && parseFloat(lastTripData.addressDetails.latitude) !== 0? lastTripData.addressDetails.latitude+","+lastTripData.addressDetails.longitude:"";
        pickLatLng.current = tripData.details[0].addressDetails.latitude && parseFloat(tripData.details[0].addressDetails.longitude) !== 0? tripData.details[0].addressDetails.latitude+","+tripData.details[0].addressDetails.longitude:"";
        
        setPickExtraInfo(tripData.details[0].addressDetails.remarks);
        setDropExtraInfo(lastTripData.addressDetails.remarks);
        setPickPOI(tripData.details[0].addressDetails.poiName); //POI set if any
        setDropPOI(lastTripData.addressDetails.poiName);
        setAddrPhoneInfo({pick: (areAddressPhonesGiven.pick ? ("+1"+tripData.details[0].addressDetails.phone.replaceAll("-","")) : null), 
          drop: (areAddressPhonesGiven.drop ? ("+1"+lastTripData.addressDetails.phone.replaceAll("-","")) : null)
        });

        setMobilityChecks({vehTypeCheck:tripData.details[0].vehicleInfo.onlyPreferedVType, vehNumCheck:tripData.details[0].vehicleInfo.onlyPreferedVehicle, 
          driverNumCheck:tripData.details[0].driverInfo.onlyPreferedDriver, genderCheck:tripData.details[0].driverInfo.onlyPreferedDriverGender,
          languageCheck:tripData.details[0].driverInfo.onlyPreferedDriverLanguage
        });
        setMobilityDetails({totalVeh:1, vehTypeMin:0, vehNumMin:tripData.details[0].vehicleInfo.vehicleNoTimeDiff, 
          driverNumMin:tripData.details[0].driverInfo.driverNoTimeDiff, genderMin:tripData.details[0].driverInfo.genderTimeDiff, 
          languageMin:tripData.details[0].driverInfo.langTimeDiff
        });
        setSelectedGender((genderInitialChecks ? tripData.details[0].driverInfo.preferedDriverGender : "Gender"));
        setSelectedLanguage((languageInitialChecks ? tripData.details[0].driverInfo.preferedLanguage : "Language"));
        let tripLatLng = []; 
        if(pickLatLng.current !== "" && dropLatLng.current !== "")
        {
          tripLatLng.push(
            {lat:parseFloat(pickLatLng.current.split(",")[0]),
              lng: parseFloat(pickLatLng.current.split(",")[1]), Type:"PU", 
              name:(editRowData.riderInfo.pickupPerson), address: (tripData.details[0].addressDetails.address + ", " + tripData.details[0].addressDetails.city + ", " + tripData.details[0].addressDetails.state + " " + tripData.details[0].addressDetails.zip)
            },
            {lat:parseFloat(dropLatLng.current.split(",")[0]),
              lng: parseFloat(dropLatLng.current.split(",")[1]), Type:"DO", 
              name:(editRowData.riderInfo.pickupPerson), address: (lastTripData.addressDetails.address + ", " + lastTripData.addressDetails.city + ", " + lastTripData.addressDetails.state + " " + lastTripData.addressDetails.zip)
            },
          ); //Setting details for map markers
        }
        let discoveredID = 0;
        let trimmedName = editRowData.riderInfo.pickupPerson.trim();
        let nameFormatForSearch = (trimmedName.includes(" ") ? (trimmedName.split(" ")[1] + ", " + trimmedName.split(" ")[0]) : trimmedName);
        if(parseInt(tripData.details[0].paymentInfo.paymentTypeID) === 2 || parseInt(tripData.details[0].paymentInfo.iActualPaymentTypeID) === 2)
        {
          //await handleSearchCustomerName(nameFormatForSearch, false, (editRowData.riderInfo.id ? editRowData.riderInfo.id : 0), false);
        }
        
        if(editRowData.addressInfo.trips.length > 1) //In case of multi-trip, save and show correctly selected trip to user on stop order
        {
          let tripDetail = editRowData.addressInfo.trips;
          let stopOrderArr = [];
          let stopDetailsTrackerArr = [];
          for(let k = 0; k < tripDetail.length; k++)
          {
            stopDetailsTrackerArr.push(
              {
                stopNo:(k+1), 
                distance: tripDetail[k].details[0].estimatedInfo.estimatedDistance,
                duration: tripDetail[k].details[1].estimatedInfo.estimatedDistance
              }
            );
          }
          for(let i = 0; i < tripDetail.length; i++)
          {
            let pickData = tripDetail[i].details[0];
            let dropData = (tripDetail[i].details.length === 2 ? tripDetail[i].details[1] : tripDetail[i].details[(tripDetail[i].details.length - 1)]);
            let pickAddress = pickData.addressDetails.address + ", "+ pickData.addressDetails.city + ", " + pickData.addressDetails.state + " " + pickData.addressDetails.zip;
            let dropAddress = dropData.addressDetails.address + ", "+ dropData.addressDetails.city + ", " + dropData.addressDetails.state + " " + dropData.addressDetails.zip;
            let dateGiven = (pickData.dateInfo.isWillCall ? pickData.dateInfo.willCallDay.split("T")[0] : formatDate(pickData.dateInfo.pickupDate.split("T")[0]));
            let timeGiven = (pickData.dateInfo.isWillCall ? "Will Call" : pickData.dateInfo.pickupDate.split("T")[1]);
            let correctDate = (dateGiven.includes("-") ? formatDate(dateGiven) : dateGiven);
            let ambulatoryPassCount = parseInt(pickData.passengerInfo.totalPassengers) - parseInt(pickData.passengerInfo.totalWheelChairs);
            let fareEstimateDataDict = {copay: (pickData.paymentInfo.CopayPrice && pickData.paymentInfo.CopayPrice !== ""? parseInt(pickData.paymentInfo.CopayPrice) : 0), 
              walletID: (pickData.tripInfo.selfWalletID && pickData.tripInfo.selfWalletID !== ""? parseInt(pickData.tripInfo.selfWalletID) : 0), 
              promo: (pickData.tripInfo.Promocode || ""), eaasJSON: (pickData.tripInfo.EaasJSONResp || ""), displayMessage: "", verifyStatus: ""
            };
            let attributesDesc = (pickData.tripInfo.entityAttributes ? (pickData.tripInfo.entityAttributes.split(",").map((num) => parseInt(num.trim(), 10)).filter((num) => !isNaN(num)) ) : []);
            
            let BrokerMode = GetBrokerModeByAffiliateID();
            if(pickData.tripInfo.FSBrokerMode != undefined && pickData.tripInfo.FSBrokerMode != ""){
              BrokerMode = pickData.tripInfo.FSBrokerMode;
            }

            let brokerDict = {brokerMode: (BrokerMode || 0) , globalBrokerMode: (BrokerMode || 0)};

            let addressExtraDetailsVal = {pick: {state:pickData.addressDetails.state, city: pickData.addressDetails.city, zip: pickData.addressDetails.zip}, 
              drop: {state:dropData.addressDetails.state, city:dropData.addressDetails.city, zip:dropData.addressDetails.zip}};
            stopOrderArr.push({pickAddr: pickAddress, dropAddr: dropAddress, pickPOI: pickData.addressDetails.poiName, dropPOI: dropData.addressDetails.poiName,
                date: correctDate, email: pickData.tripInfo.customerEmail,
                time: timeGiven, distance: pickData.estimatedInfo.estimatedDistance, duration: pickData.estimatedInfo.estimatedTime, fare: pickData.estimatedInfo.estimatedCost, 
                copay: pickData.estimatedInfo.coPay, willCall: pickData.dateInfo.isWillCall, 
                apptTime: (pickData.dateInfo.isWillCall? "Will Call":(!pickData.dateInfo.apptTime.includes("1900")? pickData.dateInfo.apptTime.split("T")[1] : "")), 
                notes: pickData.tripInfo.agentInstructions, phone: editRowData.riderInfo.phoneNo, 
                puNotes: pickData.addressDetails.remarks, doNotes: dropData.addressDetails.remarks, riderName: editRowData.riderInfo.pickupPerson, 
                passCount: {ambPass:ambulatoryPassCount,totalWC:pickData.passengerInfo.totalWheelChairs,
                  totalSA:pickData.passengerInfo.serviceAnimalCount, total:pickData.passengerInfo.totalPassengers}, callBackPhone: (pickData.tripInfo.callBackInfo.includes("-")? ("+1"+pickData.tripInfo.callBackInfo.replaceAll("-","")) : pickData.tripInfo.callBackInfo),
                waitTime: "", stops:[], isReturn: pickData.tripInfo.returnTrip, pickLatLng: (pickData.addressDetails.latitude+","+pickData.addressDetails.longitude), 
                dropLatLng: (dropData.addressDetails.latitude+","+dropData.addressDetails.longitude),
                stopsDetails: stopDetailsTrackerArr, addressExtraDetails: addressExtraDetailsVal, id: editRowData.riderInfo.id, 
                //clientMedID: editRowData.riderInfo.medicalID, 
                clientMedID: editRowData?.riderInfo?.medicalID?.trim() || editRowData?.riderInfo?.riderID?.trim() || "0",
                paymentExtraInfo: pickData.tripInfo.extraInfo, clientJob: pickData.tripInfo.ext2,
                clientAddr: editRowData.riderInfo.clientAddress, clientCity: editRowData.riderInfo.clientCity, clientState: editRowData.riderInfo.clientState, 
                clientZip: editRowData.riderInfo.clientZip, fareZones: {pickFareZone:pickData.addressDetails.fareZone, dropFareZone:dropData.addressDetails.fareZone}, 
                dispatchZones: {pickZone: pickData.addressDetails.zone, dropZone: dropData.addressDetails.zone},
                FundingSource: pickData.paymentInfo.fundingSourceID, PaymentSelected: pickData.paymentInfo.paymentTypeID, 
                AffiliateSelected: editRowData.generalInfo.requestAffiliateID, COS: pickData.tripInfo.classOfServiceID, 
                vehType: (pickData.vehicleInfo.vehicleTypeId && pickData.vehicleInfo.vehicleTypeId !== -1 ? pickData.vehicleInfo.vehicleTypeId : "VT"), 
                vehTypeCheck: pickData.vehicleInfo.onlyPreferedVType, vehTypeMins: 0,
                cardNum: (pickData.paymentInfo.ccInfo.includes(",")? pickData.paymentInfo.ccInfo.split(",")[0] : ""), 
                cardExp: (pickData.paymentInfo.ccInfo.includes(",")? pickData.paymentInfo.ccInfo.split(",")[1] : ""), 
                RC: {phoneType:pickData.tripInfo.isRollingCallTypePhone, emailType:pickData.tripInfo.isRollingCallTypeEmail, SMSType:pickData.tripInfo.isRollingCallTypeSMS}, 
                driverNum: (pickData.driverInfo.assignedDriverNo !== "" ? pickData.driverInfo.assignedDriverNo : "DN"), driverNumCheck: pickData.driverInfo.onlyPreferedDriver,
                driverMins: pickData.driverInfo.driverNoTimeDiff, gender: (pickData.driverInfo.preferedDriverGender !== "" ? pickData.driverInfo.preferedDriverGender : "Gender"), 
                genderMins: pickData.driverInfo.genderTimeDiff, vehNum: (pickData.vehicleInfo.assignedVehNo !== "" ? pickData.vehicleInfo.assignedVehNo : "VN"), 
                genderCheck: pickData.driverInfo.onlyPreferedDriverGender,
                vehNumCheck: pickData.vehicleInfo.onlyPreferedVehicle, vehMins: pickData.vehicleInfo.vehicleNoTimeDiff, 
                language: (pickData.driverInfo.preferedLanguage !== "" && pickData.driverInfo.preferedLanguage !== 0 ? pickData.driverInfo.preferedLanguage : "Language"), 
                languageMins: pickData.driverInfo.langTimeDiff, languageCheck: pickData.driverInfo.onlyPreferedDriverLanguage,
                tripAttribute: attributesDesc, insurance: {Agency: editRowData.insuranceInfo.agencyID, Type: editRowData.insuranceInfo.insuranceID, 
                CaseWorker: editRowData.insuranceInfo.caseWorkerID, AuthCode: editRowData.insuranceInfo.authID,
                ServiceCode: editRowData.insuranceInfo.serviceCodeID}, copayPayType: pickData.paymentInfo.iActualPaymentTypeID, 
                copayFS: pickData.paymentInfo.iCopayFundingSourceID, tripType: pickData.tripInfo.callType, manualAmount: {estimatedFare: 0, estimatedDistance:0, price:0},
                tripPriority: pickData.tripInfo.slaClassID, fareMethod: pickData.tripInfo.fareMethod, billableAmount: pickData.estimatedInfo.billableAmount, 
                additionalPassengerCost: pickData.estimatedInfo.additionalPassCost, confirmationNo: ((copy)? "-1": pickData.tripInfo.refID),
                fareEstimateAPIData : fareEstimateDataDict, broker: brokerDict, CCInfo: cardInfo, ForcePassServiceHours: pickData.tripInfo.ForcePassServiceHoursCheck,
                paymentLogicInfo: {uniqueID: -1, oldUniqueID: -1, payStatusID: -1, invalidForSave: 0, retCCUniqueID: -1, CCPaidAmount: 0, CCRetPaidAmount: 0},
                addressPhoneInfo: {pick: pickData.addressDetails.phone, drop: dropData.addressDetails.phone},
                passengerMobilityInfo : {Primary: pickData.passengerInfo.primary, 
                  PCA: pickData.passengerInfo.pca, Guests: pickData.passengerInfo.guests, 
                  Children: pickData.passengerInfo.children, IsMobility: pickData.passengerInfo.isMobility},
                PUApartment: pickData.addressDetails.apartmentNo,
                  DOApartment: dropData.addressDetails.apartmentNo
              }
            );
            if(parseInt(pickData.tripInfo.refID) === parseInt(selectedConfirmationNo))
            {
              discoveredID = i;
              setVerifiedInfoUpdateIndex(i);
            }
          }
          setVerifiedAddr(stopOrderArr);
          setAddLegBtnTitle("Update");
          
        }
        setTimeout( async () => {
          
          if(editRowData.addressInfo.trips.length > 1) //Set new broker mode depending on multi/single trip
          {
            let BrokerMode = GetBrokerModeByAffiliateID();
            if(editRowData.addressInfo.trips[discoveredID].details[0].tripInfo.FSBrokerMode != undefined || editRowData.addressInfo.trips[discoveredID].details[0].tripInfo.FSBrokerMode != null){
              BrokerMode = editRowData.addressInfo.trips[discoveredID].details[0].tripInfo.FSBrokerMode;
            }

            setBrokerModes(prevState=>({...prevState, brokerMode: (BrokerMode || 0)}));
            let pickData = editRowData.addressInfo.trips[discoveredID].details[0];
            let fsData = (FundingSourceData[parseInt(editRowData.generalInfo.requestAffiliateID)] && 
              FundingSourceData[parseInt(editRowData.generalInfo.requestAffiliateID)] !== undefined ? 
              JSON.parse(FundingSourceData[parseInt(editRowData.generalInfo.requestAffiliateID)]) : []
            );
            let fsSelected = (fsData.length > 0 ? fsData.find(item => parseInt(item.FID) === parseInt(pickData.paymentInfo.fundingSourceID)) : 0);
            handleManualAmountOnFSChange(fsSelected, parseInt(pickData.paymentInfo.fundingSourceID));
            setAffiliateAbbr(fsSelected.AffiliateAbbrevation);
            if(parseInt(pickData.paymentInfo.paymentTypeID) === 2 || parseInt(pickData.paymentInfo.iActualPaymentTypeID) === 2)
            {
              setShowCCBtn(true);
            }
          }
          else
          {
            let pickData = editRowData.addressInfo.trips[0].details[0];
            if(parseInt(pickData.paymentInfo.paymentTypeID) === 2 || parseInt(pickData.paymentInfo.iActualPaymentTypeID) === 2)
            {
              setShowCCBtn(true);
            }
            let fsData = (FundingSourceData[parseInt(selectedAff)] && 
              FundingSourceData[parseInt(selectedAff)] !== undefined ? 
              JSON.parse(FundingSourceData[parseInt(selectedAff)]) : []
            );

            let fsSelected = fsData.length > 0 ? fsData.find(item =>parseInt(item.FID) === parseInt(tripData.details[0].paymentInfo.fundingSourceID) ) || fsData[0]: 0;
            setBrokerModes(prevState=>({...prevState, brokerMode: (fsSelected === 0 ? 0 : fsSelected.BrokerMode)}));
            handleManualAmountOnFSChange(fsSelected, parseInt(tripData.details[0].paymentInfo.fundingSourceID));
            setAffiliateAbbr(fsSelected.AffiliateAbbrevation);
          }
          setIsSchTimeFieldDisabled(false);

          let fsData = (FundingSourceData[parseInt(selectedAff)] && 
            FundingSourceData[parseInt(selectedAff)] !== undefined ? 
            JSON.parse(FundingSourceData[parseInt(selectedAff)]) : []
          );

          let fsSelected = fsData.length > 0 ? fsData.find(item =>parseInt(item.FID) === parseInt(tripData.details[0].paymentInfo.fundingSourceID) ) || fsData[0]: 0;
          setFSSelected(parseInt(tripData.details[0].paymentInfo.fundingSourceID));

          setCopayFSSelected(parseInt(tripData.details[0].paymentInfo.iCopayFundingSourceID));
          setCopayPayTypeSelected(tripData.details[0].paymentInfo.iActualPaymentTypeID);
          setPaySelected(tripData.details[0].paymentInfo.paymentTypeID);
          setMapData(tripLatLng);
          let tempArrLoop = (editRowData.addressInfo.trips.length > 1 ? editRowData.addressInfo.trips : [0])
          for(let j = 0; j < tempArrLoop.length; j++)
          {
            if(tempArrLoop.length === 1)
            {
              if(parseInt(tripData.details[0].paymentInfo.paymentTypeID) === 2 || parseInt(tripData.details[0].paymentInfo.iActualPaymentTypeID) === 2) { 
                setCardInfo(prevState=>({...prevState, gateID: tripData.details[0].tripInfo.gateID})); 
                
                await GetiCCInfo(parseInt(editRowData.riderInfo.id), tripData.details[0].tripInfo.gateID, parseInt(tripData.details[0].tripInfo.receivingAffiliateID));
                await GetCCTransInfo(parseInt(tripData.details[0].tripInfo.refID), 0);
              }
            }
            else
            {
              let pickData = tempArrLoop[j].details[0];
              if(parseInt(pickData.paymentInfo.paymentTypeID) === 2 || parseInt(pickData.paymentInfo.iActualPaymentTypeID) === 2) { 
                await GetiCCInfo(parseInt(editRowData.riderInfo.id), pickData.tripInfo.gateID, parseInt(pickData.tripInfo.receivingAffiliateID), j, discoveredID);
                await GetCCTransInfo(parseInt(pickData.tripInfo.refID), 0, j);
              }
            }
            
          }
          setManualDataOverwrite(prevState=>({...prevState, price:tripData.details[0].estimatedInfo.billableAmount, fare:tripData.details[0].estimatedInfo.estimatedCost}));

        }, 500); //settimeout is required to make sure changes are correctly populated on map, rider ID, pay, and FS
        if(pickLatLng.current !== "" && dropLatLng.current !== "")
        { //Handle fare or rcz verification depending on micro / para
          if(type === "API") { handleInitialFareAPIs(tripData.details[0].paymentInfo.fundingSourceID, editRowData.generalInfo.requestAffiliateID, tripData.details[0].tripInfo.classOfServiceID, [editRowData], tripData);}
          
          if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2))
          {
            wrapperHandleRCZVerification("PU", 
              (tripData.details[0].addressDetails.address + ", " + tripData.details[0].addressDetails.city + ", " + tripData.details[0].addressDetails.state + " " + tripData.details[0].addressDetails.zip),
              (lastTripData.addressDetails.address + ", " + lastTripData.addressDetails.city + ", " + lastTripData.addressDetails.state + " " + lastTripData.addressDetails.zip));
          }
        }
      }
      else
      {
        setModalHeaderText("Edit Info Error");
        setModalBodyHTML("There is an error while editing the trip, please try again or contact administrator.");
        setModalFooterHTML(
          <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
            OK
          </Button>
        );
        setShowDynamicModal(true);
      }
    }
    catch(err){console.log(err);}
    setShowDynamicModal(false);
  };

  function GetBrokerModeByAffiliateID () 
  {
    let BrokerMode = 0;
    try {
      let FSData = FundingSourceData[parseInt(selectedAff)] && FundingSourceData[parseInt(selectedAff)] !== undefined ? JSON.parse(FundingSourceData[parseInt(selectedAff)]) : [];
      if(FSData){
        BrokerMode = FSData[0].BrokerMode;
      }
    } catch (error) {
      return BrokerMode;
    }
    return BrokerMode;
  }


  const getMobilityAttributes = (tripData) => {
    try {
     let guests = [];
     let children = [];
     let pca;
     let primary;
     let mobilityAttributes = {primary: {}, pca: [], guests: [], children: []}
      
     if(tripData.passengerInfo.guests){
      guests = tripData.passengerInfo.guests;
      mobilityAttributes.guests = guests;
     }
     if(tripData.passengerInfo.pca){
      pca = tripData.passengerInfo.pca;
      mobilityAttributes.pca = pca;
     }
     if(tripData.passengerInfo.primary){
      primary = tripData.passengerInfo.primary;
      mobilityAttributes.primary = primary;
     }
     if(tripData.passengerInfo.children){
      children = tripData.passengerInfo.children;
      mobilityAttributes.children = children;
     }

    return countTotalWCCountFromObject(mobilityAttributes);
     //countTotalWCCount(mobilityAttributes);
    } catch (error) {
      return 0;
    }
  }

  const handleManualAmountOnFSChange = (fundingSourceSelected = {}, FSID = 0, type = "", data = {}) => {
    try{
      let bAgentPriceAdjust = false;
      let bEstCostByProvider = false;
      try{ //Manual Cost estimate/miles estimate
        bEstCostByProvider = (String(fundingSourceSelected.vFare).toLowerCase() === "" ? false : (String(fundingSourceSelected.vFare).toLowerCase() === "estimated cost, agent adj." ? true : false));
        if (!bEstCostByProvider) {
          let costAdjustmentFSIDArr = (manualCheckRef.current.AgentPriceAdjustmentFareFSIDs.includes(",") ? manualCheckRef.current.AgentPriceAdjustmentFareFSIDs.split(",") : [manualCheckRef.current.AgentPriceAdjustmentFareFSIDs]);
          for (let k = 0; k < costAdjustmentFSIDArr.length; k++) 
          {
            if (parseInt(costAdjustmentFSIDArr[k]) === parseInt(FSID) && String(fundingSourceSelected.vFare).toLowerCase() == "estimated cost from provider") {
              bEstCostByProvider = true;
              break;
            }
          }
        }
      } catch(err) {bEstCostByProvider = false;}
      try{ //Manual price check
        if(manualCheckRef.current.AgentPriceAdjustmentFSIDs !== "")
        {
          if(manualCheckRef.current.AgentPriceAdjustmentFSIDs == "-1" && String(fundingSourceSelected.vFare).toLowerCase() === "estimated cost from provider")
          {
            bAgentPriceAdjust = true;
          }
          else
          {
            let priceAdjustmentFSIDArr = (manualCheckRef.current.AgentPriceAdjustmentFSIDs.includes(",") ? manualCheckRef.current.AgentPriceAdjustmentFSIDs.split(",") : [manualCheckRef.current.AgentPriceAdjustmentFSIDs]);
            for(let k = 0; k < priceAdjustmentFSIDArr.length; k++)
            {
              if (parseInt(priceAdjustmentFSIDArr[k]) === parseInt(FSID) && String(fundingSourceSelected.vFare).toLowerCase() == "estimated cost from provider") {
                bAgentPriceAdjust = true;
                break;
              }
            }
          }
        }
      } catch(err){console.log(err); bAgentPriceAdjust = false;}

      if(bEstCostByProvider)
      {
        setManualFareChecks(prevState => ({...prevState, mileEstimateCheck: true, mileEstimateDisabled: false, fareEstimateCheck: true, fareEstimateDisabled: false}));
        manualFareChecksRef.current.fareCheck = true;
        manualFareChecksRef.current.milesCheck = true;
        if(type === 'editTrip')
          setManualDataOverwrite(prevState => ({...prevState, fare: data.cost, miles: data.dist}));
      }
      else
      {
        setManualFareChecks(prevState => ({...prevState, mileEstimateCheck: false, mileEstimateDisabled: true, fareEstimateCheck: false, fareEstimateDisabled: true}));
        // setManualDataOverwrite(prevState => ({...prevState, fare: clientSummary.TripFare, miles: clientSummary.tripDistance}));
        manualFareChecksRef.current.fareCheck = false;
        manualFareChecksRef.current.milesCheck = false;
      }

      if(bAgentPriceAdjust || (manualCheckRef.current.SDEnableNegotiatedFare === "true" && String(fundingSourceSelected.vFare).toLowerCase() === "actual cost"))
      {
        //enable manual price and check the manual price checkbox
        setManualFareChecks(prevState => ({...prevState, priceCheck: true, priceCheckDisabled: false}));
        manualFareChecksRef.current.priceCheck = true;
        if(type === 'editTrip')
          setManualDataOverwrite(prevState=>({...prevState, price: data.price}));
      }
      else
      {
        setManualFareChecks(prevState => ({...prevState, priceCheck: false, priceCheckDisabled: true}));
        // setManualDataOverwrite(prevState => ({...prevState, price: 0}));
        manualFareChecksRef.current.priceCheck = false;
      }
    }
    catch(err){console.log(err);}
  };

  const startAffSelectionDropDown = (selectedAffVS, uniqueAff = 0, affChanged = false) => {
    try{
      let updatedListofVS = [];
      let filteredSet = new Set();
      selectedAffVS.forEach(item =>{
        if(!filteredSet.has(item.ID))
        {
          updatedListofVS.push(item);
          filteredSet.add(item.ID);
        }
      }); //Removing all duplicates from virtual stop options and sorting according to name of VS
      let sortedListofVS = updatedListofVS.sort((a,b)=>{
        return a.Location.localeCompare(b.Location);
      });
      let checkingDataCompany = AffiliateData.find(item=>item.AffiliateID === parseInt(uniqueAff));
      let loginUserAffiliateList = (loginData.UserAffiliateList.includes(",")? loginData.UserAffiliateList.split(",") : [loginData.UserAffiliateList]);
      let affiliateOptionsHTML = AffiliateData.map(function(item, index){
        if(loginUserAffiliateList.includes(String(item.AffiliateID)) && (checkingDataCompany ? item.vATSPGroupName === checkingDataCompany.vATSPGroupName: true))
        {
          return (
            <option key={index} value={item.AffiliateID}>{item.AffiliateCompany}</option>
          );
        }
      });
      let virtualStopOptionsHTML = sortedListofVS.map(function(item, index){
        let LatLng = String(item.vLatitude) +","+ String(item.vLongitude);
        return(
          <option key={index} value={item.ID} data-name={item.Street} data-virtual={LatLng}>{item.Location}</option>
        );
      });
      if(affiliateOptionsHTML && affiliateOptionsHTML.length === 1 && !affChanged)
      {
        setSelectedAff(AffiliateData[0].AffiliateID); //setting the affiliate ID manually if there are no others
      }
      setVirtualStopDropDownHTML(virtualStopOptionsHTML);
      if(!affChanged)
        setAffiliateDropDownHTML(affiliateOptionsHTML); 
      if(updatedListofVS.length > 0)
      {
        for(let j = 0; j < updatedListofVS.length; j++)
        {
          if(rowData.current && rowData.current.length > 0 && rowData.current[0].PickupAddress && rowData.current[0].PickupAddress.includes(updatedListofVS[j].Location))
          {
            setPickupVirtualStop({...pickupVirtualStop, value:updatedListofVS[j].ID, name:updatedListofVS[j].Location});
          }
          if(rowData.current && rowData.current.length > 0 && rowData.current[0].Destination && rowData.current[0].Destination.includes(updatedListofVS[j].Location))
          {
            setDropAddrVirtualStop({...dropAddrVirtualStop, value:updatedListofVS[j].ID, name:updatedListofVS[j].Location});
          }
        }
      }
    }
    catch(err){console.log(err);}
  };

  //#endregion

  const handleSchTimeBlur = async(e)=>{ //Triggered when user clicks/tabs out of schedule PU time/date
    try{
      let eventObj = e;
      if (eventObj.target.value !== "" && eventObj.target.value.includes(":")) { //If value is not empty, begin to validate time
        await validateMinScheduleTimeDifference(null, true);
      }
      else if(eventObj.target.name === "dateGiven" || (eventObj.target.value !== "" && eventObj.target.value.includes("-"))) //If date is changed...
      {
        if(eventObj.target.value === "") //...If it is reset to empty, show error and disable add leg/book 
        {
          setModalHeaderText("Schedule Date & Time Alert");
          setModalBodyHTML("Please enter a valid date before continuing.");
          setModalFooterHTML(
            <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
              OK
            </Button>
          );
          setShowDynamicModal(true);
          addLegBtnRef.current.disabled = true;
          paratransitBookBtnRef.current.disabled = true;
          setIsTimeValidated(false);
        }
        else
        {
          //...If date is given, proceed to validation...
          let currDate = new Date(systemDateTimeRef.current.date+" 00:00:00");
          let selectedDate = new Date(eventObj.target.value + " 00:00:00");
          if((selectedDate < currDate) || (selectedDate === currDate && schTime !== "")) //...Only when given date is in the past / same as server date with time not empty
          {
            await validateMinScheduleTimeDifference(null, true);
          }
          else
          {
            if(!isTimeValidated) //If date is equal to server date and time is empty / given date is in future, skip validation
            {
              setIsTimeValidated(true);
              if(paratransitBookBtnRef.current)
              {
                addLegBtnRef.current.disabled = false;
                paratransitBookBtnRef.current.disabled = false;
              }
            }
          }
        }
      }
      else{

        if(bookBtnRef.current) //In case of microtransit time blur
        {
          if(schTime === "")
          {
            setIsTimeValidated(true);
            bookBtnRef.current.disabled = false;
          }
          else
          {
            bookBtnRef.current.disabled = true;
          }
        }
        else if(paratransitBookBtnRef.current) //In paratransit, only if certain conditions are met, skip validation
        {
          let currDate = new Date(systemDateTimeRef.current.date+" 00:00:00");
          let selectedDate = new Date(selectedDateSchTime + " 00:00:00");
          if(eventObj.target.value === "" && pickLatLng.current !== "" && dropLatLng.current !== "" && selectedDate >= currDate)
          {
            setIsTimeValidated(true);
            addLegBtnRef.current.disabled = false;
            paratransitBookBtnRef.current.disabled = false;
          }
        }
      }
    }
    catch(err){console.log(err);}
  };

  const schTimeOnClick = () => {
    try {
      if(bookBtnRef.current) //In microtransit trip, disable scheduled time if clicked until blur happens
      {
        if (!bookBtnRef.current.disabled) {
          bookBtnRef.current.disabled = true;
        }
      }
    } catch (error) {}
  };

  const schTimeOnFocus = () => {
    try {
      isValidateRCZCalledFromReset.current = false; //In microtransit trip, disable booking if PU time is focused 
      if(bookBtnRef.current)
      {
        if (!bookBtnRef.current.disabled) {
          bookBtnRef.current.disabled = true;
        }
      }
    } catch (error) { }
  };

  const clearSchTime = () => {
    try{
      setSchTime(""); //Function to reset PU time and enable booking if triggered
      let currDate = new Date(systemDateTimeRef.current.date+" 00:00:00");
      let selectedDate = (selectedDateSchTime === "" ? "" : new Date(selectedDateSchTime + " 00:00:00"));
      if(selectedDate !== "" && selectedDate >= currDate)
        setIsTimeValidated(true);
      if(bookBtnRef.current)
      {
        if(bookBtnRef.current.disabled && pickLatLng.current !== "" && dropLatLng.current !== "")
        {
          bookBtnRef.current.disabled = false;
        }
      }
      else if(paratransitBookBtnRef.current)
      {
        if(paratransitBookBtnRef.current.disabled && pickLatLng.current !== "" && dropLatLng.current !== "" && selectedDate !== "" && selectedDate >= currDate)
        {
          paratransitBookBtnRef.current.disabled = false;
          addLegBtnRef.current.disabled = false;
        }
      }
    }
    catch(err){console.log(err);}
  };

  function militaryToStandardTime(militaryTime) {
    try{
      // Split the military time into hours and minutes
      let [hour, minute] = militaryTime.split(":").map(Number);
        
      // Determine AM or PM based on the hour
      const period = hour >= 12 ? "PM" : "AM";

      // Round minutes to nearest integer
      minute = Math.round(parseInt(minute));

      // Convert hour to 12-hour format
      hour = hour % 12 || 12; // Changes 0 to 12 for midnight, keeps 12 as 12 for noon

      // Format the time as HH:MM AM/PM
      return `${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")} ${period}`;
    }
    catch(err){return militaryTime;}
  };

  const getCurrentSystemDateTime = async (type = "", bChange = false) => {
    try{
      let serverDateTime = await DateTimeUtils.getCurrentSystemDateTime();
      // Regex to capture time and AM/PM
      const regex = /(\d{2}:\d{2})(AM|PM)$/;
      // Match the time and AM/PM
      const match = serverDateTime.match(regex);
      if(match)
      { //server date and time is given from the API
        let systemTime = DateTimeUtils.toMilitaryTime(match[1]+" "+match[2], addedMinutesSystemSetting.current);
        let [month, day, year] = (serverDateTime.split(" ")[0]?.split("/") || ['','','']);
        let systemDate = year+"-"+month+"-"+day;
        if(type.toLowerCase() === "time") //Updating only time on useState systemDateTime
        {
          setSystemDateTime(prevState=>({...prevState, time:(systemTime.military)}));
          systemDateTimeRef.current = {time:(systemTime.military), date:systemDate, givenDate: serverDateTime.split(" ")[0], 
            givenTime: serverDateTime.split(" ")[1], timeWithSettingAdded: systemTime.timeWithSetting
          };
          if(bChange) //Only change PU time when asked in bChange
          {
            setSchTime((systemTime.military));
          }
        }
        else if(type.toLowerCase() === "date") //Updating only date on useState systemDateTime
        {
          setSystemDateTime(prevState=>({...prevState, date:systemDate}));
          systemDateTimeRef.current = {time:(systemTime.military), date:systemDate, givenDate: serverDateTime.split(" ")[0], givenTime: serverDateTime.split(" ")[1],
            timeWithSettingAdded: systemTime.timeWithSetting
          };
          // Get the current date
          const currentDate = new Date(systemDate+ " 00:00:00");
          // Get current year and month (formatted as YYYY-MM)
          const currentYear = currentDate.getFullYear();
          const currentMonth = String(currentDate.getMonth() + 1).padStart(2, '0'); // pad single digit months with 0
          setMinMonth(`${currentYear}-${currentMonth}`);
          // Get 5 years from now
          const futureDate = new Date();
          futureDate.setFullYear(currentDate.getFullYear() + 5);
          const futureYear = futureDate.getFullYear();
          const futureMonth = String(futureDate.getMonth() + 1).padStart(2, '0');
          setMaxMonth(`${futureYear}-${futureMonth}`);
          
          if(bChange) //Only change PU date when asked in bChange
          {
            let date = PersistStorage.retrieve("selectedDate", true);
            let [year, month, day] = (date && date.includes("-")? date.split("-").map(num => parseInt(num)) : ["", "", ""]);
            let newDate = "";
            if(year !== "")
            {
              month = String(month).padStart(2, "0");
              day = String(day).padStart(2, "0");
              newDate = `${year}-${month}-${day}`;
            }
            
            if(newDate && newDate !== "") //If stored date from D2.0 exists, replace with that, otherwise replace with server date
            {
              setSelectedDateSchTime(newDate);
            }
            else
            {
              setSelectedDateSchTime(systemDate);
            }
          }
        }
        else
        {
          setSystemDateTime({time:(systemTime.military), date:systemDate}); //Setting both date and time
          systemDateTimeRef.current = {time:(systemTime.military), date:systemDate, givenDate: serverDateTime.split(" ")[0], givenTime: serverDateTime.split(" ")[1]
            , timeWithSettingAdded: systemTime.timeWithSetting
          };
          if(bChange)
          {
            setSchTime((systemTime.military));
            setSelectedDateSchTime(systemDate);
          }
        }
      }
    }
    catch(err){console.log(err);}
  };

  const handleMapVSSelected = (data)=>{ //Get and set the selected VS from map into call taker data (microtransit)
    setMapVSSelected(data);
  };

  const handleMapPointSelection = (data)=>{
    if(data !== undefined && data){ //Used to get the latest address details depending on type when map is right clicked
      try {
        if(data[0].type === "PU"){
          mapPointPickupSelection.current = data;
        }
        else if(data[0].type === "DO"){
          mapPointDropoffSelection.current = data;
        }
        
      } catch (error) {}
    }
    setMapPointSelection(data);
  };

  const handleCancelTrip = async(confirmation, type="dispatchTrip")=>{
    try{
      setShowAPILoader(true); //Cancel a trip based on certain conditions and given data
      let data = {
        "ConfirmatinoNo": String(confirmation),
        "TripID": "-1",
        "Status": "Cancelled",
        "Message": "Cancelled by Agent",
        "iModifiedbyAppId": 26,
        "iModifiedByUID": parseInt(loginData.iUserID)
      };
      let response = await APICom.fetchData("ReservationCoreURL","SubmitTripConfirmation", "post", {}, data, xCancelSourceForGrid.current);
      setShowAPILoader(false);
      if(!type.toLowerCase().includes("active"))
      {
        if(response && parseInt(response.data.responseCode) !== 200) //For any other trip besides active, only show error if exists
        {
          handleResetAll("func");
          setModalHeaderText("Cancel Trip Error");
          setModalBodyHTML("An issue occured while cancelling the trip, please try again later.");
          setModalFooterHTML(
            <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
              OK
            </Button>
          );
          setShowDynamicModal(true);
        }
      }
      else
      { //Active trip cancellation confirmation along with errors if any
        if(response && parseInt(response.data.responseCode) !== 200)
        {
          setModalHeaderText("Cancel Trip Error");
          setModalBodyHTML("An issue occured while cancelling the trip, please try again later.");
          setModalFooterHTML(
            <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
              OK
            </Button>
          );
          setShowDynamicModal(true);
        }
        else if(parseInt(response.data.responseCode) === 200)
        {
          setModalHeaderText("Trip Cancelled Successfully");
          setModalBodyHTML("Trip #"+confirmation+" is cancelled.");
          setModalFooterHTML(
            <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
              OK
            </Button>
          );
          let filteredData = ActiveTripsTableData.filter((item)=>{
            return String(item.iRefId) !== String(confirmation);
          }); //Removing cancelled trip from active trips table

          setActiveTripsTableData(filteredData);
          setShowDynamicModal(true);
          setActiveTripConfirmation("");
        }
      }
    }
    catch(err){console.log(err);}
  };

  const handleRemoveRecord = (e)=>{
    try{
      let mtsmConfirmationNumList = PersistStorage.retrieve("confirmationsData", false);
      
      const updatedList = mtsmConfirmationNumList.filter(item=>{
        return item.Confirmation !== e.target.name;
      }); //Removes microtransit record from the MTSM, essentially hiding it from view of agents but not cancelling
      PersistStorage.save("confirmationsData", updatedList, 999, false);
    }
    catch(err){console.log(err);}
  };

  const handleRejectConfirmation = (e)=>{
    try{
      let eventType = e.target.getAttribute('data-name');
      let Type = "";
      if(eventType && eventType.toLowerCase() === 'cancel') //Determining the type of cancellation before initiating API
      {
        Type = "Cancel";
      }
      else
      {
        Type = "Reject";
      }
      setModalHeaderText(Type+" Trip Confirmation"); //Asking for confirmation before proceeding
      setModalBodyHTML(
        <>
          <p className="m-0 user-select-none">
            {"Are you sure to "}{Type.toLowerCase()}{" the trip with following confirmation#?"} 
          </p>
          <p className="m-0 w-100 fw-bold text-center user-select-none">{e.target.name}</p>
        </>
      );
      setModalFooterHTML(
        <>
          <Button variant='dark' name={e.target.name} data-name={eventType} className="border-0" onClick={handleRejectTrip}>
            Yes
          </Button>
          <Button variant='secondary' className="border-0" onClick={()=>{setShowDynamicModal(false);}}>
            No
          </Button>
        </>
      );
      setShowDynamicModal(true);
    }
    catch(err){console.log(err);}
  };

  const handleRejectTrip = async(e)=>{
    try{
      setShowDynamicModal(false); //Performing cancellation/rejection depending on the type
      setShowAPILoader(true);
      let mtsmConfirmationNumList = PersistStorage.retrieve("confirmationsData", false);
      let cancelType = e.target.getAttribute('data-name');
      let data = {
        "ConfirmatinoNo": String((e.target.name)),
        "TripID": "-1",
        "Status": "Cancelled",
        "Message": (cancelType && cancelType.toLowerCase() === "cancel") ? "Cancelled while booking" : "Cancelled by Agent",
        "iModifiedbyAppId": 26,
        "iModifiedByUID": parseInt(loginData.iUserID)
      };
      let response = await APICom.fetchData("ReservationCoreURL","SubmitTripConfirmation", "post", {}, data, xCancelSourceForGrid.current);

      setShowAPILoader(false);
      if(response && parseInt(response.data.responseCode) === 200)
      {
        if(cancelType && cancelType.toLowerCase() === "cancel")
        {
          for(let l = 0; l < mtsmConfirmationNumList.length; l++)
          {
            if(String(mtsmConfirmationNumList[l].Confirmation) === String(e.target.name))
            {
              mtsmConfirmationNumList[l].time = "N/A";
              mtsmConfirmationNumList[l].dropTime = "N/A";
              mtsmConfirmationNumList[l].msg = "Cancelled by Agent";
            }
          }
          PersistStorage.save('confirmationsData', mtsmConfirmationNumList, 999, false);
        }
        else if(cancelType.toLowerCase() === "reject")
        {
          for(let l = 0; l < mtsmConfirmationNumList.length; l++)
          {
            if(String(mtsmConfirmationNumList[l].Confirmation) === String(e.target.name))
            {
              mtsmConfirmationNumList[l].time = "N/A";
              mtsmConfirmationNumList[l].dropTime = "N/A";
              mtsmConfirmationNumList[l].msg = "Proposed time rejected by the customer";
            }
          }
          PersistStorage.save('confirmationsData', mtsmConfirmationNumList, 999, false);
        }
      }
      else
      {
        for(let l = 0; l < mtsmConfirmationNumList.length; l++)
        {
          if(String(mtsmConfirmationNumList[l].Confirmation) === String((e.target.name)))
          {
            mtsmConfirmationNumList[l].time = "N/A";
            mtsmConfirmationNumList[l].dropTime = "N/A";
            mtsmConfirmationNumList[l].msg = "Cancellation has failed, please try again";
          }
        }
        PersistStorage.save('confirmationsData', mtsmConfirmationNumList, 999, false);
      }
    }
    catch(err){console.log(err);}
  };

  function findDaysInRange(from, to, dayIndex) {
    try{
      const startDate = new Date(from+"T00:00:00"); //Function related to update trip, gets all days in given range of edit API data
      const endDate = new Date(to+"T00:00:00");
      const daysInRange = [];
    
      // Adjust for time portion, setting both to the start of their respective days
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(0, 0, 0, 0);
      let alignedDateStart = new Date(startDate)
      while (alignedDateStart.getDay() !== dayIndex) {
        alignedDateStart.setDate(alignedDateStart.getDate() + 1); // Move one day forward
      }
      // Iterate through the date range
      for (let currentDate = new Date(alignedDateStart); currentDate <= endDate; currentDate.setDate(currentDate.getDate() + 7)) {
        const formattedDate = 
          ((currentDate.getMonth() + 1).toString().padStart(2, '0') + '/' + 
          currentDate.getDate().toString().padStart(2, '0') + '/' + 
          currentDate.getFullYear()
        );
        daysInRange.push(formattedDate);
      }
    
      return daysInRange;
    }
    catch(err){console.log(err); return "N/A"}
  }

  

  // Parsing data
  const ParseGeoCodedData = (data, Identifier, Index = 0) => {  
    try{
      let StreatNum = "", route = "", Locality = "", Admin3 = "", Admin2 = "", Admin1 = "", Country = "", PostalCode = "",
      establishment = "", neighborhood = "", park = "", premise = "", subpremise = "", sublocality = "", intersection = "", 
      FormatedAddress = "";
      let StreatNum_short = "", route_short = "", neighborhood_short = "", park_short = "", premise_short = "", 
      subpremise_short = "", intersection_short = ""; //Initializing all necessary pieces of address data to be assigned from given data
      let _mapSource = "unkwnSource";
      let isPoiLatLong = false;
      //Assigning each variable to accurate component of OSRM using switch case
      if(data.address_components){
        data.address_components.forEach((component) => {
          const componentType = component.types[0];
          const longName = component.long_name;
          const shortName = component.short_name;

          switch (componentType) {
            case 'street_number': StreatNum = longName; StreatNum_short = shortName;
              break;
            case 'route': route = longName; route_short = shortName;
              break;
            case 'locality': Locality = longName;
              break;
            case 'administrative_area_level_3': Admin3 = longName;
              break;
            case 'administrative_area_level_2': Admin2 = longName;
              break;
            case 'administrative_area_level_1': Admin1 = shortName;
              break;
            case 'country': Country = longName;
              break;
            case 'postal_code': PostalCode = longName;
              break;
            case 'establishment': establishment = longName;
              break;
            case 'neighborhood': neighborhood = longName; neighborhood_short = shortName;
              break;
            case 'park': park = longName; park_short = shortName;
              break;
            case 'premise': premise = longName; premise_short = shortName;
              break;
            case 'subpremise': subpremise = longName; subpremise_short = shortName;
              break;
            case 'sublocality': sublocality = longName;
              break;
            case 'intersection': intersection = longName; intersection_short = shortName;
              break;
            default: break;
          }
        });
      }
      FormatedAddress = data.formatted_address;
      if (Admin1.trim() === Country.trim()) {//If it sends country in state, empty the state.
        Admin1 = "";
      }
      let AggregatedStreetAdddr = "";
      AggregatedStreetAdddr = (premise.trim() === "" ? "" : premise + ", ") + 
        (subpremise.trim() === "" ? "" : subpremise + ", ") + (park.trim() === "" ? "" : park + ", ") + 
        ((neighborhood.trim() === "" || route !== "" || StreatNum !== "") ? "" : neighborhood + ", ") + 
      (intersection.trim() === "" ? "" : intersection + ", ") + StreatNum + " " + route;
      
  
      try {
        if (FormatedAddress.split(',').length > 0) {

          let StreetAdd = data.formatted_address.split(',')[0];
          if (StreetAdd != "" && StreetAdd.indexOf("&") > -1 && (StreetAdd.indexOf(route) > -1 || StreetAdd.indexOf(StreatNum) > -1
            || StreetAdd.indexOf(intersection) > -1 || StreetAdd.indexOf(neighborhood) > -1 || StreetAdd.indexOf(park) > -1
            || StreetAdd.indexOf(subpremise) > -1 || StreetAdd.indexOf(premise) > -1
            || StreetAdd.indexOf(route_short) > -1 || StreetAdd.indexOf(StreatNum_short) > -1
            || StreetAdd.indexOf(intersection_short) > -1 || StreetAdd.indexOf(neighborhood_short) > -1
            || StreetAdd.indexOf(park_short) > -1 || StreetAdd.indexOf(subpremise_short) > -1 || StreetAdd.indexOf(premise_short) > -1)) 
          {
            AggregatedStreetAdddr = StreetAdd;
          }
        }
      } catch (CrashFailSafe) { }
      
      try {
        if (typeof data.mapSource !== 'undefined') {
          _mapSource = data.mapSource;
        }
        if (typeof data.placessearchedresult !== 'undefined') {
          if (data.placessearchedresult === true) {
            isPoiLatLong = true;
          }
        }
      } catch (setMapSrcExp) { }
      let ParsedData = {
        "Street": AggregatedStreetAdddr.trim() === "" ? establishment : AggregatedStreetAdddr.trim(),
        "City": (Locality === "") ? Admin2 : Locality,
        "State": (Admin1.toString().toLowerCase() === "maryland") ? 'MD' : Admin1,
        "Zip": PostalCode,
        "Lat": (data.geometry ? data.geometry.location.lat : ""),
        "Long": (data.geometry ? data.geometry.location.lng : ""),
        "Address": FormatedAddress,
        "data": data,
        "Country": Country,
        "Identifier": Identifier,
        "isPoiLatLong": isPoiLatLong,
        "UnitNumber": (data.sUnitNumber === undefined || data.sUnitNumber === null) ? "" : data.sUnitNumber,
        "GeocodeSource": _mapSource
      };
      return ParsedData;
    }
    catch(err){console.log(err);}
  };
  // ___________________

  const handleFSSelectionChange = async (e, type, newData={}, medicalID = -1) => {
    try{

      if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2))
      { //Paratransit mode Funding Source change
        let accurateOption = (e === "" ? newData.props : e.target);
        const selectedIndex = (e !== "" ? e.target.selectedIndex : "");
        const selectedOption = (e !== "" ? e.target.options[selectedIndex] : newData);
        const virtualData = (e !== "" ? selectedOption.getAttribute('data-virtual') : newData.props["data-virtual"]);
        if(type === "fs")
        {
          let fsData = (FundingSourceData[parseInt(selectedAff)] && 
            FundingSourceData[parseInt(selectedAff)] !== undefined ? 
            JSON.parse(FundingSourceData[parseInt(selectedAff)]) : []
          );

          let fsSelected = 0;
          if(fsData?.length > 0){
            if(parseInt(accurateOption.value) === -1){
              fsSelected = fsData[0];
            }
            else{
              fsSelected = fsData.find(p => parseInt(p.FID) === parseInt(accurateOption.value));
            }
          }

          //let fsSelected = (fsData.length > 0 ? fsData.find(item => parseInt(item.FID) === parseInt(accurateOption.value)) : 0);
          
          let riderIDData = (medicalID !== -1 ? medicalID : "");
          handleManualAmountOnFSChange(fsSelected, parseInt(accurateOption.value));
          setBrokerModes(prevState=>({...prevState, brokerMode: (fsSelected === 0 ? 0 : fsSelected?.BrokerMode)}));
          setFSSelected(accurateOption.value); 
          setAffiliateAbbr(fsSelected?.AffiliateAbbrevation);
          setPaySelected(parseInt(virtualData)); //Get fare estimate and fare method on funding source change
          setAgentNotes(fsSelected?.vFSComments? fsSelected?.vFSComments: "")
          let tempPayOption = PayDropdown.find((option)=> (option?.props && parseInt(option.props.value) === parseInt(virtualData)));
          if(tempPayOption)
          {
            if(tempPayOption.props.children.toLowerCase().includes("card"))
            {
              setShowCCBtn(true);
            }
            else
            {
              setShowCCBtn(false);
            }
          }
          await handleGetFareCalcMethod((accurateOption.value ? accurateOption.value : "-1"), selectedAff, COSSelected);
          const tripTypes = [
              { type: "pick", mapInfo: pickLatLng.current },
              { type: "drop", mapInfo: dropLatLng.current },
            ];
  
          for (const trip of tripTypes) {
            if (fareMethodRef.current === 1) {
              await getFareZone((accurateOption.value ? accurateOption.value : "-1"), selectedAff, COSSelected, trip.mapInfo, trip.type);
            }
            await getDispatchZone(selectedAff, trip.mapInfo, trip.type);
          }
          await wrapperHandleFareCalc(clientSummary.tripDistance, clientSummary.TripDuration, 
            accurateOption.value, copayFSSelected, passengerTypeCount.totalWC, 
            passengerTypeCount.total, COSSelected, selectedAff, 
            pickLatLng.current, copayAmount, "", riderIDData
          ); 
        }
        else
        {
          let textContent = (selectedOption.textContent ? selectedOption.textContent.toLowerCase() : selectedOption.props.label.toLowerCase());
          let riderIDData = (medicalID !== -1 ? medicalID : "");
          setCopayFSSelected(accurateOption.value);
          if(textContent.includes('card')) //Check if the name of Funding Source has card for credit card button
          {
            setShowCCBtn(true);
          }
          else
          {
            setShowCCBtn(false);
          }
          setCopayPayTypeSelected(parseInt(virtualData)); //Get fare estimate and fare method on copay funding source change
          await handleGetFareCalcMethod((FSSelected? FSSelected: "-1"), selectedAff, COSSelected);
          await wrapperHandleFareCalc(clientSummary.tripDistance, clientSummary.TripDuration, 
            FSSelected, accurateOption.value, passengerTypeCount.totalWC, 
            passengerTypeCount.total, COSSelected, selectedAff, 
            pickLatLng.current, copayAmount, "", riderIDData
          ); 
        }
      }
      else
      { //Microtransit mode Funding Source change
        let fsData = (FundingSourceData[parseInt(selectedAff)] && 
          FundingSourceData[parseInt(selectedAff)] !== undefined ? 
          JSON.parse(FundingSourceData[parseInt(selectedAff)]) : []
        );
        let accurateOption = (e === "" ? newData.props : e.target);
        let riderIDData = (medicalID !== -1 ? medicalID : "");
        await handleGetFareCalcMethod((accurateOption.value ? accurateOption.value : "-1"), selectedAff, COSSelected);
        await wrapperHandleFareCalc(clientSummary.tripDistance, clientSummary.TripDuration, 
          FSSelected, accurateOption.value, passengerTypeCount.totalWC, 
          passengerTypeCount.total, COSSelected, selectedAff, 
          pickLatLng.current, copayAmount, "", riderIDData
        ); 
        let fsSelected = (fsData.length > 0 ? fsData.find(item => parseInt(item.FID) === parseInt(accurateOption.value)) : 0);
        setAgentNotes(fsSelected?.vFSComments? fsSelected?.vFSComments: "")
        setBrokerModes(prevState=>({...prevState, brokerMode: (fsSelected === 0 ? 0 : fsSelected.BrokerMode)}));
        
        setFSSelected(accurateOption.value); 
        setAffiliateAbbr(fsSelected.AffiliateAbbrevation);
      }
    }
    catch(err){console.log(err);}
  };

  const handleSearchCustomerMedicalID = async () => {
    try{
      let clientInfoMedID = [];
      if(affiliateSelRef.current.options.length !== 0 && affiliateSelRef.current.options.length !== affiliateDropDownHTML.length)
      {
        let loginUserAffiliateList = (loginData.UserAffiliateList.includes(",")? loginData.UserAffiliateList.split(",") : [loginData.UserAffiliateList]);
        let affiliateOptionsHTML = AffiliateData.map(function(item, index){
          if(loginUserAffiliateList.includes(String(item.AffiliateID)))
          {
            return (
              <option key={index} value={item.AffiliateID}>{item.AffiliateCompany}</option>
            );
          }
        });
        setAffiliateDropDownHTML(affiliateOptionsHTML);  
      }
      clientMedIDCheckRef.current.blur();
      setSearchButtonValidation("");
      if(!clientInfoDisplay)
      {
        setClientInfoDisplay(true);
      }
      if(medicalIDCheck.trim().length > 0 && !isNaN(medicalIDCheck.trim()))
      {
        searchClientBtnRef.current.disabled = true;
        let selectedFamilyData = AffiliateData.filter((item)=>{
          if(parseInt(item.AffiliateID) === parseInt(selectedAff))
          {
            return true;
          }
        });

        let data = {
          "searchCriteria": "CustomerMedID",
          "searchText": String(medicalIDCheck),
          "bActiveRecords": true,
          "iATSPID": selectedAff ? parseInt(selectedAff) : -1,
          "iDTSPID": selectedFamilyData ? parseInt(selectedFamilyData[0].DTSPID): -1,
        };
        
        setModalHeaderText("Client Info Processing");
        setModalBodyHTML("Please wait...");
        setModalFooterHTML(
          <>
            <Button variant='dark' className="border-0" onClick = {()=>{setShowDynamicModal(false);}}>
              OK
            </Button>
          </>
        );
        setShowDynamicModal(true);
        setModalClass("d-none");
        setShowAPILoader(true);
        searchClientFlagRef.current = true;
        setShowSearchLoader(true);
        searchClientBtnRef.current.disabled = true;
        let response = await APICom.fetchData("ReservationCoreURL","SearchClientData", "post", {}, data, xCancelSourceForGrid.current);
        setShowSearchLoader(false);
        searchClientBtnRef.current.disabled = false;
        searchClientFlagRef.current = false;
        if(response && response.error === "" && parseInt(response.data.responseCode) === 200)
        {
          searchClientBtnRef.current.disabled = false;
          clientInfoMedID = JSON.parse(response.data.responseJSON);
          setSearchButtonValidation("");
          searchButtonValidationRef.current = '';
        }
        else
        {
          setModalClass("");
          setShowAPILoader(false);
          searchClientBtnRef.current.disabled = false;
          if(response && response.error === "") //no client found
          {
            setSearchButtonValidation("No Client Found");
            searchButtonValidationRef.current = 'none';
            clientMedIDCheckRef.current.focus();
            setTimeout(() => {
              setSearchButtonValidation("");
            }, 5000);
            setTimeout(() => {
              setModalHeaderText("New Client Alert");
              setModalBodyHTML("The client profile does not exist, please create a new client profile before booking a trip.");
              setModalFooterHTML(
                <>
                  <Button variant='dark' className="border-0" onClick = {()=>{handleNewClientManualLoad(); setShowDynamicModal(false);}}>
                    Continue
                  </Button>
                  <Button variant='secondary' className="border-0" onClick = {()=>{setShowDynamicModal(false);}}>
                    Cancel
                  </Button>
                </>
              );
              setShowDynamicModal(true);
            }, 200);
            
          }
          else
          {
            setShowDynamicModal(false);
            setSearchButtonValidation(response.error);
            searchButtonValidationRef.current = '';
            setTimeout(() => {
              setSearchButtonValidation("");
            }, 5000);
          }
        }
      }
      if(clientInfoMedID.length > 1)
      {
        let sortedClientInfoList = clientInfoMedID.sort((a,b)=>{

          const dateA = a.LastCallDate ? new Date(a.LastCallDate.split("T")[0] + " 00:00:00") : null;
          const dateB = b.LastCallDate ? new Date(b.LastCallDate.split("T")[0] + " 00:00:00") : null;

          if (!dateA && !dateB) return 0; // Both dates are empty
          if (!dateA) return 1; // Move entries with empty lastCall to the end
          if (!dateB) return -1; // Move entries with empty lastCall to the end

          return dateB - dateA; // Sort by date if both are valid (newest to oldest)
        });
        clientIndexRef.current = {index : 0, data : sortedClientInfoList[0]};
        setInputSuggestionListClientName("");
        setInputSuggestionListClientPhone("");
        setInputSuggestionListClientMedID("");
        setModalHeaderText("Client Info Selection");
        setModalBodyHTML(
          <>
            <p className="m-0 user-select-none">
              {"Please select the desired client from the following options with provided ID: "}
              <span className="fw-bold text-center user-select-none">{"("+medicalIDCheck+")"}</span> 
            </p>
            <Row className="m-0 justify-content-center">
              <select className='text-left m-1 px-1 w-100 overflow-hidden' style={{textOverflow:"ellipsis"}}
                onChange={(e)=>{clientIndexRef.current = {index : e.target.value, data : sortedClientInfoList[parseInt(e.target.value)]};}}
              >
                <option disabled hidden value={999}>{"Select Client"}</option>
                {sortedClientInfoList.map(function(item, index){
                  let [year, month, day] = item.LastCallDate ?  item.LastCallDate.split("T")[0].split("-"): ["","",""];
                  let formattedName = (item.FirstName === "" ? item.LastName.trim() : (item.LastName === "" 
                    ? (item.FirstName.trim().includes(",") ? item.FirstName.split(",")[1].trim()+", "+item.FirstName.split(",")[0].trim(): item.FirstName.trim())  
                    : item.LastName.trim()+", "+item.FirstName.trim()));
                  return(
                    <option key={index} value={index}>
                      
                      {/* {formattedName + (item.HomePhone.length === 0 ? (year !== "" ? " [Last Call: "+month+"/"+day+"/"+year+"]" : ""):
                      " ("+item.HomePhone+")"+(year !== "" ? " [Last Call: "+month+"/"+day+"/"+year+"]" : ""))} */}

                        {formattedName +
                              (item.HomePhone.length === 0
                                ? (year !== ""
                                    ? ` [Last Call: ${month}/${day}/${year}]`
                                    : "")
                                : ` (${item.HomePhone}) [RiderId: ${item.MedicalId || -1}]${
                                    year !== "" ? ` [Last Call: ${month}/${day}/${year}]` : ""
                                  }`)}
                      
                      
                      </option>
                  );
                })}
              </select>
            </Row>
          </>
        );
        setModalFooterHTML(
          <>
            <Button variant='dark' className="border-0"
              onClick={()=>{handleClientInfoGeneration(sortedClientInfoList[parseInt(clientIndexRef.current.index)]);}}>
              OK
            </Button>
          </>
        );
        setShowDynamicModal(true);
        setModalClass("");
        setShowAPILoader(false);
      }
      else
      {
        await handleClientInfoGeneration(clientInfoMedID[0]);
      }
    }
    catch(err){console.log(err);}
  };

  const handleSearchCustomerName = async (givenData = "", OpenMultipleDialog = true, clientID = 0, showActiveTrips = true) =>{
    try{
      if(affiliateSelRef.current.options.length !== 0 && affiliateSelRef.current.options.length !== affiliateDropDownHTML.length)
      {
        let loginUserAffiliateList = (loginData.UserAffiliateList.includes(",")? loginData.UserAffiliateList.split(",") : [loginData.UserAffiliateList]);
        let affiliateOptionsHTML = AffiliateData.map(function(item, index){
          if(loginUserAffiliateList.includes(String(item.AffiliateID)))
          {
            return (
              <option key={index} value={item.AffiliateID}>{item.AffiliateCompany}</option>
            );
          }
        });
        setAffiliateDropDownHTML(affiliateOptionsHTML);  
      }
      clientNameCheckRef.current.blur();
      setMedicalIDCheck("");
      setSearchButtonValidation("");
      searchButtonValidationRef.current = '';
      if(!clientInfoDisplay)
      {
        setClientInfoDisplay(true);
      }
      if((riderNameCheck.length > 0) || givenData !== "")
      {
        let isContainedFilter = clientNameList.length > 0 && givenData === ""? clientNameList.filter((item, index)=>{
          let nameParts = (riderNameCheck.trim().includes(" ") ? riderNameCheck.trim().split(" ") : riderNameCheck);
          let fullName = (item.FirstName === "" ? item.LastName : item.FirstName + (item.LastName === "" ? "" : " " + item.LastName));
          return ((Array.isArray(nameParts) && nameParts.every(part=> fullName.toLowerCase().includes(part.toLowerCase()))) || 
            (!Array.isArray(nameParts) && fullName.toLowerCase().includes(nameParts.trim().toLowerCase())));
        }) : [];
        let response = "";
        let clientInfo = [];
        if(isContainedFilter.length === 0)
        {
          searchClientBtnRef.current.disabled = true;
          let selectedFamilyData = AffiliateData.filter((item)=>{
            if(parseInt(item.AffiliateID) === parseInt(selectedAff))
            {
              return true;
            }
          });
  
          let data = {
            "searchCriteria": "CustomerName",
            "searchText": (givenData !== "" ? givenData : riderNameCheck),
            "bActiveRecords": true,
            "iATSPID": selectedAff ? parseInt(selectedAff) : -1,
            "iDTSPID": selectedFamilyData ? parseInt(selectedFamilyData[0].DTSPID): -1,
          };
          
          setModalHeaderText("Client Info Processing");
          setModalBodyHTML("Please wait...");
          setModalFooterHTML(
            <>
              <Button variant='dark' className="border-0" onClick = {()=>{setShowDynamicModal(false);}}>
                OK
              </Button>
            </>
          );
          setShowDynamicModal(true);
          setModalClass("d-none");
          setShowAPILoader(true);
          searchClientFlagRef.current = true;
          setShowSearchLoader(true);
          searchClientBtnRef.current.disabled = true;
          response = await APICom.fetchData("ReservationCoreURL","SearchClientData", "post", {}, data, xCancelSourceForGrid.current);
          searchClientFlagRef.current = false;
          setShowSearchLoader(false);
          searchClientBtnRef.current.disabled = false;

          if(response && response.error === "" && parseInt(response.data.responseCode) === 200)
          {
            searchClientBtnRef.current.disabled = false;
            clientInfo = JSON.parse(response.data.responseJSON);
            setSearchButtonValidation("");
            searchButtonValidationRef.current = '';
          }
          else
          {
            setModalClass("");
            setShowAPILoader(false);
            searchClientBtnRef.current.disabled = false;
            if(response && response.error === "") //no client found
            {
              setSearchButtonValidation("No Client Found");
              searchButtonValidationRef.current = 'none';
              // riderNameRef.current.focus();
              setTimeout(() => {
                setSearchButtonValidation("");
              }, 5000);
              setMainInfoNewClient({type: 'name', value: riderNameCheck});
              setTimeout(() => {
                setModalHeaderText("New Client Alert");
                setModalBodyHTML("The client profile does not exist, please create a new client profile before booking a trip.");
                setModalFooterHTML(
                  <>
                    <Button variant='dark' className="border-0" onClick = {()=>{handleNewClientManualLoad(); setShowDynamicModal(false);}}>
                      Continue
                    </Button>
                    <Button variant='secondary' className="border-0" onClick = {()=>{setShowDynamicModal(false); riderNameRef.current.focus();}}>
                      Cancel
                    </Button>
                  </>
                );
                setShowDynamicModal(true);
              }, 200);
            }
            else
            {
              setShowDynamicModal(false);
              setSearchButtonValidation(response.error);
              searchButtonValidationRef.current = '';
              setTimeout(() => {
                setSearchButtonValidation("");
              }, 5000);
            }
          }
        }
        else
        {
          clientInfo = [...isContainedFilter];
        }
        if(clientInfo.length > 1 && OpenMultipleDialog)
        {
          let sortedClientInfoList = clientInfo.sort((a,b)=>{

            const dateA = a.LastCallDate ? new Date(a.LastCallDate.split("T")[0] + " 00:00:00") : null;
            const dateB = b.LastCallDate ? new Date(b.LastCallDate.split("T")[0] + " 00:00:00") : null;

            if (!dateA && !dateB) return 0; // Both dates are empty
            if (!dateA) return 1; // Move entries with empty lastCall to the end
            if (!dateB) return -1; // Move entries with empty lastCall to the end

            return dateB - dateA; // Sort by date if both are valid (newest to oldest)
          });
          clientIndexRef.current = {index : 0, data : sortedClientInfoList[0]};
          setInputSuggestionListClientName("");
          setInputSuggestionListClientPhone("");
          setInputSuggestionListClientMedID("");
          setModalHeaderText("Client Info Selection");
          setModalBodyHTML(
            <>
              <p className="m-0 user-select-none">
                {"Please select the desired client from the following options with provided name: "}
                <span className="fw-bold text-center user-select-none">{"("+riderNameCheck+")"}</span> 
              </p>
              <Row className="m-0 justify-content-center">
                <select className='text-left m-1 px-1 w-100 overflow-hidden' style={{textOverflow:"ellipsis"}}
                  onChange={(e)=>{clientIndexRef.current = {index : e.target.value, data : sortedClientInfoList[parseInt(e.target.value)]};}}
                >
                  <option disabled hidden value={999}>{"Select Client"}</option>
                  {sortedClientInfoList.map(function(item, index){
                    let [year, month, day] = item.LastCallDate ?  item.LastCallDate.split("T")[0].split("-"): ["","",""];
                    let formattedName = (item.FirstName === "" ? item.LastName.trim() : (item.LastName === "" 
                      ? (item.FirstName.trim().includes(",") ? item.FirstName.split(",")[1].trim()+", "+item.FirstName.split(",")[0].trim(): item.FirstName.trim())  
                      : item.LastName.trim()+", "+item.FirstName.trim()));
                    return(
                      <option key={index} value={index}>
                        {/* {formattedName + (item.HomePhone.length === 0 ? (year !== "" ? " [Last Call: "+month+"/"+day+"/"+year+"]" : ""):
                        " ("+item.HomePhone+")"+(year !== "" ? " [Last Call: "+month+"/"+day+"/"+year+"]" : ""))} */}
                            {formattedName +
                              (item.HomePhone.length === 0
                                ? (year !== ""
                                    ? ` [Last Call: ${month}/${day}/${year}]`
                                    : "")
                                : ` (${item.HomePhone}) [RiderId: ${item.MedicalId || -1}]${
                                    year !== "" ? ` [Last Call: ${month}/${day}/${year}]` : ""
                                  }`)}
                        
                        </option>
                    );
                  })}
                </select>
              </Row>
            </>
          );
          setModalFooterHTML(
            <>
              <Button variant='dark' className="border-0"
                onClick={()=>{handleClientInfoGeneration(sortedClientInfoList[parseInt(clientIndexRef.current.index)]);}}>
                OK
              </Button>
            </>
          );
          setShowDynamicModal(true);
          setModalClass("");
          setShowAPILoader(false);
        }
        else
        {
          const resultClient =  (clientID !== 0 ? clientInfo.find((item)=>{
            const itemID = parseInt(item.id ?? item.Id);
            return itemID === parseInt(clientID)}) : null);
          let validData = (clientInfo.length > 1 ? (resultClient? resultClient : clientInfo[0]) : clientInfo[0]);
          if(showActiveTrips)
          {
            setModalClass("");
            setShowDynamicModal(false);
            setShowAPILoader(false);
          }
          await handleClientInfoGeneration(validData, showActiveTrips);
        }
       
      }
      else
      {
        setClientNameList([]);
        setSearchButtonValidation("Please enter the complete name");
        searchButtonValidationRef.current = '';
      }
    }
    catch(err){console.log(err);}
  };

  const handlePhoneNumberChange = async (e) => {
    try{
      let input = "";
      if(typeof e === "string")
      {
        setPhone(e);
        input = e;
      }
      else
      {
        input = e.target.value;
      }
      if(input.trim().length >= 12)
      {
        let selectedFamilyData = AffiliateData.filter((item)=>{
          if(parseInt(item.AffiliateID) === parseInt(selectedAff))
          {
            return true;
          }
        });
        let areaCode = "";
        let firstPart = "";
        let secondPart = "";
        if(input.includes("("))
        {
          input = input.replace(/\D/g, ""); // This removes everything that is not a digit
          areaCode = input.substring(0,3);
          firstPart = input.substring(3,6);
          secondPart = input.substring(6,10);
        }
        else
        {
          areaCode = input.replace("+1","").substring(0,3);
          firstPart = input.replace("+1","").substring(3,6);
          secondPart = input.replace("+1","").substring(6,10);
        }
        let data = {
          "searchCriteria": "CustomerPhone",
          "searchText": (areaCode+"-"+firstPart+"-"+secondPart),
          "bActiveRecords": true,
          "iATSPID": selectedAff ? parseInt(selectedAff) : -1,
          "iDTSPID": selectedFamilyData ? parseInt(selectedFamilyData[0].DTSPID): -1,
        };
        searchClientFlagRef.current = true;
        setShowSearchLoader(true);
        searchClientBtnRef.current.disabled = true;
        let response = await APICom.fetchData("ReservationCoreURL","SearchClientData", "post", {}, data, xCancelSourceForGrid.current);
        searchClientFlagRef.current = false;
        setShowSearchLoader(false);
        searchClientBtnRef.current.disabled = false;



        let fsData = (FundingSourceData[parseInt(selectedAff)] && 
        FundingSourceData[parseInt(selectedAff)] !== undefined ? 
        JSON.parse(FundingSourceData[parseInt(selectedAff)]) : []
        );
        let defaultFSSelected = (fsData.length > 0 ? fsData.find(item => parseInt(item.FID) === parseInt(FSTargetID)) : {});
        handleManualAmountOnFSChange(defaultFSSelected, parseInt(FSTargetID));
        if(response && response.error === "" && parseInt(response.data.responseCode) === 200)
        {
          let clientInfo = JSON.parse(response.data.responseJSON);
          liClientPhoneRefs.current = [];

          if(clientInfo.length > 1)
          {
            let sortedClientInfoList = clientInfo.sort((a,b)=>{

              const dateA = a.LastCallDate ? new Date(a.LastCallDate.split("T")[0] + " 00:00:00") : null;
              const dateB = b.LastCallDate ? new Date(b.LastCallDate.split("T")[0] + " 00:00:00") : null;
  
              if (!dateA && !dateB) return 0; // Both dates are empty
              if (!dateA) return 1; // Move entries with empty lastCall to the end
              if (!dateB) return -1; // Move entries with empty lastCall to the end
  
              return dateB - dateA; // Sort by date if both are valid (newest to oldest)
            });
            clientIndexRef.current = {index : 0, data : sortedClientInfoList[0]};
            setInputSuggestionListClientName("");

            let suggestionsHTML = sortedClientInfoList.map(function(item, index){
              liClientPhoneRefs.current[index] = React.createRef(); // Create a ref for each <li>
              let [year, month, day] = item.LastCallDate ?  item.LastCallDate.split("T")[0].split("-"): ["","",""]; 
              // let formattedName = (item.FirstName.length === 0? (item.LastName + (year !== "" ? " [Last Call: "+month+"/"+day+"/"+year+"]" : "")) : 
              //   ((item.LastName === "" ? item.FirstName: item.LastName+", "+item.FirstName) + (year !== "" ? " [Last Call: "+month+"/"+day+"/"+year+"]" : "")));

              const lastCallText = year ? ` [Last Call: ${month}/${day}/${year}]` : "";
              const riderIdText = ` [RiderId: ${item.MedicalId || -1}]`;
              const phoneText = item.HomePhone ? ` (${item.HomePhone})` : "";

              let searchedUserDetails = "";

              if (!item.FirstName) {
                searchedUserDetails = `${item.LastName}${riderIdText}${phoneText}${lastCallText}`;
              } else if (!item.LastName) {
                searchedUserDetails = `${item.FirstName}${riderIdText}${phoneText}${lastCallText}`;
              } else {
                searchedUserDetails = `${item.LastName}, ${item.FirstName}${riderIdText}${phoneText}${lastCallText}`;
              }

            const namePart = (
              <span style={{ backgroundColor: "#eaf6f0", padding: "2px 4px", borderRadius: "4px", fontWeight: "600" }}>
                {!item.FirstName
                  ? item.LastName
                  : !item.LastName
                  ? item.FirstName
                  : `${item.LastName}, ${item.FirstName}`}
              </span>
            );

            const riderIdPart = (
              <span style={{ backgroundColor: "#fff4db", padding: "2px 4px", borderRadius: "4px", marginLeft: "4px" }}>
                {riderIdText}
              </span>
            );

            const phonePart = phoneText && (
              <span style={{ backgroundColor: "#eaf3ff", padding: "2px 4px", borderRadius: "4px", marginLeft: "4px" }}>
                {phoneText}
              </span>
            );

            const lastCallPart = lastCallText && (
              <span style={{ backgroundColor: "#fceaea", padding: "2px 4px", borderRadius: "4px", marginLeft: "4px" }}>
                {lastCallText}
              </span>
            );

              return(
                <li ref={liClientPhoneRefs.current[index]} className="border-bottom text-nowrap overflow-hidden px-1 addressSelectionRow" 
                  onFocus={()=>{focusedSuggestionCheckClientPhone.current = true;}}
                  style={{cursor:"pointer"}} tabIndex={-1} onBlur={()=>{focusedSuggestionCheckClientPhone.current = false;}} onKeyDown={(e)=>{
                      if(e.key === 'ArrowDown')
                      {
                        e.preventDefault();
                        if(liClientPhoneRefs.current.length > 0)
                        {
                          setHighlightedIndex((prevIndex) => {
                            const newIndex = (prevIndex + 1) % liClientPhoneRefs.current.length;
                            liClientPhoneRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                            return newIndex;
                          });
                        }
                      }
                      else if (e.key === 'ArrowUp') {
                        e.preventDefault();
                        if(liClientPhoneRefs.current.length > 0)
                        {
                          setHighlightedIndex((prevIndex) => {
                            const newIndex = (prevIndex - 1 + liClientPhoneRefs.current.length) % liClientPhoneRefs.current.length;
                            liClientPhoneRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                            return newIndex;
                          });
                        }
                      }
                      else if(e.key === "Enter")
                      {
                        // setInputSuggestionListClientPhone("");
                        handleClientInfoGeneration(sortedClientInfoList[index]);
                      }
                    }}
                  onClick={()=>{handleClientInfoGeneration(sortedClientInfoList[index]);}} key={index} value={searchedUserDetails}
                >
                  {namePart}
                  {phonePart}
                  {riderIdPart}
                  {lastCallPart}
                </li>
              );
            });
            setInputSuggestionListClientPhone(suggestionsHTML);
          }
          else
          {
            if(clientInfo.length > 0)
              handleClientInfoGeneration(clientInfo[0]);
          }

        }
        else
        {
          setInputSuggestionListClientPhone("");
        }

        const ContextCallResponse = await APICom.fetchData("ReservationCoreURL",`api/CallTransferService/GetLatestContextTransfer/${(areaCode+"-"+firstPart+"-"+secondPart)}`, "get", 'accept: */*', null, xCancelSourceForGrid.current);
        if (ContextCallResponse.data.success) {
          const parsedData = JSON.parse(ContextCallResponse.data.data);
          //const ContextDateTime = moment(ContextCallResponse.data.contextRecordedDate, "M/D/YYYY h:mm A").format("M/D/YYYY h:mm A");
          if(parsedData && parsedData.length > 0)
          {
            setCTPanel(preState => ({...preState, ShowcontextPanel:true, ContextPanelData:parsedData, ContextPhoneNo:(areaCode+"-"+firstPart+"-"+secondPart)}));
          }
        }
      }
      else if(input.trim().length === 0)
      {
        setInputSuggestionListClientPhone("");
      }
      else
      {
        setInputSuggestionListClientPhone("");
      }
    }
    catch(err){console.log(err);}
  };

  const handleClientMedicalIDCheckChange = async (e) => {
    try{
      let input = e.target.value;
      const regex = /^[0-9\b]+$/;
      if(input.trim().length === 0 || regex.test(input.trim()))
      {
        setMedicalIDCheck(input);
      
        if(input.trim().length === 0)
        {
          setInputSuggestionListClientMedID("");
        }
      }
    }
    catch(err){console.log(err);}
  };

  const handleClientNameChangeGenerateList = async (input) => {
    try{
      if(isNaN(input))
      {
        let isContainedFilter = clientNameList.length > 0 ? clientNameList.filter((item, index)=>{
          let nameParts = (input.includes(" ") ? input.split(" ") : input);
          let fullName = (item.FirstName === "" ? item.LastName : item.FirstName + (item.LastName === "" ? "" : " " + item.LastName));
          return ((Array.isArray(nameParts) && nameParts.every(part=> fullName.toLowerCase().includes(part.toLowerCase()))) || 
            (!Array.isArray(nameParts) && fullName.toLowerCase().includes(nameParts.trim().toLowerCase())));
        }) : [];

        let response = "";
        let clientInfo = [];
        if(isContainedFilter.length === 0)
        {
          let selectedFamilyData = AffiliateData.filter((item)=>{
            if(parseInt(item.AffiliateID) === parseInt(selectedAff))
            {
              return true;
            }
          });
  
          let data = {
            "searchCriteria": "CustomerName",
            "searchText": input,
            "bActiveRecords": true,
            "iATSPID": selectedAff ? parseInt(selectedAff) : -1,
            "iDTSPID": selectedFamilyData ? parseInt(selectedFamilyData[0].DTSPID): -1,
          };
          searchClientFlagRef.current = true;
          setShowSearchLoader(true);
          searchClientBtnRef.current.disabled = true;
          response = await APICom.fetchData("ReservationCoreURL","SearchClientData", "post", {}, data, xCancelSourceForGrid.current);
          searchClientFlagRef.current = false;
          setShowSearchLoader(false);
          searchClientBtnRef.current.disabled = false;


          if(response && response.error === "" && parseInt(response.data.responseCode) === 200)
          {
            clientInfo = JSON.parse(response.data.responseJSON);
            setClientNameList(clientInfo);
          }
          else
          {
            setInputSuggestionListClientName("");
          }
        }
        else
        {
          clientInfo = [...isContainedFilter];
        }

        liClientNameRefs.current = [];
        if(clientInfo.length > 1)
        {
          let sortedClientInfoList = clientInfo.sort((a,b)=>{

            const dateA = a.LastCallDate ? new Date(a.LastCallDate.split("T")[0] + " 00:00:00") : null;
            const dateB = b.LastCallDate ? new Date(b.LastCallDate.split("T")[0] + " 00:00:00") : null;

            if (!dateA && !dateB) return 0; // Both dates are empty
            if (!dateA) return 1; // Move entries with empty lastCall to the end
            if (!dateB) return -1; // Move entries with empty lastCall to the end

            return dateB - dateA; // Sort by date if both are valid (newest to oldest)
          });
          clientIndexRef.current = {index : 0, data : sortedClientInfoList[0]};

          setInputSuggestionListClientPhone("");
          let suggestionsHTML = sortedClientInfoList.map(function(item, index){
            liClientNameRefs.current[index] = React.createRef(); // Create a ref for each <li>
            let [year, month, day] = item.LastCallDate ?  item.LastCallDate.split("T")[0].split("-"): ["","",""]; 
            // let formattedName = 
            //   item.FirstName.length === 0 ? (item.LastName+(item.HomePhone.length === 0 ? (year !== "" ? " [Last Call: "+month+"/"+day+"/"+year+"]" : "") :" ("+item.HomePhone+")"+(year !== "" ? " [Last Call: "+month+"/"+day+"/"+year+"]" : ""))) : 
            //   (item.LastName === "" ? item.FirstName: item.LastName+", "+item.FirstName) + (item.HomePhone.length === 0 ? (year !== "" ? " [Last Call: "+month+"/"+day+"/"+year+"]" : "") :" ("+item.HomePhone+")"+(year !== "" ? " [Last Call: "+month+"/"+day+"/"+year+"]" : ""));
            
              const lastCallText = year ? ` [Last Call: ${month}/${day}/${year}]` : "";
              const riderIdText = ` [RiderId: ${item.MedicalId || -1}]`;
              const phoneText = item.HomePhone ? ` (${item.HomePhone})` : "";

              let searchedUserDetails = "";

              if (!item.FirstName) {
                searchedUserDetails = `${item.LastName}${riderIdText}${phoneText}${lastCallText}`;
              } else if (!item.LastName) {
                searchedUserDetails = `${item.FirstName}${riderIdText}${phoneText}${lastCallText}`;
              } else {
                searchedUserDetails = `${item.LastName}, ${item.FirstName}${riderIdText}${phoneText}${lastCallText}`;
              }

            const namePart = (
              <span style={{ backgroundColor: "#eaf6f0", padding: "2px 4px", borderRadius: "4px", fontWeight: "600" }}>
                {!item.FirstName
                  ? item.LastName
                  : !item.LastName
                  ? item.FirstName
                  : `${item.LastName}, ${item.FirstName}`}
              </span>
            );

            const riderIdPart = (
              <span style={{ backgroundColor: "#fff4db", padding: "2px 4px", borderRadius: "4px", marginLeft: "4px" }}>
                {riderIdText}
              </span>
            );

            const phonePart = phoneText && (
              <span style={{ backgroundColor: "#eaf3ff", padding: "2px 4px", borderRadius: "4px", marginLeft: "4px" }}>
                {phoneText}
              </span>
            );

            const lastCallPart = lastCallText && (
              <span style={{ backgroundColor: "#fceaea", padding: "2px 4px", borderRadius: "4px", marginLeft: "4px" }}>
                {lastCallText}
              </span>
            );

        

            return(
              <li ref={liClientNameRefs.current[index]} className="border-bottom text-nowrap overflow-hidden px-1 addressSelectionRow" 
                onFocus={()=>{focusedSuggestionCheckClientName.current = true;}}
                style={{cursor:"pointer"}} tabIndex={-1} onBlur={()=>{focusedSuggestionCheckClientName.current = false;}} onKeyDown={(e)=>{
                    if(e.key === 'ArrowDown')
                    {
                      e.preventDefault();
                      if(liClientNameRefs.current.length > 0)
                      {
                        setHighlightedIndex((prevIndex) => {
                          const newIndex = (prevIndex + 1) % liClientNameRefs.current.length;
                          liClientNameRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                          return newIndex;
                        });
                      }
                    }
                    else if (e.key === 'ArrowUp') {
                      e.preventDefault();
                      if(liClientNameRefs.current.length > 0)
                      {
                        setHighlightedIndex((prevIndex) => {
                          const newIndex = (prevIndex - 1 + liClientNameRefs.current.length) % liClientNameRefs.current.length;
                          liClientNameRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                          return newIndex;
                        });
                      }
                    }
                    else if(e.key === "Enter")
                    {
                      // setInputSuggestionListClientName("");
                      handleClientInfoGeneration(sortedClientInfoList[index]);
                    }
                  }}
                onClick={()=>{handleClientInfoGeneration(sortedClientInfoList[index]);}} key={index} value={searchedUserDetails}
              >
                {/* {searchedUserDetails} */}
                {namePart}
                {phonePart}
                {riderIdPart}
                {lastCallPart}
              </li>
            );
            
          });
          setInputSuggestionListClientName(suggestionsHTML);
        }
        else
        {
          if(clientInfo.length > 0)
            handleClientInfoGeneration(clientInfo[0]);
        }
      }
    }
    catch(err){console.log(err);}
  };

  const handleClientNameChange = async (e) => {
    try{
      setRiderNameCheck(e.target.value);
      let input = e.target.value;
      let trimmedInput = input.trim();
      let lastInput = trimmedInput;
      let elapsed = 0;
      let timerInterval = 200;
      if(trimmedInput.length === 0)
      {
        setClientNameList([]);
        setInputSuggestionListClientName("");
      }
      if(debounceTimeout.current){clearInterval(debounceTimeout.current);}
      debounceTimeout.current = setInterval(async () => {
        if(lastInput === riderNameCheck.trim())
        {
          elapsed += 100; //No change
        }
        else
        {
          //A change occured, reset timer
          lastInput = riderNameCheck.trim();
          elapsed = 0;
        }

        if(elapsed >= timerInterval && searchClientFlagRef.current === false && !showSearchLoader)
        {
          clearInterval(debounceTimeout.current);
          if(trimmedInput.length >= 3)
          {
            searchClientBtnRef.current.disabled = true;
            setShowSearchLoader(true);
            await handleClientNameChangeGenerateList(trimmedInput);
            setShowSearchLoader(false);
            searchClientBtnRef.current.disabled = false;
          }
        }
      }, timerInterval);
      
    }
    catch(err){console.log(err);}
  };

  const handleSearchCustomerPhone = async (givenData = "", OpenMultipleDialog = true, clientID = 0) => {
    try{
      if(affiliateSelRef.current.options.length !== affiliateDropDownHTML.length)
      {
        let loginUserAffiliateList = (loginData.UserAffiliateList.includes(",")? loginData.UserAffiliateList.split(",") : [loginData.UserAffiliateList]);
        let affiliateOptionsHTML = AffiliateData.map(function(item, index){
          if(loginUserAffiliateList.includes(String(item.AffiliateID)))
          {
            return (
              <option key={index} value={item.AffiliateID}>{item.AffiliateCompany}</option>
            );
          }
        });
        setAffiliateDropDownHTML(affiliateOptionsHTML);  
      }
      clientNameCheckRef.current.blur();
      setMedicalIDCheck("");
      phoneRef.current.blur();
      if(!clientInfoDisplay)
      {
        setClientInfoDisplay(true);
      }
      setSearchButtonValidation("");
      searchButtonValidationRef.current = '';
      if((phone && phone.length >= 12) || givenData !== "")
      {
        searchClientBtnRef.current.disabled = true;
        let selectedFamilyData = AffiliateData.filter((item)=>{
          if(parseInt(item.AffiliateID) === parseInt(selectedAff))
          {
            return true;
          }
        });
        let areaCode = (givenData !== "" ? "" : phone.replace("+1","").substring(0,3));
        let firstPart = (givenData !== "" ? "" : phone.replace("+1","").substring(3,6));
        let secondPart = (givenData !== "" ? "" : phone.replace("+1","").substring(6,10));
        let data = {
          "searchCriteria": "CustomerPhone",
          "searchText": (givenData !== "" ? givenData : (areaCode+"-"+firstPart+"-"+secondPart)),
          "bActiveRecords": true,
          "iATSPID": selectedAff ? parseInt(selectedAff) : -1,
          "iDTSPID": selectedFamilyData ? parseInt(selectedFamilyData[0].DTSPID): -1,
        };
        setModalHeaderText("Client Info Processing");
        setModalBodyHTML("Please wait...");
        setModalFooterHTML(
          <>
            <Button variant='dark' className="border-0" onClick={()=>{setShowDynamicModal(false);}}>
              OK
            </Button>
          </>
        );
        setShowDynamicModal(true);
        setModalClass("d-none");
        setShowAPILoader(true);
        searchClientFlagRef.current = true;
        let response = await APICom.fetchData("ReservationCoreURL","SearchClientData", "post", {}, data, xCancelSourceForGrid.current);
        searchClientFlagRef.current = false;



        if(response && response.error === "" && parseInt(response.data.responseCode) === 200)
        {
          searchClientBtnRef.current.disabled = false;
          let clientInfo = JSON.parse(response.data.responseJSON);
          setSearchButtonValidation("");
          searchButtonValidationRef.current = '';
          if(clientInfo.length > 1 && OpenMultipleDialog)
          {
            let sortedClientInfoList = clientInfo.sort((a,b)=>{

              const dateA = a.LastCallDate ? new Date(a.LastCallDate.split("T")[0] + " 00:00:00") : null;
              const dateB = b.LastCallDate ? new Date(b.LastCallDate.split("T")[0] + " 00:00:00") : null;
  
              if (!dateA && !dateB) return 0; // Both dates are empty
              if (!dateA) return 1; // Move entries with empty lastCall to the end
              if (!dateB) return -1; // Move entries with empty lastCall to the end
  
              return dateB - dateA; // Sort by date if both are valid (newest to oldest)
            });
            clientIndexRef.current = {index : 0, data : sortedClientInfoList[0]};
            setInputSuggestionListClientName("");
            setInputSuggestionListClientPhone("");
            setInputSuggestionListClientMedID("");
            setModalHeaderText("Client Info Selection");
            setModalBodyHTML(
              <>
                <p className="m-0 user-select-none">
                  {"Please select the desired client from the following options with provided phone number: "}
                  <span className="fw-bold text-center user-select-none">{("("+areaCode+") "+firstPart+"-"+secondPart)}</span> 
                </p>
                <Row className="m-0 justify-content-center">
                  <select className='text-left m-1 px-1 w-100 overflow-hidden' style={{textOverflow:"ellipsis"}}
                    onChange={(e)=>{clientIndexRef.current = {index : e.target.value, data : sortedClientInfoList[parseInt(e.target.value)]};}}
                  >
                    <option disabled hidden value={999}>{"Select Client"}</option>
                    {sortedClientInfoList.map(function(item, index){
                      let [year, month, day] = item.LastCallDate ?  item.LastCallDate.split("T")[0].split("-"): ["","",""]; 
                      let formattedName = (item.FirstName === "" ? item.LastName.trim() : (item.LastName === "" 
                        ? (item.FirstName.trim().includes(",") ? item.FirstName.split(",")[1].trim()+", "+item.FirstName.split(",")[0].trim(): item.FirstName.trim())  
                        : item.LastName.trim()+", "+item.FirstName.trim()));
                      return(
                        <option key={index} value={index}>
                          
                          {/* {formattedName + (item.HomePhone.length === 0 ? (year !== "" ? " [Last Call: "+month+"/"+day+"/"+year+"]" : "")
                          :" ("+item.HomePhone+")"+(year !== "" ? " [Last Call: "+month+"/"+day+"/"+year+"]" : ""))} */}

                          {formattedName +
                              (item.HomePhone.length === 0
                                ? (year !== ""
                                    ? ` [Last Call: ${month}/${day}/${year}]`
                                    : "")
                                : ` (${item.HomePhone}) [RiderId: ${item.MedicalId || -1}]${
                                    year !== "" ? ` [Last Call: ${month}/${day}/${year}]` : ""
                                  }`)}
                          
                          </option>
                      );
                    })}
                  </select>
                </Row>
              </>
            );
            setModalFooterHTML(
              <>
                <Button variant='dark' className="border-0" onClick={()=>{handleClientInfoGeneration(sortedClientInfoList[parseInt(clientIndexRef.current.index)]);}}>
                  OK
                </Button>
              </>
            );
            setShowDynamicModal(true);
            setModalClass("");
            setShowAPILoader(false);
          }
          else
          {
            const resultClient =  (clientID !== 0 ? clientInfo.find((item)=>parseInt(item.id) === parseInt(clientID)) : null);
            let validData = (clientInfo.length > 1 ? (resultClient? resultClient : clientInfo[0]) : clientInfo[0]);
            setModalClass("");
            setShowDynamicModal(false);
            setShowAPILoader(false);
            handleClientInfoGeneration(validData);
          }
        }
        else
        {
          setModalClass("");
          setShowAPILoader(false);
          searchClientBtnRef.current.disabled = false;
          if(response && response.error === "") //no client found
          {
            setSearchButtonValidation("No client found");
            searchButtonValidationRef.current = 'none';
            // riderNameRef.current.focus();
            setTimeout(() => {
              setSearchButtonValidation("");
            }, 5000);
            setMainInfoNewClient({type: 'phone', value: phone});
            setTimeout(() => {
              setModalHeaderText("New Client Alert");
              setModalBodyHTML("The client profile does not exist, please create a new client profile before booking a trip.");
              setModalFooterHTML(
                <>
                  <Button variant='dark' className="border-0" onClick = {()=>{handleNewClientManualLoad(); setShowDynamicModal(false);}}>
                    Continue
                  </Button>
                  <Button variant='secondary' className="border-0" onClick = {()=>{setShowDynamicModal(false); riderNameRef.current.focus();}}>
                    Cancel
                  </Button>
                </>
              );
              setShowDynamicModal(true);
            }, 200);
          }
          else
          {
            setShowDynamicModal(false);
            setSearchButtonValidation(response.error);
            searchButtonValidationRef.current = '';
            setTimeout(() => {
              setSearchButtonValidation("");
            }, 5000);
          }
        }
      }
      else
      {
        setSearchButtonValidation("Please enter the complete phone number/name");
        searchButtonValidationRef.current = '';
        setTimeout(() => {
          setSearchButtonValidation("");
        }, 5000);
      }
    }
    catch(err){console.log(err);}
  };

  const handleNameInputOnChange = (e) => {
    try{
      let value = e.target.value;
      let specialChar = /[^a-zA-Z0-9\s,]/g;
      let santizedValue = value.replace(specialChar, '');
      if(santizedValue.includes(","))
      {
        let numberOfComma = (santizedValue.match(/,/g) || []).length;
        if(numberOfComma > 1)
        {
          const firstCommaIndex = santizedValue.indexOf(',');
          // Split the string into two parts: before and after the first comma
          const beforeFirstComma = santizedValue.slice(0, firstCommaIndex + 1);
          const afterFirstComma = santizedValue.slice(firstCommaIndex + 1);

          // Remove all commas from the part after the first comma
          const afterFirstCommaWithoutCommas = afterFirstComma.replace(/,/g, '');

          // Concatenate the parts and return the result
          santizedValue = beforeFirstComma + afterFirstCommaWithoutCommas;
        }
      }
      setRiderName(santizedValue);
    }
    catch(err){
      console.log(err); 
      let value = e.target.value;
      let specialChar = /[^a-zA-Z0-9\s,]/g;
      let santizedValue = value.replace(specialChar, '');
      setRiderName(santizedValue);
    }
  };

  function SetClientAdditionalInfo (additionalInfo = ""){
    try {
      setPaymentAdditionalInfo(prev => {
        if (!prev) {
          return additionalInfo; // Set if empty
        }
        return `${prev}\n${additionalInfo}`; // Append with newline
      });

    } catch (error) {
      
    }
  }

  function GetAndUpdateCustomerProfilePsngrCount(data){

    let iAmbulatoryCount = data.iAmbulatoryCount;
    let iWheelChairCount = data.iWheelChairCount;
    
    let iAmbulatoryPCACount = data.iAmbulatoryPCACount;
    let iWheelChairPCACount = data.iWheelChairPCACount;
    
    let PrimaryData = {};
    let PCAData = [];
    let GuestData = [];
    let _isMobilityData = false;


    ////Section to Read counts When Mobility Attributes//
    if(refMobilityAttributeOptions.current != undefined && refMobilityAttributeOptions.current != [] 
      && refMobilityAttributeOptions.current != null && refMobilityAttributeOptions.current?.length > 0){
        _isMobilityData = true;
      if(iAmbulatoryCount == 1 && iWheelChairCount == 0){
        let ambAttribute = "";
        mobilityDbData.Primary.Name = "Primary";
        if(refMobilityAttributeOptions.current){
          ambAttribute = refMobilityAttributeOptions.current.find(p => p.value == "Ambulatory" || p.value == "Amb" || p.value == "amb" || p.value == "amb." || p.value == "Amb.")
        }
        if(ambAttribute != undefined){
          mobilityDbData.Primary.Attributes = ambAttribute.key;
        }
        mobilityDbData.Primary.selectedAttribute = ambAttribute.key;
        mobilityDbData.Primary.selectedLabel = "Primary";
        mobilityDbData.Primary.type = "primary";
        mobilityDbData.Primary.index = 0;
        mobilityDbData.Primary.key = CommonFunctions.GenerateUUID();
        PrimaryData =  structuredClone(mobilityDbData.Primary);
      }
      else if(iAmbulatoryCount == 0 && iWheelChairCount == 1){
        let ambAttribute = "";
        mobilityDbData.Primary.Name = "Primary";
        if(refMobilityAttributeOptions.current){
          ambAttribute = refMobilityAttributeOptions.current.find(p => p.value == "Wheelchair" || p.value == "wc" || p.value == "WC" || p.value == "Wchair" || p.value == "WC.")
        }
        if(ambAttribute != undefined){
          mobilityDbData.Primary.Attributes = ambAttribute.key;
        }
        mobilityDbData.Primary.selectedAttribute = ambAttribute.key;
        mobilityDbData.Primary.selectedLabel = "Primary";
        mobilityDbData.Primary.type = "primary";
        mobilityDbData.Primary.index = 0;
        mobilityDbData.Primary.key = CommonFunctions.GenerateUUID();
        PrimaryData =  structuredClone(mobilityDbData.Primary);
      }
      else if (iAmbulatoryCount == 1 && iWheelChairCount == 1){
        let ambAttribute = "";
        mobilityDbData.Primary.Name = "Primary";
        if(refMobilityAttributeOptions.current){
          ambAttribute = refMobilityAttributeOptions.current.find(p => p.value == "Ambulatory" || p.value == "Amb" || p.value == "amb" || p.value == "amb." || p.value == "Amb.")
        }
        if(ambAttribute != undefined){
          mobilityDbData.Primary.Attributes = ambAttribute.key;
        }
        mobilityDbData.Primary.selectedAttribute = ambAttribute.key;
        mobilityDbData.Primary.selectedLabel = "Primary";
        mobilityDbData.Primary.type = "primary";
        mobilityDbData.Primary.index = 0;
        mobilityDbData.Primary.key = CommonFunctions.GenerateUUID();
        PrimaryData =  structuredClone(mobilityDbData.Primary);


        const itemsToGenerate = { Guests_WC: iWheelChairCount };
        const generateData = generateRows(mobilityAttributeOptions, itemsToGenerate);
        if(generateData){
          GuestData.push(...generateData);
        }

      }
      else if(iAmbulatoryCount == 1 && iWheelChairCount == 0){
        let ambAttribute = "";
        mobilityDbData.Primary.Name = "Primary";
        if(refMobilityAttributeOptions.current){
          ambAttribute = refMobilityAttributeOptions.current.find(p => p.value == "Ambulatory" || p.value == "Amb" || p.value == "amb" || p.value == "amb." || p.value == "Amb.")
        }
        if(ambAttribute != undefined){
          mobilityDbData.Primary.Attributes = ambAttribute.key;
        }
        mobilityDbData.Primary.selectedAttribute = ambAttribute.key;
        mobilityDbData.Primary.selectedLabel = "Primary";
        mobilityDbData.Primary.type = "primary";
        mobilityDbData.Primary.index = 0;
        mobilityDbData.Primary.key = CommonFunctions.GenerateUUID();
        PrimaryData =  structuredClone(mobilityDbData.Primary);
      }
      else if (iAmbulatoryCount >= 1 && iWheelChairCount >= 1){
        
        let ambAttribute = "";
        mobilityDbData.Primary.Name = "Primary";
        if(refMobilityAttributeOptions.current){
          ambAttribute = refMobilityAttributeOptions.current.find(p => p.value == "Ambulatory" || p.value == "Amb" || p.value == "amb" || p.value == "amb." || p.value == "Amb.")
        }
        if(ambAttribute != undefined){
          mobilityDbData.Primary.Attributes = ambAttribute.key;
        }
        mobilityDbData.Primary.selectedAttribute = ambAttribute.key;
        mobilityDbData.Primary.selectedLabel = "Primary";
        mobilityDbData.Primary.type = "primary";
        mobilityDbData.Primary.index = 0;
        mobilityDbData.Primary.key = CommonFunctions.GenerateUUID();
        PrimaryData =  structuredClone(mobilityDbData.Primary);

        let remainingAmbGuests = iAmbulatoryCount - 1;
        let remainingWCGuests = iWheelChairCount;

        const itemsToGenerate = { Guest: remainingAmbGuests, Guests_WC: remainingWCGuests };
        const generateData = generateRows(mobilityAttributeOptions, itemsToGenerate);
        if(generateData){
          GuestData.push(...generateData);
        }
      }
      else if (iAmbulatoryCount >= 1 && iWheelChairCount == 0){
        
        let ambAttribute = "";
        mobilityDbData.Primary.Name = "Primary";
        if(refMobilityAttributeOptions.current){
          ambAttribute = refMobilityAttributeOptions.current.find(p => p.value == "Ambulatory" || p.value == "Amb" || p.value == "amb" || p.value == "amb." || p.value == "Amb.")
        }
        if(ambAttribute != undefined){
          mobilityDbData.Primary.Attributes = ambAttribute.key;
        }
        mobilityDbData.Primary.selectedAttribute = ambAttribute.key;
        mobilityDbData.Primary.selectedLabel = "Primary";
        mobilityDbData.Primary.type = "primary";
        mobilityDbData.Primary.index = 0;
        mobilityDbData.Primary.key = CommonFunctions.GenerateUUID();
        PrimaryData =  structuredClone(mobilityDbData.Primary);

        let remainingAmbGuests = iAmbulatoryCount - 1;

        const itemsToGenerate = { Guest: remainingAmbGuests };
        const generateData = generateRows(mobilityAttributeOptions, itemsToGenerate);
        if(generateData){
          GuestData.push(...generateData);
        }
      }
      else if (iAmbulatoryCount == 0 && iWheelChairCount >= 1){
        
        let ambAttribute = "";
        mobilityDbData.Primary.Name = "Primary";
        if(refMobilityAttributeOptions.current){
          ambAttribute = refMobilityAttributeOptions.current.find(p => p.value == "Wheelchair" || p.value == "wc" || p.value == "WC" || p.value == "Wchair" || p.value == "WC.")
        }
        if(ambAttribute != undefined){
          mobilityDbData.Primary.Attributes = ambAttribute.key;
        }
        mobilityDbData.Primary.selectedAttribute = ambAttribute.key;
        mobilityDbData.Primary.selectedLabel = "Primary";
        mobilityDbData.Primary.type = "primary";
        mobilityDbData.Primary.index = 0;
        mobilityDbData.Primary.key = CommonFunctions.GenerateUUID();
        PrimaryData =  structuredClone(mobilityDbData.Primary);

        let remainingAmbGuests = iWheelChairCount - 1;

        const itemsToGenerate = { Guests_WC: remainingAmbGuests };
        const generateData = generateRows(mobilityAttributeOptions, itemsToGenerate);
        if(generateData){
          GuestData.push(...generateData);
        }
      }
      else{
        let ambAttribute = "";
        mobilityDbData.Primary.Name = "Primary";
        if(refMobilityAttributeOptions.current){
          ambAttribute = refMobilityAttributeOptions.current.find(p => p.value == "Ambulatory" || p.value == "Amb" || p.value == "amb" || p.value == "amb." || p.value == "Amb.")
        }
        if(ambAttribute != undefined){
          mobilityDbData.Primary.Attributes = ambAttribute.key;
        }
        mobilityDbData.Primary.selectedAttribute = ambAttribute.key;
        mobilityDbData.Primary.selectedLabel = "Primary";
        mobilityDbData.Primary.type = "primary";
        mobilityDbData.Primary.index = 0;
        mobilityDbData.Primary.key = CommonFunctions.GenerateUUID();
        PrimaryData =  structuredClone(mobilityDbData.Primary);
      }

      if(iAmbulatoryPCACount >= 1 || iWheelChairPCACount >= 1){
        const itemsToGenerate = { PCA: iAmbulatoryPCACount, PCA_WC: iWheelChairPCACount };
        const generateData = generateRows(mobilityAttributeOptions, itemsToGenerate);
        if(generateData){
          PCAData.push(...generateData);
        } 
      }
    }

    setMobilitySavedData(
      updateIndexes({
        ...mobilitySavedData,
        Primary: PrimaryData,
        PCA: PCAData,
        Guests: GuestData,
        Children: [],
        IsMobility: _isMobilityData
      })
    );

    setMobilityDbData(
      updateIndexes({
        ...mobilitySavedData,
        Primary: PrimaryData,
        PCA: PCAData,
        Guests: GuestData,
        Children: [],
        IsMobility: _isMobilityData
      })
    );

    let _iAmbulatoryCount = iAmbulatoryCount;
    if(iAmbulatoryCount <= 0){
      _iAmbulatoryCount = 1;
    }

    setPassengerTypeCount(
      { ...passengerTypeCount,
        ambPass: (iAmbulatoryPCACount + iWheelChairPCACount + _iAmbulatoryCount + iWheelChairCount),
        totalWC: parseInt(iWheelChairPCACount + iWheelChairCount),
        total: (iAmbulatoryPCACount + iWheelChairPCACount + _iAmbulatoryCount + iWheelChairCount), 
      });

    setMobilityPassengers({...mobilityPassengers,  passenger: (iAmbulatoryPCACount + iWheelChairPCACount + _iAmbulatoryCount + iWheelChairCount)});
    }
   
  

  const handleClientInfoGeneration = async (data, showActiveTrips = true) =>{
    try{
      if(data)
      {
        if(data?.Remarks){
          SetClientAdditionalInfo(data.Remarks);
        }
      

        searchedClientID.current = data.Id;
        let loginUserAffiliateList = (loginData.UserAffiliateList.includes(",")? loginData.UserAffiliateList.split(",") : [loginData.UserAffiliateList]);
        let checkingDataCompany = AffiliateData.find(item=>item.AffiliateID === parseInt(selectedAff));
        let affiliateOptionsHTML = AffiliateData.map(function(item, index){
          if(loginUserAffiliateList.includes(String(item.AffiliateID)) && item.vATSPGroupName === checkingDataCompany.vATSPGroupName)
          {
            return (
              <option key={index} value={item.AffiliateID}>{item.AffiliateCompany}</option>
            );
          }
        });
        setInputSuggestionListClientPhone("");
        setInputSuggestionListClientMedID("");
        setInputSuggestionListClientName("");
        
        phoneRef.current.disabled = true;
        clientNameCheckRef.current.disabled = true;
        clientMedIDCheckRef.current.disabled = true;
        let riderNameParse = (data.FirstName && data.FirstName !== "" ? data.FirstName + (data.LastName && data.LastName !== "" ? " "+data.LastName : "")
          : (data.LastName && data.LastName !== "" ? data.LastName : ""));

        const FSOption = (data.FS_ID && String(data.FS_ID) !== "" && String(data.FS_ID) !== "-1" ? 
          FSDropdown.find((option)=> (option?.props && parseInt(option.props.value) === parseInt(data.FS_ID))) : null
        );

        if((!phone || phone.length < 12) && showActiveTrips)
          setPhone(("+1"+data.HomePhone.replaceAll("-","")));
        phoneRef.current.style.borderColor = "";
        phoneRef.current.style.borderWidth = "";
        riderNameRef.current.style.borderColor = "";
        riderNameRef.current.style.borderWidth = "";
        if((!callBackPhone || callBackPhone.length < 12) && showActiveTrips)
          setCallBackPhone(("+1"+data.HomePhone.replaceAll("-","")));
        setClientInfo(data);
        PersistStorage.save("clientInfo", data, 99, true); 
        if(showActiveTrips)
        {
          if(FSOption)
          {
            handleFSSelectionChange("", "fs", FSOption, data.MedicalId); //Change FS to client's FS
          }
          setAffiliateDropDownHTML(affiliateOptionsHTML); 
          setRiderName(riderNameParse);
          setAccountNumber(data.Id);
          setAgentNotes((data.Notes || ""));
          setMedID((data.MedicalId ? data.MedicalId : ""));
          // riderNameRef.current.focus();
          riderNameRef.current.disabled = true;
          setClientSummary(prevState=>({...prevState, totalCancels:parseInt(data.TotalCancelled), lastCall: String(data.LastCallDate)}));
          setPassengerTypeCount({...passengerTypeCount, totalWC:parseInt(/*data.iWheelChairCount*/ 0)}); // Note: Needs to handle it properly (****)
          setRCType({phoneType:!data.PhoneCall, emailType:!data.Email, SMSType:!data.SMS});
          setRiderNameCheck(riderNameParse);
          setMedicalIDCheck(data.MedicalId);
          setClientEmail(data.CustomerEmail)
          setModalHeaderText("Existing Client Rides Processing");
          setModalBodyHTML("Please wait...");
          setModalFooterHTML(
            <>
              <Button variant='dark' className="border-0" onClick={()=>{setShowDynamicModal(false);}}>
                OK
              </Button>
            </>
          );
          setShowDynamicModal(true);
          setModalClass("d-none");
          setShowAPILoader(true);
          
          let activeTripsData = {
            "searchCriteria": "CustomerID",
            "searchText": String(data.Id),
            "iATSPID": selectedAff ? parseInt(selectedAff) : -1,
            "iUserID": loginData.recordID ? loginData.recordID : -1
          };
          let response = await APICom.fetchData("ReservationCoreURL","GetExistingRides", "post", {}, activeTripsData, xCancelSourceForGrid.current);

          setShowAPILoader(false);
          if(response && response.error === "")
          {
            if(parseInt(response.data.responseCode) === 200)
            {
              setShowClientActiveTripsModal(true);
              
              //Grid Settings
              if(response.data?.gridJSON != undefined && response.data?.gridJSON != null){
                let responseJSON = JSON.parse(response.data.gridJSON);
                setClientActiveTripsColData(responseJSON)
              }
              
              let responseJSON = JSON.parse(response.data.responseJSON);
              setActiveTripsTableData(responseJSON);
              setShowDynamicModal(false);
              setModalClass("");
            }
            else
            {
              setModalClass("");
              setShowDynamicModal(false);
              setSearchButtonValidation("No active trips found");
              setTimeout(() => {
                setSearchButtonValidation("");
              }, 5000);
            }
          }
          else
          {
            setModalClass("");
            setShowDynamicModal(false);
            setSearchButtonValidation("An error occured when retrieving active trips");
            setTimeout(() => {
              setSearchButtonValidation("");
            }, 5000);
          }
        }
        let customerConfiguredCounts = GetAndUpdateCustomerProfilePsngrCount(data);
        
        let ClientAddrData = {
          "clientID": String(data.Id),
          "affiliateID": selectedAff ? String(selectedAff) : -1
        };


        let recentAddresses = await APICom.fetchData("ReservationCoreURL","GetHistoricRides", "post", {}, ClientAddrData, xCancelSourceForGrid.current);
        if(recentAddresses && recentAddresses.error === "")
        {
          if(parseInt(recentAddresses.data.responseCode) === 200)
          {
            let recentAddrArray = JSON.parse(recentAddresses.data.responseJSON);
            if(recentAddrArray.length > 0)
            {
              setRecentAddresses(recentAddrArray);
            }
          }
        }
        setTimeout(() => {
          riderNameRef.current.disabled = false;
          riderNameRef.current.focus();
        }, 400);
        
      }
      else
      {
        clientNameCheckRef.current.focus();
      }
    }
    catch(err){console.log(err);}
  };

  const handleClientInfoTableOpen = ()=>{
    try{
      console.log("table reload");
    }
    catch(Err){console.log(Err);}
  };

  const handleValidationMsg = (e) => {
    try{
      setShowDynamicModal(false); //RCZ validation for getting walk distance, validate addresses for microtransit
      if((dropAddrVirtualStop !== undefined && dropAddrVirtualStop && dropAddrVirtualStop?.value !== "" &&  dropAddrVirtualStop?.value)
        && (pickupVirtualStop !== undefined && pickupVirtualStop && pickupVirtualStop?.value !== "" &&  pickupVirtualStop?.value))
      {
        setShowAPILoader(true);
        wrapperHandleRCZVerification("DO", dropAddrVirtualStop.name);
      }
    }
    catch(err){console.log(err);}
  };

  const validateMinScheduleTimeDifference = async(_schTime = undefined, bApptTimeRemove = false, bCalculated = false, booking='',
   bookingCCParams = {bCallAfterCCCheck : false, iNewRefID : -1, iNewReturnRefID: -1}) => {
    try 
    {
      let tempSchTime = schTime;
      if (_schTime && _schTime !== undefined) {
        setSchTime(_schTime);
        tempSchTime = _schTime;
      }
      setShowAPILoader(true);
      let ScheduleTripMinTimeDiff = parseInt((JSON.parse(ASCSSettingData[selectedAff]).find((item) => item.SubTitle === "ScheduleTripMinTimeDiff")).value);
      let date = PersistStorage.retrieve("selectedDate", true);
      let [year, month, day] = (date && date.includes("-")? date.split("-").map(num => parseInt(num)) : ["", "", ""]);
      let newDate = "";
      if(year !== "")
      {
        month = String(month).padStart(2, "0");
        day = String(day).padStart(2, "0");
        newDate = `${year}-${month}-${day}`;
      }

      try {
        if(scheduleJSON?.mainData?.Schedule?.ScheduleItem?.length > 0){
          setIsTimeValidated(true);
          setShowAPILoader(false);

          if(booking === 'book')
              handleCreateUpdateParatransitTrip(true, bookingCCParams);
            else if(booking === 'leg')
            {
              timeValidateCheck.current = true;
              addLegBtnRef.current.click();
            }
          return 0;
        }
        
      } catch (error) {
        
      }

      if (ScheduleTripMinTimeDiff !== undefined) {
        const options = {timeZone: 'America/New_York', month: '2-digit', day: '2-digit', year: 'numeric' };
        let data = {};
        if(bookBtnRef.current)
        {
          let currDate = (systemDateTime.date !== "" ? systemDateTime.date : newDate);
          data = {
            "PickupDateTime": currDate + " " + tempSchTime,
            "MinSchTimeDiff": ScheduleTripMinTimeDiff
          }
          if(tempSchTime === "")
          {
            setIsTimeValidated(true);
            // bookBtnRef.current.disabled = false;
            handleValidationMsg();
            setShowAPILoader(false);
            return 0;
          }
        }
        else
        {
          //Paratransit date
          data = {
            "PickupDateTime": selectedDateSchTime + " " + tempSchTime,
            "MinSchTimeDiff": ScheduleTripMinTimeDiff
          }
          const queryParams = new URLSearchParams(window.location.search);
          const tripSelected = queryParams.get('TripSelected') || activeTripSelected? true:false;
          let editRowData = (((PersistStorage.retrieve("rowDataEditTrip", true)  && tripSelected) || (PersistStorage.retrieve("rowDataEditTrip", true)))? PersistStorage.retrieve("rowDataEditTrip", true):"");
          let date = PersistStorage.retrieve("selectedDate", true);
          let [year, month, day] = (date && date.includes("-")? date.split("-").map(num => parseInt(num)) : ["", "", ""]);
          let newDate = "";
          if(year !== "")
          {
            month = String(month).padStart(2, "0");
            day = String(day).padStart(2, "0");
            newDate = `${year}-${month}-${day}`;
          }
          let currDate = (systemDateTime.date !== "" ? systemDateTime.date : newDate);
          if(editRowData !== "" && !(editRowData.addressInfo.trips[0].details[0].dateInfo.isScheduled))
          {
            if(booking === 'book')
              handleCreateUpdateParatransitTrip(true, bookingCCParams);
            else if(booking === 'leg')
            {
              timeValidateCheck.current = true;
              addLegBtnRef.current.click();
            }
            return 0;
          }
          else if(tempSchTime === "" && schTime === "" && selectedDateSchTime !== "" && currDate !== "")
          {
            let todayDate = new Date(currDate+" 00:00:00");
            let givenDate = new Date(selectedDateSchTime+" 00:00:00");
            if(givenDate >= todayDate || scheduleJSON.mainData.Schedule.ScheduleItem.length > 0)
            {
              setIsTimeValidated(true);
              setShowAPILoader(false);
              if(booking === 'book')
                handleCreateUpdateParatransitTrip(true, bookingCCParams);
              else if(booking === 'leg')
              {
                timeValidateCheck.current = true;
                addLegBtnRef.current.click();
              }
              
              return 0;
            }
          }
        }
        let response = await APICom.fetchData("ReservationCoreURL","ValiateMinScheduleTimeDifference", "post", {}, data, xCancelSourceForGrid.current);
        // console.log("validateTime response: ", response);
        if(response && response.error.length === 0)
        {
          if(response.data.responseCode === 400)
          {
            if(scheduleJSON.mainData !== "" && scheduleJSON.neverExpire)
            {
              if(booking === 'book')
                handleCreateUpdateParatransitTrip(true, bookingCCParams);
            }
            else
            {
              setIsTimeValidated(false);
              if(bookBtnRef.current)
              {
                bookBtnRef.current.disabled = true;
              }
              // else if(paratransitBookBtnRef.current)
              // {
              //   paratransitBookBtnRef.current.disabled = true;
              //   addLegBtnRef.current.disabled = true;
              // }
              setModalHeaderText("Schedule Date & Time");
              let formattedDate = (selectedDateSchTime !== "" ? formatDate(selectedDateSchTime) : formatDate(newDate));
              let pickupTimeText = (bCalculated ? "Pickup Time Calculated: " : "Pickup Time Entered: ");
              setModalBodyHTML(<><p>{pickupTimeText}<b>{formattedDate + " " + tempSchTime}</b></p><p className="m-0">{response.data.responseMessage}</p></>);
              setModalFooterHTML(
                <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                  OK
                </Button>
              );
              setShowDynamicModal(true);
              setModalClass("");
            }
          }
          else if(response.data.responseCode === 200 && pickLatLng.current !== "" && dropLatLng.current !== "")
          {
            setIsTimeValidated(true);
            if(bookBtnRef.current)
            {
              bookBtnRef.current.disabled = false;
              handleValidationMsg();
            }
            else if(paratransitBookBtnRef.current)
            {
              // if(bApptTimeRemove)
              // {
              //   setAppointmentTime("");
              // }
              paratransitBookBtnRef.current.disabled = false;
              addLegBtnRef.current.disabled = false;
              if(booking === 'book')
                handleCreateUpdateParatransitTrip(true, bookingCCParams);
              else if(booking === 'leg')
              {
                timeValidateCheck.current = true;
                addLegBtnRef.current.click();
              }
            }
          }
        }
        setShowAPILoader(false);
      }
    } 
    catch (error) { 
      console.log(error);
      setIsTimeValidated(false);   
      if(bookBtnRef.current)
      {
        bookBtnRef.current.disabled = true;
      }
      else if(paratransitBookBtnRef.current)
      {
        paratransitBookBtnRef.current.disabled = true;
        addLegBtnRef.current.disabled = true;
      }
      setShowAPILoader(false);
    }
  };

  function addsubtractMinutesFromMilitaryTime(time24, minutesToSubtract, minutesToAdd = 0) {
    try{
      // Split hours and minutes from the input time
      const [hours, minutes] = time24.split(':').map(Number);
      let totalMinutes = 0;
      if(minutesToAdd !== 0)
      {
        // Calculate total minutes and add
        totalMinutes = hours * 60 + minutes + minutesToAdd;
      }
      else
      {
        // Calculate total minutes and subtract
        totalMinutes = hours * 60 + minutes - minutesToSubtract;
      }
      

      // Handle cases where total minutes are negative
      if (totalMinutes < 0) {
        totalMinutes = (24 * 60 + totalMinutes) % (24 * 60); // Wraps around to previous day
      }

      // Convert back to hours and minutes
      const newHours = Math.floor(totalMinutes / 60) % 24;
      const newMinutes = totalMinutes % 60;

      // Pad hours and minutes with leading zeros if needed
      const paddedHours = String(newHours).padStart(2, '0');
      const paddedMinutes = String(newMinutes).padStart(2, '0');

      return `${paddedHours}:${paddedMinutes}`;
    }
    catch(err){

      console.log(err); 
      return time24;
    }
  }

  const handleComputeNewPickupTime = (e) => {
    try{
      let fsSelection = (FundingSourceData && FundingSourceData[parseInt(selectedAff)] && FundingSourceData[parseInt(selectedAff)] !== undefined ? 
        JSON.parse(FundingSourceData[parseInt(selectedAff)]) : []);
      const ERSASettingsData = (MvRouteSettingData && MvRouteSettingData[parseInt(selectedAff)] && MvRouteSettingData[parseInt(selectedAff)] !== "" ? 
        JSON.parse(MvRouteSettingData[parseInt(selectedAff)]) : []);
      const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
      let fsSelectedData = fsSelection.find((item)=>parseInt(item.FID) === parseInt(FSSelected));
      let selectedDay = new Date(selectedDateSchTime+"T00:00:00");
      let ScheduleTripMinTimeDiff = parseInt((JSON.parse(ASCSSettingData[selectedAff]).find((item) => item.SubTitle === "ScheduleTripMinTimeDiff")).value);
      selectedDay = days[selectedDay.getDay()];

      // console.log(ERSASettingsData, fsSelectedData, selectedDay);

      let bIsUpdate = paratransitBookBtnRef.current.textContent.toLowerCase().includes("update");

      let FsApptTimeWindow = (fsSelectedData.dApptTimeWindow && fsSelectedData.dApptTimeWindow !== ""? fsSelectedData.dApptTimeWindow : 0);
      let FsServiceTimeAmb = (fsSelectedData.serviceTimeAmb && fsSelectedData.serviceTimeAmb !== "" ? fsSelectedData.serviceTimeAmb : 0);
      let FsSeviceTimeWC = (fsSelectedData.serviceTimeWC && fsSelectedData.serviceTimeWC !== "" ? fsSelectedData.serviceTimeWC : 0);
      let FstimeWindow = (fsSelectedData.timeWindow && fsSelectedData.timeWindow !== "" ? fsSelectedData.timeWindow : 0);
      let FsdEndTimeWindow = (fsSelectedData.dEndTimeWindow && fsSelectedData.dEndTimeWindow !== "" ? fsSelectedData.dEndTimeWindow : 0);
      let FsminRideTime = (fsSelectedData.minRideTime && fsSelectedData.minRideTime !== "" ? fsSelectedData.minRideTime : 0);
      let FsmaxRideTime = (fsSelectedData.maxRideTime && fsSelectedData.maxRideTime !== "" ? fsSelectedData.maxRideTime : 0);
      let FsadditionalSameLocAmb = (fsSelectedData.additionalSameLocAmb && fsSelectedData.additionalSameLocAmb !== "" ? fsSelectedData.additionalSameLocAmb : 0);
      let FsadditionalSameLocWC = (fsSelectedData.additionalSameLocWC && fsSelectedData.additionalSameLocWC !== "" ? fsSelectedData.additionalSameLocWC : 0); 

      let bDisableRideSharing = true;
      let MinutesToMinus = 0;
      let ApptWindow = 0;

      if(ERSASettingsData.length > 0)
      {
        let bFound = false;
        let index = 0;
        let selectedERSASetting = null;
        for(let k = 0; k < ERSASettingsData.length; k++)
        {
          if(ERSASettingsData[k].vScheduleDays && ERSASettingsData[k].vScheduleDays.trim() !== '')
          {
            let tempSettingDays = ERSASettingsData[k].vScheduleDays.trim().split('');
            bFound = (tempSettingDays.find((item)=>(item.toLowerCase()) === selectedDay.charAt(0).toLowerCase()) ? true : false);
            if(bFound)
            {
              index = k;
              break;
            }
          }
        }
        
        if(bFound)
        {
          bDisableRideSharing = ERSASettingsData[index].bDisableRideSharing;
          selectedERSASetting = ERSASettingsData[index];
        }
        else //No Setting found for current selected day
        {
          let defaultERSASettingData = ERSASettingsData.filter(item=>item.bDefault === true);
          if(defaultERSASettingData && defaultERSASettingData.length > 0)
          {
            bDisableRideSharing = ERSASettingsData[0].bDisableRideSharing;
            selectedERSASetting = ERSASettingsData[0];
          }
        }
        //PU Time = Appointment Time - Estimated Direct Ride Time from Map Source – Service Time (Amb , Wheel Chair) – Appointment Time window
        if(bDisableRideSharing)
        {
          MinutesToMinus = clientSummary.TripDuration;
        }
        else
        {
          let min = 0;
          let max = 0;

          if(parseInt(FsminRideTime) > 0)
          {
            min = parseFloat(FsminRideTime);
          }
          else
          {
            min = (parseFloat(selectedERSASetting.MinimumRidTimeMin) <= 0 ? 0 : parseFloat(selectedERSASetting.MinimumRidTimeMin));
          }

          if(parseInt(FsmaxRideTime) > 0)
          {
            max = parseFloat(FsmaxRideTime);
          }
          else
          {
            max = (parseFloat(selectedERSASetting.MaxRideTimePer) <= 0 ? 0 : parseFloat(selectedERSASetting.MaxRideTimePer));
          }
          let EstTime = clientSummary.TripDuration;
          let mrt = (EstTime * parseFloat(max) / 100);
          mrt = (mrt > parseFloat(min) ? mrt : parseFloat(min));
          MinutesToMinus = mrt;
        }
        
        //Wheelchair
        let serviceTime = 0;
        if(passengerTypeCount.totalWC > 0)
        {
          serviceTime = (Array.isArray(clientInfo) ? 0 : (clientInfo.serviceTimeWC && clientInfo.serviceTimeWC !== "" ? clientInfo.serviceTimeWC : 0));
          if(serviceTime > 0)
          {
            MinutesToMinus = MinutesToMinus + (serviceTime * 2);
          }
          else if(parseFloat(FsSeviceTimeWC) > 0)
          {
            MinutesToMinus = MinutesToMinus + (parseFloat(FsSeviceTimeWC) * 2);
          }
          else
          {
            MinutesToMinus = MinutesToMinus + (parseFloat(selectedERSASetting.WCServiceTime) * 2);
          }
        }
        else //Amb
        {
          serviceTime = (Array.isArray(clientInfo) ? 0 : (clientInfo.serviceTimeAmb && clientInfo.serviceTimeAmb !== "" ? clientInfo.serviceTimeAmb : 0));
          if(serviceTime > 0)
          {
            MinutesToMinus = MinutesToMinus + (serviceTime * 2);
          }
          else if(parseFloat(FsServiceTimeAmb) > 0)
          {
            MinutesToMinus = MinutesToMinus + (parseFloat(FsServiceTimeAmb) * 2);
          }
          else
          {
            MinutesToMinus = MinutesToMinus + (parseFloat(selectedERSASetting.AmbServiceTime) * 2);
          }
        }

        //Adding appointment time
        if(bIsUpdate && parseFloat(FsApptTimeWindow) > 0)
        {
          MinutesToMinus = MinutesToMinus + parseFloat(FsApptTimeWindow);
          ApptWindow = parseFloat(FsApptTimeWindow);
        }
        else
        {
          MinutesToMinus = MinutesToMinus + parseFloat(selectedERSASetting.dApptTimeWindow);
          ApptWindow = parseFloat(selectedERSASetting.dApptTimeWindow);
        }
        apptTimeCheckValsRef.current = {ServiceTime:serviceTime, ApptWindow:ApptWindow, TimeWindow: 0};
        let tempTime = "";
        let selectedApptTime = (e.target ? e.target.value : e);
        if(selectedApptTime !== "")
        {
          const subtractMins = Math.round(MinutesToMinus);
          tempTime = addsubtractMinutesFromMilitaryTime(selectedApptTime, subtractMins);
          setSchTime(tempTime);
          calculatedTimeCheck.current = subtractMins;
        }
      }
    }
    catch(err){console.log(err);}
  };

  const convertMinutesToTime = (totalMinutes) => {
    try{
      const rounded = Math.round(totalMinutes);
      const hours24 = Math.floor(rounded / 60); // Get the hour in 24-hour format
      const minutes = rounded % 60; // Get the remaining minutes
      const period = hours24 >= 12 ? "PM" : "AM"; // Determine AM/PM
      const hours12 = hours24 % 12 || 12; // Convert to 12-hour format (0 becomes 12)
      
      // Format the time string with leading zero for minutes if needed
      return `${hours12}:${minutes.toString().padStart(2, '0')} ${period}`;
    }
    catch(err){console.log(err); return '00:00 AM';}
  };


  const validateScheduleTimeField = async (e, type = "") => {
    try {
      //await FutureDateValidation();
    } catch (error) {
      
    }
  }

  const handleApptTimeCheck = async (e, type = "") =>{
    try{
      if(pickLatLng.current !== "" && dropLatLng.current !== "")
      {
        let timeInput = (Array.isArray(e) ? "" : e.target.value);
        let eventObj = (Array.isArray(e) ? type : e);
        let currentTime = systemDateTimeRef.current.time;
        let time1 = (schTime !== "" ? schTime : currentTime);
        let time2 = (type === "" ? timeInput : type);

        let currTimeUserView = "";
        if(time1 === currentTime){currTimeUserView = systemDateTimeRef.current.givenTime;}
        else{currTimeUserView = time1;}
        if(time2 !== "" && systemDateTime.date === selectedDateSchTime)
        {      
          if(parseInt(time1.split(":")[0]) < parseInt(time2.split(":")[0]))
          {
            setAppointmentTime(time2);
            handleComputeNewPickupTime(eventObj);
          }
          else if(parseInt(time1.split(":")[0]) === parseInt(time2.split(":")[0]))
          {
            if(parseInt(time1.split(":")[1]) === parseInt(time2.split(":")[1]))
            {
                
              setModalHeaderText("Invalid Appointment Time");
              setModalBodyHTML("Please provide a valid appointment time ahead of the time: "+currTimeUserView+".");
              setModalFooterHTML(
                <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                  OK
                </Button>
              );
              setShowDynamicModal(true);
              if(type !== "")
              {
                setAppointmentTime("");
              }
              else
              {
                setAppointmentTime("");
              }
            }
            else if(parseInt(time1.split(":")[1]) > parseInt(time2.split(":")[1]))
            {
              setModalHeaderText("Invalid Appointment Time");
              setModalBodyHTML("Please provide a valid appointment time ahead of the time: "+currTimeUserView+".");
              setModalFooterHTML(
                <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                  OK
                </Button>
              );
              setShowDynamicModal(true);
              if(type !== "")
              {
                setAppointmentTime("");
              }
              else
              {
                setAppointmentTime("");
              }
            }
            else
            {
              setAppointmentTime(time2);
              handleComputeNewPickupTime(eventObj);
            }
          }
          else
          {
            if(parseInt(time1.split(":")[0]) > parseInt(time2.split(":")[0]))
            {
              if(time1 === currentTime)
              {
                if(systemDateTime.date === selectedDateSchTime)
                {
                  setModalHeaderText("Invalid Appointment Time");
                  setModalBodyHTML("Please provide a valid appointment time ahead of the time: "+currTimeUserView+".");
                  setModalFooterHTML(
                    <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                      OK
                    </Button>
                  );
                  setShowDynamicModal(true);
                  setAppointmentTime("");
                }
                else //selected date is in future
                {
                  setAppointmentTime(time2);
                  handleComputeNewPickupTime(eventObj);
                }
                
              }
              else
              {
                if(type !== "")
                {
                  setAppointmentTime("");
                }
                else
                {
                  setAppointmentTime(time2);
                }
                handleComputeNewPickupTime(eventObj);
              }
            }
          }
        } 
        else
        {
          setAppointmentTime(time2);
          handleComputeNewPickupTime(eventObj);
        }
      }
      else
      {
        let timeInput = (Array.isArray(e) ? "" : e.target.value);
        let time2 = (type === "" ? timeInput : type);
        if(time2 !== "")
        {
          setModalHeaderText("Missing Required Info");
          setModalBodyHTML("Please provide valid and different addresses before changing appointment time.");
          setModalFooterHTML(
            <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
              OK
            </Button>
          );
          setShowDynamicModal(true);
          setAppointmentTime("");
        }
        // apptTimeRef.current.blur();
        
      }
    }
    catch(err){console.log(err);}
  };

  // Helper to format phone numbers for paratransit
  const formatPhone = (phoneVal) => {
    try{
      const cleanedPhone = phoneVal.replace("+1", "");
      return `${cleanedPhone.substring(0, 3)}-${cleanedPhone.substring(3, 6)}-${cleanedPhone.substring(6)}`;
    }
    catch(err){console.log(err); return phoneVal;}
  };

  //Helper to build paratransit booking/update data dictionary
  const createParaDataDict = (tripsDetailsObj) => ({
    generalInfo: {
      CompleteUserName: (loginData.vUserName ? loginData.vUserName : ""),
      CreatedBy: loginData.vDisplayName,
      CreatedByAppID: iAppID,
      CreatedUserId: (loginData.iUserID ? loginData.iUserID : 0),
      RequestAffiliateID: tripsDetailsObj.generalInfo.RequestAffiliateID,
      ReturnDetailID: tripsDetailsObj.generalInfo.ReturnDetailID,
      FamilyID: tripsDetailsObj.generalInfo.FamilyID
    },
    riderInfo: {
      ID: tripsDetailsObj.riderInfo.ID,
      PhoneNo: tripsDetailsObj.riderInfo.PhoneNo,
      PickupPerson: tripsDetailsObj.riderInfo.PickupPerson,
      DateOfBirth: tripsDetailsObj.riderInfo.DateOfBirth,
      RiderID: tripsDetailsObj.riderInfo.RiderID,
      RiderPassword: "",
      MedicalID: tripsDetailsObj.riderInfo.MedicalID,
      ClientAddress: tripsDetailsObj.riderInfo.ClientAddress,
      ClientCity: tripsDetailsObj.riderInfo.ClientCity,
      ClientState: tripsDetailsObj.riderInfo.ClientState,
      ClientZip: tripsDetailsObj.riderInfo.ClientZip
    },
    insuranceInfo: tripsDetailsObj.insuranceInfo,
    routeSettingInfo: {
      TimeWindow: 0,
      EndTimeWindow: 0,
      MinRideTime: 0,
      MaxRideTime: 0,
      ServiceTimeAmb: 0,
      ServiceTimeWC: 0,
      ApptTimeWindow: 0,
      AdditionalSameLocAm: 0,
      AdditionalSameLocWC: 0
    },
    systemConfigInfo: tripsDetailsObj.systemConfigInfo,
    exclusions: tripsDetailsObj.exclusions,
    scheduleInfo: tripsDetailsObj.scheduleInfo,
    addressInfo: tripsDetailsObj.addressInfo
  });

  // Helper to build tempDict
  const createTempDict = () => ({
    StopType: "",
    WaitTime: 0,
    Name: "",
    tripInfo: {
      AffiliateID: 0,
      Description: "",
      OrigionalServiceId: -1,
      CallId: 0,
      ReceivingAffiliateID: -1,
      ClassOfServiceID: 0,
      EntityAttributes: "",
      ReturnTrip: false,
      AgentInstructions: "",
      OutRefID: -1,
      CustomerEmail: "",
      CallbackReq: "",
      CallBackInfo: "",
      SLAClassID: 0,
      AuthorizedBy: "",
      ServiceStatusID: 0,
      IsCheckServiceHours: true,
      IsPredictive: "0",
      IsMultiTrip: false,
      ReturnRequestAffiliateID: 0,
      TripPayStatus: 0,
      IsRollingCallTypePhone: false,
      IsRollingCallTypeSMS: false,
      IsRollingCallTypeEmail: false,
      ExtraInfo: "",
      Ext1: "",
      Ext2: "0",
      CallType: 0,
      FareMethod: 0,
      ServiceID: -1,
      ScheduleID: -1,
      RefID: -1,
    },
    passengerInfo: {
      TotalPassengers: 0,
      TotalWheelChairs: 0,
      TotalUnloadPassengers: 0,
      TotalLuggage: 0,
      TotalKids: 0,
      ServiceAnimalCount: "0",
      PCACount: "0",
      PCAWCCount: "0"
    },
    addressDetails: {
      Address: "",
      Longitude: "",
      Latitude: "",
      City: "",
      State: "",
      Zip: "",
      Zone: "",
      Remarks: "",
      Phone: "",
      POIName: "",
    },
    dateInfo: {
      PickupDate: "",
      ApptTime: "",
      RetWillCallDay: "",
      IsWillCall: false,
      IsScheduled: false,
      IsMultiSchedule: false,
    },
    estimatedInfo: {
      EstimatedDistance: 0,
      EstimatedTime: 0,
      EstimatedCost: 0,
      BillableAmount: 0,
      CoPay: 0,
      AdditionalPassCost: 0,
      BillableMiles: 0,
      IsBillingRequired: false,
    },
    paymentInfo: {
      FundingSourceID: 0,
      PaymentTypeID: 0,
      iCopayFundingSourceID: 0,
      iActualPaymentTypeID: 0,
      ReturnCopay: 0,
      CCInfo: "",
      CCResults: "",
      PromoAmount: 0,
    },
    driverInfo: {
      SpecialDriverId: 0,
      AssignedDriverId: 0,
      DriverNoTimeDiff: 0,
      OnlyPreferedDriver: false,
      AssignedDriverNo: 0,
      PreferedDriverNum: "",
      PreferedDriverGender: "",
      OnlyPreferedDriverGender: false,
      OnlyPreferedDriverLanguage: false,
      GenderTimeDiff: 0,
      LangTimeDiff: 0,
      PreferedLanguage: 0,
    },
    vehicleInfo: {
      SpecialVehicleId: 0,
      AssignedVehicleId: 0,
      VehicleTypeId: -1,
      VehicleNoTimeDiff: 0,
      OnlyPreferedVType: false,
      OnlyPreferedVehicle: false,
      AssignedVehNo: "",
      PreferedVehicleNo: "",
    },
  }); 

  const flattenMobilityData = (data) => {
    const result = {};
  
    if (data.Primary) {
      result["Primary"] = data.Primary.Attributes || "0";
    }
  
    if (data.PCA) {
      result["PCA"] = data.PCA.Attributes || "0";
    }
  
    if (Array.isArray(data.Guests)) {
      data.Guests.forEach((guest, index) => {
        result[`Guest${index}`] = guest.Attributes || "0";
      });
    }
  
    if (Array.isArray(data.Children)) {
      data.Children.forEach((child, index) => {
        result[`Child${index}`] = child.Attributes || "0";
      });
    }
  
    return result;
  };

  // Function to fill address details based on the selection
  const fillAddressDetails = (selection, extraInfo, latLng, stopType, multiTripArr = "", dataType = "", updateData = "", unloadedTotal = 0, attrList="", index = 0,
    newRefID = -1, isScheduledCheck = false, forcePassServiceHour = false, IsSkipPaymentProcessOnSD, forceDuplicateReserve = false, useMobilityDataDirect = false, ) => 
    {
    const isMultiTrip = (typeof multiTripArr === 'object');
    const singleTripPhone = (stopType === "pickup" ? (addrPhoneInfo.pick ? formatPhone(addrPhoneInfo.pick) : '') : (addrPhoneInfo.drop ? formatPhone(addrPhoneInfo.drop) : ''));
    const multiTripPhone = (isMultiTrip ? (stopType === 'pickup' ? (multiTripArr.addressPhoneInfo.pick ? multiTripArr.addressPhoneInfo.pick : '')
    :(multiTripArr.addressPhoneInfo.drop ? multiTripArr.addressPhoneInfo.drop : '')) : '');

    let IsMobilityAttributesAttached = false;
    if(isAffiliateHasMobilityAttributes){
      IsMobilityAttributesAttached = true;
    }
  
    let tripPassengerInfo = updateData?.addressInfo?.trips?.[index]?.details?.[0]?.passengerInfo || {};

    MakeMobilitiesObject();

    if(passengerTypeCount.total == 1 && passengerTypeCount.ambPass == 1 && 
      ( mobilityDbData?.Primary?.Attributes == undefined || mobilityDbData?.Primary?.Attributes == "" )){
      if(tripPassengerInfo == undefined || Object.keys(tripPassengerInfo).length === 0){
        let ambAttribute = "";
        mobilityDbData.Primary.Name = "Primary";
        if(refMobilityAttributeOptions.current){
          ambAttribute = refMobilityAttributeOptions.current.find(p => p.value == "Ambulatory" || p.value == "Amb" || p.value == "amb" || p.value == "amb." || p.value == "Amb.")
        }
        if(ambAttribute != undefined){
          mobilityDbData.Primary.Attributes = ambAttribute.key;
        }

        if(passengerTypeCount.totalChildren == 1){
          let ambAttribute = "";
          mobilityDbData.Primary.Name = "Primary";
          if(refMobilityAttributeOptions.current){
            ambAttribute = refMobilityAttributeOptions.current.find(p => p.value == "Ambulatory" || p.value == "Amb" || p.value == "amb" || p.value == "amb." || p.value == "Amb.")
          }
          if(ambAttribute != undefined){
            mobilityDbData.Children.push({ Name: "Child 1", Attributes:ambAttribute.key });
          }
  
        }
      }
    }
    else{
      //@@@@@@@@@@@@@@@@@@@
      //MakeMobilitiesObject();
    }

    if(useMobilityDataDirect){
      tripPassengerInfo = {};
      //MakeMobilitiesObject();
      // if(mobilityDbData.PCA?.Attributes == null || mobilityDbData.PCA?.Attributes == ""){
      //   mobilityDbData.PCA.Name = "";
      //   mobilityDbData.PCA.Attributes = "";
      // }
    }

    let EnablePredictiveNegotiation = ASCSSettingData ? (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "EnablePredictiveNegotiation")).value : 0;

    const address = (
      selection?.data?.['Address'] ?? selection?.['Address'] ?? ''
    );

    const LatLong = (
      (selection?.data?.['Lat'] ?? selection?.['Lat'] ?? '') + ',' +
      (selection?.data?.['Long'] ?? selection?.['Long'] ?? '')
    )

    return {
      StopType: stopType,
      Name: (isMultiTrip ?  multiTripArr.riderName : riderName),
      WaitTime: 0,
      tripInfo:{
        AffiliateID: (isMultiTrip ?  parseInt(multiTripArr.AffiliateSelected) : parseInt(selectedAff)),
        CCUniqueID: (isMultiTrip ? parseInt(multiTripArr.CCInfo.uniqueID) : parseInt(paymentCardIDInfoRef.current.uniqueID)),
        Description: "",
        SelfWalletID: (isMultiTrip ?  parseInt(multiTripArr.fareEstimateAPIData.walletID) : parseInt(fareEstimateAPISummary.walletID)),
        Promocode: (isMultiTrip ?  multiTripArr.fareEstimateAPIData.promo : fareEstimateAPISummary.promo),
        BrokerMode: (isMultiTrip ?  parseInt(multiTripArr.broker.globalBrokerMode) : parseInt(brokerModes.globalBrokerMode)),
        FSBrokerMode:(isMultiTrip ?  parseInt(multiTripArr.broker.brokerMode) : parseInt(brokerModes.brokerMode)),
        EaasJSONResp: (isMultiTrip ? multiTripArr.fareEstimateAPIData.eaasJSON : fareEstimateAPISummary.eaasJSON),
        OrigionalServiceId: -1,
        CallId: 0,
        ReceivingAffiliateID: -1,
        ClassOfServiceID: (isMultiTrip ?  multiTripArr.COS : parseInt(COSSelected)),
        EntityAttributes: (isMultiTrip ?  attrList : (selectedTripAttr === "TA" ? "":attrList)),
        ReturnTrip: (isMultiTrip ?  multiTripArr.isReturn : stopTripCheckBox),
        AgentInstructions: (isMultiTrip ?  multiTripArr.notes : agentNotes),
        OutRefID: -1,
        CustomerEmail: (isMultiTrip ?  multiTripArr.email : clientEmail),
        CallbackReq: (isMultiTrip ?  (multiTripArr.phone ? true:false) : (callBackPhone ? true:false)),
        CallBackInfo: (isMultiTrip ?  (multiTripArr.callBackPhone && multiTripArr.callBackPhone.length >= 12 ? 
          (multiTripArr.callBackPhone.includes("-") ? multiTripArr.callBackPhone : (formatPhone(multiTripArr.callBackPhone))) : "") : 
          (callBackPhone ? formatPhone(callBackPhone) : "")
        ),
        SLAClassID: (isMultiTrip ?  multiTripArr.tripPriority : selectedTripPriority),
        AuthorizedBy: "",
        ServiceStatusID: 0,
        IsCheckServiceHours: true,
        IsPredictive: EnablePredictiveNegotiation,
        IsMultiTrip: (verifiedAddr.length === 1 ? true:false),
        ReturnRequestAffiliateID: 0,
        TripPayStatus: (paymentCardIDInfoRef.current.payStatusID && parseInt(paymentCardIDInfoRef.current.payStatusID) > 0 ? String(paymentCardIDInfoRef.current.payStatusID) : (IsSkipPaymentProcessOnSD ? 2 : 0)),
        IsRollingCallTypePhone: (isMultiTrip ?  multiTripArr.RC.phoneType : RCType.phoneType),
        IsRollingCallTypeSMS: (isMultiTrip ?  multiTripArr.RC.SMSType : RCType.SMSType),
        IsRollingCallTypeEmail: (isMultiTrip ?  multiTripArr.RC.emailType : RCType.emailType),
        ExtraInfo: (isMultiTrip ?  multiTripArr.paymentExtraInfo : paymentAdditionalInfo),
        Ext1: "",
        Ext2: (isMultiTrip ?  multiTripArr.clientJob : clientJob),
        CallType: (isMultiTrip ?  multiTripArr.tripType : selectedTripType),
        FareMethod: (isMultiTrip ?  parseInt(multiTripArr.fareMethod) : parseInt(fareMethod)),
        ServiceID: (dataType.toLowerCase() === "update" ?  (updateData !== "" && updateData.addressInfo.trips[index].details[0].tripInfo.serviceID && String(updateData.addressInfo.trips[index].details[0].tripInfo.serviceID) !== "" ? parseInt(updateData.addressInfo.trips[index].details[0].tripInfo.serviceID) : -1):-1),
        ScheduleID: (dataType.toLowerCase() === "update" ?  (updateData !== "" && updateData.addressInfo.trips[index].details[0].tripInfo.scheduleID && String(updateData.addressInfo.trips[index].details[0].tripInfo.scheduleID) !== "" ? parseInt(updateData.addressInfo.trips[index].details[0].tripInfo.scheduleID) : -1):-1),
        RefID: (dataType.toLowerCase() === "update" ?  
        (updateData !== "" && updateData.addressInfo.trips[index].details[0].tripInfo.refID && String(updateData.addressInfo.trips[index].details[0].tripInfo.refID) !== "" && parseInt(updateData.addressInfo.trips[index].details[0].tripInfo.refID) > 0 ? 
        parseInt(updateData.addressInfo.trips[index].details[0].tripInfo.refID) : -1):(parseInt(newRefID) > 0 ? newRefID : -1)),
        preSchedule: (scheduleJSON.mainData !== "" && scheduleJSON.mainData.vPreSch.length > 0 && verifiedAddr.length <= 1 ? scheduleJSON.mainData.vPreSch:""),
        ForcePassServiceHoursCheck: (forcePassServiceHour ? forcePassServiceHour : ((isMultiTrip ?  multiTripArr.ForcePassServiceHours : forcePassServiceHoursCheck))),
        ForceDuplicateTripSave: forceDuplicateReserve,
        InsertPredictiveRouteEntry: false 
      },
      passengerInfo: {
        TotalPassengers: (isMultiTrip ? (multiTripArr.passCount.total === 0 ? 1 : multiTripArr.passCount.total) : 
        (passengerTypeCount.total === 0 ? 1 : passengerTypeCount.total)),
        TotalWheelChairs: (isMultiTrip ? multiTripArr.passCount.totalWC : passengerTypeCount.totalWC),
        TotalUnloadPassengers: (isMultiTrip ? (unloadedTotal !== 0 ? unloadedTotal : 0)  : unloadedTotal),
        TotalLuggage: (dataType.toLowerCase() === "update" ?  parseInt(updateData !== "" && updateData.addressInfo.trips[index].details[0].passengerInfo.totalLuggage ? updateData.addressInfo.trips[index].details[0].passengerInfo.totalLuggage : 0): 0),
        TotalKids: (dataType.toLowerCase() === "update" ?  parseInt(updateData !== "" && updateData.addressInfo.trips[index].details[0].passengerInfo.totalKids ? updateData.addressInfo.trips[index].details[0].passengerInfo.totalKids : 0) : 0),
        ServiceAnimalCount: (isMultiTrip ? verifiedAddr[0].passCount.totalSA.toString() : String(passengerTypeCount.totalSA)),
        PCACount: (dataType.toLowerCase() === "update" ?  (updateData !== "" && updateData.addressInfo.trips[index].details[0].passengerInfo.pcaCount ? updateData.addressInfo.trips[index].details[0].passengerInfo.pcaCount : "0") : "0"),
        PCAWCCount: (dataType.toLowerCase() === "update" ?  (updateData !== "" && updateData.addressInfo.trips[index].details[0].passengerInfo.pcawcCount ? updateData.addressInfo.trips[index].details[0].passengerInfo.pcawcCount : "0") : "0"),

//@@@@@@@@@@@@@@@@@@@@@@@@@@Below needs to be chanes
        Primary: (tripPassengerInfo.primary && Object.keys(tripPassengerInfo.primary).length > 0) ? tripPassengerInfo.primary : mobilityDbData.Primary,
        PCA: (Array.isArray(tripPassengerInfo.pca) && tripPassengerInfo.pca.length > 0) ? tripPassengerInfo.pca : mobilityDbData.PCA,
        Guests: (Array.isArray(tripPassengerInfo.guests) && tripPassengerInfo.guests.length > 0) ? tripPassengerInfo.guests: mobilityDbData.Guests,
        Children: (Array.isArray(tripPassengerInfo.children) && tripPassengerInfo.children.length > 0) ? tripPassengerInfo.children : mobilityDbData.Children,
//@@@@@@@@@@@@@@@@@@@@@@@@@@Below needs to be chanes



        IsMobility: IsMobilityAttributesAttached
      },
      addressDetails: {
        Address: getFormattedAddress({
          isMultiTrip,
          stopType,
          multiTripArr,
          dataType,
          selection,
          address,
          pickupAddr,
          dropAddr,
          extractStreetAddress
        })
        // (isMultiTrip ? (stopType === "pickup" ? (multiTripArr?.pickAddr?.includes(",") 
        // ? multiTripArr?.pickAddr?.split(",")[0] : multiTripArr?.pickAddr) : (multiTripArr?.dropAddr?.includes(",") 
        // ? multiTripArr?.dropAddr?.split(",")[0] : multiTripArr?.dropAddr)) : (dataType.toLowerCase() !== "update" ? 
        // (selection?.Type === "recent"
        //   ? (address?.includes(",") ? 
        //     address.split(",")[0] : address)
        //   : (selection?.Type === "poi" ? (address) : (selection?.[0]?.addressParsedObject?.Address?.includes(",") ? 
        //   selection[0]?.addressParsedObject?.Address.split(",")[0] : selection[0]?.addressParsedObject?.Address)) ?? 
        //   (address?.includes(",") ? address?.split(",")[0] : address)) : 
        //   (stopType ==="pickup" ? (pickupAddr?.includes(",") ?
        //   extractStreetAddress(pickupAddr)
        //   : pickupAddr
        //   ): 
        //   (dropAddr?.includes(",") ?
        //    extractStreetAddress(dropAddr)
        //    : dropAddr))
        // ))
        
        ,
        Latitude: parseFloat(
          selection?.Type === "recent"
            ? LatLong.split(",")[0]
            : latLng.split(",")[0]
        ),
        Longitude: parseFloat(
          selection?.Type === "recent"
            ? LatLong.split(",")[1]
            : latLng.split(",")[1]
        ),
        City: (isMultiTrip ? (stopType === "pickup" ? multiTripArr.addressExtraDetails.pick.city : multiTripArr.addressExtraDetails.drop.city) : 
          (stopType === "pickup" ? addressInfoDetails.current.pick.city : addressInfoDetails.current.drop.city)
        ),
        State: (isMultiTrip ? (stopType === "pickup" ? multiTripArr.addressExtraDetails.pick.state : multiTripArr.addressExtraDetails.drop.state) : 
          (stopType === "pickup" ? addressInfoDetails.current.pick.state : addressInfoDetails.current.drop.state)
        ),
        Zip: (isMultiTrip ? (stopType === "pickup" ? multiTripArr.addressExtraDetails.pick.zip : multiTripArr.addressExtraDetails.drop.zip) : 
          (stopType === "pickup" ? addressInfoDetails.current.pick.zip : addressInfoDetails.current.drop.zip)
        ),
        Zone: (isMultiTrip ? (stopType === "pickup" ? multiTripArr.dispatchZones.pickZone : multiTripArr.dispatchZones.dropZone):(stopType === "pickup" ? dispatchZones.pickZone : dispatchZones.dropZone)), 
        FareZone: (isMultiTrip ? (stopType === "pickup" ? multiTripArr.fareZones.pick : multiTripArr.fareZones.drop):(stopType === "pickup" ? fareZones.pick : fareZones.drop)),
        Remarks: extraInfo,
        Phone: (isMultiTrip ? multiTripPhone : singleTripPhone),
        POIName: (isMultiTrip ? (stopType === "pickup" ? multiTripArr.pickPOI : multiTripArr.dropPOI) : (stopType === "pickup" ? pickPOI : dropPOI)),
        ApartmentNo: (isMultiTrip ? (stopType === "pickup" ? multiTripArr.PUApartment : multiTripArr.DOApartment) : (stopType === "pickup" ? addrApartmentInfo["pick"] : addrApartmentInfo["drop"])),

      },
      dateInfo:{
        PickupDate: (isMultiTrip ? 
          (multiTripArr.willCall ? systemDateTime.date : multiTripArr.date + " " + (multiTripArr.time === "" ? systemDateTimeRef.current.timeWithSettingAdded:multiTripArr.time)): 
          (schTime === ""? (willCall ? systemDateTime.date: selectedDateSchTime +" "+systemDateTimeRef.current.timeWithSettingAdded): selectedDateSchTime + " " + schTime)
        ),
        ApptTime: (isMultiTrip ? (multiTripArr.apptTime !== "Will Call" && multiTripArr.apptTime !== "" ? multiTripArr.date + " " + multiTripArr.apptTime : "01/01/1900 00:00:00") : (appointmentTime === ""? "01/01/1900 00:00:00" : selectedDateSchTime + " " + appointmentTime)),
        WillCallDay: (isMultiTrip ? (multiTripArr.willCall ? multiTripArr.date : "01/01/1900 00:00:00") : (willCall ? selectedDateSchTime : "01/01/1900 00:00:00")),
        IsWillCall:(isMultiTrip ? multiTripArr.willCall: willCall),
        IsScheduled: (scheduleJSON.mainData !== "" && scheduleJSON.mainData.Schedule.ScheduleItem.length > 0 && verifiedAddr.length <= 1) ? true : (isScheduledCheck ? true : (typeof multiTripArr === 'object' ? ((multiTripArr.time === "" ? false : true)): (dataType === "update" ?  (updateData !== "" ? updateData.addressInfo.trips[index].details[0].dateInfo.isScheduled : false) : ((schTime !== "" || willCall) ? true : false)))),
        IsMultiSchedule:(scheduleJSON.mainData !== "" && scheduleJSON.mainData.Schedule.ScheduleItem.length > 0 && verifiedAddr.length <= 1 ? true : false)
      },
      estimatedInfo:{
        EstimatedDistance: (isMultiTrip ? parseFloat(multiTripArr.manualAmount.estimatedDistance === 0 ? multiTripArr.distance : multiTripArr.manualAmount.estimatedDistance) : (manualDataOverwrite.miles !== 0 ? manualDataOverwrite.miles : parseFloat(clientSummary.tripDistance))),
        EstimatedTime: (isMultiTrip ? parseFloat(multiTripArr.duration) : parseFloat(clientSummary.TripDuration)),
        EstimatedCost: (isMultiTrip ? parseFloat(multiTripArr.manualAmount.estimatedFare === 0 ? multiTripArr.fare : multiTripArr.manualAmount.estimatedFare) : (manualDataOverwrite.fare !== 0 ? manualDataOverwrite.fare : parseFloat(clientSummary.TripFare))),
        BillableAmount: (isMultiTrip ? (multiTripArr.manualAmount.price === 0 ? multiTripArr.billableAmount : multiTripArr.manualAmount.price) : (manualDataOverwrite.price !== 0 ? manualDataOverwrite.price : fareDataArr.billableAmount)),
        AdditionalPassCost: (isMultiTrip ? multiTripArr.additionalPassengerCost : fareDataArr.additionalPassengerCost),
        BillableMiles: 0,
        CoPay: (isMultiTrip ? parseFloat(multiTripArr.copay) : parseFloat(copayAmount)),
        CopayPrice:(isMultiTrip ? parseFloat(multiTripArr.fareEstimateAPIData.copay) : parseFloat(fareEstimateAPISummary.copay)),
        IsBillingRequired: false
      },
      paymentInfo:{
        FundingSourceID: (isMultiTrip ? parseInt(multiTripArr.FundingSource) : parseInt(FSSelected)),
        PaymentTypeID: (isMultiTrip ? parseInt(multiTripArr.PaymentSelected) : parseInt(PaySelected)), 
        iCopayFundingSourceID: (isMultiTrip ? parseInt(multiTripArr.copayFS) : parseInt(copayFSSelected)),
        iActualPaymentTypeID: (isMultiTrip ? parseInt(multiTripArr.copayPayType) : parseInt(copayPayTypeSelected)),
        ReturnCopay: (isMultiTrip ? parseFloat(multiTripArr.copay) : (stopTripCheckBox ? copayAmount: 0)),
        CCInfo: (isMultiTrip ? (multiTripArr.cardNum +","+ multiTripArr.cardExp) : (cardNumber+","+cardExpiration)),
        CCResults: "",
        PromoAmount: 0
      },
      driverInfo:{
        SpecialDriverId: (isMultiTrip ? (multiTripArr.driverNum === "DN" ? 0:multiTripArr.driverNum.split("_")[0]) : 
          (selectedDriverNum === "DN" ? 0:selectedDriverNum.split("_")[0])
        ),
        AssignedDriverId: (isMultiTrip ? (multiTripArr.driverNum === "DN" ? 0:multiTripArr.driverNum.split("_")[0]) : 
          (selectedDriverNum === "DN" ? 0:selectedDriverNum.split("_")[0])
        ),
        DriverNoTimeDiff: (isMultiTrip ? multiTripArr.driverMins : mobilityDetails.driverNumMin),
        OnlyPreferedDriver: (isMultiTrip ? multiTripArr.driverNumCheck : mobilityChecks.driverNumCheck),
        AssignedDriverNo: (isMultiTrip ? (multiTripArr.driverNum === "DN" ? "":multiTripArr.driverNum.split("_")[1]) : 
          (selectedDriverNum === "DN" ? "":selectedDriverNum.split("_")[1])
        ),
        PreferedDriverNum: (isMultiTrip ? (multiTripArr.driverNum === "DN" ? "":multiTripArr.driverNum.split("_")[1]) : 
          (selectedDriverNum === "DN" ? "":selectedDriverNum.split("_")[1])
        ),
        PreferedDriverGender: (isMultiTrip ? (multiTripArr.gender === "Gender" ? "":multiTripArr.gender) : 
          (selectedGender === "Gender" ? "":selectedGender)
        ),
        OnlyPreferedDriverGender: (isMultiTrip ? multiTripArr.genderCheck : mobilityChecks.genderCheck),
        OnlyPreferedDriverLanguage: (isMultiTrip ? multiTripArr.languageCheck : mobilityChecks.languageCheck),
        GenderTimeDiff:(isMultiTrip ? multiTripArr.genderMins : mobilityDetails.genderMin),
        LangTimeDiff:(isMultiTrip ? multiTripArr.languageMins : mobilityDetails.languageMin),
        PreferedLanguage:(isMultiTrip ? (multiTripArr.language === "Language" ? 0 : multiTripArr.language) : 
          (selectedLanguage === "Language" ? 0:selectedLanguage)
        ),
      },
      vehicleInfo:{
        SpecialVehicleId: (isMultiTrip ? (multiTripArr.vehNum === "VN" ? 0:multiTripArr.vehNum.split("_")[0]) : 
          (selectedVehNum === "VN" ? 0:selectedVehNum.split("_")[0])
        ),
        AssignedVehicleId: (isMultiTrip ? (multiTripArr.vehNum === "VN" ? 0:multiTripArr.vehNum.split("_")[0]) : 
          (selectedVehNum === "VN" ? 0:selectedVehNum.split("_")[0])
        ),
        VehicleTypeId: (isMultiTrip ? (multiTripArr.vehType === "VT" ? -1:parseInt(multiTripArr.vehType)) : 
          (selectedVehType === "VT" ? -1:parseInt(selectedVehType))
        ),
        VehicleNoTimeDiff: (isMultiTrip ? multiTripArr.vehMins : mobilityDetails.vehNumMin),
        OnlyPreferedVType: (isMultiTrip ? multiTripArr.vehTypeCheck : mobilityChecks.vehTypeCheck),
        OnlyPreferedVehicle: (isMultiTrip ? multiTripArr.vehNumCheck : mobilityChecks.vehNumCheck),
        AssignedVehNo: (isMultiTrip ? (multiTripArr.vehNum === "VN" ? "":multiTripArr.vehNum.split("_")[1]) : 
          (selectedVehNum === "VN" ? "":selectedVehNum.split("_")[1])
        ),
        PreferedVehicleNo: (isMultiTrip ? (multiTripArr.vehNum === "VN" ? "":multiTripArr.vehNum.split("_")[1]) : 
          (selectedVehNum === "VN" ? "":selectedVehNum.split("_")[1])
        ),
      },
    };
  };


  function getFormattedAddress({
      isMultiTrip,
      stopType,
      multiTripArr,
      dataType,
      selection,
      address,
      pickupAddr,
      dropAddr,
      extractStreetAddress
  }) {
    
    const firstPart = (val) =>
      val?.includes(",") ? val.split(",")[0] : val;
  
    // MULTI TRIP CASE
    if (isMultiTrip) {
      return stopType === "pickup"
        ? firstPart(multiTripArr?.pickAddr)
        : firstPart(multiTripArr?.dropAddr);
    }
  
    // NON-MULTI TRIP CASE
    if (dataType?.toLowerCase() !== "update") {
      if (selection?.Type === "recent") {
        return firstPart(address);
      }
  
      if (selection?.Type === "poi") {
        const poiAddr = selection?.data?.address ?? address;
        
        return poiAddr?.includes(",")
        ? extractStreetAddress(poiAddr)
        : poiAddr;
      }
  
      // Default selection case
      return (
        firstPart(selection?.[0]?.addressParsedObject?.Address) ??
        firstPart(address)
      );
    }
  
    // UPDATE CASE
    if (stopType === "pickup") {
      return pickupAddr?.includes(",")
        ? extractStreetAddress(pickupAddr)
        : pickupAddr;
    } else {
      return dropAddr?.includes(",")
        ? extractStreetAddress(dropAddr)
        : dropAddr;
    }
  }


  const MakeMobilitiesObject = () => {
    try {

        let _mobilitySavedData = structuredClone(mobilitySavedData);
        try {
          if(_mobilitySavedData?.Primary != undefined){
            mobilityDbData.Primary.Name = _mobilitySavedData.Primary.selectedLabel;
            mobilityDbData.Primary.Attributes = _mobilitySavedData.Primary.selectedAttribute;  
            mobilityDbData.Primary.key = _mobilitySavedData.Primary.key;
            mobilityDbData.Primary.selectedLabel = _mobilitySavedData.Primary.selectedLabel;
            mobilityDbData.Primary.selectedAttribute = _mobilitySavedData.Primary.selectedAttribute;
            mobilityDbData.Primary.type = _mobilitySavedData.Primary.type;
            mobilityDbData.Primary.index = _mobilitySavedData.Primary.index;
            mobilityDbData.Primary.childrenRowIndex = _mobilitySavedData.Primary.childrenRowIndex;
          }
          else{
            mobilityDbData.Primary.Name = Object.values(_mobilitySavedData).find(item => item.type === 'primary').selectedLabel;
            mobilityDbData.Primary.Attributes = Object.values(_mobilitySavedData).find(item => item.type === 'primary').selectedAttribute;  
            mobilityDbData.Primary.key = Object.values(_mobilitySavedData).find(item => item.type === 'primary').key;
            mobilityDbData.Primary.selectedLabel = Object.values(_mobilitySavedData).find(item => item.type === 'primary').selectedLabel;
            mobilityDbData.Primary.selectedAttribute = Object.values(_mobilitySavedData).find(item => item.type === 'primary').selectedAttribute;
            mobilityDbData.Primary.type = Object.values(_mobilitySavedData).find(item => item.type === 'primary').type;
            mobilityDbData.Primary.index = Object.values(_mobilitySavedData).find(item => item.type === 'primary').index;
            mobilityDbData.Primary.childrenRowIndex = Object.values(_mobilitySavedData).find(item => item.type === 'primary').childrenRowIndex;
          }
        } catch (error) {
          
        }
        
        try {
          let PCAList = [];
          let adultPCARows = [];
          if(_mobilitySavedData?.PCA != undefined){
            adultPCARows = _mobilitySavedData?.PCA.filter(item => item.type === 'adult' && item.selectedLabel == "PCA");
          }
          else{
            adultPCARows = Object.values(_mobilitySavedData).filter(item => item.type === 'adult' && item.selectedLabel == "PCA");
          }
          adultPCARows.forEach(row => {
            if (row.selectedAttribute) {
              let PCAObj = { 
                Name: row.selectedLabel,
                Attributes: row.selectedAttribute,
                key: row.key,
                selectedLabel: row.selectedLabel,
                selectedAttribute: row.selectedAttribute,
                type: row.type,
                index: row.index,
                childrenRowIndex: row.childrenRowIndex
              };
              PCAList.push(PCAObj);
            }
          });
          mobilityDbData.PCA = PCAList;
        } catch (error) {
          
        }
    
        try {
          let GuestsList = [];
          let adultGuestsRows = [];
          if(_mobilitySavedData?.Guests != undefined){
            adultGuestsRows = _mobilitySavedData?.Guests.filter(item => item.type === 'adult' && item.selectedLabel == "Guest")
          } 
          else {
            adultGuestsRows = Object.values(_mobilitySavedData).filter(item => item.type === 'adult' && item.selectedLabel == "Guest");
          }
          adultGuestsRows.forEach(row => {
            if (row.selectedAttribute) {
              let GuestObj = {
                Name: row.selectedLabel,
                Attributes: row.selectedAttribute,
                key: row.key,
                selectedLabel: row.selectedLabel,
                selectedAttribute: row.selectedAttribute,
                type: row.type,
                index: row.index,
                childrenRowIndex: row.childrenRowIndex
              };
              GuestsList.push(GuestObj);
            }
          });
        
          mobilityDbData.Guests = GuestsList;
        } catch (error) {
          
        }
    
        try {
          let ChildrenList = [];
          let childrenRows = [];
          if(_mobilitySavedData?.Children != undefined)
          {
            childrenRows = _mobilitySavedData?.Children.filter(item => item.type === 'children' && item.selectedLabel.includes("Child"));
          }
          else{
            childrenRows = Object.values(_mobilitySavedData).filter(item => item.type === 'children' && item.selectedLabel.includes("Child"));
          }
          childrenRows.forEach(row => {
            if (row.selectedAttribute) {
              let ChildObj = {
                Name: row.selectedLabel,
                Attributes: row.selectedAttribute,
                key: row.key,
                selectedLabel: row.selectedLabel,
                selectedAttribute: row.selectedAttribute,
                type: row.type,
                index: row.index,
                childrenRowIndex: row.childrenRowIndex
              }
              ChildrenList.push(ChildObj);
            }
          });
        
         
          mobilityDbData.Children = ChildrenList;
        } catch (error) {
          
        }
      } catch (error) {
        
      }
  }

  const VerifyCCAmount = (Amount, index = 0) => {
    try{
      if (Amount.Total !== "" && parseFloat(Amount.Total) > 0) 
      {
        // Call API for Checking CC Amount
        let bSchTrip = false;
        let bWillCall = false;
        let PUDate = "";
        let PUTime = "";
        let bDropInfo = true;
        let iNewRefIDForCC = -1;
        let iNewReturnRefIDForCC = -1;
        let formattedPhone = formatPhone(phone);
        try {
          bSchTrip = (schTime !== "" || willCall ? true : false);
          bWillCall = willCall;
          PUDate = formatDate(selectedDateSchTime);
          PUTime = (schTime !== "" ? militaryToStandardTime(schTime) : militaryToStandardTime(systemDateTimeRef.current.time));
          bDropInfo = (dropLatLng.current !== "");
        } catch (ex) { }

        if (paratransitBookBtnRef.current.textContent.toLowerCase().includes("update")) {
          const queryParams = new URLSearchParams(window.location.search);
          const tripSelected = queryParams.get('TripSelected') || activeTripSelected? true:false;
          let editRowData = (PersistStorage.retrieve("rowDataEditTrip", true)  && tripSelected? PersistStorage.retrieve("rowDataEditTrip", true):"");
          iNewRefIDForCC = (editRowData !== "" && typeof editRowData === 'object'? editRowData.addressInfo.trips[index].details[0].tripInfo.refID : "");
        }

        let CheckCCParams = {
          "AffID": parseInt(selectedAff), 
          "amount": Amount.Go, 
          "pu_date": PUDate,
          "pu_time": PUTime, 
          "is_willcall": bWillCall, 
          "cc_unique_id": "", 
          "is_drop_info_available": bDropInfo,
          "phone_no": formattedPhone, 
          "app_id": iAppID, 
          "ref_id": iNewRefIDForCC,
          "is_multisch": (scheduleJSON.mainData !== "" && scheduleJSON.mainData.Schedule.ScheduleItem.length > 0 && verifiedAddr.length <= 1 ? true : false), 
          "return_trip": null
        };
        paymentCardIDInfoRef.current.uniqueID = -2;
        paymentCardIDInfoRef.current.invalidForSave = -1;
        paymentCardIDInfoRef.current.retCCUniqueID = -2;
        let stringData = JSON.stringify(CheckCCParams);
        setCheckCCParams(stringData);
        // CheckCCAmount(CheckCCParams); 
      }
    }
    catch(err){console.log(err);}
  };

  const CheckCCAmountResponseHandler = async (response) => {
    try{
      let iNewRefIDForCC = -1;
      let iNewReturnRefIDForCC = -1;
      if(!response || response === "")
      {
        setModalHeaderText("Error on CC Transaction");
        setModalBodyHTML("Invalid response while performing CC Transaction.");
        setModalFooterHTML(
          <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
            OK
          </Button>
        );
        setShowDynamicModal(true);
        setShowAddLegLoader(false);
      }
      else if(response && response.error !== "")
      {
        let Error = response.error;
        setModalHeaderText("Error on CC Transaction");
        setModalBodyHTML("Please try with another card as following error occured while performing CC Transaction: " + Error);
        setModalFooterHTML(
          <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
            OK
          </Button>
        );
        setShowDynamicModal(true);
        setShowAddLegLoader(false);
      }
      else
      {
        if(response.data.Trip.confNo && response.data.Trip.confNo !== ""){ iNewRefIDForCC = parseInt(response.data.Trip.confNo);}
        if(response.data.Trip.TranStatus !== "success")
        {
          setModalHeaderText("CC Transaction Failed");
          setModalBodyHTML("CC transaction failed for the following reason: " + response.data.Trip.Msg);
          setModalFooterHTML(
          <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
              OK
          </Button>
          );
          setShowDynamicModal(true);
          paymentCardIDInfoRef.current.uniqueID = -2;
          paymentCardIDInfoRef.current.retCCUniqueID = -2;
          paymentCardIDInfoRef.current.invalidForSave = -3;
          setShowAddLegLoader(false);
          return;
        }
        else
        {
          paymentCardIDInfoRef.current.uniqueID = cardInfo.uniqueID;
          if(response.data.Trip.PayStausID && response.data.Trip.PayStausID !== ""){paymentCardIDInfoRef.current.payStatusID = parseInt(response.data.Trip.PayStausID);}
        }
        if (response.data.RetTrip) {
          if (response.data.RetTrip.confNo && response.data.RetTrip.confNo !== ""){ iNewReturnRefIDForCC = parseInt(response.data.RetTrip.confNo);}
          if (response.data.RetTrip.TranStatus !== "success") {
            setModalHeaderText("CC Transaction Failed");
            setModalBodyHTML("Remove return trip, system will not save this trips as CC transaction has failed for the following reason: " + response.data.Trip.Msg);
            setModalFooterHTML(
                <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                OK
                </Button>
            );
            setShowDynamicModal(true);
            paymentCardIDInfoRef.current.retCCUniqueID = -2;
            paymentCardIDInfoRef.current.invalidForSave = -2;
            setShowAddLegLoader(false);
            return;
          }
          else paymentCardIDInfoRef.current.retCCUniqueID = paymentCardIDInfoRef.current.uniqueID;
        }
        paymentCardIDInfoRef.current.invalidForSave = 1;
        if(!showAddLegLoader)
        {
          await validateMinScheduleTimeDifference(null, false, false, 'book', {bCallAfterCCCheck: true, iNewRefID: iNewRefIDForCC, iNewReturnRefID: iNewReturnRefIDForCC});
        }
        else
        {
          await handleAddLeg(addLegBtnTitle, true, iNewRefIDForCC);
        }
      }
    }
    catch(err) {console.log(err); return 0;}
  };
  
  const CheckIfCCRequired = () => {
    try{
      let ObjAmount = { "Total": 0.00, "Go": 0.00, "Ret": 0.00 };
      let tempTarget = PayDropdown.find((option)=> (option?.props && parseInt(option.props.value) === parseInt(PaySelected)));
      let copayTempTarget = PayDropdown.find((option)=> (option?.props && parseInt(option.props.value) === parseInt(copayPayTypeSelected)));
      if(tempTarget && tempTarget.props.children.toLowerCase().includes("card") && parseInt(PaySelected) === 2)
      {
        ObjAmount.Go = (manualFareChecksRef.current.fareCheck && (manualDataOverwrite.fare !== "" && parseFloat(manualDataOverwrite.fare) > 0) ? parseFloat(manualDataOverwrite.fare) : parseFloat(clientSummary.TripFare));
        ObjAmount.Total = (manualFareChecksRef.current.fareCheck && (manualDataOverwrite.fare !== "" && parseFloat(manualDataOverwrite.fare) > 0) ? parseFloat(manualDataOverwrite.fare) : parseFloat(clientSummary.TripFare));
      }
      else if(copayTempTarget && copayTempTarget.props.children.toLowerCase().includes("card") && parseInt(copayPayTypeSelected) === 2)
      {
        ObjAmount.Go = parseFloat(fareEstimateAPISummary.copay);
        ObjAmount.Total = parseFloat(fareEstimateAPISummary.copay);
      }

      return ObjAmount;
    }
    catch(err){console.log(err); return { "Total": 0.00, "Go": 0.00, "Ret": 0.00 };}
  };

  function IsAppointmentTimeValid() {
    try{
      let retVal = true;

      if(appointmentTime === "" || schTime === "")
      {
        return retVal;
      }
      let DRT = parseFloat(clientSummary.TripDuration);
      let timeInMinutes = apptTimeCheckValsRef.current.ApptWindow + (2 * apptTimeCheckValsRef.current.ServiceTime) + DRT;
      const [hours, minutes] = appointmentTime.split(':').map(Number);
      const [PUhours, PUminutes] = schTime.split(':').map(Number);
      let TimeWindow = "";
      let apptTimeInMinutes = hours * 60 + minutes;
      let puTimeInMinutes = PUhours * 60 + PUminutes;

      TimeWindow = apptTimeInMinutes - timeInMinutes;

      retVal = puTimeInMinutes <= TimeWindow;

      TimeWindow = convertMinutesToTime(TimeWindow);
      apptTimeCheckValsRef.current.TimeWindow = TimeWindow;

      return retVal;
    }
    catch(err){console.log(err); return false;}
  }

  const GetiCCInfo = async (clientID, gateID, affID, indexGiven = -1, selectedTripIndex = -1) => {
    try
    {
      if(gateID == "") {
        setShowAPILoader(false);
        return;
      }
      setShowAPILoader(true);
      let myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');
      let headersObj = headersToObject(myHeaders);
      let data = {
        ClientID : clientID,
        GateID : gateID,
        ATSPID : affID
      };
      let response = await APICom.fetchData("ReservationCoreURL", "api/ParatransitCT/GetiCCInfo", "post", headersObj, data);
      if(response && response.error === "")
      {
        if(response.data !== "")
        {
          let CCInfo = response.data;
          if(!CCInfo.hasOwnProperty("Message"))
          {
            if((selectedTripIndex !== -1 && indexGiven !== -1 && parseInt(selectedTripIndex) === parseInt(indexGiven)) || indexGiven === -1)
            {
              setCardInfo(prevState=>({...prevState, cardNumber:CCInfo[0].Last4Digits, expiry: CCInfo[0].ExpiryDate, 
                selectedCard: CCInfo[0].Last4Digits, selectedExpiry: CCInfo[0].ExpiryDate, selectedCardType: CCInfo[0].CardType.trim(), uniqueID: CCInfo[0].UniqueID})
              );
              paymentCardIDInfoRef.current.oldUniqueID = CCInfo[0].UniqueID;
            }
            if(indexGiven !== -1)
            {
              setVerifiedAddr((prevVerifiedAddr) => {
                const updatedVerifiedAddr = prevVerifiedAddr.map((item, index) =>
                  index === indexGiven
                    ? { ...item,
                      CCInfo: {cardNumber:CCInfo[0].Last4Digits, expiry: CCInfo[0].ExpiryDate, selectedCard: CCInfo[0].Last4Digits, 
                        selectedExpiry: CCInfo[0].ExpiryDate, selectedCardType: CCInfo[0].CardType.trim(), uniqueID: CCInfo[0].UniqueID, gateID: gateID, response: ""
                      },
                      paymentLogicInfo: {...item.paymenetLogicInfo, oldUniqueID: CCInfo[0].UniqueID}
                    }: item
                  );
                return updatedVerifiedAddr;
              });
            }
          }
        }
      }
    }
    catch(err){console.log(err); setShowAPILoader(false);}
  };

  const GetCCTransInfo = async (refID, mode) => { //CC Info Update related function for future development (01/10/25)
    try{
      if(refID <= 0) 
        {
          setShowAPILoader(false);
          return;
        }
      let myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');
      let headersObj = headersToObject(myHeaders);
      let response = await APICom.fetchData("ReservationCoreURL", "api/ParatransitCT/GetCCTransInfo", "post", headersObj, parseInt(refID));
      setShowAPILoader(false);
      // console.log(response);
      if(response && response.data !== "")
      {
        let CCInfo = response.data;
        if(!CCInfo.hasOwnProperty("Message") && CCInfo !== "")
        {
          if(mode === 0)
            paymentCardIDInfoRef.current.CCPaidAmount = CCInfo[0].Amount;
          else
            paymentCardIDInfoRef.current.CCRetPaidAmount = CCInfo[0].Amount;
        }
        else
        {
          if(mode === 0)
            paymentCardIDInfoRef.current.CCPaidAmount = 0;
          else
            paymentCardIDInfoRef.current.CCRetPaidAmount = 0;
        }
      }
    }
    catch(err){console.log(err); setShowAPILoader(false);}
  };

  const handleParatransitCreateUpdateChecks = () => { //Function to automatically take care of edge case checks for paratransit reservation (optimizing efficiency)
    try{
      let schTimeCheck = IsAppointmentTimeValid();
      let isPickDropSame = sameAddrVerification(pickupAddr, dropAddr);
      let condition = true;
      if(passengerTypeCount.total === 0)
      {
        setModalHeaderText("Information Required");
        setModalBodyHTML("Total passenger count can not be 0.");
        setModalFooterHTML(
          <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
            OK
          </Button>
        );
        condition = false;
      }
      else if(!schTimeCheck)
      {
        setModalHeaderText("Stop Order Alert");
        setModalBodyHTML(<>{"Selected pickup time is violating appointment time, please select PU Time earlier than ["+apptTimeCheckValsRef.current.TimeWindow+"]."}</>);
        setModalFooterHTML(
          <>
          <Button variant='dark' className="border-0" onClick={()=>{setShowDynamicModal(false);}}>
            OK
          </Button>
          </>
        );
        condition = false;
      }
      else if(isPickDropSame && verifiedAddr.length === 0)
      {
        setModalHeaderText("Duplicate Address");
        setModalBodyHTML("Please select two different and verified addresses.");
        setModalFooterHTML(
          <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
            OK
          </Button>
        );
        condition = false;
      }
      else if(parseInt(brokerModes.brokerMode) > 0 && parseInt(brokerModes.globalBrokerMode) > 0 && riderVerification.toLowerCase().includes("not"))
      {
        setModalHeaderText("Invalid Rider ID");
        setModalBodyHTML("Please provide a valid rider ID or a different funding source to continue.");
        setModalFooterHTML(
          <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
            OK
          </Button>
        );
        condition = false;
      }
      else if((verifiedAddr.length === 0 && (pickLatLng.current === "" || dropLatLng.current === "")))
      {
        paratransitBookBtnRef.current.disabled = false;
        if(pickLatLng.current === "" || dropLatLng.current === "")
        {
          setModalHeaderText("Information Required");
          setModalBodyHTML("Please select pickup and dropoff addresses from the suggested dropdown.");
          setModalFooterHTML(
            <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
              OK
            </Button>
          );
          condition = false;
        }
      }

      if(!condition)
      {
        setShowDynamicModal(true);
        setModalClass("");
        setShowAPILoader(false);
        paratransitBookBtnRef.current.disabled = false;
        return false;
      }
      else
      {
        return true;
      }
    }
    catch(err){console.log(err); return false;}
  };

  const handleModal = (headerText, bodyHTML, footerButtons, modalClass = "", bookBtnRef) => {
    try{
      setModalHeaderText(headerText);
      setModalBodyHTML(bodyHTML);
      setModalFooterHTML(footerButtons);
      setModalClass(modalClass);
      setShowDynamicModal(true);
      setShowAPILoader(false);
      bookBtnRef.current.disabled = false;
    }
    catch(err){console.log(err);}
  };
  
  const createStopsArrDict = (stops, isMultiple = false, PhoneGiven = "", passengerNameGiven = "") => {
    try{
      let tempDict = {};
      let tempArr = [];
      for(let l = 0; l < stops.length; l++)
      {
        let givenPhone = (isMultiple? PhoneGiven : phone);
        let formattedPhone = formatPhone(givenPhone);
        tempDict = createTempDict();

        tempDict.StopType = (stops[l].passLoadType === "none" ? "wait" : stops[l].passLoadType);
        tempDict.WaitTime = (stops[l].waitTime !== 0 ? stops[l].waitTime : 0);
        tempDict.Name = (stops[l].passengerName !== "" ? stops[l].passengerName : (isMultiple? passengerNameGiven : riderName));
        
        if(stops[l].passLoadType !== "none")
        {
          if(stops[l].passLoadType === "unload")
          {
            tempDict.passengerInfo.TotalUnloadPassengers = stops[l].stopPax.total;
          }
          tempDict.passengerCountDetails.TotalPassengers = stops[l].stopPax.total;
          tempDict.passengerCountDetails.TotalWheelChairs = stops[l].stopPax.totalWC;
          tempDict.passengerCountDetails.ServiceAnimalCount = parseInt(stops[l].stopPax.totalSA);
        }
        tempDict.addressDetails.Address = stops[l].stopAddr;
        tempDict.addressDetails.Latitude = parseFloat(stops[l].stopLatLng.split(",")[0]);
        tempDict.addressDetails.Longitude = parseFloat(stops[l].stopLatLng.split(",")[1]);
        tempDict.addressDetails.City = "";
        tempDict.addressDetails.State = "";
        tempDict.addressDetails.Zip = "";
        tempDict.addressDetails.Remarks = stops[l].notes;
        tempDict.addressDetails.Phone = formattedPhone;
        
        tempArr.push(tempDict); 
      }             
      return tempArr; 
    }
    catch(err){console.log(err); return [];}
  };

  const CCMultiLegReservationCheck = async (bCallAfterCCCheck = false) => {
    try{
      if(!bCallAfterCCCheck) 
      {
        let CCAmount = CheckIfCCRequired();
        let cardSelectedID = cardInfo.uniqueID;
        if(paymentCardIDInfoRef.current.invalidForSave === -2)
        {
          if(CCAmount.Ret !== "" && parseFloat(CCAmount.Ret) > 0)
          {
            handleModal("CC Transaction Failed", "Please remove the return trip, as it does not qualifies for CC payment.", 
              <Button variant='dark' className="border-0" onClick={()=>{setShowDynamicModal(false);}}>
                OK
              </Button>, '', paratransitBookBtnRef
            );
            setShowAddLegLoader(false);
            return 0;
          }
          else
          {
            paymentCardIDInfoRef.current.invalidForSave = 1;
            paymentCardIDInfoRef.current.retCCUniqueID = -2;
          }
        }
        else if(paymentCardIDInfoRef.current.invalidForSave === -3)
        {
          if(CCAmount.Go !== "" && parseFloat(CCAmount.Go) > 0)
          {
            handleModal("CC Transaction Failed", "Please select another card or change payment type, as trip does not qualifies for CC Payment.", 
              <Button variant='dark' className="border-0" onClick={()=>{setShowDynamicModal(false);}}>
                OK
              </Button>, '', paratransitBookBtnRef
            );
            setShowAddLegLoader(false);
            return 0;
          }
          else
          {
            paymentCardIDInfoRef.current.invalidForSave = 1;
            paymentCardIDInfoRef.current.uniqueID = -2;
            paymentCardIDInfoRef.current.retCCUniqueID = -2;
          }
        }
        if(paymentCardIDInfoRef.current.invalidForSave < 1 && CCAmount.Total !== "" && parseFloat(CCAmount.Total) > 0)
        {
          if(cardSelectedID === 0)
          {
            handleModal("CC Selection Alert", "Credit Card is invalid. Please select another card.", 
              <Button variant='dark' className="border-0" onClick={()=>{setShowDynamicModal(false);}}>
                OK
              </Button>, '', paratransitBookBtnRef
            );
            setShowAddLegLoader(false);
            return 0;
          }
          if(addLegBtnTitle !== "Update")
          { //On add leg:
            VerifyCCAmount(CCAmount);
            setShowAPILoader(false);
            paratransitBookBtnRef.current.disabled = false;
            return 0;
          }
          else
          { //For update condition ONLY
            let CCPrePaymentMethod = ASCSSettingData ? (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "CCPrePaymentMethodOnTripBooking")).value : 0;
            if(CCPrePaymentMethod !== "2")
            {
              //cardSelectedID being old UniqueID while paymentCardRef constantly updates
              if(paymentCardIDInfoRef.current.oldUniqueID !== -1 && cardSelectedID !== paymentCardIDInfoRef.current.oldUniqueID && paymentCardIDInfoRef.current.CCPaidAmount !== 0)
              {
                handleModal("CC Selection Alert", "Trip was already paid with another credit card, you cannot change credit card.", 
                  <Button variant='dark' className="border-0" onClick={()=>{setShowDynamicModal(false);}}>
                    OK
                  </Button>, '', paratransitBookBtnRef
                );
                setShowAddLegLoader(false);
                return 0;
              }
              else if(cardSelectedID !== paymentCardIDInfoRef.current.oldUniqueID && paymentCardIDInfoRef.current.CCPaidAmount === 0)
              {
                VerifyCCAmount(CCAmount);
                setShowAPILoader(false);
                paratransitBookBtnRef.current.disabled = false;
                return 0;
              }
              else
              {
                paymentCardIDInfoRef.current.uniqueID = cardSelectedID;
              }
            }
            else
            {
              if(cardSelectedID === paymentCardIDInfoRef.current.oldUniqueID && 
                (CCAmount.Go !== "" && parseFloat(CCAmount.Go).toFixed(2) > parseFloat(paymentCardIDInfoRef.current.CCPaidAmount).toFixed(2))
                || (CCAmount.Ret !== "" && parseFloat(CCAmount.Ret).toFixed(2) > parseFloat(paymentCardIDInfoRef.current.CCRetPaidAmount).toFixed(2))
              )
              {
                if(CCAmount.Go !== "" && parseFloat(CCAmount.Go).toFixed(2) > parseFloat(paymentCardIDInfoRef.current.CCPaidAmount).toFixed(2))
                {
                  CCAmount.Go = (parseFloat(CCAmount.Go) - parseFloat(paymentCardIDInfoRef.current.CCPaidAmount)).toFixed(2);
                }
                else
                {
                  CCAmount.Go = 0.0;
                }
                if(CCAmount.Ret !== "" && parseFloat(CCAmount.Ret).toFixed(2) > parseFloat(paymentCardIDInfoRef.current.CCRetPaidAmount).toFixed(2))
                {
                  CCAmount.Ret = (parseFloat(CCAmount.Ret) - parseFloat(paymentCardIDInfoRef.current.CCRetPaidAmount)).toFixed(2);
                }
                else
                {
                  CCAmount.Ret = 0.0;
                }
                if(CCAmount.Go === "")
                {
                  CCAmount.Go = 0.0;
                }
                if(CCAmount.Ret === "")
                {
                  CCAmount.Ret = 0.0;
                }
                CCAmount.Total = (parseFloat(CCAmount.Go) + parseFloat(CCAmount.Ret)).toFixed(2);
                VerifyCCAmount(CCAmount);
                setShowAPILoader(false);
                paratransitBookBtnRef.current.disabled = false;
                return 0;
              }
              else if(cardSelectedID !== paymentCardIDInfoRef.current.oldUniqueID && paymentCardIDInfoRef.current.CCPaidAmount === 0)
              {
                VerifyCCAmount(CCAmount);
                setShowAPILoader(false);
                paratransitBookBtnRef.current.disabled = false;
                return 0;
              }
              else if(paymentCardIDInfoRef.current.oldUniqueID !== -1 && cardSelectedID !== paymentCardIDInfoRef.current.oldUniqueID && paymentCardIDInfoRef.current.CCPaidAmount !== 0)
              {
                handleModal("CC Selection Alert", "Trip was already paid with another credit card, you cannot change credit card.", 
                  <Button variant='dark' className="border-0" onClick={()=>{setShowDynamicModal(false);}}>
                    OK
                  </Button>, '', paratransitBookBtnRef
                );
                setShowAddLegLoader(false);
                return 0;
              }
              else
              {
                paymentCardIDInfoRef.current.uniqueID = cardSelectedID;
              }
            }
          }
        }
      }
      return 1;
    }
    catch(err){console.log(err); return 0;}
  };

  const handleGetTripsDetailsWithStops = async (IsWaitTime = false) => {
    try{
      let stopDetailsTrackerArr = [];
      let waitTime = 0;
      let distanceInMeters = 0;
      let durationInSeconds = 0;
      let entireTripDistance = 0;
      let entireTripDuration = 0;
      let entireTimeCalculated = 0;
      let myHeaders = new Headers();
        myHeaders.append("Authorization", 'Basic '+btoa(OSRM_Username.current + ":" + OSRM_Password.current));
        myHeaders.append('Content-Type', 'application/json');
      let addressAPI = ITCMapRawURL.current+'directionswithstoporder';
      let headersObj = headersToObject(myHeaders);
      let stopsDetailsArr = [{
        "StopOrder": 1,
        "StopLat": pickLatLng.current.split(",")[0],
        "StopLong": pickLatLng.current.split(",")[1]
      }, ...clientStops.map((item,index)=>{
        return {
          "StopOrder": (index+2),
          "StopLat": item.stopLatLng.split(",")[0],
          "StopLong": item.stopLatLng.split(",")[1]
        };
      }), {
        "StopOrder": (clientStops.length + 2),
        "StopLat": dropLatLng.current.split(",")[0],
        "StopLong": dropLatLng.current.split(",")[1]
      }]; 
      let data = {
        "ManifestNumber" : "",
        "StopList": stopsDetailsArr
      }
      
      let OSRMResponse = await APICom.fetchData("full", addressAPI, "post", headersObj, data);

      if(OSRMResponse && OSRMResponse.error === "" && OSRMResponse.data.StopList.length > 0)
      {
        if(IsWaitTime){
          for(let i = 0; i < clientStops.length; i++)
          {
            waitTime += parseInt(clientStops[i].waitTime && clientStops[i].waitTime !== 0 ? clientStops[i].waitTime:0); 
          }
        }
        for(let k = 0; k < OSRMResponse.data.StopList.length; k++)
        {
          if(parseInt(OSRMResponse.data.StopList[k].StopOrder) >= 2)
          {
            let timeCalculated = 0;
            if(OSRMResponse.data.mapSource === 'OSRM')
            {
              timeCalculated = handleZoneSpeedMultiplierChecks(dispatchZones.pickZone, dispatchZones.dropZone, selectedAff, parseInt(OSRMResponse.data.StopList[k].TimeFromPrevStop));
            }
            else
            {
              timeCalculated = (parseInt(OSRMResponse.data.StopList[k].TimeFromPrevStop)/60);
            }
            stopDetailsTrackerArr.push({stopNo:(parseInt(OSRMResponse.data.StopList[k].StopOrder)-1), 
              distance: parseFloat(parseFloat(OSRMResponse.data.StopList[k].DistFromPrevStop)/1609).toFixed(1),
              duration: parseFloat(timeCalculated).toFixed(2)}
            );
          }
          if(IsWaitTime)
          {
            distanceInMeters += OSRMResponse.data.StopList[k].DistFromPrevStop;
            durationInSeconds += OSRMResponse.data.StopList[k].TimeFromPrevStop;
          }
        }

        if(IsWaitTime)
        {
          if(OSRMResponse.data.mapSource === 'OSRM')
          {
            entireTimeCalculated = handleZoneSpeedMultiplierChecks(dispatchZones.pickZone, dispatchZones.dropZone, selectedAff, parseInt(durationInSeconds));
          }
          else
          {
            entireTimeCalculated = (parseInt(durationInSeconds)/60);
          }
          entireTripDistance = parseFloat(parseFloat(distanceInMeters)/1609).toFixed(1);
          entireTripDuration = parseFloat(entireTimeCalculated).toFixed(2) + waitTime;
        }
       

        for(let j = 0; j < stopDetailsTrackerArr.length; j++)
        {
          let response = await getFareDataResponse(stopDetailsTrackerArr[j].distance, stopDetailsTrackerArr[j].duration, 
            FSSelected, copayFSSelected, passengerTypeCount.totalWC, passengerTypeCount.total, 
            COSSelected, selectedAff, pickLatLng.current, copayAmount
          );

          stopDetailsTrackerArr[j] = {...stopDetailsTrackerArr[j], fareDetails: response };
        }
      }
      return {stopDetails:stopDetailsTrackerArr, waitTimeCalculated: waitTime, totalTripEstimates:{dist: entireTripDistance, dur: entireTripDuration}};
    }
    catch(err){console.log(err); return {stopDetails:[], waitTimeCalculated: 0, totalTripEstimates:{dist: 0, dur: 0}};}
  };

  function CheckResponseStatus (response) {
    let errorFound = (response.error.length > 0);
    let error = response.error;
    let dataFound = (response.data && parseInt(response.data.responseCode) === 200);
    return {errorMsg: error, dataDict: response.data, isDataGiven: dataFound, isErrorGiven: errorFound};
  }

  function handleCCAmountCheckBeforeBook (isTimeValid = false) {
    try{
      let CCAmount = CheckIfCCRequired();
      let cardSelectedID = cardInfo.uniqueID;
      if(paymentCardIDInfoRef.current.invalidForSave === -2)
      {
        if(CCAmount.Ret !== "" && parseFloat(CCAmount.Ret) > 0)
        {
          handleModal("CC Transaction Failed", "Please remove the return trip, as it does not qualifies for CC payment.", 
            <Button variant='dark' className="border-0" onClick={()=>{setShowDynamicModal(false);}}>
              OK
            </Button>, '', paratransitBookBtnRef
          );
          return 0;
        }
        else
        {
          paymentCardIDInfoRef.current.invalidForSave = 1;
          paymentCardIDInfoRef.current.retCCUniqueID = -2;
        }
      }
      else if(paymentCardIDInfoRef.current.invalidForSave === -3)
      {
        if(CCAmount.Go !== "" && parseFloat(CCAmount.Go) > 0)
        {
          handleModal("CC Transaction Failed", "Please select another card or change payment type, as trip does not qualifies for CC Payment.", 
            <Button variant='dark' className="border-0" onClick={()=>{setShowDynamicModal(false);}}>
              OK
            </Button>, '', paratransitBookBtnRef
          );
          return 0;
        }
        else
        {
          paymentCardIDInfoRef.current.invalidForSave = 1;
          paymentCardIDInfoRef.current.uniqueID = -2;
          paymentCardIDInfoRef.current.retCCUniqueID = -2;
        }
      }
      if(paymentCardIDInfoRef.current.invalidForSave < 1 && CCAmount.Total !== "" && parseFloat(CCAmount.Total) > 0)
      {
        if(cardSelectedID === 0)
        {
          handleModal("CC Selection Alert", "Credit Card is invalid, do you still want to continue saving the trip?", 
            <>
              <Button variant='dark' className="border-0" onClick={()=>
                {setShowDynamicModal(false); handleCreateUpdateParatransitTrip(isTimeValid, {bCallAfterCCCheck: true, iNewRefID: -1, iNewReturnRefID: -1});}}
              >
                Yes
              </Button>
              <Button variant='secondary' className="border-0" onClick={()=>
                {setShowDynamicModal(false); setShowAPILoader(false); paratransitBookBtnRef.current.disabled = false;}}
              >
                No
              </Button>
            </>, '', paratransitBookBtnRef
          );
          return 0;
        }
        if(submitParatransitBtnTitle !== "Update")
        { //On booking:
          VerifyCCAmount(CCAmount);
          setShowAPILoader(false);
          paratransitBookBtnRef.current.disabled = false;
          return 0;
        }
        else
        { //For update condition ONLY
          let CCPrePaymentMethod = ASCSSettingData ? (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "CCPrePaymentMethodOnTripBooking")).value : 0;
          if(CCPrePaymentMethod !== "2")
          {
            //cardSelectedID being old UniqueID while paymentCardRef constantly updates
            if(paymentCardIDInfoRef.current.oldUniqueID !== -1 && cardSelectedID !== paymentCardIDInfoRef.current.oldUniqueID && paymentCardIDInfoRef.current.CCPaidAmount !== 0)
            {
              handleModal("CC Selection Alert", "Trip was already paid with another credit card, you cannot change credit card.", 
                <Button variant='dark' className="border-0" onClick={()=>{setShowDynamicModal(false);}}>
                  OK
                </Button>, '', paratransitBookBtnRef
              );
              return 0;
            }
            else if(cardSelectedID !== paymentCardIDInfoRef.current.oldUniqueID && paymentCardIDInfoRef.current.CCPaidAmount === 0)
            {
              VerifyCCAmount(CCAmount);
              setShowAPILoader(false);
              paratransitBookBtnRef.current.disabled = false;
              return 0;
            }
            else
            {
              paymentCardIDInfoRef.current.uniqueID = cardSelectedID;
            }
          }
          else
          {
            if(cardSelectedID === paymentCardIDInfoRef.current.oldUniqueID && 
              (CCAmount.Go !== "" && parseFloat(CCAmount.Go).toFixed(2) > parseFloat(paymentCardIDInfoRef.current.CCPaidAmount).toFixed(2))
              || (CCAmount.Ret !== "" && parseFloat(CCAmount.Ret).toFixed(2) > parseFloat(paymentCardIDInfoRef.current.CCRetPaidAmount).toFixed(2))
            )
            {
              if(CCAmount.Go !== "" && parseFloat(CCAmount.Go).toFixed(2) > parseFloat(paymentCardIDInfoRef.current.CCPaidAmount).toFixed(2))
              {
                CCAmount.Go = (parseFloat(CCAmount.Go) - parseFloat(paymentCardIDInfoRef.current.CCPaidAmount)).toFixed(2);
              }
              else
              {
                CCAmount.Go = 0.0;
              }
              if(CCAmount.Ret !== "" && parseFloat(CCAmount.Ret).toFixed(2) > parseFloat(paymentCardIDInfoRef.current.CCRetPaidAmount).toFixed(2))
              {
                CCAmount.Ret = (parseFloat(CCAmount.Ret) - parseFloat(paymentCardIDInfoRef.current.CCRetPaidAmount)).toFixed(2);
              }
              else
              {
                CCAmount.Ret = 0.0;
              }
              if(CCAmount.Go === "")
              {
                CCAmount.Go = 0.0;
              }
              if(CCAmount.Ret === "")
              {
                CCAmount.Ret = 0.0;
              }
              CCAmount.Total = (parseFloat(CCAmount.Go) + parseFloat(CCAmount.Ret)).toFixed(2);
              VerifyCCAmount(CCAmount);
              setShowAPILoader(false);
              paratransitBookBtnRef.current.disabled = false;
              return 0;
            }
            else if(cardSelectedID !== paymentCardIDInfoRef.current.oldUniqueID && paymentCardIDInfoRef.current.CCPaidAmount === 0)
            {
              VerifyCCAmount(CCAmount);
              setShowAPILoader(false);
              paratransitBookBtnRef.current.disabled = false;
              return 0;
            }
            else if(paymentCardIDInfoRef.current.oldUniqueID !== -1 && cardSelectedID !== paymentCardIDInfoRef.current.oldUniqueID && paymentCardIDInfoRef.current.CCPaidAmount !== 0)
            {
              handleModal("CC Selection Alert", "Trip was already paid with another credit card, you cannot change credit card.", 
                <Button variant='dark' className="border-0" onClick={()=>{setShowDynamicModal(false);}}>
                  OK
                </Button>, '', paratransitBookBtnRef
              );
              return 0;
            }
            else
            {
              paymentCardIDInfoRef.current.uniqueID = cardSelectedID;
            }
          }
        }
      }
      return 1;
    }
    catch(err){
      console.log(err);
      handleModal("CC Alert", "An error occured on CC validation, please try again.", 
        <Button variant='dark' className="border-0" onClick={()=>{setShowDynamicModal(false);}}>
          OK
        </Button>, '', paratransitBookBtnRef
      );
      return 0;
    }
  }

  function isStateZip(part) {
    return /^[A-Z]{2}\s\d{5}(-\d{4})?$/.test(part.trim());
  }
  
  function isCountry(part) {
    const countries = ['USA', 'US', 'United States', "usa", "us", "united states"];
    return countries.includes(part.trim());
  }
  

  function extractStreetAddress(address) {
    if (!address) return "";
  
    const parts = address.split(',').map(part => part.trim());
  
    if (parts.length >= 3) {
      return parts.slice(0, parts.length - 2).join(', ');
    } else if (parts.length === 2) {
      return parts[0];
    }
    
    return address;
  }

  const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

  const handleCreateUpdateParatransitTrip = async (isTimeValid = false, bookingCCDict = {bCallAfterCCCheck : false, iNewRefID : -1, iNewReturnRefID: -1}, 
    forcePassFlagAccepted = false, iRiderID = -1, forceDuplicateReservation = false, checkOutofSrvAreVali = true, checkValidationForPCASelections = true,
    checkValidationForDuplicateTrips = true) => {
    try{

      let doesUserEntersSchedluePickupTime = true;
      try {
        if(verifiedAddr.length === 0){
          if(scheduleJSON?.mainData?.Schedule?.ScheduleItem?.length == 0 || scheduleJSON?.mainData?.Schedule == undefined || scheduleJSON?.mainData == ""){
            doesUserEntersSchedluePickupTime = await FutureDateValidation();
            if(doesUserEntersSchedluePickupTime === false){
              return;
            }
          }
        }
      } catch (error) {
        
      }

      if(isAffiliateHasMobilityAttributes){
        MakeMobilitiesObject();
      }

      let exclusionsListArr = (scheduleJSON.mainData !== "" && scheduleJSON.mainData.Exclusions.length > 0 ? scheduleJSON.mainData.Exclusions.map((item, index)=>{
        return {
          "ExclusionDate": (item.exclusionDate ? item.exclusionDate : (item.Date.split(" - ")[0] +" "+ item.Date.split(" - ")[1])),
          "ScheduleId": 0,
          "UserId": (loginData.iUserID ? loginData.iUserID : 0),
          "IsHoliday": (item.isHolidayExc ? item.isHolidayExc : item.isHoliday)
        };
      }) : []);
      const queryParams = new URLSearchParams(window.location.search);
      const tripSelected = queryParams.get('TripSelected') || activeTripSelected? true:false;
      let editRowData = (PersistStorage.retrieve("rowDataEditTrip", true)  && tripSelected? PersistStorage.retrieve("rowDataEditTrip", true):"");
      let multiSchItems = (scheduleJSON.mainData !== "" && scheduleJSON.mainData.Schedule ? scheduleJSON.mainData.Schedule : {});
      let affiliateID = (verifiedAddr.length > 0 ? parseInt(verifiedAddr[0].AffiliateSelected) : selectedAff);
      let combinedDataAddedTimeVF = ASCSSettingData ? (JSON.parse(ASCSSettingData[affiliateID]).find((item)=>item.SubTitle === "Ta01")).value : 0;
      let combinedDataDefaultShowPhoneVF = ASCSSettingData ? (JSON.parse(ASCSSettingData[affiliateID]).find((item)=>item.SubTitle === "DefaultCustomerShowPhoneNo")).value: false;
      let fsDataVF = FundingSourceData ? JSON.parse(FundingSourceData[parseInt(affiliateID)]) : [];
      let combinedDataDefaultSkipPaymentScreenVF = (fsDataVF.length > 0 ? ((fsDataVF.find((item)=> 
        { let givenFS = (verifiedAddr.length > 0 ? parseInt(verifiedAddr[0].FundingSource) : parseInt(FSSelected)); return parseInt(item.FID) === givenFS}
      ))?.bSkipPaymentProcessOnSD) : false);
      let combinedDataDefaultUseHTMLFormatEmailVF = ASCSSettingData ? (JSON.parse(ASCSSettingData[affiliateID]).find((item)=>item.SubTitle === "UseHTMLFormatEmail")).value : false;
      let combinedDataSendEmailFromSASVF = ASCSSettingData ? (JSON.parse(ASCSSettingData[affiliateID]).find((item)=>item.SubTitle === "Web_Shuttle_SendEmailFromSASCode")).value : false;
      let combinedDataSRDuplicateDelayVF = ASCSSettingData ? (JSON.parse(ASCSSettingData[affiliateID]).find((item)=>item.SubTitle === "SRDuplicateCallDelay")).value : 0;
      let correctPhoneFormat = ((verifiedAddr.length > 0 && verifiedAddr[0].phone) ? (verifiedAddr[0].phone.includes("-") ? verifiedAddr[0].phone : formatPhone(verifiedAddr[0].phone)) : formatPhone(phone));
      let FamilyIDVF = (AffiliateData && Array.isArray(AffiliateData) ? 
        (AffiliateData.find((item) => {if(parseInt(item.AffiliateID) === parseInt(affiliateID)){return item}})).iPartnerAffiliateID : 0
      );
      let trimmedName = (verifiedAddr.length > 0 ? verifiedAddr[0].riderName.trim() : riderName.trim());
      // let firstNameVF = trimmedName.includes(",") ? trimmedName.split(",")[1].trim() : (trimmedName.includes(" ")? trimmedName.split(" ")[0].trim(): trimmedName);
      // let lastNameVF = trimmedName.includes(",") ? trimmedName.split(",")[0].trim() : (trimmedName.includes(" ")? trimmedName.replace(firstNameVF, "").trim(): "");
      let insuranceInfoVF = {
        AgencyID: (verifiedAddr.length > 0 ? (verifiedAddr[0].insurance.Agency === "" ? 0 : verifiedAddr[0].insurance.Agency) : (insuranceAgency === "" ? 0 : insuranceAgency)),
        InsuranceID: (verifiedAddr.length > 0 ? (verifiedAddr[0].insurance.Type === "" ? 0 : verifiedAddr[0].insurance.Type) : (insuranceType === "" ? 0 : insuranceType)),
        CaseWorkerID: (verifiedAddr.length > 0 ? (verifiedAddr[0].insurance.CaseWorker === "" ? 0 : verifiedAddr[0].insurance.CaseWorker) : (insuranceCaseWorker === "" ? 0 : insuranceCaseWorker)),
        AuthID: (verifiedAddr.length > 0 ? (verifiedAddr[0].insurance.AuthCode === "" ? 0 : verifiedAddr[0].insurance.AuthCode) : (insuranceAuthCode === "" ? 0 : insuranceAuthCode)),
        ServiceCodeID: (verifiedAddr.length > 0 ? (verifiedAddr[0].insurance.ServiceCode === "" ? 0 : verifiedAddr[0].insurance.ServiceCode) : (insuranceServiceCode === "" ? 0 : insuranceServiceCode)),
        MedicalID: (verifiedAddr.length > 0 ? (verifiedAddr[0].clientMedID? verifiedAddr[0].clientMedID : "") : (clientInfo.MedicalId? clientInfo.MedicalId : ""))
      };
      let serviceHourCheckSettings = (ASCSSettingData ? (JSON.parse(ASCSSettingData[affiliateID]).find((item)=>item.SubTitle === "ServiceHoursViolation")).value : true);
      serviceHourCheckSettings = String(serviceHourCheckSettings) === "true";
      let systemConfigInfoVF = {
        DefaultCustomerShowPhoneNo: combinedDataDefaultShowPhoneVF,
        IsSkipPaymentProcessOnSD: combinedDataDefaultSkipPaymentScreenVF,
        Ta01: combinedDataAddedTimeVF,
        UseHTMLFormatEmail: combinedDataDefaultUseHTMLFormatEmailVF,
        Web_Shuttle_SendEmailFromSASCode: combinedDataSendEmailFromSASVF,
        SRDuplicateCallDelay: combinedDataSRDuplicateDelayVF,
        ServiceHoursViolation: serviceHourCheckSettings
      };
      let duplicateDelay = parseInt(combinedDataSRDuplicateDelayVF)/60;
      let isScheduledDateCheck = false;

      if(riderName.trim().length >= 2 && phone && phone.length >= 12)
      {
        let validateConditions = handleParatransitCreateUpdateChecks();
        let currDateCheck = new Date(systemDateTimeRef.current.givenDate + " 00:00:00");
        let providedDateCheck = new Date(selectedDateSchTime+" 00:00:00");
        let attrStringListVF = "";
        let areAllDaysExcluded = false;
        if(verifiedAddr.length === 0)
        {
          attrStringListVF = (selectedTripAttr.length > 0 ? selectedTripAttr.join(",") : "");
        }
        else
        {
          attrStringListVF = verifiedAddr.map((item)=>(item.tripAttribute.length > 0 ? item.tripAttribute.join(",") : ""));
        }
        if(providedDateCheck > currDateCheck) { isScheduledDateCheck = true;}
        if(!bookingCCDict.bCallAfterCCCheck && verifiedAddr.length === 0) 
        {
          let CCValid = handleCCAmountCheckBeforeBook(isTimeValid);
          if(!CCValid){
            return 0;
          }
        }

        if(submitParatransitBtnTitle === "Update")
        {
          if(validateConditions)
          {
            let stopsArr = [];
            setModalHeaderText("Updating In Progress");
            setModalBodyHTML("Trip is being updated, please wait.");
            setModalFooterHTML("");
            setModalClass("d-none");
            setShowAPILoader(true);
            setShowDynamicModal(true);
            let nTotalUnloaded = 0;
            if(verifiedAddr.length === 0)
            {
              for(let l = 0; l < clientStops.length; l++)
              {
                if(clientStops[l].passLoadType !== "none" && clientStops[l].passLoadType === "unload")
                {
                  nTotalUnloaded += clientStops[l].stopPax.total;
                }
              }
              //Single trip update 
              let pickupStop = fillAddressDetails(
                mapPointPickupSelection.current,
                pickExtraInfo,
                pickLatLng.current,
                "pickup", 
                "",
                "update",
                editRowData,
                nTotalUnloaded, 
                attrStringListVF,
                0,
                bookingCCDict.iNewRefID,
                isScheduledDateCheck,
                forcePassFlagAccepted,
                systemConfigInfoVF.IsSkipPaymentProcessOnSD,
                false, 
                true
              );
              stopsArr.push(pickupStop);

              // let tempDict = {};
              
              if(clientStops.length > 0)
              {
                // let stopDetailsTrackerObj = await handleGetTripsDetailsWithStops();
                let tempArr = createStopsArrDict(clientStops);
                stopsArr = [...stopsArr, ...tempArr];                
              }
              let dropoffStop = fillAddressDetails(
                mapPointDropoffSelection.current,
                dropExtraInfo,
                dropLatLng.current,
                "dropoff",
                "",
                "update",
                editRowData,
                nTotalUnloaded,
                attrStringListVF,
                0,
                bookingCCDict.iNewRefID,
                isScheduledDateCheck,
                forcePassFlagAccepted,
                systemConfigInfoVF.IsSkipPaymentProcessOnSD
              );
              stopsArr.push(dropoffStop);
              
              const transformedData = {
                Details: stopsArr.map(item=>item)
              };

              let tripsDetailsObj = {
                generalInfo: {
                  "RequestAffiliateID": parseInt(affiliateID),
                  "ReturnDetailID": "",
                  "FamilyID": parseInt(FamilyIDVF)
                },
                riderInfo: {
                  "ID": (forcePassFlagAccepted ? iRiderID : (editRowData !== "" && editRowData.riderInfo.id ? parseInt(editRowData.riderInfo.id) : (accountNumber ? parseInt(accountNumber) : -1))),
                  "PhoneNo": correctPhoneFormat,
                  "PickupPerson": trimmedName,
                  "DateOfBirth": (editRowData !== "" && editRowData.riderInfo.dateOfBirth ? editRowData.riderInfo.dateOfBirth : "01/01/1900"),
                  "RiderID": (medID && medID !== "" && parseInt(medID) !== 0 ? String(medID) : "0"),
                  "MedicalID": (editRowData !== "" && editRowData.riderInfo.medicalID? clientInfo.riderInfo.medicalID : ""),
                  "ClientAddress": (clientInfo.Address ? clientInfo.Address : ""),
                  "ClientCity": (clientInfo.City ? clientInfo.City : ""),
                  "ClientState": (clientInfo.State ? clientInfo.State : ""),
                  "ClientZip": (editRowData !== "" && editRowData.riderInfo.clientZip ? editRowData.riderInfo.clientZip : "")
                },
                insuranceInfo: insuranceInfoVF,
                systemConfigInfo: systemConfigInfoVF,
                exclusions: (scheduleJSON.mainData !== "" && scheduleJSON.mainData.Schedule.ScheduleItem.length > 0 && verifiedAddr.length <= 1 ? exclusionsListArr : []),
                scheduleInfo: multiSchItems,  
                addressInfo: {
                  "Trips":[transformedData],
                }
              };
              let data = createParaDataDict(tripsDetailsObj);

              if(isAffiliateHasMobilityAttributes){
                if(!isPCAApprovedFromEaas){
                  let doesAttributesHas_PCA = DoesPCAIncludedInAttributes(tripsDetailsObj.addressInfo.Trips);
                  let ContinueBooking ;
                  if(doesAttributesHas_PCA && checkValidationForPCASelections == true){
                    ContinueBooking = await showConfirmationModal("PCA is not authorized for the customer. Do you still want to book?", WARNING_PCA_NOT_ALLOWED, false);
                    setIsPCAApprovalCaputured(true);
                    if(ContinueBooking === false) 
                    {
                      setShowAPILoader(false);
                      return;
                    }
                  }
                }
              }
              

              let lstTripData;
              let PredictiveRoutedTripForCancellation;
              if(tripStatus === "Routed" && !PredictiveRef.current.ByPassPredictiveCheck)
              {
                lstTripData = hasTripDataChanged(data, editRowData);
                if(lstTripData.length > 0)
                {
                  for(let a = 0; a < lstTripData.length; a++)
                  {
                      if(lstTripData[a].InsertPredictiveRouteEntry)
                      {
                        PredictiveRoutedTripForCancellation = lstTripData[a];
                        break;
                      }
                  }
                  if(PredictiveRoutedTripForCancellation && PredictiveRoutedTripForCancellation.InsertPredictiveRouteEntry)
                  {
                    PredictiveRef.current.PredictiveData = data;
                    setModalHeaderText("Routed Trip Changed");
                    setModalBodyHTML(<>{`Trip is routed and changing PU/DO Address, Time, Passenger count, Mobility will cancel this reservation
                    and will book as a new ride with negotiation, Are you sure ?`}</>);
                      setModalFooterHTML(
                        <>
                          <Button variant='dark' className="border-0" onClick={()=>{ PredictiveRef.current.ByPassPredictiveCheck = true;  handleCreateUpdateParatransitTrip(isTimeValid, bookingCCDict, true, iRiderID, false, true, false);}}>
                            Yes
                          </Button>
                          <Button variant='secondary' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                            No
                          </Button>
                        </>
                      );
                      setShowDynamicModal(true);
                      setModalClass("");
                      setShowAPILoader(false);
                      return;
                  }
                }
              }
              if(PredictiveRef && PredictiveRef.current.ByPassPredictiveCheck && PredictiveRef.current.PredictiveData)
              {
                data = PredictiveRef.current.PredictiveData;
                if(forcePassFlagAccepted)
                {
                  data.addressInfo.Trips[0].Details[0].tripInfo.ForcePassServiceHoursCheck = true;
                }
              }

              if(isAffiliateHasMobilityAttributes){
                const { isCapacityValid = false, validationMsg = "" } = await validateMobilityCapacities(tripsDetailsObj);
                if(isCapacityValid == false){
                  toast.error(validationMsg, {
                    autoClose: 6000,
                    position: "top-center",
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true
                  });
                  await sleep(2000);
                }
              }

              let continueBooking = await validateMaxPassengerCount(tripsDetailsObj);
              if(continueBooking == false){
                return;
              }

              let response = await APICom.fetchData("ReservationCoreURL","UpdateBookedTrip", "post", {}, data, xCancelSourceForGrid.current); 
              let responseDict = CheckResponseStatus(response);
              if(!responseDict.isErrorGiven)
              {
                if(responseDict.isDataGiven)
                {
                  if(responseDict.dataDict.lstServiceHourViolation.length === 0)
                  {
                    let tripID = responseDict.dataDict.iRefID;
                    setConfirmationNo(tripID);
                    let historyTripsListSaved = PersistStorage.retrieve("agentTrips", true);
                    let historyTripsList = historyTripsListSaved && historyTripsListSaved.length !== 0 ? [...historyTripsListSaved] : [];
                    historyTripsList.push({confirmation:tripID, tripData:data, type: (data.addressInfo.Trips[0].Details[0].dateInfo.IsScheduled ? "Time Call (Update)":"On Demand (Update)")});
                    setHistoryTrips(historyTripsList);
                    PersistStorage.save("agentTrips", historyTripsList, 9999, true);
                    if(response.data.isPredictiveOutPut)
                    {
                      await handlePredictiveNegotiation(response.data.predictiveJSON, "Update");
                    }
                    
                    ResetEnableFutureDateValiation();
                    if(response.data.isPredictiveOutPut){
                      setModalClass("");
                      let predictiveItems = JSON.parse(response.data.predictiveJSON);
                      let items = [];
                      if(predictiveItems){
                        predictiveItems?.forEach(item => {
                          let title = "Confirmation# " + item.Confirmation + ", Please wait while the system is checking the service availability...";
                          items.push({confirmationNumber: item.Confirmation, 
                            pickDate: moment(item.PickDate, "M/D/YYYY h:mm A").format("M/D/YYYY h:mm A"),
                            status: "Pending",title: title, 
                            offeredTime: item.offeredTime,
                            showLoader: true,
                            counter: 0  
                          });
                        });
                      }
                      setPredictiveHeaderTitle("Trip Updated Successfully");
                      setPredictiveHeaderMsg("Please use the following confirmation number to check your trip status " + tripID);
                      items.sort((a, b) => new Date(a.offeredTime) - new Date(b.offeredTime));
                      setPredictiveNegotiationList(items);
                      setShowPredictiveNegotiationStatusCard(true);
                    }

                    setModalHeaderText("Trip Updated Successfully");
                    setModalBodyHTML(
                      <>
                        <p className="m-0 user-select-none">
                          {"Please use the following confirmation number to check your trip status: "} 
                        </p>
                        <p className="m-0 w-100 fw-bold text-center user-select-all">{tripID}</p>
                      </>
                    );
                    setModalFooterHTML(
                      <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                        OK
                      </Button>
                    );
                  
                    setShowAPILoader(false);
                    
                    handleResetAll("none");
                    paratransitBookBtnRef.current.disabled = false;

                    if(response.data.isPredictiveOutPut == false){
                      setShowDynamicModal(true);
                      setModalClass("");
                    }
                    else {
                      setShowDynamicModal(false);
                      setModalClass("");
                    }

                  }
                  else
                  {
                    let clientIDSingleTrip = parseInt(responseDict.dataDict.lstServiceHourViolation[0].clientId);
                    setModalHeaderText("Service Hours Violation");
                    setModalBodyHTML(<>{responseDict.dataDict.lstServiceHourViolation[0].message + " Do you want to proceed to updating the trip?"}</>);
                    setModalFooterHTML(
                      <>
                        <Button variant='dark' className="border-0" onClick={()=>{handleCreateUpdateParatransitTrip(isTimeValid, bookingCCDict, true, clientIDSingleTrip, false, true, false);}}>
                          Yes
                        </Button>
                        <Button variant='secondary' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                          No
                        </Button>
                      </>
                      
                    );
                    setShowDynamicModal(true);
                    setModalClass("");
                    setShowAPILoader(false);
                  }
                  
                }
                else
                {
                  setModalHeaderText("Error Occured on Updating");
                  setModalBodyHTML(responseDict.dataDict.responseJSON);
                  setModalFooterHTML(
                    <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                      OK
                    </Button>
                  );
                  setShowDynamicModal(true);
                  setModalClass("");
                  setShowAPILoader(false);
                }
              }
              else
              {
                setModalHeaderText("Error Occured on Updating");
                setModalBodyHTML(responseDict.errorMsg);
                setModalFooterHTML(
                  <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                    OK
                  </Button>
                );
                setShowDynamicModal(true);
                setModalClass("");
                setShowAPILoader(false);
              }
              setRequiredClass("");
            }
            else
            {
              //MultiTrip Update
              if(pickLatLng.current !== "" && dropLatLng.current !== "")
              {
                //Warning for stop order
                setModalHeaderText("Stop Order Alert");
                setModalBodyHTML("You have trip data on main screen which is not added to the stop order. Please press 'Add Leg' button before booking the trips." );
                setModalFooterHTML(
                  <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                    OK
                  </Button>
                );
                setShowDynamicModal(true);
                setModalClass("");
                setShowAPILoader(false);
              }
              else
              { //Addresses are verified and provided
                // let tempDict = {};
                for(let k = 0; k < verifiedAddr.length; k++)
                {
                  for(let i = 0; i < verifiedAddr[k].stops.length; i++)
                  {
                    if(verifiedAddr[k].stops[i].passLoadType !== "none" && verifiedAddr[k].stops[i].passLoadType === "unload")
                    {
                      nTotalUnloaded += verifiedAddr[k].stops[i].stopPax.total;
                    }
                  }
                
                  stopsArr[k] = [];
                  let pickupStop = {};
                  let selectedDateStopOrder = new Date(verifiedAddr[k].date+" 00:00:00");
                  if(currDateCheck < selectedDateStopOrder) { isScheduledDateCheck = true;}
                  else{isScheduledDateCheck = false}
                  if(editRowData.addressInfo.trips[k])
                  {
                    pickupStop = fillAddressDetails(
                      [],
                      verifiedAddr[k].puNotes,
                      verifiedAddr[k].pickLatLng,
                      "pickup",
                      verifiedAddr[k],
                      "update",
                      editRowData,
                      nTotalUnloaded,
                      attrStringListVF[k],
                      k,
                      verifiedAddr[k].confirmationNo,
                      isScheduledDateCheck,
                      forcePassFlagAccepted,
                      systemConfigInfoVF.IsSkipPaymentProcessOnSD
                    );
                  }
                  else
                  {
                    pickupStop = fillAddressDetails(
                      [],
                      verifiedAddr[k].puNotes,
                      verifiedAddr[k].pickLatLng,
                      "pickup",
                      verifiedAddr[k],
                      "",
                      "",
                      nTotalUnloaded,
                      attrStringListVF[k],
                      0,
                      verifiedAddr[k].confirmationNo,
                      isScheduledDateCheck,
                      forcePassFlagAccepted,
                      systemConfigInfoVF.IsSkipPaymentProcessOnSD
                    );
                  }

                  
                  let PassengerMbInfoDetails_pickup = {Primary:{}, PCA: [], Guests:[], Children: []}

                  if(verifiedAddr[k]?.passengerMobilityInfo != null){
                    if(verifiedAddr[k]?.passengerMobilityInfo.Primary != undefined && verifiedAddr[k]?.passengerMobilityInfo.Primary != ""){
                      PassengerMbInfoDetails_pickup.Primary = verifiedAddr[k]?.passengerMobilityInfo.Primary;
                    }
                    if(verifiedAddr[k]?.passengerMobilityInfo.PCA != undefined && verifiedAddr[k]?.passengerMobilityInfo.PCA != ""){
                      PassengerMbInfoDetails_pickup.PCA = verifiedAddr[k]?.passengerMobilityInfo.PCA;
                    }
                    if(verifiedAddr[k]?.passengerMobilityInfo.Guests != undefined && verifiedAddr[k]?.passengerMobilityInfo.Guests != "" && verifiedAddr[k]?.passengerMobilityInfo.Guests != []){
                      PassengerMbInfoDetails_pickup.Guests = verifiedAddr[k]?.passengerMobilityInfo.Guests;
                    }
                    if(verifiedAddr[k]?.passengerMobilityInfo.Children != undefined && verifiedAddr[k]?.passengerMobilityInfo.Children != "" && verifiedAddr[k]?.passengerMobilityInfo.Children != []){
                      PassengerMbInfoDetails_pickup.Children = verifiedAddr[k]?.passengerMobilityInfo.Children;
                    }

                    if(pickupStop?.passengerInfo != null){
                      if(pickupStop?.passengerInfo?.Primary != undefined && pickupStop?.passengerInfo?.Primary != {}){
                        pickupStop.passengerInfo.Primary = PassengerMbInfoDetails_pickup.Primary;
                      }
                      if(pickupStop?.passengerInfo?.PCA != undefined && pickupStop?.passengerInfo?.PCA != {}){
                        pickupStop.passengerInfo.PCA = PassengerMbInfoDetails_pickup.PCA;
                      }
                      if(pickupStop?.passengerInfo?.Guests != undefined && pickupStop?.passengerInfo?.Guests != []){
                        pickupStop.passengerInfo.Guests = PassengerMbInfoDetails_pickup.Guests;
                      }
                      if(pickupStop?.passengerInfo?.Children != undefined && pickupStop?.passengerInfo?.Children != []){
                        pickupStop.passengerInfo.Children = PassengerMbInfoDetails_pickup.Children;
                      }
                    }
                  }
                  

                  stopsArr[k].push(pickupStop);
                  let tempArr = createStopsArrDict(verifiedAddr[k].stops, true, verifiedAddr[k].phone, verifiedAddr[k].passengerName);
                  stopsArr[k] = [...stopsArr[k], ...tempArr];
                  
                  let dropoffStop = {};
                  if(editRowData.addressInfo.trips[k])
                  {
                    dropoffStop = fillAddressDetails(
                      [],
                      verifiedAddr[k].doNotes,
                      verifiedAddr[k].dropLatLng,
                      "dropoff",
                      verifiedAddr[k],
                      "update",
                      editRowData,
                      nTotalUnloaded,
                      attrStringListVF[k],
                      k,
                      verifiedAddr[k].confirmationNo,
                      isScheduledDateCheck,
                      forcePassFlagAccepted,
                      systemConfigInfoVF.IsSkipPaymentProcessOnSD
                    );
                  }
                  else
                  {
                    dropoffStop = fillAddressDetails(
                      [],
                      verifiedAddr[k].doNotes,
                      verifiedAddr[k].dropLatLng,
                      "dropoff",
                      verifiedAddr[k],
                      "",
                      "",
                      nTotalUnloaded,
                      attrStringListVF[k],
                      0, 
                      verifiedAddr[k].confirmationNo,
                      isScheduledDateCheck,
                      forcePassFlagAccepted,
                      systemConfigInfoVF.IsSkipPaymentProcessOnSD
                    );
                  }

                  let PassengerMbInfoDetails_dropoff = {Primary:{}, PCA: [], Guests:[], Children: []}

                  if(verifiedAddr[k]?.passengerMobilityInfo != null){
                    if(verifiedAddr[k]?.passengerMobilityInfo.Primary != undefined && verifiedAddr[k]?.passengerMobilityInfo.Primary != ""){
                      PassengerMbInfoDetails_dropoff.Primary = verifiedAddr[k]?.passengerMobilityInfo.Primary;
                    }
                    if(verifiedAddr[k]?.passengerMobilityInfo.PCA != undefined && verifiedAddr[k]?.passengerMobilityInfo.PCA != ""){
                      PassengerMbInfoDetails_dropoff.PCA = verifiedAddr[k]?.passengerMobilityInfo.PCA;
                    }
                    if(verifiedAddr[k]?.passengerMobilityInfo.Guests != undefined && verifiedAddr[k]?.passengerMobilityInfo.Guests != "" && verifiedAddr[k]?.passengerMobilityInfo.Guests != []){
                      PassengerMbInfoDetails_dropoff.Guests = verifiedAddr[k]?.passengerMobilityInfo.Guests;
                    }
                    if(verifiedAddr[k]?.passengerMobilityInfo.Children != undefined && verifiedAddr[k]?.passengerMobilityInfo.Children != "" && verifiedAddr[k]?.passengerMobilityInfo.Children != []){
                      PassengerMbInfoDetails_dropoff.Children = verifiedAddr[k]?.passengerMobilityInfo.Children;
                    }

                    if(dropoffStop?.passengerInfo != null){
                      if(dropoffStop?.passengerInfo?.Primary != undefined && dropoffStop?.passengerInfo?.Primary != {}){
                        dropoffStop.passengerInfo.Primary = PassengerMbInfoDetails_dropoff.Primary;
                      }
                      if(dropoffStop?.passengerInfo?.PCA != undefined && dropoffStop?.passengerInfo?.PCA != {}){
                        dropoffStop.passengerInfo.PCA = PassengerMbInfoDetails_dropoff.PCA;
                      }
                      if(dropoffStop?.passengerInfo?.Guests != undefined && dropoffStop?.passengerInfo?.Guests != []){
                        dropoffStop.passengerInfo.Guests = PassengerMbInfoDetails_dropoff.Guests;
                      }
                      if(dropoffStop?.passengerInfo?.Children != undefined && dropoffStop?.passengerInfo?.Children != []){
                        dropoffStop.passengerInfo.Children = PassengerMbInfoDetails_dropoff.Children;
                      }
                    }
                  }
                  
                  stopsArr[k].push(dropoffStop);
                }
                let responseArr = []; 
                let historyTripsListSaved = PersistStorage.retrieve("agentTrips", true);
                let historyTripsList = historyTripsListSaved && historyTripsListSaved.length !== 0 ? [...historyTripsListSaved] : [];

                const transformedData = stopsArr.map(stopsGroup => {
                  return {
                    Details: stopsGroup.map(stop => ({
                      ...stop,
                    }))
                  };
                });

                let tripsDetailsObj = {
                  generalInfo: {
                    "RequestAffiliateID": parseInt(affiliateID),
                    "ReturnDetailID": editRowData.generalInfo.returnDetailID,
                    "FamilyID": parseInt(FamilyIDVF)
                  },
                  riderInfo: {
                    "ID": (forcePassFlagAccepted ? iRiderID : (verifiedAddr[0].id ? verifiedAddr[0].id : -1)),
                    "PhoneNo": correctPhoneFormat,
                    "PickupPerson": trimmedName,
                    "DateOfBirth": (editRowData !== "" && editRowData.riderInfo.dateOfBirth ? editRowData.riderInfo.dateOfBirth : "01/01/1900"),
                    "RiderID": (verifiedAddr[0].clientMedID && verifiedAddr[0].clientMedID !== "" && parseInt(verifiedAddr[0].clientMedID) !== 0 ? String(verifiedAddr[0].clientMedID) : "0"),
                    "MedicalID": (verifiedAddr[0].clientMedID ? verifiedAddr[0].clientMedID : ""),
                    "ClientAddress": (verifiedAddr[0].clientAddr && verifiedAddr[0].clientAddr !== "" ? verifiedAddr[0].clientAddr : stopsArr[0][0].addressDetails.Address),
                    "ClientCity": (verifiedAddr[0].clientCity && verifiedAddr[0].clientCity !== "" ? verifiedAddr[0].clientCity : stopsArr[0][0].addressDetails.City),
                    "ClientState": (verifiedAddr[0].clientState && verifiedAddr[0].clientState !== "" ? verifiedAddr[0].clientState : stopsArr[0][0].addressDetails.State),
                    "ClientZip": (verifiedAddr[0].clientZip && verifiedAddr[0].clientZip !== "" ? verifiedAddr[0].clientZip : stopsArr[0][0].addressDetails.Zip),
                  },
                  insuranceInfo: insuranceInfoVF,
                  systemConfigInfo: systemConfigInfoVF,
                  exclusions: (scheduleJSON.mainData !== "" && scheduleJSON.mainData.Schedule.ScheduleItem.length > 0 && verifiedAddr.length <= 1 ? exclusionsListArr : []),
                  scheduleInfo: multiSchItems,  
                  addressInfo: {
                    "Trips":transformedData
                  }
                };
                let data = createParaDataDict(tripsDetailsObj);

                if(isAffiliateHasMobilityAttributes){
                  if(!isPCAApprovedFromEaas){
                    let doesAttributesHas_PCA = DoesPCAIncludedInAttributes(tripsDetailsObj.addressInfo.Trips);
                    let ContinueBooking ;
                    if(doesAttributesHas_PCA && checkValidationForPCASelections == true){
                      ContinueBooking = await showConfirmationModal("PCA is not authorized for the customer. Do you still want to book?", WARNING_PCA_NOT_ALLOWED, false);
                      setIsPCAApprovalCaputured(true);
                      if(ContinueBooking === false) 
                      {
                        setShowAPILoader(false);
                        return;
                      }
                    }
                  }
                }

                let lstTripData= [];
                let PredictiveRoutedTripForCancellation;
                if(tripStatus === "Routed" && !PredictiveRef.current.ByPassPredictiveCheck)
                {
                  lstTripData = hasTripDataChanged(data, editRowData);
                  if(lstTripData.length > 0)
                  {
                    for(let a = 0; a < lstTripData.length; a++)
                    {
                       if(lstTripData[a].InsertPredictiveRouteEntry)
                       {
                          PredictiveRoutedTripForCancellation = lstTripData[a];
                          break;
                       }
                    }
                    if(PredictiveRoutedTripForCancellation && PredictiveRoutedTripForCancellation.InsertPredictiveRouteEntry)
                    {
                      PredictiveRef.current.PredictiveData = data;
                      setModalHeaderText("Routed Trip Changed");
                      setModalBodyHTML(<>{`Trip is routed and changing PU/DO Address, Time, Passenger count, Mobility will cancel this reservation
                      and will book as a new ride with negotiation, Are you sure ?`}</>);
                        setModalFooterHTML(
                          <>
                            <Button variant='dark' className="border-0" onClick={()=>{ PredictiveRef.current.ByPassPredictiveCheck = true;  handleCreateUpdateParatransitTrip(isTimeValid, bookingCCDict, true, iRiderID, false, true, false);}}>
                              Yes
                            </Button>
                            <Button variant='secondary' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                              No
                            </Button>
                          </>
                        );
                        setShowDynamicModal(true);
                        setModalClass("");
                        setShowAPILoader(false);
                        return;
                    }
                  }
                }
                if(PredictiveRef && PredictiveRef.current.ByPassPredictiveCheck && PredictiveRef.current.PredictiveData)
                {
                  data = PredictiveRef.current.PredictiveData;
                  if(forcePassFlagAccepted)
                  {
                    for(let b = 0; b < data.addressInfo.Trips.length; b++)
                    data.addressInfo.Trips[b].Details[0].tripInfo.ForcePassServiceHoursCheck = true;
                  }
                }

                if(isAffiliateHasMobilityAttributes){
                  const { isCapacityValid = false, validationMsg = "" } = await validateMobilityCapacities(tripsDetailsObj);
                  if(isCapacityValid == false){
                    toast.error(validationMsg, {
                      autoClose: 6000,
                      position: "top-center",
                      hideProgressBar: false,
                      closeOnClick: true,
                      pauseOnHover: true
                    });
                    await sleep(2000);
                  }
                }

                let continueBooking = await validateMaxPassengerCount(tripsDetailsObj);
                if(continueBooking == false){
                  return;
                }

                let response = await APICom.fetchData("ReservationCoreURL","UpdateBookedTrip", "post", {}, data, xCancelSourceForGrid.current);
                let responseDict = CheckResponseStatus(response);
                if(!responseDict.isErrorGiven)
                {
                  if(responseDict.isDataGiven)
                  {
                    if(response.data.lstServiceHourViolation.length === 0)
                    {
                      let confirmation = response.data.iRefID+(response.data.returnLegsList && response.data.returnLegsList !== "" ? "-"+parseInt(response.data.returnLegsList) : "");
                      responseArr.push({trip:1, code:response.data.responseCode, response:response.data});
                      if(response.data.isPredictiveOutPut)
                      {
                        await handlePredictiveNegotiation(response.data.predictiveJSON, "Update");
                      }
                      ResetEnableFutureDateValiation();

                      if(response?.data?.isPredictiveOutPut){
                        setModalClass("");
                        let predictiveItems = JSON.parse(response.data.predictiveJSON);
                        let items = [];
                        if(predictiveItems){
                          predictiveItems?.forEach(item => {
                            let title = "Confirmation# " + item.Confirmation + ", Please wait while the system is checking the service availability...";
                            items.push({confirmationNumber: item.Confirmation, pickDate: 
                              moment(item.PickDate, "M/D/YYYY h:mm A").format("M/D/YYYY h:mm A"), 
                              status: "Pending",title: title, 
                              offeredTime: item.offeredTime, 
                              showLoader: true,
                              counter: 0  
                            });
                          });
                        }
                        setPredictiveHeaderTitle("Trip(s) Updated Successfully");
                        setPredictiveHeaderMsg("Please use the following confirmation number to check your trip status: " + confirmation);
                        items.sort((a, b) => new Date(a.offeredTime) - new Date(b.offeredTime));
                        setPredictiveNegotiationList(items);
                        setShowPredictiveNegotiationStatusCard(true);
                      }

                      setModalHeaderText("Trip(s) Updated Successfully");
                      setModalBodyHTML(
                        <>
                          <p className="m-0 user-select-none">
                            {"Please use the following confirmation number to check your trip status: "} 
                          </p>
                          <p className="m-0 w-100 fw-bold text-center user-select-all">{confirmation}</p>
                        </>
                      );
                      setModalFooterHTML(
                        <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                          OK
                        </Button>
                      );
                      setShowAPILoader(false);
                      if(response?.data?.isPredictiveOutPut == false){
                        setShowDynamicModal(true);
                        setModalClass("");
                      }
                      
                      if(responseArr[0].code === 200)
                      {
                        handleResetAll("none");
                      }
                      paratransitBookBtnRef.current.disabled = false;
                      for(let j = 0; j < data.addressInfo.Trips.length; j++)
                      {
                        historyTripsList.push({confirmation:(parseInt(response.data.iRefID)+j), tripData:data, type: (data.addressInfo.Trips[j].Details[0].dateInfo.IsScheduled ? "Time Call Update (StopOrder)":"On Demand Update (StopOrder)")});
                      }
                      setConfirmationNo(confirmation);
                    }
                    else
                    {
                      let clientIDMultiTrip = parseInt(response.data.lstServiceHourViolation[0].clientId);
                      setModalHeaderText("Service Hours Violation");
                      setModalBodyHTML(
                        <>
                          <p className="m-0 user-select-none">
                            {(response.data.lstServiceHourViolation.length > 1 ? "The following violations occured: " : "The following violation(s) occured: ")} 
                          </p>
                          {response.data.lstServiceHourViolation.map((item, index) => {
                            let correctverifiedAddrIndex = verifiedAddr.findIndex((itemOrig)=> parseInt(itemOrig.confirmationNo) === parseInt(item.leg));
                            correctverifiedAddrIndex = (correctverifiedAddrIndex > -1 ? (parseInt(correctverifiedAddrIndex)+1) : correctverifiedAddrIndex);
                            return(
                              <p key={index} style={{textOverflow:"ellipsis", maxWidth:"450px"}} className={`m-0 ${index === 0 ? "mt-1":""} text-wrap overflow-hidden small fw-normal user-select-none`}>
                                <b>{(correctverifiedAddrIndex !== -1 ? "Conf# "+verifiedAddr[(correctverifiedAddrIndex-1)].confirmationNo+": " : "Trip "+item.leg+": ")}</b>
                                {item.message}
                              </p>
                            );
                          })}
                          <p className="m-0 mt-1 user-select-none">
                            {"Do you want to proceed to updating the trips?"} 
                          </p>
                        </>
                      );
                      setModalFooterHTML(
                        <>
                          <Button variant='dark' className="border-0" onClick={()=>{handleCreateUpdateParatransitTrip(isTimeValid, bookingCCDict, true, clientIDMultiTrip);}}>
                            Yes
                          </Button>
                          <Button variant='secondary' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                            No
                          </Button>
                        </>
                      );
                      setShowDynamicModal(true);
                      setModalClass("");
                      setShowAPILoader(false);
                    }
                  }
                  else
                  {
                    setModalHeaderText("Error Occured on Booking");
                    setModalBodyHTML(response.data.responseJSON);
                    setModalFooterHTML(
                      <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                        OK
                      </Button>
                    );
                    setShowDynamicModal(true);
                    setModalClass("");
                    setShowAPILoader(false);
                    responseArr.push({trip:1, code:response.data.responseCode, response:response.data.responseJSON});
                  }
                }
                else
                {
                  setModalHeaderText("Error Occured on Booking");
                  setModalBodyHTML(responseDict.errorMsg);
                  setModalFooterHTML(
                    <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                      OK
                    </Button>
                  );
                  setShowDynamicModal(true);
                  setModalClass("");
                  setShowAPILoader(false);
                  responseArr.push({trip:1, code:"error", response:responseDict.errorMsg});
                }
                setHistoryTrips(historyTripsList);
                PersistStorage.save("agentTrips", historyTripsList, 9999, true);
              }
              setRequiredClass("");
            }
          }
        }
        else if(submitParatransitBtnTitle === "Book")
        {
          if(isTimeValid && validateConditions)
          {
            let stopsArr = [];
            let data = {};
            setModalHeaderText("Booking In Progress");
            setModalBodyHTML("Trip is being booked, please wait.");
            setModalFooterHTML("");
            setModalClass("d-none");
            setShowAPILoader(true);
            setShowDynamicModal(true);
            
            if(verifiedAddr.length === 0)
            {
              //Single trip Book
              let pickupStop = fillAddressDetails(
                mapPointPickupSelection.current,
                pickExtraInfo,
                pickLatLng.current,
                "pickup",
                "",
                "",
                "",
                0,
                attrStringListVF, 
                0,
                bookingCCDict.iNewRefID,
                isScheduledDateCheck,
                (forcePassFlagAccepted ? true : forcePassServiceHoursCheck),
                systemConfigInfoVF.IsSkipPaymentProcessOnSD,
                forceDuplicateReservation
              );
              stopsArr.push(pickupStop);

              let nTotalUnloaded = 0;

              if(clientStops.length > 0)
              {
                // let stopDetailsTrackerObj = await handleGetTripsDetailsWithStops();
                let tempArr = createStopsArrDict(clientStops);
                stopsArr = [...stopsArr, ...tempArr];
              }

              let dropoffStop = fillAddressDetails(
                mapPointDropoffSelection.current,
                dropExtraInfo,
                dropLatLng.current,
                "dropoff",
                "",
                "",
                "",
                0,
                attrStringListVF, 
                0, 
                bookingCCDict.iNewRefID,
                isScheduledDateCheck,
                (forcePassFlagAccepted ? true : forcePassServiceHoursCheck),
                systemConfigInfoVF.IsSkipPaymentProcessOnSD,
                forceDuplicateReservation
              );
              stopsArr.push(dropoffStop);

              const transformedData = {
                Details: stopsArr.map(item=>item)
              };

              let tripsDetailsObj = {
                generalInfo: {
                  "RequestAffiliateID": parseInt(affiliateID),
                  "ReturnDetailID": "",
                  "FamilyID": parseInt(FamilyIDVF)
                },
                riderInfo: {
                  "ID": (forcePassFlagAccepted ? iRiderID : (accountNumber ? parseInt(accountNumber) : -1)),
                  "PhoneNo": correctPhoneFormat,
                  "PickupPerson": trimmedName,
                  "DateOfBirth": "01/01/1900",
                  "RiderID":  (medID && medID !== "" && parseInt(medID) !== 0 ? String(medID) : "0"),
                  "MedicalID": (clientInfo.MedicalId? clientInfo.MedicalId : ""),
                  "ClientAddress": (clientInfo.Address ? clientInfo.Address : stopsArr[0].addressDetails.Address),
                  "ClientCity": (clientInfo.City ? clientInfo.City : stopsArr[0].addressDetails.City),
                  "ClientState": (clientInfo.State ? clientInfo.State : stopsArr[0].addressDetails.State),
                  "ClientZip": (clientInfo.Zip ? clientInfo.Zip: stopsArr[0].addressDetails.Zip),
                },
                insuranceInfo: insuranceInfoVF,
                systemConfigInfo: systemConfigInfoVF,
                exclusions: (scheduleJSON.mainData !== "" && scheduleJSON.mainData.Schedule.ScheduleItem.length > 0 && verifiedAddr.length <= 1 ? exclusionsListArr : []),
                scheduleInfo: multiSchItems,  
                addressInfo: {
                  "Trips":[transformedData],
                }
              };

           

              if(isAffiliateHasMobilityAttributes){
                if(!isPCAApprovedFromEaas){
                  let doesAttributesHas_PCA = DoesPCAIncludedInAttributes(tripsDetailsObj.addressInfo.Trips);
                  let ContinueBooking ;
                  if(doesAttributesHas_PCA && checkValidationForPCASelections == true){
                    ContinueBooking = await showConfirmationModal("PCA is not authorized for the customer. Do you still want to book?", WARNING_PCA_NOT_ALLOWED, false);
                    setIsPCAApprovalCaputured(true);
                    if(ContinueBooking === false) 
                    {
                      setShowAPILoader(false);
                      return;
                    }
                  }
                }
              }

              let data = createParaDataDict(tripsDetailsObj);
              const _lat = data.addressInfo.Trips[0].Details[0].addressDetails.Latitude;
              const _lng = data.addressInfo.Trips[0].Details[0].addressDetails.Longitude;
              const _droplat = data.addressInfo.Trips[0].Details[1].addressDetails.Latitude;
              const _droplng = data.addressInfo.Trips[0].Details[1].addressDetails.Longitude;
              if(checkOutofSrvAreVali === true){
                let IsValidArea = await IsServiceAreaValid(_lat, _lng, _droplat, _droplng);
                let userValidation = false;
                if(IsValidArea === false){
                  userValidation = await showConfirmationModal("Selected address is out of service area? Do you want to continue?", "Warning: Service Area");
                  if(userValidation === false) 
                  {
                    setShowAPILoader(false);
                    return;
                  }
                }
              }

              if(isAffiliateHasMobilityAttributes){
                const { isCapacityValid = false, validationMsg = "" } = await validateMobilityCapacities(tripsDetailsObj);
                if(isCapacityValid == false){
                  toast.error(validationMsg, {
                    autoClose: 6000,
                    position: "top-center",
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true
                  });
                  await sleep(2000);
                }
              }

              let continueBooking = await validateMaxPassengerCount(tripsDetailsObj);
              if(continueBooking == false){
                return;
              }

              if(checkValidationForDuplicateTrips == true){
                try {
                  let tripToBeValidated = {
                    vPickupPerson: trimmedName, 
                    vPickupAddress: pickupStop?.addressDetails.Address,
                    vPickupCity: pickupStop?.addressDetails.City, 
                    vPickupState: pickupStop?.addressDetails.State, 
                    vDropoffAddress: dropoffStop?.addressDetails.Address,
                    vDropoffCity: dropoffStop?.addressDetails.City, 
                    vDropoffState:dropoffStop?.addressDetails.State,
                    dtPickupDate: pickupStop.dateInfo.PickupDate,
                    iATSPID: pickupStop.tripInfo.AffiliateID
                  }
                  const validateTripsResponse = await ValidateDuplicateTrips(tripToBeValidated, xCancelSourceForGrid.current);
                 
                  if(validateTripsResponse != -1){
                    setShowAPILoader(false);
                    if(validateTripsResponse == false){
                      setShowDynamicModal(false);
                      return ;
                    }
                    else if(validateTripsResponse == true){
                      setShowDynamicModal(false);
                      setShowAPILoader(true);
                    }
                  }
                  
                } catch (error) {
                  
                }
              }

              if(fareMethodRef.current === 1)
              {
                let validateResult = await ZeroFareValidation(data);
                if(validateResult.toLowerCase() === "false".toLowerCase() && validateZeroFare.current.FareAlertMessage !== "")
                {
                  let ZeroConfirmationDialogResult = await showConfirmationModal(validateZeroFare.current.FareAlertMessage, "Fare is Zero",);
                  if(ZeroConfirmationDialogResult === false) 
                  {
                    setShowAPILoader(false);
                    return;
                  }
                }
               }

              let response = await APICom.fetchData("ReservationCoreURL","BookParatransitTrip", "post", {}, data, xCancelSourceForGrid.current);
              let responseDict = CheckResponseStatus(response);
              if(!responseDict.isErrorGiven)
              {
                if(responseDict.isDataGiven)
                {
                  if(response.data.lstServiceHourViolation.length === 0)
                  {
                    const isDuplicate = (response.data.iRefID <= 0 && response.data.responseJSON !== "");
                    if(isDuplicate)
                    {
                      
                      let parsedError = JSON.parse(response.data.responseJSON).Result;
                      let isSameInfoError = (parsedError.includes("same information"));
                      let duplicateSplitError = (isSameInfoError ? parsedError.split('before') : "");
                      let footerHandler = (isSameInfoError ? 
                        <>
                          <Button variant='dark' className="border-0" onClick={()=>{
                            handleCreateUpdateParatransitTrip(isTimeValid, bookingCCDict, forcePassFlagAccepted, iRiderID, true, false, false, false);
                          }}>
                            Yes
                          </Button>
                          <Button variant='secondary' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                            No
                          </Button>
                        </>
                        :
                        <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                          OK
                        </Button>
                      );
                      let errorMsg = (isSameInfoError ? 
                        <p className="m-0 user-select-none fw-normal">
                          {duplicateSplitError[0]} <b>{duplicateDelay+" minutes "}</b> 
                          {"before "+duplicateSplitError[1]} <br/>
                          {"Or would you like to force the reservation anyway?"}
                        </p>
                        : parsedError
                      );
                      setModalHeaderText("Error Occured on Booking");
                      setModalBodyHTML(errorMsg);
                      setModalFooterHTML(footerHandler);
                      setShowDynamicModal(true);
                      setModalClass("");
                      setShowAPILoader(false);
                    }
                    else
                    {
                      let tripID = response.data.iRefID;
                      let historyTripsListSaved = PersistStorage.retrieve("agentTrips", true);
                      let historyTripsList = historyTripsListSaved && historyTripsListSaved.length > 0 ? [...historyTripsListSaved] : [];
                      const tripType = (data.addressInfo.Trips[0].Details[0].dateInfo.IsScheduled ? "Time Call":"On Demand");
                      
                      historyTripsList.push({ confirmation: tripID, tripData: data, type: tripType });
                      if(response.data.isPredictiveOutPut)
                      {
                        await handlePredictiveNegotiation(response.data.predictiveJSON, "Insert");
                      }
                      setConfirmationNo(tripID);
                      setHistoryTrips(historyTripsList);
                      ResetEnableFutureDateValiation();

                      if(response.data.isPredictiveOutPut){
                        setModalClass("");
                        let predictiveItems = JSON.parse(response.data.predictiveJSON);
                        let items = [];
                        if(predictiveItems){
                          predictiveItems?.forEach(item => {
                            let title = "Confirmation# " + item.Confirmation + ", Please wait while the system is checking the service availability...";
                            items.push({confirmationNumber: item.Confirmation, pickDate: moment(item.PickDate, "M/D/YYYY h:mm A").format("M/D/YYYY h:mm A"), 
                            status: "Pending",title: title, offeredTime: item.offeredTime, showLoader: true, counter: 0  });
                          });
                        }
                        setPredictiveHeaderTitle("Trip Booked Successfully");
                        setPredictiveHeaderMsg("Please use the following confirmation number to check your trip status: " + tripID);
                        items.sort((a, b) => new Date(a.offeredTime) - new Date(b.offeredTime));
                        setPredictiveNegotiationList(items);
                        setShowPredictiveNegotiationStatusCard(true);
                        setShowDynamicModal(false);
                      }


                      setModalHeaderText("Trip Booked Successfully");
                      setModalBodyHTML(
                        <>
                          <p className="m-0 user-select-none">
                            {"Please use the following confirmation number to check your trip status: "} 
                          </p>
                          <p className="m-0 w-100 fw-bold text-center user-select-all">{tripID}</p>
                        </>
                      );
                      setModalFooterHTML(
                        <Button variant='dark' className="border-0" onClick={()=>{setShowDynamicModal(false); ResetEnableFutureDateValiation();}}>
                          OK
                        </Button>
                      );
                      setShowAPILoader(false);
                      if(response.data.isPredictiveOutPut === false){
                        setShowDynamicModal(true);
                        setModalClass("");
                      }
                 

                      PersistStorage.save("agentTrips", historyTripsList, 9999, true);
                      handleResetAll("none");

                      paratransitBookBtnRef.current.disabled = false;
                      setIsPCAApprovalCaputured(false);
                    }
                  }
                  else
                  {
                    //service hour violation false
                    let clientIDSingleTrip = parseInt(response.data.lstServiceHourViolation[0].clientId);
                    setModalHeaderText("Service Hours Violation");
                    setModalBodyHTML(<>{response.data.lstServiceHourViolation[0].message + " Do you want to proceed to booking the trip?"}</>);
                    setModalFooterHTML(
                      <>
                        <Button variant='dark' className="border-0" onClick={()=>{handleCreateUpdateParatransitTrip(isTimeValid, bookingCCDict, true, clientIDSingleTrip, false, false, false, false);}}>
                          Yes
                        </Button>
                        <Button variant='secondary' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                          No
                        </Button>
                      </>
                      
                    );
                    setShowDynamicModal(true);
                    setModalClass("");
                    setShowAPILoader(false);
                  }
                  
                }
                else
                {
                  let parsedError = JSON.parse(response.data.responseJSON).Result;
                  let isSameInfoError = (parsedError.includes("same information"));
                  let duplicateSplitError = (isSameInfoError ? parsedError.split('before') : "");
                  let footerHandler = (isSameInfoError ? 
                    <>
                      <Button variant='dark' className="border-0" onClick={()=>{handleCreateUpdateParatransitTrip(isTimeValid, bookingCCDict, forcePassFlagAccepted, iRiderID, true, false, false, false);}}>
                        Yes
                      </Button>
                      <Button variant='secondary' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                        No
                      </Button>
                    </>
                    :
                    <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                      OK
                    </Button>
                  );
                  let errorMsg = (isSameInfoError ? 
                    <p className="m-0 user-select-none fw-normal">
                      {duplicateSplitError[0]} <b>{duplicateDelay+" minutes "}</b> 
                      {"before "+duplicateSplitError[1]} <br />
                      {"Or would you like to force the reservation anyway?"}
                    </p>
                    : 
                    parsedError
                  );
                  setModalHeaderText("Error Occured on Booking");
                  setModalBodyHTML(errorMsg);
                  setModalFooterHTML(footerHandler);
                  setShowDynamicModal(true);
                  setModalClass("");
                  setShowAPILoader(false);
                }
              }
              else
              {
                setModalHeaderText("Error Occured on Booking");
                setModalBodyHTML(responseDict.errorMsg);
                setModalFooterHTML(
                  <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                    OK
                  </Button>
                );
                setShowDynamicModal(true);
                setModalClass("");
                setShowAPILoader(false);
                setIsPCAApprovalCaputured(false);
              }
            }
            else
            {
              //Multi-trip Book
              if(pickLatLng.current !== "" && dropLatLng.current !== "")
              {
                //Warning for stop order
                setModalHeaderText("Stop Order Alert");
                setModalBodyHTML("You have trip data on main screen which is not added to the stop order. Please press 'Add Leg' button before booking the trips." );
                setModalFooterHTML(
                  <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                    OK
                  </Button>
                );
                setShowDynamicModal(true);
                setModalClass("");
                setShowAPILoader(false);
              }
              else
              { //Addresses are verified and correct
                let nTotalUnloaded = 0;

                for(let k = 0; k < verifiedAddr.length; k++)
                {
                  for(let i = 0; i < verifiedAddr[k].stops.length; i++)
                  {
                    if(verifiedAddr[k].stops[i].passLoadType !== "none" && verifiedAddr[k].stops[i].passLoadType === "unload")
                    {
                      nTotalUnloaded += verifiedAddr[k].stops[i].stopPax.total;
                    }

                  }
                  
                  stopsArr[k] = [];
                  let selectedDateStopOrder = new Date(verifiedAddr[k].date+" 00:00:00");
                  if(currDateCheck < selectedDateStopOrder) { isScheduledDateCheck = true;}
                  else{isScheduledDateCheck = false}
                  let pickupStop = fillAddressDetails(
                    [],
                    verifiedAddr[k].puNotes,
                    verifiedAddr[k].pickLatLng,
                    "pickup",
                    verifiedAddr[k],
                    "",
                    "",
                    nTotalUnloaded,
                    attrStringListVF[k],
                    0,
                    verifiedAddr[k].confirmationNo,
                    isScheduledDateCheck,
                    forcePassFlagAccepted,
                    systemConfigInfoVF.IsSkipPaymentProcessOnSD
                    //verifiedAddr[k].passengerMobilityInfo
                  );
                  if(pickupStop != undefined && pickupStop.passengerInfo != undefined){
                    pickupStop.passengerInfo.Primary = verifiedAddr[k].passengerMobilityInfo.Primary;
                    pickupStop.passengerInfo.PCA = verifiedAddr[k].passengerMobilityInfo.PCA;
                    pickupStop.passengerInfo.Guests = verifiedAddr[k].passengerMobilityInfo.Guests;
                    pickupStop.passengerInfo.Children = verifiedAddr[k].passengerMobilityInfo.Children;
                    pickupStop.passengerInfo.IsMobility =  verifiedAddr[k].passengerMobilityInfo.IsMobility;
                  }
                  stopsArr[k].push(pickupStop);

                  let tempArr = createStopsArrDict(verifiedAddr[k].stops, true, verifiedAddr[k].phone, verifiedAddr[k].passengerName);
                    
                  stopsArr[k] = [...stopsArr[k], ...tempArr];
                  
                  let dropoffStop = fillAddressDetails(
                    [],
                    verifiedAddr[k].doNotes,
                    verifiedAddr[k].dropLatLng,
                    "dropoff",
                    verifiedAddr[k],
                    "",
                    "",
                    nTotalUnloaded,
                    attrStringListVF[k],
                    0, 
                    verifiedAddr[k].confirmationNo,
                    isScheduledDateCheck,
                    forcePassFlagAccepted,
                    systemConfigInfoVF.IsSkipPaymentProcessOnSD
                  );
                  if(pickupStop != undefined && pickupStop.passengerInfo != undefined){
                    pickupStop.passengerInfo.Primary = verifiedAddr[k].passengerMobilityInfo.Primary;
                    pickupStop.passengerInfo.PCA = verifiedAddr[k].passengerMobilityInfo.PCA;
                    pickupStop.passengerInfo.Guests = verifiedAddr[k].passengerMobilityInfo.Guests;
                    pickupStop.passengerInfo.Children = verifiedAddr[k].passengerMobilityInfo.Children;
                    pickupStop.passengerInfo.IsMobility =  verifiedAddr[k].passengerMobilityInfo.IsMobility;
                  }
                  stopsArr[k].push(dropoffStop);
                }
                let responseArr = []; 
                let namesArr = [];
                let historyTripsListSaved = PersistStorage.retrieve("agentTrips", true);
                let historyTripsList = historyTripsListSaved && historyTripsListSaved.length !== 0 ? [...historyTripsListSaved] : [];
              
                // let unloadedPassengerArr = stopsArr[0].filter(item=>item.StopType.toLowerCase() === "unload");
                const transformedData = stopsArr.map(stopsGroup => {
                  return {
                    Details: stopsGroup.map(stop => ({
                      ...stop,
                    }))
                  };
                });
                let tripsDetailsObj = {
                  generalInfo: {
                    "RequestAffiliateID": parseInt(affiliateID),
                    "ReturnDetailID": "",
                    "FamilyID": parseInt(FamilyIDVF)
                  },
                  riderInfo: {
                    "ID": (forcePassFlagAccepted ? iRiderID : (verifiedAddr[0].id ? verifiedAddr[0].id : -1)),
                    "PhoneNo": correctPhoneFormat,
                    "PickupPerson": trimmedName,
                    "DateOfBirth": "01/01/1900",
                    "RiderID":  (medID && medID !== "" && parseInt(medID) !== 0 ? String(medID) : "0"),
                    "MedicalID": (verifiedAddr[0].clientMedID ? verifiedAddr[0].clientMedID : ""),
                    "ClientAddress": (verifiedAddr[0].clientAddr && verifiedAddr[0].clientAddr !== "" ? verifiedAddr[0].clientAddr : stopsArr[0][0].addressDetails.Address),
                    "ClientCity": (verifiedAddr[0].clientCity && verifiedAddr[0].clientCity !== "" ? verifiedAddr[0].clientCity : stopsArr[0][0].addressDetails.City),
                    "ClientState": (verifiedAddr[0].clientState && verifiedAddr[0].clientState !== "" ? verifiedAddr[0].clientState : stopsArr[0][0].addressDetails.State),
                    "ClientZip": (verifiedAddr[0].clientZip && verifiedAddr[0].clientZip !== "" ? verifiedAddr[0].clientZip : stopsArr[0][0].addressDetails.Zip),
                  },
                  insuranceInfo: insuranceInfoVF,
                  systemConfigInfo: systemConfigInfoVF,
                  exclusions: (scheduleJSON.mainData !== "" && scheduleJSON.mainData.Schedule.ScheduleItem.length > 0 && verifiedAddr.length <= 1 ? exclusionsListArr : []),
                  scheduleInfo: multiSchItems,  
                  addressInfo: {
                    "Trips":transformedData,
                  }
                };
                let data = createParaDataDict(tripsDetailsObj);

                if(isAffiliateHasMobilityAttributes){
                  if(!isPCAApprovedFromEaas){
                    let doesAttributesHas_PCA = DoesPCAIncludedInAttributes(tripsDetailsObj.addressInfo.Trips);
                    let ContinueBooking ;
                    if(doesAttributesHas_PCA && checkValidationForPCASelections == true){
                      ContinueBooking = await showConfirmationModal("PCA is not authorized for the customer. Do you still want to book?", WARNING_PCA_NOT_ALLOWED, false);
                      setIsPCAApprovalCaputured(true);
                      if(ContinueBooking === false) 
                      {
                        setShowAPILoader(false);
                        return;
                      }
                    }
                  }
                }

                if(isAffiliateHasMobilityAttributes){
                  const { isCapacityValid = false, validationMsg = "" } = await validateMobilityCapacities(tripsDetailsObj);
                  if(isCapacityValid == false){
                    toast.error(validationMsg, {
                      autoClose: 6000,
                      position: "top-center",
                      hideProgressBar: false,
                      closeOnClick: true,
                      pauseOnHover: true
                    });
                    await sleep(2000);
                  }
                }

                let continueBooking = await validateMaxPassengerCount(tripsDetailsObj);
                if(continueBooking == false){
                  return;
                }

                let response = await APICom.fetchData("ReservationCoreURL","BookParatransitTrip", "post", {}, data, xCancelSourceForGrid.current);
                if(response && response.error.length === 0)
                {
                  if(response.data && response.data.responseCode === 200)
                  {
                    if(response.data.lstServiceHourViolation.length === 0)
                    {
                      if(response.data.iRefID <= 0 && response.data.responseJSON !== "")
                      {
                        setModalHeaderText("Error Occured on Booking");
                        setModalBodyHTML(response.data.responseJSON);
                        setModalFooterHTML(
                          <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                            OK
                          </Button>
                        );
                        setShowDynamicModal(true);
                        setModalClass("");
                        setShowAPILoader(false);
                        setIsPCAApprovalCaputured(false);
                      }
                      else
                      {
                        let confirmation = response.data.iRefID+(response.data.returnLegsList && response.data.returnLegsList !== "" ? "-"+parseInt(response.data.returnLegsList) : "");
                        responseArr.push({trip:1, code:response.data.responseCode, response:response.data});
                        if(response.data.isPredictiveOutPut)
                        {
                          await handlePredictiveNegotiation(response.data.predictiveJSON, "Insert");
                        }
                        ResetEnableFutureDateValiation();

                        
                        if(response?.data?.isPredictiveOutPut){
                          setModalClass("");
                          let predictiveItems = JSON.parse(response.data.predictiveJSON);
                          let items = [];
                          if(predictiveItems){
                            predictiveItems?.forEach(item => {
                              let title = "Confirmation# " + item.Confirmation + ", Please wait while the system is checking the service availability...";
                              items.push({confirmationNumber: item.Confirmation, pickDate: moment(item.PickDate, "M/D/YYYY h:mm A").format("M/D/YYYY h:mm A"), 
                              status: "Pending",title: title, offeredTime: item.offeredTime, showLoader: true, counter: 0  });
                            });
                          }

                          setPredictiveHeaderTitle("Trip Booked Successfully");
                          setPredictiveHeaderMsg("Please use the following confirmation number(s) to check your trip status: " + confirmation);
                          items.sort((a, b) => new Date(a.offeredTime) - new Date(b.offeredTime));
                          setPredictiveNegotiationList(items);
                          setShowPredictiveNegotiationStatusCard(true);
                          setShowDynamicModal(false);
                        }

                        setModalHeaderText("Trip Booked Successfully");
                        setModalBodyHTML(
                          <>
                            <p className="m-0 user-select-none">
                              {"Please use the following confirmation number(s) to check your trip status: "} 
                            </p>
                            <p className="m-0 w-100 fw-bold text-center user-select-all">{confirmation}</p>
                          </>
                        );
                        setModalFooterHTML(
                          <Button variant='dark' className="border-0" onClick={()=>{setShowDynamicModal(false); ResetEnableFutureDateValiation()}}>
                            OK
                          </Button>
                        );
                        
                        setShowAPILoader(false);
                        if(response?.data?.isPredictiveOutPut == false){
                          setShowDynamicModal(true);
                          setModalClass("");
                        }

                        if(responseArr[0].code === 200)
                        {
                          handleResetAll("none");
                        }
                        paratransitBookBtnRef.current.disabled = false;
                        for(let j = 0; j < data.addressInfo.Trips.length; j++)
                        {
                          historyTripsList.push({confirmation:confirmation, tripData:data, type: (data.addressInfo.Trips[j].Details[0].dateInfo.IsScheduled ? "Time Call (StopOrder)":"On Demand (StopOrder)")});
                        }
                        setConfirmationNo(confirmation);
                        setIsPCAApprovalCaputured(false);
                      }
                    }
                    else
                    {
                      let clientIDMultiTrip = parseInt(response.data.lstServiceHourViolation[0].clientId);
                      setModalHeaderText("Service Hours Violation");
                      setModalBodyHTML(
                        <>
                          <p className="m-0 user-select-none">
                            {(response.data.lstServiceHourViolation.length > 1 ? "The following violations occured: " : "The following violation(s) occured: ")} 
                          </p>
                          {response.data.lstServiceHourViolation.map((item, index) => {
                            let correctverifiedAddrIndex = verifiedAddr.findIndex((itemOrig)=> parseInt(itemOrig.confirmationNo) === parseInt(item.leg));
                            correctverifiedAddrIndex = (correctverifiedAddrIndex > -1 ? (parseInt(correctverifiedAddrIndex)+1) : correctverifiedAddrIndex);
                            return(
                              <p key={index} style={{textOverflow:"ellipsis", maxWidth:"450px"}} className={`m-0 ${index === 0 ? "mt-1":""} text-wrap overflow-hidden small fw-normal user-select-none`}>
                                <b>{(correctverifiedAddrIndex !== -1 ? "Conf# "+verifiedAddr[(correctverifiedAddrIndex-1)].confirmationNo+": " : "Trip "+item.leg+": ")}</b>
                                {item.message}
                              </p>
                            );
                          })}
                          <p className="m-0 mt-1 user-select-none">
                            {"Do you want to proceed to booking the trips?"} 
                          </p>
                        </>
                      );
                      setModalFooterHTML(
                        <>
                          <Button variant='dark' className="border-0" onClick={()=>{handleCreateUpdateParatransitTrip(isTimeValid, bookingCCDict, true, clientIDMultiTrip, false, false, false, false);}}>
                            Yes
                          </Button>
                          <Button variant='secondary' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                            No
                          </Button>
                        </>
                      );
                      setShowDynamicModal(true);
                      setModalClass("");
                      setShowAPILoader(false);
                    }
                  }
                  else
                  {
                    setModalHeaderText("Error Occured on Booking");
                    setModalBodyHTML(response.data.responseJSON);
                    setModalFooterHTML(
                      <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                        OK
                      </Button>
                    );
                    setShowDynamicModal(true);
                    setModalClass("");
                    setShowAPILoader(false);
                    responseArr.push({trip:1, code:response.data.responseCode, response:response.data.responseJSON});
                    setIsPCAApprovalCaputured(false);
                  }
                }
                else
                {
                  setModalHeaderText("Error Occured on Booking");
                  setModalBodyHTML(response.error);
                  setModalFooterHTML(
                    <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                      OK
                    </Button>
                  );
                  setShowDynamicModal(true);
                  setModalClass("");
                  setShowAPILoader(false);
                  responseArr.push({trip:1, code:"error", response:response.error});
                }
                namesArr.push(verifiedAddr[0].riderName);

                setHistoryTrips(historyTripsList);
                PersistStorage.save("agentTrips", historyTripsList, 9999, true);
                setIsPCAApprovalCaputured(false);
              }
            }
          }
        }
        setRequiredClass("");
      }
      else
      {
        let nameFlag = (riderName === "" || riderName.trim().length < 2);
        let phoneFlag = (!phone || phone.length < 12);
        let headerTxt = "Information Required";
        let bodyTxt = '';
        let footer = (
          <Button variant='dark' className="border-0" onClick={() => setShowDynamicModal(false)}>
            OK
          </Button>
        );
        let borderStyle = {phone: '', name: ''};

        if(nameFlag && phoneFlag)
        {
          borderStyle = {phone: "3px solid red", name: "3px solid red"};
          bodyTxt = "Please enter the complete phone number and full name in the provided fields.";
        }
        else if(nameFlag)
        {
          borderStyle = {phone: "", name: "3px solid red"};
          bodyTxt = "Please enter the full name in the highlighted field.";
        }
        else if(phoneFlag)
        {
          borderStyle = {phone: "3px solid red", name: ""};
          bodyTxt = "Please enter the complete phone number in the highlighted field.";
        }
        setModalHeaderText(headerTxt);
        setModalBodyHTML(bodyTxt);
        setModalFooterHTML(footer);
        setShowDynamicModal(true);
        setModalClass("");
        setShowAPILoader(false);
        riderNameRef.current.style.border = (borderStyle.name.length > 0 ? borderStyle.name : '');
        phoneRef.current.style.border = (borderStyle.phone.length > 0 ? borderStyle.phone : '');
        paratransitBookBtnRef.current.disabled = false;
        setRequiredClass("");
        setIsPCAApprovalCaputured(false);
      }
    }
    catch(err){
      console.log(err);
      paratransitBookBtnRef.current.disabled = false;
      setShowDynamicModal(false);
      setModalClass("");
      setRequiredClass("");
      setShowAPILoader(false);
      setIsPCAApprovalCaputured(false);
    }
  };

  
  const validateMaxPassengerCount = async (tripsDetailsObj) => {
    try {
      let maxPassengersPerTrip = [];
      let _MaxPassengerCount_ASCS = parseInt(MaxPassengerCount_ASCS.current);
      if(_MaxPassengerCount_ASCS == 0 || tripsDetailsObj == undefined){
        return true;
      }
      
      let doesTripHasMultiLeg = tripsDetailsObj?.addressInfo?.Trips?.length > 1 ? true : false;
      if(doesTripHasMultiLeg){
        tripsDetailsObj?.addressInfo?.Trips?.forEach((p,index) => {
          let passengerInfoObj = p.Details[0].passengerInfo;
          if(passengerInfoObj){
            const maxPassengers = passengerInfoObj.TotalPassengers;
            if(maxPassengers > _MaxPassengerCount_ASCS && _MaxPassengerCount_ASCS > 0){
              let i = index;
              i++;
              maxPassengersPerTrip.push({
                tripIndex: i,
                trip: p,
                message: " has " + maxPassengers + " passengers."
              });
            }
          }
        })
      }
      else{
        const maxPassengers = tripsDetailsObj?.addressInfo?.Trips[0]?.Details[0]?.passengerInfo?.TotalPassengers;
        if(maxPassengers > _MaxPassengerCount_ASCS && _MaxPassengerCount_ASCS > 0){
          maxPassengersPerTrip.push({
            tripIndex: 1,
            trip: tripsDetailsObj.addressInfo.Trips[0].Details[0],
            message: ""
          });
        }
      }

      if(maxPassengersPerTrip?.length >= 1){
        let validationMsg = "";
        if(maxPassengersPerTrip?.length > 1){
          validationMsg = (
            <div>
              <h6>Passenger limit exceeded. Maximum {_MaxPassengerCount_ASCS} passengers are allowed.</h6>
              {maxPassengersPerTrip.map(item => (
                <div key={item.tripIndex} style={{ marginBottom: "0px" }}>
                  <strong>Leg {item.tripIndex}:</strong> {item.message}
                </div>
              ))}
              <div style={{marginTop: "5px"}}>
                <h6>Do you still want to book?</h6>
              </div>
            </div>
          );
        }
        else{
          validationMsg = " Passenger limit exceeded. Maximum " + _MaxPassengerCount_ASCS + " passengers allowed. Do you still want to book?";
        }
        
        let ContinueBooking = false;
        ContinueBooking = await showConfirmationModal(validationMsg, "Warning: Max Capacity Reached", false);
        if(ContinueBooking === false) 
        {
          setShowAPILoader(false);
          return false;
        }
        else{
          return true;
        }
      }
      else{
        return true;
      }
    } catch (error) {
      console.log("An Exception has occured while validating max passenger count");
      return true;
    }
  }

  const prepareDataForAddress = (mapPointSelection, type) => {
    const isPickup = type === "pickup";
    const dataTemplate = {
      street: "",
      city: "",
      state: "",
      zip: "",
      zone: "",
      lat: "",
      long: "",
      stopname: ""
    };
  
    try {
      if (mapPointSelection?.current) {
        const current = mapPointSelection.current;
        return {
          ...dataTemplate,
          city: current.City || current[`${isPickup ? "PU" : "DO"}City`] || "",
          state: current.State || current[`${isPickup ? "PU" : "DO"}State`] || "",
          street: current.Street || current[`${isPickup ? "PU" : "DO"}Address`] || "",
          zip: current.Zip || current[`${isPickup ? "PU" : "DO"}Zip`] || "",
          lat: current.Lat || current[`${isPickup ? "PU" : "DO"}Lat`] || "",
          long: current.Long || current[`${isPickup ? "PU" : "DO"}Long`] || "",
        };
      }
    } catch (error) {console.log(error);}
    return dataTemplate;
  };

  const showConfirmationModal = (errorMsg, headerText = "Warning", yesButtonDark = true) => {
    return new Promise((resolve) => {
      const footerHandler = (
          <>
            <Button variant={yesButtonDark == true ? 'dark' : 'secondary'} className="border-0" onClick={() => {
              setShowDynamicModal(false);
              resolve(true);
            }}>
              Yes
            </Button>
            <Button variant={yesButtonDark == true ? 'secondary' : 'dark'} className="border-0" onClick={() => {
              setShowDynamicModal(false);
              resolve(false);
            }}>
              No
            </Button>
          </>
      );
  
      setModalHeaderText(headerText);
      setModalBodyHTML(errorMsg);
      setModalFooterHTML(footerHandler);
      setModalClass("");
      setShowDynamicModal(true);
    });
  };

  const handleMicrotransitCardVerification = async ( ) => {
    try{
      if(cardInfo.selectedCard !== ""){
        let formattedPhone = formatPhone(phone);
        let CheckCCParams = {
          "AffID": selectedAff,
          "amount": (clientSummary.TripFare !== 0 ? String(clientSummary.TripFare) : "0"),
          "pu_date": systemDateTimeRef.current.givenDate,
          "pu_time": (schTime !== "" ? schTime:systemDateTimeRef.current.timeWithSettingAdded),
          "is_willcall": "false",
          "cc_unique_id": String(cardInfo.uniqueID),
          "is_drop_info_available": "false",
          "phone_no": formattedPhone,
          "app_id": iAppID,
          "ref_id": "-1",
          "is_multisch": "false",
          "return_trip": null
        };
        let inloadURL = (GlobalASCSData.find(dict => dict.SubTitle === "InLoadAPI_URL") ? GlobalASCSData.find(dict => dict.SubTitle === "InLoadAPI_URL").value : "");
        let fullURL = inloadURL + "/Payment/CheckCCForPayment";
        let response = await APICom.fetchData("full", fullURL, "post", {}, CheckCCParams, xCancelSourceForGrid.current);
        if(response && response.data.Trip.TranStatus === 'success' && response.data.Trip.confNo !== ''){
          // console.log(response);
          let validationSuccessDict = {CCValid: true, TransResp: response.data.Trip};
          await handleCreateUpdateTrip('book', validationSuccessDict);
        }
        else {
          let handlerMsg = (response.data.Trip.Msg !== '' ? response.data.Trip.Msg : "The CC verification has failed, please try again or use a different card.")
          handleModal("CC Validation Failed", handlerMsg, 
            <Button variant='dark' className="border-0" onClick={()=>{setShowDynamicModal(false);}}>
              OK
            </Button>, '', bookBtnRef
          );
        }
      }
      else{
        handleModal("Information Required", "Please select a valid card for the transaction.", 
          <Button variant='dark' className="border-0" onClick={()=>{setShowDynamicModal(false);}}>
            OK
          </Button>, '', bookBtnRef
        );
      }
    }
    catch(err){console.log(err);}
  };
  function GetvExternalBrokerProviderId(){
    let _vExternalBrokerProviderID = -1;
    try {
      if(BrokerServingAffiliatesData != undefined && BrokerServingAffiliatesData?.length > 0){
        let selectedAffiliate_ExternalBroker = BrokerServingAffiliatesData?.find(p => p.AffiliateID === parseInt(selectedAff) && p.iFSID === parseInt(FSTargetID));
        if(selectedAffiliate_ExternalBroker != undefined && selectedAffiliate_ExternalBroker && selectedAffiliate_ExternalBroker?.vExternalBrokerProviderID){
          _vExternalBrokerProviderID = selectedAffiliate_ExternalBroker.vExternalBrokerProviderID;
        }
      }
    } catch (error) {
      return -1;
    }
    return _vExternalBrokerProviderID;
  }

  const handleCreateUpdateTrip = async(e, CCValidation = {CCValid: false, TransResp: {}})=>{
    try{
      let vExternalBrokerProviderID = GetvExternalBrokerProviderId();

      let title = (e.target ? e.target.textContent.toLowerCase() : e);
      if(!isTimeValidated)
      {
        await validateMinScheduleTimeDifference();
      }
      else if(isTimeValidated)
      {
        sethandlePageProgressBar("calltaker");
        if(passengerTypeCount.total === 0)
        {
          setModalHeaderText("Information Required");
          setModalBodyHTML("Total passenger count can not be 0.");
          setModalFooterHTML(
            <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
              OK
            </Button>
          );
          setModalClass("");
          setShowDynamicModal(true);
          setShowAPILoader(false);
        }
        else if(clientSummary.TripDuration === 0 || clientSummary.tripDistance === 0)
        {
          setModalHeaderText("Information Required");
          setModalBodyHTML("Total duration and distance can not be 0.");
          setModalFooterHTML(
            <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
              OK
            </Button>
          );
          setModalClass("");
          setShowDynamicModal(true);
          setShowAPILoader(false);
        }
        else
        {
          if(riderName.length >= 2 && phone && phone.length >= 12 && typeof rczVerifData === 'object')
          {
            if(title === "update")
            {
      
            }
            else if(title === "book")//create
            {
              let tempTarget = PayDropdown.find((option)=> (option?.props && parseInt(option.props.value) === parseInt(PaySelected)));
              setModalHeaderText("Booking In Progress");
              setModalBodyHTML("Trip is being booked, please wait.");
              setModalFooterHTML("");
              setModalClass("d-none");
              setShowAPILoader(true);
              setShowDynamicModal(true);
              bookBtnRef.current.disabled = true;
              const options = {timeZone: 'America/New_York', month: '2-digit', day: '2-digit', year: 'numeric' };
              const currDate = systemDateTimeRef.current.date;
              // Get the current time
              const currentTime = new Date();
              let addedMinutes = parseInt((JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "Ta01")).value)/60;
              let combinedDataAddedTime = (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "Ta01")).value;
              // Add 10 minutes to the current time
              currentTime.setMinutes(currentTime.getMinutes() + addedMinutes);

              let formattedPhone = formatPhone(phone);
      
              let userEnteredPickupAddress = prepareDataForAddress(mapPointPickupSelection, "pickup");

              if(tempTarget && tempTarget.props.children.toLowerCase().includes("card") && parseInt(PaySelected) === 2 && !CCValidation.CCValid)
              {
                await handleMicrotransitCardVerification();
                return 0;
              }

              if(!userEnteredPickupAddress.street || userEnteredPickupAddress.street === "")
              {
                userEnteredPickupAddress.street = pickupAddr;
              }
        
              if(pickupVirtualStop?.value && pickupVirtualStop?.value !== ""){
                try {
                  const virtualStopData = VirtualStopsData.find(p => p.ID === pickupVirtualStop.value);
                  if(virtualStopData){
                    userEnteredPickupAddress.city = userEnteredPickupAddress.city || virtualStopData.City || "";
                    userEnteredPickupAddress.state = userEnteredPickupAddress.state || virtualStopData.State || "";
                    userEnteredPickupAddress.zip = userEnteredPickupAddress.zip || virtualStopData.Zipcode || "";
                  }
                } catch (error) { }
              }

              let userEnteredDropoffAddress = prepareDataForAddress(mapPointDropoffSelection, "dropoff");

              if(!userEnteredDropoffAddress.street || userEnteredDropoffAddress.street === "")
              {
                userEnteredDropoffAddress.street = dropAddr;
              }

              if(dropAddrVirtualStop?.value && dropAddrVirtualStop?.value !== ""){
                try {
                  const virtualStopData = VirtualStopsData.find(p => p.ID === dropAddrVirtualStop.value);
                  if(virtualStopData){
                    userEnteredDropoffAddress.city = userEnteredDropoffAddress.city || virtualStopData.City || "";
                    userEnteredDropoffAddress.state = userEnteredDropoffAddress.state || virtualStopData.State || "";
                    userEnteredDropoffAddress.zip = userEnteredDropoffAddress.zip || virtualStopData.Zipcode || "";
                  }
                } catch (error) { }
              }

              let data = {
                "id": "-1",
                "Ta01": (combinedDataAddedTime? combinedDataAddedTime:0),
                "TravelMinutes": parseFloat(walkDistance.PUDuration),
                "referenceId": "",
                "linkedRideIds": [],
                "transportationProviderId": vExternalBrokerProviderID,
                "scheduledDate": schTime !== "" ? currDate + " " + schTime:systemDateTimeRef.current.givenDate + " " + systemDateTimeRef.current.timeWithSettingAdded,
                "appointmentTime": "01/01/1900 00:00:00",
                "isPredictive" : "1",
                "bCheckServiceHours": "true",
                "iCreatedByAppID": iAppID,
                "iCreatedUserId": String(loginData.iUserID),
                "additionalPassengers": {
                  "attendants": 0,
                  "escorts": 0
                },
                "willCall": false,
                "billableAmount": (typeof fareDataArr === 'object' ? parseFloat(fareDataArr.billableAmount) : 0),
                "billableMiles": parseFloat(clientSummary.tripDistance),
                "assistanceNeeds": [],
                "billingRequired": true,
                "levelOfService": "A",
                "levelOfServiceDescription": "Ambulatory",
                "levelOfServiceGroup": "Ambulatory",
                "unableToSign": false,
                "signatureRequired": true,
                "additionalProperties": {
                  "condition": null,
                  "carseats": 0,
                  "copay": parseFloat(clientSummary.TripFare),
                  "member_number": null,
                  "ordering_medical_provider_name": null,
                  "ordering_medical_provider_npi": null,
                  "prior_auth_num": null
                },
                "rider": {
                  "id": searchedClientID.current,
                  "firstName": riderName === "" ? loginData.vDisplayName.split(", ")[1] : riderName.trim().split(" ")[0],
                  "middleName": "",
                  "lastName": riderName === "" ? loginData.vDisplayName.split(", ")[0] : riderName.trim().split(" ")[1],
                  "dateOfBirth": "1974-09-19",
                  "gender": "M",
                  "weight": 0,
                  "phone": formattedPhone,
                },
                "pickup": {
                  "address": {
                    "addressLine1": (rczVerifData.pudoNearbyVS.pvs.street.includes(",")?rczVerifData.pudoNearbyVS.pvs.street.split(", ")[0]:rczVerifData.pudoNearbyVS.pvs.street),
                    "addressLine2": "",
                    "city": rczVerifData.pudoNearbyVS.pvs.city,
                    "county": "",
                    "state": rczVerifData.pudoNearbyVS.pvs.state,
                    "zipCode": rczVerifData.pudoNearbyVS.pvs.zip,
                    "latitude": (rczVerifData.pudoNearbyVS.pvs?.latitude ? parseFloat(rczVerifData.pudoNearbyVS.pvs.latitude) : parseFloat(pickLatLng.current.split(",")[0])),
                    "longitude": (rczVerifData.pudoNearbyVS.pvs?.longitude ? parseFloat(rczVerifData.pudoNearbyVS.pvs.longitude) : parseFloat(pickLatLng.current.split(",")[1])),
                    "stopname":pickupVirtualStop.name,
                    "reqpustreet": userEnteredPickupAddress?.street ? userEnteredPickupAddress.street : "",
                    "reqpucity": userEnteredPickupAddress?.city ? userEnteredPickupAddress.city : "",
                    "reqpustate": userEnteredPickupAddress?.state ? userEnteredPickupAddress.state : "",
                    "reqpuzip": userEnteredPickupAddress?.zip ? userEnteredPickupAddress.zip : "",
                    "reqpuzone": zones,
                    "reqpulat": userEnteredPickupAddress?.lat ? userEnteredPickupAddress.lat : "",
                    "reqpulong": userEnteredPickupAddress?.long ? userEnteredPickupAddress.long : "",
                    "reqpustopname": pickupVirtualStop.name,
                  },
                  "scheduledTime": schTime !== "" ? currDate+" "+schTime:"01/01/1900 00:00:00",
                  "name": "",
                  "comments": pickExtraInfo,
                  "phone": {
                    "number": formattedPhone,
                    "ext": 1
                  }
                },
                "dropoff": {
                  "address": {
                    "addressLine1": (rczVerifData.pudoNearbyVS.dvs.street.includes(",")?rczVerifData.pudoNearbyVS.dvs.street.split(", ")[0]:rczVerifData.pudoNearbyVS.dvs.street),
                    "addressLine2": "",
                    "city": rczVerifData.pudoNearbyVS.dvs.city,
                    "county": "",
                    "state": rczVerifData.pudoNearbyVS.dvs.state,
                    "zipCode": rczVerifData.pudoNearbyVS.dvs.zip,
                    "latitude": (rczVerifData.pudoNearbyVS.dvs?.latitude ? parseFloat(rczVerifData.pudoNearbyVS.dvs.latitude) : parseFloat(dropLatLng.current.split(",")[0])),
                    "longitude": (rczVerifData.pudoNearbyVS.dvs?.longitude ? parseFloat(rczVerifData.pudoNearbyVS.dvs.longitude) : parseFloat(dropLatLng.current.split(",")[1])),
                    "stopname":dropAddrVirtualStop.name,
                    "reqdostreet": userEnteredDropoffAddress?.street ? userEnteredDropoffAddress.street : "",
                    "reqdocity": userEnteredDropoffAddress?.city ? userEnteredDropoffAddress.city : "",
                    "reqdostate": userEnteredDropoffAddress?.state ? userEnteredDropoffAddress.state : "",
                    "reqdozip": userEnteredDropoffAddress?.zip ? userEnteredDropoffAddress.zip : "",
                    "reqdozone": zones,
                    "reqdolat": userEnteredDropoffAddress?.lat ? userEnteredDropoffAddress.lat : "",
                    "reqdolong": userEnteredDropoffAddress?.long ? userEnteredDropoffAddress.long : "",
                    "reqdostopname": dropAddrVirtualStop.name,
                  },
                  "scheduledTime": schTime !== "" ? currDate+" "+schTime:"01/01/1900 00:00:00",
                  "name": "",
                  "comments": dropExtraInfo,
                  "phone": {
                    "number": formattedPhone,
                    "ext": 1
                  }
                },
                "webhookURL": "https://api.circulation.com/transit/webhook/atms/",
                "nTotalPassengers":parseInt(passengerTypeCount.total),
                "nTotalWheelChairs":parseInt(passengerTypeCount.totalWC),
                "iServiceAnimalsCount":parseInt(passengerTypeCount.totalSA),
                "FareEstimateCalculationMethod": fareMethodRef.current,
                "FromZip": fareZonesRef.current.pickFareZone,
                "ToZip": fareZonesRef.current.dropFareZone,
                'EstimatedDistance': parseFloat(clientSummary.tripDistance),
                'EstimatedTime': parseFloat(clientSummary.TripDuration),
                'EstimatedCost': (typeof fareDataArr === 'object' ? parseFloat(fareDataArr.totalCost) : 0),
                'confNo': (CCValidation.TransResp.confNo ? CCValidation.TransResp.confNo : ''),
                'iCCUniqueID': (cardInfo.uniqueID ? parseInt(cardInfo.uniqueID) : -1),
                'iPaymentTypeID': (parseInt(PaySelected))
              };
              let response = await APICom.fetchData("ReservationCoreURL","CreateRide", "post", {}, data, xCancelSourceForGrid.current);

              if(response && response.error.length === 0)
              {
                if(response.data.responseCode !== 200)
                {
                  setModalHeaderText("Trip Reservation Failed");
                  setModalBodyHTML(response.data.responseMessage);
                  setModalFooterHTML(
                    <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                      OK
                    </Button>
                  );
                  setShowDynamicModal(true);
                  setModalClass("");
                  setShowAPILoader(false);
                }
                else
                {
                  //Trip Booked with response JSON
                  let tripID = response.data.id;
                  ResetEnableFutureDateValiation();
                  setModalHeaderText("Trip Booked Successfully");
                  setModalBodyHTML(
                    <>
                      <p className="m-0 user-select-none">
                        {"Please use the following confirmation number to check your trip status: "} 
                      </p>
                      <p className="m-0 w-100 fw-bold text-center user-select-all">{tripID}</p>
                    </>
                  );
                  setModalFooterHTML(
                    <Button variant='dark' className="border-0" onClick={()=>{setShowDynamicModal(false); ResetEnableFutureDateValiation()}}>
                      OK
                    </Button>
                  );
                  setShowDynamicModal(true);
                  setModalClass("");
                  setShowAPILoader(false);
                  handleResetAll("none");
                  setConfirmationNo(tripID);
                  let oldDataArr = PersistStorage.retrieve('confirmationsData', false);
                  let updatedArr = oldDataArr ? [...oldDataArr, {Confirmation: tripID, time: null, dropTime:null, name:riderName, creationTime: new Date(), msg:"", tripID: ""}] 
                    : [{Confirmation: tripID, time: null, dropTime:null, name:riderName, creationTime: new Date(), msg:"", tripID: ""}];
                  PersistStorage.save('confirmationsData', updatedArr, 999, false);
                  // setSubmitBtnTitle("Update");
                  setTripStatus("Routed");
                  setSchPUTime(null);
                  let MTMSNegotiationHTML = [tripID].map(function(item, index){
                    return(
                      <tr key={index} className="text-center border-bottom border-dark">
                        <td className="border border-dark user-select-none small">{item}</td>
                        <td className="border border-dark user-select-none small overflow-hidden text-nowrap" title={""} style={{textOverflow:"ellipsis"}}>
                          {""}
                        </td>
                        <td className="border border-dark user-select-none small overflow-hidden text-nowrap" title={""} style={{textOverflow:"ellipsis"}}>
                          {""}
                        </td>
                        <td className="border border-dark user-select-none text-nowrap small overflow-hidden" 
                        style={{textOverflow:"ellipsis"}} title={riderName}
                        >{riderName}</td>
                        <td className="border border-dark user-select-none text-nowrap small overflow-hidden" title={""} 
                          style={{textOverflow:"ellipsis"}}
                        >
                          {""}
                        </td>
                        <td className="border-dark border-bottom user-select-none text-center justify-content-center">
                          <div className="d-flex">
                            <Button variant="secondary" className="d-inline-block p-1 py-0" disabled={true} title={"Remove trip from view"} 
                              onClick={handleRemoveRecord} tabIndex={-1} name={item}>
                              X
                            </Button>
                            <Button variant="danger" className="mx-1 d-inline-block p-1 py-0" disabled={true} title={"Reject scheduled trip"} 
                              onClick={handleRejectTrip} tabIndex={-1} name={item}>
                              Reject
                            </Button>
                          </div>
                        </td>
                      </tr>
                    )
                  });
                  setMTSMTableHTML(prevState=>(
                    <>
                      {MTMSNegotiationHTML}
                      {prevState? prevState:""}
                    </>
                  ));
                }
              }
              else
              {
                setModalHeaderText("Trip Reservation Failed");
                setModalBodyHTML(response.error);
                setModalFooterHTML(
                  <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                    OK
                  </Button>
                );
                setShowDynamicModal(true);
                setModalClass("");
                setShowAPILoader(false);
                bookBtnRef.current.disabled = false;
              }
            }
          }
          else
          {
            if((riderName === "" || riderName.length < 2) && (!phone || phone.length < 12))
            {
              setModalHeaderText("Information Required");
              setModalBodyHTML("Please enter the complete phone number and full name in the provided fields.");
              setModalFooterHTML(
                <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                  OK
                </Button>
              );
              setShowDynamicModal(true);
              setModalClass("");
              setShowAPILoader(false);
              riderNameRef.current.style.border = "3px solid red";
              phoneRef.current.style.border = "3px solid red";
            }
            else if(riderName === "" || riderName.length < 2)
            {
              riderNameRef.current.style.border = "3px solid red";
              setModalHeaderText("Information Required");
              setModalBodyHTML("Please enter the full name in the highlighted field.");
              setModalFooterHTML(
                <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                  OK
                </Button>
              );
              setModalClass("");
              setShowDynamicModal(true);
              setShowAPILoader(false);
            }
            else if(!phone || phone.length < 12)
            {
              phoneRef.current.style.border = "3px solid red";
              setModalHeaderText("Information Required");
              setModalBodyHTML("Please enter the complete phone number in the highlighted field.");
              setModalFooterHTML(
                <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                  OK
                </Button>
              );
              setModalClass("");
              setShowDynamicModal(true);
              setShowAPILoader(false);
            }
            else if(rczVerifData.length === 0)
            {
              setModalHeaderText("Information Required");
              setModalBodyHTML("Please enter and verify the addresses in provided fields to continue.");
              setModalFooterHTML(
                <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                  OK
                </Button>
              );
              setModalClass("");
              setShowDynamicModal(true);
              setShowAPILoader(false);
            }
          }
        }
      }
    }
    catch(err)
    {
      console.log(err);
    }
  };

  const IsServiceAreaValid = async (pickupLat, pickuLng, dropOffLat, dropOffLng) => {
    try {
      let validServiceArea = false;
      let geoPointCoordinates = 
      {
        "pickupPoints": {
          "latitude": pickupLat,
          "longitude": pickuLng
        },
        "dropoffPoints": {
          "latitude": dropOffLat,
          "longitude": dropOffLng
        },
        "defaultPoints": {
          "latitude": defaultZoneLatLngsFromASCS.Latitude,
          "longitude": defaultZoneLatLngsFromASCS.Longitude
        },
        "maxMiles": maxAgentPromptMilesASCS,
        "isMilesWithinRange": false
      }
      let response = await APICom.fetchData("ReservationCoreURL","ServiceAreaBoundsValidation", "post", {}, geoPointCoordinates, xCancelSourceForGrid.current);
      if(response && response.error.length === 0){

        if(response.data?.responseCode === 200){
          if(response.data?.isMilesWithinRange === true){
            validServiceArea = true;
          }
          else{
            validServiceArea = false;
          }
        }
        return validServiceArea;
      }
      else{
        return validServiceArea;
      }
    } catch (error) {
      return false;
    }
  }

  const handlePassCountTotal = (e, type = "", count = 0)=>{
    try{
      const regex = /^[0-9\b]+$/;
      let wcCount = 0;
      let totalCount = 0;
      if(type === "" && e.target.value.length > 0)
      {
        let tempVal = e.target.value;
        if(tempVal[0] === "0" && tempVal.length > 1)
        {
          e.target.value = tempVal[1];
        }
      }

      let _totalWCCount = passengerTypeCount.totalWC;
      if(transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2){
          _totalWCCount = 0;
      }

      if(type === "" && e.target.name === "ambPass")
      {
        if(!regex.test(e.target.value)){e.target.value = 0;}
        else if(parseInt(e.target.value) > 30){e.target.value = 30;}

        if(e.target.value == 0){
          e.target.value = 1;
        }

     

        wcCount = parseInt(passengerTypeCount.totalWC);
        totalCount = parseInt(passengerTypeCount.totalWC) + parseInt(e.target.value);
        setPassengerTypeCount({...passengerTypeCount,ambPass:parseInt(e.target.value), 
          total:(parseInt(e.target.value) + parseInt(_totalWCCount) + parseInt(passengerTypeCount.totalChildren))});



          
          const newPassengerCount = parseInt(e.target.value);
          const oldPassengerCount = mobilityPassengers.passenger || 0;
          
          if (newPassengerCount < oldPassengerCount) {
            const updatedData = { ...mobilityDbData };
          
            // Clear Primary if less than 1 passenger
            if (newPassengerCount < 1) {
              updatedData.Primary = { Name: "Primary", Attributes: "" };
            }
          
            // Clear PCA if less than 2 passengers
            if (newPassengerCount < 2) {
              updatedData.PCA = { Name: "PCA", Attributes: "" };
            }
          
            // Limit Guests based on (passenger - 2)
            const allowedGuests = Math.max(0, newPassengerCount - 2);
            if (Array.isArray(mobilityDbData.Guests)) {
              updatedData.Guests = mobilityDbData.Guests.slice(0, allowedGuests);
            }
          
          setMobilityDbData(updatedData);
          
        }
        if(isAffiliateHasMobilityAttributes && newPassengerCount > 0){
          setTimeout(() => {
            setShowMobilityAttributes(true);
          }, 2000);
        }
        setMobilityPassengers({...mobilityPassengers, passenger:parseInt(e.target.value)});
      }
      else if(type === "" && e.target.name === "totalWC")
      {
        if(!regex.test(e.target.value)){e.target.value = 0;}
        else if(parseInt(e.target.value) > 10){e.target.value = 0;}
        wcCount = parseInt(e.target.value);
        totalCount = parseInt(e.target.value) + parseInt(passengerTypeCount.ambPass);
        setPassengerTypeCount({...passengerTypeCount,totalWC:parseInt(e.target.value), 
          total:(parseInt(e.target.value) + parseInt(passengerTypeCount.ambPass))});
      }
      else if(type === "" && e.target.name === "totalSA")
      {
        if(!regex.test(e.target.value)){e.target.value = 0;}
        else if(parseInt(e.target.value) > 5){e.target.value = 5;}
        wcCount = parseInt(passengerTypeCount.totalWC);
        totalCount = parseInt(passengerTypeCount.totalWC) + parseInt(passengerTypeCount.ambPass);

        if(isAffiliateHasMobilityAttributes == true){
          setPassengerTypeCount({...passengerTypeCount,totalSA:parseInt(e.target.value), 
            total:(parseInt(passengerTypeCount.ambPass) + parseInt(passengerTypeCount.totalChildren))});
        }
        else{
          setPassengerTypeCount({...passengerTypeCount,totalSA:parseInt(e.target.value), 
            total:(parseInt(passengerTypeCount.ambPass)+ parseInt(passengerTypeCount.totalWC) + parseInt(passengerTypeCount.totalChildren))});
        }

        
      }
      else if (type === "" && e.target.name === "childCount"){
        if(!regex.test(e.target.value)){e.target.value = 0;}
        else if(parseInt(e.target.value) > 30){e.target.value = 30;}
        wcCount = parseInt(passengerTypeCount.totalWC);
        totalCount = parseInt(passengerTypeCount.totalWC) + parseInt(passengerTypeCount.ambPass);
        setPassengerTypeCount({...passengerTypeCount, totalChildren: parseInt(e.target.value),
          total:(parseInt(passengerTypeCount.ambPass) + parseInt(_totalWCCount) + parseInt(e.target.value))});

        const newChildCount = parseInt(e.target.value);

        const oldChildCount = mobilityPassengers.children || 0;
        if (newChildCount < oldChildCount) {
        
          const updatedData = { ...mobilityDbData };
          const updateddataMobilitySaved = { ...mobilitySavedData };
        
          if (newChildCount === 0) {
            updatedData.Children = [];
            updateddataMobilitySaved.Children = [];
          }
      
          if (Array.isArray(mobilityDbData.Children) && newChildCount >= 0) {
          }
          updatedData.Children = mobilityDbData.Children.slice(0, newChildCount);
          setMobilityDbData(updatedData);

          //Object.values(mobilitySavedData).filter(item => item.type === 'children');

          if(mobilitySavedData?.Children != undefined){
            updateddataMobilitySaved.Children = mobilitySavedData.Children.slice(0, newChildCount);
            setMobilitySavedData(updateddataMobilitySaved);
          }
          else{
            const childEntries = Object.values(mobilitySavedData).filter(item => item.type === "children");
            if(childEntries){
              const keptChildren = childEntries.slice(0, newChildCount);
              const updated = Object.fromEntries(
                Object.entries(mobilitySavedData).filter(
                  ([, value]) => value.type !== "children"
                )
              );
              keptChildren.forEach(child => {
                updated[child.key] = child;
              });

              setMobilitySavedData(updated);
            }
          }

          
        }
        setMobilityPassengers({...mobilityPassengers, children:parseInt(e.target.value)});
        if(isAffiliateHasMobilityAttributes && newChildCount >= 0){
          setTimeout(() => {
            setShowMobilityAttributes(true);
          }, 500);
        }
      }

      if(type !== "")
      {
        wcCount = count;
        totalCount = parseInt(count);
        setPassengerTypeCount({...passengerTypeCount, ambPass:0, totalWC:parseInt(count), 
          total:(parseInt(count))});
          setMobilityPassengers({...mobilityPassengers,  passenger:0, children: 0});
      }

      // if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2))
      // {
        if(pickLatLng.current !== "" && (FSSelected && FSSelected !=="") && (copayFSSelected && copayFSSelected !== ""))
        {
          handleFareCalculation(clientSummary.tripDistance, clientSummary.TripDuration, FSSelected, copayFSSelected, wcCount, totalCount, COSSelected, selectedAff, pickLatLng.current, copayAmount);
        }
      // }
      
    }
    catch(err){console.log(err);}
  };

  const handlePassCountTotalStop = (e)=>{
    try{
      const regex = /^[0-9\b]+$/;
      if(e.target.value.length > 0)
      {
        let tempVal = e.target.value;
        if(tempVal[0] === "0" && tempVal.length > 1)
        {
          e.target.value = tempVal[1];
        }
      }
      if(e.target.name === "ambPass")
      {
        if(!regex.test(e.target.value)){e.target.value = 0;}
        else if(parseInt(e.target.value) > 30){e.target.value = 30;}
        setPassengerTypeCountStop({...passengerTypeCountStop,ambPass:parseInt(e.target.value), 
          total:(parseInt(e.target.value) + parseInt(passengerTypeCountStop.totalWC))});
      }
      else if(e.target.name === "totalWC")
      {
        if(!regex.test(e.target.value)){e.target.value = 0;}
        else if(parseInt(e.target.value) > 10){e.target.value = 10;}
        setPassengerTypeCountStop({...passengerTypeCountStop,totalWC:parseInt(e.target.value), 
          total:(parseInt(e.target.value) + parseInt(passengerTypeCountStop.ambPass))});
      }
      else if(e.target.name === "totalSA")
      {
        if(!regex.test(e.target.value)){e.target.value = 0;}
        else if(parseInt(e.target.value) > 5){e.target.value = 5;}
        setPassengerTypeCountStop({...passengerTypeCountStop,totalSA:parseInt(e.target.value), 
          total:(parseInt(passengerTypeCountStop.ambPass)+ parseInt(passengerTypeCountStop.totalWC))});
      }
      else if(e.target.name === "waitTime")
      {
        if(!regex.test(e.target.value)){e.target.value = 0;}
        else if(parseInt(e.target.value) > 60){e.target.value = 60;}
        setStopWaitTimeInput(parseInt(e.target.value));
      }
      
    }
    catch(err){console.log(err);}
  };

  const handleVehTypeChangeModal = (option, type = '', vehicle = '', driver = '', gender = '')=>{
    try{
      // console.log(option);
      if(type === 'wc')
      {
        handlePassCountTotal(option, "totalWC", 1);
      }
      setShowDynamicModal(false);
      let vehData = (DispatchVehicleData[parseInt(selectedAff)] && DispatchVehicleData[parseInt(selectedAff)] !== "" ? DispatchVehicleData[parseInt(selectedAff)] : []);
      let vehNum = (vehData.length !== 0 ? handleDuplicates(JSON.parse(vehData), "VehicleNumber") : []);
      let driverNum = DispatchDriverData[parseInt(selectedAff)] ? JSON.parse(DispatchDriverData[parseInt(selectedAff)]) : [];
      // console.log(driverNum);
      const sortedVehNum = vehNum.sort((a, b) => a.VehicleNumber - b.VehicleNumber);
      const sortedDriverNum = driverNum.sort((a, b) => a.DriverNumber - b.DriverNumber);
      // console.log(sortedVehNum);
      let newVehNumberOptions = "";
      let newDriverNumberOptions = "";
      if(option !== "VT")
      {
        newVehNumberOptions = sortedVehNum.filter(item => parseInt(item.iVTypeID) === parseInt(option)).map((item, index)=>{
          return(
            <option key={index} value={item.VehicleID+"_"+item.VehicleNumber}>{item.VehicleNumber}</option>
          ); 
        });
        newVehNumberOptions.unshift(<option key={444} value={"VN"}>{"None"}</option>);
        
        newDriverNumberOptions = sortedDriverNum.filter(item => parseInt(item.iVTypeID) === parseInt(option) || String(item.iVTypeID) === "-1").map((item, index)=>{
          
          return(
            <option key={index} value={item.DriverID+"_"+item.DriverNumber}>{item.DriverNumber}</option>
          ); 
          
        });
        newDriverNumberOptions.unshift(<option key={555} value={"DN"}>{"None"}</option>);
      }
      else
      {
        if(vehicle === "")
        {
          newVehNumberOptions = sortedVehNum.map((item, index)=>{
            return(
              <option key={index} value={item.VehicleID+"_"+item.VehicleNumber}>{item.VehicleNumber}</option>
            ); 
          });
          newVehNumberOptions.unshift(<option key={444} value={"VN"}>{"None"}</option>);
          
          newDriverNumberOptions = sortedDriverNum.map((item, index)=>{
            if(String(item.iVTypeID) === "-1")
            {
              return(
                <option key={index} value={item.DriverID+"_"+item.DriverNumber}>{item.DriverNumber}</option>
              ); 
            }
          });
          newDriverNumberOptions.unshift(<option key={555} value={"DN"}>{"None"}</option>);
          
        }
        
      }
      if(newVehNumberOptions && newVehNumberOptions !== "")
      {
        setVehNumberOptionsHTML(newVehNumberOptions);
        setDriverNumberOptionsHTML(newDriverNumberOptions);
      }
      setSelectedDriverNum((driver === '' ? "DN" : driver));
      setSelectedVehNum((vehicle === '' ? "VN" : vehicle));
      setSelectedGender((gender === '' ? "Gender" : gender));
    }
    catch(err){console.log(err);}
  };

  const handleVehTypeChanged = (e, selectedVehTypeVal = "0", maxWheelChairs = "0", vehicleData = "", driverData = "", gender = "")=>{
    try{
      const input = (typeof e === "string" ? (String(selectedVehTypeVal) === "-1" ? "VT" : selectedVehTypeVal) : e.target.value);
      const selectedIndex = (typeof e === "string" ? "" : e.target.selectedIndex);
      const selectedOption = (typeof e === "string" ? "" : e.target.options[selectedIndex]);
      const virtualData = (typeof selectedOption === "string" ? maxWheelChairs : selectedOption.getAttribute('data-virtual'));

      if(String(selectedVehTypeVal) !== "-1")
      {
        setSelectedVehType(input);
      }

      if(selectedAff !== "")
      {
        if(virtualData && parseInt(virtualData) !== 0 && passengerTypeCount.totalWC === 0)
        {
          setModalHeaderText("Vehicle Type Alert");
          setModalBodyHTML("Book as a wheelchair trip?");
          setModalFooterHTML(
            <>
              <Button variant='dark' className="border-0" onClick={(e)=>{handleVehTypeChangeModal(input, 'wc', vehicleData, driverData, gender);}}>
                Yes
              </Button>
              <Button variant='secondary' className="border-0" onClick={(e)=>{handleVehTypeChangeModal(input, '', vehicleData, driverData, gender);}}>
                No
              </Button>
            </>
          );
          setShowDynamicModal(true);
        }
        else
        {
          handleVehTypeChangeModal(input, '', vehicleData, driverData, gender);
        }
      }
    }
    catch(err){console.log(err);}
  };

  const handleVSChange = (e)=>{
    try{
      if(bookBtnRef.current)
      {
        bookBtnRef.current.disabled = true;
      }
      const selectedIndex = e.target.selectedIndex;
      const selectedOption = e.target.options[selectedIndex];
      const virtualData = selectedOption.getAttribute('data-virtual');
      const name = selectedOption.getAttribute('data-name');
      const nm = selectedOption.textContent;
      const fetchVSFareZone = async (latLng) => {
        if(e.target.title.toLowerCase().includes("pickup") && fareMethodRef.current === 1){
          await getFareZone(FSSelected, selectedAff, COSSelected, latLng, "pick");
        }
        else if(e.target.title.toLowerCase().includes("drop off") && fareMethodRef.current === 1){
          await getFareZone(FSSelected, selectedAff, COSSelected, latLng, "drop");
        }
      };
      fetchVSFareZone(virtualData);
      if(e.target.title.toLowerCase().includes("pickup"))
      {
        mapPointPickupSelection.current = [];
        if(e.target.value === "PU VS")
        {
          setPickupVirtualStop({...pickupVirtualStop, value:"PU VS", name:""});
          setWalkDistance(prevWalkDistance=>({...prevWalkDistance, PUWalk:0, PUDuration:0}));
          if(pickLatLng.current === ""){
            setPickupAddr("");
          }
        }
        else
        {
          vsChangeRef.current.type = vsChangeRef.current.type.length === 0 ? "PU ": (vsChangeRef.current.type.includes("PU")
            ? vsChangeRef.current.type:vsChangeRef.current.type+"PU ");
          setPickupVirtualStop({...pickupVirtualStop, value:e.target.value, name:nm});
          if(pickLatLng.current === ""){
            setPickupAddr(name);
            pickLatLng.current = virtualData;
            if(!vsSelectedRef.current.includes("PU")){vsSelectedRef.current.push("PU")};
            let stopMarkersArr = [{lat:parseFloat(pickLatLng.current.split(",")[0]),
              lng: parseFloat(pickLatLng.current.split(",")[1]), Type:"PU", 
              name:(riderName === "" ? "N/A" : riderName.trim()), address: name
            },];
            let filteredMapMarkers = mapData.filter((item)=>{
              if(item.Type === "Stop")
              {
                stopMarkersArr.push(item);
              }
              return item.Type === "DO";
            });
            filteredMapMarkers.unshift(...stopMarkersArr);
            setMapData(filteredMapMarkers);
            setInputSuggestionListPU("");
            if(dropLatLng.current !== "")
            {
              puVSCallValidation.current = true;
              setIsSchTimeFieldDisabled(false);
            }
            setWalkDistance(prevWalkDistance=>({...prevWalkDistance, PUWalk:0, PUDuration:0}));
          }
          else //if address entered is valid and VS changed
          {
            setPickupAddr(name);
            pickLatLng.current = virtualData;
            let stopMarkersArr = [{lat:parseFloat(pickLatLng.current.split(",")[0]),
              lng: parseFloat(pickLatLng.current.split(",")[1]), Type:"PU", 
              name:(riderName === "" ? "N/A" : riderName.trim()), address: name
            }];
            let filteredMapMarkers = mapData.filter((item)=>{
              if(item.Type === "Stop")
              {
                stopMarkersArr.push(item);
              }
              return item.Type === "DO";
            });
            filteredMapMarkers.unshift(...stopMarkersArr);
            setMapData(filteredMapMarkers);
            if(dropLatLng.current !== "")
            {
              puVSCallValidation.current = true;
              setIsSchTimeFieldDisabled(false);
            }
          } 
        }
        
      }
      else if(e.target.title.toLowerCase().includes("drop off"))
      {
        mapPointPickupSelection.current = [];
        if(e.target.value === "DO VS")
        {
          setDropAddrVirtualStop({...dropAddrVirtualStop, value:"DO VS", name:""});
          setWalkDistance(prevWalkDistance=>({...prevWalkDistance, DOWalk:0, DODuration:0}));
          if(dropLatLng.current === ""){
            setDropAddr("");
          }
        }
        else
        {
          vsChangeRef.current.type = vsChangeRef.current.type.length === 0 ? "DO ": (vsChangeRef.current.type.includes("DO")?
           vsChangeRef.current.type:vsChangeRef.current.type+"DO ");
          setDropAddrVirtualStop({...dropAddrVirtualStop, value:e.target.value, name:nm});

          if(dropLatLng.current === ""){
            setDropAddr(name);
            dropLatLng.current = virtualData;
            if(!vsSelectedRef.current.includes("DO")){vsSelectedRef.current.push("DO")};
            let stopMarkersArr = [];
            let filteredMapMarkers = mapData.filter((item)=>{
              if(item.Type === "Stop")
              {
                stopMarkersArr.push(item);
              }
              return item.Type === "PU";
            });
            stopMarkersArr.push({lat:parseFloat(dropLatLng.current.split(",")[0]),
              lng: parseFloat(dropLatLng.current.split(",")[1]), Type:"DO", 
              name:(riderName === "" ? "N/A" : riderName.trim()), address: name
            });
            filteredMapMarkers.push(...stopMarkersArr);
            setMapData(filteredMapMarkers);
            setInputSuggestionListPU("");
            if(pickLatLng.current !== "")
            {
              doVSCallValidation.current = true;
              setIsSchTimeFieldDisabled(false);
            }
            setWalkDistance(prevWalkDistance=>({...prevWalkDistance, DOWalk:0, DODuration:0}));
          }
          else
          {
            setDropAddr(name);
            dropLatLng.current = virtualData;
            let stopMarkersArr = [];
            let filteredMapMarkers = mapData.filter((item)=>{
              if(item.Type === "Stop")
              {
                stopMarkersArr.push(item);
              }
              return item.Type === "PU";
            });
            stopMarkersArr.push({lat:parseFloat(dropLatLng.current.split(",")[0]),
              lng: parseFloat(dropLatLng.current.split(",")[1]), Type:"DO", 
              name:(riderName === "" ? "N/A" : riderName.trim()), address: name
            });
            filteredMapMarkers.push(...stopMarkersArr);
            setMapData(filteredMapMarkers);
            if(pickLatLng.current !== "")
            {
              doVSCallValidation.current = true;
              setIsSchTimeFieldDisabled(false);
            }
          }  
        }
        
      }
    }
    catch(err){console.log(err);}
  };

  const handleWalkDistanceCalculation = async(type, vsLatLng)=>{
    try
    {
      let origin = (type === "PU" ? pickLatLng.current : vsLatLng);
      let destination = (type === "PU" ? vsLatLng : dropLatLng.current);
      let addressAPI = ITCMapDirections.current + "?origin=" + origin + "&destination=" + destination + "&AppType=calltaker&walking=true"; //"&bounds=" + mapBounds+ 
      let OSRMResponse = await APICom.fetchData("full", addressAPI, "get", {
        'Authorization': 'Basic '+btoa(OSRM_Username.current + ":" + OSRM_Password.current),
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': '*',
        'mode': 'no-cors'
      }, {});

      if(OSRMResponse && OSRMResponse.data.status.toUpperCase() === "OK")
      {
        let distanceInMeters = OSRMResponse.data.routes[0].legs[0].distance.value;
        let durationInSeconds = OSRMResponse.data.routes[0].legs[0].duration.value;
        let distanceInMiles = parseFloat(parseFloat(distanceInMeters)/1609).toFixed(1);
        let duration = 0;
        let polylines = OSRMResponse.data.routes[0].overview_polyline.points;
        if(OSRMResponse.data.mapSource === 'OSRM')
        {
          duration = handleZoneSpeedMultiplierChecks('', '', selectedAff, durationInSeconds);
          duration = parseFloat(duration).toFixed(2);
        }
        else
        {
          duration = parseFloat(parseInt(durationInSeconds)/60).toFixed(2);
        }
        if(type === "PU")
        {
          setWalkDistance(prevWalkDistance=>({...prevWalkDistance, PUWalk:distanceInMiles, PUDuration:duration}));
          microPolylineDict.current.pick = polylines;
        }
        else
        {
          setWalkDistance(prevWalkDistance =>({...prevWalkDistance, DOWalk:distanceInMiles, DODuration:duration}));
          microPolylineDict.current.drop = polylines;
        }
      }
      else if(OSRMResponse && OSRMResponse.data.status.toUpperCase() === "ZERO_RESULTS")
      {
        if(type === "PU")
        {
          setWalkDistance(prevWalkDistance =>({...prevWalkDistance, PUWalk:0, PUDuration:0}));
        }
        else
        {
          setWalkDistance(prevWalkDistance =>({...prevWalkDistance, DOWalk:0, DODuration:0}));
        }
      }
    }
    catch(err){console.log(err);}
  };

  const handleResetAll = (type)=>{
    try{
      setCTPanel(preState => ({...preState, ShowcontextPanel:false, ContextPanelData:"", ContextDateTime:"", ContextPhoneNo:""}));
      setEnableFutureDateValidation(true);
      ResetEnableFutureDateValiation();
      setActiveTripSelected(false);
      setShowCCBtn(false);
      setBrokerModes(prevState=>({...prevState, brokerMode:0}));
      setFareEstimateAPISummary({copay: 0, walletID: 0, promo: "", eaasJSON: "", displayMessage: "", verifyStatus: ""});
      setRiderVerification("");
      setScheduleJSON({mainData: "", multiSchData:"", range:"", neverExpire:false});
      setIsSchTimeFieldDisabled(true);
      setManualFareChecks({fareEstimateCheck: false, fareEstimateDisabled: false, mileEstimateCheck: false, mileEstimateDisabled: false, priceCheck: false, priceCheckDisabled: false});
      manualFareChecksRef.current = {priceCheck:false, fareCheck:false, milesCheck:false};
      // manualCheckRef.current = {AgentPriceAdjustmentFSIDs: "", SDEnableNegotiatedFare: -1};
      apptTimeCheckValsRef.current = {ServiceTime:0, ApptWindow:0};
      if(searchClientBtnRef.current)
        searchClientBtnRef.current.disabled = false;
      setShowSearchLoader(false);
      setForcePassServiceHoursCheck(false);
      isValidateRCZCalledFromReset.current = true;
      addStopErrorFlag.current = false;
      // PersistStorage.save("rowDataCallAgent", [], 999, true);
      PersistStorage.save("rowDataEditTrip", "", 999, true);
      PersistStorage.save("clientInfo", [], 99, true);
      fareZonesRef.current = {pickFareZone:"", dropFareZone:""};
      setSearchButtonValidation("");
      searchButtonValidationRef.current = '';
      setStopLoadRiderName("");
      // setFareMethod(0);
      // fareMethodRef.current = 0;
      setShowAddrPhone({pick:false, drop:false});
      setAddrPhoneInfo({pick:null, drop:null});
      setShowAddrApartment({pick:false, drop:false});
      setAddrApartmentInfo({pick:null, drop:null});
      setFareZones({pick:"", drop:""});
      setDispatchZones({pickZone:"", dropZone:""});
      setStopUnloadRiderName("RN");
      setClientNameList([]);
      setFareDataArr([]);
      setMedID("");
      setMapData([]);
      setVerifiedAddr([]);
      setAddLegBtnTitle("Add Leg");
      setVerifiedInfoUpdateIndex(0);
      getCurrentSystemDateTime("date", true);
      setStopWaitTimeInput(0);
      setSchTime("");
      setAppointmentTime("");
      setWillCall(false);
      setStopWillCall(false);
      setRecentAddresses([]);
      setWalkDistance({...walkDistance, DOWalk:0, PUWalk:0, PUDuration:0, DODuration:0});
      setManualDataOverwrite({fare:0, price: 0, miles: 0}); 
      setNewClientInfoExtraInfo({language: 0, passType: '', agentNotes: '', ID: '', remarks: '', email: '', rollcall: {phone: false, sms: false, email: false}, 
        priority: '', name: '', affDetails: {affID: 0, FSID: 0}, phone: ''}
      );
      setMainInfoNewClient({type:'', value: ''});
      stopPassengerLoadTrackerRef.current = 0;
      searchedClientID.current = -1;
      // setConfirmationNo("");
      setSchPUTime("");
      setTripStatus("");
      setShowStopsInput(true);
      if(riderNameRef.current)
      {
        riderNameRef.current.style.borderColor = "";
        riderNameRef.current.style.borderWidth = "";
      }
      if(phoneRef.current)
      {
        phoneRef.current.style.borderColor = "";
        phoneRef.current.style.borderWidth = "";
      }
      setClientSummary(prevState=>({...prevState, totalCalls:0, totalNS:0, 
        totalCancels:0, lastCall:"",
        tripDistance:0.0, TripDuration:0.0, TripFare:0.0, TripCopay:0.0
      }));
      setCardNumber("");
      setCardType("");
      setCheckCCParams("");
      paymentCardIDInfoRef.current = {uniqueID: -1, oldUniqueID: -1, payStatusID: -1, invalidForSave: 0, retCCUniqueID: -1, CCPaidAmount: 0, CCRetPaidAmount: 0};
      setCardInfo({cardNumber:"", expiry: "", selectedCard: "", selectedExpiry: "", selectedCardType: "", uniqueID: 0, gateID: "", response: ""});
      setCardExpiration("");
      setAgentNotes("");
      setStopPhone("");
      setSelectedSummaryHeader("stopOrder");
      setAgentTripsDisplay(false);
      setStopOrderDisplay(true);
      setManifestDetailsDisplay(false);
      setMobilityDetails({...mobilityDetails, totalVeh:1, vehTypeMin:0, vehNumMin:0, driverNumMin:0, genderMin:0, languageMin:0});
      setMobilityChecks({...mobilityChecks, vehTypeCheck:false, vehNumCheck:false, driverNumCheck:false, genderCheck:false, languageCheck:false});
      setPassengerTypeCount({...passengerTypeCount, ambPass: 1, totalSA: 0,
        totalWC: 0, totalPass: 0, total:1, totalChildren: 0
      });
      setMobilityPassengers({...mobilityPassengers,  passenger:1, children: 0});
      setMobilityDbData({Primary: {Name: "Primary", Attributes: ""}, PCA:[], Guests: [], Children: []});
      setMobilitySavedData([]);
      
      setPassengerTypeCountStop({ambPass:1,totalWC:0,totalSA:0, total:1});
      setPickPOI("");
      setDropPOI("");
      setPickupAddr("");
      setDropAddr("");
      setStopAddr("");
      pickLatLng.current = "";
      dropLatLng.current = "";
      stopLatLng.current = "";

      addressInfoDetails.current = {pick: {state:"", city: "", zip: ""}, drop: {state:"", city:"", zip:""}};
      setPickExtraInfo("");
      setDropExtraInfo("");
      setStopAddrExtra("");
      setSubmitBtnTitle("Book");
      validateZeroFare.current = {FareAlertMessage: ""};
      const url = new URL(window.location.href);
      if(submitParatransitBtnTitle.toLowerCase() === "update")
      {
        setSubmitParatransitBtnTitle("Book");
        const cleanURL = url.origin + url.pathname; //URL without query string
        window.history.replaceState({}, '', cleanURL);
      }
      else
      {
        const cleanURL = url.origin + url.pathname; //URL without query string
        window.history.replaceState({}, '', cleanURL);
      }
      setPickupVirtualStop({...pickupVirtualStop, value:"PU VS", name:""});
      setDropAddrVirtualStop({...dropAddrVirtualStop, value:"DO VS", name:""});
      setZones("");
      setStopAddrZone("");
      setCopayAmount(0);
      setSelectedVehType('VT');
      setSelectedVehNum('VN');
      setSelectedTripAttr([]);
      if(type !== "func")
      {
        SetAttributesFilterMultiSelect({ ...AttributesFilterMultiSelect, ...{ selectedValues: []}});
      }
      if(type !== "aff")
      {
        setClientInfo([]);
        setClientIDInfo([]);
        setRiderName("");
        setAccountNumber("");
        setCallBackPhone("");
        setPhone("");
        setChatBotPhone("");
        setRiderNameCheck("");
        setMedicalIDCheck("");
        if(affiliateSelRef.current.options.length !== affiliateDropDownHTML.length)
        {
          let loginUserAffiliateList = (loginData.UserAffiliateList.includes(",")? loginData.UserAffiliateList.split(",") : [loginData.UserAffiliateList]);
          let affiliateOptionsHTML = AffiliateData.map(function(item, index){
            if(loginUserAffiliateList.includes(String(item.AffiliateID)))
            {
              return (
                <option key={index} value={item.AffiliateID}>{item.AffiliateCompany}</option>
              );
            }
          });
          setAffiliateDropDownHTML(affiliateOptionsHTML);  
        }
        if(phoneRef.current)
          phoneRef.current.disabled = false;
        if(clientNameCheckRef.current)
          clientNameCheckRef.current.disabled = false;
        if(clientMedIDCheckRef.current)
          clientMedIDCheckRef.current.disabled = false;
      }
      setSelectedDriverNum("DN");
      setSelectedGender("Gender");
      setSelectedLanguage("Language");
      setSelectedTripType(3);
      setSelectedTripPriority(5);
      setClientEmail("");
      setRCType({phoneType:false, emailType:false, SMSType:false});
      setStopLoadType({none:true, load:false, unload:false});
      setClientJob("");
      setInputSuggestionListClientName("");
      setInputSuggestionListClientPhone("");
      setInputSuggestionListClientMedID("");
      setStopSaveBtnTitle("Save");
      setClientStops([]);
      setStopEditInfo({data:{}, index:0});
      setPaymentAdditionalInfo("");
      if(type==="none"){
        let fsData = (FundingSourceData[parseInt(selectedAff)] && 
          FundingSourceData[parseInt(selectedAff)] !== undefined ? 
          JSON.parse(FundingSourceData[parseInt(selectedAff)]) : []
        );
        let fsSelected = (fsData.length > 0 ? fsData.find(item => parseInt(item.FID) === parseInt(FSTargetID)) : {});
        setBrokerModes(prevState=>({...prevState, brokerMode: (fsSelected === 0 ? 0 : fsSelected.BrokerMode)}));
        setAffiliateAbbr(fsSelected.AffiliateAbbrevation);
        
        setFSSelected(FSTargetID); setCopayFSSelected(1); setPaySelected(PayTargetID); setCopayPayTypeSelected(PayTargetID);
        handleManualAmountOnFSChange(fsSelected, parseInt(FSTargetID));
        setCOSSelected(COSTargetID);
      } 
      if(bookBtnRef.current)
      {
        bookBtnRef.current.disabled = true;
      }
      else if(paratransitBookBtnRef.current)
      {
        paratransitBookBtnRef.current.disabled = false;
        addLegBtnRef.current.disabled = false;
      }
      PredictiveRef.current = { ByPassPredictiveCheck: false, PredictiveData: null }
      setIsPCAApprovalCaputured(false);
      setShowAPILoader(false);
    
    }
    catch(err)
    {
      console.log(err);
      ResetEnableFutureDateValiation();
      setIsPCAApprovalCaputured(false);
      
    }
  };

  const ResetEnableFutureDateValiation = () => {
    try {
      setRequiredClass("");
      //setEnableFutureDateValidation(false);
    } catch (error) {
      
    }
  }

  const customHideFunc = () =>{
    try{
      // console.log(modalHeaderText);
      if(modalHeaderText && typeof modalHeaderText === "string" && modalHeaderText.toLowerCase() === "client info selection")
      {
        // console.log(clientIndexRef.current);
        handleClientInfoGeneration(clientIndexRef.current.data);
        setShowDynamicModal(false);
      }
      else
      {
        setShowDynamicModal(false);
      }
      if(modalHeaderText && typeof modalHeaderText === "string" && modalHeaderText.toLocaleLowerCase() === WARNING_PCA_NOT_ALLOWED.toLowerCase()){
        setShowAPILoader(false);
      }
    }
    catch(err){console.log(err);}
  };

  const formatDate = (data) => {
    try{
      const [year, month, day] = data.split('-');
      const date = new Date(year, month-1, day);
      // Get the components of the date
      const paddedMonth = String(date.getMonth() + 1).padStart(2, "0"); // Ensure two digits
      const paddedDay = String(date.getDate()).padStart(2, "0"); // Ensure two digits
      const paddedYear = date.getFullYear(); // No padding needed for the year
      
      return `${paddedMonth}/${paddedDay}/${paddedYear}`;
    }
    catch(err){console.log(err); return data;}
  };

  const handleClearLegInfo = (e)=>{
    try{
      let dropAddressTemp = dropAddr;
      let dropPOITemp = dropPOI;
      let dropLatLngTemp = dropLatLng.current;
      let dropFareZoneTemp = fareZonesRef.current.dropFareZone;
      let tripLatLng = [];
      let stopDetailsExtra = structuredClone(addressInfoDetails.current);
      // let tripFare = (clientInfo && typeof clientInfo === 'object'? clientInfo.)
      addressInfoDetails.current = {pick: stopDetailsExtra.drop, drop: {state:"", city:"", zip:""}};
      // setPassengerTypeCount({...passengerTypeCount, ambPass: 1, totalSA: 0,
      //   totalWC: 0, totalPass: 0, total:1, totalChildren: 0
      // });
      //setMobilityPassengers({...mobilityPassengers,  passenger:1, children: 0});
      //setMobilityDbData({Primary: {Name: "Primary", Attributes: ""}, PCA: {Name: "PCA", Attributes: ""}, Guests: [], Children: []});
      setPassengerTypeCountStop({ambPass:1,totalWC:0,totalSA:0, total:1});
      setStopLoadRiderName("");
      setStopUnloadRiderName("RN");
      setManualDistanceEditMode(false);
      setForcePassServiceHoursCheck(false);
      setScheduleJSON({mainData: "", multiSchData:"", range:"", neverExpire:false});
      setRCType({phoneType:false, emailType:false, SMSType:false});
      setStopLoadType({none:true, load:false, unload:false});
      setMobilityChecks({vehTypeCheck:false, vehNumCheck:false, driverNumCheck:false, genderCheck:false, languageCheck:false});
      setMobilityDetails({totalVeh:1, vehTypeMin:0, vehNumMin:0, driverNumMin:0, genderMin:0, languageMin:0});
      setClientStops([]);
      setClientNameList([]);
      setClientJob("");
      setCopayAmount(0);
      setCardNumber("");
      setCardType("");
      paymentCardIDInfoRef.current = {uniqueID: -1, oldUniqueID: -1, payStatusID: -1, invalidForSave: 0, retCCUniqueID: -1, CCPaidAmount: 0, CCRetPaidAmount: 0};
      setCardInfo(prevState=>({...prevState, cardNumber:"", expiry: "", selectedCard: "", selectedExpiry: "", selectedCardType: "", uniqueID: 0, response: ""}));
      setCardExpiration("");
      setSelectedTripType(3);
      setPaymentAdditionalInfo("");
      setClientEmail("");
      setSelectedVehType('VT');
      setSelectedVehNum('VN');
      setSelectedDriverNum('DN');
      setSelectedGender('Gender');
      setSelectedLanguage('Language');
      setVerifiedInfoUpdateIndex(0);
      setShowStopBlock(false);
      setPickExtraInfo("");
      setDropExtraInfo("");
      setAgentNotes("");
      setAppointmentTime("");
      setPickupAddr(dropAddressTemp);
      setPickPOI(dropPOITemp);
      setStopPOI("");
      setFareZones({pick:fareZones.drop, drop:""});
      setDispatchZones({pickZone:dispatchZones.dropZone, dropZone:""});
      setDropAddr("");
      setDropPOI("");
      pickLatLng.current = dropLatLngTemp;
      apptTimeCheckValsRef.current = {ServiceTime:0, ApptWindow:0};
      dropLatLng.current = "";
      fareZonesRef.current = {pickFareZone: dropFareZoneTemp, dropFareZone:""};
      stopPassengerLoadTrackerRef.current = 0;
      tripLatLng.push(
        {lat:parseFloat(pickLatLng.current.split(",")[0]),
          lng: parseFloat(pickLatLng.current.split(",")[1]), Type:"PU", 
          name:(riderName), address: dropAddressTemp
        }
      );
      setMapData(tripLatLng);
      setWillCall(false);
      setSchTime("");
      setShowAddrPhone({pick:false, drop:false});
      setAddrPhoneInfo({pick:null, drop:null});
      setShowAddrApartment({pick:false, drop:false});
      setAddrApartmentInfo({pick:null, drop:null});
      setStopTripCheckBox(false);
      setAddLegBtnTitle("Add Leg");
      setFareDataArr([]);
      setCopayAmount(0); 
      validateZeroFare.current = {FareAlertMessage: ""};
      setManualDataOverwrite(prevState=>({...prevState, price:0, fare:0, miles:0}));
      setClientSummary(prevState=>({...prevState, totalCalls:0, totalNS:0, 
        totalCancels:0, lastCall:"",
        tripDistance:0.0, TripDuration:0.0, TripFare:0.0, TripCopay:0.0
      }));

      setRequiredClass("");
      validateUserEnteredSchedulePickuptime.current = false;

    }
    catch(err){console.log(err);}
  };

  const handleRemoveStop = (e, index) =>{
    try{
      if(clientStops[index].passLoadType === "load")
      {
        stopPassengerLoadTrackerRef.current = parseInt(stopPassengerLoadTrackerRef.current) - parseInt(clientStops[index].stopPax.total);
      }
      else if(clientStops[index].passLoadType === "unload")
      {
        stopPassengerLoadTrackerRef.current = parseInt(stopPassengerLoadTrackerRef.current) + parseInt(clientStops[index].stopPax.total);
      }

      let filteredMapMarkers = mapData.filter((item)=>{
        return parseInt(item.id) !== parseInt(index);
      });

      setMapData(filteredMapMarkers);

      setClientStops((prevClientStops) =>
        prevClientStops.filter((_, i) => i !== index)
      );

      if(clientStops.length === 1)
      {
        setShowStopBlock(false);
      }
    }
    catch(err){console.log(err);}
  };

  const handleEditStop = (e, data, index)=>{
    try{
      if(data.passLoadType === "load")
      {
        setStopLoadType({none:false, load:true, unload:false});
      }
      else if(data.passLoadType === "unload")
      {
        setStopLoadType({none:false, load:false, unload:true});
      }
      else
      {
        setStopLoadType({none:true, load:false, unload:false});
      }
      setPassengerTypeCountStop(data.stopPax);
      setShowStopsInput(true);
      setStopSaveBtnTitle("Update");
      setStopLoadRiderName(data.passengerName);
      setStopUnloadRiderName(data.passengerName);
      setStopAddr(data.stopAddr);
      setStopAddrExtra(data.notes);
      setStopWaitTimeInput(data.waitTime);
      setStopEditInfo({data:data, index:index});
      stopLatLng.current = data.stopLatLng;
    }
    catch(err){console.log(err);}
  };

  function headersToObject(headers) {
    try{
      let result = {};
      for (let [key, value] of headers.entries()) {
        result[key] = value;
      }
      return result;
    }
    catch(err){console.log(err); return [];}
  };

  const sameAddrVerification = (pick, drop) =>{
    try{
      const abbreviations = {
        '\\bst\\b': 'street',
        '\\bw\\b': 'west',
        '\\be\\b': 'east',
        '\\bn\\b': 'north',
        '\\bs\\b': 'south',
        // Add more abbreviations as needed
      };
      let pickAddrNormalized = (pick.includes(",") ? (pick.split(",")[0].toLowerCase().replace(/\bst\b/gi, 'street')
      .replace(/\bave\b/gi, 'avenue')
      .replace(/\brd\b/gi, 'road')
      .replace(/\bdr\b/gi, 'drive')
      .replace(/\bln\b/gi, 'lane')
      .replace(/\bblvd\b/gi, 'boulevard')) : pick.toLowerCase());
      let dropAddrNormalized = (drop.includes(",") ? (drop.split(",")[0].toLowerCase().replace(/\bst\b/gi, 'street')
      .replace(/\bave\b/gi, 'avenue')
      .replace(/\brd\b/gi, 'road')
      .replace(/\bdr\b/gi, 'drive')
      .replace(/\bln\b/gi, 'lane')
      .replace(/\bblvd\b/gi, 'boulevard')) : drop.toLowerCase());
      for (const [abbr, full] of Object.entries(abbreviations)) {
        const regex = new RegExp(abbr, 'g');
        pickAddrNormalized = pickAddrNormalized.replace(regex, full);
        dropAddrNormalized = dropAddrNormalized.replace(regex, full);
      }
      const isPickDropSame = (pickAddrNormalized === dropAddrNormalized);
      return isPickDropSame;
    }
    catch(err){console.log(err);}
  };

  const checkIsMultiScheEntered = () => {
    try {
      if(scheduleJSON.mainData.Schedule.ScheduleItem.length > 0){
        return true;
      }
      else{
        return false;
      }
    } catch (error) { 
      return false;
    }
  }


  const handleAddLeg = async (title, CCConditionMet = false, confirmationNo = "") => {
    try{

      let isMultiSch = checkIsMultiScheEntered();
      if(isMultiSch){
        addLegBtnRef.current.disabled = true;
        return;
      }
    
      
      let doesUserEntersSchedluePickupTime = true;
        try {
          if(scheduleJSON?.mainData?.Schedule?.ScheduleItem?.length == 0 || scheduleJSON?.mainData?.Schedule == undefined || scheduleJSON?.mainData == ""){
            doesUserEntersSchedluePickupTime = await FutureDateValidation();
            if(doesUserEntersSchedluePickupTime === false){
              isPreviousLegSchTimeValidated.current = false;
              return;
            }
            else{
              isPreviousLegSchTimeValidated.current = true;
            }
          }  
        } catch (error) {
          
        }


      if(fareMethodRef.current === 1)
      {
        let validateResult = await ZeroFareValidationByValues(fareZones.pick, fareZones.drop, selectedAff, clientSummary.TripFare);
        if(validateResult.toLowerCase() === "false".toLowerCase() && validateZeroFare.current.FareAlertMessage !== "")
        {
          let ZeroConfirmationDialogResult = await showConfirmationModal(validateZeroFare.current.FareAlertMessage, "Fare is Zero",);
          if(ZeroConfirmationDialogResult === false) 
          {
            return;
          }
        }
      }
      
      let IsMobilityAttributesAttached = false;
      if(isAffiliateHasMobilityAttributes === true){
        MakeMobilitiesObject();
        mobilityDbData.IsMobility = true;
        if(mobilityDbData.Primary !== undefined && mobilityDbData.Primary?.Attributes !== ""){
          IsMobilityAttributesAttached = true;
        }

        if(passengerTypeCount.total == 1 && passengerTypeCount.ambPass == 1){
          if(mobilityDbData.Primary == undefined || Object.keys(mobilityDbData.Primary).length === 0 || mobilityDbData?.Primary?.Attributes == "" || mobilityDbData?.Primary?.Attributes == undefined){
            let ambAttribute = "";
            mobilityDbData.Primary.Name = "Primary";
            if(refMobilityAttributeOptions.current){
              ambAttribute = refMobilityAttributeOptions.current.find(p => p.value == "Ambulatory" || p.value == "Amb" || p.value == "amb" || p.value == "amb." || p.value == "Amb.")
            }
            if(ambAttribute != undefined){
              mobilityDbData.Primary.Attributes = ambAttribute.key;
            }
            mobilityDbData.Primary.selectedAttribute = ambAttribute.key;
            mobilityDbData.Primary.selectedLabel = "Primary";
            mobilityDbData.Primary.type = "primary";
            mobilityDbData.Primary.index = 0;
            mobilityDbData.Primary.key = CommonFunctions.GenerateUUID();
    
            if(passengerTypeCount.totalChildren == 1){
              let ambAttribute = "";
             // mobilityDbData.Primary.Name = "Primary";
              if(refMobilityAttributeOptions.current){
                ambAttribute = refMobilityAttributeOptions.current.find(p => p.value == "Ambulatory" || p.value == "Amb" || p.value == "amb" || p.value == "amb." || p.value == "Amb.")
              }
              if(ambAttribute != undefined){
                mobilityDbData.Children.push({ Name: "Child", Attributes:ambAttribute.key });
              }
      
            }
          }
    
        }
      }



      let clientInfoData = (PersistStorage.retrieve("clientInfo", true) ? PersistStorage.retrieve("clientInfo", true) : "");
      let clientLocationDict = {id: (clientInfoData.riderInfo ? clientInfoData.riderInfo.id : (clientInfoData.Id ? clientInfoData.Id : "")), 
        city: (clientInfoData.riderInfo ? clientInfoData.riderInfo.clientCity : (clientInfoData.City ? clientInfoData.City : "")), 
        state: (clientInfoData.riderInfo? clientInfoData.riderInfo.clientState: (clientInfoData.State ? clientInfoData.State : "")), 
        zip: (clientInfoData.riderInfo ? clientInfoData.riderInfo.clientZip : (clientInfoData.Zip ? clientInfoData.Zip : "")), 
        //medicalID: (clientInfoData.riderInfo ? clientInfoData.riderInfo.medicalID : (medID? medID : "")), 
        medicalID: clientInfoData?.riderInfo?.medicalID ? clientInfoData.riderInfo.medicalID : (medID || ""),
        address: (clientInfoData.riderInfo ? clientInfoData.riderInfo.clientAddress : (clientInfoData.Address ? clientInfoData.Address : ""))
      };
      if((pickLatLng.current !== undefined && pickLatLng.current !== "") && (dropLatLng.current !== undefined && dropLatLng.current !== ""))
      {
        if(riderName === "")
        {
          setModalHeaderText("Stop Order Alert");
          setModalBodyHTML("Please enter the client's name in the provided field.");
          setModalFooterHTML(
            <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
              OK
            </Button>
          );
          setShowDynamicModal(true);
        }
        else if(!phone || phone.length < 12)
        {
          setModalHeaderText("Stop Order Alert");
          setModalBodyHTML("Please enter the client's phone number in the provided field.");
          setModalFooterHTML(
            <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
              OK
            </Button>
          );
          setShowDynamicModal(true);
        }
        else
        {
          
          if(title.toLowerCase().includes("leg"))
          {
            
            let stopDetailsTrackerObj = await handleGetTripsDetailsWithStops(true);
            let sameAddrFlag = false;
            let pickGeoInfo = structuredClone(pickLatLng.current);
            let dropGeoInfo = structuredClone(dropLatLng.current);
            let PUApartment = structuredClone(addrApartmentInfo.pick);
            let DOApartment = structuredClone(addrApartmentInfo.drop);
            

            let userResponse = await ValidateServiceArea(pickGeoInfo, dropGeoInfo);
            if(userResponse === false){
              return;
            }

            let fareMethodInfo = structuredClone(fareMethodRef.current);
            let givenConfirmation = 0;
            if(verifiedAddr.length === 0 && submitParatransitBtnTitle.trim().toLowerCase() === "update"){
              const queryParams = new URLSearchParams(window.location.search);
              const tripSelected = queryParams.get('TripSelected') || activeTripSelected? true:false;
              let editRowData = (PersistStorage.retrieve("rowDataEditTrip", true)  && tripSelected? PersistStorage.retrieve("rowDataEditTrip", true):"");
              if(editRowData && typeof editRowData === 'object')
              {
                givenConfirmation = parseInt(editRowData.addressInfo.trips[0].details[0].tripInfo.refID);
              }
            }
            setShowAddLegLoader(true);
            
            paymentCardIDInfoRef.current = {uniqueID: -1, oldUniqueID: -1, payStatusID: -1, invalidForSave: 0, retCCUniqueID: -1, CCPaidAmount: 0, CCRetPaidAmount: 0};
            let ccverified = ((parseInt(copayPayTypeSelected) === 2 || parseInt(PaySelected) === 2) && !CCConditionMet ? await CCMultiLegReservationCheck(false) : true);
            if(ccverified)
            {
              const updatedCard = {...cardInfo, response: ''};
              let stopDetailsExtra = structuredClone(addressInfoDetails.current);
              setTripDetails((prevTripDetails)=>{
                let correctDate = formatDate(selectedDateSchTime);
                const tripDetailArr = {...prevTripDetails, 
                  willCall:willCall,
                   apptTime:appointmentTime, 
                   pickAddr:pickupAddr, 
                   dropAddr: dropAddr,
                    pickPOI:pickPOI, 
                    dropPOI:dropPOI,
                  notes:agentNotes, 
                  phone:phone, 
                  callBackPhone:callBackPhone, 
                  puNotes:pickExtraInfo,
                   doNotes:dropExtraInfo, 
                   riderName:(riderName === ""?"Unkwn":riderName), 
                  passCount:passengerTypeCount, 
                  distance: (prevTripDetails.distance),
                  duration: (prevTripDetails.duration), 
                  fareZones: fareZones, 
                  email: clientEmail,
                  date: correctDate, 
                  time:(schTime === "" && verifiedAddr.length === 0 ? "":schTime), 
                  waitTime: "", 
                  dispatchZones: dispatchZones,
                  id: (clientInfo.Id ? clientInfo.Id : clientLocationDict.id), 
                  clientMedID: clientLocationDict.medicalID, 
                  clientAddr: (clientInfo.Address ? clientInfo.Address : clientLocationDict.address), 
                  clientCity: (clientInfo.City ? clientInfo.City : clientLocationDict.city),
                   clientState: (clientInfo.State ? clientInfo.State : clientLocationDict.state), 
                  clientZip: (clientInfo.Zip? clientInfo.Zip : clientLocationDict.zip), 
                  vehType: selectedVehType, 
                  vehTypeCheck: mobilityChecks.vehTypeCheck, 
                  vehTypeMins: mobilityDetails.vehTypeMin,
                  FundingSource: FSSelected, 
                  PaymentSelected: PaySelected, 
                  AffiliateSelected: selectedAff, 
                  COS: COSSelected, 
                  copay:(copayAmount === 0 || copayAmount === ""? clientSummary.TripCopay: copayAmount), 
                  cardNum: cardNumber, 
                  cardExp: cardExpiration,
                   RC: RCType, driverNum: selectedDriverNum,
                    driverNumCheck: mobilityChecks.driverNumCheck,
                  driverMins: mobilityDetails.driverNumMin, gender: selectedGender, genderMins: mobilityDetails.genderMin, vehNum: selectedVehNum, genderCheck: mobilityChecks.genderCheck,
                  vehNumCheck: mobilityChecks.vehNumCheck, vehMins: mobilityDetails.vehNumMin, language: selectedLanguage, languageMins: mobilityDetails.languageMin, languageCheck: mobilityChecks.languageCheck,
                  tripAttribute: selectedTripAttr, insurance: {Agency: insuranceAgency, Type: insuranceType, CaseWorker: insuranceCaseWorker, AuthCode: insuranceAuthCode, 
                  ServiceCode: insuranceServiceCode}, copayPayType: copayPayTypeSelected, fare: clientSummary.TripFare, 
                  copayFS: copayFSSelected, paymentExtraInfo: paymentAdditionalInfo, clientJob: clientJob, tripType: selectedTripType, tripPriority: selectedTripPriority,
                  passengerMobilityInfo: structuredClone(mobilityDbData),
                  PUApartment: PUApartment,
                  DOApartment: DOApartment
                };
                setVerifiedAddr((prevVerifiedAddr) => {
                  const isDuplicate = prevVerifiedAddr.some(
                    (leg)=> leg.pickAddr === tripDetailArr.pickAddr && leg.dropAddr === tripDetailArr.dropAddr
                  );
                  let isPickDropSame = sameAddrVerification(tripDetailArr.pickAddr, tripDetailArr.dropAddr);
                  
                  if(isDuplicate){
                    setModalHeaderText("Stop Order Alert");
                    setModalBodyHTML("The entered addresses were entered previously, addresses must be different and verified.");
                    setModalFooterHTML(
                      <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                        OK
                      </Button>
                    );
                    setShowDynamicModal(true);
                    sameAddrFlag = true;
                    return prevVerifiedAddr;
                  }
                  if(isPickDropSame)
                  {
                    setModalHeaderText("Stop Order Alert");
                    setModalBodyHTML("The entered addresses are duplicates. Addresses must be different and verified.");
                    setModalFooterHTML(
                      <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                        OK
                      </Button>
                    );
                    setShowDynamicModal(true);
                    sameAddrFlag = true;
                    return prevVerifiedAddr;
                  }

                  return [...prevVerifiedAddr, {pickAddr: tripDetailArr.pickAddr, dropAddr: tripDetailArr.dropAddr, pickPOI: tripDetailArr.pickPOI, dropPOI: tripDetailArr.dropPOI,
                    date: tripDetailArr.date, email: tripDetailArr.email, confirmationNo: (confirmationNo !== "" ? confirmationNo : givenConfirmation),
                    time: (tripDetailArr.willCall ? "Will Call":tripDetailArr.time), distance: stopDetailsTrackerObj.totalTripEstimates.dist, duration: stopDetailsTrackerObj.totalTripEstimates.dur, fare: tripDetailArr.fare, copay: tripDetailArr.copay,
                    willCall: tripDetailArr.willCall, apptTime: (tripDetailArr.willCall ? "Will Call":tripDetailArr.apptTime), notes:tripDetailArr.notes, phone:tripDetailArr.phone, 
                    puNotes:tripDetailArr.puNotes, doNotes:tripDetailArr.doNotes, riderName:tripDetailArr.riderName, passCount:tripDetailArr.passCount, 
                    callBackPhone: tripDetailArr.callBackPhone, manualAmount: {estimatedFare: manualDataOverwrite.fare, estimatedDistance: manualDataOverwrite.miles, price:manualDataOverwrite.price},
                    waitTime:tripDetailArr.waitTime, stops:clientStops, isReturn:stopTripCheckBox, pickLatLng: pickGeoInfo, dropLatLng: dropGeoInfo,
                    stopsDetails: stopDetailsTrackerObj.stopDetails, addressExtraDetails: stopDetailsExtra, id: tripDetailArr.id, 
                    clientMedID: tripDetailArr.clientMedID, paymentExtraInfo: tripDetailArr.paymentExtraInfo, clientJob: tripDetailArr.clientJob,
                    clientAddr: tripDetailArr.clientAddr, clientCity: tripDetailArr.clientCity, 
                    clientState: tripDetailArr.clientState, clientZip: tripDetailArr.clientZip, fareZones: tripDetailArr.fareZones, dispatchZones: tripDetailArr.dispatchZones,
                    FundingSource: tripDetailArr.FundingSource, PaymentSelected: tripDetailArr.PaymentSelected, AffiliateSelected: tripDetailArr.AffiliateSelected, 
                    COS: tripDetailArr.COS, vehType: tripDetailArr.vehType, vehTypeCheck: tripDetailArr.vehTypeCheck, vehTypeMins: tripDetailArr.vehTypeMins,
                    cardNum: tripDetailArr.cardNum, cardExp: tripDetailArr.cardExp, RC: tripDetailArr.RC, driverNum: tripDetailArr.driverNum, driverNumCheck: tripDetailArr.driverNumCheck,
                    driverMins: tripDetailArr.driverMins, gender: tripDetailArr.gender, genderMins: tripDetailArr.genderMins, vehNum: tripDetailArr.vehNum, genderCheck: tripDetailArr.genderCheck,
                    vehNumCheck: tripDetailArr.vehNumCheck, vehMins: tripDetailArr.vehMins, language: tripDetailArr.language, languageMins: tripDetailArr.languageMins, languageCheck: tripDetailArr.languageCheck,
                    tripAttribute: tripDetailArr.tripAttribute, insurance: {Agency: tripDetailArr.insurance.Agency, Type: tripDetailArr.insurance.Type, 
                    CaseWorker: tripDetailArr.insurance.CaseWorker, AuthCode: tripDetailArr.insurance.AuthCode,
                    ServiceCode: tripDetailArr.insurance.ServiceCode}, copayPayType: tripDetailArr.copayPayType, copayFS: tripDetailArr.copayFS, tripType: tripDetailArr.tripType, 
                    tripPriority: tripDetailArr.tripPriority, fareMethod: fareMethodInfo, billableAmount: fareDataArr.billableAmount , additionalPassengerCost: fareDataArr.additionalPassengerCost,
                    fareEstimateAPIData : fareEstimateAPISummary, broker: brokerModes, CCInfo: updatedCard, paymentLogicInfo: paymentCardIDInfoRef.current,
                    addressPhoneInfo: {pick: addrPhoneInfo.pick, drop: addrPhoneInfo.drop},
                    passengerMobilityInfo: tripDetailArr.passengerMobilityInfo,
                    PUApartment: tripDetailArr.PUApartment,
                    DOApartment: tripDetailArr.DOApartment
                  }];
                
                });
                return tripDetailArr;
              });
              setShowAddLegLoader(false);
              if(!sameAddrFlag)
              {
                handleClearLegInfo();
              }
            }
          }
          else if(title.toLowerCase().includes("return"))
          {
            if(verifiedAddr.length === 0)
            {
              setModalHeaderText("Add Return Stop Error");
              setModalBodyHTML("Please add a start point before adding a return address");
              setModalFooterHTML(
                <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                  OK
                </Button>
              );
              setShowDynamicModal(true);
            }
            else
            {
              if(dropLatLng.current !== "" && pickLatLng.current !== "")
              {
                let stopDetailsTrackerObj = await handleGetTripsDetailsWithStops(true);
                let sameAddrFlag = false;
                let pickGeoInfo = structuredClone(pickLatLng.current);
                let dropGeoInfo = structuredClone(dropLatLng.current);

                let userResponse = await ValidateServiceArea(pickGeoInfo, dropGeoInfo);
                if(userResponse === false){
                  return;
                }

                let fareMethodInfo = structuredClone(fareMethodRef.current);
                let stopDetailsExtra = structuredClone(addressInfoDetails.current);
                setShowAddLegLoader(true);
                setTripDetails((prevTripDetails) => {
                  let correctDate = formatDate(selectedDateSchTime);
                  const tripDetailArr = {...prevTripDetails, willCall:willCall, apptTime:appointmentTime, 
                    notes:agentNotes, phone:phone, callBackPhone:callBackPhone, puNotes:pickExtraInfo, doNotes:dropExtraInfo, riderName:(riderName === ""?"Unkwn":riderName), 
                    passCount:passengerTypeCount, pickAddr: pickupAddr, dropAddr: dropAddr, pickPOI:pickPOI, dropPOI:dropPOI,
                    distance: (clientSummary.tripDistance), 
                    duration: (clientSummary.TripDuration), fareZones: fareZones, dispatchZones: dispatchZones,
                    date: correctDate, time:(schTime === "" && verifiedAddr.length === 0? "":schTime), waitTime: "", email: clientEmail, clientZip: clientInfo.Zip,
                    id: (clientInfo.Id ? clientInfo.Id : clientLocationDict.id), clientMedID: (clientLocationDict.medicalID), 
                    clientAddr: (clientInfo.Address ? clientInfo.Address : clientLocationDict.address), 
                    clientCity: (clientInfo.City ? clientInfo.City : clientLocationDict.city), clientState: (clientInfo.State ? clientInfo.State : clientLocationDict.state), 
                    vehType: selectedVehType, vehTypeCheck: mobilityChecks.vehTypeCheck, vehTypeMins: mobilityDetails.vehTypeMin,
                    FundingSource: FSSelected, PaymentSelected: PaySelected, AffiliateSelected: selectedAff, COS: COSSelected, 
                    copay:(copayAmount === 0 || copayAmount === ""? clientSummary.TripCopay: copayAmount),
                    cardNum: cardNumber, cardExp: cardExpiration, RC: RCType, driverNum: selectedDriverNum, driverNumCheck: mobilityChecks.driverNumCheck, 
                    genderCheck: mobilityChecks.genderCheck,
                    driverMins: mobilityDetails.driverNumMin, gender: selectedGender, genderMins: mobilityDetails.genderMin, vehNum: selectedVehNum, 
                    languageCheck: mobilityChecks.languageCheck,
                    vehNumCheck: mobilityChecks.vehNumCheck, vehMins: mobilityDetails.vehNumMin, language: selectedLanguage, 
                    languageMins: mobilityDetails.languageMin, fare: clientSummary.TripFare,
                    tripAttribute: selectedTripAttr, insurance: {Agency: insuranceAgency, Type: insuranceType, 
                      CaseWorker: insuranceCaseWorker, AuthCode: insuranceAuthCode,
                    ServiceCode: insuranceServiceCode}, copayPayType: copayPayTypeSelected, copayFS: copayFSSelected, 
                    paymentExtraInfo: paymentAdditionalInfo, clientJob: clientJob, tripType: selectedTripType, tripPriority: selectedTripPriority,
                    passengerMobilityInfo: mobilityDbData
                  }; 
  
                  setVerifiedAddr((prevVerifiedAddr) => {
                    const isDuplicate = prevVerifiedAddr.some(
                      (leg)=> leg.pickAddr === tripDetailArr.pickAddr && leg.dropAddr === tripDetailArr.dropAddr
                    );
                    let pickAddrNormalized = (tripDetailArr.pickAddr.includes(",") ? (tripDetailArr.pickAddr.split(",")[0].toLowerCase().replace(/\bst\b/gi, 'street')
                    .replace(/\bave\b/gi, 'avenue')
                    .replace(/\brd\b/gi, 'road')
                    .replace(/\bdr\b/gi, 'drive')
                    .replace(/\bln\b/gi, 'lane')
                    .replace(/\bblvd\b/gi, 'boulevard')) : tripDetailArr.pickAddr.toLowerCase());
                    let dropAddrNormalized = (tripDetailArr.dropAddr.includes(",") ? (tripDetailArr.dropAddr.split(",")[0].toLowerCase().replace(/\bst\b/gi, 'street')
                    .replace(/\bave\b/gi, 'avenue')
                    .replace(/\brd\b/gi, 'road')
                    .replace(/\bdr\b/gi, 'drive')
                    .replace(/\bln\b/gi, 'lane')
                    .replace(/\bblvd\b/gi, 'boulevard')) : tripDetailArr.dropAddr.toLowerCase());
                    const isPickDropSame = (pickAddrNormalized === dropAddrNormalized);
                    if(isPickDropSame)
                    {
                      setModalHeaderText("Stop Order Alert");
                      setModalBodyHTML("The entered addresses are duplicates. Addresses must be different and verified.");
                      setModalFooterHTML(
                        <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                          OK
                        </Button>
                      );
                      setShowDynamicModal(true);
                      sameAddrFlag = true;
                      return prevVerifiedAddr;
                    }
                    
                    return [...prevVerifiedAddr, {pickAddr: tripDetailArr.pickAddr, dropAddr: tripDetailArr.dropAddr, pickPOI: tripDetailArr.pickPOI, dropPOI: tripDetailArr.dropPOI,
                      date: tripDetailArr.date, clientZip: tripDetailArr.clientZip, confirmationNo: 0,
                      time: (tripDetailArr.willCall ? "Will Call":tripDetailArr.time), distance: stopDetailsTrackerObj.totalTripEstimates.dist, duration: stopDetailsTrackerObj.totalTripEstimates.dur, 
                      fare: tripDetailArr.fare, copay: tripDetailArr.copay,
                      willCall: tripDetailArr.willCall, apptTime: (tripDetailArr.willCall ? "Will Call":tripDetailArr.apptTime), email: tripDetailArr.email, 
                      notes:tripDetailArr.notes, phone:tripDetailArr.phone, 
                      puNotes:tripDetailArr.puNotes, doNotes:tripDetailArr.doNotes, riderName:tripDetailArr.riderName, passCount:tripDetailArr.passCount, 
                      fareZones: tripDetailArr.fareZones, dispatchZones: tripDetailArr.dispatchZones,
                      waitTime:tripDetailArr.waitTime, stops:clientStops, isReturn:stopTripCheckBox, pickLatLng: pickGeoInfo, dropLatLng: dropGeoInfo, 
                      callBackPhone:tripDetailArr.callBackPhone,
                      stopsDetails: stopDetailsTrackerObj.stopDetails, addressExtraDetails: stopDetailsExtra, id: tripDetailArr.id, clientMedID: tripDetailArr.clientMedID, 
                      paymentExtraInfo: tripDetailArr.paymentExtraInfo, clientJob: tripDetailArr.clientJob,
                      clientAddr: tripDetailArr.clientAddr, clientCity: tripDetailArr.clientCity, clientState: tripDetailArr.clientState, fareMethod: fareMethodInfo,
                      FundingSource: tripDetailArr.FundingSource, PaymentSelected: tripDetailArr.PaymentSelected, AffiliateSelected: tripDetailArr.AffiliateSelected, 
                      COS: tripDetailArr.COS, vehType: tripDetailArr.vehType, vehTypeCheck: tripDetailArr.vehTypeCheck, vehTypeMins: tripDetailArr.vehTypeMins, 
                      genderCheck: tripDetailArr.genderCheck,
                      cardNum: tripDetailArr.cardNum, cardExp: tripDetailArr.cardExp, RC: tripDetailArr.RC, driverNum: tripDetailArr.driverNum, 
                      driverNumCheck: tripDetailArr.driverNumCheck,
                      driverMins: tripDetailArr.driverMins, gender: tripDetailArr.gender, genderMins: tripDetailArr.genderMins, vehNum: tripDetailArr.vehNum, 
                      languageCheck: tripDetailArr.languageCheck,
                      vehNumCheck: tripDetailArr.vehNumCheck, vehMins: tripDetailArr.vehMins, language: tripDetailArr.language, languageMins: tripDetailArr.languageMins,
                      tripAttribute: tripDetailArr.tripAttribute, insurance: {Agency: tripDetailArr.insurance.Agency, Type: tripDetailArr.insurance.Type, 
                      CaseWorker: tripDetailArr.insurance.CaseWorker, AuthCode: tripDetailArr.insurance.AuthCode, 
                      ServiceCode: tripDetailArr.insurance.ServiceCode}, copayPayType: tripDetailArr.copayPayType, copayFS: tripDetailArr.copayFS, 
                      tripType: tripDetailArr.tripType, tripPriority: tripDetailArr.tripPriority, billableAmount: fareDataArr.billableAmount , 
                      additionalPassengerCost: fareDataArr.additionalPassengerCost, fareEstimateAPIData : fareEstimateAPISummary, broker: brokerModes, CCInfo: cardInfo,
                      paymentLogicInfo: {uniqueID: -1, oldUniqueID: -1, payStatusID: -1, invalidForSave: 0, retCCUniqueID: -1, CCPaidAmount: 0, CCRetPaidAmount: 0},
                      addressPhoneInfo: {pick: addrPhoneInfo.pick, drop: addrPhoneInfo.drop},
                      passengerMobilityInfo: tripDetailArr.passengerMobilityInfo
                    }];
                  
                  });
                  return tripDetailArr;
                });
                setShowAddLegLoader(false);
                if(!sameAddrFlag)
                {
                  handleClearLegInfo();
                }
              }
              else
              {
                setModalHeaderText("Stop Order Alert");
                setModalBodyHTML("Please enter a valid address for pickup and drop-off fields to make a return trip.");
                setModalFooterHTML(
                  <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                    OK
                  </Button>
                );
                setShowDynamicModal(true);
              }
            }
          } 
          else if(title.toLowerCase().includes("update"))
          {
            
            let stopDetailsTrackerObj = await handleGetTripsDetailsWithStops(true);
            let sameAddrFlag = false;
            let pickGeoInfo = structuredClone(pickLatLng.current);
            let dropGeoInfo = structuredClone(dropLatLng.current);
            let PUApartment = structuredClone(addrApartmentInfo.pick);
            let DOApartment = structuredClone(addrApartmentInfo.drop);
            

            let userResponse = await ValidateServiceArea(pickGeoInfo, dropGeoInfo);
            if(userResponse === false){
              return;
            }

            let fareMethodInfo = structuredClone(fareMethodRef.current);
            setShowAddLegLoader(true);
            paymentCardIDInfoRef.current = {uniqueID: -1, oldUniqueID: -1, payStatusID: -1, invalidForSave: 0, retCCUniqueID: -1, CCPaidAmount: 0, CCRetPaidAmount: 0};
            let ccverified = (cardInfo.uniqueID !== verifiedAddr[verifiedInfoUpdateIndex].CCInfo.uniqueID && !CCConditionMet ? await CCMultiLegReservationCheck(false) : true);
            if(ccverified)
            {
              
              const updatedCard = {...cardInfo, response: ''};
              let stopDetailsExtra = structuredClone(addressInfoDetails.current);
              setTripDetails((prevTripDetails)=>{
                let correctDate = formatDate(selectedDateSchTime);
                const tripDetailArr = {...prevTripDetails, willCall:willCall, apptTime:appointmentTime, 
                  notes:agentNotes, phone:phone, callBackPhone:callBackPhone, puNotes:pickExtraInfo, doNotes:dropExtraInfo, riderName:(riderName === ""?"Unkwn":riderName), 
                  passCount:passengerTypeCount, pickAddr: pickupAddr, dropAddr: dropAddr, pickPOI:pickPOI, dropPOI:dropPOI,
                  distance: (prevTripDetails.distance), 
                  duration: (prevTripDetails.duration), fareZones: fareZones, dispatchZones: dispatchZones,
                  date: correctDate, time:(schTime === "" && verifiedAddr.length === 0? "":schTime), waitTime: "", email:clientEmail,
                  id: (clientInfo.Id ? clientInfo.Id : clientLocationDict.id), 
                  clientMedID: (clientLocationDict.medicalID), //=========> Check this
                  clientAddr: (clientInfo.Address ? clientInfo.Address : clientLocationDict.address), 
                  clientCity: (clientInfo.City ? clientInfo.City : clientLocationDict.city), clientState: (clientInfo.State ? clientInfo.State : clientLocationDict.state), 
                  clientZip: (clientInfo.Zip? clientInfo.Zip : clientLocationDict.zip),
                  vehType: selectedVehType, vehTypeCheck: mobilityChecks.vehTypeCheck, vehTypeMins: mobilityDetails.vehTypeMin,
                  FundingSource: FSSelected, PaymentSelected: PaySelected, AffiliateSelected: selectedAff, COS: COSSelected, copay:(copayAmount === 0 || copayAmount === ""? clientSummary.TripCopay: copayAmount), 
                  cardNum: cardNumber, cardExp: cardExpiration, RC: RCType, driverNum: selectedDriverNum, driverNumCheck: mobilityChecks.driverNumCheck, fare: clientSummary.TripFare,
                  driverMins: mobilityDetails.driverNumMin, gender: selectedGender, genderMins: mobilityDetails.genderMin, vehNum: selectedVehNum, genderCheck: mobilityChecks.genderCheck,
                  vehNumCheck: mobilityChecks.vehNumCheck, vehMins: mobilityDetails.vehNumMin, language: selectedLanguage, languageMins: mobilityDetails.languageMin, 
                  languageCheck: mobilityChecks.languageCheck,
                  tripAttribute: selectedTripAttr, insurance: {Agency: insuranceAgency, Type: insuranceType, CaseWorker: insuranceCaseWorker, AuthCode: insuranceAuthCode,
                  ServiceCode: insuranceServiceCode}, copayPayType: copayPayTypeSelected, copayFS: copayFSSelected, paymentExtraInfo: paymentAdditionalInfo, 
                  clientJob: clientJob, tripType: selectedTripType, tripPriority: selectedTripPriority, CCInfo: updatedCard, 
                  paymentLogicInfo: {uniqueID: -1, oldUniqueID: -1, payStatusID: -1, invalidForSave: 0, retCCUniqueID: -1, CCPaidAmount: 0, CCRetPaidAmount: 0},
                  passengerMobilityInfo: mobilityDbData,
                  PUApartment: PUApartment,
                  DOApartment: DOApartment
                };
                setVerifiedAddr((prevVerifiedAddr) => {
                  let isPickDropSame = sameAddrVerification(tripDetailArr.pickAddr, tripDetailArr.dropAddr);
                  if(isPickDropSame)
                  {
                    setModalHeaderText("Stop Order Alert");
                    setModalBodyHTML("The entered addresses are duplicates. Addresses must be different and verified.");
                    setModalFooterHTML(
                      <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                        OK
                      </Button>
                    );
                    setShowDynamicModal(true);
                    sameAddrFlag = true;
                    return prevVerifiedAddr;
                  }
                  
                  const updatedVerifiedAddr = prevVerifiedAddr.map((item, index) =>
                    index === verifiedInfoUpdateIndex
                      ? {
                          ...item,
                          pickAddr: tripDetailArr.pickAddr, pickPOI: tripDetailArr.pickPOI, 
                          dropAddr: tripDetailArr.dropAddr, dropPOI: tripDetailArr.dropPOI,
                          date: tripDetailArr.date,
                          time: tripDetailArr.willCall ? "Will Call" : tripDetailArr.time,
                          distance: stopDetailsTrackerObj.totalTripEstimates.dist,
                          duration: stopDetailsTrackerObj.totalTripEstimates.dur,
                          fare: tripDetailArr.fare,
                          copay: tripDetailArr.copay,
                          email: tripDetailArr.email,
                          willCall: tripDetailArr.willCall,
                          apptTime: tripDetailArr.willCall ? "Will Call" : tripDetailArr.apptTime,
                          notes: tripDetailArr.notes,
                          phone: tripDetailArr.phone, callBackPhone: tripDetailArr.callBackPhone,
                          puNotes: tripDetailArr.puNotes,
                          doNotes: tripDetailArr.doNotes,
                          riderName: tripDetailArr.riderName,
                          passCount: tripDetailArr.passCount,
                          waitTime: tripDetailArr.waitTime,
                          stops: clientStops,
                          isReturn: stopTripCheckBox,
                          pickLatLng: pickGeoInfo,
                          dropLatLng: dropGeoInfo,
                          manualAmount: {estimatedFare: manualDataOverwrite.fare, estimatedDistance: manualDataOverwrite.miles, price:manualDataOverwrite.price},
                          stopsDetails: stopDetailsTrackerObj.stopDetails, addressExtraDetails: stopDetailsExtra,
                          id: tripDetailArr.id, CCInfo: tripDetailArr.CCInfo, paymentLogicInfo: tripDetailArr.paymentLogicInfo,
                          clientMedID: tripDetailArr.clientMedID, //==============> check this
                          confirmationNo: (confirmationNo !== "" ? confirmationNo : item.confirmationNo),
                          clientAddr: tripDetailArr.clientAddr, clientCity: tripDetailArr.clientCity, clientState: tripDetailArr.clientState, clientZip: tripDetailArr.clientZip,
                          FundingSource: tripDetailArr.FundingSource, 
                          PaymentSelected: tripDetailArr.PaymentSelected, 
                          AffiliateSelected: tripDetailArr.AffiliateSelected, 
                          COS: tripDetailArr.COS,
                          cardNum: tripDetailArr.cardNum, cardExp: tripDetailArr.cardExp, 
                          RC: tripDetailArr.RC, 
                          driverNum: tripDetailArr.driverNum, driverNumCheck: tripDetailArr.driverNumCheck, driverMins: tripDetailArr.driverMins, 
                          gender: tripDetailArr.gender, genderMins: tripDetailArr.genderMins, genderCheck: tripDetailArr.genderCheck,
                          vehNum: tripDetailArr.vehNum, vehNumCheck: tripDetailArr.vehNumCheck, vehMins: tripDetailArr.vehMins, 
                          vehType: tripDetailArr.vehType, vehTypeCheck: tripDetailArr.vehTypeCheck, vehTypeMins: tripDetailArr.vehTypeMins,
                          language: tripDetailArr.language, languageMins: tripDetailArr.languageMins, languageCheck: tripDetailArr.languageCheck,
                          tripAttribute: tripDetailArr.tripAttribute, 
                          insurance: {Agency: tripDetailArr.insurance.Agency, Type: tripDetailArr.insurance.Type, 
                            CaseWorker: tripDetailArr.insurance.CaseWorker, AuthCode: tripDetailArr.insurance.AuthCode,
                            ServiceCode: tripDetailArr.insurance.ServiceCode
                          },
                          copayPayType: tripDetailArr.copayPayType, copayFS: tripDetailArr.copayFS, fareEstimateAPIData : fareEstimateAPISummary, broker: brokerModes,
                          fareMethod: fareMethodInfo, fareZones: tripDetailArr.fareZones, dispatchZones: tripDetailArr.dispatchZones, billableAmount: fareDataArr.billableAmount , additionalPassengerCost: fareDataArr.additionalPassengerCost,
                          paymentExtraInfo: tripDetailArr.paymentExtraInfo, clientJob: tripDetailArr.clientJob, tripType: tripDetailArr.tripType, tripPriority: tripDetailArr.tripPriority,
                          addressPhoneInfo: {pick: addrPhoneInfo.pick, drop: addrPhoneInfo.drop},
                          passengerMobilityInfo: tripDetailArr.passengerMobilityInfo,
                          PUApartment: tripDetailArr.PUApartment,
                          DOApartment: tripDetailArr.DOApartment
                        }
                      : item
                  );
            
                  return updatedVerifiedAddr;
                
                });
                return tripDetailArr;
              });
              setShowAddLegLoader(false);
              if(!sameAddrFlag)
              {
                handleClearLegInfo();
              }
            }
          }

          // setMobilityDbData({Primary: {Name: "Primary", Attributes: ""}, PCA: {Name: "PCA", Attributes: ""}, Guests: [], Children: []});
          // setMobilityPassengers({...mobilityPassengers,  passenger: 1, children: 0});
        }
      }
      else
      {
        setModalHeaderText("Stop Order Alert");
        setModalBodyHTML("Please enter a valid address for pickup and drop-off fields to add a leg.");
        setModalFooterHTML(
          <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
            OK
          </Button>
        );
        setShowDynamicModal(true);
      }
    }
    catch(err){console.log(err);}
  };


  const ValidateServiceArea = async (pickGeoInfo, dropGeoInfo) => {
    let userValidation = false;
    try {
      if(pickGeoInfo && dropGeoInfo){
        let PickupLat = 0;
        let PickupLng = 0;

        let DropOffLat = 0;
        let DropOffLng = 0;
        if(pickGeoInfo){
          try {
            PickupLat = pickGeoInfo.split(",")[0];
            PickupLng = pickGeoInfo.split(",")[1];
          } catch (error) {}
        }
        if(dropGeoInfo){
          try {
            DropOffLat = dropGeoInfo.split(",")[0];
            DropOffLng = dropGeoInfo.split(",")[1];
          } catch (error) {
            
          }
        }
        if(PickupLat && PickupLng && DropOffLat && DropOffLng){
          const _lat = PickupLat;
          const _lng = PickupLng;
          const _droplat = DropOffLat;
          const _droplng =  DropOffLng;
         
          let IsValidArea = await IsServiceAreaValid(_lat, _lng, _droplat, _droplng);
         
          if(IsValidArea === false){
            userValidation = await showConfirmationModal("Selected address is out of service area? Do you want to continue adding it?", "Warning: Service Area");
            if(userValidation === false) 
            {
              setShowAPILoader(false);
            }
          }
          else{
            userValidation = IsValidArea;
          }
        
        }
      }
      return userValidation;
    } catch (error) {return userValidation;}
  }

  const handleClearVerifiedAddr = (index)=>{
    try{
      if(verifiedAddr[index].confirmationNo !== 0 && verifiedAddr[index].CCInfo.uniqueID === 0)
      {
        setModalHeaderText("Stop Order Clear Alert");
        setModalBodyHTML("Clear action for booked trip is restricted.");
        setModalFooterHTML(
          <>
            <Button variant='dark' className="border-0" onClick={()=>{setShowDynamicModal(false);}}>
              {"OK"}
            </Button>
          </>
        );
        setShowDynamicModal(true);
      }
      else
      {
        setModalHeaderText("Stop Order Clear Confirmation");
        setModalBodyHTML("Are you sure you would like to remove this trip?");
        setModalFooterHTML(
          <>
            <Button variant='dark' className="border-0" onClick={()=>{
                let indexToRemove = index;
                setVerifiedAddr((prevVerifiedAddr) =>
                  prevVerifiedAddr.filter((_, i) => i !== indexToRemove)
                );
                setShowDynamicModal(false);
              }}
            >
              {"Yes"}
            </Button>
            <Button variant='secondary' className="border-0" onClick={()=>setShowDynamicModal(false)}>
              {"No"}
            </Button>
          </>
          
        );
        setShowDynamicModal(true);
      }
    }
    catch(err){console.log(err);}
  };

  const handleEditEntireTrip = (index) =>{ //Function that populates full data for selected stop order trip as well as map markers for update before booking
    try{
      let data = verifiedAddr[index];

      setAddrApartmentInfo({pick: data.PUApartment, drop: data.DOApartment});

      let attrSelection = AttributeData ? AttributeData.filter((item,index)=> {return parseInt(item.iAttrATSPID) === parseInt(selectedAff) && parseInt(item.iAttrType) !== 10}) : [];
      let attrOptionsMultiSel = attrSelection && attrSelection.length > 0 ? attrSelection.map((item)=>{
        let dict = {};
        dict.id = item.ID;
        dict.name = item.Title;
        return dict;
      }).sort((a, b) => a.name.localeCompare(b.name)) : [];
      let providedAttrArray = data.tripAttribute;
      let groupSelected = [];
      let tripLatLng = [];
      let manualPrice = (parseFloat(data.manualAmount.price) > 0 ? data.manualAmount.price : data.billableAmount);
      let manualCost = (parseFloat(data.manualAmount.estimatedFare) > 0 ? data.manualAmount.estimatedFare : data.fare);
      let manualDistance = (parseFloat(data.manualAmount.estimatedDistance) > 0 ? data.manualAmount.estimatedDistance : data.distance);
      let fsData = (FundingSourceData[parseInt(selectedAff)] && 
        FundingSourceData[parseInt(selectedAff)] !== undefined ? 
        JSON.parse(FundingSourceData[parseInt(selectedAff)]) : []
      );
      let fsSelected = (fsData.length > 0 ? fsData.find(item => parseInt(item.FID) === parseInt(data.FundingSource)) : {});
      const [month, day, year] = data.date.split('/');
      let dateFormatted = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
      let callbackData = (data.callBackPhone && data.callBackPhone.includes("+1") ? data.callBackPhone : (data.callBackPhone && data.callBackPhone !== "" ? "+1"+data.callBackPhone : ""))
      for(let k = 0; k < attrOptionsMultiSel.length; k++)
      {
        if(providedAttrArray.includes(String(attrOptionsMultiSel[k].id)))
        {
          groupSelected.push({id:attrOptionsMultiSel[k].id, name:attrOptionsMultiSel[k].name});
        }
      }
      SetAttributesFilterMultiSelect({ ...AttributesFilterMultiSelect, ...{options: attrOptionsMultiSel,
        selectedValues:(data.tripAttribute.length !== 0 ? groupSelected : [])}}
      );
      setForcePassServiceHoursCheck(data.ForcePassServiceHours);
      setPickupAddr(data.pickAddr);
      setPickPOI(data.pickPOI);
      setDropAddr(data.dropAddr);
      setDropPOI(data.dropPOI);
      pickLatLng.current = data.pickLatLng;
      dropLatLng.current = data.dropLatLng;
      addressInfoDetails.current = data.addressExtraDetails;
      setFareZones({pick: data.fareZones.pick, drop: data.fareZones.drop});
      setDispatchZones({pickZone: data.dispatchZones.pickZone, dropZone: data.dispatchZones.dropZone});
      fareZonesRef.current = {pickFareZone: data.fareZones.pick, dropFareZone:data.fareZones.drop};
      fareMethodRef.current = data.fareMethod;
      setPickExtraInfo(data.puNotes);
      setDropExtraInfo(data.doNotes);
      setAppointmentTime((data.willCall ? "":data.apptTime));
      setSchTime((data.willCall ? "":data.time));
      setSelectedDateSchTime(dateFormatted);
      if(data.stops.length > 0)
      {
        setShowStopBlock(true);
        setShowStopsInput(false);
      }
      setClientStops(data.stops);
      setClientEmail(data.email);
      setPassengerTypeCount(data.passCount);
      
      if(isAffiliateHasMobilityAttributes === false){
        setMobilityPassengers({...mobilityPassengers,  passenger:data.passCount.ambPass, children: data.passCount.totalChildren});
      }
      else{
        if(transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2){
          let ambPassengerCount = data.passCount.total;
          let totalCount = data.passCount.total; // AMB + WC + Children
          let ambOnlyCount = data.passCount.ambPass;
          let wcOnlyCount = data.passCount.totalWC;
          let totalChildren = data.passCount.totalChildren;


          // let _totalWCCount;// = tripData.details[0].passengerInfo.totalWheelChairs;
          // if(transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2){
          //   _totalWCCount = 0;
          //   //ambPassengerCount = 0;
          //   if(data.passengerMobilityInfo.Guests.length >= 1){
          //     //ambPassengerCount = data.passengerMobilityInfo.Guests.length;// + 2; // (2) 1. Primary + 1. PCA
          //   }
          //   else{
          //     // if(data.passengerMobilityInfo.PCA.Attributes != "" && data.passengerMobilityInfo.PCA.Attributes != null && data.passengerMobilityInfo.PCA.Attributes != undefined){
          //     //   ambPassengerCount = 1;
          //     // }
          //     if(data.passengerMobilityInfo.Primary.Attributes != "" && 
          //     data.passengerMobilityInfo.Primary.Attributes != null && data.passengerMobilityInfo.Primary.Attributes != undefined){
          //       //ambPassengerCount += 1;
          //     }
          //   }
          // }
  

          const passengerMobilityInfoMapper = {
            passengerInfo: {
              primary: data.passengerMobilityInfo?.Primary,
              pca: data.passengerMobilityInfo?.PCA || [],
              guests: data.passengerMobilityInfo?.Guests || [],
              children: data.passengerMobilityInfo?.Children || []
            }
          }

          if(refMobilityAttributeOptions.current != undefined && refMobilityAttributeOptions.current != [] 
            && refMobilityAttributeOptions.current != null && refMobilityAttributeOptions.current?.length > 0){
  
            let Mobility_TotalAdultsCount = 0;
            let Mobility_TotalChildrenCount = 0;
  
            let PCACount = 0;
            let GuestsCount = 0;
            let ChildrenCount = 0;
  
            if(data.passengerMobilityInfo.Primary != undefined && data.passengerMobilityInfo.Primary?.selectedAttribute) {
              Mobility_TotalAdultsCount += 1;
            }
            if(data.passengerMobilityInfo?.PCA?.length >= 0){
              PCACount = data.passengerMobilityInfo?.PCA?.length;
              Mobility_TotalAdultsCount += PCACount;
            }
            if(data.passengerMobilityInfo?.Guests?.length >= 0){
              GuestsCount = data.passengerMobilityInfo?.Guests.length;
              Mobility_TotalAdultsCount += GuestsCount;
            }
            if(data.passengerMobilityInfo?.Children?.length >= 0){
              Mobility_TotalChildrenCount = data.passengerMobilityInfo?.Children.length;
            }

            setMobilityPassengers({...mobilityPassengers,  passenger:Mobility_TotalAdultsCount, children: Mobility_TotalChildrenCount});

            let wcCount = getMobilityAttributes(passengerMobilityInfoMapper);
            setPassengerTypeCount(
              {
                ambPass: Mobility_TotalAdultsCount,
                totalWC: parseInt(wcCount), 
                totalSA: parseInt(data.passCount.totalSA),
                total: parseInt(Mobility_TotalAdultsCount) + Mobility_TotalChildrenCount, 
                totalChildren: parseInt(Mobility_TotalChildrenCount)
            });
          }
          else{

            setMobilityPassengers({...mobilityPassengers,  passenger:ambOnlyCount, children: data.passengerMobilityInfo?.Children?.length});
            setPassengerTypeCount({ambPass: ambOnlyCount, totalWC: parseInt(wcOnlyCount), 
              totalSA: parseInt(data.passCount.totalSA), total:totalCount, totalChildren: parseInt(data.passengerMobilityInfo.Children?.length)
            });
          }

        
        
      
          
        }
      }
      
      

      


      setAccountNumber(data.id);
      
      setMedID(data.clientMedID);
      setCopayFSSelected(parseInt(data.copayFS));
      setCopayAmount(data.copay);
      setCopayPayTypeSelected(parseInt(data.copayPayType));
      setCardInfo(data.CCInfo);
      setSelectedVehType(data.vehType);
      setSelectedVehNum(data.vehNum);
      setSelectedDriverNum(data.driverNum);
      setSelectedGender(data.gender);
      setSelectedLanguage(data.language);
      setSelectedTripAttr(data.tripAttribute);
      setSelectedTripType(data.tripType);
      setClientJob(data.clientJob);
      setPaymentAdditionalInfo(data.paymentExtraInfo);
      setMobilityDetails({totalVeh:1, vehTypeMin:data.vehTypeMins, vehNumMin:data.vehMins, driverNumMin:data.driverMins, genderMin:data.genderMins, languageMin:data.languageMins});
      setMobilityChecks({vehTypeCheck:data.vehTypeCheck, vehNumCheck:data.vehNumCheck, driverNumCheck:data.driverNumCheck, genderCheck:data.genderCheck, languageCheck:data.languageCheck});
      setClientSummary(prevState=>({...prevState,
        tripDistance: data.distance, TripDuration:data.duration, TripFare:data.fare, TripCopay:data.copay
      }));
      setFareEstimateAPISummary(data.fareEstimateAPIData);
      
      setBrokerModes(data.broker);
      setFSSelected(parseInt(data.FundingSource));
      setAffiliateAbbr(fsSelected.AffiliateAbbrevation);
      handleManualAmountOnFSChange(fsSelected, parseInt(data.FundingSource), 'editTrip', {price: manualPrice, cost: manualCost, dist: manualDistance});
      setPaySelected(parseInt(data.PaymentSelected));
      setAgentNotes(data.notes);
      setRCType({phoneType:data.RC.phoneType, emailType:data.RC.emailType, SMSType:data.RC.SMSType});
      setRiderName(data.riderName);
      setWillCall(data.willCall);
      setStopTripCheckBox(data.isReturn);
      setAddLegBtnTitle("Update");
      setVerifiedInfoUpdateIndex(index);
      setCallBackPhone(callbackData);
      setAddrPhoneInfo({pick: data.addressPhoneInfo.pick, drop: data.addressPhoneInfo.drop});

      if(data.stops.length > 0)
      {
        let stopsInfo = data.stops;
        for(let k = 0; k < stopsInfo.length; k++)
        {
          let load = (stopsInfo[k].passLoadType === "load" ? "load" : (stopsInfo[k].passLoadType === "unload" ? "unload" : "none"));
          tripLatLng.push(
            {lat:parseFloat(stopsInfo[k].stopLatLng.split(",")[0]),
              lng: parseFloat(stopsInfo[k].stopLatLng.split(",")[1]), Type:"Stop", description: stopsInfo[k].notes,
              name:stopsInfo[k].passengerName, address: stopsInfo[k].stopAddr, stopType:load, id:(k)
            }
          );
        }
      }
      tripLatLng.push(
      {lat:parseFloat(data.dropLatLng.split(",")[0]),
        lng: parseFloat(data.dropLatLng.split(",")[1]), Type:"DO", 
        name:(data.riderName), address: data.dropAddr
      });
      tripLatLng.unshift(
        {lat:parseFloat(data.pickLatLng.split(",")[0]),
          lng: parseFloat(data.pickLatLng.split(",")[1]), Type:"PU", 
          name:(data.riderName), address: data.pickAddr
        },
      );
      if(data?.passengerMobilityInfo != undefined){
        setMobilityDbData(data.passengerMobilityInfo);
        setMobilitySavedData(data.passengerMobilityInfo);
      }
      setMapData(tripLatLng);
    }
    catch(err){console.log(err);}
  };

  const handleMoveClientStops = (index, location) =>{
    try{
      setClientStops((prevStops) => {
        const newStops = [...prevStops];
        if(location === "up")
        {
          if (index === 0){ return prevStops;} // No move if the element is already at the top
          else if(newStops[index - 1].passLoadType === "load" && newStops[index].passLoadType === "unload"){return prevStops;}
          [newStops[index - 1], newStops[index]] = [newStops[index], newStops[index - 1]]; // Swap elements
        }
        else
        {
          if(index === prevStops.length - 1){ return prevStops;}  // No move if the element is already at the bottom
          else if(newStops[index].passLoadType === "load" && newStops[index + 1].passLoadType === "unload"){return prevStops;}
          [newStops[index + 1], newStops[index]] = [newStops[index], newStops[index + 1]]; // Swap elements
        }
        let newStopsMapData = [];
        for(let k = 0; k < newStops.length; k++)
        {
          let load = newStops[k].passLoadType === "load" ? "load" : (newStops[k].passLoadType === "unload" ? "unload" : "none");
          newStopsMapData.push({lat:parseFloat(newStops[k].stopLatLng.split(",")[0]),
            lng: parseFloat(newStops[k].stopLatLng.split(",")[1]), Type:"Stop", description: newStops[k].notes,
            name:newStops[k].passengerName, address: newStops[k].stopAddr, stopType:load, id:(k)
          });
        }
        const updatedMapData = [
          ...mapData.slice(0,1),
          ...newStopsMapData,
          ...mapData.slice(-1)
        ];
        setMapData(updatedMapData);
        return newStops;
      });
    }
    catch(err){console.log(err);}
  };
  
  const handleMoveVerifiedAddr = (index, location)=>{
    try{
      setVerifiedAddr((prevVerifiedAddr) => {
        const newVerifiedAddr = [...prevVerifiedAddr];
        if(location === "up")
        {
          if (index === 0) return prevVerifiedAddr; // No move if the element is already at the top
          
          [newVerifiedAddr[index - 1], newVerifiedAddr[index]] = [newVerifiedAddr[index], newVerifiedAddr[index - 1]]; // Swap elements
        }
        else
        {
          if(index === prevVerifiedAddr.length - 1) return prevVerifiedAddr;  // No move if the element is already at the bottom
          [newVerifiedAddr[index + 1], newVerifiedAddr[index]] = [newVerifiedAddr[index], newVerifiedAddr[index + 1]]; // Swap elements
        }
        return newVerifiedAddr;
      });
    }
    catch(err){console.log(err);}
  };

  const handleChangeOnVehNumber = async (e) =>{
    try{

      setSelectedVehNum(e.target.value);
      let actualSelectedNum = e.target.value;
      const FamilyID = (AffiliateData.find((item) => {if(parseInt(item.AffiliateID) === parseInt(selectedAff)){return item}})).iPartnerAffiliateID;

      if(actualSelectedNum !== "VN")
      {
        let data = {
          "searchtext": actualSelectedNum.split("_")[1],
          "FamilyID": parseInt(FamilyID),
          "user_id": parseInt(loginData.iUserID)
        }
        xCancelSourceForGrid.current = APICom.GenerateSource();
        let response = await APICom.fetchData("main","GridData/GetDriverSearchGridData", "post", {}, data, xCancelSourceForGrid.current);
        if(response && response.error.length === 0)
        {
          if(response.data && response.data.length > 0)
          {
            const cleanedInput = JSON.parse(response.data.split("@$@@$@|*|")[1]);
            if(cleanedInput.length > 0)
            {
              let givenData = cleanedInput[0];
              let driverVal = (givenData.iDriverID && String(givenData.iDriverID) !== "-1" ? givenData.iDriverID + "_" + givenData["Driver#"] : "DN");
              setSelectedDriverNum(driverVal);
            }
          }
        }
      }
    }
    catch(err){console.log(err); setSelectedVehNum(e.target.value);}
  };

  const handleAddAllAddressTypestoArr = (modifiedArr = [], originArr = [], input = "") => {
    try{
      let sortedAddresses = [];
      if(modifiedArr.length > 0 && originArr.length > 0)
      {
        for(let k = 0; k < originArr.length; k++)
        {
          for(let j = 0; j < modifiedArr.length; j++)
          {
            if(originArr[k].Address === modifiedArr[j].Address)
            {
              if(typeof modifiedArr[j].AddressType === 'number' && parseInt(modifiedArr[j].AddressType) !== parseInt(originArr[k].AddressType)){
                modifiedArr[j].AddressType = [modifiedArr[j].AddressType];
              }
              if(Array.isArray(modifiedArr[j].AddressType) && !modifiedArr[j].AddressType.includes(parseInt(originArr[k].AddressType))){
                modifiedArr[j].AddressType.push(originArr[k].AddressType);
              }
            }
          }
        }
        let filteredAddresses = modifiedArr.length > 0 ? modifiedArr.filter(item => { 
          let formattedAddr = item.Address + ", " + item.City + ", " + item.State + " " + item.Zip + ", USA";
          return input.trim().length === 0 || formattedAddr.toLowerCase().includes(input.trim().toLowerCase());
        }) : [];
        sortedAddresses = filteredAddresses.sort((a, b) => {
          const aIsType2 = Array.isArray(a.AddressType) ? a.AddressType.includes(2) : a.AddressType === 2;
          const bIsType2 = Array.isArray(b.AddressType) ? b.AddressType.includes(2) : b.AddressType === 2;
          return bIsType2 - aIsType2;
        });

        if(sortedAddresses.length > 0)
        {
          sortedAddresses.unshift({
            Address: "",
            City: "",
            State: "",
            Zip: "",
            Lat: "",
            Long: "",
            AddressType: 0,
            isStatic: true, // Add a flag to differentiate this static entry
          });
        }
      }
      return sortedAddresses;
    }
    catch(err){console.log(err); return [];}
  };

  const handleAddressKeyDown = (e, highlightIndexSetter, optionRef, isStatic = false) => {
    try{
      if(e.key === 'ArrowDown')
      {
        e.preventDefault();
        if(optionRef.current.length > 0)
        {
          highlightIndexSetter((prevIndex) => {
            const newIndex = (prevIndex + 1) % optionRef.current.length;
            optionRef.current[newIndex]?.current.focus(); // Focus the newly highlighted element
            return newIndex;
          });
        }
      }
      else if (e.key === 'ArrowUp') {
        e.preventDefault();
        if(optionRef.current.length > 0)
        {
          highlightIndexSetter((prevIndex) => {
            const newIndex = (prevIndex - 1 + optionRef.current.length) % optionRef.current.length;
            optionRef.current[newIndex]?.current.focus(); // Focus the newly highlighted element
            return newIndex;
          });
        }
      }
    }
    catch(err){console.log(err);}
  };

  const handleGetSuggestionsList = (sortedAddrArr = [], trimmedInput = "", addressComponentRef = [], optionRef = [], focusedOptionRef = false, highlightIndexSetter = null, handleFunction = null, isRecent = "", type = "") => {
    try{
      let suggestionHTML = sortedAddrArr && sortedAddrArr.length > 0 ? sortedAddrArr.map((item, index) => {
        optionRef.current[index] = React.createRef();
        let formattedAddr = (type === "" ? item.Address+", "+item.City+", "+item.State+" "+item.Zip+", USA" : item.formatted_address);
        let detailedData = (type === "" ? item.City+","+item.State+","+item.Zip : "");
        let LatLng = (type === "" ? String(item.Lat)+","+String(item.Long) : "");
        const inputFilter = (trimmedInput.length > 0 && formattedAddr && formattedAddr.toLowerCase().includes(trimmedInput.toLowerCase()));
        const shouldShowAll = (trimmedInput === "" || isRecent === "");
        const isStatic = item.isStatic;
        const isRecentAddress = (isRecent !== "" ? {isrecentaddress:"true", recentaddressindex: index } : {index: index});
        
        if(isStatic)
        {
          return (
            <li ref={optionRef.current[index]} className="small border-bottom text-nowrap overflow-hidden addressSelectionRow"
              onFocus={() => { focusedOptionRef.current = true;}}
              style={{ cursor: "pointer" }} tabIndex={-1} onBlur={() => { focusedOptionRef.current = false; }}
              onKeyDown={(e)=>{if(e.key === 'ArrowDown')
                {
                  e.preventDefault();
                  if(optionRef.current.length > 0)
                  {
                    highlightIndexSetter((prevIndex) => {
                      const newIndex = (prevIndex + 1) % optionRef.current.length;
                      optionRef.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                      return newIndex;
                    });
                  }
                }
                else if (e.key === 'ArrowUp') {
                  e.preventDefault();
                  if(optionRef.current.length > 0)
                  {
                    highlightIndexSetter((prevIndex) => {
                      const newIndex = (prevIndex - 1 + optionRef.current.length) % optionRef.current.length;
                      optionRef.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                      return newIndex;
                    });
                  }
                }
              }} key={index} value={""}
            >
              <Icon icon="ph:info" className="text-info me-1" style={{ width: "20px", height: "20px" }} />
              {"Search POI by typing #POI Name"}
            </li>
          );
        }
        if(inputFilter || shouldShowAll){
          if(type === "AutoComplete")
          {
            let detailedDataAuto = {
              city: "",
              state: "",
              zip: ""
            };
            item.address_components.forEach((component)=>{
              if(component.types.includes("locality"))
              {
                detailedDataAuto.city = component.long_name;
              }
              if (component.types.includes("administrative_area_level_1")) {
                detailedDataAuto.state = component.short_name;
              }
              if (component.types.includes("postal_code")) {
                detailedDataAuto.zip = component.long_name;
              }
            });
            detailedData = detailedDataAuto.city+","+detailedDataAuto.state+","+detailedDataAuto.zip;
            LatLng = String(item.geometry.location.lat) +","+ String(item.geometry.location.lng);
          }
          if(shouldShowAll){
            try {
              let result = ParseGeoCodedData(item, "", index);
              addressComponentRef.current[index] = result;
            } catch (err) {console.log(err);}
          }
          else if(isRecent === "recent"){
            try {
              addressComponentRef.current[index] = item;
            } catch (err) {console.log(err);}
          }
          return(
            <li ref={optionRef.current[index]} {...isRecentAddress} className="small border-bottom text-nowrap overflow-hidden addressSelectionRow" 
              title={formattedAddr} onFocus={()=>{focusedOptionRef.current = true;}} style={{cursor:"pointer"}} tabIndex={-1} onBlur={()=>{focusedOptionRef.current = false;}} 
              onKeyDown={(e)=>{
                if(e.key === 'ArrowDown')
                {
                  e.preventDefault();

                  if(optionRef.current.length > 0)
                  {
                    highlightIndexSetter((prevIndex) => {
                      const newIndex = (prevIndex + 1) % optionRef.current.length;
                      optionRef.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                      return newIndex;
                    });
                  }
                }
                else if (e.key === 'ArrowUp') {
                  e.preventDefault();
                  if(optionRef.current.length > 0)
                  {
                    highlightIndexSetter((prevIndex) => {
                      const newIndex = (prevIndex - 1 + optionRef.current.length) % optionRef.current.length;
                      optionRef.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                      return newIndex;
                    });
                  }
                }
                else if(e.key === "Enter")
                {
                  handleFunction(e);
                }
              }} onClick={handleFunction} key={index} value={formattedAddr} data-name={detailedData} data-virtual={LatLng}
            >
              {type !== "AutoComplete" && ( 
                Array.isArray(item.AddressType) ? (
                  <>
                    <Icon icon="bx:heart" className="text-danger me-1" style={{width:"20px", height:"20px"}}/> 
                    <Icon icon="bx:history" className="text-secondary me-1" style={{width:"20px", height:"20px"}}/>
                  </> 
                )  
                : 
                ( item.AddressType === 2 ? 
                  <Icon icon="bx:heart" className="text-danger me-1" style={{width:"20px", height:"20px"}}/> 
                  : 
                  <Icon icon="bx:history" className="text-secondary me-1" style={{width:"20px", height:"20px"}}/>
                )
              )}
              {formattedAddr}
            </li>
          );
        }

      }) : "";
      return suggestionHTML;
    }
    catch(err){console.log(err); return "";}
  };

  const handleOSRMAutoComplete = async (input) => {
    try{
      let myHeaders = new Headers();
        myHeaders.append("Authorization", 'Basic '+btoa(OSRM_Username.current + ":" + OSRM_Password.current));
        myHeaders.append('Content-Type', 'application/json');
      let headersObj = headersToObject(myHeaders);
      let mapBounds = (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "OSRMRectangleBounds")).value.replace(" ", ""); //"&bounds="+mapBounds+
      let addressAPI = ITCMapURL.current + encodeURIComponent(input) + "&bounds="+mapBounds+ "&AppType=Web_Reservation";
      let OSRMResponse = await APICom.fetchData("full", addressAPI, "get", headersObj, {});
      return OSRMResponse;
    }
    catch(err){console.log(err); return null;}
  };


  const isValidAddressString = (str) => {
    if (!str || typeof str !== "string") return false;
    const cleaned = str.trim().replace(/,+/g, ",").replace(/^\s*,+|,+\s*$/g, "");
    return cleaned.length > 0 && /[a-zA-Z0-9]/.test(cleaned);
  };

  const handlePUAddrChanged = async(e)=>{
    try{
      let input = e.target.value || "";
      if(isValidAddressString(input) && input.trim() === pickupAddr && pickLatLng.current !== ""){return;} //check for no change in input
      setFareZones(prevState=>({...prevState, pick: ""}));
      fareZonesRef.current.pickFareZone = "";
      setDispatchZones(prevState=>({...prevState, pickZone: ""}));
      if(input === ""){
        setIsSchTimeFieldDisabled(true);
      }
      if(bookBtnRef.current)
      {
        bookBtnRef.current.disabled = true;
      }
      if(input.trim() === ""){handleClearAddr("PU");}
      setPickupAddr(input);
      setZones("");
      vsSelectedRef.current = vsSelectedRef.current.filter(item => item !== "PU");
      setClientSummary(prevState=>({...prevState, 
        tripDistance: 0, TripDuration:0, TripFare:0.0, TripCopay:0.0
      }));
      setWalkDistance({...walkDistance, DOWalk:0, PUWalk:0, PUDuration:0, DODuration:0});
      pickLatLng.current = "";
      liRefs.current = [];
      let poiSuggestionAddrHTML = null;
      let hashIndex = input.indexOf("#");

      if(hashIndex !== -1)
      {
        //run POISuggestion
        handleClearAddr("PU");
        input = input.slice(hashIndex);
        setPickupAddr(input);
        input = input.replaceAll("#","");
          let trimmedInput = input.trim();
          let lastInput = trimmedInput;
          let elapsedTime = 0;
          let timeInterval = 300;
          if(puPOITimerIntervalRef.current){clearInterval(puPOITimerIntervalRef.current);}
          if(trimmedInput !== "")
          {
            puPOITimerIntervalRef.current = setInterval(async () => {
              try{
                if(lastInput === pickupAddr.trim())
                {
                  //No change occured
                  elapsedTime += 100;
                }
                else
                {
                  //A change occured, reset timer
                  lastInput = pickupAddr.trim();
                  elapsedTime = 0;
                }
                if(elapsedTime >= timeInterval)
                {
                  clearInterval(puPOITimerIntervalRef.current);
                  if(lastInput.length >= 3)
                  {
                    let data = {
                      "affiliateID": parseInt(selectedAff),
                      "poi": input.replaceAll("#",""),
                    }
                    xCancelSourceForGrid.current = APICom.GenerateSource();
                    let response = await APICom.fetchData("ReservationCoreURL","api/ParatransitCT/GetPOISuggestion", "post", 
                      {'Content-Type': 'application/json',
                      'Access-Control-Allow-Origin': '*',
                      'Access-Control-Allow-Headers': '*',
                      'mode': 'no-cors'}, data, xCancelSourceForGrid.current
                    );
          
                    if(response.error.length === 0 && (Array.isArray(response.data) && response.data.length > 0))
                    {
                      let SuggestedAddrArray = response.data;
                      let filteredPOISuggestion = SuggestedAddrArray.filter(item=>{
                        let formattedAddr = item.POI;
                        return formattedAddr.toLowerCase().includes(input.trim().toLowerCase());
                      });
                      focusedSuggestionCheckPU.current = false;
                      poiSuggestionAddrHTML = filteredPOISuggestion ? filteredPOISuggestion.map(function(item, index){
                        let detailedData = item.City+","+item.Region+","+item.ZipCode;
                        let formattedAddr = item.POI;
                        let fullAddr = (item.Street + (item.City && item.City !== ""? ", "+item.City +", "+ (item.Region && item.Region !== "" ? item.Region +" "+ item.ZipCode: ""): "") );
                        let LatLng = String(item.vPOILatitude)+","+String(item.vPOILongitude);
                        let poiApartment = item.Apartment
                        liRefs.current[index] = React.createRef();
                        return(
                          <li ref={liRefs.current[index]} poisuggestion={"true"} className="small border-bottom text-nowrap overflow-hidden addressSelectionRow" 
                            title={fullAddr} onFocus={()=>{focusedSuggestionCheckPU.current = true;}} poiAprt={poiApartment}
                            style={{cursor:"pointer"}} tabIndex={-1} onBlur={()=>{focusedSuggestionCheckPU.current = false;}} onKeyDown={(e)=>{
                              if(e.key === 'ArrowDown')
                              {
                                e.preventDefault();
          
                                if(liRefs.current.length > 0)
                                {
                                  setHighlightedIndex((prevIndex) => {
                                    const newIndex = (prevIndex + 1) % liRefs.current.length;
                                    liRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                                    return newIndex;
                                  });
                                }
                              }
                              else if (e.key === 'ArrowUp') {
                                e.preventDefault();
                                if(liRefs.current.length > 0)
                                {
                                  setHighlightedIndex((prevIndex) => {
                                    const newIndex = (prevIndex - 1 + liRefs.current.length) % liRefs.current.length;
                                    liRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                                    return newIndex;
                                  });
                                }
                              }
                              else if(e.key === "Enter")
                              {
                                handlePUSuggestionClicked(e);
                              }
                            }}
                            onClick={handlePUSuggestionClicked} key={index} value={formattedAddr} data-name={detailedData} data-virtual={LatLng}
                          >
                            {item.icon && item.icon !== ""? <Icon icon={item.icon} className="text-success me-1" style={{width:"20px", height:"20px"}}/> :
                              <Icon icon={"gis:search-poi"} className="text-success me-1" style={{width:"20px", height:"20px"}}/>
                            }
                            {formattedAddr}
                          </li>
                        );
                      }) : "";
                      setInputSuggestionListPU(poiSuggestionAddrHTML);
                    }
                  }
                }
              } catch(err){console.log(err);}
            }, timeInterval);
          }
      }
      else
      {
        setPickupAddr(input);
      }
      
      let suggestionsRecentArr = [];
      for(let entry of recentAddresses)
      {
        if(entry.PUAddress)
        {
          suggestionsRecentArr.push({
            Address: entry.PUAddress,
            City: entry.PUCity,
            Lat: entry.PULat,
            Long: entry.PULong,
            State: entry.PUState,
            Zip: entry.PUZip,
            AddressType: entry.AddressType,
              Apartment: entry.PUApartment
          });
        }
        if(entry.DOAddress)
        {
          suggestionsRecentArr.push({
            Address: entry.DOAddress,
            City: entry.DOCity,
            Lat: entry.DOLat,
            Long: entry.DOLong,
            State: entry.DOState,
            Zip: entry.DOZip,
            AddressType: entry.AddressType,
              Apartment: entry.DOApartment
          });
        }
      }
      
      let uniqueRecentAddresses = handleDuplicates(suggestionsRecentArr, "Address");
            uniqueRecentAddresses = updateApartment(uniqueRecentAddresses, suggestionsRecentArr);

      const sortedAddresses = handleAddAllAddressTypestoArr(uniqueRecentAddresses, suggestionsRecentArr, input.trim());
      let recentAddrHTML2_0 = handleGetSuggestionsList(sortedAddresses, input.trim(), liRefRecentPickupAddressComponent, liRefs, focusedSuggestionCheckPU, setHighlightedIndex, handlePUSuggestionClicked, "recent");

        let trimmedInput = input.trim();
        let lastInput = trimmedInput;
        let elapsedTime = 0;
        let timeInterval = 400;
        if(puTimerIntervalRef.current){clearInterval(puTimerIntervalRef.current);}
        if(trimmedInput !== "" && hashIndex === -1)
        {
          puTimerIntervalRef.current = setInterval(async () => {
            try{
              if(lastInput === pickupAddr.trim())
              {
                //No change occured
                elapsedTime += 100;
              }
              else
              {
                //A change occured, reset timer
                if(pickupAddr.trim() === ""){elapsedTime = timeInterval;}
                else{
                  lastInput = pickupAddr.trim();
                  elapsedTime = 0;
                }
                
              }
              if(elapsedTime >= timeInterval)
              {
                clearInterval(puTimerIntervalRef.current);
                if(lastInput.length > 8)
                {
                  let OSRMResponse = await handleOSRMAutoComplete(input.trim());
                  let SuggestedAddrArray = [];

                  if(OSRMResponse && OSRMResponse.data.status.toUpperCase() === "OK")
                  {
                    SuggestedAddrArray = OSRMResponse.data.results.map(function(item)
                    {
                      return item;
                    });

                    liRefs.current = [];
                    liRefPickupAddressComponent.current = [];
                    focusedSuggestionCheckPU.current = false;
                    if(SuggestedAddrArray.length > 0)
                    {
                      SuggestedAddrArray.unshift({
                        Address: "",
                        City: "",
                        State: "",
                        Zip: "",
                        Lat: "",
                        Long: "",
                        AddressType: 0,
                        isStatic: true, // Add a flag to differentiate this static entry
                      });
                    }

                    let suggestionsHTML2_0 = handleGetSuggestionsList(SuggestedAddrArray, input.trim(), liRefPickupAddressComponent, liRefs, focusedSuggestionCheckPU, setHighlightedIndex, handlePUSuggestionClicked, "", "AutoComplete");

                    if(suggestionsHTML2_0 !== "" && e.target.value !== "")
                    {
                      setInputSuggestionListDO("");
                      setInputSuggestionListPU(suggestionsHTML2_0);
                    }
                    else if(recentAddrHTML2_0.length > 0)
                    {
                      setInputSuggestionListDO("");
                      setInputSuggestionListPU(recentAddrHTML2_0);
                    }
                  }        
                }
              }
            }
            catch(err){console.log(err);}
          }, timeInterval);
        }
        
      if(input.trim().length === 0)
      {
        if(recentAddrHTML2_0.length > 0)
        {
          setInputSuggestionListPU(recentAddrHTML2_0);
        }
        else
        {
          setInputSuggestionListPU("");
        }
      }
      else
      {
        if(hashIndex !== -1 && poiSuggestionAddrHTML !== "")
        {
          setInputSuggestionListPU(poiSuggestionAddrHTML);
        }
        else if(recentAddrHTML2_0.length > 0)
        {
          setInputSuggestionListPU(recentAddrHTML2_0);
        }
        else
        {
          setInputSuggestionListPU("");
        }
      }
    }
    catch(err){console.log(err);}
  };
  const handlePUSuggestionClicked = async (e)=>{
    try{
      let correctDate = formatDate(selectedDateSchTime);
      let PULatLng = e.target.dataset.virtual;
      if(PULatLng.split(",")[0] !== "0" && PULatLng.split(",")[0] !== "")
      {
        let selectedIndex = e.target.getAttribute('index');
        let poiSelected = e.target.getAttribute('poisuggestion')
        let selectedIndexAddressComponent = "";
        let indexType = "";
        if(selectedIndex !== undefined && selectedIndex)
        {
          selectedIndex = parseInt(selectedIndex);
          if(selectedIndex >= 0 && liRefPickupAddressComponent !== undefined)
          {
            indexType = "manual";
            selectedIndexAddressComponent = liRefPickupAddressComponent?.current[selectedIndex];
            mapPointPickupSelection.current = selectedIndexAddressComponent;
          }
        }
        else if(poiSelected)
        {
          indexType = "poi";
          mapPointPickupSelection.current = {data: {address: e.target.title, POI: e.target.textContent}};
            setAddrApartmentInfo(prev => ({
                ...prev,
                ['pick']: e.target.getAttribute("poiAprt") ?? ''
            }));
        }
        else 
        {
          let _IsRecentAddressSelected = e.target.getAttribute('isrecentaddress');
          let selectedIndexRecentAddressComponent = "";
          if(_IsRecentAddressSelected !== undefined && _IsRecentAddressSelected){
            let recentaddressindex = e.target.getAttribute('recentaddressindex');
            if(recentaddressindex !== undefined && recentaddressindex){
              recentaddressindex = parseInt(recentaddressindex);
              if(recentaddressindex >= 0 && liRefRecentPickupAddressComponent !== undefined){
                indexType = "recent";
                selectedIndexRecentAddressComponent = liRefRecentPickupAddressComponent?.current[recentaddressindex];
                setAddrApartmentInfo(prev => ({
                    ...prev,
                    ['pick']: selectedIndexRecentAddressComponent?.data?.Apartment ?? ''
                }));
                mapPointPickupSelection.current = selectedIndexRecentAddressComponent;
              }
            }
          }
        }
        let selectedAddressContext = (poiSelected ? e.target.title : e.target.textContent);
        let addressDetails = e.target.getAttribute('data-name');
        setPickupAddr(selectedAddressContext);
        setPickPOI((poiSelected? e.target.textContent : ""));
        addressInfoDetails.current.pick = {state:addressDetails.split(",")[1], city: addressDetails.split(",")[0], zip: addressDetails.split(",")[2]};
        mapPointPickupSelection.current["Type"] = indexType;
        pickLatLng.current = e.target.dataset.virtual;
        if(fareMethodRef.current === 1)
        {
          setShowAPILoader(true);
          await getFareZone(FSSelected, selectedAff, COSSelected, pickLatLng.current, "pick");
        }
        if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2))
        {
          await getDispatchZone(selectedAff, pickLatLng.current, "pick");
          
        }
        setShowAPILoader(false);
        if(addLegBtnRef.current){
          addLegBtnRef.current.disabled = false;
        }
        let stopMarkersArr = [{lat:parseFloat(pickLatLng.current.split(",")[0]),
          lng: parseFloat(pickLatLng.current.split(",")[1]), Type:"PU", 
          name:(riderName === "" ? "N/A" : riderName.trim()), address: selectedAddressContext
        }];
        let filteredMapMarkers = mapData.filter((item)=>{
          if(item.Type === "Stop")
          {
            stopMarkersArr.push(item);
          }
          return item.Type === "DO";
        });
        filteredMapMarkers.unshift(...stopMarkersArr);

        setMapData(filteredMapMarkers);
        setInputSuggestionListPU("");
        if(dropLatLng.current !== "")
        {
          setIsSchTimeFieldDisabled(false);
          if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2))
          {
            wrapperHandleRCZVerification("PU", selectedAddressContext);
          }
          else
          {
            wrapperHandleAddressDetails("PU", selectedAddressContext, selectedAddressContext, dropAddr, correctDate, schTime);
          }
        }
      }
      else
      {
        if(e.target.getAttribute('poisuggestion'))
        {
          let OSRMResponse = await handleOSRMAutoComplete(e.target.title);
          if(OSRMResponse && OSRMResponse.data.status.toUpperCase() === "OK")
          {
            let addressFound = OSRMResponse.data.results[0];
            let selectedAddressContext = addressFound.formatted_address;
            let addressDetails = e.target.getAttribute('data-name');
            setPickupAddr(selectedAddressContext);
            setPickPOI(e.target.textContent);
            mapPointPickupSelection.current = {data: {address: e.target.title, POI: e.target.textContent}};
            addressInfoDetails.current.pick = {state:addressDetails.split(",")[1], city: addressDetails.split(",")[0], zip: addressDetails.split(",")[2]};
            mapPointPickupSelection.current["Type"] = "poi";
            pickLatLng.current = addressFound.geometry.location.lat+","+addressFound.geometry.location.lng;
            if(fareMethodRef.current === 1)
            {
              setShowAPILoader(true);
              await getFareZone(FSSelected, selectedAff, COSSelected, pickLatLng.current, "pick");
            }
            if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2))
            {
              await getDispatchZone(selectedAff, pickLatLng.current, "pick");
            }
            if(addLegBtnRef.current){
              addLegBtnRef.current.disabled = false;
            }
            setShowAPILoader(false);
            let stopMarkersArr = [{lat:parseFloat(pickLatLng.current.split(",")[0]),
              lng: parseFloat(pickLatLng.current.split(",")[1]), Type:"PU", 
              name:(riderName === "" ? "N/A" : riderName.trim()), address: selectedAddressContext
            }];
            let filteredMapMarkers = mapData.filter((item)=>{
              if(item.Type === "Stop")
              {
                stopMarkersArr.push(item);
              }
              return item.Type === "DO";
            });
            filteredMapMarkers.unshift(...stopMarkersArr);

            setMapData(filteredMapMarkers);
            setInputSuggestionListPU("");
            if(dropLatLng.current !== "")
            {
              setIsSchTimeFieldDisabled(false);
              if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2))
              {
                wrapperHandleRCZVerification("PU", selectedAddressContext);
              }
              else
              {
                wrapperHandleAddressDetails("PU", selectedAddressContext, selectedAddressContext, dropAddr, correctDate, schTime);
              }
            }
          }
        }
      }
    }
    catch(er){console.log(er);}
  };

  const handleCorrectPhoneFormatDisplay = (e) =>{
    try{
      let input = (e.target.value.length === 0 ? "1":e.target.value);
      if(input.length === 1)
      {
        setCallBackActual(input);
      }
      else if(input.length === 3)
      {
        setCallBackActual("("+input+") ");
      }
      else if(input.length === 9)
      {
        let areaCode = input.replace(/[() ]/g, '').substring(0,3);
        let secondSection = input.replace(/[() ]/g, '').substring(3,6);
        setCallBackActual("("+areaCode+") "+secondSection+"-");
      }
    }
    catch(err){console.log(err);}
  };

  const handleDuplicates = (dict, title) =>
  {
    try{
      // Declare a new array
      let newArray = [];
                  
      // Declare an empty object
      let uniqueObject = {};

      for(var j in dict)
      {
        // Extract the title
        let objTitle = dict[j][title];
        
        // Use the title as the index
        uniqueObject[objTitle] = dict[j];
      }
      
      // Loop to push unique object into array
      for (var u in uniqueObject) {
        newArray.push(uniqueObject[u]);
      }

      // Display the unique objects
      return newArray;
    }
    catch(err){console.log(err);}
  };

  const handleFinishAddingStops = (e)=> {
    try{
      if(pickLatLng.current !== "" && dropLatLng.current !== "")
      {
        if(clientStops.length > 0)
        {
          if(stopLatLng.current !== "")
          {
            handleAddTripStops();
            if(!addStopErrorFlag.current)
            {
              setShowStopsInput(false);
            }
          }
          else
          {
            setShowStopsInput(false);
            
          }
        }
        else
        {
          if(stopLatLng.current !== "")
          {
            handleAddTripStops();
            if(!addStopErrorFlag.current)
            {
              setShowStopsInput(false);
            }
          }
          else
          {
            setShowStopBlock(false);
          }
        }
        if(!addStopErrorFlag.current)
        {
          setStopEditInfo({data:{}, index:0});
          setStopSaveBtnTitle("Save");
          setStopAddr("");
          setStopLoadRiderName("");
          setStopUnloadRiderName("RN");
          setStopLoadType({none:true, load:false, unload:false});
          setPassengerTypeCountStop({ambPass:1,totalWC:0,totalSA:0, total:1});
          stopLatLng.current = "";
          setStopAddrExtra("");
          setStopWaitTimeInput(0);
        }
        
      }
      else
      {
        setModalHeaderText("Add Stop Error");
        setModalBodyHTML("Please add pickup & drop-off addresses before adding a stop.");
        setModalFooterHTML(
          <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
            OK
          </Button>
        );
        setShowDynamicModal(true);
      }
    }
    catch(err){console.log(err);}
  };

  const handleCloseStops = (e)=>{
    try{
      if(clientStops.length > 0)
      {
        setShowStopsInput(false);
      }
      else
      {
        setShowStopBlock(false);
      }
      setStopEditInfo({data:{}, index:0});
      setStopSaveBtnTitle("Save");
      setStopLoadType({none:true, load:false, unload:false});
      setPassengerTypeCountStop({ambPass:1,totalWC:0,totalSA:0, total:1});
      setStopLoadRiderName("");
      setStopUnloadRiderName("RN");
      setStopAddr("");
      stopLatLng.current = "";
      setStopAddrExtra("");
      setStopWaitTimeInput(0);
    }
    catch(err){console.log(err);}
  };

  const handleAddTripStops = (e)=>{
    try{
      let totalCheck = Object.keys(stopEditInfo.data).length > 0 ? 
        ((stopPassengerLoadTrackerRef.current + parseInt(stopEditInfo.data.stopPax.total)) - passengerTypeCountStop.total):
        (stopPassengerLoadTrackerRef.current - passengerTypeCountStop.total);
      addStopErrorFlag.current = false;
      let unloadPassengerName = "";
      if(!(stopLoadType.none) || (stopLoadType.none && stopWaitTimeInput !== 0))
      {
        if(pickLatLng.current !== "" && dropLatLng.current !== "")
        {
          if(stopLoadType.unload && clientStops.length === 0 && parseInt(passengerTypeCount.total) === 1)
          {
            setModalHeaderText("Add Stop Error");
            setModalBodyHTML("Please add a load type trip before unload.");
            setModalFooterHTML(
              <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                OK
              </Button>
            );
            setShowDynamicModal(true);
            addStopErrorFlag.current = true;
          }
          //(parseInt(clientStops[(clientStops.length - 1)].stopPax.total) < parseInt(passengerTypeCountStop.total) [below line temporarily commented for future update]
          // else if(stopLoadType.unload && clientStops.length > 0 && totalCheck < 0)
          // {
          //   setModalHeaderText("Add Stop Error");
          //   setModalBodyHTML("Please provide either the same or fewer number of passengers for unload.");
          //   setModalFooterHTML(
          //     <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
          //       OK
          //     </Button>
          //   );
          //   setShowDynamicModal(true);
          //   addStopErrorFlag.current = true;
          // }
          else
          {
            const unloadNames = clientStops.filter(item => item.passLoadType === 'unload').map(item => item.passengerName);
            if(stopLoadType.load && stopLoadRiderName.trim() === "")
            {
              setModalHeaderText("Add Stop Error");
              setModalBodyHTML("Please enter a name before adding the stop.");
              setModalFooterHTML(
                <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                  OK
                </Button>
              );
              setShowDynamicModal(true);
              addStopErrorFlag.current = true;
            }
            else if(stopLoadType.unload && stopUnloadRiderName === "RN" && clientStops.length !== 0)
            {
              setModalHeaderText("Add Stop Error");
              setModalBodyHTML("Please select a name before adding the stop.");
              setModalFooterHTML(
                <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                  OK
                </Button>
              );
              setShowDynamicModal(true);
              addStopErrorFlag.current = true;
            }
            else if(stopLoadType.unload && stopUnloadRiderName === "RN" && clientStops.length === 0 && riderName === "")
            {
              setModalHeaderText("Add Stop Error");
              setModalBodyHTML("Please enter a name for the rider before adding unload.");
              setModalFooterHTML(
                <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                  OK
                </Button>
              );
              setShowDynamicModal(true);
              addStopErrorFlag.current = true;
            }
            else if(stopLoadType.unload && unloadNames.includes(stopUnloadRiderName))
            {
              setModalHeaderText("Add Stop Error");
              setModalBodyHTML(stopUnloadRiderName+ " is already selected, please select a different name.");
              setModalFooterHTML(
                <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                  OK
                </Button>
              );
              setShowDynamicModal(true);
              addStopErrorFlag.current = true;
            }
            else
            {
              if(stopLatLng.current !== "")
              {
                if(Object.keys(stopEditInfo.data).length > 0)
                {
                  let loadType = "";
                  let indexCheck = -1;
                  if(stopLoadType.load){
                    loadType = "load"; 
                    indexCheck = clientStops.findIndex((item)=>(item.passLoadType === 'unload' && item.passengerName === stopEditInfo.data.passengerName));

                    if(parseInt(clientStops[stopEditInfo.index].stopPax.total) > parseInt(passengerTypeCountStop.total))
                    {
                      stopPassengerLoadTrackerRef.current = stopPassengerLoadTrackerRef.current - Math.abs(passengerTypeCountStop.total - parseInt(clientStops[stopEditInfo.index].stopPax.total));
                    }
                    else
                    {
                      stopPassengerLoadTrackerRef.current = stopPassengerLoadTrackerRef.current + Math.abs(passengerTypeCountStop.total - parseInt(clientStops[stopEditInfo.index].stopPax.total));
                    }
                  }
                  else if(stopLoadType.unload){
                    loadType = "unload"; 
                    if(parseInt(clientStops[stopEditInfo.index].stopPax.total) > parseInt(passengerTypeCountStop.total))
                    {
                      stopPassengerLoadTrackerRef.current = stopPassengerLoadTrackerRef.current + Math.abs(passengerTypeCountStop.total - parseInt(clientStops[stopEditInfo.index].stopPax.total));
                    }
                    else
                    {
                      stopPassengerLoadTrackerRef.current = stopPassengerLoadTrackerRef.current - Math.abs(passengerTypeCountStop.total - parseInt(clientStops[stopEditInfo.index].stopPax.total));
                    }
                  }
                  else if(stopLoadType.none){loadType = "none";}
                  const updatedData = clientStops.map((item, i) => (i === stopEditInfo.index ? {stopAddr: stopAddr, 
                    stopLatLng: stopLatLng.current, waitTime: stopWaitTimeInput, notes: stopAddrExtra, 
                    passLoadType:loadType, stopPax: passengerTypeCountStop, 
                    passengerName: (stopLoadType.load? stopLoadRiderName: (stopLoadType.unload? stopUnloadRiderName: ""))} : 
                    (indexCheck !== -1 ? (i === (indexCheck) ? {...item, passengerName:stopLoadRiderName} : item) : item) 
                  )
                  );
                  setClientStops(updatedData);
                  setShowStopsInput(false);
                  
                  setStopSaveBtnTitle("Save");
                  setStopEditInfo({data:{}, index:0});
                }
                else
                {
                  if(stopLoadType.unload && stopUnloadRiderName === "RN" && clientStops.length === 0)
                  {
                    unloadPassengerName = riderName;
                  }

                  let clientStopsArr = [];
                  setClientStops((prevStops) => {
                    
                    let loadType = "";
                    if(stopLoadType.load){loadType = "load"; stopPassengerLoadTrackerRef.current = stopPassengerLoadTrackerRef.current + passengerTypeCountStop.total;}
                    else if(stopLoadType.unload){loadType = "unload"; stopPassengerLoadTrackerRef.current = stopPassengerLoadTrackerRef.current - passengerTypeCountStop.total;}
                    else if(stopLoadType.none){loadType = "none";}
                    clientStopsArr = [...prevStops, 
                      {stopAddr: stopAddr, stopLatLng: stopLatLng.current, 
                        waitTime: stopWaitTimeInput, notes: stopAddrExtra, passLoadType:loadType,
                        stopPax: passengerTypeCountStop, passengerName: (stopLoadType.load? stopLoadRiderName: (stopLoadType.unload? (unloadPassengerName !== ""? unloadPassengerName:stopUnloadRiderName): "")), 
                      }
                    ];
                    return [...prevStops, 
                      {stopAddr: stopAddr, stopLatLng: stopLatLng.current, 
                        waitTime: stopWaitTimeInput, notes: stopAddrExtra, passLoadType:loadType,
                        stopPax: passengerTypeCountStop, passengerName: (stopLoadType.load? stopLoadRiderName: (stopLoadType.unload? (unloadPassengerName !== ""? unloadPassengerName:stopUnloadRiderName): "")), 
                      }
                    ];
                  });
                  let load = stopLoadType.load ? "load" : (stopLoadType.unload ? "unload" : "none");
                  let clientName = stopLoadType.load ? stopLoadRiderName : (stopLoadType.unload ? stopUnloadRiderName:riderName);
                  let newStop = {lat:parseFloat(stopLatLng.current.split(",")[0]),
                    lng: parseFloat(stopLatLng.current.split(",")[1]), Type:"Stop", description: stopAddrExtra,
                    name:(clientName.trim() === "" ? "N/A":clientName), address: stopAddr, stopType:load, id:(clientStopsArr.length - 1)
                  };
                  
                  const updatedMapData = [
                    ...mapData.slice(0,-1),
                    newStop,
                    ...mapData.slice(-1)
                  ];

                  setMapData(updatedMapData);
                }

                setStopAddr("");
                setStopLoadRiderName("");
                setStopUnloadRiderName("RN");
                stopLatLng.current = "";
                setStopAddrExtra("");
                setStopWaitTimeInput(0);
                setStopLoadType({none:true, load:false, unload:false});
                setPassengerTypeCountStop({ambPass:1,totalWC:0,totalSA:0, total:1});
              }
              else
              {
                setModalHeaderText("Add Stop Error");
                setModalBodyHTML("Please select a suggested address before adding the stop.");
                setModalFooterHTML(
                  <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                    OK
                  </Button>
                );
                setShowDynamicModal(true);
                addStopErrorFlag.current = true;
              }
            }
          }
        }
        else
        {
          setModalHeaderText("Add Stop Error");
          setModalBodyHTML("Please add pickup & drop-off addresses before adding a stop.");
          setModalFooterHTML(
            <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
              OK
            </Button>
          );
          setShowDynamicModal(true);
          addStopErrorFlag.current = true;
        }
      }
      else
      {
        setModalHeaderText("Add Stop Error");
        setModalBodyHTML("Please add a wait time for the stop.");
        setModalFooterHTML(
          <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
            OK
          </Button>
        );
        setShowDynamicModal(true);
        addStopErrorFlag.current = true;
      }
      
    }
    catch(err){console.log(err);}
  };

  const handleAccountNumberChange = (e) => { //Checks to make sure the input is a number and correctly entered (Client ID)
    try{
      const regex = /^([0-9]+)?$/;
      let flag = false;
      if(e.target.value.length > 0 && e.target.value > 0)
      {
        let tempVal = e.target.value;
        if(tempVal[0] === "0")
        {
          e.target.value = tempVal[1];
        }
      }
      if(!regex.test(e.target.value)){flag = true;}
      if(!flag)
      {
        setAccountNumber(e.target.value);
      }
    }
    catch(err){console.log(err);}
  };

  const handleUndoManualChange = (e, type = "") => {
    try{
      if(type === 'price')
      {
        if(parseFloat(manualDataOverwrite.price) > 0)
        {
          const queryParams = new URLSearchParams(window.location.search);
          const tripSelected = queryParams.get('TripSelected') || activeTripSelected? true:false;
          let editRowData = (PersistStorage.retrieve("rowDataEditTrip", true)  && tripSelected? PersistStorage.retrieve("rowDataEditTrip", true):"");
          if(editRowData && editRowData !== "" && paratransitBookBtnRef.current.textContent.toLowerCase().includes("update"))
          {
            if(addLegBtnRef.current.textContent.toLowerCase().includes("update") && editRowData.addressInfo.trips[verifiedInfoUpdateIndex])
            {
              let estimatedData = (verifiedAddr.length > 0 && parseFloat(verifiedAddr[verifiedInfoUpdateIndex].manualAmount.price) > 0 ? parseFloat(verifiedAddr[verifiedInfoUpdateIndex].manualAmount.price) : parseFloat(editRowData.addressInfo.trips[verifiedInfoUpdateIndex].details[0].estimatedInfo.billableAmount));
              setManualDataOverwrite(prevState => ({...prevState, price: estimatedData}));
            }
            else
            {
              if(!editRowData.addressInfo.trips[verifiedInfoUpdateIndex] && verifiedAddr.length > 0 && parseFloat(verifiedAddr[verifiedInfoUpdateIndex].manualAmount.price) > 0)
              {
                setManualDataOverwrite(prevState => ({...prevState, price:parseFloat(verifiedAddr[verifiedInfoUpdateIndex].manualAmount.price)}));
              }
              else
              {
                let priceVal = (editRowData.addressInfo.trips[verifiedInfoUpdateIndex] ? parseFloat(editRowData.addressInfo.trips[verifiedInfoUpdateIndex].details[0].estimatedInfo.billableAmount) : (typeof fareDataArr === 'object' ? parseFloat(fareDataArr.billableAmount) : 0));
                setManualDataOverwrite(prevState => ({...prevState, price: priceVal}));
              }
            }
          }
          else
          {
            if(verifiedAddr.length > 0 && addLegBtnRef.current.textContent.toLowerCase().includes("update") && parseFloat(verifiedAddr[verifiedInfoUpdateIndex].manualAmount.price) > 0)
            {
              setManualDataOverwrite(prevState => ({...prevState, price: parseFloat(verifiedAddr[verifiedInfoUpdateIndex].manualAmount.price)}));
            }
            else if(typeof fareDataArr === 'object' && parseFloat(fareDataArr.billableAmount) > 0)
            {
              setManualDataOverwrite(prevState => ({...prevState, price: parseFloat(fareDataArr.billableAmount)}));
            }
            else
            {
              setManualDataOverwrite(prevState => ({...prevState, price: 0}));
            }
          }
        }
      }
      else if(type === 'fare')
      {
        if(parseFloat(manualDataOverwrite.fare) > 0)
        {
          let editRowData = PersistStorage.retrieve("rowDataEditTrip", true);
          if(editRowData && editRowData !== "" && paratransitBookBtnRef.current.textContent.toLowerCase().includes("update"))
          {
            if(addLegBtnRef.current.textContent.toLowerCase().includes("update") && editRowData.addressInfo.trips[verifiedInfoUpdateIndex])
            {
              let estimatedData = (verifiedAddr.length > 0 && parseFloat(verifiedAddr[verifiedInfoUpdateIndex].manualAmount.estimatedFare) > 0 ? verifiedAddr[verifiedInfoUpdateIndex].manualAmount.estimatedFare : editRowData.addressInfo.trips[verifiedInfoUpdateIndex].details[0].estimatedInfo.estimatedCost);
              setManualDataOverwrite(prevState => ({...prevState, fare: parseFloat(estimatedData)}));
            }
            else
            {
              if(addLegBtnRef.current.textContent.toLowerCase().includes("add"))
              {
                let fareData = (editRowData.addressInfo.trips[verifiedInfoUpdateIndex] ? editRowData.addressInfo.trips[verifiedInfoUpdateIndex].details[0].estimatedInfo.estimatedCost : clientSummary.TripFare);
                setManualDataOverwrite(prevState => ({...prevState, fare: parseFloat(fareData)}));
              }
            }
          }
          else
          {
            if(verifiedAddr.length > 0 && addLegBtnRef.current.textContent.toLowerCase().includes("update") && parseFloat(verifiedAddr[verifiedInfoUpdateIndex].manualAmount.estimatedFare) > 0)
            {
              setManualDataOverwrite(prevState => ({...prevState, fare: parseFloat(verifiedAddr[verifiedInfoUpdateIndex].manualAmount.estimatedFare)}));
            }
            else if(typeof fareDataArr === 'object' && parseFloat(fareDataArr.totalCost) > 0)
            {
              setManualDataOverwrite(prevState => ({...prevState, fare: parseFloat(fareDataArr.totalCost)}));
            }
            else
            {
              setManualDataOverwrite(prevState => ({...prevState, fare: 0}));
            }
          }
        }
      }
      else
      {
        //type === 'miles'
        if(parseFloat(manualDataOverwrite.miles) > 0)
        {
          let editRowData = PersistStorage.retrieve("rowDataEditTrip", true);
          if(editRowData && editRowData !== "" && paratransitBookBtnRef.current.textContent.toLowerCase().includes("update"))
          {
            if(addLegBtnRef.current.textContent.toLowerCase().includes("update") && editRowData.addressInfo.trips[verifiedInfoUpdateIndex])
            {
              let estimatedData = (verifiedAddr.length > 0 && parseFloat(verifiedAddr[verifiedInfoUpdateIndex].manualAmount.estimatedDistance) > 0 ? verifiedAddr[verifiedInfoUpdateIndex].manualAmount : editRowData.addressInfo.trips[verifiedInfoUpdateIndex].details[0].estimatedInfo);
              setManualDataOverwrite(prevState => ({...prevState, miles: parseFloat(estimatedData.estimatedDistance)}));
              handleBlurDistance(parseFloat(estimatedData.estimatedDistance));
            }
            else
            {
              if(addLegBtnRef.current.textContent.toLowerCase().includes("add"))
              {
                let manualMiles = (editRowData.addressInfo.trips[verifiedInfoUpdateIndex] ? editRowData.addressInfo.trips[verifiedInfoUpdateIndex].details[0].estimatedInfo.estimatedDistance : clientSummary.tripDistance);
                setManualDataOverwrite(prevState => ({...prevState, miles: parseFloat(manualMiles)}));
                handleBlurDistance(parseFloat(manualMiles));
              }
              else if(addLegBtnRef.current.textContent.toLowerCase().includes("update"))
              {
                setManualDataOverwrite(prevState => ({...prevState, miles: parseFloat(verifiedAddr[verifiedInfoUpdateIndex].manualAmount.estimatedDistance)}));
                handleBlurDistance(parseFloat(verifiedAddr[verifiedInfoUpdateIndex].manualAmount.estimatedDistance));
              }
            }
          }
          else
          {
            if(verifiedAddr.length > 0 && addLegBtnRef.current.textContent.toLowerCase().includes("update") && parseFloat(verifiedAddr[verifiedInfoUpdateIndex].manualAmount.estimatedDistance) > 0)
            {
              setManualDataOverwrite(prevState => ({...prevState, miles: parseFloat(verifiedAddr[verifiedInfoUpdateIndex].manualAmount.estimatedDistance)}));
              handleBlurDistance(parseFloat(verifiedAddr[verifiedInfoUpdateIndex].manualAmount.estimatedDistance));
            }
            else if(typeof fareDataArr === 'object')
            {
              setManualDataOverwrite(prevState => ({...prevState, miles: parseFloat(clientSummary.tripDistance)}));
              handleBlurDistance(parseFloat(clientSummary.tripDistance));
            }
            else
            {
              setManualDataOverwrite(prevState => ({...prevState, miles: 0}));
              handleBlurDistance(0);
            }
          }
        }
      }
    }
    catch(err){console.log(err);}
  };

  const handleManualUserChange = (e, type = "") => {
    try{
      if(type === 'fare'){setManualDistanceEditMode(false); setManualDataOverwrite(prev=>({...prev, miles:clientSummary.tripDistance}))}
      const regex = (type === 'miles' ? /^(0|[1-9][0-9]{0,2})(\.[0-9]{0,2})?$/ : 
      ///^(0|[1-9][0-9]?)(\.[0-9]{0,2})?$/);
      /^(0|[1-9][0-9]{0,2})(\.[0-9]{0,2})?$/); 

      if(e.target.value.length > 0)
      {
        let tempVal = e.target.value;
        if(tempVal[0] === "0" && tempVal.length > 1 && !tempVal.includes("."))
        {
          e.target.value = tempVal[1];
        }
      }
      if(e.target.value === "")
      {
        setManualDataOverwrite(prevState => ({...prevState, [type]: 0}));
      }
      else if(regex.test(e.target.value)){setManualDataOverwrite(prevState => ({...prevState, [type]: e.target.value}));}
    }
    catch(err){console.log(err); setManualDataOverwrite(prevState => ({...prevState, [type]: e.target.value}));}
  };

  const handleCopayAmountChange = (e) => { //Check and display correct amount when user enters a copay (up to 2 decimal points)
    try{
      const regex = /^(0|[1-9][0-9]*)(\.[0-9]{0,2})?$/;
      if(e.target.value.length > 0)
      {
        let tempVal = e.target.value;
        if(tempVal[0] === "0" && tempVal.length > 1 && !tempVal.includes("."))
        {
          e.target.value = tempVal[1];
        }
      }
      if(!regex.test(e.target.value)){e.target.value = 0;}
      setCopayAmount(e.target.value);
    }
    catch(err){console.log(err);}
  };

  const handleMobilityInputChange = (event, type) =>{ //Handler for changes in mobility number information for timeDiff
    try{
      const regex = /^[0-9\b]+$/;
      if(event.target.value.length > 0 && event.target.value > 0)
      {
        let tempVal = event.target.value;
        if(tempVal[0] === "0")
        {
          event.target.value = tempVal[1];
        }
      }
      if(!regex.test(event.target.value)){event.target.value = 0;}
      else if(parseInt(event.target.value) > 10) {event.target.value = 10;}
      else if(parseInt(event.target.value) > 50 && type === "totalVeh"){event.target.value = 50;}
      setMobilityDetails({...mobilityDetails, [type]:event.target.value});
      
    }
    catch(err){console.log(err);}
  };

  const handleDOAddrChanged = async(e)=>{
    try{
      let input =  e.target.value || "";
      if(isValidAddressString(input) && input.trim() === dropAddr && dropLatLng.current !== ""){return;} //check for no change in input
      setFareZones(prevState=>({...prevState, drop: ""}));
      fareZonesRef.current.dropFareZone = "";
      setDispatchZones(prevState=>({...prevState, dropZone: ""}));
      if(input === ""){setIsSchTimeFieldDisabled(true);}
      if(bookBtnRef.current){bookBtnRef.current.disabled = true;}
      setZones("");
      if(input.trim() === ""){handleClearAddr("DO");}
      vsSelectedRef.current = vsSelectedRef.current.filter(item => item !== "DO");

      setClientSummary(prevState=>({...prevState, 
        tripDistance: 0, TripDuration:0, TripFare:0.0, TripCopay:0.0
      }));
      setWalkDistance({...walkDistance, DOWalk:0, PUWalk:0, PUDuration:0, DODuration:0});

      dropLatLng.current = "";
      liRefsDO.current = [];
      let suggestionsRecentArr = [];
      let poiSuggestionAddrHTML = null;
      let hashIndex = input.indexOf("#");
      if(hashIndex !== -1)
      {
        //run POISuggestion
        handleClearAddr("DO");
        input = input.slice(hashIndex);
        setDropAddr(input);
        input = input.replaceAll("#","");

          let trimmedInput = input.trim();
          let lastInput = trimmedInput;
          let elapsedTime = 0;
          let timeInterval = 300;
          if(doPOITimerIntervalRef.current){clearInterval(doPOITimerIntervalRef.current);}
          if(trimmedInput !== "")
          {
            doPOITimerIntervalRef.current = setInterval(async () => {
              try{
                if(lastInput === dropAddr.trim())
                {
                  //No change occured
                  elapsedTime += 100;
                }
                else
                {
                  //A change occured, reset timer
                  lastInput = dropAddr.trim();
                  elapsedTime = 0;
                }
                if(elapsedTime >= timeInterval)
                {
                  clearInterval(doPOITimerIntervalRef.current);
                  if(lastInput.length >= 3)
                  {
                    let data = {
                      "affiliateID": parseInt(selectedAff),
                      "poi": input.replaceAll("#",""),
                    }
                    xCancelSourceForGrid.current = APICom.GenerateSource();
                    let response = await APICom.fetchData("ReservationCoreURL","api/ParatransitCT/GetPOISuggestion", "post", 
                      {'Content-Type': 'application/json',
                      'Access-Control-Allow-Origin': '*',
                      'Access-Control-Allow-Headers': '*',
                      'mode': 'no-cors'}, data, xCancelSourceForGrid.current
                    );
          
                    if(response.error.length === 0 && (Array.isArray(response.data) && response.data.length > 0))
                    {
                      let SuggestedAddrArray = response.data;
                      let filteredPOISuggestion = SuggestedAddrArray.filter(item=>{
                        let formattedAddr = item.POI;
                        return formattedAddr.toLowerCase().includes(input.trim().toLowerCase());
                      });
                      focusedSuggestionCheckDO.current = false;
                      poiSuggestionAddrHTML = filteredPOISuggestion ? filteredPOISuggestion.map(function(item, index){
                        let detailedData = item.City+","+item.Region+","+item.ZipCode;
                        let formattedAddr = item.POI;
                        let fullAddr = (item.Street + (item.City && item.City !== ""? ", "+item.City +", "+ (item.Region && item.Region !== "" ? item.Region +" "+ item.ZipCode: ""): "") );
                        let LatLng = String(item.vPOILatitude)+","+String(item.vPOILongitude);
                        let poiApartment = item.Apartment
                        liRefsDO.current[index] = React.createRef();
                        return(
                          <li ref={liRefsDO.current[index]} poisuggestion={"true"} className="small border-bottom text-nowrap overflow-hidden addressSelectionRow" 
                            title={fullAddr} onFocus={()=>{focusedSuggestionCheckDO.current = true;}} poiAprt={poiApartment}
                            style={{cursor:"pointer"}} tabIndex={-1} onBlur={()=>{focusedSuggestionCheckDO.current = false;}} onKeyDown={(e)=>{
                              if(e.key === 'ArrowDown')
                              {
                                e.preventDefault();
          
                                if(liRefsDO.current.length > 0)
                                {
                                  setHightlightedIndexDO((prevIndex) => {
                                    const newIndex = (prevIndex + 1) % liRefsDO.current.length;
                                    liRefsDO.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                                    return newIndex;
                                  });
                                }
                              }
                              else if (e.key === 'ArrowUp') {
                                e.preventDefault();
                                if(liRefsDO.current.length > 0)
                                {
                                  setHightlightedIndexDO((prevIndex) => {
                                    const newIndex = (prevIndex - 1 + liRefsDO.current.length) % liRefsDO.current.length;
                                    liRefsDO.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                                    return newIndex;
                                  });
                                }
                              }
                              else if(e.key === "Enter")
                              {
                                handleDOSuggestionClicked(e);
                              }
                            }}
                            onClick={handleDOSuggestionClicked} key={index} value={formattedAddr} data-name={detailedData} data-virtual={LatLng}
                          >
                            {item.icon && item.icon !== ""? <Icon icon={item.icon} className="text-danger me-1" style={{width:"20px", height:"20px"}}/> :
                              <Icon icon={"gis:search-poi"} className="text-danger me-1" style={{width:"20px", height:"20px"}}/>
                            }
                            {formattedAddr}
                          </li>
                        );
                      }) : "";
                      setInputSuggestionListDO(poiSuggestionAddrHTML);
                    }
                  }
                }
              } catch(err){console.log(err);}
            }, timeInterval);
          }
          
        
      }
      else
      {
        setDropAddr(input);
      }

      for(let entry of recentAddresses)
      {
        if(entry.PUAddress)
        {
          suggestionsRecentArr.push({
            Address: entry.PUAddress,
            City: entry.PUCity,
            Lat: entry.PULat,
            Long: entry.PULong,
            State: entry.PUState,
            Zip: entry.PUZip,
            AddressType: entry.AddressType,
              Apartment: entry.PUApartment
          });
        }
        if(entry.DOAddress)
        {
          suggestionsRecentArr.push({
            Address: entry.DOAddress,
            City: entry.DOCity,
            Lat: entry.DOLat,
            Long: entry.DOLong,
            State: entry.DOState,
            Zip: entry.DOZip,
            AddressType: entry.AddressType,
              Apartment: entry.DOApartment
          });
        }
      }
      let uniqueRecentAddresses = handleDuplicates(suggestionsRecentArr, "Address");
      uniqueRecentAddresses = updateApartment(uniqueRecentAddresses, suggestionsRecentArr);

      focusedSuggestionCheckDO.current = false;
      const sortedAddresses = handleAddAllAddressTypestoArr(uniqueRecentAddresses, suggestionsRecentArr, input.trim());
      let recentAddrHTML2_0 = handleGetSuggestionsList(sortedAddresses, input.trim(), liRefRecentDropoffAddressComponent, liRefsDO, focusedSuggestionCheckDO, setHightlightedIndexDO, handleDOSuggestionClicked, "recent");
      

        let trimmedInput = input.trim();
        let lastInput = trimmedInput;
        let elapsedTime = 0;
        let timeInterval = 400;
        if(doTimerIntervalRef.current){clearInterval(doTimerIntervalRef.current);}
        if(trimmedInput !== "" && hashIndex === -1)
        {
          doTimerIntervalRef.current = setInterval(async () => {
            try{
              if(lastInput === dropAddr.trim())
              {
                //No change occured
                elapsedTime += 100;
              }
              else
              {
                //A change occured, reset timer
                if(dropAddr.trim() === ""){elapsedTime = timeInterval;}
                else{
                  lastInput = dropAddr.trim();
                  elapsedTime = 0;
                }
              }
              if(elapsedTime >= timeInterval)
              {
                clearInterval(doTimerIntervalRef.current);
                if(lastInput.length > 4)
                {
                  let myHeaders = new Headers();
                  myHeaders.append("Authorization", 'Basic '+btoa(OSRM_Username.current + ":" + OSRM_Password.current));
                  myHeaders.append('Content-Type', 'application/json');
                  let headersObj = headersToObject(myHeaders);
                  let mapBounds = (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "OSRMRectangleBounds")).value.replace(" ", ""); //"&bounds=" + mapBounds+
                  let addressAPI = ITCMapURL.current + encodeURIComponent(input) + "&bounds=" + mapBounds+ "&AppType=Web_Reservation";
                  let OSRMResponse = await APICom.fetchData("full", addressAPI, "get", headersObj, {});
                  let SuggestedAddrArray = [];
          
                  if(OSRMResponse && OSRMResponse.data.status.toUpperCase() === "OK")
                  {
                    SuggestedAddrArray = OSRMResponse.data.results.map(function(item)
                    {
                      return item;
                    });
          
                    focusedSuggestionCheckDO.current = false;
                    liRefsDO.current = [];
                    if(SuggestedAddrArray.length > 0)
                    {
                      SuggestedAddrArray.unshift({
                        Address: "",
                        City: "",
                        State: "",
                        Zip: "",
                        Lat: "",
                        Long: "",
                        AddressType: 0,
                        isStatic: true, // Add a flag to differentiate this static entry
                      });
                    }
                    let suggestionsHTML2_0 = handleGetSuggestionsList(SuggestedAddrArray, input.trim(), liRefDropoffAddressComponent, liRefsDO, focusedSuggestionCheckDO, setHightlightedIndexDO, handleDOSuggestionClicked, "", "AutoComplete");
                    
                    if(suggestionsHTML2_0 !== "" && e.target.value !== "")
                    {
                      setInputSuggestionListPU("");
                      setInputSuggestionListDO(suggestionsHTML2_0);
                    }
                    else if(recentAddrHTML2_0.length > 0)
                    {
                      setInputSuggestionListPU("");
                      setInputSuggestionListDO(recentAddrHTML2_0);
                    }
                  }
                }
              }
            }catch(err){console.log(err);}
          }, timeInterval);
        }
        
      
      if(input.trim().length === 0)
      {
        if(recentAddrHTML2_0.length > 0)
        {
          setInputSuggestionListDO(recentAddrHTML2_0);
        }
        else
        {
          setInputSuggestionListDO("");
        }
      }
      else
      {
        if(hashIndex !== -1 && poiSuggestionAddrHTML !== "")
        {
          setInputSuggestionListDO(poiSuggestionAddrHTML);
        }
        else if(recentAddrHTML2_0.length > 0)
        {
          setInputSuggestionListDO(recentAddrHTML2_0);
        }
        else
        {
          setInputSuggestionListDO("");
        }
      }
    }
    catch(err){console.log(err);}
  };

    const updateApartment = (uniqueAddresses, suggestedAddresses) => {
        uniqueAddresses.forEach(uniqueAddress => {
            const matchingSuggestedAddress = suggestedAddresses.find(suggestedAddress =>
                suggestedAddress.Address === uniqueAddress.Address &&
                suggestedAddress.City === uniqueAddress.City &&
                suggestedAddress.State === uniqueAddress.State &&
                suggestedAddress.Zip === uniqueAddress.Zip
            );

            if (matchingSuggestedAddress && !uniqueAddress.Apartment) {
                uniqueAddress.Apartment = matchingSuggestedAddress.Apartment || '';
            }
        });

        return uniqueAddresses;
    }

  const handleStopAddrChange = async (e) => { //Get the correct address suggestions for a stop depending on user input (POI's/Recents/Suggestions)
    try{
      let input = e.target.value;
      let suggestionsRecentArr = [];
      let poiSuggestionAddrHTML = null;
      let hashIndex = input.indexOf("#");
      if(input === stopAddr && stopLatLng.current !== ""){return;} //check for no change in input
      setStopAddrZone("");
      if(input.trim() === ""){handleClearAddr("Return");} //If user clears input, clear all suggestions and selected address lat lng
      stopLatLng.current = "";
      liRefsStop.current = [];
      if(hashIndex !== -1)
      {
        //run POISuggestion
        handleClearAddr("Return");
        input = input.slice(hashIndex);
        setStopAddr(input);
        input = input.replaceAll("#","");
        if(input.length >= 3)
        {
          let data = {
            "affiliateID": parseInt(selectedAff),
            "poi": input.replaceAll("#",""),
          }
          xCancelSourceForGrid.current = APICom.GenerateSource();
          let response = await APICom.fetchData("ReservationCoreURL","api/ParatransitCT/GetPOISuggestion", "post", 
            {'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'mode': 'no-cors'}, data, xCancelSourceForGrid.current
          );

          if(response.error.length === 0 && (Array.isArray(response.data) && response.data.length > 0))
          {
            let SuggestedAddrArray = response.data;
            let filteredPOISuggestion = SuggestedAddrArray.filter(item=>{
              let formattedAddr = item.POI;
              return formattedAddr.toLowerCase().includes(input.trim().toLowerCase());
            });
            focusedSuggestionCheckStop.current = false;
            poiSuggestionAddrHTML = filteredPOISuggestion ? filteredPOISuggestion.map(function(item, index){
              let detailedData = item.City+","+item.Region+","+item.ZipCode;
              let formattedAddr = item.POI;
              let fullAddr = (item.Street + (item.City && item.City !== ""? ", "+item.City +", "+ (item.Region && item.Region !== "" ? item.Region +" "+ item.ZipCode: ""): "") );
              let LatLng = String(item.vPOILatitude)+","+String(item.vPOILongitude);
              let poiApartment = item.Apartment
              liRefsStop.current[index] = React.createRef();
              return(
                <li ref={liRefsStop.current[index]} poisuggestion={"true"} className="small border-bottom text-nowrap overflow-hidden addressSelectionRow" 
                  title={fullAddr} onFocus={()=>{focusedSuggestionCheckStop.current = true;}}  poiAprt={poiApartment}
                  style={{cursor:"pointer"}} tabIndex={-1} onBlur={()=>{focusedSuggestionCheckStop.current = false;}} onKeyDown={(e)=>{
                    if(e.key === 'ArrowDown')
                    {
                      e.preventDefault();

                      if(liRefsStop.current.length > 0)
                      {
                        setHightlightedIndexStop((prevIndex) => {
                          const newIndex = (prevIndex + 1) % liRefsStop.current.length;
                          liRefsStop.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                          return newIndex;
                        });
                      }
                    }
                    else if (e.key === 'ArrowUp') {
                      e.preventDefault();
                      if(liRefsStop.current.length > 0)
                      {
                        setHightlightedIndexStop((prevIndex) => {
                          const newIndex = (prevIndex - 1 + liRefsStop.current.length) % liRefsStop.current.length;
                          liRefsStop.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                          return newIndex;
                        });
                      }
                    }
                    else if(e.key === "Enter")
                    {
                      handleStopSuggestionClicked(e);
                    }
                  }}
                  onClick={handleStopSuggestionClicked} key={index} value={formattedAddr} data-name={detailedData} data-virtual={LatLng}
                >
                  {item.icon && item.icon !== ""? <Icon icon={item.icon} className="text-danger me-1" style={{width:"20px", height:"20px"}}/> :
                    <Icon icon={"gis:search-poi"} className="text-danger me-1" style={{width:"20px", height:"20px"}}/>
                  }
                  {formattedAddr}
                </li>
              );
            }) : "";
          }
        }
      }
      else
      {
        setStopAddr(input);
      }

      for(let entry of recentAddresses)
      {
        if(entry.PUAddress)
        {
          suggestionsRecentArr.push({
            Address: entry.PUAddress,
            City: entry.PUCity,
            Lat: entry.PULat,
            Long: entry.PULong,
            State: entry.PUState,
            Zip: entry.PUZip,
            AddressType: entry.AddressType,
            Apartment: entry.PUApartment
          });
        }
        if(entry.DOAddress)
        {
          suggestionsRecentArr.push({
            Address: entry.DOAddress,
            City: entry.DOCity,
            Lat: entry.DOLat,
            Long: entry.DOLong,
            State: entry.DOState,
            Zip: entry.DOZip,
            AddressType: entry.AddressType,
              Apartment: entry.DOApartment
          });
        }
      }
      let uniqueRecentAddresses = handleDuplicates(suggestionsRecentArr, "Address"); //Make sure there are no duplicates in given addresses then filter by input and get a formatted result
      uniqueRecentAddresses = updateApartment(uniqueRecentAddresses, suggestionsRecentArr);
        focusedSuggestionCheckStop.current = false;
      const sortedAddresses = handleAddAllAddressTypestoArr(uniqueRecentAddresses, suggestionsRecentArr, input.trim());
      let recentAddrHTML2_0 = handleGetSuggestionsList(sortedAddresses, input.trim(), liRefStopAddressComponent, liRefsStop, focusedSuggestionCheckStop, setHightlightedIndexStop, handleStopSuggestionClicked, "recent");
      
      //If user enters a minimum of 8 characters, change suggestions to autoComplete address suggestions
      if(input.trim().length > 8 && hashIndex === -1)
      {
        let myHeaders = new Headers();
        myHeaders.append("Authorization", 'Basic '+btoa(OSRM_Username.current + ":" + OSRM_Password.current));
        myHeaders.append('Content-Type', 'application/json');
        let headersObj = headersToObject(myHeaders);
        let mapBounds = (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "OSRMRectangleBounds")).value.replace(" ", ""); //"&bounds=" + mapBounds+
        let addressAPI = ITCMapURL.current + encodeURIComponent(input) + "&bounds=" + mapBounds+ "&AppType=Web_Reservation";
        let OSRMResponse = await APICom.fetchData("full", addressAPI, "get", headersObj, {});
        let SuggestedAddrArray = [];
        if(OSRMResponse && OSRMResponse.data.status.toUpperCase() === "OK")
        {
          SuggestedAddrArray = OSRMResponse.data.results.map(function(item)
          {
            return item;
          });
          if(SuggestedAddrArray.length > 0)
          {
            SuggestedAddrArray.unshift({
              Address: "",
              City: "",
              State: "",
              Zip: "",
              Lat: "",
              Long: "",
              AddressType: 0,
              isStatic: true, // Add a flag to differentiate this static entry
            });
          }
          focusedSuggestionCheckStop.current = false;
          liRefsStop.current = [];
          liRefStopAddressComponent.current = []; 
          let suggestionsHTML2_0 = handleGetSuggestionsList(SuggestedAddrArray, input.trim(), liRefStopAddressComponent, liRefsStop, focusedSuggestionCheckStop, setHightlightedIndexStop, handleStopSuggestionClicked, "", "AutoComplete");
          
          if(suggestionsHTML2_0 !== "" && e.target.value !== "")
          {
            setInputSuggestionListStop(suggestionsHTML2_0);
          }
          else if(recentAddrHTML2_0.length > 0)
          {
            setInputSuggestionListStop(recentAddrHTML2_0);
          }
        }
      }
      else if(input.trim().length === 0)
      {
        if(recentAddrHTML2_0.length > 0)
        {
          setInputSuggestionListStop(recentAddrHTML2_0);
        }
        else
        {
          setInputSuggestionListStop("");
        }
      }
      else
      {
        if(hashIndex !== -1 && poiSuggestionAddrHTML !== "")
        {
          setInputSuggestionListStop(poiSuggestionAddrHTML);
        }
        else if(recentAddrHTML2_0.length > 0)
        {
          setInputSuggestionListStop(recentAddrHTML2_0);
        }
        else
        {
          setInputSuggestionListStop("");
        }
      }
    }
    catch(err){console.log(err);}
  };

  const handleStopSuggestionClicked = async (e) => {
    try{
      let PULatLng = e.target.dataset.virtual;
      if(PULatLng.split(",")[0] !== "0" && PULatLng.split(",")[0] !== "")
      {
        let selectedIndex = e.target.getAttribute('index');
        let poiSelected = e.target.getAttribute('poisuggestion');
        let selectedIndexAddressComponent = "";
        let indexType = "";
        if(selectedIndex !== undefined && selectedIndex)
        {
          selectedIndex = parseInt(selectedIndex);
          if(selectedIndex >= 0 && liRefStopAddressComponent !== undefined)
          {
            indexType = "manual";
            selectedIndexAddressComponent = liRefStopAddressComponent?.current[selectedIndex];
            mapPointStopSelection.current = selectedIndexAddressComponent;
          }
        }
        else if(poiSelected)
        {
          indexType = "poi";
          mapPointStopSelection.current = {data: {address: e.target.title, POI: e.target.textContent}};
        }
        else
        {
          let _IsRecentAddressSelected = e.target.getAttribute('isrecentaddress');
          let selectedIndexRecentAddressComponent = "";
          if(_IsRecentAddressSelected !== undefined && _IsRecentAddressSelected)
          {
            let recentaddressindex = e.target.getAttribute('recentaddressindex');
            if(recentaddressindex !== undefined && recentaddressindex){
              recentaddressindex = parseInt(recentaddressindex);
              if(recentaddressindex >= 0 && liRefStopAddressComponent !== undefined){
                indexType = "recent";
                selectedIndexRecentAddressComponent = liRefStopAddressComponent?.current[recentaddressindex];
                mapPointStopSelection.current = selectedIndexRecentAddressComponent;
              }
            }
          }
        }
        setStopAddr(e.target.textContent);
        setStopPOI((poiSelected? e.target.textContent : ""));
        setInputSuggestionListStop("");
        mapPointStopSelection.current["Type"] = indexType;
        stopLatLng.current = e.target.dataset.virtual;
      }
      else
      {
        if(e.target.getAttribute('poisuggestion'))
        {
          let myHeaders = new Headers();
          myHeaders.append("Authorization", 'Basic '+btoa(OSRM_Username.current + ":" + OSRM_Password.current));
          myHeaders.append('Content-Type', 'application/json');
          let mapBounds = (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "OSRMRectangleBounds")).value.replace(" ", "");
          let addressAPI = ITCMapURL.current + encodeURIComponent(e.target.title) + "&bounds="+mapBounds+ "&AppType=Web_Reservation";
          let headersObj = headersToObject(myHeaders);
          let OSRMResponse = await APICom.fetchData("full", addressAPI, "get", headersObj, {});
          if(OSRMResponse && OSRMResponse.data.status.toUpperCase() === "OK")
          {
            let addressFound = OSRMResponse.data.results[0];
            let selectedAddressContext = addressFound.formatted_address;
            setStopAddr(selectedAddressContext);
            setStopPOI(e.target.textContent);
            setInputSuggestionListStop("");
            mapPointStopSelection.current = {data: {address: e.target.title, POI: e.target.textContent}};
            mapPointStopSelection.current["Type"] = "poi";
            stopLatLng.current = addressFound.geometry.location.lat+","+addressFound.geometry.location.lng;
          }
        }
      }
    }
    catch(err){console.log(err);}
  };

  const handleDOSuggestionClicked = async (e) => {
    try{ 
      let PULatLng = e.target.dataset.virtual;
      let correctDate = formatDate(selectedDateSchTime);
      if(PULatLng.split(",")[0] !== "0" && PULatLng.split(",")[0] !== "")
      { 
        let selectedIndex = e.target.getAttribute('index');
        let poiSelected = e.target.getAttribute('poisuggestion')
        let selectedIndexAddressComponent = "";
        let indexType = "";
        if(selectedIndex !== undefined && selectedIndex)
        {
          selectedIndex = parseInt(selectedIndex);
          if(selectedIndex >= 0 && liRefDropoffAddressComponent !== undefined)
          {
            indexType = "manual";
            selectedIndexAddressComponent = liRefDropoffAddressComponent?.current[selectedIndex];
            mapPointDropoffSelection.current = selectedIndexAddressComponent;
          }
        }
        else if(poiSelected)
        {
          indexType = "poi";
          mapPointDropoffSelection.current = {data: {address: e.target.title, POI: e.target.textContent}};
                      setAddrApartmentInfo(prev => ({
                ...prev,
                ['drop']: e.target.getAttribute("poiAprt") ?? ''
            }));
        }
        else
        {
          let _IsRecentAddressSelected = e.target.getAttribute('isrecentaddress');
          let selectedIndexRecentAddressComponent = "";
          if(_IsRecentAddressSelected !== undefined && _IsRecentAddressSelected){
            let recentaddressindex = e.target.getAttribute('recentaddressindex');
            if(recentaddressindex !== undefined && recentaddressindex){
              recentaddressindex = parseInt(recentaddressindex);
              if(recentaddressindex >= 0 && liRefRecentDropoffAddressComponent !== undefined){
                indexType = "recent";
                selectedIndexRecentAddressComponent = liRefRecentDropoffAddressComponent?.current[recentaddressindex];
                  setAddrApartmentInfo(prev => ({
                      ...prev,
                      ['drop']: selectedIndexRecentAddressComponent?.data?.Apartment ?? ''
                  }));
                mapPointDropoffSelection.current = selectedIndexRecentAddressComponent;
              }
            }
          }
        }
        let selectedAddressContext = (poiSelected ? e.target.title : e.target.textContent);
        let addressDetails = e.target.getAttribute('data-name');
        addressInfoDetails.current.drop = {state:addressDetails.split(",")[1], city: addressDetails.split(",")[0], zip: addressDetails.split(",")[2]};
        mapPointDropoffSelection.current["Type"] = indexType;
        
        setDropAddr(selectedAddressContext);
        setDropPOI((poiSelected? e.target.textContent : ""));
        dropLatLng.current = e.target.dataset.virtual;
        if(fareMethodRef.current === 1)
        {
          setShowAPILoader(true);
          await getFareZone(FSSelected, selectedAff, COSSelected, dropLatLng.current, "drop");
        }
        if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2))
        {
          await getDispatchZone(selectedAff, dropLatLng.current, "drop");
        }
        setShowAPILoader(false);
        if(addLegBtnRef.current){
          addLegBtnRef.current.disabled = false;
        }
        let stopMarkersArr = []; //Adding correct map markers and only updating DO marker
        let filteredMapMarkers = mapData.filter((item)=>{
          if(item.Type === "Stop")
          {
            stopMarkersArr.push(item);
          }
          return item.Type === "PU";
        });
        stopMarkersArr.push({lat:parseFloat(dropLatLng.current.split(",")[0]),
          lng: parseFloat(dropLatLng.current.split(",")[1]), Type:"DO", 
          name:(riderName === "" ? "N/A" : riderName.trim()), address: selectedAddressContext
        });
        filteredMapMarkers.push(...stopMarkersArr);

        setMapData(filteredMapMarkers);
        setInputSuggestionListDO("");
        if(pickLatLng.current !== "")
        {
          setIsSchTimeFieldDisabled(false);
          if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2))
          {
            wrapperHandleRCZVerification("DO", selectedAddressContext);
          }
          else{
            wrapperHandleAddressDetails("DO", selectedAddressContext, pickupAddr, selectedAddressContext, correctDate, schTime);
          }
        }
      }
      else
      {
        if(e.target.getAttribute('poisuggestion'))
        {
          let myHeaders = new Headers();
          myHeaders.append("Authorization", 'Basic '+btoa(OSRM_Username.current + ":" + OSRM_Password.current));
          myHeaders.append('Content-Type', 'application/json');
          let mapBounds = (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "OSRMRectangleBounds")).value.replace(" ", ""); //"&bounds="+mapBounds+
          let addressAPI = ITCMapURL.current + encodeURIComponent(e.target.title) + "&bounds="+mapBounds+ "&AppType=Web_Reservation";
          let headersObj = headersToObject(myHeaders);
          let OSRMResponse = await APICom.fetchData("full", addressAPI, "get", headersObj, {});
          if(OSRMResponse && OSRMResponse.data.status.toUpperCase() === "OK") 
          {
            let addressFound = OSRMResponse.data.results[0]; //Saving data for use in reservation
            let selectedAddressContext = addressFound.formatted_address;
            let addressDetails = e.target.getAttribute('data-name');
            let stopMarkersArr = []; 
            setDropAddr(selectedAddressContext);
            setDropPOI(e.target.textContent);
            addressInfoDetails.current.drop = {state:addressDetails.split(",")[1], city: addressDetails.split(",")[0], zip: addressDetails.split(",")[2]};
            mapPointDropoffSelection.current = {data: {address: e.target.title, POI: e.target.textContent}};
            mapPointDropoffSelection.current["Type"] = "poi";
            dropLatLng.current = addressFound.geometry.location.lat+","+addressFound.geometry.location.lng;
            if(fareMethodRef.current === 1)
            {
              setShowAPILoader(true);
              await getFareZone(FSSelected, selectedAff, COSSelected, dropLatLng.current, "drop");
            }
            if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2)) //Calculate fare and dispatch zone based on selected address
            {
              await getDispatchZone(selectedAff, dropLatLng.current, "drop");
            }
            setShowAPILoader(false);
            if(addLegBtnRef.current){
              addLegBtnRef.current.disabled = false;
            }
            //Adding correct map markers and only updating DO marker
            let filteredMapMarkers = mapData.filter((item)=>{
              if(item.Type === "Stop")
              {
                stopMarkersArr.push(item);
              }
              return item.Type === "PU";
            });
            stopMarkersArr.push({lat:parseFloat(dropLatLng.current.split(",")[0]),
              lng: parseFloat(dropLatLng.current.split(",")[1]), Type:"DO", 
              name:(riderName === "" ? "N/A" : riderName.trim()), address: selectedAddressContext
            });
            filteredMapMarkers.push(...stopMarkersArr);

            setMapData(filteredMapMarkers);
            setInputSuggestionListDO(""); //Making sure suggestions are reset

            if(pickLatLng.current !== "")
            {
              setIsSchTimeFieldDisabled(false);
              if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2))
              {
                wrapperHandleRCZVerification("DO", selectedAddressContext); //If microtransit trip, initiate RCZ validation
              }
              else{
                wrapperHandleAddressDetails("DO", selectedAddressContext, pickupAddr, selectedAddressContext, correctDate, schTime); //Get distance and time data from PU to DO
              }
            }
          }
        }
      }
    }
    catch(er){console.log(er);}
  };

  const wrapperHandleFareCalc = async(tripDistance, tripDuration, FSID, CopayFSID, totalWC, totalPax, COSID, AffiliateID, pickupLatLng, Copay, type = "", riderID = "") =>{
    try{
      if(pickupLatLng && pickupLatLng !== "") //Initiate fare calculation API from wrapper. In case of no latlng for PU, set them to 0
      {
        await handleFareCalculation(tripDistance, tripDuration, FSID, CopayFSID, totalWC, totalPax, COSID, AffiliateID, pickupLatLng, Copay, type, riderID);
      }
      else
      {
        let newPickLatLng = "0,0";
        await handleFareCalculation(tripDistance, tripDuration, FSID, CopayFSID, totalWC, totalPax, COSID, AffiliateID, newPickLatLng, Copay, type, riderID);
      }
      if(addLegBtnRef.current && addLegBtnRef.current.disabled) //Making sure add leg is not disabled
      {
        addLegBtnRef.current.disabled = false;
      }
    }
    catch(err){console.log(err);}
  };

  const wrapperHandleRCZVerification = async (type, actualAddr, addr2 = " ") => {
    try {
      await handleRCZVerification(type, actualAddr, addr2); //Initiate RCZ validation from wrapper function
    } catch(err) {console.log(err)}
  };

  const handleGetFareCalcMethod = async (FundingSourceID, AffiliateID, ClassOfServiceID) => {
    try{
      // setModalHeaderText("Get Fare Method Processing");
      // setModalBodyHTML("Please wait...");
      // setShowDynamicModal(true);
      // setModalClass("d-none");
      // setShowAPILoader(true);
      let data = {
        "FundingSourceID": parseInt(FundingSourceID),
        "AffiliateID": parseInt(AffiliateID),
        "ClassOfServiceID": parseInt(ClassOfServiceID)
      }
      xCancelSourceForGrid.current = APICom.GenerateSource(); //GetFareCalcMethod which is called on every aff, page load, FS, and class of service change
      let response = await APICom.fetchData("ReservationCoreURL","api/ParatransitCT/GetFareCalculationMethod", "post", 
        {'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': '*',
        'mode': 'no-cors'}, data, xCancelSourceForGrid.current
      );
      setShowDynamicModal(false);
      setShowAPILoader(false);
      setModalClass("");
      if(paratransitBookBtnRef.current && paratransitBookBtnRef.current.disabled){paratransitBookBtnRef.current.disabled = false; addLegBtnRef.current.disabled = false;}
      if(response.error.length === 0)
      {
        if(response.data.httpResponseCode === 200)
        {
          let faremethod = response.data.fareMethod;
          setFareMethod(faremethod);
          fareMethodRef.current = faremethod; //Gives a fare method value 0/1 which determines if fare zone is necessary
        }
        else
        {
          setModalHeaderText("Fare Method Calculation Failed");
          setModalBodyHTML("The following error occured for fare method calculation: " + response.data.exceptionMessage);
          setModalFooterHTML(
            <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
              OK
            </Button>
          );
          setShowDynamicModal(true);
          setFareMethod(0);
          fareMethodRef.current = 0;
        }
      }
      else
      {
        setFareMethod(0);
        fareMethodRef.current = 0;
      }
    }
    catch(err){console.log(err);}
  };

  const getFareZone = async (FundingSourceID, AffiliateID, ClassOfServiceID, Latlng, type) => {
    try{
      
      if(Latlng.trim() === "") 
        return;

      let data = {
        "FundingSourceID": parseInt(FundingSourceID),
        "AffiliateID": parseInt(AffiliateID),
        "ClassOfServiceID": parseInt(ClassOfServiceID),
        "Latitude": parseFloat(Latlng.split(",")[0]),
        "Longitude": parseFloat(Latlng.split(",")[1])
      }
      xCancelSourceForGrid.current = APICom.GenerateSource();
      let response = await APICom.fetchData("ReservationCoreURL","api/ParatransitCT/GetFareZone", "post", 
        {'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': '*',
        'mode': 'no-cors'}, data, xCancelSourceForGrid.current
      );
      if(addLegBtnRef.current)
        addLegBtnRef.current.disabled = true;
      if(response.error.length === 0)
      {
        if(response.data.httpResponseCode === 200)
        {
          if(type === "pick") //Depending on type of fare zone (PU/DO), map them to correct reference and useState vars
          {
            setFareZones(prevState=>({...prevState, pick:response.data.zone}));
            fareZonesRef.current.pickFareZone = response.data.zone;
          }
          else
          {
            setFareZones(prevState=>({...prevState, drop:response.data.zone}));
            fareZonesRef.current.dropFareZone = response.data.zone;
          }
        }
        else
        {
          setModalHeaderText("Fare Zone Calculation Failed");
          setModalBodyHTML("The following error occured for fare zone calculation: " + response.data.exceptionMessage);
          setModalFooterHTML(
            <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
              OK
            </Button>
          );
          setShowDynamicModal(true);
          setFareZones({pick:"", drop:""});
          fareZonesRef.current = {pickFareZone:"", dropFareZone:""};
        }
      }
      else
      {
        setModalHeaderText("Fare Zone Calculation Failed");
        setModalBodyHTML(response.error);
        setModalFooterHTML(
          <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
            OK
          </Button>
        );
        setShowDynamicModal(true);
        setFareZones({pick:"", drop:""});
        fareZonesRef.current = {pickFareZone:"", dropFareZone:""};
      }
    }
    catch(err){console.log(err);}
  };

  const getDispatchZone = async (AffiliateID, Latlng, type) => { //Get dispatch zone of a selected address
    try{
      
      if(Latlng.trim() === "") 
        return;

      let data = {
        "AffiliateID": parseInt(AffiliateID),
        "Latitude": parseFloat(Latlng.split(",")[0]),
        "Longitude": parseFloat(Latlng.split(",")[1])
      }
      xCancelSourceForGrid.current = APICom.GenerateSource();
      let response = await APICom.fetchData("ReservationCoreURL","api/ParatransitCT/GetDispatchZone", "post", 
        {'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': '*',
        'mode': 'no-cors'}, data, xCancelSourceForGrid.current
      );

      if(response.error.length === 0)
      {
        if(response.data.httpResponseCode === 200)
        {
          if(type === "pick")
          {
            setDispatchZones(prevState=>({...prevState, pickZone:response.data.zone}));
          }
          else
          {
            setDispatchZones(prevState=>({...prevState, dropZone:response.data.zone}));
          }
        }
        else
        {
          setModalHeaderText("Dispatch Zone Calculation Failed");
          setModalBodyHTML("The following error occured for dispatch zone calculation: " + response.data.exceptionMessage);
          setModalFooterHTML(
            <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
              OK
            </Button>
          );
          setShowDynamicModal(true);
          setDispatchZones({pickZone:"", dropZone:""});
        }
      }
      else
      {
        setModalHeaderText("Dispatch Zone Calculation Failed");
        setModalBodyHTML(response.error);
        setModalFooterHTML(
          <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
            OK
          </Button>
        );
        setShowDynamicModal(true);
        setDispatchZones({pickZone:"", dropZone:""});
      }
    }
    catch(err){console.log(err);}
  };

  const getFareDataResponse = async (tripDistance, tripDuration, FSID, CopayFSID, totalWC, totalPax, COSID, AffiliateID, pickupLatLng, Copay, riderID = 0, distanceFlag = false) => {
    try{
      let clientID = (medID ? String(medID) : "-1");
      let tspidVal = AffiliateData.find(item=>item.AffiliateID === parseInt(AffiliateID));

      let _PCA = GetMobilityCountByLabel("PCA");

      let data = {
        "distance": parseFloat(tripDistance),
        "travelTime": parseFloat(tripDuration),
        "fundingSourceID": parseInt(FSID),
        "copay": parseFloat(Copay),
        "numberOfWheelchairs": parseInt(totalWC),
        "numberOfPassengers": parseInt(totalPax),
        "classOfServiceID": parseInt(COSID),
        "affiliateID": parseInt(AffiliateID),
        "pickupLatitude": parseFloat(pickupLatLng.split(",")[0]),
        "pickupLongitude": parseFloat(pickupLatLng.split(",")[1]),
        "copayFundingSourceID": parseInt(CopayFSID),
        "riderID": (riderID !== 0 ? riderID : clientID),
        "authorizedStaff": "",
        "startFareZone": fareZonesRef.current.pickFareZone,
        "endFareZone": fareZonesRef.current.dropFareZone,
        "tspid": (tspidVal ? String(tspidVal.iOutTSPID) : ""),
        "httpResponseCode": 200,
        "PCAPassengersCount": _PCA
      }
      setModalHeaderText("Get Fare Estimate Processing");
      setModalBodyHTML("Please wait...");
      setModalFooterHTML(
        <>
          <Button variant='dark' className="border-0" onClick={()=>{setShowDynamicModal(false);}}>
            OK
          </Button>
        </>
      );
      setShowDynamicModal(true);
      setModalClass("d-none");
      setShowAPILoader(true);
      xCancelSourceForGrid.current = APICom.GenerateSource();
      let response = await APICom.fetchData("ReservationCoreURL","api/ParatransitCT/GetFareEstimate", "post", 
        {'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': '*',
        'mode': 'no-cors'}, data, xCancelSourceForGrid.current
      );

      if(response.error.length === 0 && response.data.httpResponseCode === 200)
      {
        let dataDict = response.data;
        setRiderVerification(dataDict.riderVerificationStatus.trim()); //Display found rider ID status (only shows if FS and Aff are brokers)
        if(dataDict.verifyStatus === "false")
          setSearchButtonValidation(dataDict.displayMessage);
        else 
          setSearchButtonValidation("");
        if(dataDict.vJSON && dataDict.vJSON !== "")
        {
          let EaasJSON = JSON.parse(dataDict.vJSON);
          let NameGiven = (EaasJSON.FirstName ? EaasJSON.FirstName.trim() : "") + (EaasJSON.LastName ? " " + EaasJSON.LastName.trim() : "");
          if(dataDict.verifyStatus === "true")
          {
            setRiderName(NameGiven.trim()); 
          }
        }

        if(dataDict?.eaasPCAApproved != undefined){
          if(dataDict?.eaasPCAApproved === true){
            setIsPCAApprovedFromEaas(true);
          }
        }

        if(dataDict.mobility && dataDict.mobility !== "" && paratransitBookBtnRef.current.textContent.toLowerCase().includes("book"))
        {
          let mobAttrArray = JSON.parse(dataDict.mobility).filter((item) => {return item.iAttrType === 10});
          if(mobAttrArray && mobAttrArray.length > 0)
          {
            let primaryAttr = mobAttrArray[0].iAttrID.toString();
            if(mobilitySavedData.Primary === undefined)
            {
              UpatePrimaryMobilityAttribute(primaryAttr);
            } 
            else if(mobilitySavedData.Primary.hasOwnProperty("Name") && mobilitySavedData.Primary.selectedLabel === "Primary")
            {
              const newPrimary = mobilitySavedData.Primary = {Name: "Primary", Attributes: primaryAttr, selectedAttribute: primaryAttr, selectedLabel: "Primary", type: "primary", index:0, key: CommonFunctions.GenerateUUID()}
              setMobilitySavedData(prev => ({...prev, Primary: newPrimary}));
            }
            if(isPCAApprovedFromEaas || dataDict?.eaasPCAApproved == true){
             setTimeout(() => {
               UpateMobilityAttribute("Guest", "PCA");
             }, 500);
            }
          }
          let tripAttrArray = JSON.parse(dataDict.mobility).filter((item) => {return item.iAttrType !== 10});
          if(tripAttrArray && tripAttrArray.length > 0)
          {
            let tripAttrStr = tripAttrArray.map((item) => item.iAttrID.toString());
            AttributesSelectCallback(tripAttrStr);
          }
        }
        if(dataDict.tripInstructions && dataDict.tripInstructions !== "")
        {
          setPaymentAdditionalInfo(prev => {
            if (!prev) {
              return dataDict.tripInstructions; // Set if empty
            }
            const normalizedPrev = prev.toLowerCase();
            const normalizedInstructions = dataDict.tripInstructions.toLowerCase();
            
            if (normalizedPrev.includes(normalizedInstructions)) {
                return prev;
            }
            return `${prev}\n${dataDict.tripInstructions}`; // Append with newline
          });
          setAgentNotes(dataDict.tripInstructions);
        }
        setFareEstimateAPISummary({copay: parseInt(dataDict.copayPrice), 
          walletID: parseInt(dataDict.eaaSWalletFSID), promo: dataDict.promoCode, eaasJSON: dataDict.vJSON, 
          displayMessage: dataDict.displayMessage, verifyStatus: dataDict.verifyStatus
        });
        if(manualFareChecksRef.current.priceCheck && (manualDataOverwrite.price === "" || parseFloat(manualDataOverwrite.price) === 0))
        {
          setManualDataOverwrite(prevState => ({...prevState, price: dataDict.billableAmount}));
        }
        if(manualFareChecksRef.current.fareCheck /*&& (distanceFlag || (manualDataOverwrite.fare === "" || parseFloat(manualDataOverwrite.fare) === 0))*/)
        {
          setManualDataOverwrite(prevState => ({...prevState, fare: dataDict.totalCost}));
        }
        setShowDynamicModal(false);
        setModalClass("");
        setShowAPILoader(false);
        return response.data;
      }
      else
      {
        setRiderVerification("");
        setSearchButtonValidation("");
        setFareEstimateAPISummary({copay: 0, walletID: 0, promo: "", eaasJSON: "", displayMessage: "", verifyStatus: ""});
        setShowDynamicModal(false);
        setModalClass("");
        setShowAPILoader(false);
        return [];
      }
    }
    catch(err){console.log(err);}
  };

  const handleFareCalculation = async (tripDistance, tripDuration, FSID, CopayFSID, totalWC, totalPax, COSID, AffiliateID, pickupLatLng, Copay, type = "", riderID = "") => {
    try{
      //Function to get the fare estimate at the end of reservation process (when addresses are entered)
      let clientID = (medID ? String(medID) : riderID); //If medical ID exists, use that, otherwise use riderID given in parameter
      let tspidVal = AffiliateData.find(item=>item.AffiliateID === parseInt(AffiliateID)); //Get the correct TSPID for estimate
      let _PCA = GetMobilityCountByLabel("PCA");
      let data = {
        "distance": parseFloat(tripDistance),
        "travelTime": parseFloat(tripDuration),
        "fundingSourceID": parseInt(FSID),
        "copay": parseFloat(Copay),
        "numberOfWheelchairs": parseInt(totalWC),
        "numberOfPassengers": parseInt(totalPax),
        "classOfServiceID": parseInt(COSID),
        "affiliateID": parseInt(AffiliateID),
        "pickupLatitude": parseFloat(pickupLatLng.split(",")[0]),
        "pickupLongitude": parseFloat(pickupLatLng.split(",")[1]),
        "copayFundingSourceID": parseInt(CopayFSID),
        "riderID": (riderID !== ""? riderID : clientID),
        "authorizedStaff": "",
        "startFareZone": fareZonesRef.current.pickFareZone,
        "endFareZone": fareZonesRef.current.dropFareZone,
        "tspid": (tspidVal ? String(tspidVal.iOutTSPID) : ""),
        "httpResponseCode": 200,
        "PCAPassengersCount": _PCA
      }
      if(parseFloat(pickupLatLng.split(",")[0]) > 0)
      {
        setModalHeaderText("Get Fare Estimate Processing");
        setModalBodyHTML("Please wait...");
        setModalFooterHTML(
          <>
            <Button variant='dark' className="border-0" onClick={()=>{setShowDynamicModal(false);}}>
              OK
            </Button>
          </>
        );
        setShowDynamicModal(true);
        setModalClass("d-none");
        setShowAPILoader(true);
        xCancelSourceForGrid.current = APICom.GenerateSource();
        let response = await APICom.fetchData("ReservationCoreURL","api/ParatransitCT/GetFareEstimate", "post", 
          {'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
          'mode': 'no-cors'}, data, xCancelSourceForGrid.current
        );

        if(response.error.length === 0)
        {
          if(response.data.httpResponseCode === 200)
          {
            let dataDict = response.data;
            setRiderVerification(dataDict.riderVerificationStatus.trim()); //Display found rider ID status (only shows if FS and Aff are brokers)
            if(dataDict.verifyStatus === "false") //Display alert message in red on top if rider ID is rejected (only shows if FS and Aff are brokers)
              setSearchButtonValidation(dataDict.displayMessage);
            else 
              setSearchButtonValidation("");

            if(dataDict.vJSON && dataDict.vJSON !== "")
            {
              let EaasJSON = JSON.parse(dataDict.vJSON);
              let NameGiven = (EaasJSON.FirstName ? EaasJSON.FirstName.trim() : "") + (EaasJSON.LastName ? " "+  EaasJSON.LastName.trim() : "");
              if(dataDict.verifyStatus === "true")
              {
                setRiderName(NameGiven.trim()); 
              }
              
              if(EaasJSON?.RiderID != undefined && EaasJSON?.RiderID != ""){
                setMedID(EaasJSON.RiderID);
              }
            }
            if(dataDict?.eaasPCAApproved != undefined){
              if(dataDict?.eaasPCAApproved === true){
                setIsPCAApprovedFromEaas(true);
              }
            }
            if(dataDict.mobility && dataDict.mobility !== "" && paratransitBookBtnRef.current.textContent.toLowerCase().includes("book"))
            {
              let mobAttrArray = JSON.parse(dataDict.mobility).filter((item) => {return item.iAttrType === 10});
              if(mobAttrArray && mobAttrArray.length > 0)
              {
                let primaryAttr = mobAttrArray[0].iAttrID.toString();
                if(mobilitySavedData.Primary === undefined)
                {
                  UpatePrimaryMobilityAttribute(primaryAttr);
                } 
                else if(mobilitySavedData.Primary.hasOwnProperty("Name") && mobilitySavedData.Primary.selectedLabel === "Primary")
                {
                  const newPrimary = mobilitySavedData.Primary = {Name: "Primary", Attributes: primaryAttr, selectedAttribute: primaryAttr, selectedLabel: "Primary", type: "primary", index:0, key: CommonFunctions.GenerateUUID()}
                  setMobilitySavedData(prev => ({...prev, Primary: newPrimary}));
                }
                if(isPCAApprovedFromEaas || (dataDict?.eaasPCAApproved != undefined && dataDict?.eaasPCAApproved == true)){
                  setTimeout(() => {
                    UpateMobilityAttribute("Guest", "PCA");
                  }, 500);
                }
              }
              let tripAttrArray = JSON.parse(dataDict.mobility).filter((item) => {return item.iAttrType !== 10});
              if(tripAttrArray && tripAttrArray.length > 0)
              {
                let tripAttrStr = tripAttrArray.map((item) => item.iAttrID.toString());
                AttributesSelectCallback(tripAttrStr);
              }
            }
            if(dataDict.tripInstructions && dataDict.tripInstructions !== "")
            {
              setPaymentAdditionalInfo(prev => {
                if (!prev) {
                  return dataDict.tripInstructions; // Set if empty
                }
                const normalizedPrev = prev.toLowerCase();
                const normalizedInstructions = dataDict.tripInstructions.toLowerCase();
                
                if (normalizedPrev.includes(normalizedInstructions)) {
                    return prev;
                }
                return `${prev}\n${dataDict.tripInstructions}`; // Append with newline
              });
              setAgentNotes(dataDict.tripInstructions);
            }
            setFareEstimateAPISummary({copay: parseInt(dataDict.copayPrice), 
              walletID: parseInt(dataDict.eaaSWalletFSID), promo: dataDict.promoCode, eaasJSON: dataDict.vJSON, 
              displayMessage: dataDict.displayMessage, verifyStatus: dataDict.verifyStatus
            }); //Save all rider ID fare details for reservation use in a useState var
            let fareData = response.data;
            const queryParams = new URLSearchParams(window.location.search);
            const tripSelected = queryParams.get('TripSelected') || activeTripSelected? true:false;
            let editRowData = (PersistStorage.retrieve("rowDataEditTrip", true)  && tripSelected? PersistStorage.retrieve("rowDataEditTrip", true):"");
            if(manualFareChecksRef.current.priceCheck && (manualDataOverwrite.price === "" || parseFloat(manualDataOverwrite.price) === 0))
            {
              if(paratransitBookBtnRef.current && ((editRowData && editRowData !== "" && verifiedAddr.length >= 1 && !editRowData.addressInfo.trips[(verifiedAddr.length)]) || paratransitBookBtnRef.current.textContent.trim().toLowerCase() !== "update"))
              {
                setManualDataOverwrite(prevState => ({...prevState, price: fareData.billableAmount}));
              }
            }
            if(manualFareChecksRef.current.fareCheck /*&& (manualDataOverwrite.fare === "" || parseFloat(manualDataOverwrite.fare) === 0)*/)
            {
              if(paratransitBookBtnRef.current && ((editRowData && editRowData !== "" && verifiedAddr.length >= 1 && !editRowData.addressInfo.trips[(verifiedAddr.length)]) || paratransitBookBtnRef.current.textContent.trim().toLowerCase() !== "update"))
              {
                setManualDataOverwrite(prevState => ({...prevState, fare: dataDict.totalCost}));
              }
            }
            setFareDataArr(fareData); //Set all fare related data on a useState var for use in reservation
            if(type === "")
            {
              setClientSummary(prevState=>({...prevState, 
                TripFare:fareData.totalCost, TripCopay:fareData.copay
              }));
              setCopayAmount(fareData.copay); //Set the copay and cost to correct values from API
            }
            setShowDynamicModal(false);
            setModalClass("");
            setShowAPILoader(false);
          }
          else
          {
            setModalClass("");
            setShowAPILoader(false);
            setModalHeaderText("Fare Calculation Failed");
            setModalBodyHTML("Error code: "+ response.data.httpResponseCode+ " Please contact the admin office for help.");
            setModalFooterHTML(
              <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                OK
              </Button>
            );
            setRiderVerification("");
            setSearchButtonValidation("");
            setFareEstimateAPISummary({copay: 0, walletID: 0, promo: "", eaasJSON: "", displayMessage: "", verifyStatus: ""});
          }
        }
        else
        {
          setModalClass("");
          setShowAPILoader(false);
          setModalHeaderText("Fare Calculation Failed");
          setModalBodyHTML(response.error);
          setModalFooterHTML(
            <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
              OK
            </Button>
          );
          setRiderVerification("");
          setSearchButtonValidation("");
          setFareEstimateAPISummary({copay: 0, walletID: 0, promo: "", eaasJSON: "", displayMessage: "", verifyStatus: ""});
        }
      }
    }
    catch(err){console.log(err);}
  };


  const GetMobilityCountByLabel = (label) => {
    let _totalCount = 0;
    try {
      if(label === "PCA"){ 
        if(isNormalizedFormat(mobilitySavedData) == false){
          _totalCount = Object.entries(mobilitySavedData).find(([key, value]) => value.selectedLabel === label).filter(p => p.selectedLabel == label).length;
        }
        else{
          if(mobilityDbData?.PCA != undefined){
            _totalCount = mobilityDbData.PCA.length;
          }
          else if(mobilitySavedData?.PCA != undefined){
            _totalCount = mobilitySavedData.PCA.length;
          }
          else{
            _totalCount = 0;
          }
        }
      }
      
    } catch (error) {
      return 0;
    }
    return _totalCount;
  }

  const UpatePrimaryMobilityAttribute = (primaryAttr) => {
    let primaryItem;
    try {
      primaryItem = Object.entries(mobilitySavedData).find(([key, value]) => value.selectedLabel === "Primary");
  
      if (primaryItem) {
        const [rowKey, rowValue] = primaryItem;
        rowValue.Attributes = primaryAttr;
        rowValue.selectedAttribute = primaryAttr;
        setMobilitySavedData(prev => ({
          ...prev,
          [rowKey]: {
            ...rowValue,
          }
        }));
      }
    } catch (error) { 

    }
  }

  const UpateMobilityAttribute = (selectedLabel, labelToBeUpdated) => {
    let guestItem;
    let labelToBeUpdatedExists;
    let PCAData = [];
    try {

      if(isNormalizedFormat(mobilitySavedData)){// It has keys like "PCA", "Primary", "Guests" etc....
        if(mobilitySavedData.PCA?.length === 0 && mobilitySavedData.Guests?.length === 0) 
        {
          const itemsToGenerate = { PCA: 1 };
          const generateData = generateRows(mobilityAttributeOptions, itemsToGenerate);
          if(generateData){
            PCAData.push(...generateData);
          }
        }
  
        else if(mobilitySavedData?.PCA?.length == 0 && mobilitySavedData?.Guests?.length > 0){
          //In this case remove the guest and make it PCA and insert to PCA
          let movedRecord = mobilitySavedData.Guests.shift(); // removes first element from guest
          movedRecord.selectedLabel = "PCA";
          movedRecord.Name = "PCA";
          PCAData.push(...movedRecord);
        }
        else if(mobilitySavedData?.PCA?.length == 0 && mobilitySavedData?.Guests?.length == 0){
          //In this case insert a new PCA
          const itemsToGenerate = { PCA: 1 };
          const generateData = generateRows(mobilityAttributeOptions, itemsToGenerate);
          if(generateData){
            PCAData.push(...generateData);
          }
        }      
        setMobilitySavedData(prev => ({
          ...prev,
          PCA: PCAData
        }));
  
        setMobilityDbData(prev => ({
          ...prev,
          PCA: PCAData
        }));
      }
      else{
        guestItem = Object.entries(mobilitySavedData).find(([key, value]) => value.selectedLabel === selectedLabel);
        labelToBeUpdatedExists = Object.entries(mobilitySavedData).find(([key, value]) => value.selectedLabel === labelToBeUpdated);
    
        if (guestItem && labelToBeUpdatedExists == undefined) {
          const [rowKey, rowValue] = guestItem;
          rowValue.selectedLabel = labelToBeUpdated;
          rowValue.Name = labelToBeUpdated;
          setMobilitySavedData(prev => ({
            ...prev,
            [rowKey]: {
              ...rowValue,
            }
          }));
        }
        else if(labelToBeUpdated == undefined){ // when no entry for labelToBeUpdated
          const itemsToGenerate = { PCA: 1 };
          const generateData = generateRows(mobilityAttributeOptions, itemsToGenerate);
          if(generateData){
            PCAData.push(...generateData);
          }
  
          setMobilitySavedData(prev => ({
            ...prev,
            PCA: PCAData
          }));
  
          setMobilityDbData(prev => ({
            ...prev,
            PCA: PCAData
          }));
        }
      }

      
    } catch (error) { 

    }
  }

  function isNormalizedFormat(data) {
    if (!Array.isArray(data)) return false;

    return data.every(
      item => Array.isArray(item) && KNOWN_KEYS.includes(item[0])
    );
  }

  const handleRCZVerification = async (type, actualAddr, addr2 = " ") => {
    try{
      let data = {};
      let verifiedDropAddr = (dropAddr === ""? "123 Main St, Annapolis, MD 21401":dropAddr);
      let verifiedPUAddr =  (pickupAddr === ""? "123 Main St, Annapolis, MD 21401":pickupAddr);
      let pickCity = "";
      let pickState = "";
      let pickZip = "";
      let pickStreet = "";
      let dropCity = "";
      let dropState = "";
      let dropZip = "";
      let dropStreet = "";
      let combinedDataAddedTime = (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "Ta01")).value;
      let userEnteredPickupAddress = prepareDataForAddress(mapPointPickupSelection, "pickup");
      let userEnteredDropoffAddress = prepareDataForAddress(mapPointDropoffSelection, "dropoff"); //Populating the info for manually entered addresses
      bookBtnRef.current.disabled = true;
      const currDate = systemDateTimeRef.current.date;

      let stopMarkersArr = [];
      let filteredMapMarkers = mapData.filter((item)=>{
        if(item.Type === "Stop")
        {
          stopMarkersArr.push(item);
        }
        return item.Type === "PU";
      });
      stopMarkersArr.push({lat:parseFloat(dropLatLng.current.split(",")[0]),
        lng: parseFloat(dropLatLng.current.split(",")[1]), Type:"DO", 
        name:(riderName === "" ? "N/A" : riderName.trim()), address: dropAddr
      }); 
      filteredMapMarkers.push(...stopMarkersArr);

      if(!userEnteredPickupAddress.street || userEnteredPickupAddress.street === "")
      {
        userEnteredPickupAddress.street = pickupAddr;
      }

      if(pickupVirtualStop?.value && pickupVirtualStop?.value !== ""){
        try {
          const virtualStopData = VirtualStopsData.find(p => p.ID === pickupVirtualStop.value);
          if(virtualStopData){
            userEnteredPickupAddress.city = userEnteredPickupAddress.city || virtualStopData.City || "";
            userEnteredPickupAddress.state = userEnteredPickupAddress.state || virtualStopData.State || "";
            userEnteredPickupAddress.zip = userEnteredPickupAddress.zip || virtualStopData.Zipcode || "";
          }
        } catch (error) { }
      }

      if(!userEnteredDropoffAddress.street || userEnteredDropoffAddress.street === "")
      {
        userEnteredDropoffAddress.street = dropAddr;
      }

      if(dropAddrVirtualStop?.value && dropAddrVirtualStop?.value !== ""){
        try {
          const virtualStopData = VirtualStopsData.find(p => p.ID === dropAddrVirtualStop.value);
          if(virtualStopData){
            userEnteredDropoffAddress.city = userEnteredDropoffAddress.city || virtualStopData.City || "";
            userEnteredDropoffAddress.state = userEnteredDropoffAddress.state || virtualStopData.State || "";
            userEnteredDropoffAddress.zip = userEnteredDropoffAddress.zip || virtualStopData.Zipcode || "";
          }
        } catch (error) { }
      }

      data = {
        "Ta01": (combinedDataAddedTime? combinedDataAddedTime:0),
        "iAffiliateID": parseInt(selectedAff),
        "vPULatitude": pickLatLng.current.split(",")[0],
        "vPULongitude": pickLatLng.current.split(",")[1],
        "vDOLatitude": dropLatLng.current.split(",")[0],
        "vDOLongitude": dropLatLng.current.split(",")[1],
        "dtPickupDateTime": (schTime !== "" ? currDate+" "+schTime:"01/01/1900 00:00:00"),
        "dEstimatedTime": 0.0,
        "RCZList": "",
        "ErrorMessage": "",
        "PUDONearbyVS" : {
          "userid": loginData.iUserID,
          "brandid": "3",
          "iAffiliateID": parseInt(selectedAff),
          "pulocation": "",
          "pustreet": pickStreet,
          "pucity": pickCity,
          "pustate": pickState,
          "puzip": pickZip,
          "puaddress": (type === "PU" ? actualAddr : verifiedPUAddr),
          "puinstruction": pickExtraInfo,
          "pulatitude": pickLatLng.current.split(",")[0],
          "pulongitude": pickLatLng.current.split(",")[1],
          "dolocation": "",
          "dostreet": dropStreet,
          "docity": dropCity,
          "dostate": dropState,
          "dozip": dropZip,
          "doaddress": (type === "PU"? verifiedDropAddr : actualAddr),
          "doinstruction": dropExtraInfo,
          "dolatitude": dropLatLng.current.split(",")[0],
          "dolongitude": dropLatLng.current.split(",")[1]
        },
        "vPUStreetAddress": (userEnteredPickupAddress?.street || ""), 
        "vPUCity": (userEnteredPickupAddress?.city || ""), 
        "vPUState": (userEnteredPickupAddress?.state || ""), 
        "vPUZip": (userEnteredPickupAddress?.zip || ""), 
        "vDOStreetAddress": (userEnteredDropoffAddress?.street || ""), 
        "vDOCity": (userEnteredDropoffAddress?.city || ""), 
        "vDOState": (userEnteredDropoffAddress?.state || ""),
        "vDOZip": (userEnteredDropoffAddress?.zip || ""), 
        "iAppID": iAppID, 
        "iUserID": String(loginData.iUserID),
        "vPUStopName": (pickupVirtualStop.name !== "" ? pickupVirtualStop.name : puVSValueChanged.current),
        "vDOStopName": (dropAddrVirtualStop.name !== "" ? dropAddrVirtualStop.name : doVSValueChanged.current),
        "vCustomerPhone": phone,
        "vCustomerName": riderName
      };
      setModalHeaderText("Validation");
      setModalBodyHTML("Please wait for the validation...");
      setModalFooterHTML("");
      setModalClass("d-none");
      setShowDynamicModal(true);
      puVSCallValidation.current = false;
      doVSCallValidation.current = false;
      xCancelSourceForGrid.current = APICom.GenerateSource(); //Validate RCZ
      setShowAPILoader(true);
      let response = await APICom.fetchData("ReservationCoreURL","ValidateRCZ", "post", 
        {'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': '*',
        'mode': 'no-cors'}, data, xCancelSourceForGrid.current
      );
      if(response.error.length === 0)
      {
        let errorMsg  = response.data.errorMessage;
        let responseMsg = response.data.responseMessage;
        if(responseMsg && responseMsg !== "")
        {
          setModalHeaderText("RCZ Verification Error");
          setModalBodyHTML(responseMsg);
          setModalFooterHTML(
            <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
              OK
            </Button>
          );
          setModalClass("");
          setShowDynamicModal(true);
          setZones("");
          setShowAPILoader(false);

          setMapData(filteredMapMarkers);
        }
        else if(errorMsg && errorMsg !== "")
        {
          setModalHeaderText("RCZ Verification Error");
          setModalBodyHTML(errorMsg);
          setModalFooterHTML(
            <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
              OK
            </Button>
          );
          setModalClass("");
          setShowDynamicModal(true);
          setZones("");
          setShowAPILoader(false);

          setMapData(filteredMapMarkers);
        }
        else
        {
          //Work after verification
          if(pickLatLng.current === dropLatLng.current) //Check for duplicate addresses
          {
            setShowAPILoader(false);
            setModalHeaderText("Identical Address Selection Error");
            setModalBodyHTML("Please select two different addresses to continue.");
            setModalFooterHTML(
              <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                OK
              </Button>
            );
            setModalClass("");
            setShowDynamicModal(true);
          }
          else
          {
            if(response.data.pudoNearbyVS.pvs && response.data.pudoNearbyVS.dvs)
            {
              let tripLatLng = []; //starts with given address, second is PU VS, third is DO VS, and final is the given destination
              let matchedDataPUVS = "";
              let matchedDataDOVS = "";
              setModalClass("");
              setShowDynamicModal(false);
              setShowAPILoader(false);
              setRczVerifData(response.data);
              bookBtnRef.current.disabled = false;
              if(response.data.rczList)
              {
                setZones(response.data.rczList); //Set zones to correct rcz after validation
              }
              //Get the markers for provided addresses along with any walk markers if needed
              tripLatLng.push(
                (response.data.pudoNearbyVS.pvs.latitude !== response.data.pudoNearbyVS.pu.latitude && response.data.pudoNearbyVS.pvs.longitude !== response.data.pudoNearbyVS.pu.longitude
                ? {lat:parseFloat((pickLatLng.current.split(",")[0])),
                  lng: parseFloat((pickLatLng.current.split(",")[1])), Type:"Walk", 
                  name:(riderName === "" ? "N/A" : riderName.trim()), 
                  address:(type === "PU"? actualAddr:(pickupAddr === ""? addr2:pickupAddr))
                }:{lat:"",
                lng: "", Type:"Walk", 
                name:(riderName === "" ? "N/A" : riderName.trim()), 
                address:(type === "PU"? actualAddr:(pickupAddr === ""? addr2:pickupAddr))
                }),
                {lat: (parseFloat(response.data.pudoNearbyVS.pvs.latitude)),
                  lng: (parseFloat(response.data.pudoNearbyVS.pvs.longitude)), Type:"PU", 
                  name:(riderName === "" ? "N/A" : riderName.trim()), 
                  address:(response.data.pudoNearbyVS.pvs.address)
                },
                {lat:(parseFloat(response.data.pudoNearbyVS.dvs.latitude)),
                  lng: (parseFloat(response.data.pudoNearbyVS.dvs.longitude)), Type:"DO", 
                  name:(riderName === "" ? "N/A" : riderName.trim()), 
                  address:(response.data.pudoNearbyVS.dvs.address)
                },
                (response.data.pudoNearbyVS.dvs.latitude !== response.data.pudoNearbyVS.do.latitude && response.data.pudoNearbyVS.dvs.longitude !== response.data.pudoNearbyVS.do.longitude
                ? {lat:parseFloat((dropLatLng.current.split(",")[0])),
                  lng: parseFloat((dropLatLng.current.split(",")[1])), Type:"Drop", 
                  name:(riderName === "" ? "N/A" : riderName.trim()), 
                  address:(type === "DO"? actualAddr:(dropAddr === ""?addr2:dropAddr))
                }:{lat:"",
                lng: "", Type:"Drop", 
                name:(riderName === "" ? "N/A" : riderName.trim()), 
                address:(type === "DO"? actualAddr:(dropAddr === ""?addr2:dropAddr))
                }),
              );
              
              //Loop to get correct virtual stops from dropdowns for selecting and distance calculation
              for(let k = 0; k < VirtualStopsData.length; k++) 
              {
                if(parseInt(selectedAff) === parseInt(VirtualStopsData[k].iSATSPID))
                {
                  if(response.data.pudoNearbyVS.pvs && String(response.data.pudoNearbyVS.pvs.id) === String(VirtualStopsData[k].ID))
                  {
                    matchedDataPUVS = VirtualStopsData[k].Location+"$"+VirtualStopsData[k].ID;
                  }
                  if(response.data.pudoNearbyVS.dvs && String(response.data.pudoNearbyVS.dvs.id) === String(VirtualStopsData[k].ID))
                  {
                    matchedDataDOVS = VirtualStopsData[k].Location+"$"+VirtualStopsData[k].ID;
                  }
                }
              }

              if(response.data.pudoNearbyVS.pvs) { //Calculate walk distance for given PU VS
                setPickupVirtualStop((matchedDataPUVS === "" ? {...pickupVirtualStop, value:"PU VS", name:""}
                :{...pickupVirtualStop, value:matchedDataPUVS.split("$")[1], name:matchedDataPUVS.split("$")[0]})); 
                let pickLatLng = response.data.pudoNearbyVS.pvs.latitude+","+response.data.pudoNearbyVS.pvs.longitude;
                await handleWalkDistanceCalculation("PU", pickLatLng);
              }
              
              if(response.data.pudoNearbyVS.dvs) { //Calculate walk distance for given DO VS
                setDropAddrVirtualStop((matchedDataDOVS === "" ? {...dropAddrVirtualStop, value:"DO VS", name:""}
                :{...dropAddrVirtualStop, value:matchedDataDOVS.split("$")[1], name:matchedDataDOVS.split("$")[0]}));
                let dropLatLng = response.data.pudoNearbyVS.dvs.latitude+","+response.data.pudoNearbyVS.dvs.longitude;
                await handleWalkDistanceCalculation("DO", dropLatLng);
              }
              vsChangeRef.current.type = "";
              SetMicrotransitMapWalkPolyline(microPolylineDict.current);
              microPolylineDict.current = {pick: 0, drop: 0};
              setMapData(tripLatLng);
              let correctDate = formatDate(selectedDateSchTime);
              let VSDict = {pick: (response.data.pudoNearbyVS.pvs.latitude+","+response.data.pudoNearbyVS.pvs.longitude), drop: (response.data.pudoNearbyVS.dvs.latitude+","+response.data.pudoNearbyVS.dvs.longitude)};
              await handleAddressDetails("PU", "", (type !== "PU"? verifiedDropAddr : actualAddr), (type === "PU"? verifiedDropAddr : actualAddr), correctDate, schTime, VSDict);
            }
            else if (response.data.pudoNearbyVS.responseCode !== 200 && response.data.pudoNearbyVS.responseMessage !== "")
            {
              setModalHeaderText("Validation");
              setModalBodyHTML(response.data.pudoNearbyVS.responseMessage);
              setModalFooterHTML(
                <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                  OK
                </Button>
              );
              setModalClass("");
              setShowDynamicModal(true);
              setZones("");
              setShowAPILoader(false);

              setMapData(filteredMapMarkers);
            }
            else
            {
              setModalHeaderText("No Virtual Stop Assigned");
              setModalBodyHTML("The verification process could not provide virtual stops for the given addresses. Please try again.");
              setModalFooterHTML(
                <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                  OK
                </Button>
              );
              setModalClass("");
              setShowDynamicModal(true);
              setZones("");
              setShowAPILoader(false);

              setMapData(filteredMapMarkers);
            }
          } 
        }
      }
      else
      {
        setModalHeaderText("RCZ Verification Failed");
        setModalBodyHTML(response.error);
        setModalFooterHTML(
          <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
            OK
          </Button>
        );
        setModalClass("");
        setShowDynamicModal(true);
        setShowAPILoader(false);

        setMapData(filteredMapMarkers);
      }
    }
    catch(err){console.log(err);}
  };

  const handleBlurRiderID = async (e) => { //Called when rider ID is out of focus to check elgibility
    try{
      let LatLng = (pickLatLng.current === "" ? "0,0" : pickLatLng.current);
      if(true)
      {
        await getFareDataResponse(0, 0, 
          FSSelected, copayFSSelected, passengerTypeCount.totalWC, passengerTypeCount.total, 
          COSSelected, selectedAff, LatLng, copayAmount, e.target.value
        );
      }
    }
    catch(err){console.log(err);}
  };
  //Function to handle multiplier check for OSRM duration
  const handleZoneSpeedMultiplierChecks = (dispatchPUZone = '', dispatchDOZone = '', affiliateID = 0, durationInSeconds = 0) => {
    try
    {
      let secondsToMinutes = 0;
      if(durationInSeconds > 0){
        secondsToMinutes = durationInSeconds / 60;
      }
      const speedMultiplierTable = (ZoneSpeedMultiplier && Array.isArray(ZoneSpeedMultiplier) ? ZoneSpeedMultiplier.filter((item)=>parseInt(item.iAffiliateID) === parseInt(affiliateID)) : []);
      const OSRM_TIME = (ASCSSettingData ? (JSON.parse(ASCSSettingData[affiliateID]).find((item)=>item.SubTitle === "OSRM_Time")).value : 1);
      let durationMultiplier = 1;
      let bZoneMultiplierApplied = false;
      if(speedMultiplierTable.length > 0)
      {
        let match =
        speedMultiplierTable.find(entry =>
          entry.vFromZone === dispatchPUZone &&
          entry.vToZone === dispatchDOZone &&
          secondsToMinutes >= entry.dFromTime &&
          secondsToMinutes < entry.dToTime
        ) ||
        speedMultiplierTable.find(entry =>
          entry.vFromZone === '' &&
          entry.vToZone === dispatchDOZone &&
          secondsToMinutes >= entry.dFromTime &&
          secondsToMinutes < entry.dToTime
        ) ||
        speedMultiplierTable.find(entry =>
          entry.vFromZone === dispatchPUZone &&
          entry.vToZone === '' &&
          secondsToMinutes >= entry.dFromTime &&
          secondsToMinutes < entry.dToTime
        );

        if (match) {
          durationMultiplier = parseFloat(match.dSlabMultiplier);
        } else {
          durationMultiplier = parseFloat(speedMultiplierTable[0].dMultiplier); // fallback
        }
        bZoneMultiplierApplied = true;
      }
      let multiplier = (bZoneMultiplierApplied ? parseFloat(durationMultiplier) : parseFloat(OSRM_TIME));
      let timeInMinutes = (parseFloat(durationInSeconds)/60) * multiplier;
      return timeInMinutes;
    }
    catch(err){console.log(err); return (parseFloat(durationInSeconds)/60);}
  };

  const handleBlurDistance = async (e) => {
    let LatLng = (pickLatLng.current === "" ? "0,0" : pickLatLng.current);
    let givenDist = (e.target ? e.target.value : e);
      if(pickLatLng.current !== "")
      {
        await getFareDataResponse(givenDist, clientSummary.TripDuration, 
          FSSelected, copayFSSelected, passengerTypeCount.totalWC, passengerTypeCount.total, 
          COSSelected, selectedAff, LatLng, copayAmount, 0, true
        );
      }
  };

  const wrapperHandleAddressDetails = async(type, data, addrVerfPU, addrVerfDO, addrVerfDate, addrVerfTime)=>{ //wrapper for drive distance & duration API
    try {
      await handleAddressDetails(type, data, addrVerfPU, addrVerfDO, addrVerfDate, addrVerfTime);
    } catch (err) {console.log(err);}
  }

  const handleAddressDetails = async(type, data, addrVerfPU, addrVerfDO, addrVerfDate, addrVerfTime, RCZVSLatLng = {pick:'', drop:''})=>{
    try{
      //OSRM API to get distance & duration of two points (PU/DO) while recalculating fare estimate and saving trip details for use in multi-trip
      let origin = (RCZVSLatLng.pick !== '' ? RCZVSLatLng.pick : pickLatLng.current);
      let dest = (RCZVSLatLng.drop !== '' ? RCZVSLatLng.drop : dropLatLng.current);
      let addressAPI = ITCMapDirections.current + "?origin=" + origin + "&destination=" + dest + "&AppType=calltaker"; //"&bounds=" + mapBounds+ 
      let OSRMResponse = await APICom.fetchData("full", addressAPI, "get", {
        'Authorization': 'Basic '+btoa(OSRM_Username.current + ":" + OSRM_Password.current),
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': '*',
        'mode': 'no-cors'
      }, {});

      if(OSRMResponse && OSRMResponse.data.status.toUpperCase() === "OK")
      {
        let distanceInMeters = OSRMResponse.data.routes[0].legs[0].distance.value;
        let durationInSeconds = OSRMResponse.data.routes[0].legs[0].duration.value;
        let TimeCalculated = 0;
        if(OSRMResponse.data.mapSource === 'OSRM')
        {
          TimeCalculated = handleZoneSpeedMultiplierChecks(dispatchZones.pickZone, dispatchZones.dropZone, selectedAff, durationInSeconds);
        }
        else
        {
          TimeCalculated = (parseInt(durationInSeconds)/60);
        }
        let distance = parseFloat(parseFloat(distanceInMeters)/1609).toFixed(1);
        let duration = parseFloat(TimeCalculated).toFixed(2);
        setClientSummary(prevState=>({...prevState, 
          tripDistance: distance, TripDuration:duration
        }));
        if(addrVerfTime === "" && verifiedAddr.length === 0){addrVerfTime = systemDateTimeRef.current.time}
        setTripDetails({...tripDetails, pickAddr: addrVerfPU, dropAddr: addrVerfDO, date: addrVerfDate, time: addrVerfTime, distance: distance, duration: duration,
          fare: 0, copay: 0, waitTime:"",
          willCall: willCall, apptTime: appointmentTime, notes:agentNotes, phone:callBackPhone, puNotes:pickExtraInfo, doNotes:dropExtraInfo, 
          riderName:riderName, passCount: passengerTypeCount
        });
        // if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2))
        // {
          wrapperHandleFareCalc(distance, duration, FSSelected, copayFSSelected, passengerTypeCount.totalWC, passengerTypeCount.total, COSSelected, selectedAff, pickLatLng.current, copayAmount);
        // }
      }
      else if(OSRMResponse.data.status.toUpperCase().includes("EXCEEDED"))
      {
        setModalHeaderText("Directions Alert");
        setModalBodyHTML(OSRMResponse.data.status);
        setModalFooterHTML(
          <>
          <Button variant='dark' className="border-0" onClick={()=>{setShowDynamicModal(false);}}>
            OK
          </Button>
          </>
        );
        setShowDynamicModal(true);
      }
    }
    catch(err){console.log(err);}
  };

  const handleAffChange = (e)=>{
    try{
      const newAffVal = (e.target? e.target.value : e);

      setSchTime("");  //Upon affiliate change on call taker, only have client Info open, reset PU time and other parameters, get new aff data and populate it for all dropdowns
      setDriverVehInfoDisplay(false);
      setPaymentDetailsDisplay(false);
      setAdditionalDetailsDisplay(false);
      setInsuranceInfoDisplay(false);
      transitTypeRef.current = AffiliateData.filter((item,index) => {
        try{
          return parseInt(item.AffiliateID) === parseInt(newAffVal);
        }
        catch(err){console.log(err);}
      });
      const familyAffiliates = (transitTypeRef.current.length > 0 ? AffiliateData.filter((item) => {
        return parseInt(item.DTSPID) === parseInt(transitTypeRef.current[0].DTSPID) && parseInt(item.iTransType) === 2;
      }) : []);
      const isMicroIncluded = (familyAffiliates.length > 0);
      const dynamicCallAgentHeight = (transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2)
        ? { height: "396px", maxHeight: "396px" }
        : { height: `calc(100vh - 125px)` }; //Creating dynamic style for main two columns on call taker to avoid repetition
      const rowContainerDynamicHeight = (transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2)
        ? { marginLeft: "10%", marginRight:"10%", boxShadow:"-2px 0px 3px #999, 2px 0px 3px #999" }
        : { height: `calc(100vh - 125px)`, marginLeft: "10%", marginRight:"10%", boxShadow:"-2px 0px 3px #999, 2px 0px 3px #999" };
      
      let vehData = (DispatchVehicleData[parseInt(newAffVal)] && DispatchVehicleData[parseInt(newAffVal)] !== ""? DispatchVehicleData[parseInt(newAffVal)]: []);
      let vehNum = (vehData.length !== 0 ? handleDuplicates(JSON.parse(vehData), "VehicleNumber") : []);
      let vehType = (vehData.length !== 0 ? handleDuplicates(JSON.parse(vehData), "VehicleType") : []);
      let driverNum = DispatchDriverData[parseInt(newAffVal)] ? JSON.parse(DispatchDriverData[parseInt(newAffVal)]) : [];
      let languageTypes = ["English", "Spanish", "Chinese", "Tagalog", "Vietnamese", "Arabic", "French", "Korean", "Russian", "Haitian Creole",
        "Hindi", "Portuguese", "Italian", "Polish", "Urdu", "Japanese", "Persian", "Gujarati", "Telugu", "Bengali", "Greek", "Punjabi", "Tamil", 
        "Armenian", "Serbo-Croatian", "Hebrew"];
      let languageOptions = languageTypes.map(function(item, index){
        return(
          <option key={index} value={(index+1)}>{item}</option>
        );
      })
      let vehicleNumOptionsHTML = vehNum.map(function(item, index){
        return(
            <option key={index} value={item.VehicleID+"_"+item.VehicleNumber}>{item.VehicleNumber}</option>
        );
      });
      let vehicleTypeOptionsHTML = vehType.map(function(item, index){
        if(item.VehicleType !== null && item.VehicleType.toUpperCase() !== "TESTTYPE")
        {
          return(
            <option key={index} value={item.iVTypeID} data-virtual={item.MaxWheelChairs}>{item.VehicleType}</option>
          );
        }
      });
      let driverNumberOptionsHTML = driverNum.map(function(item, index){
        return(
          <option key={index} value={item.DriverID+"_"+item.DriverNumber}>{item.DriverNumber}</option>
        );
      });
      vehicleTypeOptionsHTML.unshift(<option key={333} value={"VT"}>{"None"}</option>);
      vehicleNumOptionsHTML.unshift(<option key={444} value={"VN"}>{"None"}</option>);
      driverNumberOptionsHTML.unshift(<option key={555} value={"DN"}>{"None"}</option>);
      languageOptions.unshift(<option key={666} value={"Language"}>{"None"}</option>);
      let attrSelection = AttributeData ? AttributeData.filter((item,index)=> {return parseInt(item.iAttrATSPID) === parseInt(newAffVal) && parseInt(item.iAttrType) !== 10 }) : [];
      let fsSelection = FundingSourceData[parseInt(newAffVal)] && FundingSourceData[parseInt(newAffVal)] !== undefined ? JSON.parse(FundingSourceData[parseInt(newAffVal)]) : [];
      let cosSelection = ClassOfServiceData[parseInt(newAffVal)] && ClassOfServiceData[parseInt(newAffVal)] !== undefined ? JSON.parse(ClassOfServiceData[parseInt(newAffVal)]) : [];
      let paySelection = PaymentTypesData[parseInt(newAffVal)] && PaymentTypesData[parseInt(newAffVal)] !== undefined ? JSON.parse(PaymentTypesData[parseInt(newAffVal)]) : [];
      let copayFSSetting = (ASCSSettingData[parseInt(newAffVal)] ? (JSON.parse(ASCSSettingData[parseInt(newAffVal)]).find((item) => item.SubTitle === "CopayFSID_List")).value : "");
      let ASCSGlobalBrokerMode = (ASCSSettingData[parseInt(newAffVal)] ? 
        (JSON.parse(ASCSSettingData[parseInt(newAffVal)]).find((item) => item.SubTitle === "BrokerMode")).value : 0
      );
      let SettingData = (newAffVal && ASCSSettingData[newAffVal] ? JSON.parse(ASCSSettingData[newAffVal]) : "");
      let AgentPriceAdjustmentFSIDs = (SettingData !== "" ? (SettingData.find((item) => item.SubTitle === "FS_IDs_AgentPriceAdjustment")).value : "");
      let SDEnableNegotiatedFare = (SettingData !== "" ? SettingData.find((item) => item.SubTitle === "SDEnableNegotiatedFare").value : 0);
      let AgentPriceAdjustmentFareFSIDsSetting = (SettingData !== "" ? (SettingData.find((item) => item.SubTitle === "FS_IDs_AgentFareAdjustment")).value : "");
      manualCheckRef.current = {AgentPriceAdjustmentFSIDs: AgentPriceAdjustmentFSIDs, SDEnableNegotiatedFare: SDEnableNegotiatedFare, AgentPriceAdjustmentFareFSIDs: AgentPriceAdjustmentFareFSIDsSetting};
      let fundingSourceTarget = "";
      let selectedFSIndex = -1;
      let uniqueID = clientInfo && !Array.isArray(clientInfo) ? parseInt(newAffVal) : 0;
      let selectedAffVS = [];
      let attrOptionsMultiSelAff = attrSelection && attrSelection.length > 0 ? attrSelection.map((item)=>{
        let dict = {};
        dict.id = item.ID;
        dict.name = item.Title;
        return dict;
      }).sort((a, b) => a.name.localeCompare(b.name)) : [];
      let cosOptionsHTML = cosSelection.map((item, index)=>{
        return(
          <option key={index} value={item.iClassOfServiceID}>
            {item.vClassName}
          </option>
        );
      });
      if(cosSelection[0]){
        setCOSSelected(cosSelection[0].iClassOfServiceID);
        setCOSTargetID(cosSelection[0].iClassOfServiceID);
      }
      let fsOptionsHTML = fsSelection.map((item, index)=>{
        if((item.AccountID.toLowerCase().includes("self") || item.AccountID.toLowerCase().includes("cash")) || parseInt(item.FID) === 1)
        {
          setBrokerModes({globalBrokerMode: ASCSGlobalBrokerMode, brokerMode: item.BrokerMode}); 
          handleManualAmountOnFSChange(item, parseInt(item.FID));
          setFSSelected(item.FID);
          setAffiliateAbbr(item.AffiliateAbbrevation);
          setFSTargetID(item.FID);
          fundingSourceTarget = item.FID;
          selectedFSIndex = index;
        }
        return(
          <option key={index} value={item.FID} data-virtual={item.FPayTypeID} label={item.AccountID}>
            {item.AccountID}
          </option>
        );
      });
      if(selectedFSIndex === -1){
        selectedFSIndex = 0;
        handleManualAmountOnFSChange(fsSelection[selectedFSIndex], parseInt(fsSelection[selectedFSIndex].FID));
        setFSSelected(fsSelection[selectedFSIndex].FID);
        setAffiliateAbbr(fsSelection[selectedFSIndex].AffiliateAbbrevation);
        setFSTargetID(fsSelection[selectedFSIndex].FID);
      }
      let payOptionsHTML = paySelection.map((item, index)=>{
        if(selectedFSIndex > -1 && parseInt(fsSelection[selectedFSIndex].PaymentTypeID) === parseInt(item.iID))
        {
          setPayTargetID(item.iID);
          setCopayPayTypeSelected(item.iID);
          setPaySelected(item.iID);
        }
        if(item.vName !== "" && item.vName !== "-" && !item.vName.toLowerCase().includes("unused") && !item.vName.toLowerCase().includes("wallet") && item.bActive)
        {
          return(
            <option key={index} value={item.iID}>
              {item.vName}
            </option>
          );
        }
      });
      let copayFSOptionsHTML = fsSelection.map((item, index)=>{
        if(copayFSSetting === "")
        {
          
          if((item.AccountID.toLowerCase().includes("self") || item.AccountID.toLowerCase().includes("cash")) || parseInt(item.FID) === 1)
          {
            setCopayFSSelected(item.FID);
          }
          
          return(
            <option key={index} value={item.FID} data-virtual={item.FPayTypeID} label={item.AccountID}>
              {item.AccountID}
            </option>
          );
        }
        else
        {
          setCopayFSSelected(1);
          let tempSettingIDs = copayFSSetting.includes(",")? copayFSSetting.split(",") : copayFSSetting;
          if(Array.isArray(tempSettingIDs))
          {
            if(tempSettingIDs.includes(String(item.FID)))
            {
              return(
                <option key={index} value={item.FID} data-virtual={item.FPayTypeID} label={item.AccountID}>
                  {item.AccountID}
                </option>
              );
            }
          }
          else
          {
            if(parseInt(tempSettingIDs) === parseInt(item.FID))
            {
              return(
                <option key={index} value={item.FID} data-virtual={item.FPayTypeID} label={item.AccountID}>
                  {item.AccountID}
                </option>
              );
            }
          }
        }
            
      });
      setDynamicModeStyle(dynamicCallAgentHeight); 
      setDynamicModeRowStyle(rowContainerDynamicHeight);
      setIsAffMicroFlag(isMicroIncluded);
      setSelectedAff(newAffVal);
      if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2))
      {
        setClientInfoDisplay(true);
      }

      setLanguageOptionsHTML(languageOptions);
      setVehNumberOptionsHTML(vehicleNumOptionsHTML);
      setVehTypeOptionsManageHTML(vehicleTypeOptionsHTML);
      setDriverNumberOptionsHTML(driverNumberOptionsHTML);
      setCOSDropdown(cosOptionsHTML);
      setPayDropdown(payOptionsHTML);
      setFSDropdown(fsOptionsHTML);
      setCopayFSDropdown(copayFSOptionsHTML);

      SetAttributesFilterMultiSelect({...AttributesFilterMultiSelect, ...{options: attrOptionsMultiSelAff, selectedValues:[]}}); 

      setMapOptionsCallAgent(prevState=>({...prevState, mapOptions: {...prevState.mapOptions, aff:(newAffVal)}}));

      if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2))
      {
        handleGetFareCalcMethod((fundingSourceTarget? fundingSourceTarget : "-1"), newAffVal, COSSelected);
      }
      
        for(let k = 0; k < VirtualStopsData.length; k++)
        {
          if(parseInt(newAffVal) === parseInt(VirtualStopsData[k].iSATSPID))
          {
            selectedAffVS.push(VirtualStopsData[k]);
          }
        }
      startAffSelectionDropDown(selectedAffVS, 0, true);
      handleResetAll((parseInt(uniqueID) === 0 ? "func" : "aff"));
      
    }
    catch(err){console.log(err);}
  };

  const AttributesSelectCallback = (selectedVals) => { //Multiselect attribute selection on change
    try
    {
      const selectedAttrArray = (selectedVals && selectedVals.length > 0) ? selectedVals : []; // Add fallback for undefined
      const groupSelected = AttributesFilterMultiSelect.options
        .filter(option => selectedAttrArray.includes(option.id))
        .map(({ id, name }) => ({ id, name }));

      SetAttributesFilterMultiSelect(prev => ({
        ...prev,
        selectedValues: groupSelected
      }));

      setSelectedTripAttr(selectedAttrArray);
    }
    catch(setAttrExp)
    { 
      console.log("AttributesSelectCallback : " + setAttrExp);
    }
    // try{
      
    //   const stringVals = selectedVals;//selectedVals.map((num) => num.toString());
      
    //   let groupSelected = [];
    //   for(let k = 0; k < AttributesFilterMultiSelect.options.length; k++)
    //   {
    //     if(stringVals.includes(String(AttributesFilterMultiSelect.options[k].id)))
    //     {
    //       groupSelected.push({id:AttributesFilterMultiSelect.options[k].id, name:AttributesFilterMultiSelect.options[k].name});
    //     }
    //   }
    //   setSelectedTripAttr(stringVals);
    //   SetAttributesFilterMultiSelect({ ...AttributesFilterMultiSelect, ...{ selectedValues: groupSelected}});
    // }
    // catch(err){console.log(err);}
  };

  const handleSummaryHeaderClick = (type)=>{ //This function takes care of clicking tabs on right column of call taker and switching between them
    try{
      if(type.toLowerCase()=== "stoporder")
      {
        setSelectedSummaryHeader(type);
        setAgentTripsDisplay(false);
        setStopOrderDisplay(true);
        setManifestDetailsDisplay(false);
      }
      else if(type.toLowerCase()=== "manifest")
      {
        setSelectedSummaryHeader(type);
        setAgentTripsDisplay(false);
        setStopOrderDisplay(false);
        setManifestDetailsDisplay(true);
      }
      else if(type.toLowerCase()=== "manualfare")
      {
        setSelectedSummaryHeader(type);
        setAgentTripsDisplay(false);
        setStopOrderDisplay(false);
        setManifestDetailsDisplay(false);
      }
      else if(type.toLowerCase() === "agenttrips")
      {
        setSelectedSummaryHeader(type);
        setAgentTripsDisplay(true);
        setStopOrderDisplay(false);
        setManifestDetailsDisplay(false);
      }
    }
    catch(err){console.log(err);}
  };

  const handleAutoBookTrip = ()=>{ //Function to automatically book a microtransit trip (FOR TEST ONLY)
    try{
      let correctDate = formatDate(selectedDateSchTime);
      setRiderName("Kamran A");
      setPhone("+16667778888");
      setPickupAddr("816 Bestgate Road, Annapolis, MD 21401, USA");
      setDropAddr("2002 Annapolis Mall Road, Annapolis, MD 21401, USA");
      pickLatLng.current = "38.994088959031814,-76.53922746079853";
      dropLatLng.current = "38.98793225777333,-76.54685231846949";
      if(pickLatLng.current !== "")
      {
        handleAddressDetails("PU", "816 Bestgate Road, Annapolis, MD 21401, USA", 
          "816 Bestgate Road, Annapolis, MD 21401, USA", "2002 Annapolis Mall Road, Annapolis, MD 21401, USA", correctDate, schTime);
        if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2))
        {
          wrapperHandleRCZVerification("PU", "816 Bestgate Road, Annapolis, MD 21401, USA");
        }
      }
    }
    catch(err){console.log(err);}
  };

  const handleSetRiderName = (e) => {
    try{ //Check to see if entered name is not using numbers and at least 2 characters to be verified
      setSearchButtonValidation("");
      const regex = /^[a-zA-Z0-9 ,.'-]+$/;
      let initialName = e.target.value;
      if(initialName.length > 0 && !regex.test(e.target.value)){e.target.value = initialName.slice(0,-1);}
      if(initialName !== "" && e.target.value.length < 2)
      {
        riderNameRef.current.style.border = "3px solid red";
      }
      else
      {
        riderNameRef.current.style.borderColor = "";
        riderNameRef.current.style.borderWidth = "";
      }
    }
    catch(err){console.log(err);}
  };

  const handleClearAddr = (type)=>{
    try{

      if(type === "PU") //Function to remove PU/DO from the map, POI removal, and virtual stop info removal (if any)
      {
        setPickupVirtualStop({...pickupVirtualStop, value:"PU VS", name:""});
        let stopMarkersArr = [];
        let filteredMapMarkers = mapData.filter((item)=>{
          if(item.Type === "Stop")
          {
            stopMarkersArr.push(item);
          }
          return item.Type === "DO";
        });
        filteredMapMarkers.unshift(...stopMarkersArr);
        setMapData(filteredMapMarkers);
        setPickPOI("");
      }
      else if(type === "DO")
      {
        setDropAddrVirtualStop({...dropAddrVirtualStop, value:"DO VS", name:""});
        let stopMarkersArr = [];
        let filteredMapMarkers = mapData.filter((item)=>{
          if(item.Type === "Stop")
          {
            stopMarkersArr.push(item);
          }
          return item.Type === "PU";
        });
        filteredMapMarkers.push(...stopMarkersArr);
        setMapData(filteredMapMarkers);
        setDropPOI("");
      }
      
    }
    catch(err){console.log(err);}
  };

  const handlePhoneCheck = ()=>{
    try{
      setSearchButtonValidation(""); //When entering phone, remove any error messages until API is called
      if(!phone) //If phone number deleted, reset client info parameters from call taker
      {
        setRecentAddresses([]);
        setRiderName("");
        setAgentNotes("");
        setAccountNumber("");
        setCallBackPhone("");
      }
      if(phone && phone.length < 12) //Highlighting phone input if it is wrong or entered incorrectly and vice versa
      {
        phoneRef.current.style.border = "3px solid red";
        setRecentAddresses([]);
      }
      else
      {
        phoneRef.current.style.borderColor = "";
        phoneRef.current.style.borderWidth = "";
      }
    }
    catch(err){console.log(err);}
  };

  const handleClientMedicalIDCheck = () => {
    try{
      if(medicalIDCheck.trim().length > 0 && !isNaN(medicalIDCheck.trim()))
      {

      }
    }
    catch(err){console.log(err);}
  };

  const handleClientNameCheck = () => {
    try{

      if(riderNameCheck.length === 0) //If rider name is deleted from search input, reset the client Info
      {
        setRecentAddresses([]);
        setRiderName("");
        setAccountNumber("");
        setAgentNotes("");
        setCallBackPhone("");
      }
      else if(riderNameCheck.trim().length >= 3 && !isNaN(riderNameCheck.trim())) //Check added for rider ID check
      {
        //If client ID search is needed, it should be implemented here...
      }
    }
    catch(err){console.log(err);}
  };

  const handleInsuranceInfoDisplay = ()=>{
    try{
      setInsuranceInfoDisplay(!insuranceInfoDisplay); //Function to display or hide insurance info section (if available)
    }
    catch(err){console.log(err);}
  };

  const handleMultischeduleOpen = (e)=>{
    try{
      setMultischModalShow(true); //Open multi-schedule dialog component
    }
    catch(err){console.log(err);}
  };

  const handleReturnCheck = async(e) =>{
    try{
      if(!pickLatLng.current || pickLatLng.current.trim() === "" || !dropLatLng.current || dropLatLng.current.trim() === ""){return;}

      const swapLatLngAndAddresses = () => { //Swapping addresses and markers
        const pickInfo = { addr: pickupAddr, latlng: pickLatLng.current, POI: pickPOI };
        const dropInfo = { addr: dropAddr, latlng: dropLatLng.current, POI: dropPOI };
  
        const tripLatLng = [
          { lat: parseFloat(dropInfo.latlng.split(",")[0]), lng: parseFloat(dropInfo.latlng.split(",")[1]), Type: "PU", name: riderName, address: dropInfo.addr },
          { lat: parseFloat(pickInfo.latlng.split(",")[0]), lng: parseFloat(pickInfo.latlng.split(",")[1]), Type: "DO", name: riderName, address: pickInfo.addr },
        ];
  
        setMapData(tripLatLng);
        setDropAddr(pickInfo.addr);
        setDropPOI(pickInfo.POI);
        setPickupAddr(dropInfo.addr);
        setPickPOI(dropInfo.POI);
        pickLatLng.current = dropInfo.latlng;
        dropLatLng.current = pickInfo.latlng;
      };

      const calculateAndSetTripSummary = async () => { //Calculating new distance, time, and fare
        const addressAPI = `${ITCMapDirections.current}?origin=${pickLatLng.current}&destination=${dropLatLng.current}&AppType=calltaker`;
        const OSRMResponse = await APICom.fetchData("full", addressAPI, "get", {
          Authorization: `Basic ${btoa(OSRM_Username.current + ":" + OSRM_Password.current)}`,
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Headers": "*",
          mode: "no-cors",
        });
  
        if (OSRMResponse?.data.status.toUpperCase() === "OK") {
          const distanceInMeters = OSRMResponse.data.routes[0].legs[0].distance.value;
          const durationInSeconds = OSRMResponse.data.routes[0].legs[0].duration.value;
          let distance = (parseFloat(distanceInMeters) / 1609).toFixed(1);
          let duration = 0;
          if(OSRMResponse.data.mapSource === 'OSRM')
          {
            duration = handleZoneSpeedMultiplierChecks(dispatchZones.pickZone, dispatchZones.dropZone, selectedAff, durationInSeconds);
            duration = parseFloat(duration).toFixed(2);
          }
          else
          {
            duration = Math.round(parseInt(durationInSeconds)/60);
          }
  
          setClientSummary((prevState) => ({
            ...prevState,
            tripDistance: distance,
            TripDuration: duration,
          }));
  
          if (pickLatLng.current && dropLatLng.current) {
            setShowAPILoader(true);
            resetBtnRef.current.disabled = true;
            paratransitBookBtnRef.current.disabled = true;
  
            await handleGetFareCalcMethod(FSSelected || "-1", selectedAff, COSSelected);
  
            const tripTypes = [
              { type: "pick", mapInfo: pickLatLng.current },
              { type: "drop", mapInfo: dropLatLng.current },
            ];
  
            for (const trip of tripTypes) {
              if (fareMethodRef.current === 1) {
                await getFareZone(FSSelected, selectedAff, COSSelected, trip.mapInfo, trip.type);
              }
              await getDispatchZone(selectedAff, trip.mapInfo, trip.type);
            }
            await wrapperHandleFareCalc(distance, duration, FSSelected, copayFSSelected, passengerTypeCount.totalWC, 
              passengerTypeCount.total, COSSelected, selectedAff, pickLatLng.current, copayAmount, ""
            );
            setShowAPILoader(false);
            resetBtnRef.current.disabled = false;
            if(paratransitBookBtnRef){
              paratransitBookBtnRef.current.disabled = false;
              addLegBtnRef.current.disabled = false;
            }
            
          }
        }
      };

      if(e.key && e.key === "Enter")
      {
        swapLatLngAndAddresses();
        await calculateAndSetTripSummary();
      }
      else
      {
        swapLatLngAndAddresses();
        await calculateAndSetTripSummary();
      }
    }
    catch(err){console.log(err);}
  };

  const updatePhoneNumber = (newPhone, affiliateId) => {
    try{
      // setting value to phone number input and manually triggering enter event for caller ID
      setSelectedAff(affiliateId)
      setPhone("");
      setChatBotPhone(newPhone);
      phoneRef.current.value = "";

      if (!showChatBotRef.current) {
        setTimeout(() => {
          phoneRef.current.value = newPhone; // Set the phoneRef input value
          setIsPhoneUpdateFromFunction(true); // Set the flag to signal useEffect
          setPhone(newPhone); // Update the phone, triggering useEffect
        }, 100);
      }
    }
    catch(err){console.log(err);}
  };

  const handleSSNChange = (e) => {
    try{
      const input = e.target.value;
      setInsuranceSSN(input);
      setSSNDisplayValue('•'.repeat(input.length)); //Get SSN and replace the actual value with dots for privacy
    }
    catch(err){console.log(err);}
  };

  const handleClassOfServiceChange = async (e) => {
    try{
      setCOSSelected(e.target.value);
      // if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2))
      // {
        await handleGetFareCalcMethod((FSSelected? FSSelected: "-1"), selectedAff, e.target.value);
        await wrapperHandleFareCalc(clientSummary.tripDistance, clientSummary.TripDuration, 
          FSSelected, copayFSSelected, passengerTypeCount.totalWC, 
          passengerTypeCount.total, e.target.value, selectedAff, 
          pickLatLng.current, copayAmount, ""); 
      // }
    }
    catch(err){console.log(err);}
  };

  function handleNewClientManualLoad () {
    try{
      if(phone && phone.length >= 12){
        setMainInfoNewClient({type:'phone', value: phone});
      }
      else if(riderNameCheck.trim().length >= 2){
        setMainInfoNewClient({type:'name', value: riderNameCheck.trim()});
      }
      const passType = (parseInt(passengerTypeCount.ambPass) > 0 ? 'amb' : 'wc');
      //{language: 0, passType: '', agentNotes: '', remarks: '', email: '', rollcall: {phone: false, sms: false, email: false}, priority: ''}
      setNewClientInfoExtraInfo({language: selectedLanguage, 
        passType: passType, agentNotes: agentNotes, ID: '', remarks: paymentAdditionalInfo, email: clientEmail,
        rollcall: {phone: RCType.phoneType, sms: RCType.SMSType, email: RCType.emailType}, priority: selectedTripPriority, name: riderName.trim()
        , affDetails: {affID: 0, FSID: 0}, phone: ''
      });
      setShowClientInfoCreationDialog(true);
    }
    catch(err){console.log(err);}
  }

    const handlePredictiveNegotiation = async (PredictiveData, Status) => {
      console.log(PredictiveData);
      let ExsistingPredictiveData = PersistStorage.retrieve("PredictiveData", false);
      let predictiveDataLength = 0;
      let PredictiveHTML = "";
      if(ExsistingPredictiveData !== null)
      {
        const now = moment();
        let predictiveDataLength =  JSON.parse(PredictiveData).length;
        if(Status === "Update")
        {
          for(let j=0; j < predictiveDataLength; j++)
          {
            let updatePDItem = JSON.parse(PredictiveData)[j];
            let ExistingPD = JSON.parse('[' + ExsistingPredictiveData + ']');
            let filteredExsistingPredictiveData =  ExistingPD.filter(item => item.Confirmation !== updatePDItem.Confirmation);
            if(filteredExsistingPredictiveData && filteredExsistingPredictiveData.length > 0)
            {
              ExsistingPredictiveData = "";
              for(let i=0; i < filteredExsistingPredictiveData.length; i++)
              {
                ExsistingPredictiveData += JSON.stringify(filteredExsistingPredictiveData[i]) + ",";
              }
              if(ExsistingPredictiveData !== ""){
                ExsistingPredictiveData = ExsistingPredictiveData.endsWith(',') ? ExsistingPredictiveData.slice(0, -1) : ExsistingPredictiveData;
              }
            }else
            {
              ExsistingPredictiveData = "";
            }
          }
        }
        for(let i=0; i < predictiveDataLength; i++)
        {
            if(ExsistingPredictiveData && ExsistingPredictiveData !== ""){
              ExsistingPredictiveData += "," + JSON.stringify(JSON.parse(PredictiveData)[i]);
            }
            else{
              ExsistingPredictiveData += JSON.stringify(JSON.parse(PredictiveData)[i]);
            }
        }
        PersistStorage.save("PredictiveData", "", 999, false);
        PersistStorage.save("PredictiveData", ExsistingPredictiveData, 999, false);

        let PreditiveTripDataUpdate = JSON.parse('[' + ExsistingPredictiveData + ']');
        if(PreditiveTripDataUpdate !== null && PreditiveTripDataUpdate.length > 0)
        {

              PreditiveTripDataUpdate = PreditiveTripDataUpdate.sort((a, b) => {
                    let dateA = new Date(a.InsertTime);
                    let dateB = new Date(b.InsertTime);
                    return dateB - dateA ; // Ascending order (earliest first)
              });

              PreditiveTripDataUpdate = PreditiveTripDataUpdate.filter(item => {
                const insertTime = moment(item.InsertTime, "M/D/YYYY h:mm:ss A");
                let systemcalcTime = now.clone().add(timeZoneDiff.current, 'milliseconds')
                const diffInMinutes = Math.abs(insertTime.diff(systemcalcTime, 'minutes'));
                return diffInMinutes <= 30; // Only include items within 30 minutes
              });
              
              if(PreditiveTripDataUpdate.length)
              {
                setTotalPredictiveRecords(PreditiveTripDataUpdate.length);
                PredictiveHTML =  PreditiveTripDataUpdate.map((item, index) => (
                  <tr key={item.Confirmation} className="text-center">
                  <td className="border border-dark user-select-none" style={{fontSize:"smaller"}} >{item.Confirmation}</td>
                  <td className="border border-dark user-select-none" style={{fontSize:"smaller"}}>{item.Status}</td>
                  <td className="border border-dark user-select-none text-nowrap small overflow-hidden" style={{fontSize:"smaller"}}>
                    {moment(item.PickDate, "M/D/YYYY h:mm A").format("M/D/YYYY h:mm A")}</td>
                  <td className="border border-dark user-select-none text-nowrap small overflow-hidden">{item.OfferedTime}</td>
                  {item.Status === 'Routed (Out of Window)' && (
                            <td className="border border-dark user-select-none text-center justify-content-center">
                              <span title={"Force Request Time"}><Icon icon="entypo:back-in-time" className="me-3 text-white my-auto text-secondary" style={{width:"22px", height:"22px", color:"white", cursor:"pointer"}}
                              onClick={(e) => {handlePredictiveForceReq(item.Confirmation)}} /></span>
                              {"                                                                                       "}
                              <span title={"Cancel Trip"}><Icon icon="game-icons:cancel" className=" text-white my-auto text-secondary" style={{width:"22px", height:"22px", color:"white", cursor:"pointer"}}
                              onClick={(e) => {handlePredictiveCancel(item.Confirmation)}} /></span>
                            </td>
                          )}
                          {item.Status === 'Routed' && (
                            <td className="border border-dark user-select-none text-center justify-content-center">
                              <span style={{ visibility: "hidden" }}>
                                <Icon icon="entypo:back-in-time" className="me-3" style={{width:"22px", height:"22px"}} />
                              </span> 
                              {"                                                                                       "}
                              <span title={"Cancel Trip"}><Icon icon="game-icons:cancel" className=" text-white my-auto text-secondary" style={{width:"22px", height:"22px", color:"white", cursor:"pointer"}}
                              onClick={(e) => {handlePredictiveCancel(item.Confirmation)}} /></span>
                            </td>
                          )}
                          {(item.Status === 'UnRouted' || item.Status === 'UnRouted (Forced)') && (
                            <td className="border border-dark user-select-none text-center justify-content-center">
                              <span title={"Edit Request Time"}><Icon icon="cuida:edit-outline" className="me-3 text-white my-auto text-secondary" style={{width:"22px", height:"22px", color:"white", cursor:"pointer"}}
                              onClick={(e) => {handlePredictiveEdit(item.Confirmation, item.PickDate)}} /></span>
                              {"                                                                                       "}
                              <span title={"Cancel Trip"}><Icon icon="game-icons:cancel" className=" text-white my-auto text-secondary" style={{width:"22px", height:"22px", color:"white", cursor:"pointer"}}
                              onClick={(e) => {handlePredictiveCancel(item.Confirmation)}} /></span>
                            </td>
                          )}
                          {item.Status === 'Cancelled' && (
                            <td className="border border-dark user-select-none text-center justify-content-center">{""}</td>
                          )}
                </tr>
                ))
              }
              else{
                setTotalPredictiveRecords(0);
              }
        }
      }
      else
      {
        let NewPredictiveData = "";
        predictiveDataLength = JSON.parse(PredictiveData).length;
        for(let j=0; j < predictiveDataLength; j++)
        {
            NewPredictiveData +=  JSON.stringify(JSON.parse(PredictiveData)[j]) + ",";
        }  
        if(NewPredictiveData !== ""){
          NewPredictiveData = NewPredictiveData.endsWith(',') ? NewPredictiveData.slice(0, -1) : NewPredictiveData;
          PersistStorage.save("PredictiveData", NewPredictiveData, 999, false);
        }

        let PreditiveTripData = JSON.parse('[' + NewPredictiveData + ']');
        if(PreditiveTripData !== null && PreditiveTripData.length > 0)
        {
              setTotalPredictiveRecords(PreditiveTripData.length);
              PredictiveHTML = [...PreditiveTripData].sort((a, b) => {
                const dateA = a.PickDate ? new Date(a.PickDate) : new Date(0);
                const dateB = b.PickDate ? new Date(b.PickDate) : new Date(0);
                return dateA - dateB; // Descending order (latest first)
              }).map((item, index) => (
              //PredictiveHTML =  PreditiveTripData.map((item, index) => (
                <tr key={item.Confirmation} className="text-center">
                <td className="border border-dark user-select-none" style={{fontSize:"smaller"}} >{item.Confirmation}</td>
                <td className="border border-dark user-select-none" style={{fontSize:"smaller"}}>{item.Status}</td>
                <td className="border border-dark user-select-none text-nowrap small overflow-hidden" style={{fontSize:"smaller"}}>
                 {moment(item.PickDate, "M/D/YYYY h:mm A").format("M/D/YYYY h:mm A")}</td>
                <td className="border border-dark user-select-none text-nowrap small overflow-hidden">{item.OfferedTime}</td>
                <td className="border border-dark user-select-none text-center justify-content-center">{""}</td>
              </tr>
          ))
        }
      }
        setPredictiveTableHTML(PredictiveHTML === ""? null : PredictiveHTML);
    }

    const handlePredictiveResponse = async (Resp) => {
      if(Resp !== null){    
        let ExsistingPredictiveData = PersistStorage.retrieve("PredictiveData", false);
        if(ExsistingPredictiveData !== null)
        {
            let PreditiveTripData = JSON.parse('[' + ExsistingPredictiveData + ']');
            let PredictiveHTML = "";
            const now = moment();
            if(PreditiveTripData !== null && PreditiveTripData.length > 0)
            {
              PreditiveTripData = PreditiveTripData.sort((a, b) => {
                let dateA = new Date(a.InsertTime);
                let dateB = new Date(b.InsertTime);
                return dateB - dateA ; // Ascending order (earliest first)
              });

              PreditiveTripData = PreditiveTripData.filter(item => {
                const insertTime = moment(item.InsertTime, "M/D/YYYY h:mm:ss A");
                let systemcalcTime = now.clone().add(timeZoneDiff.current, 'milliseconds')
                const diffInMinutes = Math.abs(insertTime.diff(systemcalcTime, 'minutes'));
                return diffInMinutes <= 30; // Only include items within 30 minutes
              });

             if(PreditiveTripData !== null && PreditiveTripData.length > 0)
             {
                let UpdatedPredictiveData = "";
                for(let i=0; i < PreditiveTripData.length; i++)
                {
                  if(Resp.message.ConfirmationNo.toString() === PreditiveTripData[i].Confirmation)
                  {
                    
                    if(Resp.status.toUpperCase() === "ROUTEDOUTOFWINDOW")
                    {
                      PreditiveTripData[i].Status = Resp.message.Message;
                      PreditiveTripData[i].OfferedTime = Resp.message.OfferTime;
                    }
                    else if(Resp.status.toUpperCase() === "ROUTED")
                    {
                      PreditiveTripData[i].Status = Resp.message.Message;
                      PreditiveTripData[i].OfferedTime = Resp.message.OfferTime;
                    }
                    else if(Resp.status.toUpperCase() === "FAIL")
                    {
                      PreditiveTripData[i].Status = Resp.message.Message;
                      PreditiveTripData[i].OfferedTime = "";
                    }
                    
                    UpdatedPredictiveData += JSON.stringify(PreditiveTripData[i]) + ",";
                  }
                  else
                  {
                    UpdatedPredictiveData += JSON.stringify(PreditiveTripData[i]) + ",";
                  }
                }
                if(UpdatedPredictiveData !== "")
                {
                  UpdatedPredictiveData = UpdatedPredictiveData.endsWith(',') ? UpdatedPredictiveData.slice(0, -1) : UpdatedPredictiveData;
                  PersistStorage.save("PredictiveData", UpdatedPredictiveData, 999, false);
                }
                PredictiveHTML = [...PreditiveTripData].sort((a, b) => {
                  const dateA = a.PickDate ? new Date(a.PickDate) : new Date(0);
                  const dateB = b.PickDate ? new Date(b.PickDate) : new Date(0);
                  return dateA - dateB; // Descending order (latest first)
                }).map((item, index) => (
                //PredictiveHTML =  PreditiveTripData.map((item, index) => (
                      <tr key={item.Confirmation} className="text-center">
                        <td className="border border-dark user-select-none" style={{fontSize:"smaller"}} >{item.Confirmation}</td>
                        <td className="border border-dark user-select-none" style={{fontSize:"smaller"}}>{item.Status}</td>
                        <td className="border border-dark user-select-none text-nowrap small overflow-hidden" style={{fontSize:"smaller"}}>
                        {moment(item.PickDate, "M/D/YYYY h:mm A").format("M/D/YYYY h:mm A")}</td>
                        <td className="border border-dark user-select-none text-nowrap small overflow-hidden" style={{fontSize:"smaller"}}>
                        {item.OfferedTime}</td>
                        {item.Status === 'Routed (Out of Window)' && (
                            <td className="border border-dark user-select-none text-center justify-content-center">
                              <span title={"Force Request Time"}><Icon icon="entypo:back-in-time" className="me-3 text-white my-auto text-secondary" style={{width:"22px", height:"22px", color:"white", cursor:"pointer"}}
                              onClick={(e) => {handlePredictiveForceReq(item.Confirmation)}} /></span>
                              {"                                                                                       "}
                              <span title={"Cancel Trip"}><Icon icon="game-icons:cancel" className=" text-white my-auto text-secondary" style={{width:"22px", height:"22px", color:"white", cursor:"pointer"}}
                              onClick={(e) => {handlePredictiveCancel(item.Confirmation)}} /></span>
                            </td>
                          )}
                          {item.Status === 'Routed' && (
                            <td className="border border-dark user-select-none text-center justify-content-center">
                              <span style={{ visibility: "hidden" }}>
                                <Icon icon="entypo:back-in-time" className="me-3" style={{width:"22px", height:"22px"}} />
                              </span> 
                              {"                                                                                       "}
                              <span title={"Cancel Trip"}><Icon icon="game-icons:cancel" className=" text-white my-auto text-secondary" style={{width:"22px", height:"22px", color:"white", cursor:"pointer"}}
                              onClick={(e) => {handlePredictiveCancel(item.Confirmation)}} /></span>
                            </td>
                          )}
                          {(item.Status === 'UnRouted' || item.Status === 'UnRouted (Forced)') && (
                            <td className="border border-dark user-select-none text-center justify-content-center">
                              <span title={"Edit Request Time"}><Icon icon="cuida:edit-outline" className="me-3 text-white my-auto text-secondary" style={{width:"22px", height:"22px", color:"white", cursor:"pointer"}}
                              onClick={(e) => {handlePredictiveEdit(item.Confirmation, item.PickDate)}} /></span>
                              {"                                                                                       "}
                              <span title={"Cancel Trip"}><Icon icon="game-icons:cancel" className=" text-white my-auto text-secondary" style={{width:"22px", height:"22px", color:"white", cursor:"pointer"}}
                              onClick={(e) => {handlePredictiveCancel(item.Confirmation)}} /></span>
                            </td>
                          )}
                          {item.Status === 'Cancelled' && (
                            <td className="border border-dark user-select-none text-center justify-content-center">{""}</td>
                          )}
                      </tr>
                    ))

                    if(PreditiveTripData){
                        handlePredictiveNegotiationStatusUpdated(PreditiveTripData);
                    }
              }
            }
            
            setPredictiveTableHTML(PredictiveHTML === "" ? null : PredictiveHTML);
        }
      }
    }

    const handlePredictiveNegotiationStatusUpdated = (PreditiveTripData) => {
      try {
        
        let parsedJsonItems = PreditiveTripData;
        if(parsedJsonItems){
          parsedJsonItems.forEach(item => {
            let confirNum = item.Confirmation;
            let status = item?.Status ? item?.Status : "";
            let date = item?.PickDate ? item?.PickDate : "";
            let OfferedTime = item?.OfferedTime ? item?.OfferedTime : "";
            if(status === "Routed (Out of Window)" || status.toUpperCase() === "ROUTEDOUTOFWINDOW"){
              let title = "Confirmation# " + confirNum + ", request has been Routed (Out of Window) successfully...";
              updateStatusByConfirmationNumber(confirNum, status, title, moment(date, "M/D/YYYY h:mm A").format("M/D/YYYY h:mm A"), OfferedTime,  false, 0);
            }
            else if(status.toUpperCase() === "ROUTED"){
              setCurrentBookedTripConfirmationNumber(confirNum);
              let title = "Confirmation# " + confirNum + ", request has been Routed successfully...";
              updateStatusByConfirmationNumber(confirNum, status, title, moment(date, "M/D/YYYY h:mm A").format("M/D/YYYY h:mm A"), OfferedTime,  false, 0);
            }
            else if(status.toUpperCase() === "FAIL" || status.toUpperCase() === "UNROUTED" || status === "UnRouted (Forced)"){
              let title = "Confirmation# " + confirNum + " is Un-Routed, You can Edit or Cancel this request...";
              updateStatusByConfirmationNumber(confirNum, status, title, moment(date, "M/D/YYYY h:mm A").format("M/D/YYYY h:mm A"), OfferedTime, false, 0);
            }
            else if(status.toUpperCase() === "CANCELLED")
            {
              let title = "Confirmation# " + confirNum + " is Cancelled";
              updateStatusByConfirmationNumber(confirNum, status, title, moment(date, "M/D/YYYY h:mm A").format("M/D/YYYY h:mm A"), "", false, 0);
            }
            else if(status.toUpperCase() === "PENDING")
            {
               let title = "Confirmation# " + confirNum + " is Pending";
              updateStatusByConfirmationNumber(confirNum, status, title, moment(date, "M/D/YYYY h:mm A").format("M/D/YYYY h:mm A"), "", true, 120);
            }
          });
        }
      
      } catch (error) {
      }
    }

    const updateStatusByConfirmationNumber = (confirmationNumber, newStatus, headerMsg, pickupDate,offeredTimeByService, loaderVisibility, counterValue = 120) => {
      setPredictiveNegotiationList(prev =>
        prev.map(item =>
          Number(item.confirmationNumber) === Number(confirmationNumber)
            ? { ...item, status: newStatus, title: headerMsg, pickDate: moment(pickupDate, "M/D/YYYY h:mm A").format("M/D/YYYY h:mm A"), 
            showLoader: loaderVisibility, offeredTime: offeredTimeByService, counter: counterValue }
            : item
        )
      );
    };


    const handlePredictiveCancel = async (RefID) => {
      console.log("Predictive Cancel : " + RefID);
      let CancelTripConfirm = await showConfirmationModal("Are you sure to cancel this trip with conf# " + RefID + " ?", "Warning", false);
      if(CancelTripConfirm === false){
        return;
      }

      let data = {
      "ConfirmatinoNo": String(RefID),
      "TripID": "-1",
      "Status": "Cancelled",
      "Message": "Cancelled by Agent",
      "iModifiedbyAppId": 26,
      "iModifiedByUID": parseInt(loginData.iUserID)
      };
      let response = await APICom.fetchData("ReservationCoreURL","SubmitTripConfirmation", "post", {}, data, xCancelSourceForGrid.current);
      if(parseInt(response.data.responseCode) === 200)
      {
        setModalHeaderText("Trip Cancelled Successfully");
        setModalBodyHTML("Trip #"+ RefID +" is cancelled.");
        setModalFooterHTML(
          <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
            OK
          </Button>
        );
        setShowDynamicModal(true);
        let ExsistingPredictiveData = PersistStorage.retrieve("PredictiveData", false);
        if(ExsistingPredictiveData !== null)
        {
            let PreditiveTripData = JSON.parse('[' + ExsistingPredictiveData + ']');
            let PredictiveHTML = "";
            const now = moment();
            if(PreditiveTripData !== null && PreditiveTripData.length > 0)
            {
              PreditiveTripData = PreditiveTripData.sort((a, b) => {
                let dateA = new Date(a.InsertTime);
                let dateB = new Date(b.InsertTime);
                return dateB - dateA ; // Ascending order (earliest first)
              });

              PreditiveTripData = PreditiveTripData.filter(item => {
                const insertTime = moment(item.InsertTime, "M/D/YYYY h:mm:ss A");
                let systemcalcTime = now.clone().add(timeZoneDiff.current, 'milliseconds')
                const diffInMinutes = Math.abs(insertTime.diff(systemcalcTime, 'minutes'));
                return diffInMinutes <= 30; // Only include items within 30 minutes
              });

             if(PreditiveTripData !== null && PreditiveTripData.length > 0)
             {
                let UpdatedPredictiveData = "";
                for(let i=0; i < PreditiveTripData.length; i++)
                {
                  if(RefID.toString() === PreditiveTripData[i].Confirmation)
                  {
                    PreditiveTripData[i].Status = "Cancelled";
                    PreditiveTripData[i].OfferedTime = "";
                    UpdatedPredictiveData += JSON.stringify(PreditiveTripData[i]) + ",";
                  }
                  else
                  {
                    UpdatedPredictiveData += JSON.stringify(PreditiveTripData[i]) + ",";
                  }
                }
                if(UpdatedPredictiveData !== "")
                {
                  UpdatedPredictiveData = UpdatedPredictiveData.endsWith(',') ? UpdatedPredictiveData.slice(0, -1) : UpdatedPredictiveData;
                  PersistStorage.save("PredictiveData", UpdatedPredictiveData, 999, false);
                }

                PredictiveHTML = [...PreditiveTripData].sort((a, b) => {
                  const dateA = a.PickDate ? new Date(a.PickDate) : new Date(0);
                  const dateB = b.PickDate ? new Date(b.PickDate) : new Date(0);
                  return dateA - dateB; // Descending order (latest first)
                }).map((item, index) => (

                //PredictiveHTML =  PreditiveTripData.map((item, index) => (
                      <tr key={item.Confirmation} className="text-center">
                        <td className="border border-dark user-select-none" style={{fontSize:"smaller"}} >{item.Confirmation}</td>
                        <td className="border border-dark user-select-none" style={{fontSize:"smaller"}}>{item.Status}</td>
                        <td className="border border-dark user-select-none text-nowrap small overflow-hidden" style={{fontSize:"smaller"}}>
                        {moment(item.PickDate, "M/D/YYYY h:mm A").format("M/D/YYYY h:mm A")}</td>
                        <td className="border border-dark user-select-none text-nowrap small overflow-hidden" style={{fontSize:"smaller"}}>
                        {item.OfferedTime}</td>
                        {item.Status === 'Routed (Out of Window)' && (
                            <td className="border border-dark user-select-none text-center justify-content-center">
                              <span title={"Force Request Time"}><Icon icon="entypo:back-in-time" className="me-3 text-white my-auto text-secondary" style={{width:"22px", height:"22px", color:"white", cursor:"pointer"}}
                              onClick={(e) => {handlePredictiveForceReq(item.Confirmation)}} /></span>
                              {"                                                                                       "}
                              <span title={"Cancel Trip"}><Icon icon="game-icons:cancel" className=" text-white my-auto text-secondary" style={{width:"22px", height:"22px", color:"white", cursor:"pointer"}}
                              onClick={(e) => {handlePredictiveCancel(item.Confirmation)}} /></span>
                            </td>
                          )}
                          {item.Status === 'Routed' && (
                            <td className="border border-dark user-select-none text-center justify-content-center">
                              <span style={{ visibility: "hidden" }}>
                                <Icon icon="entypo:back-in-time" className="me-3" style={{width:"22px", height:"22px"}} />
                              </span> 
                              {"                                                                                       "}
                              <span title={"Cancel Trip"}><Icon icon="game-icons:cancel" className=" text-white my-auto text-secondary" style={{width:"22px", height:"22px", color:"white", cursor:"pointer"}}
                              onClick={(e) => {handlePredictiveCancel(item.Confirmation)}} /></span>
                            </td>
                          )}
                          {(item.Status === 'UnRouted' || item.Status === 'UnRouted (Forced)') && (
                            <td className="border border-dark user-select-none text-center justify-content-center">
                              <span title={"Edit Request Time"}><Icon icon="cuida:edit-outline" className="me-3 text-white my-auto text-secondary" style={{width:"22px", height:"22px", color:"white", cursor:"pointer"}}
                              onClick={(e) => {handlePredictiveEdit(item.Confirmation, item.PickDate)}} /></span>
                              {"                                                                                       "}
                              <span title={"Cancel Trip"}><Icon icon="game-icons:cancel" className=" text-white my-auto text-secondary" style={{width:"22px", height:"22px", color:"white", cursor:"pointer"}}
                              onClick={(e) => {handlePredictiveCancel(item.Confirmation)}} /></span>
                            </td>
                          )}
                          {item.Status === 'Cancelled' && (
                            <td className="border border-dark user-select-none text-center justify-content-center">{""}</td>
                          )}
                      </tr>
                    ))

                    if(PreditiveTripData){
                      handlePredictiveNegotiationStatusUpdated(PreditiveTripData);
                    }
              }
            }
            
            setPredictiveTableHTML(PredictiveHTML === "" ? null : PredictiveHTML);
        }
      }
    }

    const handlePredictiveForceReq = async (RefID) => {
      console.log("Predictive Force Req : " + RefID);
      let data = {
          "RefID": String(RefID),
          "ModifiedByUID": parseInt(loginData.iUserID)
        };
      let response = await APICom.fetchData("ReservationCoreURL", "api/ParatransitCT/ForceRequestTime", "post", { 'Content-Type': 'application/json' }, data, xCancelSourceForGrid.current);
      if(parseInt(response.data) > 0)
      {
        setModalHeaderText("Force request successful");
        setModalBodyHTML("Trip #"+ RefID +" force request successful.");
        setModalFooterHTML(
          <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
            OK
          </Button>
        );
        setShowDynamicModal(true);
        let ExsistingPredictiveData = PersistStorage.retrieve("PredictiveData", false);
        if(ExsistingPredictiveData !== null)
        {
            let PreditiveTripData = JSON.parse('[' + ExsistingPredictiveData + ']');
            let PredictiveHTML = "";
            const now = moment();
            if(PreditiveTripData !== null && PreditiveTripData.length > 0)
            {
              PreditiveTripData = PreditiveTripData.sort((a, b) => {
                let dateA = new Date(a.InsertTime);
                let dateB = new Date(b.InsertTime);
                return dateB - dateA ; // Ascending order (earliest first)
              });

              PreditiveTripData = PreditiveTripData.filter(item => {
                const insertTime = moment(item.InsertTime, "M/D/YYYY h:mm:ss A");
                let systemcalcTime = now.clone().add(timeZoneDiff.current, 'milliseconds')
                const diffInMinutes = Math.abs(insertTime.diff(systemcalcTime, 'minutes'));
                return diffInMinutes <= 30; // Only include items within 30 minutes
              });

             if(PreditiveTripData !== null && PreditiveTripData.length > 0)
             {
                let UpdatedPredictiveData = "";
                for(let i=0; i < PreditiveTripData.length; i++)
                {
                  if(RefID.toString() === PreditiveTripData[i].Confirmation)
                  {
                    PreditiveTripData[i].Status = "UnRouted (Forced)";
                    PreditiveTripData[i].OfferedTime = "";
                    UpdatedPredictiveData += JSON.stringify(PreditiveTripData[i]) + ",";
                  }
                  else
                  {
                    UpdatedPredictiveData += JSON.stringify(PreditiveTripData[i]) + ",";
                  }
                }
                if(UpdatedPredictiveData !== "")
                {
                  UpdatedPredictiveData = UpdatedPredictiveData.endsWith(',') ? UpdatedPredictiveData.slice(0, -1) : UpdatedPredictiveData;
                  PersistStorage.save("PredictiveData", UpdatedPredictiveData, 999, false);
                }

                PredictiveHTML = [...PreditiveTripData].sort((a, b) => {
                  const dateA = a.PickDate ? new Date(a.PickDate) : new Date(0);
                  const dateB = b.PickDate ? new Date(b.PickDate) : new Date(0);
                  return dateA - dateB; // Descending order (latest first)
                }).map((item, index) => (
                //PredictiveHTML =  PreditiveTripData.map((item, index) => (
                      <tr key={item.Confirmation} className="text-center">
                        <td className="border border-dark user-select-none" style={{fontSize:"smaller"}} >{item.Confirmation}</td>
                        <td className="border border-dark user-select-none" style={{fontSize:"smaller"}}>{item.Status}</td>
                        <td className="border border-dark user-select-none text-nowrap small overflow-hidden" style={{fontSize:"smaller"}}>
                        {moment(item.PickDate, "M/D/YYYY h:mm A").format("M/D/YYYY h:mm A")}</td>
                        <td className="border border-dark user-select-none text-nowrap small overflow-hidden" style={{fontSize:"smaller"}}>
                        {item.OfferedTime}</td>
                        {item.Status === 'Routed (Out of Window)' && (
                            <td className="border border-dark user-select-none text-center justify-content-center">
                              <span title={"Force Request Time"}><Icon icon="entypo:back-in-time" className="me-3 text-white my-auto text-secondary" style={{width:"22px", height:"22px", color:"white", cursor:"pointer"}}
                              onClick={(e) => {handlePredictiveForceReq(item.Confirmation)}} /></span>
                              {"                                                                                       "}
                              <span title={"Cancel Trip"}><Icon icon="game-icons:cancel" className=" text-white my-auto text-secondary" style={{width:"22px", height:"22px", color:"white", cursor:"pointer"}}
                              onClick={(e) => {handlePredictiveCancel(item.Confirmation)}} /></span>
                            </td>
                          )}
                          {item.Status === 'Routed' && (
                            <td className="border border-dark user-select-none text-center justify-content-center">
                              <span style={{ visibility: "hidden" }}>
                                <Icon icon="entypo:back-in-time" className="me-3" style={{width:"22px", height:"22px"}} />
                              </span> 
                              {"                                                                                       "}
                              <span title={"Cancel Trip"}><Icon icon="game-icons:cancel" className=" text-white my-auto text-secondary" style={{width:"22px", height:"22px", color:"white", cursor:"pointer"}}
                              onClick={(e) => {handlePredictiveCancel(item.Confirmation)}} /></span>
                            </td>
                          )}
                          {(item.Status === 'UnRouted' || item.Status === 'UnRouted (Forced)') && (
                            <td className="border border-dark user-select-none text-center justify-content-center">
                              <span title={"Edit Request Time"}><Icon icon="cuida:edit-outline" className="me-3 text-white my-auto text-secondary" style={{width:"22px", height:"22px", color:"white", cursor:"pointer"}}
                              onClick={(e) => {handlePredictiveEdit(item.Confirmation, item.PickDate)}} /></span>
                              {"                                                                                       "}
                              <span title={"Cancel Trip"}><Icon icon="game-icons:cancel" className=" text-white my-auto text-secondary" style={{width:"22px", height:"22px", color:"white", cursor:"pointer"}}
                              onClick={(e) => {handlePredictiveCancel(item.Confirmation)}} /></span>
                            </td>
                          )}
                          {item.Status === 'Cancelled' && (
                            <td className="border border-dark user-select-none text-center justify-content-center">{""}</td>
                          )}
                      </tr>
                    ))
              }
            }
            
            setPredictiveTableHTML(PredictiveHTML === "" ? null : PredictiveHTML);
        }
      }
    }

    const handlePredictiveEdit = async (RefID, PickupDateTime) => {
      console.log("Predictive Edit Req Time : " + RefID);
      let _forceReqDate = moment(PickupDateTime, "M/D/YYYY h:mm:ss A").format("YYYY-MM-DD");
      let _forceReqTime = moment(PickupDateTime, "M/D/YYYY h:mm:ss A").format("HH:mm")
      setShowForceReqTimeModal(prev => ({ ...prev, show: true, ForceReqTripID: RefID, forceReqDate: _forceReqDate, forceReqTime:_forceReqTime }));
    }

    const handlePredictiveUpdate = async () => {
      console.log("Predictive Update data : " + showForceReqTimeModal);
      if(showForceReqTimeModal.forceReqDate !== '' && showForceReqTimeModal.forceReqTime !== '' && showForceReqTimeModal.ForceReqTripID !== '')
      {
        let data = {
          "RefID": String(showForceReqTimeModal.ForceReqTripID),
          "PickupDateTime" :  moment(`${showForceReqTimeModal.forceReqDate} ${showForceReqTimeModal.forceReqTime}`, 'YYYY-MM-DD HH:mm').format('M/D/YYYY h:mm:ss A'),
          "ModifiedbyAppId": 26,
          "ModifiedByUID": parseInt(loginData.iUserID)
        };
        let response = await APICom.fetchData("ReservationCoreURL", "api/ParatransitCT/PredictiveUpdateRequestedTime", "post", { 'Content-Type': 'application/json' },data, xCancelSourceForGrid.current);
        if(parseInt(response.data) > 0)
        {
          setShowForceReqTimeModal(prev => ({ ...prev, show: false }));
          setModalHeaderText("Request time update");
          setModalBodyHTML("Trip #"+ data.RefID +" requested time update successful.");
          setModalFooterHTML(
            <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
              OK
            </Button>
          );
          setShowDynamicModal(true);
          let ExsistingPredictiveData = PersistStorage.retrieve("PredictiveData", false);
          if(ExsistingPredictiveData !== null)
          {
              let PreditiveTripData = JSON.parse('[' + ExsistingPredictiveData + ']');
              let PredictiveHTML = "";
              const now = moment();
              if(PreditiveTripData !== null && PreditiveTripData.length > 0)
              {
                PreditiveTripData = PreditiveTripData.sort((a, b) => {
                  let dateA = new Date(a.InsertTime);
                  let dateB = new Date(b.InsertTime);
                  return dateB - dateA ; // Ascending order (earliest first)
                });

                PreditiveTripData = PreditiveTripData.filter(item => {
                  const insertTime = moment(item.InsertTime, "M/D/YYYY h:mm:ss A");
                  let systemcalcTime = now.clone().add(timeZoneDiff.current, 'milliseconds')
                  const diffInMinutes = Math.abs(insertTime.diff(systemcalcTime, 'minutes'));
                  return diffInMinutes <= 30; // Only include items within 30 minutes
                });

              if(PreditiveTripData !== null && PreditiveTripData.length > 0)
              {
                  let UpdatedPredictiveData = "";
                  for(let i=0; i < PreditiveTripData.length; i++)
                  {
                    if(data.RefID.toString() === PreditiveTripData[i].Confirmation)
                    {
                      PreditiveTripData[i].Status = "Pending";
                      PreditiveTripData[i].OfferedTime = "";
                      PreditiveTripData[i].PickDate = data.PickupDateTime;
                      UpdatedPredictiveData += JSON.stringify(PreditiveTripData[i]) + ",";
                    }
                    else
                    {
                      UpdatedPredictiveData += JSON.stringify(PreditiveTripData[i]) + ",";
                    }
                  }
                  if(UpdatedPredictiveData !== "")
                  {
                    UpdatedPredictiveData = UpdatedPredictiveData.endsWith(',') ? UpdatedPredictiveData.slice(0, -1) : UpdatedPredictiveData;
                    PersistStorage.save("PredictiveData", UpdatedPredictiveData, 999, false);
                  }

                  PredictiveHTML = [...PreditiveTripData].sort((a, b) => {
                    const dateA = a.PickDate ? new Date(a.PickDate) : new Date(0);
                    const dateB = b.PickDate ? new Date(b.PickDate) : new Date(0);
                    return dateA - dateB; // Descending order (latest first)
                  }).map((item, index) => (

                  //PredictiveHTML =  PreditiveTripData.map((item, index) => (
                        <tr key={item.Confirmation} className="text-center">
                          <td className="border border-dark user-select-none" style={{fontSize:"smaller"}} >{item.Confirmation}</td>
                          <td className="border border-dark user-select-none" style={{fontSize:"smaller"}}>{item.Status}</td>
                          <td className="border border-dark user-select-none text-nowrap small overflow-hidden" style={{fontSize:"smaller"}}>
                          {moment(item.PickDate, "M/D/YYYY h:mm A").format("M/D/YYYY h:mm A")}</td>
                          <td className="border border-dark user-select-none text-nowrap small overflow-hidden" style={{fontSize:"smaller"}}>
                          {item.OfferedTime}</td>
                          {item.Status === 'Routed (Out of Window)' && (
                              <td className="border border-dark user-select-none text-center justify-content-center">
                                <span title={"Force Request Time"}><Icon icon="entypo:back-in-time" className="me-3 text-white my-auto text-secondary" style={{width:"22px", height:"22px", color:"white", cursor:"pointer"}}
                                onClick={(e) => {handlePredictiveForceReq(item.Confirmation)}} /></span>
                                {"                                                                                       "}
                                <span title={"Cancel Trip"}><Icon icon="game-icons:cancel" className=" text-white my-auto text-secondary" style={{width:"22px", height:"22px", color:"white", cursor:"pointer"}}
                                onClick={(e) => {handlePredictiveCancel(item.Confirmation)}} /></span>
                              </td>
                            )}
                            {item.Status === 'Routed' && (
                              <td className="border border-dark user-select-none text-center justify-content-center">
                                <span style={{ visibility: "hidden" }}>
                                  <Icon icon="entypo:back-in-time" className="me-3" style={{width:"22px", height:"22px"}} />
                                </span> 
                                {"                                                                                       "}
                                <span title={"Cancel Trip"}><Icon icon="game-icons:cancel" className=" text-white my-auto text-secondary" style={{width:"22px", height:"22px", color:"white", cursor:"pointer"}}
                                onClick={(e) => {handlePredictiveCancel(item.Confirmation)}} /></span>
                              </td>
                            )}
                            {(item.Status === 'UnRouted' || item.Status === 'UnRouted (Forced)') && (
                              <td className="border border-dark user-select-none text-center justify-content-center">
                                <span title={"Edit Request Time"}><Icon icon="cuida:edit-outline" className="me-3 text-white my-auto text-secondary" style={{width:"22px", height:"22px", color:"white", cursor:"pointer"}}
                                onClick={(e) => {handlePredictiveEdit(item.Confirmation, item.PickDate)}} /></span>
                                {"                                                                                       "}
                                <span title={"Cancel Trip"}><Icon icon="game-icons:cancel" className=" text-white my-auto text-secondary" style={{width:"22px", height:"22px", color:"white", cursor:"pointer"}}
                                onClick={(e) => {handlePredictiveCancel(item.Confirmation)}} /></span>
                              </td>
                            )}
                            {item.Status === 'Cancelled' && (
                              <td className="border border-dark user-select-none text-center justify-content-center">{""}</td>
                            )}
                            {item.Status === 'Pending' && (
                              <td className="border border-dark user-select-none text-center justify-content-center">{""}</td>
                            )}
                        </tr>
                      ))
                      if(PreditiveTripData){
                        handlePredictiveNegotiationStatusUpdated(PreditiveTripData);
                      }
                }
              }
              
              setPredictiveTableHTML(PredictiveHTML === "" ? null : PredictiveHTML);
          }
        }
      }
    }

    const hasTripDataChanged = (newData, originalData) => {
      // Helper function to extract trip details by stop type from CallTaker object
      const getTripDetailsByStopType = (data, stopType, iRefID) => {
        const trips = data?.addressInfo?.Trips || data?.addressInfo?.trips || [];
        let results;
        trips.forEach(trip => {
        const details = trip.Details || trip.details || [];
        details.forEach(detail => {
            if ((detail.StopType === stopType) && (detail?.tripInfo?.RefID === iRefID) || (detail.stopType === stopType) && (details[0]?.tripInfo?.refID === iRefID)) {
              results = detail;
            }
          });
        });
      
        return results;
      };

      // Helper function to extract RefID from pickup stop types (only valid RefIDs > 0)
      const extractPickupRefIDs = (data) => {
        const result = [];
        
        // Handle both capitalized and lowercase property names
        const trips = data?.addressInfo?.Trips || data?.addressInfo?.trips || [];
        
        trips.forEach(trip => {
          const details = trip.Details || trip.details || [];
          
          details.forEach(detail => {
            // Check if this is a pickup stop type
            if (detail.StopType === 'pickup') {
              const refID = detail?.tripInfo?.RefID;
              const insertPredictive = detail?.tripInfo?.InsertPredictiveRouteEntry || false;
              
              // Only include valid RefIDs that are greater than 0
              if (refID > 0) {
                result.push({
                  RefID: refID,
                  InsertPredictiveRouteEntry: insertPredictive
                });
              }
            }
          });
        });
        
        return result;
      };

      let LatTolerance = (ASCSSettingData ? (JSON.parse(ASCSSettingData[selectedAff]).find((item)=>item.SubTitle === "LatTolerance")).value : "0.0099");
      const lstTripData = extractPickupRefIDs(newData);
      if(lstTripData && lstTripData.length > 0)
      {
        for(let z=0; z < lstTripData.length; z++)
        {
          // Get pickup and dropoff details from both datasets
          let newPickup = getTripDetailsByStopType(newData, 'pickup', lstTripData[z].RefID);
          let originalPickup = getTripDetailsByStopType(originalData, 'pickup', lstTripData[z].RefID);
          let newDropoff = getTripDetailsByStopType(newData, 'dropoff', lstTripData[z].RefID);
          let originalDropoff = getTripDetailsByStopType(originalData, 'dropoff', lstTripData[z].RefID);
          let bPickLocChange = false;
          let bDropLocChange = false;

          // Check if required data exists
          if (!newPickup || !originalPickup || !newDropoff || !originalDropoff) {
            console.error('Missing required trip details');
            continue;
          }

          // 1. Check TotalPassengers difference for pickup
          let PassenterCountDiff = Math.abs(parseInt(newPickup.passengerInfo?.TotalPassengers) - parseInt(originalPickup.passengerInfo?.totalPassengers));

          // 2. Check pickup date difference
          let newPickupDate = moment(newPickup.dateInfo?.PickupDate);
          let originalPickupDate = moment(originalPickup.dateInfo?.pickupDate);
          let duration =  moment.duration(moment(newPickupDate).diff(moment(originalPickupDate)));
          let PickUpDateTimeDiff = Math.abs(duration.asMinutes());

          let PickLatDiff = Math.abs(parseFloat(newPickup.addressDetails?.Latitude) - parseFloat(originalPickup.addressDetails?.latitude));
          let PickLongDiff = Math.abs(parseFloat(newPickup.addressDetails?.Longitude) - parseFloat(originalPickup.addressDetails?.longitude));
          let DropLatDiff = Math.abs(parseFloat(newDropoff.addressDetails?.Latitude ) - parseFloat(originalDropoff.addressDetails?.latitude));
          let DropLongDiff = Math.abs(parseFloat(newDropoff.addressDetails?.Longitude) - parseFloat(originalDropoff.addressDetails?.longitude));
          if ((PickLatDiff > 0 && PickLatDiff > parseFloat(LatTolerance)) || (PickLongDiff > 0 && PickLongDiff > parseFloat(originalDropoff.addressDetails?.longitude))) {
              bPickLocChange = true;
          }
          if ((DropLatDiff > 0 && DropLatDiff > parseFloat(LatTolerance)) || (DropLongDiff > 0 && DropLongDiff > parseFloat(originalDropoff.addressDetails?.longitude))) {
              bDropLocChange = true;
          }
          if ((PassenterCountDiff > 0) || (PickUpDateTimeDiff > 1) || bPickLocChange == true || bDropLocChange == true) {
            lstTripData[z].InsertPredictiveRouteEntry = true;
            newData.addressInfo.Trips[z].Details[0].tripInfo.InsertPredictiveRouteEntry = true;
            continue;
          }
        
          // Check if mobility is true, then compare passenger details
          if (newPickup.passengerInfo?.IsMobility) {
            const newPrimary = newPickup.passengerInfo?.Primary;
            const originalPrimary = originalPickup.passengerInfo?.primary;
            
            // 8. Check Primary differences
            if (newPrimary?.Name !== originalPrimary?.Name || 
                newPrimary?.Attributes !== originalPrimary?.Attributes) {
              lstTripData[z].InsertPredictiveRouteEntry = true;
              newData.addressInfo.Trips[z].Details[0].tripInfo.InsertPredictiveRouteEntry = true;
              continue;
            }

            // 9. Check PCA differences
            const newPCA = newPickup.passengerInfo?.PCA || [];
            const originalPCA = originalPickup.passengerInfo?.pca || [];

            if (newPCA.length !== originalPCA.length) {
              lstTripData[z].InsertPredictiveRouteEntry = true;
              newData.addressInfo.Trips[z].Details[0].tripInfo.InsertPredictiveRouteEntry = true;
              continue;
            }
            
            //Check each PCA  array differences
            for (let i = 0; i < newPCA.length; i++) {
              if (newPCA[i]?.Name !== originalPCA[i]?.Name || 
                  newPCA[i]?.Attributes !== originalPCA[i]?.Attributes) {
                lstTripData[z].InsertPredictiveRouteEntry = true;
                newData.addressInfo.Trips[z].Details[0].tripInfo.InsertPredictiveRouteEntry = true;
                continue;
              }
            }

            // 10. Check Guests array differences
            const newGuests = newPickup.passengerInfo?.Guests || [];
            const originalGuests = originalPickup.passengerInfo?.guests || [];
            
            if (newGuests.length !== originalGuests.length) {
              lstTripData[z].InsertPredictiveRouteEntry = true;
              newData.addressInfo.Trips[z].Details[0].tripInfo.InsertPredictiveRouteEntry = true;
              continue;
            }

            // Check each guest object for differences
            for (let i = 0; i < newGuests.length; i++) {
              if (newGuests[i]?.Name !== originalGuests[i]?.Name || 
                  newGuests[i]?.Attributes !== originalGuests[i]?.Attributes) {
                lstTripData[z].InsertPredictiveRouteEntry = true;
                newData.addressInfo.Trips[z].Details[0].tripInfo.InsertPredictiveRouteEntry = true;
                continue;
              }
            }

            // 11. Check Children array differences
            const newChildren = newPickup.passengerInfo?.Children || [];
            const originalChildren = originalPickup.passengerInfo?.children || [];
            
            if (newChildren.length !== originalChildren.length) {
              lstTripData[z].InsertPredictiveRouteEntry = true;
              newData.addressInfo.Trips[z].Details[0].tripInfo.InsertPredictiveRouteEntry = true;
              continue;
            }

            // Check each child object for differences
            for (let i = 0; i < newChildren.length; i++) {
              if (newChildren[i]?.Name !== originalChildren[i]?.Name || 
                  newChildren[i]?.Attributes !== originalChildren[i]?.Attributes) {
                lstTripData[z].InsertPredictiveRouteEntry = true;
                newData.addressInfo.Trips[z].Details[0].tripInfo.InsertPredictiveRouteEntry = true;
                continue;
              }
            }
          }
        }
      }

      console.log(lstTripData);
      return lstTripData;
       

   };


    const PredictiveNegotiationStatusCard_OnAction = (action, status, confirmatinNumber, pickDate) => {
      try {
        if(action === "Continue"){
          onPredictiveNegotiationStatusCardClick();
        }
        else if(action == "Cancel" && status === "Routed"){
          handlePredictiveCancel(confirmatinNumber);
        }
        else if(action === "Edit" && (status === "UnRouted" || status === "Pending")){
          handlePredictiveEdit(confirmatinNumber, pickDate);
        }
        else if(action === "Cancel" && (status === "UnRouted" || status === "Pending")){
          handlePredictiveCancel(confirmatinNumber);
        }
        else if(action === "Force Time" && status === "Routed (Out of Window)"){
          handlePredictiveForceReq(confirmatinNumber);
        }
        else if(action === "Cancel" && status === "Routed (Out of Window)"){
          handlePredictiveCancel(confirmatinNumber);
        }
      } catch (error) {
        
      }
    }

    const DoesPCAIncludedInAttributes = (trips) => {
      try {
        let hasPCA = false;

        for (let trip of trips) {
            for (let detail of trip.Details) {
                const pcaList = detail.passengerInfo.PCA;
                if (pcaList && pcaList?.length > 0) {
                    hasPCA = true;
                    break; 
                }
            }
            if (hasPCA) break;
        }
        return hasPCA;

      } catch (error) {
        return false;
      }
    }

    async function CallToValidateMobilityCapacities(payload, xCancelSourceForGrid, i, showLegCounter = true) {
      let validationMsgsLst = [];
      try {
        let validationMsg = "";
        let response = await APICom.fetchData("ReservationCoreURL", "ValidateMobilityCapacityAgainstLimits", "post",
          {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'mode': 'no-cors'
          }, payload, xCancelSourceForGrid.current
        );

        if (response.error == "") {
        }
      } catch (error) {
        console.error('Submission error:', error);
        return [];
      }
      return validationMsgsLst;
    }


    async function ValidateDuplicateTrips(payload, xCancelSourceForGrid) {
      try {
        
        let json = {
          "vPickupPerson": payload.vPickupPerson, 
          "vPickupAddress": payload.vPickupAddress, 
          "vPickupCity": payload.vPickupCity, 
          "vPickupState": payload.vPickupState, 
          "vDropoffAddress": payload.vDropoffAddress, 
          "vDropoffCity": payload.vDropoffCity, 
          "vDropoffState": payload.vDropoffState,
          "dtPickupDate": payload.dtPickupDate,
          "iATSPID": payload.iATSPID
        }

        let response = await APICom.fetchData("ReservationCoreURL", "api/ParatransitCT/PromptRequestAlreadyExists", "post",
          {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'mode': 'no-cors'
          }, json, xCancelSourceForGrid
        );

        if (response.error == "" && response.data != false) {
          setShowAPILoader(false);
          return new Promise((resolve) => {
            setDuplicateTripsTableData(response.data);
            setShowClienteDuplicateTripsModal(true);
            setModalResolveAllowDuplicate(() => resolve);
          });
        }
        else{
          return -1;
        }
      } catch (error) {
        setShowAPILoader(false);
        console.error('Submission error:', error);
        return -1;
      }
    }
 
    const ZeroFareValidation = async (Payload) => 
    {
      let valid = 'True';
      if(Payload && Payload.addressInfo.Trips.length == 1)
      {
          
        let validateZeroFareResponse = "";
        if(Payload.addressInfo.Trips[0].Details[0].estimatedInfo.EstimatedCost =='0')
        {
          let data = {
            "PickFareZone": Payload.addressInfo.Trips[0].Details[0].addressDetails.FareZone,
            "DropFareZone": Payload.addressInfo.Trips[0].Details[1].addressDetails.FareZone,
            "AffiliateID": Payload.generalInfo.RequestAffiliateID,
            "Return": false,
            "ReturnFareZone": ""
          };
        
          validateZeroFareResponse = await APICom.fetchData("ReservationCoreURL","api/ParatransitCT/ValidateZeroFare", "post", {}, data, xCancelSourceForGrid.current);
          if(validateZeroFareResponse.data && validateZeroFareResponse.data.length > 0)
          {
            valid = validateZeroFareResponse.data[0].Result.toString();
            validateZeroFare.current.FareAlertMessage = validateZeroFareResponse.data[0].FareAlertMessage;
          }
        }
      }
      return valid;
    }

    const ZeroFareValidationByValues = async (PickFareZone, DropFareZone, AffiliateID, EstimatedCost) => 
    {
      let valid = 'True';
         
        let validateZeroFareResponse = "";
        if(EstimatedCost =='0')
        {
          let data = {
            "PickFareZone": PickFareZone,
            "DropFareZone": DropFareZone,
            "AffiliateID": AffiliateID,
            "Return": false,
            "ReturnFareZone": ""
          };
        
          validateZeroFareResponse = await APICom.fetchData("ReservationCoreURL","api/ParatransitCT/ValidateZeroFare", "post", {}, data, xCancelSourceForGrid.current);
          if(validateZeroFareResponse.data && validateZeroFareResponse.data.length > 0)
          {
            valid = validateZeroFareResponse.data[0].Result.toString();
            validateZeroFare.current.FareAlertMessage = validateZeroFareResponse.data[0].FareAlertMessage;
          }
        }
      return valid;
    }


  return(
    <>
    
    <div>
    {isLoading && (
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(255, 255, 255, 0.7)', // light overlay
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 999,
        }}
      >
        <Spinner
          as="span"
          animation="border"
          size="sm"
          role="status"
          aria-hidden="true"
          style={{ marginBottom: '3px' }}
        />
        <label style={{marginLeft: "10px",fontSize: "larger",marginBottom: "5px"}}>Please wait, Loading Data....</label>
      </div>
    )}
     <div style={{opacity: isLoading ? 0.5 : 1}}>
      {ctpanel.ShowcontextPanel? <ContextTransferPanel ctphoneno={ctpanel.ContextPhoneNo} ctdatetime={ctpanel.ContextDateTime} ctpopulatedata={handleContextTripLoad} ctpaneldata={ctpanel.ContextPanelData}/> : "" }
      <ARBResponseListener handlePageProgressBar={handlePageProgressBar} handlePredictiveResponse={handlePredictiveResponse} setAlert = {setAlert} showARBValidationsMessage={false}/>
      <CallerIDNotifierListener  onUpdatePhone={updatePhoneNumber} />
      <Row className="m-0 px-1" style={{backgroundColor:"#07447b", height:"38px", maxHeight:"38px"}}>
        <Col className="d-flex my-auto align-items-center">
          <img src={ITCLogo} className='ITCLogo page-header-logo user-select-none p-0 m-0' style={{maxWidth:"200px", maxHeight:"30px"}} alt="ITCurves" />
          <p className="fw-bold text-white text-center text-nowrap callAgentTitleResponsive overflow-hidden h3 user-select-none flex-grow-1" style={{margin:"0",marginLeft:"10%"}}>
            {(transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2) ?
             <>
              {IsAffMicroFlag ? <span className="callAgentLabelsResponsive">Microtransit</span> : ''} Reservation
             </>
             :
             <>
              {IsAffMicroFlag ? <span className="callAgentLabelsResponsive">Paratransit</span> : ''} Reservation
             </>}
          </p>

          <span className="d-inline-flex text-end callAgentTitleAffResponsive" style={{marginRight:"9%"}}>
            <Icon icon="bx:sitemap" className="text-white my-auto" style={{width:"20px", height:"20px"}}/>
            <label className='m-0 mx-1 user-select-none my-auto text-white callAgentLabelsResponsive'>Affiliate:</label>
            <select ref={affiliateSelRef} style={{textOverflow:"ellipsis", borderRadius:"5px", maxHeight:"30px", height:"30px"}} 
              value={(selectedAff? selectedAff:"")} 
              onChange={(e)=>{handleAffChange(e); if(paratransitBookBtnRef.current){paratransitBookBtnRef.current.disabled = false;}}} 
              className='text-center mx-1 overflow-hidden callAgentInputStyle callAgentAffDropdownResponsive' tabIndex={-1}
            >
              {affiliateDropDownHTML}
            </select>
          </span>
        </Col>
      </Row>
      <Row className='callAgentMainColsResponsive' style={{boxShadow:"0px 3px 6px #999"}}>
        <Col xs={6} className="my-1 overflow-auto callAgentSummaryScroller">
          <span className="d-inline-flex" style={{width:"100%"}}>
            {screenWidthSize >= 720 ? 
              <>
                <span className="d-inline-flex mx-1">
                  {renderPhone(true)}
                </span>
                <span className="d-inline-flex mx-1">
                  {renderClientName(true)}
                </span> 
                <span className="d-inline-flex mx-1">
                  {renderMedicalID(true)}
                </span> 
                {renderSearchBtn()}
              </> 
            : ""}
            
            {searchButtonValidation !== "" ? <p className="text-danger fw-bold small m-0 overflow-hidden user-select-none text-nowrap my-auto" 
              title={searchButtonValidation} style={{textOverflow:"ellipsis", paddingLeft:"5px"}}
            >{searchButtonValidation}</p> :""}
          </span>
          
          {microtransit ? "":
          <>
            <span className="d-inline-flex">
              <Icon icon="bx:user" className="m-1" style={{width:"20px", height:"20px"}}/>
              <label className='m-0 m-1 user-select-none fw-bold'>Name</label>
              <input type={"text"} value={riderNameCheck} onChange={(e)=>setRiderNameCheck(e.target.value)} placeholder={"Client Name"} style={{width:"120px"}}/>
            </span>
            
          </>
          }
          
        </Col>
        <Col xs={6} className="text-end my-auto">
          <div className="d-flex justify-content-end">
            <div className="d-flex flex-nowrap overflow-auto callAgentSummaryScroller">
              {screenWidthSize >= 720 ?
                <>
                  <span className="d-inline-flex mt-1 small" title={"Client Status"}>
                    <Icon icon="hugeicons:user-status" className="m-1" style={{width:"20px", height:"20px"}}/>
                    <label className='m-0 my-1 user-select-none fw-bold text-nowrap callAgentLabelsResponsive'>Client Status</label>
                    <select style={{minWidth:"110px", maxHeight:"30px", height:"30px"}} tabIndex={-1} value={clientStatus} 
                      onChange={(e)=>setClientStatus(e.target.value)} disabled className='text-center mx-1 callAgentInputStyle'
                    >
                      <option>Select...</option>
                    </select>
                  </span>
                  <span className="d-inline-flex mx-1 mt-1 small" title={"Class of Service (Vehicle Type)"}>
                    {renderCOSJSXDropdown(true)}
                  </span> 
                </> 
              : 
                <>
                  {!showSideBar ? 
                    <Button type='button' variant='light' 
                      className='border-0 p-0 rounded' onClick={()=>{setShowSideBar(true);}} title="Client Search"
                    ><Icon icon="bx:menu" className='w-100' style={{color:"gray", height:"30px", cursor:"pointer", display:"block", zIndex:"999"}}/></Button>
                    :
                    <div className={`sidebarCallTaker pt-4 ${showSideBar ? 'open' : ''} bg-dark`}>
                      <Button variant="transparent"className="border-0 p-0 text-white rounded close-btn" onClick={()=>{setShowSideBar(false);}}>
                        &times;
                      </Button>
                      <ul className="list-unstyled mt-1 text-center">
                        <h5 className="my-2 text-white user-select-none text-nowrap overflow-hidden">{"Client Search"}</h5>
                        <li className="border border-white" style={{height:"2px"}}></li>
                        <li>
                          {renderPhone()}
                        </li>
                        <li>
                          {renderClientName()}
                        </li>
                        <li>
                          {renderMedicalID()}
                        </li>
                        <li>
                          {renderSearchBtn("my-2 callTakerSideBarSearchBtnStyle")}
                        </li>
                        <h5 className="my-2 text-white user-select-none text-nowrap overflow-hidden">{"Client Status"}</h5>
                        <li className="border border-white" style={{height:"2px"}}></li>
                        <li>
                          <select style={{width:"120px", maxWidth:"120px", maxHeight:"30px", height:"30px"}} tabIndex={-1} value={clientStatus} 
                            onChange={(e)=>setClientStatus(e.target.value)} disabled className='text-center my-2 callAgentInputStyle'
                          >
                            <option>Select...</option>
                          </select>
                        </li>
                        <h5 className="my-2 text-white user-select-none text-nowrap overflow-hidden" title="Class of Service">{"COS"}</h5>
                        <li className="border border-white" style={{height:"2px"}}></li>
                        <li>
                          {renderCOSJSXDropdown()}
                        </li>
                      </ul>
                    </div>
                  }
                </>
              }
            </div>
          </div>
        </Col>
      </Row>
      {ShowAPILoader ? <div className="loader"></div> : ""}
      <Row style={dynamicModeRowStyle} className="roundedEndsStyle callAgentMainColsResponsive">
        <Col xs={6} className="overflow-auto callAgentSummaryScroller border-end border-secondary" style={dynamicModeStyle}>
          <Row style={{height:"35px", maxHeight:"35px"}}>
            <Col className="text-start" onClick={(e)=>{setClientInfoDisplay(!clientInfoDisplay);}} style={{backgroundColor:"#07447b"}}>
              <span className="d-inline-flex my-auto w-75" title={"Client Information"}>
                <Icon icon="bx:info-circle" className="mt-1 text-white" style={{minWidth:"25px", minHeight:"25px", width:"25px", height:"25px"}}/>
                <label className='m-0 m-1 user-select-none fw-bold text-white text-nowrap overflow-hidden' style={{textOverflow:"ellipsis"}}>Client Information</label>
              </span>
              {(transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2) ?  
                <span className="d-inline-flex mt-1 float-end" tabIndex={0} ref={clientInfoDisplayRef}
                  onClick={(e)=>{setClientInfoDisplay(!clientInfoDisplay);}} onKeyDown={(e)=>{
                    if(e.key === "Enter"){setClientInfoDisplay(!clientInfoDisplay);}
                    else if(e.key === 'Tab' && !e.shiftKey)
                    {
                      if(clientInfoDisplay)
                      {
                        e.preventDefault();
                        riderNameRef.current.focus();
                      }
                    }
                  }}
                >
                  {clientInfoDisplay? <Icon icon="bx:chevron-down" className="text-white" style={{width:"25px", height:"25px", cursor:"pointer"}}/>:
                    <Icon icon="bx:chevron-up" className="text-white" style={{width:"25px", height:"25px", cursor:"pointer"}}/>
                  }
                </span>
              :""}
            </Col>
          </Row>
          <Row className={`${clientInfoDisplay? '':'d-none'}`}>
            <Col className={`text-start p-0 overflow-auto overflow-y-hidden callAgentSummaryScroller`} style={{maxHeight:"580px"}}>
              <Row className="m-0 w-100">
                <Row>
                  <Col xs={2}>
                    <span className="d-block small mt-1 text-nowrap overflow-hidden" title={"Full Name"}>
                      <Icon icon="bx:user" className="m-1" style={{width:"15px", height:"15px"}}/>
                      <label className='m-0 my-1 user-select-none callAgentLabelsResponsive'>Name</label>
                    </span>
                    <span className="d-block small mt-2 text-nowrap" 
                      title={((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2) ? "Pickup" : "Pickup or Virtual Stop")}
                    >
                      <Icon icon="bx:map" className="m-1 text-success" style={{width:"15px", height:"15px"}}/>
                      <label className='m-0 user-select-none callAgentLabelsResponsive'>
                        {(transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2) ?"PU":"PU/VS"}
                      </label>
                    </span>
                    <span className="d-block small mt-1 text-nowrap" title={"Pickup Route Coverage Zone"}>
                      <Icon icon="bx:map-alt" className="m-1 text-info" style={{width:"15px", height:"15px"}}/>
                      <label className='m-0 my-1 user-select-none callAgentLabelsResponsive'>Zone</label>
                    </span>
                    {(transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2) ?
                      <span className="text-start mt-3 justify-content-start d-block AddressIconsResponsive" title={"Switch Addresses"}>
                        <Icon icon="bx:sort-alt-2" tabIndex={0} ref={addressSwitchBtnRef}
                          onClick={handleReturnCheck} onKeyDown={(e)=>{
                            if(e.key === "Tab" && !e.shiftKey)
                            { 
                              e.preventDefault();
                              passengerCountPassengerRef.current.focus();
                            }
                            else if(e.key === "Tab" && e.shiftKey)
                            {
                              e.preventDefault();
                              pickExtraInfoRef.current.focus();
                            }
                            else
                            {
                              handleReturnCheck(e);
                            }
                          }} className="m-1" 
                          style={{cursor:"pointer", width:"20px", height:"20px", color:"darkgreen"}}
                        />
                      </span>
                    :""}
                    
                  </Col>
                  <Col xs={10} className="p-0">
                    
                    <Row className="my-1">
                      {(transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2) ? 
                      <>
                        <Col xs={6} className="d-flex">
                          <input type={"text"} value={riderName} autoComplete="new_pass" ref={riderNameRef} minLength={4} maxLength={35} required 
                            onChange={handleNameInputOnChange} tabIndex={0}
                            onKeyDown={(e)=>{
                              if(e.key === "Tab" && e.shiftKey)
                              {
                                e.preventDefault();
                                clientInfoDisplayRef.current.focus();
                              }
                            }}
                            className='text-nowrap p-0 px-1 callAgentInputStyle w-100' placeholder="Full Name" onKeyUp={handleSetRiderName} 
                            style={{maxHeight:"30px", height:"30px"}}
                          /> 
                          {accountNumber === '' ? 
                            <span onClick={handleNewClientManualLoad} onKeyDown={(e)=>{if(e.key === 'Enter'){handleNewClientManualLoad(e);}}} 
                              className="d-inline-flex my-auto user-select-none" 
                              style={{cursor:"pointer"}} title={'Add New Client'} tabIndex={0}
                            >
                              <Icon icon='fa-solid:pencil-alt' className={`text-info ms-1`} style={{width:"15px", height:"15px"}}/>
                            </span> 
                          : ""}
                        </Col>
                        <Col xs={6}>
                          <span className="d-flex justify-content-end">
                            <input type={"text"} value={accountNumber} autoComplete="new_pass" minLength={4} required 
                              onChange={handleAccountNumberChange} tabIndex={-1} title={"Client ID"}
                              className='text-nowrap p-0 px-1 d-inline-block callAgentInputStyle w-50' placeholder="Client ID"
                              style={{maxHeight:"30px", height:"30px"}} readOnly
                            /> 
                            <input type={"text"} value={medID} autoComplete="new_pass" minLength={4} required 
                              onChange={(e)=>{setMedID(e.target.value);}} tabIndex={-1} title={"Rider ID"} onBlur={async(e)=>{if(!e.target.readOnly){await handleBlurRiderID(e);}}}
                              className='text-nowrap p-0 px-1 ms-2 callAgentInputStyle d-inline-block w-50' placeholder="Rider ID"
                              style={{maxHeight:"30px", height:"30px"}} 
                              readOnly={(brokerModes.globalBrokerMode > 0 && brokerModes.brokerMode > 0 ? false : true)}
                            /> 
                            {parseInt(brokerModes.globalBrokerMode) > 0 && parseInt(brokerModes.brokerMode) > 0 && riderVerification !== ""? 
                              
                              <span title={riderVerification}>
                                <Icon icon={`${fareEstimateAPISummary.verifyStatus !== "true" ? "entypo:circle-with-cross" : "lets-icons:check-fill"}`} 
                                  className={`${fareEstimateAPISummary.verifyStatus !== "true" ? "text-danger":"text-success"} ms-1 my-auto`} style={{width:"15px", height:"15px"}}
                                />
                              </span>
                            : ""} 
                          </span>
                          
                        </Col>
                      </> :
                      <Col>
                        <input type={"text"} value={riderName} autoComplete="new_pass" ref={riderNameRef} minLength={4} maxLength={35} required 
                          onChange={handleNameInputOnChange} tabIndex={0}
                          className={`text-nowrap p-0 px-1 callAgentInputStyle ${accountNumber === '' ? 'w-75':'w-100'}`} 
                          placeholder="Full Name" onKeyUp={handleSetRiderName} 
                          style={{maxHeight:"30px", height:"30px"}}
                        /> 
                        {/* searchButtonValidation.toLowerCase().includes('no client') || (!searchButtonValidation.toLowerCase().includes('no client') && (Array.isArray(clientInfo))) */}
                        {accountNumber === '' ? 
                          <span onClick={handleNewClientManualLoad} onKeyDown={(e)=>{if(e.key === 'Enter'){handleNewClientManualLoad(e);}}} 
                            className="d-inline-flex my-auto user-select-none" 
                            style={{cursor:"pointer"}} title={'Add New Client'} tabIndex={0}
                          >
                            <Icon icon='fa-solid:pencil-alt' className={`text-info ms-1`} style={{width:"15px", height:"15px"}}/>
                          </span> 
                        : ""}
                      </Col>
                      }
                    </Row>
                    <Row className="mt-1">
                      <Col xs={(transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2) ? 6:12} className="">
                        <span className="position-relative">
                          <input type={"search"} autoComplete="new_pass" value={pickupAddr} placeholder="Pickup Address..." 
                            title={pickupAddr + " (Search POI by typing #POI Name)"} onChange={handlePUAddrChanged}
                            style={{ textOverflow:"ellipsis", maxHeight:"30px", height:"30px"}} 
                            className='text-nowrap d-inline-flex px-1 p-0 pe-3 w-100 callAgentInputStyle' 
                            onFocus={handlePUAddrChanged} onBlur={()=>{setTimeout(() => {
                              if(!focusedSuggestionCheckPU.current)
                              {
                                setInputSuggestionListPU("");
                              }
                            }, 300);}}
                            onKeyDown={(e)=>{
                              if(e.key === 'ArrowDown')
                              {
                                e.preventDefault();
                                setHighlightedIndex(-1);
                                if(liRefs.current.length > 0)
                                {
                                  if(liRefs.current[0]?.current) //check for empty references
                                  {
                                    setHighlightedIndex((prevIndex) => {
                                      const newIndex = (prevIndex + 1) % liRefs.current.length;
                                      liRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                                      return newIndex;
                                    });
                                  }
                                }
                              }
                              else if (e.key === 'ArrowUp') {
                                e.preventDefault();
                                setHighlightedIndex(-1);
                                if(liRefs.current.length > 0)
                                {
                                  if(liRefs.current[0]?.current)
                                  {
                                    setHighlightedIndex((prevIndex) => {
                                      const newIndex = (prevIndex - 1 + liRefs.current.length) % liRefs.current.length;
                                      liRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                                      return newIndex;
                                    });
                                  }
                                }
                              }
                            }}
                          />
                          {renderAddressApartmentInfoPopup('pick')}
                          {renderAddressPhoneInfoPopup('pick')}
                        </span>
                        {inputSuggestionListPU && inputSuggestionListPU !== "" ?
                          <ul tabIndex={0} className="user-select-none border position-absolute px-1" 
                            style={{width:"auto", maxWidth:"400px", height:"80px", overflowY:"auto", zIndex:1000, backgroundColor:"#e6eef1"}} 
                          >
                            {inputSuggestionListPU}
                          </ul>
                        :""}
                        
                      </Col>
                      {(transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2) ? 
                        <Col xs={6} className="d-flex my-auto">
                          <select className='text-left w-100 overflow-hidden callAgentInputStyle' value={pickupVirtualStop.value} name={pickupVirtualStop.name} onChange={handleVSChange} 
                            title={"Pickup Virtual Stop: "+pickupVirtualStop.name} style={{height:"25px", maxHeight:"25px", textOverflow:"ellipsis"}} disabled={isVSSelectionDisabled} ref={PUVSDropdownRef}
                          >
                            <option value={"PU VS"}>Select Virtual Stop</option>
                            {virtualStopDropDownHTML}
                          </select>
                          {walkDistance.PUWalk !== 0?<p className="m-0 d-inline-flex user-select-none text-nowrap">{"("+walkDistance.PUWalk+"mi, "+walkDistance.PUDuration+"min)"}</p>: ""}
                        </Col>
                      : ""}
                    </Row>
                    <Row className="mt-1">
                      <Col>
                        <p type={"text"} style={{textOverflow:"ellipsis", maxWidth:"260px"}} 
                          title={((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2) ? (zones!==""?zones:"Unknown Zone")
                            :(pickPOI !== ""?("POI: " +pickPOI) : dispatchZones.pickZone))} 
                          className="overflow-hidden user-select-none text-nowrap m-0 w-100 fw-bold small">
                          {(transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2) ? 
                            (zones !== "" ? zones:""):(pickPOI !== ""?`${dispatchZones.pickZone}${'\u00A0'.repeat(4)}${pickPOI}` : dispatchZones.pickZone)
                          }
                        </p>
                        
                      </Col>
                      <Col className="d-inline-flex justify-content-start">
                        <p className='m-0 mx-1 user-select-none small'>Notes</p>
                        <textarea
                          name="ctl00$ctl00$ContentPlaceHolder1$ContentPlaceHolder1$txtAgentInstructionNotes"
                          rows={2}
                          cols={20} ref={pickExtraInfoRef}
                          onKeyDown={(e)=>{
                            // if(e.key === "Tab" && !e.shiftKey)
                            // {
                            //   e.preventDefault();
                            //   if(addressSwitchBtnRef.current){
                            //     addressSwitchBtnRef.current.focus();
                            //   }
                            // }
                          }}
                          placeholder="Pickup extra info..."
                          id="ctl00_ctl00_ContentPlaceHolder1_ContentPlaceHolder1_txtAgentInstructionNotes"
                          style={{resize:"none", minWidth:"84px"}} autoComplete="new_pass"
                          value={pickExtraInfo} onChange={(e)=>setPickExtraInfo(e.target.value)}
                          className="tripDetails-label-dataFields d-inline-flex w-100 callAgentInputStyle"
                        />
                      </Col>
                      
                    </Row>
                    {(transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2) ? 
                      <>
                        <Row className="m-0">
                          <Col className={`d-inline-flex ${screenWidthSize <= 630 ? "flex-wrap justify-content-start" : ""}`}>
                            <span className={`d-inline-flex small my-1 text-nowrap ${screenWidthSize <= 630 ? "mb-0" : ""}`}>
                              <Icon icon="bx:group" className="my-auto text-secondary" style={{width:"25px", height:"25px"}}/>
                              <label className='m-0 my-2 user-select-none callAgentLabelsResponsive' title={"Ambulatory Passenger Count"}>Pass.</label>
                              <input type={"number"} maxLength={2} value={passengerTypeCount.ambPass} style={{minWidth:"25px", maxHeight:"30px", height:"30px"}} 
                                name="ambPass" onChange={handlePassCountTotal} autoComplete="new_pass" ref={passengerCountPassengerRef}
                                onKeyDown={(e)=>{
                                  if(e.key === "Tab" && e.shiftKey)
                                  {
                                    e.preventDefault();
                                    if(addressSwitchBtnRef.current){
                                      addressSwitchBtnRef.current.focus();
                                    }
                                  }
                                }}
                                className='text-nowrap border-1 p-1 m-1 w-25 text-center callcenterInputNumbers callAgentInputStyle no-counter'
                              />
                              {screenWidthSize <= 630 ?
                                <>
                                  <Icon icon="bx:handicap" className="my-auto text-primary" style={{width:"25px", height:"25px"}}/>
                                  <label className='m-0 my-2 user-select-none callAgentLabelsResponsive' title={"WheelChair Passenger Count"}>WC</label>
                                  <input type={"number"} maxLength={2} value={passengerTypeCount.totalWC} disabled = {isAffiliateHasMobilityAttributes == true ? true : false }
                                    style={{minWidth:"25px", maxHeight:"30px", height:"30px"}} name="totalWC" onChange={handlePassCountTotal} autoComplete="new_pass"
                                    className='text-nowrap border-1 p-1 m-1 w-25 text-center callcenterInputNumbers callAgentInputStyle no-counter'
                                  />

                                  {isAffiliateHasMobilityAttributes &&
                                  <>
                                    <Icon icon="mdi:human-child" className="my-auto text-primary" style={{width:"25px", height:"25px", color: "#c3a386", marginRight: "5px"}}/>
                                    <label className='m-0 my-2 user-select-none callAgentLabelsResponsive' title={"Children Count"}>Children</label>
                                    <input type={"number"} maxLength={2} value={passengerTypeCount.totalChildren} 
                                      style={{minWidth:"25px", maxHeight:"30px", height:"30px"}} name="childCount" onChange={handlePassCountTotal} autoComplete="new_pass"
                                      className='text-nowrap border-1 p-1 m-1 w-25 text-center callcenterInputNumbers callAgentInputStyle no-counter'
                                    />
                                    </>
                                  }
                                </>
                              :""}
                            </span>
                            {screenWidthSize > 630 ?
                              <>
                                <span className={`d-inline-flex small my-1 text-nowrap`}>
                                  <Icon icon="bx:handicap" className="my-auto text-primary" style={{width:"25px", height:"25px"}}/>
                                  <label className='m-0 my-2 user-select-none callAgentLabelsResponsive' title={"WheelChair Passenger Count"}>WC</label>
                                  <input type={"number"} maxLength={2} value={passengerTypeCount.totalWC}  disabled = {isAffiliateHasMobilityAttributes == true ? true : false }
                                    style={{minWidth:"25px", maxHeight:"30px", height:"30px"}} name="totalWC" onChange={handlePassCountTotal} autoComplete="new_pass"
                                    className='text-nowrap border-1 p-1 m-1 w-25 text-center callcenterInputNumbers callAgentInputStyle no-counter'
                                  />

                                 {isAffiliateHasMobilityAttributes &&
                                 <>
                                  <Icon icon="mdi:human-child" className="my-auto text-primary" style={{width:"25px", height:"25px", color: "#c3a386" , marginRight: "5px"}}/>
                                  <label className='m-0 my-2 user-select-none callAgentLabelsResponsive' title={"Children Count"}>Children</label>
                                  <input type={"number"} maxLength={2} value={passengerTypeCount.totalChildren} 
                                    style={{minWidth:"25px", maxHeight:"30px", height:"30px"}} name="childCount" onChange={handlePassCountTotal} autoComplete="new_pass"
                                    className='text-nowrap border-1 p-1 m-1 w-25 text-center callcenterInputNumbers callAgentInputStyle no-counter'
                                  />
                                  </>
                                }
                                </span>
                              </>
                            :""}
                            
                            <span className={`d-inline-flex small text-nowrap ${screenWidthSize <= 630 ? "my-0" : "my-1"}`} style={{alignItems: "center"}}>
                              <Icon icon="material-symbols:pets" className="my-auto" style={{width:"25px", height:"25px", color: "#c3a386"}}/>
                              <label className='m-0 my-2 user-select-none callAgentLabelsResponsive' title={"Service Animal Count"}>SA</label>
                              <input type={"number"} maxLength={2} value={passengerTypeCount.totalSA} style={{minWidth:"25px", maxHeight:"30px", height:"30px"}} name="totalSA"
                                onChange={handlePassCountTotal} 
                                className='text-nowrap border-1 p-1 m-1 w-25 text-center callcenterInputNumbers callAgentInputStyle no-counter' autoComplete="new_pass"
                              />
                              {screenWidthSize <= 630 ?
                                <>
                                  <Icon icon="ph:stack-plus-fill" className="my-auto" style={{width:"25px", height:"25px", color: "#ffcc00"}}/>
                                  <label className='m-0 my-2 user-select-none callAgentLabelsResponsive' title={"Total Passengers Count"}>Total</label>
                                  <input type={"text"} value={passengerTypeCount.total} style={{minWidth:"25px", maxHeight:"30px", height:"30px"}} name="total" 
                                  onChange={handlePassCountTotal} 
                                  autoComplete="new_pass"
                                    disabled  className='text-nowrap border-1 p-1 m-1 w-25 text-center callAgentInputStyle' title={"Total Passengers Count: "+passengerTypeCount.total}
                                  />
                                  {isAffiliateHasMobilityAttributes &&
                                    <Button tabIndex={0} variant="secondary" className="p-0 p-1 rounded" 
                                      style={{ borderRadius: "0px", width: "37%", height: "30px", maxHeight: "30px"}} title={"Show Mobility Attributes"} 
                                      onClick={handleCloseStops}>
                                      <Icon 
                                        icon={mobilityAdditions} 
                                        width="16" 
                                        height="16" 
                                      />
                                    </Button>
                                  }
                                </>
                              :""}
                            </span>
                            {screenWidthSize > 630 ?
                              <>
                                <span className={`d-inline-flex small my-1 text-nowrap`} style={{alignItems: "center"}}>
                                  <label className='m-0 my-2 user-select-none' title={"Total Passengers Count"}>Total</label>
                                  <input type={"text"} value={passengerTypeCount.total} style={{minWidth:"25px", maxHeight:"30px", height:"30px"}} name="total"  autoComplete="new_pass"
                                    disabled  className='text-nowrap border-1 p-1 m-1 w-25 text-center callAgentInputStyle' title={"Total Passengers Count: "+passengerTypeCount.total}
                                  />
                                  {isAffiliateHasMobilityAttributes &&
                                    <Button tabIndex={0} variant="secondary" className="p-0 p-1 rounded" 
                                      style={{ borderRadius: "0px", width: "37%", height: "30px", maxHeight: "30px"}} title={"Show Mobility Attributes"} 
                                      onClick={handleMobilityAttributesBtn}>
                                      <Icon 
                                        icon={mobilityAdditions} 
                                        width="16" 
                                        height="16" 
                                      />
                                    </Button>
                                  }
                                </span>
                              </>
                            : ""}
                            {/* <>
                              <span>
                                
                              </span>
                            </> */}
                          </Col>
                        </Row>
                      </>
                    :""}
                  </Col>
                </Row>
                {(transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2) ?
                  <Row>
                    <Col xs={2} className="d-flex flex-column">
                      
                      <span className="d-block small text-start AddressIconsResponsive text-nowrap my-auto" title={"Add a stop to the trip"}>
                        <Icon icon="bx:plus-circle" tabIndex={0} onKeyDown={(e)=>
                            {
                              // if(e.key === "Enter")
                              // {
                              //   setShowStopBlock(true);
                              //   setShowStopsInput(true);
                              //   if(stopLatLng.current !== "")
                              //   {
                              //     handleAddTripStops(e);
                              //   }
                              // }
                            }
                          } className="m-1 text-secondary" style={{width:"15px", height:"15px", cursor:"not-allowed"}} onClick={(e)=>{
                            // setShowStopBlock(true); 
                            // setShowStopsInput(true);
                            // if(stopLatLng.current !== "")
                            // {
                            //   handleAddTripStops(e);
                            // }
                          }}
                        />
                      </span>
                      <span className="d-block small text-start dottedLineResponsive mb-0 text-nowrap user-select-none">
                        <label>⋮</label>
                      </span>
                    </Col>
                    {showStopBlock ? 
                      <Col xs={10} className="p-0 mt-1 border rounded my-auto overflow-auto callAgentSummaryScroller" style={{maxHeight:"150px"}}>
                        {clientStops && clientStops.length > 0 ? clientStops.map((item, index)=>{
                          let waitTime = (item.waitTime && item.waitTime !== 0 ? item.waitTime:0);
                          return(
                            <Row className="m-0 my-1" key={index}>
                              <Col className="mx-3 px-1 rounded callAgentInputStyle overflow-auto callAgentSummaryScroller">
                                <span className="d-block small justify-content-between my-auto mt-1 text-nowrap overflow-hidden">
                                  <Button tabIndex={0} variant="light" className="p-0 px-1 small rounded" style={{ borderRadius: "0px"}} 
                                    title={"Edit Stop"} onClick={(e)=>{handleEditStop(e, item, index)}} 
                                    onKeyDown={(e)=>{if(e.key === "Enter"){handleEditStop(e, item, index)}}}
                                  >
                                    {"Edit"}
                                  </Button>
                                  <Button tabIndex={0} variant="light" className="p-0 ms-1 px-1 small rounded" style={{ borderRadius: "0px"}} 
                                    title={"Remove Stop"} onClick={(e)=>{handleRemoveStop(e, index)}} 
                                    onKeyDown={(e)=>{if(e.key === "Enter"){handleRemoveStop(e, index)}}}
                                  >
                                    {"Remove"}
                                  </Button>
                                  <span title={"Move Stop Up"} onClick={(e)=>{handleMoveClientStops(index, "up");}}>
                                    <Icon icon="bx:chevrons-up" title={"Move Stop Up"} className="my-auto text-dark" style={{width:"20px", height:"20px", cursor:"pointer"}}/>
                                  </span>
                                  <span title={"Move Stop Down"} className="ms-2" onClick={(e)=>{handleMoveClientStops(index, "down");}}>
                                    <Icon icon="bx:chevrons-down" title={"Move Stop Down"} className="my-auto text-dark" style={{width:"20px", height:"20px", cursor:"pointer"}}/>
                                  </span>
                                  <label className='m-0 d-inline-block user-select-none text-end float-end'>
                                    {"Stop: "+(index+1)}
                                  </label>
                                </span>
                                <span className="d-flex small text-nowrap overflow-hidden">
                                  <Icon icon="bx:map" className="my-auto mx-1 text-dark" style={{width:"15px", height:"15px"}}/>
                                  <label className='m-0 user-select-none text-nowrap overflow-hidden' 
                                    style={{textOverflow:"ellipsis", whiteSpace: "nowrap", minWidth:"150px", maxWidth:"250px"}}
                                    title={item.stopAddr}
                                  >
                                    {item.stopAddr}
                                  </label>
                                </span>
                                <span className="small text-nowrap overflow-hidden">
                                  <span className="d-inline-flex">
                                    <Icon icon="bx:pen" className="my-auto mx-1 text-dark" style={{width:"15px", height:"15px"}}/>
                                    <label className='m-0 user-select-none text-nowrap overflow-hidden' title={(item.notes === ""? "":"Notes: "+item.notes)}  
                                      style={{textOverflow:"ellipsis", whiteSpace: "nowrap", minWidth:"80px", maxWidth:"100px"}}>
                                      {(item.notes === "" ? "No Notes":item.notes)}
                                    </label>
                                  </span>
                                  <span className="d-inline-flex ms-2">
                                    <Icon icon="bx:alarm" className="my-auto mx-1 text-dark" style={{width:"15px", height:"15px"}}/>
                                    <label className='m-0 user-select-none text-nowrap overflow-hidden' 
                                      title={(parseInt(waitTime) === 0  ? "": " Wait: "+ (parseInt(waitTime) > 9 ? parseInt(waitTime) + " mins": parseInt(waitTime) + " min"))}  
                                      style={{textOverflow:"ellipsis", whiteSpace: "nowrap", minWidth:"80px", maxWidth:"100px"}}
                                    >
                                      {(parseInt(waitTime) === 0  ? "No Wait": (parseInt(waitTime) > 9 ? parseInt(waitTime) + " mins": parseInt(waitTime) + " min"))}
                                    </label>
                                  </span>
                                  <span className="d-inline-flex ms-2">
                                    <Icon icon="bx:walk" className="my-auto mx-1 text-dark" style={{width:"15px", height:"15px"}}/>
                                    <label className='m-0 user-select-none text-nowrap overflow-hidden' 
                                      title={"Load Type: "+ item.passLoadType.charAt(0).toUpperCase() + item.passLoadType.slice(1)}  
                                      style={{textOverflow:"ellipsis", whiteSpace: "nowrap", minWidth:"80px", maxWidth:"100px"}}
                                    >
                                      {(item.passLoadType === "none"? item.passLoadType.charAt(0).toUpperCase() + item.passLoadType.slice(1): item.passLoadType.charAt(0).toUpperCase() + item.passLoadType.slice(1) + " ("+item.stopPax.total+")")}
                                    </label>
                                  </span>
                                  {item.passengerName !== ""?
                                    <span className="ms-2 d-inline-flex my-auto">
                                      <Icon icon="bx:user" className="my-auto mx-1 text-dark" style={{width:"15px", height:"15px"}}/>
                                      <label className='m-0 user-select-none text-nowrap overflow-hidden' title={(item.passengerName)}  
                                        style={{textOverflow:"ellipsis", minWidth:"60px", maxWidth:"80px"}}>
                                        {item.passengerName}
                                      </label>
                                    </span>
                                  :""}
                                </span>
                              </Col>
                            </Row>
                          );
                          
                        }):""}
                        {showStopsInput ? 
                          <>
                            <Row className={`m-0 ${clientStops.length > 0 ? "":"mt-1"} mx-1`}>
                              <Col xs={8} className="position-relative my-auto">
                                <input type={"search"} autoComplete="new_pass" value={stopAddr} placeholder="Stop Address..." title={stopAddr + " (Search POI by typing #POI Name)"}
                                  style={{ textOverflow:"ellipsis", maxHeight:"28px", minWidth:"200px", height:"28px"}} onFocus={handleStopAddrChange}
                                  className='text-nowrap px-1 p-0 w-100 callAgentInputStyle' onChange={handleStopAddrChange}
                                  onBlur={()=>{setTimeout(() => {
                                    if(!focusedSuggestionCheckStop.current)
                                    {
                                      setInputSuggestionListStop("");
                                    }
                                  }, 300);}} onKeyDown={(e) => {
                                    if(e.key === 'ArrowDown')
                                    {
                                      e.preventDefault();
                                      setHightlightedIndexStop(-1);
                                      if(liRefsStop.current.length > 0)
                                      {
                                        if(liRefsStop.current[0]?.current) //check for empty references
                                        {
                                          setHightlightedIndexStop((prevIndex) => {
                                            const newIndex = (prevIndex + 1) % liRefsStop.current.length;
                                            liRefsStop.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                                            return newIndex;
                                          });
                                        }
                                      }
                                    }
                                    else if (e.key === 'ArrowUp') {
                                      e.preventDefault();
                                      setHightlightedIndexStop(-1);
                                      if(liRefsStop.current.length > 0)
                                      {
                                        if(liRefsStop.current[0]?.current)
                                        {
                                          setHightlightedIndexStop((prevIndex) => {
                                            const newIndex = (prevIndex - 1 + liRefsStop.current.length) % liRefsStop.current.length;
                                            liRefsStop.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                                            return newIndex;
                                          });
                                        }
                                      }
                                    }
                                  }}
                                />
                                {inputSuggestionListStop && inputSuggestionListStop !== "" ?
                                <ul tabIndex={0} className="user-select-none border position-absolute px-1 w-100" 
                                  style={{width:"auto", height:"80px", overflowY:"auto", zIndex:1000, backgroundColor:"#e6eef1"}} 
                                >
                                  {inputSuggestionListStop}
                                </ul>
                                :""}
                              </Col>
                              <Col xs={4} className="my-auto text-end">
                                {stopLoadType.none ?
                                  <span className="d-block my-auto small" style={{borderRadius:"4px", maxHeight:"28px"}}>
                                    <p className="m-0 my-auto d-inline-flex user-select-none text-nowrap" title={"Wait Time (minutes)"}>{"Wait"}</p>
                                    <input type={"number"} maxLength={2} value={stopWaitTimeInput} style={{width:"25px", maxWidth:"25px", maxHeight:"28px", height:"28px"}} 
                                      name="waitTime" onChange={handlePassCountTotalStop} autoComplete="new_pass"
                                      className='text-nowrap border-1 my-auto mx-1 w-25 text-center callcenterInputNumbers callAgentInputStyle no-counter'
                                    />
                                  </span>
                                :
                                stopLoadType.load ? 
                                  (
                                    <span className="d-block my-auto small" style={{borderRadius:"4px", maxHeight:"28px"}}>
                                      <input type={"text"} value={stopLoadRiderName} autoComplete="new_pass" minLength={4} maxLength={35} required 
                                        onChange={(e)=>{setStopLoadRiderName(e.target.value)}} tabIndex={0}
                                        className='text-nowrap p-0 px-1 callAgentInputStyle w-100' placeholder="Full Name"
                                        style={{maxHeight:"28px", height:"28px"}}
                                      /> 
                                    </span>
                                  )
                                  :(
                                    <span className="d-block my-auto small" style={{borderRadius:"4px", maxHeight:"28px"}}>
                                      <select className='text-center w-100 overflow-hidden callAgentInputStyle' value={stopUnloadRiderName} ref={StopNameSelectionRef}
                                        onChange={(e)=>{setStopUnloadRiderName(e.target.value)}} title={(stopUnloadRiderName === "RN" ? "Select Rider Name":stopUnloadRiderName)}
                                        style={{minWidth:"58px", maxHeight:"28px", height:"28px", textOverflow:"ellipsis"}}
                                      >
                                        <option value={"RN"} disabled hidden>{"Rider Name"}</option>
                                        {clientStops.length > 0 ? clientStops.map((item,index)=>{
                                          if(item.passengerName !== "" && item.passLoadType === "load")
                                          {
                                            return(
                                              <option key={index} value={item.passengerName}>{item.passengerName}</option>
                                            );
                                          }
                                        }):""}
                                      </select>
                                    </span>
                                  )
                                }
                              </Col>
                            </Row>
                            <Row className="m-0 mt-1 mx-1">
                              <Col className="text-start d-flex small">
                                <span className="d-inline-flex my-auto" style={{borderRadius:"4px", maxHeight:"28px"}}>
                                  <p className="m-0 small d-inline-block user-select-none text-nowrap">{"Load"}</p>
                                  <input type="checkbox" className="mx-1" style={{cursor:"pointer"}} checked={stopLoadType.load} 
                                    onChange={(e)=>{
                                      let noneChecked = false;
                                      if(!(e.target.checked)){noneChecked = true;}
                                      else{setStopWaitTimeInput(0);}
                                      setStopLoadType({none:noneChecked, load:e.target.checked, unload:false});}
                                    }
                                    onKeyDown={(e)=>{if(e.key === "Enter"){
                                      let noneChecked = false;
                                      if(e.target.checked){noneChecked = true;}
                                      else{setStopWaitTimeInput(0);}
                                      setStopLoadType({none:noneChecked, load:!(e.target.checked), unload:false});
                                    }}}
                                  />
                                </span>
                                <span className="d-inline-flex my-auto" style={{borderRadius:"4px", maxHeight:"28px"}}>
                                  <p className="m-0 small d-inline-block user-select-none text-nowrap">{"Unload"}</p>
                                  <input type="checkbox" className="mx-1" style={{cursor:"pointer"}} checked={stopLoadType.unload} 
                                    onChange={(e)=>{
                                      let noneChecked = false;
                                      if(!(e.target.checked)){noneChecked = true;}
                                      else{setStopWaitTimeInput(0);}
                                      setStopLoadType({none:noneChecked, load:false, unload:e.target.checked});}
                                    }
                                    onKeyDown={(e)=>{if(e.key === "Enter"){
                                      let noneChecked = false;
                                      if(e.target.checked){noneChecked = true;}
                                      else{setStopWaitTimeInput(0);}
                                      setStopLoadType({none:noneChecked, load:false, unload:!(e.target.checked)});
                                    }}}
                                  />
                                </span>
                              </Col>
                              {stopLoadType.load || stopLoadType.unload ? 
                                <Col className="d-flex justify-content-end small text-end my-auto">
                                  <span className="d-inline-flex small my-auto text-nowrap">
                                    <Icon icon="bx:group" className="my-auto text-secondary" style={{width:"25px", height:"25px"}}/>
                                    <label className='m-0 my-auto user-select-none' title={"Ambulatory Passenger Count"}>Pax</label>
                                    <input type={"number"} maxLength={2} value={passengerTypeCountStop.ambPass} style={{minWidth:"25px", maxHeight:"28px", height:"28px"}} 
                                      name="ambPass" onChange={handlePassCountTotalStop} autoComplete="new_pass"
                                      className='text-nowrap border-1 m-1 w-25 text-center callcenterInputNumbers callAgentInputStyle no-counter'
                                    />
                                  </span>
                                  <span className="d-inline-flex small my-auto text-nowrap">
                                    <Icon icon="bx:handicap" className="my-auto text-primary" style={{width:"25px", height:"25px"}}/>
                                    <label className='m-0 my-auto user-select-none' title={"WheelChair Passenger Count"}>WC</label>
                                    <input type={"number"} maxLength={2} value={passengerTypeCountStop.totalWC} style={{minWidth:"25px", maxHeight:"28px", height:"28px"}} 
                                      name="totalWC" onChange={handlePassCountTotalStop} autoComplete="new_pass"
                                      className='text-nowrap border-1 m-1 w-25 text-center callcenterInputNumbers callAgentInputStyle no-counter'
                                    />
                                  </span>
                                  <span className="d-inline-flex small my-auto text-nowrap">
                                    <Icon icon="material-symbols:pets" className="my-auto" style={{width:"25px", height:"25px", color: "#c3a386"}}/>
                                    <label className='m-0 my-auto user-select-none' title={"Service Animal Count"}>SA</label>
                                    <input type={"number"} maxLength={2} value={passengerTypeCountStop.totalSA} style={{minWidth:"25px", maxHeight:"28px", height:"28px"}} 
                                      name="totalSA" onChange={handlePassCountTotalStop} autoComplete="new_pass"
                                      className='text-nowrap border-1 m-1 w-25 text-center callcenterInputNumbers callAgentInputStyle no-counter'
                                    />
                                  </span>
                                </Col>
                              :""}
                            </Row>
                            <Row className="m-0 mt-1 mx-1">
                              <Col className="text-start">
                                <textarea
                                  name="ctl00$ctl00$ContentPlaceHolder1$ContentPlaceHolder1$txtAgentInstructionNotes"
                                  rows={2}
                                  cols={20}
                                  placeholder="Stop extra info..." autoComplete="new_pass"
                                  id="ctl00_ctl00_ContentPlaceHolder1_ContentPlaceHolder1_txtAgentInstructionNotes"
                                  style={{resize:"none"}} value={stopAddrExtra} onChange={(e)=>setStopAddrExtra(e.target.value)}
                                  className="tripDetails-label-dataFields d-inline-flex w-100 callAgentInputStyle"
                                />           
                              </Col>
                              <Col className="d-flex justify-content-end text-end my-auto">
                                <Button tabIndex={0} variant="success" className="p-0 p-1 mx-1 rounded" style={{ borderRadius: "0px"}} 
                                  title={"Finish adding the stops"} onClick={handleFinishAddingStops}
                                >
                                  {stopSaveBtnTitle}
                                </Button>
                                <Button tabIndex={0} variant="secondary" className="p-0 p-1 rounded" style={{ borderRadius: "0px"}} 
                                  title={"Close stop view"} onClick={handleCloseStops}
                                >
                                  {"Discard"}
                                </Button>
                              </Col>
                            </Row>
                          </>
                          
                        :""}
                      </Col> 
                    : ""}
                  </Row>
                :""}
                <Row className="">
                  <Col xs={2}>
                    <span className="d-block small mt-2 text-nowrap" 
                      title={((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2) ? "Drop Off" : "Drop Off or Virtual Stop")}
                    >
                      <Icon icon="bx:map" className="m-1 text-danger" style={{width:"15px", height:"15px"}}/>
                      <label className='m-0 user-select-none callAgentLabelsResponsive'>
                        {(transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2) ?"DO":"DO/VS"}
                      </label>
                    </span>
                    <span className="d-block small mt-1 text-nowrap" title={"Drop Off Route Coverage Zone"}>
                      <Icon icon="bx:map-alt" className="m-1 text-info" style={{width:"15px", height:"15px"}}/>
                      <label className='m-0 my-1 user-select-none callAgentLabelsResponsive'>Zone</label>
                    </span>
                  </Col>
                  <Col xs={10} className="p-0">
                    <Row className="my-1">
                      <Col xs={(transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2) ? 6:12} className="">
                        <span className="position-relative">
                          <input type={"search"} placeholder="Drop Off Address..." value={dropAddr}
                            title={dropAddr + " (Search POI by typing #POI Name)"} style={{textOverflow:"ellipsis", maxHeight:"30px", height:"30px"}} 
                            onChange={handleDOAddrChanged} autoComplete="new_pass" className='text-nowrap p-0 pe-3 px-1 w-100 callAgentInputStyle' onFocus={handleDOAddrChanged} 
                            onBlur={()=>{setTimeout(() => {
                              if(!focusedSuggestionCheckDO.current)
                              {
                                setInputSuggestionListDO("");
                              }
                            }, 300);}} 
                            onKeyDown={(e)=>{
                              if(e.key === 'ArrowDown')
                              {
                                e.preventDefault();
                                setHightlightedIndexDO(-1);
                                if(liRefsDO.current.length > 0)
                                {
                                  if(liRefsDO.current[0]?.current) //check for empty references
                                  {
                                    setHightlightedIndexDO((prevIndex) => {
                                      const newIndex = (prevIndex + 1) % liRefsDO.current.length;
                                      liRefsDO.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                                      return newIndex;
                                    });
                                  }
                                }
                              }
                              else if (e.key === 'ArrowUp') {
                                e.preventDefault();
                                setHightlightedIndexDO(-1);
                                if(liRefsDO.current.length > 0)
                                {
                                  if(liRefsDO.current[0]?.current)
                                  {
                                    setHightlightedIndexDO((prevIndex) => {
                                      const newIndex = (prevIndex - 1 + liRefsDO.current.length) % liRefsDO.current.length;
                                      liRefsDO.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                                      return newIndex;
                                    });
                                  }
                                }
                              }
                            }}
                          />
                          {renderAddressApartmentInfoPopup('drop')}
                          {renderAddressPhoneInfoPopup('drop')}
                        </span>
                        {inputSuggestionListDO && inputSuggestionListDO !== "" ?
                          <ul tabIndex={0} className="user-select-none border position-absolute px-1" 
                            style={{width:"auto", maxWidth:"400px", height:"80px", overflowY:"auto", zIndex:1000, backgroundColor:"#e6eef1"}} 
                          >
                            {inputSuggestionListDO}
                          </ul>
                        :""}
                      </Col>
                      {(transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2) ? 
                        <Col xs={6} className="d-flex my-auto">
                          <select className='text-left w-100 overflow-hidden callAgentInputStyle' value={dropAddrVirtualStop.value} name={dropAddrVirtualStop.name} 
                            onChange={handleVSChange} title={"Drop Off Virtual Stop: "+dropAddrVirtualStop.name} disabled={isVSSelectionDisabled} ref={DOVSDropdownRef}
                            style={{minWidth:"58px", maxHeight:"25px", height:"25px", textOverflow:"ellipsis"}}
                          >
                            <option value={"DO VS"}>Select Virtual Stop</option>
                            {virtualStopDropDownHTML}
                          </select>
                          {walkDistance.DOWalk !== 0?<p className="m-0 d-inline-flex user-select-none text-nowrap">{"("+walkDistance.DOWalk+"mi, "+walkDistance.DODuration+"min)"}</p>: ""}
                        </Col>
                      : ""}
                    </Row>
                    <Row className="mt-1">
                      <Col>
                        <p type={"text"} style={{textOverflow:"ellipsis", maxWidth:"260px"}} 
                          title={((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2) ?
                            (zones!==""?zones:"Unknown Zone") : (dropPOI !== ""?("POI: " + dropPOI) : dispatchZones.dropZone))} 
                          className="overflow-hidden user-select-none text-nowrap m-0 w-100 fw-bold small">
                          {(transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2) ? 
                            (zones !== "" ? zones:""):(dropPOI !== ""?`${dispatchZones.dropZone}${'\u00A0'.repeat(4)}${dropPOI}` : dispatchZones.dropZone)
                          }
                        </p>
                        
                      </Col>
                      <Col className="d-inline-flex justify-content-start">
                        <p className='m-0 mx-1 user-select-none small'>Notes</p>
                        <textarea
                          name="ctl00$ctl00$ContentPlaceHolder1$ContentPlaceHolder1$txtAgentInstructionNotes"
                          rows={2}
                          cols={20}
                          placeholder="Drop off extra info..." autoComplete="new_pass" onFocus={(e)=>{setInputSuggestionListDO("")}}
                          id="ctl00_ctl00_ContentPlaceHolder1_ContentPlaceHolder1_txtAgentInstructionNotes"
                          style={{resize:"none", minWidth:"84px"}} value={dropExtraInfo} onChange={(e)=>setDropExtraInfo(e.target.value)}
                          className="tripDetails-label-dataFields d-inline-flex w-100 callAgentInputStyle"
                        />                   
                      </Col>
                    </Row>
                  </Col>
                </Row> {/* Equipment & total passengers row*/}
                { (transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2) ?
                  <Row className="m-0">
                    <Col xs={2}>

                    </Col>
                    <Col xs={8} className="d-inline-flex">
                      <span className="d-inline-flex small my-1 text-nowrap">
                        <Icon icon="bx:group" className="my-2 text-secondary" style={{width:"25px", height:"25px"}}/>
                        <label className='m-0 my-2 user-select-none callAgentLabelsResponsive' title={"Ambulatory Passenger Count"}>Pass.</label>
                        <input type={"number"} maxLength={2} value={passengerTypeCount.ambPass} style={{minWidth:"25px", maxHeight:"30px", height:"30px"}} 
                          name="ambPass" onChange={handlePassCountTotal} autoComplete="new_pass"
                          className='text-nowrap border-1 p-1 m-1 w-25 text-center callcenterInputNumbers callAgentInputStyle no-counter'
                        />
                      </span>
                      <span className="d-inline-flex small my-1 text-nowrap">
                        <Icon icon="bx:handicap" className="my-2 text-primary" style={{width:"25px", height:"25px"}}/>
                        <label className='m-0 my-2 user-select-none callAgentLabelsResponsive' title={"WheelChair Passenger Count"}>WC</label>
                        <input type={"number"} maxLength={2} value={passengerTypeCount.totalWC} 
                          style={{minWidth:"25px", maxHeight:"30px", height:"30px"}} name="totalWC" onChange={handlePassCountTotal} autoComplete="new_pass"
                          className='text-nowrap border-1 p-1 m-1 w-25 text-center callcenterInputNumbers callAgentInputStyle no-counter'
                        />
                      </span>
                      <span className="d-inline-flex small my-1 text-nowrap">
                        <Icon icon="material-symbols:pets" className="my-auto" style={{width:"25px", height:"25px", color: "#c3a386"}}/>
                        <label className='m-0 my-2 user-select-none callAgentLabelsResponsive' title={"Service Animal Count"}>SA</label>
                        <input type={"number"} maxLength={2} value={passengerTypeCount.totalSA} style={{minWidth:"25px", maxHeight:"30px", height:"30px"}} name="totalSA" onChange={handlePassCountTotal} 
                          className='text-nowrap border-1 p-1 m-1 w-25 text-center callcenterInputNumbers callAgentInputStyle no-counter' autoComplete="new_pass"
                        />
                      </span>
                      <span className="d-inline-flex small my-1 text-nowrap">
                        <label className='m-0 my-2 user-select-none' title={"Total Passengers Count"}>Total</label>
                        <input type={"text"} value={passengerTypeCount.total} style={{minWidth:"25px", maxHeight:"30px", height:"30px"}} name="total"  autoComplete="new_pass"
                          disabled  className='text-nowrap border-1 p-1 m-1 w-25 text-center callAgentInputStyle' title={"Total Passengers Count: "+passengerTypeCount.total}
                        />
                      </span>
                    </Col>
                  </Row> 
                :""}
                {(transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2) ?
                  <>
                    <Row className={""}>
                      <Col xs={2} className="text-start">
                        <span className="d-block small mt-1 text-nowrap overflow-hidden" title={"Schedule Date"}>
                          <Icon icon="bx:calendar" className="mb-1 mx-1" style={{width:"15px", height:"15px"}}/>
                          <label className='m-0 user-select-none callAgentLabelsResponsive'>Date</label>
                        </span>
                        <span className="d-block small mt-2 text-nowrap overflow-hidden" title={"Appointment Time"}>
                          <Icon icon="bx:time" className="mb-1 mx-1" style={{width:"15px", height:"15px"}}/>
                          <label className='m-0 user-select-none callAgentLabelsResponsive'>Appt</label>
                        </span>
                      </Col>
                      <Col xs={10} className=" p-0">
                        <Row className="m-0">
                          <Col xs={6} className="" style={{padding:0, paddingLeft:"0.25rem", paddingRight:"0.8rem"}}>
                            <input type="date" name="dateGiven" autoComplete="new_pass" value={selectedDateSchTime} 
                              onChange={(e)=>{setSelectedDateSchTime(e.target.value); setIsTimeValidated(false);}} 
                              className={`m-0 px-1 w-100 text-center callAgentInputStyle` }
                              style={{minWidth:"120px", maxHeight:"30px", height:"30px"}} 
                              min={systemDateTimeRef.current.date}
                            />
                            <input type="time" ref={apptTimeRef} autoComplete="new_pass" disabled={(willCall)} value={appointmentTime} 
                              onChange={(e)=>{setAppointmentTime(e.target.value);}} onBlur={(e)=>{handleApptTimeCheck(e);}}
                              className={`m-0 px-1 w-100 mt-1 text-center callAgentInputStyle`} style={{minWidth:"120px", maxHeight:"30px", height:"30px"}}
                            />
                          </Col>
                          <Col xs={6} className="p-0 ps-3">
                            {screenWidthSize >= 880 ? 
                              <>
                                {renderMultiScheduleComponent()}
                                {renderSchTimeComponent()}
                              </> 
                            :""}
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    {screenWidthSize < 880 ? 
                      <Row className={""}>
                        <Col xs={2} className="text-start">
                          <span className="d-block small mt-1 text-nowrap overflow-hidden" title={"Reservation Time"}>
                            <Icon icon="flat-color-icons:overtime" className="mb-1 mx-1" style={{width:"15px", height:"15px"}}/>
                            <label className='m-0 user-select-none callAgentLabelsResponsive'>{"Time"}</label>
                          </span>
                          
                        </Col>
                        <Col xs={10} className="p-0">
                          <Row className="m-0">
                            <Col xs={6} className="" style={{padding:0, paddingLeft:"0.25rem", paddingRight:"0.8rem"}}>
                              {renderSchTimeComponent()}
                            </Col>
                            <Col xs={6} className="p-0 my-auto ps-3">
                              {renderMultiScheduleComponent()}
                            </Col>
                          </Row>
                          
                        </Col>
                      </Row>
                    :""}
                  </>
                :
                  <Row className="mt-1">
                    <Col xs={2}>
                      <span className="d-block mt-1 small text-nowrap" title={"Callback phone number"}>
                        <Icon icon="bx:phone" className="m-1" style={{width:"15px", height:"15px"}}/>
                        <label className='m-0 user-select-none callAgentLabelsResponsive'>Callback</label>
                      </span>
                    </Col>
                    <Col xs={10} className="p-0">
                      {renderCallbackPhone()}
                    </Col>
                  </Row> 
                }
                <Row className="mb-1"> {/*Remaining payment, callback, and Rider ID row */}
                  <Col xs={2}>
                    <span className="d-block small mt-2 text-nowrap" title={"Funding Source"}>
                      <Icon icon="bx:money" className="m-1 text-success" style={{width:"15px", height:"15px"}}/>
                      <label className='m-0 user-select-none callAgentLabelsResponsive'>FS</label>
                    </span>
                    <span className="d-block small mt-2 text-nowrap" title={"Payment Type Selection"}>
                      <Icon icon="bx:credit-card" className="m-1 text-warning" style={{width:"15px", height:"15px"}}/>
                      <label className='m-0 user-select-none callAgentLabelsResponsive'>Pay</label>
                    </span>
                  </Col>
                  <Col xs={10} className="p-0">
                    <Row className="m-0">
                      <Col className="p-0 px-1">
                        
                        <Row className="m-0">
                          <Col className="p-0">
                            <select className='text-center mt-1 p-1 d-inline-flex w-100 callAgentInputStyle' value={FSSelected} 
                              onChange={(e)=>{handleFSSelectionChange(e, "fs");}} style={{minWidth:"120px", maxHeight:"30px", height:"30px"}}
                            >
                                <option value="-1"></option>
                              {FSDropdown && FSDropdown.length > 0 ? FSDropdown:""}
                            </select>
                          </Col>
                          {(transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2 && showCCBtn && 
                            ((clientInfo && !Array.isArray(clientInfo)) || (accountNumber !== ''))) ? 
                            <span className="d-flex text-start px-0 mt-1 my-auto">
                              {renderPayDropdown('micro')}
                              <Button className={`my-auto ms-1 p-0 ${cardType === "" ? 'border-2 border-danger raised-button': 'border-0 raised-button'} rounded ${cardInfo.selectedCard !== '' ? 'callAgentBtnIconVerifiedStyle' : 'callAgentBtnIconStyle'}`} 
                                style={{height:"30px", maxHeight:"30px", width:"45px", maxWidth:"45px", backgroundColor:"#e6eef1"}} 
                                title={(cardType !== "" ? ("(" + cardNumber.trim() + " " + cardType.trim() + ') Change CC selected') : 'Add CC')} onClick={(e)=>{setShowCCInfoDialog(true);}}
                              >
                                <Icon icon={(cardInfo.selectedCard !== '' ? "mdi:credit-card-check-outline" : "mdi:credit-card-search-outline")} 
                                  style={{width:"25px", height:"25px"}}
                                />
                              </Button>
                            </span>
                            :
                            renderPayDropdown()
                          }
                        </Row>
                      </Col>
                      <Col className="d-inline-flex justify-content-start ms-4 p-0">
                        <p className='m-0 mx-1 user-select-none small' style={{maxWidth:"40px"}} title={"Agent Notes"}>{"Agent Notes"}</p>
                          <textarea
                            name="ctl00$ctl00$ContentPlaceHolder1$ContentPlaceHolder1$txtAgentInstructionNotes"
                            rows={2}
                            cols={20}
                            ref={agentNotesBtnRef}
                            placeholder={(screenWidthSize >= 650 ? "Agent Comments..." : "Comments...")}
                            id="ctl00_ctl00_ContentPlaceHolder1_ContentPlaceHolder1_txtAgentInstructionNotes"
                            style={{resize:"none", minWidth:"84px"}}
                            value={agentNotes} autoComplete="new_pass"
                            onChange={(e)=>setAgentNotes(e.target.value)}
                            className={`tripDetails-label-dataFields w-100 d-inline-flex mt-1 ${screenWidthSize >= 650 ? "" : "me-1"} px-1 callAgentInputStyle`}
                            onKeyDown={(e)=>
                            { 
                              try{
                                if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2))
                                {
                                  if(e.key === "Tab" && !e.shiftKey)
                                  {
                                    e.preventDefault();
                                    if(!bookBtnRef.current.disabled)
                                    {
                                      bookBtnRef.current.focus();
                                    }
                                    else
                                    {
                                      resetBtnRef.current.focus();
                                    }
                                  }
                                }
                              }
                              catch(err){console.log(err);}
                            }
                            }
                          />
                        
                      </Col>
                    </Row>
                  </Col>
                </Row>
                {(transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2) ?
                  <Row className="mb-1">
                    <Col className="" xs={7}>

                    </Col>
                    <Col className={`${screenWidthSize < 650 ? "pe-0" : ""}`} xs={5}>
                      <span className="d-block my-auto text-nowrap">
                        {screenWidthSize >= 650 ? 
                          <p className='m-0 mx-1 user-select-none my-auto d-inline-flex text-start' style={{minWidth:"40px"}} title={"Add Leg/Return"}>{"Leg(s)"}</p>
                        :""}
                        <Button variant="dark" className={`${screenWidthSize < 650 ? 'w-100 justify-content-end':''}, p-0 p-1`} style={{maxHeight:"34px"}} ref={addLegBtnRef} onClick={(e)=>{
                          
                          let isMultiSch = checkIsMultiScheEntered();
                          if(isMultiSch){
                            addLegBtnRef.current.disabled = true;
                          }

                          const isSameTime = verifiedAddr.some(
                            (leg)=> leg.time === schTime && leg.date === selectedDateSchTime && leg.time !== ""
                          );
                          let schTimeCheck = IsAppointmentTimeValid();

                          if(!timeValidateCheck.current)
                          {
                            validateMinScheduleTimeDifference(null, false, false, 'leg');
                          }
                          else if(!schTimeCheck)
                          {
                            setModalHeaderText("Stop Order Alert");
                            setModalBodyHTML("Selected pickup time is violating appointment time, please select PU Time earlier than ["+apptTimeCheckValsRef.current.TimeWindow+"].");
                            setModalFooterHTML(
                              <>
                              <Button variant='dark' className="border-0" onClick={()=>{setShowDynamicModal(false);}}>
                                OK
                              </Button>
                              </>
                            );
                            setShowDynamicModal(true);
                          }
                          else if(scheduleJSON.mainData !== "" && scheduleJSON.mainData.Schedule.ScheduleItem.length > 0)
                          {
                            setModalHeaderText("Stop Order Alert");
                            setModalBodyHTML("Multischedule is applied, please clear multischedule if you want to book multileg trips.");
                            setModalFooterHTML(
                              <>
                              <Button variant='dark' className="border-0" onClick={()=>{setShowDynamicModal(false);}}>
                                OK
                              </Button>
                              </>
                            );
                            setShowDynamicModal(true);
                          }
                          else if(isSameTime && addLegBtnTitle.toLowerCase().includes("leg"))
                          {
                            setModalHeaderText("Stop Order Alert");
                            setModalBodyHTML("Are you sure, you want to enter the time that is equal to last leg time? (" +schTime+")");
                            setModalFooterHTML(
                              <>
                              <Button variant='dark' className="border-0" onClick={()=>{setShowDynamicModal(false); timeValidateCheck.current = false; handleAddLeg(addLegBtnTitle);}}>
                                Yes
                              </Button>
                              <Button variant='secondary' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                                No
                              </Button>
                              </>
                            );
                            setShowDynamicModal(true);
                          
                          }
                          else
                          {
                            timeValidateCheck.current = false;
                            handleAddLeg(addLegBtnTitle);
                          }
                          
                          }} title={"Add trip to stop order"}>
                          {showAddLegLoader ? <span role='status' aria-hidden='true' className='spinner-border spinner-border-sm'></span> : addLegBtnTitle}
                        </Button>
                        <Button variant="dark" className="p-0 ms-1 p-1 d-none" style={{minWidth:"92px", maxHeight:"34px"}} disabled={(addLegBtnTitle.toLowerCase()==="update")} 
                          onClick={()=>{handleAddLeg(addLegBtnTitle);}} title={"Add a return trip to stop order"}>
                          {"Add Return"}
                        </Button>
                      </span>
                      
                    </Col>
                  </Row> 
                : ""}
              </Row>
            </Col>
          </Row>
          {(transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2) ?
          <>
            <Row>
              <Col className="text-start border-top" onClick={(e)=>{setAdditionalDetailsDisplay(!additionalDetailsDisplay);}} style={{backgroundColor:"#07447b"}}>
                <span className="d-inline-flex w-75" title={"Additional Details & Communication Methods"}>
                  <Icon icon="bx:chat" className="mt-1 text-white" style={{minWidth:"25px", minHeight:"25px", width:"25px", height:"25px"}}/>
                  <label className='m-0 m-1 user-select-none fw-bold text-white text-nowrap overflow-hidden' style={{textOverflow:"ellipsis"}}>Additional Details & Comm. Methods</label>
                </span>
                <span className="d-inline-flex mt-1 float-end"
                  onClick={(e)=>{setAdditionalDetailsDisplay(!additionalDetailsDisplay);}} tabIndex={0}
                  onKeyDown={(e)=>{if(e.key === "Enter"){setAdditionalDetailsDisplay(!additionalDetailsDisplay);}}}>
                  {additionalDetailsDisplay? <Icon icon="bx:chevron-down" className="text-white" style={{width:"25px", height:"25px", cursor:"pointer"}}/>:
                    <Icon icon="bx:chevron-up" className="text-white" style={{width:"25px", height:"25px", cursor:"pointer"}}/>
                  }
                </span>
              </Col>
            </Row>
            <Row className={`${additionalDetailsDisplay? '':'d-none'} m-0 mt-1 overflow-auto callAgentSummaryScroller`}>
              <Col className="text-start p-0">
                <Row className="m-0">
                  <Col className="p-0 rounded border border-dark overflow-auto callAgentSummaryScroller">
                    <Row className="m-0 px-1 mt-2">
                      <Col className="small" xs={(screenWidthSize >= 820 ? 6: 12)}>
                        <span className="d-flex small my-auto text-nowrap" title={"Client email address"}>
                          <Icon icon="bx:mail-send" className="my-auto mx-1 text-secondary" style={{minWidth:"15px", minHeight:"15px", width:"15px", height:"15px"}}/>
                          <label className='m-0 my-auto user-select-none callAgentLabelsResponsive'>Email</label>
                          <input type="text" value={clientEmail} onChange={(e)=>{setClientEmail(e.target.value);}}
                            className="m-0 ms-2 px-1 w-100 text-start callAgentInputStyle" style={{minWidth:"120px", maxHeight:"30px", height:"30px"}} autoComplete="new_pass"
                          /> 
                        </span>
                      </Col>
                      <Col className={`${(screenWidthSize >= 820 ? '':'d-none')} small`} xs={6}>
                        {screenWidthSize >= 820 ? 
                          <>
                            {renderCallbackPhone()}
                          </>
                        :""}
                      </Col>
                    </Row>
                    {screenWidthSize < 820 ?
                      <Row className="m-0 px-1 mt-1">
                        <Col className="small w-100" xs={12}>
                          {renderCallbackPhone()}
                        </Col>
                      </Row>
                    :""}
                    <Row className="m-0 px-1">
                      <Col className="mb-1">
                        <span className="d-inline-flex" style={{borderRadius:"4px", minWidth:"80px", maxHeight:"28px"}}>
                          <input type="checkbox" className="mx-1" style={{cursor:"pointer"}} checked={RCType.phoneType} onChange={(e)=>{setRCType({...RCType, phoneType:e.target.checked});}}/>
                          <p className="m-0 small d-inline-block user-select-none text-nowrap">{"Call"}</p>
                        </span>
                        <span className="d-inline-flex" style={{borderRadius:"4px", minWidth:"80px", maxHeight:"28px"}}>
                          <input type="checkbox" className="mx-1" style={{cursor:"pointer"}} checked={RCType.emailType} onChange={(e)=>{setRCType({...RCType, emailType:e.target.checked});}}/>
                          <p className="m-0 small d-inline-block user-select-none text-nowrap">{"Email"}</p>
                        </span>
                        <span className="d-inline-flex" style={{borderRadius:"4px", minWidth:"80px", maxHeight:"28px"}}>
                          <input type="checkbox" className="mx-1" style={{cursor:"pointer"}} 
                            checked={RCType.SMSType} onChange={(e)=>{setRCType({...RCType, SMSType:e.target.checked});}}
                          />
                          <p className="m-0 small d-inline-block user-select-none text-nowrap">{"SMS"}</p>
                        </span>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row className="m-0 my-1">
                  <Col className="p-0 rounded border border-dark overflow-auto callAgentSummaryScroller">
                    <Row className="m-0 px-1 mt-2">
                      <Col className="small">
                        <table className="w-100 mb-2 callAgentInputStyle">
                          <thead className="" style={{borderTop:"5px"}}>
                            <tr className="text-center text-nowrap text-white">
                              <th className="p-1 border-right border-secondary user-select-none" style={{backgroundColor:"#35738a", fontWeight:"500", borderTopLeftRadius:"5px", borderRight:"1px solid #ccc"}}>{"Trip Priority"}</th>
                              <th className="p-1 border-right border-secondary user-select-none" style={{backgroundColor:"#35738a", fontWeight:"500",borderRight:"1px solid #ccc"}}>{"Job"}</th>
                              <th className="p-1 border-right border-secondary user-select-none" style={{backgroundColor:"#35738a", fontWeight:"500", borderTopRightRadius:"5px"}}>{"Trip Type"}</th>
                            </tr>
                          </thead>
                          <tbody className="">
                            <tr className="text-center">
                              <td className="text-nowrap small overflow-hidden p-1" style={{borderRight:"1px solid #ccc"}}>
                                <select className='text-center d-inline-block p-1 w-100 callAgentInputStyle' style={{minWidth:"120px", height:"30px", maxHeight:"30px"}}
                                  value={selectedTripPriority} onChange={(e)=>{setSelectedTripPriority(e.target.value);}} disabled
                                > 
                                  <option value={1}>{"P1"}</option>
                                  <option value={2}>{"P2"}</option>
                                  <option value={3}>{"P3"}</option>
                                  <option value={4}>{"P4"}</option>
                                  <option value={5}>{"P5"}</option>
                                </select>
                              </td>
                              <td className="text-nowrap small overflow-hidden px-1" style={{borderRight:"1px solid #ccc"}}>
                                <input type="text" className="w-100 callAgentInputStyle text-center" autoComplete="new_pass" style={{minWidth:"100px", border:"1px solid black", height:"30px", maxHeight:"30px"}} 
                                  value={clientJob} onChange={(e)=>{setClientJob(e.target.value);}}
                                />
                              </td>
                              <td className="text-nowrap small overflow-hidden p-1" style={{}}>
                                <select className='text-center d-inline-block p-1 w-100 callAgentInputStyle' style={{minWidth:"120px", height:"30px", maxHeight:"30px", border:"1px solid black"}}
                                  value={selectedTripType} onChange={(e)=>{setSelectedTripType(e.target.value);}}
                                >
                                  {tripTypeOptionsHTML}
                                </select>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <textarea
                          name="ctl00$ctl00$ContentPlaceHolder1$ContentPlaceHolder1$txtAgentInstructionNotes"
                          rows={2}
                          cols={20}
                          placeholder="Additional Information..."
                          id="ctl00_ctl00_ContentPlaceHolder1_ContentPlaceHolder1_txtAgentInstructionNotes"
                          style={{resize:"none"}} autoComplete="new_pass"
                          value={paymentAdditionalInfo} onChange={(e)=>setPaymentAdditionalInfo(e.target.value)}
                          className="tripDetails-label-dataFields px-1 d-inline-flex w-100 callAgentInputStyle small"
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              <Col className="text-start border-top" onClick={(e)=>{setPaymentDetailsDisplay(!paymentDetailsDisplay);}} style={{backgroundColor:"#07447b"}}>
                <span className="d-inline-flex w-75 my-auto" title={"Payment Details"}>
                  <Icon icon="bx:credit-card" className="mt-1 text-white" style={{minWidth:"25px", minHeight:"25px", width:"25px", height:"25px"}}/>
                  <label className='m-0 m-1 user-select-none fw-bold text-white text-nowrap overflow-hidden' style={{textOverflow:"ellipsis"}}>Payment Details</label>
                </span>
                <span className="d-inline-flex mt-1 float-end"
                  onClick={(e)=>{setPaymentDetailsDisplay(!paymentDetailsDisplay);}} tabIndex={0}
                  onKeyDown={(e)=>{if(e.key === "Enter"){setPaymentDetailsDisplay(!paymentDetailsDisplay);}}}>
                  {paymentDetailsDisplay? <Icon icon="bx:chevron-down" className="text-white" style={{width:"25px", height:"25px", cursor:"pointer"}}/>:
                    <Icon icon="bx:chevron-up" className="text-white" style={{width:"25px", height:"25px", cursor:"pointer"}}/>
                  }
                </span>
              </Col>
            </Row>
            <Row className={`${paymentDetailsDisplay? '':'d-none'} m-0 mt-1 overflow-auto callAgentSummaryScroller`}>
              <Col className="text-start p-0">
                <Row className="m-0 my-1">
                  <Col className="p-0 rounded border border-dark overflow-auto callAgentSummaryScroller">
                    <span className="d-block small fw-bold mt-1 text-nowrap overflow-hidden">
                      <Icon icon="bx:receipt" className="mb-1 mx-1 text-warning" style={{width:"15px", height:"15px"}}/>
                      <label className='m-0 user-select-none'>Copay Info</label>
                    </span>
                    <Row className="m-0 px-1">
                      <Col className="d-flex small">
                        <select className='text-center d-inline-block p-1 w-100 callAgentInputStyle' style={{minWidth:"120px", maxHeight:"30px"}}
                          value={copayFSSelected} onChange={(e)=>{handleFSSelectionChange(e, "copay");}} title={"Copay FS"}
                        >
                          {/* <option disabled hidden value={"CFS"}>{"Copay FS"}</option> */}
                          {CopayFSDropdown && CopayFSDropdown.length > 0 ? CopayFSDropdown:""}
                        </select>
                        <select className='text-center p-1 ms-1 w-100 callAgentInputStyle' style={{minWidth:"120px", maxHeight:"30px"}}
                          value={copayPayTypeSelected} 
                          onChange={(e)=>{setCopayPayTypeSelected(e.target.value); 
                            const selectedIndex = e.target.selectedIndex;
                            const selectedOption = e.target.options[selectedIndex];
                            if(selectedOption.textContent.toLowerCase().includes("card") && parseInt(e.target.value) === 2){setShowCCBtn(true);}else{ if(parseInt(PaySelected) !== 2){setShowCCBtn(false);}}
                          }} title={"Copay Pay Type"}
                        >
                          <option disabled hidden value={"CPT"}>{"Copay Pay Type"}</option>
                          {PayDropdown && PayDropdown.length > 0 ? PayDropdown:""}
                        </select>
                        
                      </Col>
                    </Row>
                    <Row className="m-0 pe-3">
                      <Col className="d-flex small text-start" xs={6}>
                        <span className="d-inline-block small my-auto text-nowrap overflow-hidden" title={"Copay Amount"}>
                          <Icon icon="bx:dollar" className="mb-1 mx-1 text-success" style={{minWidth:"15px", minHeight:"15px", width:"15px", height:"15px"}}/>
                          <label className='m-0 user-select-none callAgentLabelsResponsive'>Copay/Promo</label>
                        </span>
                        <input type="number" value={copayAmount} 
                          onChange={handleCopayAmountChange} maxLength={7}
                          className="m-0 ms-2 m-1 px-1 w-100 text-center callAgentInputStyle no-counter callcenterInputNumbers" style={{minWidth:"60px", maxWidth:"100px"}} autoComplete="new_pass" 
                          title={"$"+copayAmount}
                        />  
                      </Col>
                      <Col className="d-flex small text-start p-0 ps-2" xs={6}>
                        {showCCBtn ?
                          <>
                            <span className="d-flex small my-auto text-nowrap overflow-hidden" title={"Card Info"}>
                              <Icon icon="bx:credit-card-front" className="my-auto mx-1" style={{minWidth:"15px", minHeight:"15px", width:"15px", height:"15px"}}/>
                              <label className='m-0 user-select-none callAgentLabelsResponsive'>Card Info:</label>
                              <p type={"text"} style={{textOverflow:"ellipsis"}} 
                                title={(cardType !== "" ? cardNumber + " " + cardType:"NONE")} 
                                className="overflow-hidden user-select-none text-nowrap m-0 ms-2 my-auto w-100 fw-normal"
                              >
                                {(cardType !== "" ? cardNumber + " " + cardType:"NONE")}
                              </p>
                            </span>
                          
                            <Button variant="dark"
                              className="ms-1 p-0 px-1 rounded small my-auto fw-normal text-nowrap" onClick={(e)=>{
                                if((clientInfo && !Array.isArray(clientInfo)) || (searchButtonValidationRef.current === 'none' && accountNumber !== '')){
                                  setShowCCInfoDialog(true);
                                }
                                else
                                {
                                  setModalHeaderText("Card Info Alert");
                                  setModalBodyHTML("Customer profile must exist before adding cards in profile.");
                                  setModalFooterHTML(
                                    <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                                      OK
                                    </Button>
                                  );
                                  setShowDynamicModal(true);
                                }
                              }}  
                              style={{borderRadius:"0px", height:"25px", maxHeight:"25px"}}
                            >
                              {"CC Info"}
                            </Button>
                          </> 
                        :""}
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className="">
              <Col className={`${driverVehInfoDisplay? "" : "headerRoundedCornerStyle"} text-start border-top`} 
                onClick={(e)=>{setDriverVehInfoDisplay(!driverVehInfoDisplay);}} style={{backgroundColor:"#07447b"}}
              >
                <span className="d-inline-flex w-75 my-auto" title={"Mobility Information"}>
                  <Icon icon="bx:taxi" className="mt-1 text-white" style={{minWidth:"25px", minHeight:"25px", width:"25px", height:"25px"}}/>
                  <label className='m-0 m-1 user-select-none fw-bold text-white text-nowrap overflow-hidden' style={{textOverflow:"ellipsis"}}>Mobility Information</label>
                </span>
                <span className="d-inline-flex mt-1 float-end" tabIndex={0} ref={mobilityInfoDisplayRef}
                  onClick={(e)=>{setDriverVehInfoDisplay(!driverVehInfoDisplay);}} onKeyDown={(e)=>{
                    if(e.key === "Enter"){setDriverVehInfoDisplay(!driverVehInfoDisplay);}
                    else if(e.key === "Tab" && !e.shiftKey && !driverVehInfoDisplay && !insuranceInfoDisplayRef.current){
                      e.preventDefault();
                      if(paratransitBookBtnRef.current.disabled)
                      {
                        resetBtnRef.current.focus();
                      }
                      else
                      {
                        paratransitBookBtnRef.current.focus();
                      }
                    }
                  }}>
                  {driverVehInfoDisplay? <Icon icon="bx:chevron-down" className="text-white" style={{width:"25px", height:"25px", cursor:"pointer"}}/>:
                    <Icon icon="bx:chevron-up" className="text-white" style={{width:"25px", height:"25px", cursor:"pointer"}}/>
                  }
                </span>
              </Col>
            </Row>
            <Row className={`${driverVehInfoDisplay? '':'d-none'} mt-1 overflow-auto callAgentSummaryScroller`}>
              <Row className="m-0 mb-1">
                <Col xs={6} className="text-start small">
                  <span className="user-select-none d-flex my-auto small" title={"Trip Attributes Selection"} style={{height:"30px", maxHeight:"30px"}}>
                    <Icon icon="bx:customize" className="my-auto" style={{width:"25px", height:"25px"}}/>
                    <MultiSelectDropdown options={AttributesFilterMultiSelect} disablePreSelectedValues={true} 
                      SelectionChangeCallback={AttributesSelectCallback} FireSelectEventOnEveryItemChange={true}
                      />
                  </span>
                  <span className="user-select-none d-flex mt-1 small" title={"Preferred Vehicle Type Selection"} style={{height:"30px", maxHeight:"30px"}}>
                    <Icon icon="tdesign:vehicle" className="my-auto" style={{width:"25px", height:"25px"}}/>
                    <select className='text-center ms-2 p-1 w-100 callAgentInputStyle' style={{minWidth:"120px", maxHeight:"30px", height:"30px"}} value={selectedVehType}
                      onChange={handleVehTypeChanged} title={(selectedVehType === "VT"? "":"Vehicle Type: "+ selectedVehType)}
                    >
                      <option value={"VT"} disabled hidden>{"Vehicle Type"}</option>
                      {vehTypeOptionsHTML}
                    </select>
                  </span>
                  <span className="user-select-none d-flex mt-1 small text-center" title={"Preferred Vehicle Number Selection"} style={{height:"30px", maxHeight:"30px"}}>
                    <Icon icon="bx:taxi" className="my-auto" style={{width:"25px", height:"25px"}}/>
                    <select className='text-center ms-2 p-1 w-100 callAgentInputStyle' style={{minWidth:"120px", maxHeight:"30px", height:"30px"}} value={selectedVehNum}
                      onChange={handleChangeOnVehNumber} title={(selectedVehNum === "VN"? "":"Vehicle #: "+ selectedVehNum.split("_")[1])}
                    >
                      <option value={"VN"} disabled hidden>{"Vehicle #"}</option>
                      {vehNumberOptionsHTML}
                    </select>
                  </span>

                  <span className="user-select-none d-flex mt-1 small text-center" title={"Preferred Driver Number Selection"} style={{height:"30px", maxHeight:"30px"}}>
                    <Icon icon="healthicons:truck-driver" className="my-auto" style={{width:"25px", height:"25px"}}/>
                    <select className='text-center ms-2 p-1 w-100 callAgentInputStyle' style={{minWidth:"120px", maxHeight:"30px", height:"30px"}} value={selectedDriverNum}
                      onChange={(e)=>{setSelectedDriverNum(e.target.value)}} title={(selectedDriverNum === "DN"? "":"Driver #: "+ selectedDriverNum.split("_")[1])}
                    >
                      <option value={"DN"} disabled hidden>{"Driver #"}</option>
                      {driverNumberOptionsHTML}
                    </select>
                  </span>
                  <span className="user-select-none d-flex mt-1 small text-center" title={"Preferred Driver Gender Selection"} style={{height:"30px", maxHeight:"30px"}}>
                    <Icon icon="bx:male-female" className="my-auto" style={{width:"25px", height:"25px"}}/>
                    <select className='text-center ms-2 p-1 w-100 callAgentInputStyle' style={{minWidth:"120px", maxHeight:"30px", height:"30px"}} value={selectedGender}
                      onChange={(e)=>{setSelectedGender(e.target.value);}}
                    >
                      <option value={"Gender"} disabled hidden>{"Gender"}</option>
                      <option value={"Gender"}>{"None"}</option>
                      <option value={"Male"}>{"Male"}</option>
                      <option value={"Female"}>{"Female"}</option>
                    </select>
                  </span>
                  <span className="user-select-none d-flex mt-1 small text-center" title={"Preferred Driver Language Selection"} style={{height:"30px", maxHeight:"30px"}}>
                    <Icon icon="bx:chat" className="my-auto" style={{width:"25px", height:"25px"}}/>
                    <select className='text-center ms-2 p-1 w-100 callAgentInputStyle' style={{minWidth:"120px", maxHeight:"30px", height:"30px"}} value={selectedLanguage}
                      onChange={(e)=>{setSelectedLanguage(e.target.value);}} ref={languageOptionsSelRef}
                    >
                      <option value={"Language"} disabled hidden>{"Language"}</option>
                      {languageOptionsHTML}
                    </select>
                  </span>
                  
                </Col>
                <Col xs={6} className="text-start small">
                  <span className="user-select-none d-flex my-auto small" style={{height:"30px", maxHeight:"30px"}}>
                  </span>
                  <span className="user-select-none d-flex mt-1 my-auto small" style={{height:"30px", maxHeight:"30px"}}>
                    <input type="checkbox" style={{cursor:"pointer"}} className="p-1" checked={mobilityChecks.vehTypeCheck}
                      onChange={(e)=>{if(!e.target.checked){setMobilityDetails({...mobilityDetails, vehTypeMin:0});}
                        setMobilityChecks({...mobilityChecks, vehTypeCheck:e.target.checked});
                      }} 
                      onKeyDown={(e)=>{if(e.key === "Enter"){
                        if(e.target.checked)
                        {
                          setMobilityDetails({...mobilityDetails, vehTypeMin:0});
                        }
                        setMobilityChecks({...mobilityChecks, vehTypeCheck:!e.target.checked});
                      }
                      }}
                    />
                  </span>
                  <span className="user-select-none d-flex mt-1 my-auto small" style={{height:"30px", maxHeight:"30px"}}>
                    <input type="checkbox" style={{cursor:"pointer"}} className="p-1" checked={mobilityChecks.vehNumCheck}
                      onChange={(e)=>{
                        if(!e.target.checked){setMobilityDetails({...mobilityDetails, vehNumMin:0});}
                        setMobilityChecks({...mobilityChecks, vehNumCheck:e.target.checked});
                      }} 
                      onKeyDown={(e)=>{if(e.key === "Enter"){
                        if(e.target.checked)
                        {
                          setMobilityDetails({...mobilityDetails, vehNumMin:0});
                        }
                        setMobilityChecks({...mobilityChecks, vehNumCheck:!e.target.checked});
                      }}}
                    />
                    <input type="number" maxLength={2} disabled={!mobilityChecks.vehNumCheck} value={mobilityDetails.vehNumMin} 
                      onChange={(e)=>{handleMobilityInputChange(e,"vehNumMin");}} title={mobilityDetails.vehNumMin+" min"}
                      className="m-0 px-1 ms-2 w-100 text-center callAgentInputStyle no-counter" 
                      style={{minWidth:"80px", maxHeight:"30px", height:"30px"}} autoComplete="new_pass"
                    />
                  </span>
                  <span className="user-select-none d-flex mt-1 my-auto small" style={{height:"30px", maxHeight:"30px"}}>
                    <input type="checkbox" style={{cursor:"pointer"}} className="p-1" checked={mobilityChecks.driverNumCheck} 
                      onChange={(e)=>{
                        if(!e.target.checked){setMobilityDetails({...mobilityDetails, driverNumMin:0});}
                        setMobilityChecks({...mobilityChecks, driverNumCheck:e.target.checked});
                      }} onKeyDown={(e)=>{if(e.key === "Enter"){
                        if(e.target.checked){setMobilityDetails({...mobilityDetails, driverNumMin:0});}
                        setMobilityChecks({...mobilityChecks, driverNumCheck:!e.target.checked});
                      }}}
                    />
                    <input type="number" disabled={!mobilityChecks.driverNumCheck} maxLength={2} value={mobilityDetails.driverNumMin} 
                      onChange={(e)=>{handleMobilityInputChange(e,"driverNumMin");}}
                      className="m-0 px-1 ms-2 w-100 text-center callAgentInputStyle no-counter" 
                      style={{minWidth:"80px", maxHeight:"30px", height:"30px"}} 
                      autoComplete="new_pass" title={mobilityDetails.driverNumMin+" min"}
                    />
                  </span>
                  <span className="user-select-none d-flex mt-1 my-auto small" style={{height:"30px", maxHeight:"30px"}}>
                    <input type="checkbox" style={{cursor:"pointer"}} className="p-1" checked={mobilityChecks.genderCheck} 
                      onChange={(e)=>{
                        if(!e.target.checked){setMobilityDetails({...mobilityDetails, genderMin:0});}
                        setMobilityChecks({...mobilityChecks, genderCheck:e.target.checked});
                      }} onKeyDown={(e)=>{if(e.key === "Enter"){
                        if(e.target.checked){setMobilityDetails({...mobilityDetails, genderMin:0});}
                        setMobilityChecks({...mobilityChecks, genderCheck:!e.target.checked});
                      }}}
                    />
                    <input type="number" disabled={!mobilityChecks.genderCheck} maxLength={2} value={mobilityDetails.genderMin} 
                      onChange={(e)=>{handleMobilityInputChange(e,"genderMin");}}
                      className="m-0 px-1 ms-2 w-100 text-center callAgentInputStyle no-counter" 
                      style={{minWidth:"80px", maxHeight:"30px", height:"30px"}} 
                      autoComplete="new_pass" title={mobilityDetails.genderMin+" min"}
                    />
                  </span>
                  <span className="user-select-none d-flex mt-1 my-auto small" style={{height:"30px", maxHeight:"30px"}}>
                    <input type="checkbox" style={{cursor:"pointer"}} className="p-1" checked={mobilityChecks.languageCheck} 
                      onChange={(e)=>{
                        if(!e.target.checked){setMobilityDetails({...mobilityDetails, languageMin:0});}
                        setMobilityChecks({...mobilityChecks, languageCheck:e.target.checked});
                      }} onKeyDown={(e)=>{if(e.key === "Enter"){
                          if(e.target.checked){setMobilityDetails({...mobilityDetails, languageMin:0});}
                          setMobilityChecks({...mobilityChecks, languageCheck:!e.target.checked});
                        }
                        else if(e.key === "Tab" && !e.shiftKey)
                        {
                          if(!mobilityChecks.vehNumCheck && !mobilityChecks.driverNumCheck && !mobilityChecks.genderCheck && !mobilityChecks.languageCheck)
                          {
                            e.preventDefault();
                            if(paratransitBookBtnRef.current.disabled)
                            {
                              resetBtnRef.current.focus();
                            }
                            else
                            {
                              paratransitBookBtnRef.current.focus();
                            }
                          }
                        }
                      
                      }}
                    />
                    <input type="number" disabled={!mobilityChecks.languageCheck} maxLength={2} value={mobilityDetails.languageMin} 
                      onChange={(e)=>{handleMobilityInputChange(e,"languageMin");}}
                      onKeyDown={(e)=>{
                        if(e.key === 'Tab' && !e.shiftKey)
                        {
                          e.preventDefault();
                          if(paratransitBookBtnRef.current.disabled)
                          {
                            resetBtnRef.current.focus();
                          }
                          else
                          {
                            paratransitBookBtnRef.current.focus();
                          }
                        }
                      }}
                      className="m-0 px-1 ms-2 w-100 text-center callAgentInputStyle no-counter" 
                      style={{minWidth:"80px", maxHeight:"30px", height:"30px"}} 
                      autoComplete="new_pass" title={mobilityDetails.languageMin+" min"}
                    />
                  </span>
                </Col>
              </Row>
            </Row>
            {/* <Row>
              <Col className="text-start border-top" style={{backgroundColor:"#07447b"}}>
                <span className="d-inline-flex">
                  <Icon icon="bx:shield" className="mt-1 text-white" style={{width:"25px", height:"25px"}}/>
                  <label className='m-0 m-1 user-select-none fw-bold text-white'>Insurance Information</label>
                </span>
                <span className="d-inline-flex mt-1 float-end" ref={insuranceInfoDisplayRef} tabIndex={0}
                  onClick={handleInsuranceInfoDisplay} onKeyDown={(e)=>{
                    if(e.key === "Enter"){handleInsuranceInfoDisplay(e);}
                    else if(e.key === "Tab" && !e.shiftKey && !insuranceInfoDisplay)
                    {
                      e.preventDefault();
                      if(paratransitBookBtnRef.current.disabled)
                      {
                        resetBtnRef.current.focus();
                      }
                      else
                      {
                        paratransitBookBtnRef.current.focus();
                      }
                    }
                  }}>
                  {insuranceInfoDisplay? <Icon icon="bx:chevron-down" className="text-white" style={{width:"25px", height:"25px", cursor:"pointer"}}/>:
                    <Icon icon="bx:chevron-up" className="text-white" style={{width:"25px", height:"25px", cursor:"pointer"}}/>
                  }
                </span>
              </Col>
            </Row> */}
            <Row className={`${insuranceInfoDisplay? 'd-none':'d-none'} mt-1 overflow-auto callAgentSummaryScroller`}>
              <Row className="">
                <Col xs={2} className="text-start">
                  <span className="d-block small mt-1 text-nowrap overflow-hidden" title={"Medical ID number"}>
                    <Icon icon="bx:id-card" className="mb-1 mx-1" style={{width:"15px", height:"15px"}}/>
                    <label className='m-0 user-select-none'>MedID</label>
                  </span>
                  <span className="d-block small mt-2 pt-1 text-nowrap overflow-hidden" title={"Policyholder's name"}>
                    <Icon icon="bx:user" className="mb-1 mx-1" style={{width:"15px", height:"15px"}}/>
                    <label className='m-0 user-select-none'>Name</label>
                  </span>
                  <span className="d-block small mt-2 pt-1 text-nowrap overflow-hidden" title={"Policyholder's date of birth"}>
                    <Icon icon="bx:cake" className="mb-1 mx-1" style={{width:"15px", height:"15px"}}/>
                    <label className='m-0 user-select-none'>DOB</label>
                  </span>
                  <span className="d-block small mt-2 pt-1 text-nowrap overflow-hidden" title={"Social Security number"}>
                    <Icon icon="bx:credit-card-front" className="mb-1 mx-1" style={{width:"15px", height:"15px"}}/>
                    <label className='m-0 user-select-none'>SSN</label>
                  </span>
                  <span className="d-block small mt-2 pt-1 text-nowrap overflow-hidden" title={"Authorization number"}>
                    <Icon icon="bx:hash" className="mb-1 mx-1" style={{width:"15px", height:"15px"}}/>
                    <label className='m-0 user-select-none'>Auth</label>
                  </span>
                </Col>
                <Col xs={10} className="p-0 text-start">
                  <Row>
                    <Col xs={6}>
                      <input type="text" className="w-100 callAgentInputStyle text-center small" autoComplete="new_pass" 
                        style={{minWidth:"110px", height:"30px", maxHeight:"30px"}} 
                        value={medID} 
                        onChange={(e)=>{setMedID(e.target.value);}}
                      />
                      <input type="text" className="d-block mt-1 w-100 callAgentInputStyle small" autoComplete="new_pass" value={insuranceName} 
                        onChange={(e)=>{setInsuranceName(e.target.value);}} 
                        style={{minWidth:"110px", height:"30px", maxHeight:"30px"}}
                      />
                      <input type="date" autoComplete="new_pass" value={insuranceDOB} onChange={(e)=>{setInsuranceDOB(e.target.value);}}
                        className="m-0 px-1 mt-1 w-100 text-center small callAgentInputStyle" style={{minWidth:"110px", height:"30px", maxHeight:"30px"}}
                      />
                      <input type="text" maxLength={9} className="d-block mt-1 w-100 small callAgentInputStyle" 
                        autoComplete="new_pass" style={{minWidth:"110px", height:"30px", maxHeight:"30px"}} value={SSNDisplayValue} 
                        onChange={handleSSNChange}
                      />
                      <input type="text" className="d-block mt-1 w-100 small callAgentInputStyle" 
                        autoComplete="new_pass" style={{minWidth:"110px", height:"30px", maxHeight:"30px"}} value={insuranceAuthCode} 
                        onChange={(e)=>{setInsuranceAuthCode(e.target.value);}}
                      />
                    </Col>
                    <Col xs={6} className="p-0">
                      <Row>
                        <Col xs={2} className="text-end">
                          <span className="d-block small mt-1 text-nowrap overflow-hidden" style={{minWidth:"30px"}} title={"Insurance Type"}>
                            <label className='m-0 user-select-none'>INS</label>
                          </span>
                          <span className="d-block small mt-2 pt-1 text-nowrap overflow-hidden" style={{minWidth:"30px"}} title={"Service Code"}>
                            <label className='m-0 user-select-none'>SC</label>
                          </span>
                          <span className="d-block small mt-2 pt-1 text-nowrap overflow-hidden" style={{minWidth:"30px"}} title={"Agency Name"}>
                            <label className='m-0 user-select-none'>Ag</label>
                          </span>
                          <span className="d-block small mt-2 pt-1 text-nowrap overflow-hidden" style={{minWidth:"30px"}} title={"Case Worker name"}>
                            <label className='m-0 user-select-none'>CW</label>
                          </span>
                          <span className="d-block small mt-2 pt-1 text-nowrap overflow-hidden" style={{minWidth:"30px"}} title={"Ride type"}>
                            <label className='m-0 user-select-none'>Ride</label>
                          </span>
                        </Col>
                        <Col xs={10} className="p-0 pe-4 ps-2">
                          <select className='text-center p-1 w-100 small callAgentInputStyle' style={{minWidth:"120px", maxHeight:"30px", height:"30px"}}
                            value={insuranceType} onChange={(e)=>{setInsuranceType(e.target.value);}}
                          >
                            
                          </select>
                          <select className='text-center mt-1 p-1 w-100 small callAgentInputStyle' style={{minWidth:"120px", maxHeight:"30px", height:"30px"}}
                            value={insuranceServiceCode} onChange={(e)=>{setInsuranceServiceCode(e.target.value);}}
                          >
                            
                          </select>
                          <select className='text-center mt-1 p-1 w-100 small callAgentInputStyle' style={{minWidth:"120px", maxHeight:"30px", height:"30px"}}
                            value={insuranceAgency} onChange={(e)=>{setInsuranceAgency(e.target.value);}}
                          >
                            
                          </select>
                          <select className='text-center mt-1 p-1 w-100 small callAgentInputStyle' style={{minWidth:"120px", maxHeight:"30px", height:"30px"}}
                            value={insuranceCaseWorker} onChange={(e)=>{setInsuranceCaseWorker(e.target.value);}}
                          >
                            
                          </select>
                          <select className='text-center mb-1 mt-1 p-1 w-100 small callAgentInputStyle' style={{minWidth:"120px", maxHeight:"30px", height:"30px"}}
                            value={insuranceRide} onChange={(e)=>{setInsuranceRide(e.target.value);}} ref={insuranceRideSelRef}
                            onKeyDown={(e)=>{
                              try{  
                                if(e.key === "Tab" && !e.shiftKey)
                                {
                                  e.preventDefault();
                                  if(!paratransitBookBtnRef.current.disabled)
                                  {
                                    paratransitBookBtnRef.current.focus();
                                  }
                                  else
                                  {
                                    resetBtnRef.current.focus();
                                  }
                                }
                              }
                              catch(err){console.log(err);}
                            }}
                          >
                            
                          </select>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  
                </Col>
              </Row>
            </Row>
          </>:""}
        </Col>
        <Col xs={6} className="overflow-auto callAgentSummaryScroller" style={dynamicModeStyle}>
          {(transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2) ? 
          <>
            <Row>
              <Col className="text-center" style={{backgroundColor:"#51677c"}}>
                <span className="d-inline-flex">
                  <Icon icon="bx:list-check" className="mt-1 text-white" style={{width:"25px", height:"25px"}}/>
                  <label className='m-0 m-1 user-select-none fw-bold text-white'>Summary</label>
                </span>
              </Col>
            </Row>
          
            <Row>
              <Col className={`text-start callAgentSummaryScroller`} style={{maxHeight:"361px"}}> {/* Summary row*/}
                <Row className="overflow-auto">
                  <Col className="text-white overflow-auto callAgentSummaryScroller" style={{backgroundColor:"#346492"}}>
                    <Row>
                      <p className="m-0 w-50 fw-bold text-start user-select-none text-nowrap">MTSM Negotiation</p>
                      <span className="w-50"  style={{float:"right", display:"inline-flex", justifyContent: "flex-end", alignItems:"center"}}>
                        <label style={{fontSize:"14px"}} className="user-select-none">Records:</label>
                        <label style={{paddingLeft:"5px", fontSize:"14px"}} className="user-select-none">{TotalMTSMRecords}</label>
                      </span>
                    </Row>
                    <Row className="m-0 overflow-auto callAgentSummaryScroller" style={{maxHeight:"150px", minHeight:"140px"}}>
                      <table className="w-100 border border-dark my-1" >
                        <thead>
                            <tr className="text-center text-nowrap" style={{background:"rgb(37 82 125)", height:"30px"}}>
                              <th className="border border-dark p-1 user-select-none" style={{fontWeight:"500", width:"19%"}}>{"Confirmation"}</th>
                              <th className="border border-dark p-1 user-select-none" style={{fontWeight:"500", width:"18%"}}>{"Sch PickTime"}</th>
                              <th className="border border-dark p-1 user-select-none" style={{fontWeight:"500", width:"18%"}}>{"Sch DropTime"}</th>
                              <th className="border border-dark p-1 user-select-none" style={{fontWeight:"500", width:"19%"}}>{"Name"}</th>
                              <th className="border border-dark p-1 user-select-none" style={{fontWeight:"500", width:"35%"}}>{"Msg"}</th>
                              <th className="border border-dark p-1 user-select-none" style={{fontWeight:"500"}}>{"Actions"}</th>
                            </tr>
                        </thead>
                        <tbody>
                          {MTSMTableHTML ? MTSMTableHTML
                          : 
                          <tr className="text-center">
                            <td className="border border-dark user-select-none">{""}</td>
                            <td className="border border-dark user-select-none">{""}</td>
                            <td className="border border-dark user-select-none">{""}</td>
                            <td className="border border-dark user-select-none text-nowrap small overflow-hidden" title={""}
                              style={{textOverflow:"ellipsis"}}
                            >{""}</td>
                            <td className="border border-dark user-select-none text-nowrap small overflow-hidden" title={""} 
                              style={{textOverflow:"ellipsis"}}
                            >{""}</td>
                            <td className="user-select-none text-center justify-content-center">
                              {""}
                            </td>
                          </tr>
                          } 
                        </tbody>
                      </table>
                    </Row>
                    
                  </Col>
                </Row>
                <Row className="" style={{height:"197px"}}>
                  <Col xs={6} className="text-white overflow-auto callAgentSummaryScroller" style={{backgroundColor:"#07447b", maxHeight:"200px"}}>
                    <Row className="mt-1">
                      <p className="m-0 fw-bold text-start user-select-none text-nowrap">Client Summary</p>
                    </Row>
                    <table className="m-1">
                      <tbody>
                        <tr className="text-start">
                          <td className="user-select-none small text-nowrap">{(screenWidthSize < 745 ? 'Calls' : "Total Calls")}</td>
                          <td className="user-select-none">
                            <input type={"text"} disabled style={{minWidth:"45px", marginLeft:"10px", borderRadius:"5px"}} value={clientSummary.totalCalls} title={clientSummary.totalCalls} 
                              className='text-nowrap border-1 p-1 mt-1 w-100 text-center text-white'
                            />
                          </td>
                        </tr>
                        <tr className="text-start">
                          <td className="user-select-none small text-nowrap" title={"Total No-Shows"}>{(screenWidthSize < 745 ? 'NS' : "Total NS")}</td>
                          <td className="user-select-none">
                            <input type={"text"} disabled style={{minWidth:"45px", marginLeft:"10px", borderRadius:"5px"}} value={clientSummary.totalNS} title={clientSummary.totalNS} 
                              className='text-nowrap border-1   p-1 my-1 w-100 text-center text-white'
                            />
                          </td>
                        </tr>
                        <tr className="text-start">
                          <td className="user-select-none small text-nowrap">{(screenWidthSize < 745 ? 'Cancelled' : "Total Cancelled")}</td>
                          <td className="user-select-none">
                            <input type={"text"} disabled style={{minWidth:"45px", marginLeft:"10px", borderRadius:"5px"}} value={clientSummary.totalCancels} title={clientSummary.totalCancels} 
                              className='text-nowrap border-1   p-1 my-1 mt-0 w-100 text-center text-white'
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </Col>
                  <Col xs={6} className="text-white overflow-auto callAgentSummaryScroller" style={{backgroundColor:"#415f7b", borderBottomRightRadius:"5px"}}>
                    <Row className="mt-1">
                      <p className="m-0 fw-bold text-start user-select-none text-nowrap">Trip Estimates</p>
                    </Row>
                    <table className="m-1">
                        <tbody>
                          <tr className="text-start">
                            <td className="user-select-none small" title={"Distance (miles)"}>{"Distance"}</td>
                            <td className="user-select-none">
                              <input type={"text"} disabled value={clientSummary.tripDistance} style={{minWidth:"45px", borderRadius:"5px"}}
                                title={"Distance: "+clientSummary.tripDistance+" miles"} className='text-nowrap border-1 p-1 mt-1 mx-1 w-100 text-center text-white'
                              />
                            </td>
                          </tr>
                          <tr className="text-start">
                            <td className="user-select-none small" title={"Time (min)"}>{"Time"}</td>
                            <td className="user-select-none">
                              <input type={"text"} disabled value={clientSummary.TripDuration} style={{minWidth:"45px", borderRadius:"5px"}}
                                title={"Duration: "+clientSummary.TripDuration+" min"} className='text-nowrap border-1 p-1 my-1 mx-1 w-100 text-center text-white'
                              />
                            </td>
                          </tr>
                          <tr className="text-start">
                            <td className="user-select-none small" title={"Total Cost (USD)"}>{"Cost"}</td>
                            <td className="user-select-none">
                              <input type={"text"} disabled value={(typeof fareDataArr === 'object' && fareDataArr.totalCost ? String(fareDataArr.totalCost) : '0')} 
                                style={{minWidth:"45px", borderRadius:"5px"}}
                                title={"Total Trip Cost: $"+(typeof fareDataArr === 'object' && fareDataArr.totalCost ? fareDataArr.totalCost : '0')} 
                                className='text-nowrap border-1 p-1 mx-1 w-100 text-center text-white'
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                  </Col>
                </Row>
              </Col>
            </Row>
          </>
          :
          <>
            <Row className="p-0">
              <Col className="text-start" style={{backgroundColor:"#07447b", height:"35px", maxHeight:"35px"}}>
                <span className={`${selectedSummaryHeader === "stopOrder"? 'callAgentHeaderStyleSelected':'callAgentHeaderStyle'} justify-content-center 
                  d-inline-flex small mt-2 h-100 border-white`}
                  onClick={()=>{handleSummaryHeaderClick("stopOrder");}} style={{minWidth:"40px"}}
                >
                  <Icon icon="bx:trip" className="mt-1" style={{ width:"20px", height:"20px"}}/>
                  <label className='m-0 m-1 user-select-none fw-bold callAgentLabelsResponsive' style={{cursor:"pointer"}}>Stop Order</label>
                </span>
                {false ? <span className={`${selectedSummaryHeader === "manifest"? 'callAgentHeaderStyleSelected':'callAgentHeaderStyle'} justify-content-center 
                  d-inline-flex small mt-2 ms-1 h-100 border-light`}
                  onClick={()=>{handleSummaryHeaderClick("manifest");}} style={{minWidth:"40px"}}
                >
                  <Icon icon="bx:list-check" className="mt-1" style={{width:"20px", height:"20px"}}/>
                  <label className='m-0 m-1 user-select-none fw-bold callAgentLabelsResponsive' style={{cursor:"pointer"}}>Manifest Details</label>
                </span>
                :""}
                <span className={`${selectedSummaryHeader === "agentTrips"? 'callAgentHeaderStyleSelected':'callAgentHeaderStyle'} justify-content-center 
                  d-inline-flex small mt-2 ms-1 h-100 border-light`}
                  onClick={()=>{handleSummaryHeaderClick("agentTrips");}} style={{minWidth:"40px"}}
                >
                  <Icon icon="bx:history" className="mt-1" style={{width:"20px", height:"20px"}}/>
                  <label className='m-0 m-1 user-select-none fw-bold callAgentLabelsResponsive' style={{cursor:"pointer"}}>Booked Trips</label>
                </span>
              </Col>
            </Row>
            <Row className={`${stopOrderDisplay? '':'d-none'} m-0 overflow-auto callAgentSummaryScroller`} style={{height:`${summaryViewScreenHeightSize}px`, maxHeight:`${summaryViewScreenHeightSize}px`}}>
              <Col className="callAgentInputStyle" style={{borderTopLeftRadius:0, borderTopRightRadius:0}}> 
                <Row>
                  <Col className="p-0">
                    {verifiedAddr.length > 0 ? 
                      verifiedAddr.map((item, index)=>{
                        let time = item.waitTime;
                        const selectedFSOption = FSDropdown.find(option => parseInt(option.props.value) === parseInt(item.FundingSource));
                        let FSText = selectedFSOption ? selectedFSOption.props.children : item.FundingSource;
                        let [hours, minutes] = (item.time !== "" && item.time !== "Will Call" ? item.time.split(":") : ["",""]);
                        let [apptHours, apptMins] = (item.apptTime !== "" && item.apptTime !== "Will Call"? item.apptTime.split(":") : ["",""]);
                        // console.log(item.time, hours, minutes);
                        let meridiem = hours !== "" ? (hours >= 12 ? 'PM' : 'AM'):"";
                        let meridiemAppt = apptHours !== "" ? (apptHours >= 12 ? 'PM' : 'AM'):"";
                        apptHours = (apptHours !== "" ? (parseInt(apptHours) % 12 || 12) : ""); //24 to 12 hour format
                        apptMins = (apptMins !== "" ? (parseInt(apptMins) < 10 ? '0' + parseInt(apptMins) : apptMins) : "");
                        hours = (hours !== "" ? (parseInt(hours) % 12 || 12) : ""); //24 to 12 hour format
                        minutes = (minutes !== "" ? (parseInt(minutes) < 10 ? '0' + parseInt(minutes) : minutes) : "");
                        let waitTime = (time && time !== "" ? time.split(":")[0]+(parseInt(time.split(":")[0]) > 9 ? " mins" : " min"): "");
                        const queryParams = new URLSearchParams(window.location.search);
                        const tripSelected = queryParams.get('TripSelected') || activeTripSelected? true:false;
                        let editRowData = (PersistStorage.retrieve("rowDataEditTrip", true)  && tripSelected? PersistStorage.retrieve("rowDataEditTrip", true):"");
                        let showMoveUpDown = (editRowData && editRowData !== "" && editRowData !== "No data found" && typeof editRowData === 'object' ? false : true);
                        let distanceVal = (parseFloat(item.manualAmount.estimatedDistance) > 0 ? parseFloat(item.manualAmount.estimatedDistance) : (item.distance));
                        return(
                          <Row className="m-0 mt-1 mx-1" style={{border:"1px solid gray", borderRadius:"5px"}} key={index} >
                            <Col className="p-0 overflow-auto callAgentSummaryScroller">
                              <span className="d-flex small text-nowrap overflow-hidden" style={{minWidth:"500px"}}>
                                <Icon icon="bx:map" className="my-auto mx-1 text-success" style={{width:"15px", height:"15px"}}/>
                                <label className='m-0 user-select-none text-nowrap overflow-hidden' 
                                  style={{textOverflow:"ellipsis", whiteSpace: "nowrap", minWidth:"100px", maxWidth:"350px"}} 
                                  title={item.pickAddr}
                                >
                                  {item.pickAddr}
                                </label>
                                <label className='m-0 ms-1 px-1 user-select-none text-nowrap overflow-hidden bg-light text-start rounded' 
                                  style={{textOverflow:"ellipsis", whiteSpace: "nowrap" , minWidth:"100px", maxWidth:"150px"}}
                                  title={"Name: "+ item.riderName}
                                >
                                  {"Name: "+ item.riderName}
                                </label>
                                <label className='m-0 ms-1 px-1 user-select-none text-nowrap overflow-hidden bg-light text-start rounded' 
                                  style={{textOverflow:"ellipsis", whiteSpace: "nowrap" , minWidth:"100px", maxWidth:"150px"}}
                                  title={"Funding Source: "+ FSText}
                                >
                                  {"FS: "+ (FSText)}
                                </label>
                              </span>
                              <span className="d-flex mt-1 small mx-2 text-nowrap" style={{maxWidth:"480px", maxHeight:"25px"}}>
                                <p className="m-0 ms-3 text-center user-select-none d-inlin-block text-nowrap bg-light callAgentInputStyle" style={{minWidth:"100px"}}
                                  title={"Date"}
                                >
                                  {item.date}
                                </p>
                                <p className="m-0 ms-1 text-center user-select-none d-inlin-block text-nowrap bg-light callAgentInputStyle" style={{minWidth:"60px"}}
                                  title={"Scheduled Time"}
                                >
                                  {(hours !== "" ? hours+":"+minutes+" "+meridiem : (item.time === "Will Call"? item.time: ""))}
                                </p>
                                <p className="m-0 ms-1 text-center user-select-none d-inlin-block text-nowrap bg-light callAgentInputStyle" style={{minWidth:"80px"}}
                                  title={"Appointment Time"}
                                >
                                  {(apptHours !== "" ? apptHours+":"+apptMins+" "+meridiemAppt : (item.time === "Will Call"? "Will Call": ""))}
                                </p>
                                <p className="m-0 ms-1 text-center user-select-none d-inlin-block text-nowrap bg-light callAgentInputStyle" style={{minWidth:"80px"}}
                                  title={"Distance"}
                                >
                                  {distanceVal + (parseFloat(distanceVal) > 1 ? " miles":" mile")}
                                </p>
                                <p className="m-0 ms-1 text-center user-select-none d-inlin-block text-nowrap bg-light callAgentInputStyle" style={{minWidth:"80px"}}
                                  title={"Duration"}
                                >
                                  {item.duration+(parseFloat(item.duration) > 1 ?" mins":" min")}
                                </p>
                                <span className="ms-1">
                                  {addLegBtnTitle != "Update" &&
                                    <span title={"Clear Trip"} onClick={(e)=>{handleClearVerifiedAddr(index);}}>
                                      <Icon icon="bx:eraser" className="my-auto text-danger" style={{width:"20px", height:"20px", cursor:"pointer"}}/>
                                    </span>
                                  }
                                  <span title={(addLegBtnTitle === "Update" ? "Cancel Edit":"Edit Trip")} className="mx-2" 
                                    onClick={(e)=>{
                                      if(addLegBtnTitle === "Update"){handleClearLegInfo();} 
                                      else{handleEditEntireTrip(index);}
                                    }}
                                  >
                                    <Icon icon={(addLegBtnTitle === "Update" ? "bx:task-x":"bx:edit")} title={(addLegBtnTitle === "Update" ? "Cancel Edit":"Edit Trip")} 
                                      className="my-auto text-warning" style={{width:"20px", height:"20px", cursor:"pointer"}}
                                    />
                                  </span>
                                  {showMoveUpDown ? 
                                    <>
                                      <span title={"Move Trip Up"} onClick={(e)=>{handleMoveVerifiedAddr(index, "up");}}>
                                        <Icon icon="bx:chevrons-up" title={"Move Trip Up"} className="my-auto text-dark" style={{width:"20px", height:"20px", cursor:"pointer"}}/>
                                      </span>
                                      <span title={"Move Trip Down"} className="ms-2" onClick={(e)=>{handleMoveVerifiedAddr(index, "down");}}>
                                        <Icon icon="bx:chevrons-down" title={"Move Trip Down"} className="my-auto text-dark" style={{width:"20px", height:"20px", cursor:"pointer"}}/>
                                      </span>
                                    </> 
                                  : ""}
                                </span>
                                
                              </span>
                              {item.stops && item.stops.length > 0 ? item.stops.map((item,index) =>{
                                let waitTime = (item.waitTime && item.waitTime !== 0 ? item.waitTime:0);
                                return(
                                  <Row className="m-0 mt-1" key={index}>
                                    <Col className="mx-4 p-0 px-1 border rounded border-secondary overflow-auto callAgentSummaryScroller">
                                      <span className="d-flex mt-1 small text-nowrap overflow-hidden" style={{minWidth:"300px"}}>
                                        <Icon icon="bx:map" 
                                          className={`${item.passLoadType === "load" ? "text-success" : (item.passLoadType === "unload" ? "text-danger" : "text-secondary")} my-auto mx-1 `} 
                                          style={{width:"15px", height:"15px"}}
                                        />
                                        <label className='m-0 px-1 user-select-none text-nowrap overflow-hidden bg-light rounded' 
                                          style={{textOverflow:"ellipsis", whiteSpace: "nowrap", minWidth:"100px", maxWidth:"200px"}} title={item.stopAddr}
                                        >
                                          {item.stopAddr}
                                        </label>
                                        {item.passengerName !== "" ?
                                          <label className='m-0 px-1 ms-1 user-select-none text-nowrap overflow-hidden bg-light text-center rounded' 
                                            style={{textOverflow:"ellipsis", whiteSpace: "nowrap", width:"100px", maxWidth:"100px"}}
                                            title={"Name: "+item.passengerName}
                                          >
                                            {"Name: "+item.passengerName}
                                          </label> 
                                        :""}
                                        {parseInt(waitTime) !== 0  ?
                                          <label className='m-0 ms-1 user-select-none text-nowrap overflow-hidden bg-light text-center rounded' 
                                            style={{textOverflow:"ellipsis", whiteSpace: "nowrap" , minWidth:"100px"}}
                                            title={(parseInt(waitTime) === 0  ? "No wait": " Wait: "+ (parseInt(waitTime) > 9 ? parseInt(waitTime) + " mins": parseInt(waitTime) + " min"))}
                                          >
                                            {" Wait: "+ (parseInt(waitTime) > 9 ? parseInt(waitTime) + " mins": parseInt(waitTime) + " min")}
                                          </label> 
                                        :""}
                                      </span>
                                      <span className="d-flex small my-1 text-nowrap overflow-hidden">
                                        <Icon icon="bx:pen" className="mx-1 my-auto text-dark" style={{width:"15px", height:"15px"}}/>
                                        <label className='m-0 px-1 user-select-none text-nowrap overflow-hidden bg-light rounded' 
                                          style={{textOverflow:"ellipsis", whiteSpace: "nowrap", minWidth:"100px", maxWidth:"300px"}} 
                                          title={item.notes}
                                        >
                                          {(item.notes !== "" ? item.notes : "No notes provided.")}
                                        </label>
                                        {item.passLoadType !== "none" ?
                                          <label className='m-0 ms-1 user-select-none text-nowrap overflow-hidden bg-light text-center rounded' 
                                            style={{textOverflow:"ellipsis", whiteSpace: "nowrap" , minWidth:"100px"}}
                                            title={"Load Type"}
                                          >
                                            
                                            {(item.passLoadType.charAt(0).toUpperCase() + item.passLoadType.slice(1)+" ("+item.stopPax.total+")")}
                                            
                                          </label>
                                        :""}
                                      </span>
                                    </Col>
                                    
                                  </Row>
                                );
                              })
                              : ""}
                              <span className="d-flex mt-1 small text-nowrap overflow-hidden" style={{minWidth:"500px"}}>
                                <Icon icon="bx:map" className="my-auto mx-1 text-danger" style={{width:"15px", height:"15px"}}/>
                                <label className='m-0 user-select-none text-nowrap overflow-hidden' title={item.dropAddr}
                                  style={{textOverflow:"ellipsis", whiteSpace: "nowrap", minWidth:"100px", maxWidth:"350px"}} 
                                >
                                  {item.dropAddr}
                                </label>
                              </span>
                            </Col>
                          </Row>
                        ); 
                      })
                    :""}
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className={`${manifestDetailsDisplay? '':'d-none'} m-0`} style={{height:`${summaryViewScreenHeightSize}px`, maxHeight:`${summaryViewScreenHeightSize}px`}}>
              <Col className="callAgentInputStyle" style={{borderTopLeftRadius:0, borderTopRightRadius:0}}> 
              
              </Col>
            </Row>
            <Row className={`${agentTripsDisplay? '':'d-none'} m-0`} style={{height:`${summaryViewScreenHeightSize}px`, maxHeight:`${summaryViewScreenHeightSize}px`}}>
              <Col className="callAgentInputStyle" style={{borderTopLeftRadius:0, borderTopRightRadius:0}}> 
                <Row className="m-0 mt-3 px-1 overflow-auto callAgentSummaryScroller" style={{maxHeight:"200px", minHeight:"100px"}}>
                  <Col className="small p-0">
                    <table className="w-100 mb-2 callAgentInputStyle" style={{minHeight:"100px"}}>
                      <thead className="" style={{borderTop:"5px"}}>
                        <tr className="text-center text-nowrap text-white">
                          <th className="p-1 border-right border-secondary user-select-none" 
                            style={{backgroundColor:"#35738a", fontWeight:"500", borderTopLeftRadius:"5px", borderRight:"1px solid #ccc"}}
                          >
                            {"Confirmation"}
                          </th>
                          <th className="p-1 border-right border-secondary user-select-none" 
                            style={{backgroundColor:"#35738a", fontWeight:"500",borderRight:"1px solid #ccc"}}
                          >{"Type"}</th>
                          <th className="p-1 border-right border-secondary user-select-none" title={"Cost (USD)"}
                            style={{backgroundColor:"#35738a", fontWeight:"500",borderRight:"1px solid #ccc"}}
                          >{"Cost"}</th>
                          <th className="p-1 border-right border-secondary user-select-none" title={"Distance (mi)"}
                            style={{backgroundColor:"#35738a", fontWeight:"500",borderRight:"1px solid #ccc"}}
                          >{"Distance"}</th>
                          <th className="p-1 border-right border-secondary user-select-none" title={"Duration (min)"}
                            style={{backgroundColor:"#35738a", fontWeight:"500", borderTopRightRadius:"5px"}}
                          >{"Duration"}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {AgentTripRecordsTableHTML ? AgentTripRecordsTableHTML 
                        : 
                          <tr className="text-center">
                            <td className="text-nowrap small overflow-hidden bg-light p-1" style={{borderRight:"1px solid #ccc", borderBottomLeftRadius:"5px"}}>
                              {""}
                            </td>
                            <td className="text-nowrap small overflow-hidden bg-light px-1" style={{borderRight:"1px solid #ccc"}}>
                              {""}
                            </td>
                            <td className="text-nowrap small overflow-hidden bg-light px-1" style={{borderRight:"1px solid #ccc"}}>
                              {""}
                            </td>
                            <td className="text-nowrap small overflow-hidden bg-light px-1" style={{borderRight:"1px solid #ccc"}}>
                              {""}
                            </td>
                            <td className="text-nowrap small overflow-hidden bg-light p-1" style={{ borderBottomRightRadius:"5px"}}>
                              {""}
                            </td>
                          </tr>
                        } 
                      </tbody>
                    </table>
                  </Col>
                </Row>
              </Col>
            </Row>
            {[1, 2].includes(EnablePredictiveNegotiation) && (<Row className="overflow-auto" style={{"margintop": "2px"}}>
                  <Col className="text-white overflow-auto callAgentSummaryScroller" style={{backgroundColor:"#346492"}}>
                    <Row>
                      <p className="m-0 w-50 fw-bold text-start user-select-none text-nowrap">Predictive Negotiation</p>
                      <span className="w-50"  style={{float:"right", display:"inline-flex", justifyContent: "flex-end", alignItems:"center"}}>
                        <label style={{fontSize:"14px"}} className="user-select-none">Records:</label>
                        <label style={{paddingLeft:"5px", fontSize:"14px"}} className="user-select-none">{TotalPredictiveRecords}</label>
                      </span>
                    </Row>
                    <Row className="m-0 overflow-auto callAgentSummaryScroller" style={{maxHeight:"120px", minHeight:"120px"}}>
                      <table className="w-100 border border-dark my-1" >
                        <thead>
                            <tr className="text-center text-nowrap" style={{background:"rgb(37 82 125)", height:"30px"}}>
                              <th className="border border-dark p-1 user-select-none" style={{fontWeight:"500", width:"15%"}}>{"Confirmation"}</th>
                              <th className="border border-dark p-1 user-select-none" style={{fontWeight:"500", width:"30%"}}>{"Status"}</th>
                              <th className="border border-dark p-1 user-select-none" style={{fontWeight:"500", width:"20%"}}>{"Req Time"}</th>
                              <th className="border border-dark p-1 user-select-none" style={{fontWeight:"500", width:"20%"}}>{"Offered Time"}</th>
                              <th className="border border-dark p-1 user-select-none" style={{fontWeight:"500"}}>{"Actions"}</th>
                            </tr>
                        </thead>
                        <tbody>
                          {PredictiveTableHTML ? PredictiveTableHTML
                          : 
                          <tr key={""} className="text-center">
                            <td className="border border-dark user-select-none">{""}</td>
                            <td className="border border-dark user-select-none">{""}</td>
                            <td className="border border-dark user-select-none text-nowrap small overflow-hidden" style={{textOverflow:"ellipsis"}} >{""}</td>
                            <td className="border border-dark user-select-none text-nowrap small overflow-hidden" style={{textOverflow:"ellipsis"}} >{""}</td>
                            <td className="user-select-none text-center justify-content-center">{""}</td>
                          </tr>
                          } 
                        </tbody>
                      </table>
                    </Row>
                    
                  </Col>
             </Row> )}
            <Row className="" style={{height:"115px", maxHeight:"115px"}}>
              <Col className="">
                <span className="d-inline-flex">
                  <Icon icon="bx:receipt" className="mt-1" style={{width:"25px", height:"25px"}}/>
                  <label className='m-0 m-1 user-select-none fw-bold'>Ride Estimates</label>
                </span>
                  <Row className="m-0 overflow-auto callAgentSummaryScroller px-1 text-center" style={{maxHeight:"100px", minHeight:"80px"}}>
                    <table className="my-1 callAgentInputStyle">
                      <thead className="" style={{borderTop:"5px"}}>
                        <tr className="text-center text-nowrap text-white">
                          <th className="p-1 border-right border-secondary user-select-none" style={{backgroundColor:"#35738a", fontWeight:"500", borderTopLeftRadius:"5px", borderRight:"1px solid #ccc"}}>{"Fare"}</th>
                          <th className="p-1 border-right border-secondary user-select-none" style={{backgroundColor:"#35738a", fontWeight:"500",borderRight:"1px solid #ccc"}}>{"Copay"}</th>
                          <th className="p-1 border-right border-secondary user-select-none" style={{width: "90px", maxWidth:"90px", backgroundColor:"#35738a", fontWeight:"500", borderRight:"1px solid #ccc"}}>{"Price"}</th>
                          <th className="p-1 border-right border-secondary user-select-none" style={{backgroundColor:"#35738a", fontWeight:"500", borderRight:"1px solid #ccc"}}>{"Distance"}</th>
                          <th className="p-1 user-select-none" style={{backgroundColor:"#35738a", fontWeight:"500", borderTopRightRadius:"5px"}}>{"Time"}</th>
                        </tr>
                      </thead>
                      <tbody className="">
                        <tr className="text-center">
                          <td className="user-select-none text-nowrap small overflow-hidden" style={{borderRight:"1px solid #ccc"}}>
                            {manualFareChecks.fareEstimateCheck?
                              <span className="user-select-none d-flex my-auto justify-content-center fw-normal text-nowrap">
                                <p className="m-0 user-select-none my-auto text-center">{"$"}</p>
                                <input type="text" className="w-100 mx-1 text-center callAgentInputStyle"
                                  autoComplete="new_pass" style={{maxWidth:"60px", minWidth:"50px", height:"30px", maxHeight:"30px", backgroundColor:"#f3f7f8"}} 
                                  value={manualDataOverwrite.fare} onChange={(e)=>{handleManualUserChange(e, 'fare');}}
                                />
                                <span className="d-inline-block my-auto" title={"Undo"} onClick={(e)=>{handleUndoManualChange(e, 'fare')}}>
                                  <Icon icon="mynaui:undo" className="text-dark" style={{width:"15px", height:"15px", cursor:"pointer"}}/>
                                </span>
                              </span>
                              :
                              ("$"+clientSummary.TripFare)
                            }
                          </td>
                          <td className="user-select-none text-nowrap small overflow-hidden" style={{borderRight:"1px solid #ccc"}}>{"$"+clientSummary.TripCopay}</td>
                          <td className="user-select-none text-nowrap small overflow-hidden" style={{borderRight:"1px solid #ccc"}}>
                            {manualFareChecks.priceCheck? 
                              <span className="user-select-none d-flex justify-content-center my-auto fw-normal text-nowrap">
                                <p className="m-0 user-select-none my-auto text-center">{"$"}</p>
                                <input type={"number"} className="w-100 mx-1 text-center callAgentInputStyle no-counter"
                                  autoComplete="new_pass" style={{maxWidth:"60px", minWidth:"50px", height:"30px", maxHeight:"30px", backgroundColor:"#f3f7f8"}} 
                                  value={manualDataOverwrite.price} onChange={(e)=>{handleManualUserChange(e, 'price');}} maxLength={3}
                                />
                                <span className="d-inline-block my-auto" title={"Undo"} onClick={(e)=>{handleUndoManualChange(e, 'price')}}>
                                  <Icon icon="mynaui:undo" className="text-dark" style={{width:"15px", height:"15px", cursor:"pointer"}}/>
                                </span>
                              </span>
                              :
                              ("$0")
                            }
                          </td>
                          <td className="user-select-none text-nowrap small overflow-hidden" style={{borderRight:"1px solid #ccc"}} title={"Distance (Miles)"}
                          >{manualFareChecks.mileEstimateCheck ? 
                            (!manualDistanceEditMode ? 
                            <p className="m-0 user-select-none my-auto small ">
                              {(parseFloat(manualDataOverwrite.miles) > 0 ? manualDataOverwrite.miles + (parseFloat(manualDataOverwrite.miles) > 1 ?" miles": " mile") : clientSummary.tripDistance + (parseFloat(clientSummary.tripDistance) > 1 ?" miles": " mile"))}
                              <span className="d-inline-block my-auto" title={"Edit Distance"}
                                onClick={(e)=>{setManualDistanceEditMode(true); setManualDataOverwrite(prev=>({...prev, fare:clientSummary.TripFare, miles: (parseFloat(prev.miles) > 0 ? prev.miles : clientSummary.tripDistance)}));}}
                                onKeyDown={(e)=>{if(e.key === 'Enter'){e.preventDefault(); setManualDistanceEditMode(true); setManualDataOverwrite(prev=>({...prev, fare:clientSummary.TripFare,  miles: (parseFloat(prev.miles) > 0 ? prev.miles : clientSummary.tripDistance)}));}}}
                              >
                                <Icon icon="fe:edit" className="text-dark" style={{width:"15px", height:"15px", cursor:"pointer"}}/>
                              </span>
                            </p> 
                            : 
                            <span className="user-select-none d-flex justify-content-center my-auto fw-normal text-nowrap">
                              <input type={"number"} className="w-100 mx-1 text-center callAgentInputStyle no-counter"
                                autoComplete="new_pass" style={{maxWidth:"60px", minWidth:"50px", height:"30px", maxHeight:"30px", backgroundColor:"#f3f7f8"}} 
                                value={manualDataOverwrite.miles} onChange={(e)=>{handleManualUserChange(e, 'miles');}} onBlur={async(e)=>{await handleBlurDistance(e);}} 
                                maxLength={2}
                              />
                              <p className="m-0 user-select-none my-auto text-center">{(parseFloat(manualDataOverwrite.miles) > 1 ?" miles": " mile")}</p>
                              <span className="d-inline-block  ms-1 my-auto" title={"Undo"} onClick={(e)=>{handleUndoManualChange(e, 'miles')}}>
                                <Icon icon="mynaui:undo" className="text-dark" style={{width:"15px", height:"15px", cursor:"pointer"}}/>
                              </span>
                            </span>)
                            :
                            (clientSummary.tripDistance+ (parseFloat(clientSummary.tripDistance) > 1 ?" miles": " mile"))}
                          </td>
                          <td className="user-select-none text-nowrap small overflow-hidden" title={"Duration (Minutes)"}
                          >{clientSummary.TripDuration+ (parseFloat(clientSummary.TripDuration) > 1 ?" mins": " min")}</td>
                        </tr>
                      </tbody>
                    </table>
                  </Row>
              </Col>
            </Row>
            <Row className="m-0" style={{height:`${mapScreenHeightSize}px`, minHeight:`${mapScreenHeightSize}px`, marginLeft: "10%", marginRight:"10%"}}>
              <Col className="p-0 my-1 border-0" style={{boxShadow:"0px 3px 6px #999"}}>
                <MapControlSkeleton
                  setIsSchTimeFieldDisabled={setIsSchTimeFieldDisabled}
                  setIsVSSelectionDisabled={setIsVSSelectionDisabled}
                  vsSelection={handleMapVSSelected}
                  mapPointSelection={handleMapPointSelection}
                  zones={((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2) ? 
                    ((RCZZoneVerticesData && RCZZoneVerticesData.Table.length > 0) ? RCZZoneVerticesData.Table : ZoneVerticesData.Table) : ZoneVerticesData.Table)
                  }
                  MapDetailData={mapData} 
                  options={mapOptionsCallAgent}
                  DispatchVehicleData={DispatchVehicleData}
                  CurrentAff = {selectedAff}
                  onConditionMet={null}
                />
                {/* !showChatBot && (!Array.isArray(specificLinkRequirement)) */}
                {!showChatBot && (!Array.isArray(specificLinkRequirement)) && specificLinkRequirement !== ""? 
                  <div style={{ position: 'absolute', cursor:"pointer", zIndex: 9999 }} 
                    onClick={(e)=>{setShowChatBot(true); showChatBotRef.current = true;}} 
                    title={"Click to open chatbot"} className={`rounded-circle p-2 text-center border chatbotBtnStyle`}
                  >
                    <Icon icon="bx:chat" className="text-white my-auto" style={{ width: "25px", height: "25px", zIndex: 9999 }} />
                  </div> 
                : ""}
              </Col>
            </Row>
            {showChatBot && (!Array.isArray(specificLinkRequirement)) && specificLinkRequirement !== ""? 
                <>
                  <Button variant="dark" className="position-fixed p-0" 
                    style={{right:"50px", bottom:"662px", zIndex: 2}} 
                    onClick={(e)=>{setShowChatBot(false); showChatBotRef.current = false;}}
                  >
                    <Icon icon="maki:cross" className="text-white my-auto" style={{ width: "20px", height: "20px"}} />
                  </Button>
                    
                  {(()=>{
                    let formattedPhone = (phone && phone.length >= 12 ? formatPhone(phone) : "");
                    const PhoneNo = typeof clientInfo === 'object' && clientInfo.HomePhone ? clientInfo.HomePhone : formattedPhone ;
                    const AffiliateID = parseInt(selectedAff);
                    const FamilyID = (AffiliateData.find((item) => {if(parseInt(item.AffiliateID) === parseInt(selectedAff)){return item}})).iPartnerAffiliateID;
                    const UserID = parseInt(loginData.iUserIDActual);
                    const clientID = typeof clientInfo === 'object' && clientInfo.Id && String(clientInfo.Id) !== "-1"? clientInfo.Id : "-1";

                    if(srcUrl.includes("clientID=-1") && (typeof clientInfo === 'object' && clientInfo.Id && String(clientInfo.Id) !== "-1"))
                    {
                      // setSrcUrl(`${specificLinkRequirement}?PhoneNo=${PhoneNo}&iAffiliateID=${AffiliateID}&iFamilyID=${FamilyID}&iUserID=${UserID}&clientID=${clientID}`);
                      setSrcUrl(`${specificLinkRequirement}?phoneNo=${PhoneNo}&affiliateId=${AffiliateID}&familyId=${FamilyID}&userID=${UserID}&clientID=${clientID}`);
                    }
                    
                    return(
                      <iframe
                        id="chatbotiFrame"
                        title="Chatbot"
                        allow="microphone"
                        src={srcUrl}
                        ref={iframeRef}
                        className="text-center justify-content-center position-fixed bg-transparent"
                        style={{
                          bottom: "30px",
                          right: "10px",
                          width: '480px',
                          minWidth:"480px",
                          height: '700px',
                          border: 'none',
                          zIndex: 1
                        }}
                      />
                    );
                  })()}
                </>
            : ""}
              
          </>
          }
        </Col>
      </Row>
      {(transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2) ?
        <Row className="callAgentMainColsResponsive" style={{height:`calc(100vh - 520px)`}}>
          <Col className="p-0 my-1 border-0" style={{boxShadow:"0px 3px 6px #999"}}>
            <MapControlSkeleton
              vsSelection={handleMapVSSelected}
              mapPointSelection={handleMapPointSelection}
              setIsSchTimeFieldDisabled={setIsSchTimeFieldDisabled}
              setIsVSSelectionDisabled={setIsVSSelectionDisabled}
              zones={((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2) ? 
                ((RCZZoneVerticesData && RCZZoneVerticesData.Table.length > 0) ? RCZZoneVerticesData.Table : ZoneVerticesData.Table) : ZoneVerticesData.Table)
              }
              microPolylinePoints = {MicrotransitMapWalkPolyline}
              MapDetailData={mapData} 
              options={mapOptionsCallAgent}
              DispatchVehicleData={DispatchVehicleData}
              CurrentAff = {selectedAff}
              onConditionMet={null}
            />
          </Col>
        </Row>
      :""}
      <Row className="m-0 p-1 page-footer fixed-bottom" style={{backgroundColor:"#07447b", height:'45px', maxHeight:'45px'}}>
        <Col className="text-start callAgentTitleResponsive">
          <Row>
            <Col xs={4}>
              <span className="d-inline-flex small text-nowrap text-white">
                <label className='m-0 my-1 user-select-none' title={"Last Confirmation Number"}>Last Confirmation#</label>
                <input type={"text"} disabled value={confirmationNo} onChange={(e)=>setConfirmationNo(e.target.value)}  title={confirmationNo}
                  className='d-inline-flex text-nowrap text-center text-white border-1 mx-1 p-1' style={{borderRadius:"5px"}}
                />
              </span>
            </Col>
            
          </Row>
        </Col>
        <Col className="text-end callAgentTitleAffResponsive">
          {/* <Button variant="dark" className="mx-1 rounded" onClick={handleDemoMessagesView}>{"Auto"}</Button> */}
          
          {
          (transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2) ?
            <Button tabIndex={0} variant="success" className="mx-1 rounded" style={{ borderRadius: "0px"}} ref={bookBtnRef} onClick={handleCreateUpdateTrip}
              onKeyDown={(e)=>
                { 
                  try{
                    
                    if(e.key === "Tab" && e.shiftKey)
                    {
                      e.preventDefault();
                      agentNotesBtnRef.current.focus();
                    }
                    
                  }
                  catch(err){console.log(err);}
                }
              }
            >
              {submitBtnTitle}
            </Button>
          :
            <Button tabIndex={0} variant="success" className="mx-1 rounded" style={{ borderRadius: "0px"}} ref={paratransitBookBtnRef} 
              onClick={(e)=>{ validateMinScheduleTimeDifference(null, false, false, 'book');}}
              onKeyDown={(e)=>
                { 
                  try{
                    
                    if(e.key === "Tab" && e.shiftKey)
                    {
                      e.preventDefault();
                      if(insuranceInfoDisplay)
                      {
                        insuranceRideSelRef.current.focus();
                      }
                      else
                      {
                        if(insuranceInfoDisplayRef.current)
                        {
                          insuranceInfoDisplayRef.current.focus();
                        }
                        else
                        {
                          if(driverVehInfoDisplay)
                          {
                            languageOptionsSelRef.current.focus();
                          }
                          else
                          {
                            mobilityInfoDisplayRef.current.focus();
                          }
                        }
                      }
                    }
                    else if(e.key === "Enter")
                    {
                      validateMinScheduleTimeDifference(null, false, false, 'book'); 
                    }
                  }
                  catch(err){console.log(err);}
                }
              }
            >
              {submitParatransitBtnTitle}
            </Button>
          }
          <Button tabIndex={0} variant="info" className="mx-1 rounded" ref={resetBtnRef} style={{ borderRadius: "0px"}} 
            title={"Reset Parameters"} onClick={()=>{handleResetAll("none")}}
            onKeyDown={(e)=>
              { 
                try{
                  if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2))
                  {
                    if(e.key === "Tab" && e.shiftKey)
                    {
                      e.preventDefault();
                      if(bookBtnRef.current.disabled)
                      {
                        agentNotesBtnRef.current.focus();
                      }
                      else
                      {
                        bookBtnRef.current.focus();
                      }
                    }
                    else if(e.key === "Tab" && !e.shiftKey)
                    {
                      e.preventDefault();
                      phoneRef.current.focus();
                    }
                  }
                  else if((transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2))
                  {
                    if(e.key === "Tab" && e.shiftKey)
                    {
                      e.preventDefault();
                      if(paratransitBookBtnRef.current.disabled)
                      {
                        if(driverVehInfoDisplay)
                        { 
                          languageOptionsSelRef.current.focus();
                        }
                        else
                        {
                          mobilityInfoDisplayRef.current.focus();
                        }
                      }
                      else
                      {
                        paratransitBookBtnRef.current.focus();
                      }
                    }
                    else if(e.key === "Tab" && !e.shiftKey)
                    {
                      e.preventDefault();
                      phoneRef.current.focus();
                    }
                  }
                }
                catch(err){console.log(err);}
              }
            }
          >
            {"Reset"}
          </Button>
        </Col>
      </Row>
      
      {showClientActiveTripsModal ? 
        <Modal centered backdrop="static" keyboard={true} onHide={()=>setShowClientActiveTripsModal(false)} size={"xl"} show={showClientActiveTripsModal} animation={true}>
          <Modal.Header className='text-white callAgent-modal-header user-select-none p-0 py-1 px-2' closeButton>
              <Modal.Title style={{fontSize:"20px"}}>
                {"Client Active Trips"}
              </Modal.Title>
          </Modal.Header>
          <Modal.Body className='fw-normal user-select-none'>
            {clientInfo?<Row className="m-0 d-flex">
              <Col xs={3} className="p-0">
                <p className="m-0">{"Name: "}<span className="fw-normal">{clientInfo.FirstName + " " + clientInfo.LastName}</span></p>
                <p className="m-0">{"Home Phone: "}<span className="fw-normal">{clientInfo.HomePhone? clientInfo.HomePhone:"N/A"}</span></p>
              </Col>
              <Col xs={9} className="p-0">
                <p className="m-0">{"Last Call: "}
                  <span className="fw-normal">{clientInfo.LastCallDate? clientInfo.LastCallDate.split("T")[0]+" "+clientInfo.LastCallDate.split("T")[1].split(".")[0]:"N/A"}</span>
                </p>
                <p className="m-0">{"Phone: "}<span className="fw-normal">{clientInfo.OfficePhone? clientInfo.OfficePhone:"N/A"}</span></p>
              </Col>
            </Row>:""}
            <Row className="m-0 mt-4">
              <GridControl ShowLoader={showLoader} ReloadDataFunction={handleClientInfoTableOpen} 
              setActiveTripConfirmation={setActiveTripConfirmation} 
              setColumnChooser={setShowColumnChooser} showColumnChooser={showColumnChooser}
              GridColumnSetting={clientActiveTripsColData} 
              Data={ActiveTripsTableData} options={activeTripsGridOptions}/>
            </Row>
          </Modal.Body>
          <Modal.Footer className='p-0 px-2 py-1'>
            <Button variant="secondary" className="mx-1" onClick={()=>setShowClientActiveTripsModal(false)} title={"Close client info table"}>Close</Button>
          </Modal.Footer>
        </Modal>
      : ""}

    {showClienteDuplicateTripsModal ? 
        <Modal centered backdrop="static" keyboard={true} onHide={()=>setShowClienteDuplicateTripsModal(false)} size={"xl"} show={showClienteDuplicateTripsModal} animation={true}>
          <Modal.Header className='text-white callAgent-modal-header user-select-none p-0 py-1 px-2'>
              <Modal.Title style={{fontSize:"20px"}}>
                {"Customer Existing Trips"}
              </Modal.Title>
          </Modal.Header>
          <Modal.Body className='fw-normal user-select-none'>
            <Row>
              <p style={{color: "red", fontWeight:"500"}}>Warning! Following trip(s) already exists in sytem for this customer. Do you still want to save this request?</p>
            </Row>
            <Row className="m-0 mt-4">
              <GridControl ShowLoader={showLoader} ReloadDataFunction={handleClientInfoTableOpen}
                Data={duplicateTripsTableData} options={duplicateTripsGridOptions}/>
            </Row>
          </Modal.Body>
          <Modal.Footer className='p-0 px-2 py-1'>
            <Button
              variant="secondary"
              className="mx-1"
              onClick={() => {
                setShowClienteDuplicateTripsModal(false);
                    if (modalResolveAllowDuplicate) modalResolveAllowDuplicate(true); // ✅ Yes
                  }}
                >
            Yes
          </Button>
          <Button
            variant="dark"
            className="mx-1"
            onClick={() => {
              setShowClienteDuplicateTripsModal(false);
              
              if (modalResolveAllowDuplicate) modalResolveAllowDuplicate(false); // ❌ No
            }}
          >
            No
          </Button>
          </Modal.Footer>
        </Modal>
      : ""}
     

      {showDynamicModal ? 
        <Modal centered className={modalClass} backdrop="static" keyboard={true} onKeyDown={(e)=>{
            if(e.key === "Enter")
            {
              e.preventDefault();
              customHideFunc();
            }
          }} 
          onHide={()=>{customHideFunc();}} show={showDynamicModal} animation={true}>
            <Modal.Header className='text-white user-select-none p-0 py-1 px-2 callAgent-modal-header'   closeButton={showCloseButton}>
                <Modal.Title style={{fontSize:"20px"}}>{modalHeaderText}</Modal.Title>
            </Modal.Header>
            <Modal.Body className='fw-normal user-select-none'>{modalBodyHTML}</Modal.Body>
            {modalFooterHTML === ""? "":
              <Modal.Footer className='p-0 px-2 py-1'>
                {modalFooterHTML}
              </Modal.Footer>
            }
        </Modal>
      : ""}
      {showCCInfoDialog || CheckCCParams !== "" ? 
        <CCProfile bCCInfoDialogOpen={showCCInfoDialog} setCCInfoDialog={setShowCCInfoDialog} minimumMonth={minMonth} maximumMonth={maxMonth} CardDetails={cardInfo} 
          AffID={selectedAff} FSID={FSSelected} clientInfoData={(accountNumber !== '' ? {Id:accountNumber} : clientInfo)} setCardDetails={setCardInfo} checkCCParams={CheckCCParams} pageLoader={setShowAPILoader}
        />
      : ""}
      {multischModalShow ? 
        <MultiSchedule setShowMultiSchedule={setMultischModalShow} scheduleJSONData={scheduleJSON} setScheduleJSON={setScheduleJSON} date={selectedDateSchTime}
          bMultiScheduleShow={multischModalShow} AffID={selectedAff} FSID={FSSelected} clientInfoData={clientInfo} paxCount={passengerTypeCount} isEditMode={(paratransitBookBtnRef.current.textContent.toLowerCase() === "update")}
        />
      :""}
      {showClientInfoCreationDialog ?
        <ClientProfile setShowClientProfile={setShowClientInfoCreationDialog} showClientProfile={showClientInfoCreationDialog} 
          selectedAff={selectedAff} disabledField={mainInfoNewClient} extraInfo = {newClientInfoExtraInfo} setExtraInfo = {setNewClientInfoExtraInfo}
        />
      : ""}

      {/* Mobility Attributes selection */}    
      {showMobilityAttributes ? 
        <Modal centered backdrop="static" keyboard={()=>onAttributeValidation_New()} onHide={()=>onAttributeValidation_New()} size={"sm"} show={showMobilityAttributes} animation={true}>
          <Modal.Header className='text-white callAgent-modal-header user-select-none p-0 py-1 px-2' closeButton>
              <Modal.Title style={{fontSize:"20px"}}>
                {"Mobility Attributes"}
              </Modal.Title>
          </Modal.Header>
          <Modal.Body className='fw-normal user-select-none' style={{overflow:"auto", height: "300px"}}>
            {/* <AttributeSelectors
            fields = {mobilityFields}
            options = {mobilityAttributeOptions}
            counts = {mobilityPassengers}
            data = {mobilityDbData}
            onChange={handleSelectionsChange}
            ></AttributeSelectors> */}
            {
              <AttributeSelectorNew
                passengersCount = {mobilityPassengers}
                attributesOptions = {mobilityAttributeOptions}
                savedData={mobilitySavedData}
                onChange={(updated) => setMobilitySavedData(updated)}
                ></AttributeSelectorNew>
            }

          </Modal.Body>
          <Modal.Footer className='p-0 px-2 py-1'>
            <label style={{color: "red", width: "100%"}}>{attributeValidationMsg}</label>
            <Button variant="secondary" className="mx-1" onClick={()=>onAttributeValidation_New()} title={"Close Mobility Attributes."}>OK</Button>
          </Modal.Footer>
        </Modal>
      : ""
    
    }
      {/* Mobility Attributes selection */}

      {showForceReqTimeModal.show && (
        
      <Modal centered backdrop="static" onHide={() => setShowForceReqTimeModal(prev => ({ ...prev, show: false }))} size="sm" show={showForceReqTimeModal.show}>
          <Modal.Header className='text-white callAgent-modal-header user-select-none p-0 py-1 px-2' closeButton>
              <Modal.Title style={{fontSize:"19px"}}>
                {showForceReqTimeModal.title}
              </Modal.Title>
          </Modal.Header>
          <Modal.Body className='fw-normal user-select-none' style={{overflow:"auto", height: "167px"}}>
            <Form>
              <Form.Label>
              <b>Req Date:</b> <input type="date" name="ForceReqDate" autoComplete="new_pass" value={showForceReqTimeModal.forceReqDate} 
                              onChange={(e)=>{setShowForceReqTimeModal(prev => ({ ...prev, forceReqDate: e.target.value })) }} 
                              className="text-center callAgentInputStyle" style={{height:"35px", width:"85%" }} 
                              min={systemDateTimeRef.current.date} 
                            />
              </Form.Label>
               <Form.Label>
              <b>Req Time:</b> <input type="time" autoComplete="new_pass" value={showForceReqTimeModal.forceReqTime}  
                              onChange={(e)=>{setShowForceReqTimeModal(prev => ({ ...prev, forceReqTime: e.target.value }))}} 
                              className="text-center callAgentInputStyle" style={{height:"35px", width:"100%"}} 
                            />
              </Form.Label>
            </Form>
          </Modal.Body>
          <Modal.Footer className='p-0 px-2 py-1'>
            <Button variant="secondary" className="mx-1" style={{background:"#07447b"}} 
            onClick={(e)=> handlePredictiveUpdate() } title={"Update Trip's Requested Time"}>Update</Button>
          </Modal.Footer>
        </Modal>)}


        {showPredictiveNegotiationStatusCard ? 
        <Modal centered backdrop="static" onHide={()=>onPredictiveNegotiationStatusCardClick()} size={"lg"} show={showPredictiveNegotiationStatusCard} animation={true}>
          <Modal.Header className='text-white callAgent-modal-header user-select-none p-0 py-1 px-2' closeButton>
              <Modal.Title style={{fontSize:"20px"}}>
                {"Predictive Negotiation"}
              </Modal.Title>
          </Modal.Header>
          <Modal.Body className='fw-normal user-select-none' style={{overflow:"auto"}}>
            <PredictiveNegotiationStatusCard
               items ={predictiveNegotiationList}
               headerTitle={predictiveHeaderTitle}
               headerMsg={predictiveHeaderMsg}
               onAction={PredictiveNegotiationStatusCard_OnAction}
               showLoader={showPredictiveNegoLoader}
            />
          </Modal.Body>
          <Modal.Footer className='p-0 px-0 py-0' style={{display: "none"}}>
            {/* <button style={{background: "#07447b", color: "white", borderRadius: "10px 10px 10px 10px"}} onClick={(e)=> onPredictiveNegotiationStatusCardClick()} >Continue</button> */}
          </Modal.Footer>
        </Modal>
      : ""
    
      }
        {showCancel ? <CancelTrip GridRowData={selectRowData} showCancel={showCancel} setShowCancel={setShowCancel} gridType={gridMainType}   onActionPerformed={handleCancelAction}/> : ""}
     </div>
    </div>

    {/* {showDynamicModal ? 
        <Modal centered className={modalClass} backdrop="static" keyboard={true} onKeyDown={(e)=>{
            if(e.key === "Enter")
            {
              e.preventDefault();
              customHideFunc();
            }
          }} 
          onHide={()=>{customHideFunc();}} show={showDynamicModal} animation={true}>
            <Modal.Header className='text-white user-select-none p-0 py-1 px-2 callAgent-modal-header' closeButton>
                <Modal.Title style={{fontSize:"20px"}}>{modalHeaderText}</Modal.Title>
            </Modal.Header>
            <Modal.Body className='fw-normal user-select-none'>{modalBodyHTML}</Modal.Body>
            {modalFooterHTML === ""? "":
              <Modal.Footer className='p-0 px-2 py-1'>
                {modalFooterHTML}
              </Modal.Footer>
            }
        </Modal>
      : ""} */}

    </>
  );
};

export default CallTaker;


